[
    {
      "key": "1",
      "databaseFilmTitle": "¡Que viva Mexico!",
      "FilmTitle": "¡Que viva Mexico!",
      "AlternateTitle": "",
      "TitleArray": [
        "¡Que viva Mexico!"
      ],
      "Year": "1932",
      "Director": "Sergei Eisenstein, Grigori Aleksandrov",
      "DirectorArray": [
        "Sergei Eisenstein",
        "Grigori Aleksandrov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union",
        "United States"
      ],
      "1952rank": "16",
      "1952votes": "8",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2",
      "databaseFilmTitle": "¡Vivan las Antipodas!",
      "FilmTitle": "¡Vivan las Antipodas!",
      "AlternateTitle": "",
      "TitleArray": [
        "¡Vivan las Antipodas!"
      ],
      "Year": "2011",
      "Director": "Victor Kossakovsky",
      "DirectorArray": [
        "Victor Kossakovsky"
      ],
      "Country": "Germany, Argentina",
      "CountryArray": [
        "Germany",
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3",
      "databaseFilmTitle": "...A Valparaíso",
      "FilmTitle": "...A Valparaíso",
      "AlternateTitle": "",
      "TitleArray": [
        "...A Valparaíso"
      ],
      "Year": "1963",
      "Director": "Joris Ivens",
      "DirectorArray": [
        "Joris Ivens"
      ],
      "Country": "France, Chile",
      "CountryArray": [
        "France",
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4",
      "databaseFilmTitle": "...All the Marbles",
      "FilmTitle": "...All the Marbles",
      "AlternateTitle": "",
      "TitleArray": [
        "...All the Marbles"
      ],
      "Year": "1982",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "5",
      "databaseFilmTitle": "[Enema Medley]",
      "FilmTitle": "[Enema Medley]",
      "AlternateTitle": "selection from V'14 Revolutions in 16MM",
      "TitleArray": [
        "[Enema Medley]",
        "selection from V'14 Revolutions in 16MM"
      ],
      "Year": "1970",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "6",
      "databaseFilmTitle": "10",
      "FilmTitle": "10",
      "AlternateTitle": "",
      "TitleArray": [
        "10"
      ],
      "Year": "1979",
      "Director": "Blake Edwards",
      "DirectorArray": [
        "Blake Edwards"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "7",
      "databaseFilmTitle": "1126 Dewey Avenue, Apt. 207",
      "FilmTitle": "1126 Dewey Avenue, Apt. 207",
      "AlternateTitle": "",
      "TitleArray": [
        "1126 Dewey Avenue, Apt. 207"
      ],
      "Year": "1939",
      "Director": "John C. Hecker",
      "DirectorArray": [
        "John C. Hecker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "8",
      "databaseFilmTitle": "12 Angry Men",
      "FilmTitle": "12 Angry Men",
      "AlternateTitle": "",
      "TitleArray": [
        "12 Angry Men"
      ],
      "Year": "1957",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "9",
      "databaseFilmTitle": "12 Monkeys",
      "FilmTitle": "12 Monkeys",
      "AlternateTitle": "",
      "TitleArray": [
        "12 Monkeys"
      ],
      "Year": "1995",
      "Director": "Terry Gilliam",
      "DirectorArray": [
        "Terry Gilliam"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "10",
      "databaseFilmTitle": "12 Years a Slave",
      "FilmTitle": "12 Years a Slave",
      "AlternateTitle": "",
      "TitleArray": [
        "12 Years a Slave"
      ],
      "Year": "2013",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "11",
      "databaseFilmTitle": "13 Lakes",
      "FilmTitle": "13 Lakes",
      "AlternateTitle": "",
      "TitleArray": [
        "13 Lakes"
      ],
      "Year": "2004",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "12",
      "databaseFilmTitle": "13th",
      "FilmTitle": "13th",
      "AlternateTitle": "",
      "TitleArray": [
        "13th"
      ],
      "Year": "2016",
      "Director": "Ava DuVernay",
      "DirectorArray": [
        "Ava DuVernay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "13",
      "databaseFilmTitle": "1900",
      "FilmTitle": "1900",
      "AlternateTitle": "Novecento",
      "TitleArray": [
        "1900",
        "Novecento"
      ],
      "Year": "1976",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "14",
      "databaseFilmTitle": "1917",
      "FilmTitle": "1917",
      "AlternateTitle": "",
      "TitleArray": [
        "1917"
      ],
      "Year": "2019",
      "Director": "Sam Mendes",
      "DirectorArray": [
        "Sam Mendes"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "15",
      "databaseFilmTitle": "2 Days in Paris",
      "FilmTitle": "2 Days in Paris",
      "AlternateTitle": "",
      "TitleArray": [
        "2 Days in Paris"
      ],
      "Year": "2007",
      "Director": "Julie Delpy",
      "DirectorArray": [
        "Julie Delpy"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "16",
      "databaseFilmTitle": "2 into 1",
      "FilmTitle": "2 into 1",
      "AlternateTitle": "",
      "TitleArray": [
        "2 into 1"
      ],
      "Year": "1997",
      "Director": "Gillian Wearing",
      "DirectorArray": [
        "Gillian Wearing"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "17",
      "databaseFilmTitle": "2 or 3 Things I Know About Her",
      "FilmTitle": "2 or 3 Things I Know About Her",
      "AlternateTitle": "",
      "TitleArray": [
        "2 or 3 Things I Know About Her"
      ],
      "Year": "1967",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "18",
      "databaseFilmTitle": "20 Feet from Stardom",
      "FilmTitle": "20 Feet from Stardom",
      "AlternateTitle": "",
      "TitleArray": [
        "20 Feet from Stardom"
      ],
      "Year": "2013",
      "Director": "Morgan Neville",
      "DirectorArray": [
        "Morgan Neville"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "19",
      "databaseFilmTitle": "2001: A Space Odyssey",
      "FilmTitle": "2001: A Space Odyssey",
      "AlternateTitle": "",
      "TitleArray": [
        "2001: A Space Odyssey"
      ],
      "Year": "1969",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "12",
      "1982votes": "10",
      "1992rank": "10",
      "1992votes": "14",
      "2002rank": "5",
      "2002votes": "21",
      "2012rank": "6",
      "2012votes": "90",
      "2022rank": "6",
      "2022votes": "130"
    },
    {
      "key": "20",
      "databaseFilmTitle": "2046",
      "FilmTitle": "2046",
      "AlternateTitle": "",
      "TitleArray": [
        "2046"
      ],
      "Year": "2004",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "21",
      "databaseFilmTitle": "20th Century Women",
      "FilmTitle": "20th Century Women",
      "AlternateTitle": "",
      "TitleArray": [
        "20th Century Women"
      ],
      "Year": "2016",
      "Director": "Mike Mills",
      "DirectorArray": [
        "Mike Mills"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "22",
      "databaseFilmTitle": "21 Grams",
      "FilmTitle": "21 Grams",
      "AlternateTitle": "",
      "TitleArray": [
        "21 Grams"
      ],
      "Year": "2003",
      "Director": "Alejandro González Iñárritu",
      "DirectorArray": [
        "Alejandro González Iñárritu"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "23",
      "databaseFilmTitle": "23rd Psalm Branch",
      "FilmTitle": "23rd Psalm Branch",
      "AlternateTitle": "",
      "TitleArray": [
        "23rd Psalm Branch"
      ],
      "Year": "1968",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "24",
      "databaseFilmTitle": "24 Frames",
      "FilmTitle": "24 Frames",
      "AlternateTitle": "",
      "TitleArray": [
        "24 Frames"
      ],
      "Year": "2017",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "25",
      "databaseFilmTitle": "24 Hour Party People",
      "FilmTitle": "24 Hour Party People",
      "AlternateTitle": "",
      "TitleArray": [
        "24 Hour Party People"
      ],
      "Year": "2002",
      "Director": "Michael Winterbottom",
      "DirectorArray": [
        "Michael Winterbottom"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "26",
      "databaseFilmTitle": "24 Hour Psycho",
      "FilmTitle": "24 Hour Psycho",
      "AlternateTitle": "",
      "TitleArray": [
        "24 Hour Psycho"
      ],
      "Year": "1993",
      "Director": "Douglas Gordon, Alfred Hitchcock",
      "DirectorArray": [
        "Douglas Gordon",
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "27",
      "databaseFilmTitle": "25 Fireman's Street",
      "FilmTitle": "25 Fireman's Street",
      "AlternateTitle": "Tüzoltó utca 25.",
      "TitleArray": [
        "25 Fireman's Street",
        "Tüzoltó utca 25."
      ],
      "Year": "1973",
      "Director": "István Szabó",
      "DirectorArray": [
        "István Szabó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "28",
      "databaseFilmTitle": "25th Hour",
      "FilmTitle": "25th Hour",
      "AlternateTitle": "",
      "TitleArray": [
        "25th Hour"
      ],
      "Year": "2002",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "29",
      "databaseFilmTitle": "28 Days Later",
      "FilmTitle": "28 Days Later",
      "AlternateTitle": "",
      "TitleArray": [
        "28 Days Later"
      ],
      "Year": "2002",
      "Director": "Danny Boyle",
      "DirectorArray": [
        "Danny Boyle"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "30",
      "databaseFilmTitle": "3 Faces",
      "FilmTitle": "3 Faces",
      "AlternateTitle": "Se rokh",
      "TitleArray": [
        "3 Faces",
        "Se rokh"
      ],
      "Year": "2018",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "31",
      "databaseFilmTitle": "3 Godfathers",
      "FilmTitle": "3 Godfathers",
      "AlternateTitle": "",
      "TitleArray": [
        "3 Godfathers"
      ],
      "Year": "1948",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "32",
      "databaseFilmTitle": "3 Idiots",
      "FilmTitle": "3 Idiots",
      "AlternateTitle": "",
      "TitleArray": [
        "3 Idiots"
      ],
      "Year": "2009",
      "Director": "Rajkumar Hirani",
      "DirectorArray": [
        "Rajkumar Hirani"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "33",
      "databaseFilmTitle": "3 Women",
      "FilmTitle": "3 Women",
      "AlternateTitle": "",
      "TitleArray": [
        "3 Women"
      ],
      "Year": "1977",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "34",
      "databaseFilmTitle": "3-Iron",
      "FilmTitle": "3-Iron",
      "AlternateTitle": "Bin-Jip",
      "TitleArray": [
        "3-Iron",
        "Bin-Jip"
      ],
      "Year": "2004",
      "Director": "Kim Ki-duk",
      "DirectorArray": [
        "Kim Ki-duk"
      ],
      "Country": "South Korea, Japan",
      "CountryArray": [
        "South Korea",
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "35",
      "databaseFilmTitle": "3:10 to Yuma (1957)",
      "FilmTitle": "3:10 to Yuma",
      "AlternateTitle": "",
      "TitleArray": [
        "3:10 to Yuma"
      ],
      "Year": "1957",
      "Director": "Delmer Daves",
      "DirectorArray": [
        "Delmer Daves"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "36",
      "databaseFilmTitle": "31/75: Asylum",
      "FilmTitle": "31/75: Asylum",
      "AlternateTitle": "31/75: Asyl",
      "TitleArray": [
        "31/75: Asylum",
        "31/75: Asyl"
      ],
      "Year": "1975",
      "Director": "Kurt Kren",
      "DirectorArray": [
        "Kurt Kren"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "37",
      "databaseFilmTitle": "322",
      "FilmTitle": "322",
      "AlternateTitle": "",
      "TitleArray": [
        "322"
      ],
      "Year": "1969",
      "Director": "Dušan Hanák",
      "DirectorArray": [
        "Dušan Hanák"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "38",
      "databaseFilmTitle": "33 Yo-Yo Tricks",
      "FilmTitle": "33 Yo-Yo Tricks",
      "AlternateTitle": "",
      "TitleArray": [
        "33 Yo-Yo Tricks"
      ],
      "Year": "1976",
      "Director": "P. White",
      "DirectorArray": [
        "P. White"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "39",
      "databaseFilmTitle": "35 Shots of Rum",
      "FilmTitle": "35 Shots of Rum",
      "AlternateTitle": "",
      "TitleArray": [
        "35 Shots of Rum"
      ],
      "Year": "2008",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "40",
      "databaseFilmTitle": "36 Chowringhee Lane",
      "FilmTitle": "36 Chowringhee Lane",
      "AlternateTitle": "",
      "TitleArray": [
        "36 Chowringhee Lane"
      ],
      "Year": "1981",
      "Director": "Aparna Sen",
      "DirectorArray": [
        "Aparna Sen"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "41",
      "databaseFilmTitle": "37/78: Tree Again",
      "FilmTitle": "37/78: Tree Again",
      "AlternateTitle": "",
      "TitleArray": [
        "37/78: Tree Again"
      ],
      "Year": "1978",
      "Director": "Kurt Kren",
      "DirectorArray": [
        "Kurt Kren"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "42",
      "databaseFilmTitle": "4 Months, 3 Weeks and 2 Days",
      "FilmTitle": "4 Months, 3 Weeks and 2 Days",
      "AlternateTitle": "4 luni, 3 săptămâni și 2 zile",
      "TitleArray": [
        "4 Months, 3 Weeks and 2 Days",
        "4 luni, 3 săptămâni și 2 zile"
      ],
      "Year": "2007",
      "Director": "Cristian Mungiu",
      "DirectorArray": [
        "Cristian Mungiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "43",
      "databaseFilmTitle": "42nd Street",
      "FilmTitle": "42nd Street",
      "AlternateTitle": "",
      "TitleArray": [
        "42nd Street"
      ],
      "Year": "1933",
      "Director": "Lloyd Bacon",
      "DirectorArray": [
        "Lloyd Bacon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "44",
      "databaseFilmTitle": "45 Years",
      "FilmTitle": "45 Years",
      "AlternateTitle": "",
      "TitleArray": [
        "45 Years"
      ],
      "Year": "2015",
      "Director": "Andrew Haigh",
      "DirectorArray": [
        "Andrew Haigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "45",
      "databaseFilmTitle": "48 Hours",
      "FilmTitle": "48 Hours",
      "AlternateTitle": "48 oras",
      "TitleArray": [
        "48 Hours",
        "48 oras"
      ],
      "Year": "1950",
      "Director": "Gerardo de León",
      "DirectorArray": [
        "Gerardo de León"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "46",
      "databaseFilmTitle": "6 et 12",
      "FilmTitle": "6 et 12",
      "AlternateTitle": "",
      "TitleArray": [
        "6 et 12"
      ],
      "Year": "1968",
      "Director": "Mohamed Abderrahman Tazi, Ahmed Bouanani, Abdelmajid R'chich",
      "DirectorArray": [
        "Mohamed Abderrahman Tazi",
        "Ahmed Bouanani",
        "Abdelmajid R'chich"
      ],
      "Country": "Morocco",
      "CountryArray": [
        "Morocco"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "47",
      "databaseFilmTitle": "7 Songs From The Tundra",
      "FilmTitle": "7 Songs From The Tundra",
      "AlternateTitle": "Seitsemän laulua tundralta",
      "TitleArray": [
        "7 Songs From The Tundra",
        "Seitsemän laulua tundralta"
      ],
      "Year": "2000",
      "Director": "Anastasia Lapsui, Markku Lehmuskallio",
      "DirectorArray": [
        "Anastasia Lapsui",
        "Markku Lehmuskallio"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "48",
      "databaseFilmTitle": "7 Women",
      "FilmTitle": "7 Women",
      "AlternateTitle": "",
      "TitleArray": [
        "7 Women"
      ],
      "Year": "1966",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "49",
      "databaseFilmTitle": "71 Fragments of a Chronology of Chance",
      "FilmTitle": "71 Fragments of a Chronology of Chance",
      "AlternateTitle": "71 Fragmente einer Chronologie des Zufalls",
      "TitleArray": [
        "71 Fragments of a Chronology of Chance",
        "71 Fragmente einer Chronologie des Zufalls"
      ],
      "Year": "1994",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "Austria, Germany",
      "CountryArray": [
        "Austria",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "50",
      "databaseFilmTitle": "79 Springs",
      "FilmTitle": "79 Springs",
      "AlternateTitle": "79 primaveras",
      "TitleArray": [
        "79 Springs",
        "79 primaveras"
      ],
      "Year": "1969",
      "Director": "Santiago Álvarez",
      "DirectorArray": [
        "Santiago Álvarez"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "51",
      "databaseFilmTitle": "7th Heaven",
      "FilmTitle": "7th Heaven",
      "AlternateTitle": "",
      "TitleArray": [
        "7th Heaven"
      ],
      "Year": "1927",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "52",
      "databaseFilmTitle": "8½",
      "FilmTitle": "8½",
      "AlternateTitle": "",
      "TitleArray": [
        "8½"
      ],
      "Year": "1963",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "4",
      "1972votes": "15",
      "1982rank": "5",
      "1982votes": "14",
      "1992rank": "11",
      "1992votes": "10",
      "2002rank": "8",
      "2002votes": "18",
      "2012rank": "10",
      "2012votes": "64",
      "2022rank": "31",
      "2022votes": "59"
    },
    {
      "key": "53",
      "databaseFilmTitle": "8903 Empire",
      "FilmTitle": "8903 Empire",
      "AlternateTitle": "",
      "TitleArray": [
        "8903 Empire"
      ],
      "Year": "2015",
      "Director": "Kevin Jerome Everson, Kahlil Pedizisai",
      "DirectorArray": [
        "Kevin Jerome Everson",
        "Kahlil Pedizisai"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "54",
      "databaseFilmTitle": "9 to 5",
      "FilmTitle": "9 to 5",
      "AlternateTitle": "",
      "TitleArray": [
        "9 to 5"
      ],
      "Year": "1980",
      "Director": "Colin Higgins",
      "DirectorArray": [
        "Colin Higgins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "55",
      "databaseFilmTitle": "A Agonia",
      "FilmTitle": "A Agonia",
      "AlternateTitle": "",
      "TitleArray": [
        "A Agonia"
      ],
      "Year": "1976",
      "Director": "Júlio Bressane",
      "DirectorArray": [
        "Júlio Bressane"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "56",
      "databaseFilmTitle": "A Bad Film",
      "FilmTitle": "A Bad Film",
      "AlternateTitle": "Huono filmi",
      "TitleArray": [
        "A Bad Film",
        "Huono filmi"
      ],
      "Year": "1950",
      "Director": "Felix Forsman",
      "DirectorArray": [
        "Felix Forsman"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "57",
      "databaseFilmTitle": "A Bitter Taste of Freedom",
      "FilmTitle": "A Bitter Taste of Freedom",
      "AlternateTitle": "",
      "TitleArray": [
        "A Bitter Taste of Freedom"
      ],
      "Year": "2011",
      "Director": "Marina Goldovskaya",
      "DirectorArray": [
        "Marina Goldovskaya"
      ],
      "Country": "Sweden, United States",
      "CountryArray": [
        "Sweden",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "58",
      "databaseFilmTitle": "A Bread Factory Part One: For the Sake of Gold",
      "FilmTitle": "A Bread Factory Part One: For the Sake of Gold",
      "AlternateTitle": "A Bread Factory, Part One",
      "TitleArray": [
        "A Bread Factory Part One: For the Sake of Gold",
        "A Bread Factory, Part One"
      ],
      "Year": "2018",
      "Director": "Patrick Wang",
      "DirectorArray": [
        "Patrick Wang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "59",
      "databaseFilmTitle": "A Brighter Summer Day",
      "FilmTitle": "A Brighter Summer Day",
      "AlternateTitle": "Guling jie shaonian sharen shijian",
      "TitleArray": [
        "A Brighter Summer Day",
        "Guling jie shaonian sharen shijian"
      ],
      "Year": "1991",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "60",
      "databaseFilmTitle": "A Camel",
      "FilmTitle": "A Camel",
      "AlternateTitle": "Jamal",
      "TitleArray": [
        "A Camel",
        "Jamal"
      ],
      "Year": "1981",
      "Director": "Ibrahim Shaddad",
      "DirectorArray": [
        "Ibrahim Shaddad"
      ],
      "Country": "Sudan",
      "CountryArray": [
        "Sudan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "61",
      "databaseFilmTitle": "A Canterbury Tale",
      "FilmTitle": "A Canterbury Tale",
      "AlternateTitle": "",
      "TitleArray": [
        "A Canterbury Tale"
      ],
      "Year": "1944",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "62",
      "databaseFilmTitle": "A Child in the Crowd",
      "FilmTitle": "A Child in the Crowd",
      "AlternateTitle": "Un enfant dans la foule",
      "TitleArray": [
        "A Child in the Crowd",
        "Un enfant dans la foule"
      ],
      "Year": "1976",
      "Director": "Gérard Blain",
      "DirectorArray": [
        "Gérard Blain"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "63",
      "databaseFilmTitle": "A Christmas Tale",
      "FilmTitle": "A Christmas Tale",
      "AlternateTitle": "Un conte de Noël",
      "TitleArray": [
        "A Christmas Tale",
        "Un conte de Noël"
      ],
      "Year": "2008",
      "Director": "Arnaud Desplechin",
      "DirectorArray": [
        "Arnaud Desplechin"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "64",
      "databaseFilmTitle": "A City of Sadness",
      "FilmTitle": "A City of Sadness",
      "AlternateTitle": "Beiqing chengshi",
      "TitleArray": [
        "A City of Sadness",
        "Beiqing chengshi"
      ],
      "Year": "1989",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan, Hong Kong",
      "CountryArray": [
        "Taiwan",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "65",
      "databaseFilmTitle": "A Clockwork Orange",
      "FilmTitle": "A Clockwork Orange",
      "AlternateTitle": "",
      "TitleArray": [
        "A Clockwork Orange"
      ],
      "Year": "1971",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "66",
      "databaseFilmTitle": "A Colour Box",
      "FilmTitle": "A Colour Box",
      "AlternateTitle": "",
      "TitleArray": [
        "A Colour Box"
      ],
      "Year": "1935",
      "Director": "Len Lye",
      "DirectorArray": [
        "Len Lye"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "67",
      "databaseFilmTitle": "A Confucian Confusion",
      "FilmTitle": "A Confucian Confusion",
      "AlternateTitle": "Du li shi dai",
      "TitleArray": [
        "A Confucian Confusion",
        "Du li shi dai"
      ],
      "Year": "1994",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "68",
      "databaseFilmTitle": "A Corner in Wheat",
      "FilmTitle": "A Corner in Wheat",
      "AlternateTitle": "",
      "TitleArray": [
        "A Corner in Wheat"
      ],
      "Year": "1909",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "69",
      "databaseFilmTitle": "A Cottage on Dartmoor",
      "FilmTitle": "A Cottage on Dartmoor",
      "AlternateTitle": "",
      "TitleArray": [
        "A Cottage on Dartmoor"
      ],
      "Year": "1929",
      "Director": "Anthony Asquith",
      "DirectorArray": [
        "Anthony Asquith"
      ],
      "Country": "Sweden, United Kingdom",
      "CountryArray": [
        "Sweden",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "70",
      "databaseFilmTitle": "A Countess from Hong Kong",
      "FilmTitle": "A Countess from Hong Kong",
      "AlternateTitle": "",
      "TitleArray": [
        "A Countess from Hong Kong"
      ],
      "Year": "1967",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "71",
      "databaseFilmTitle": "A Dance for Two",
      "FilmTitle": "A Dance for Two",
      "AlternateTitle": "Pas de deux",
      "TitleArray": [
        "A Dance for Two",
        "Pas de deux"
      ],
      "Year": "1968",
      "Director": "Norman McLaren",
      "DirectorArray": [
        "Norman McLaren"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "72",
      "databaseFilmTitle": "A Darkness Swallowed",
      "FilmTitle": "A Darkness Swallowed",
      "AlternateTitle": "",
      "TitleArray": [
        "A Darkness Swallowed"
      ],
      "Year": "2006",
      "Director": "Betzy Bromberg",
      "DirectorArray": [
        "Betzy Bromberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "73",
      "databaseFilmTitle": "A Day in the Country",
      "FilmTitle": "A Day in the Country",
      "AlternateTitle": "Partie de campagne",
      "TitleArray": [
        "A Day in the Country",
        "Partie de campagne"
      ],
      "Year": "1946",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "90",
      "2012votes": "18",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "74",
      "databaseFilmTitle": "A Day Off",
      "FilmTitle": "A Day Off",
      "AlternateTitle": "Hyuil",
      "TitleArray": [
        "A Day Off",
        "Hyuil"
      ],
      "Year": "1968",
      "Director": "Lee Man-hee",
      "DirectorArray": [
        "Lee Man-hee"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "75",
      "databaseFilmTitle": "A Day on the Grand Canal with the Emperor of China or: Surface Is Illusion but So Is Depth",
      "FilmTitle": "A Day on the Grand Canal with the Emperor of China or: Surface Is Illusion but So Is Depth",
      "AlternateTitle": "",
      "TitleArray": [
        "A Day on the Grand Canal with the Emperor of China or: Surface Is Illusion but So Is Depth"
      ],
      "Year": "1988",
      "Director": "Philip Haas",
      "DirectorArray": [
        "Philip Haas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "76",
      "databaseFilmTitle": "A Day Out",
      "FilmTitle": "A Day Out",
      "AlternateTitle": "",
      "TitleArray": [
        "A Day Out"
      ],
      "Year": "1972",
      "Director": "Stephen Frears",
      "DirectorArray": [
        "Stephen Frears"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "77",
      "databaseFilmTitle": "A Diary for Timothy",
      "FilmTitle": "A Diary for Timothy",
      "AlternateTitle": "",
      "TitleArray": [
        "A Diary for Timothy"
      ],
      "Year": "1945",
      "Director": "Humphrey Jennings",
      "DirectorArray": [
        "Humphrey Jennings"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "78",
      "databaseFilmTitle": "A Diary of Chuji's Travels",
      "FilmTitle": "A Diary of Chuji's Travels",
      "AlternateTitle": "Chuji Tabinikki Daisanbu Goyohen",
      "TitleArray": [
        "A Diary of Chuji's Travels",
        "Chuji Tabinikki Daisanbu Goyohen"
      ],
      "Year": "1927",
      "Director": "Daisuke Itô",
      "DirectorArray": [
        "Daisuke Itô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "79",
      "databaseFilmTitle": "A Difficult Life",
      "FilmTitle": "A Difficult Life",
      "AlternateTitle": "Una vita difficile",
      "TitleArray": [
        "A Difficult Life",
        "Una vita difficile"
      ],
      "Year": "1961",
      "Director": "Dino Risi",
      "DirectorArray": [
        "Dino Risi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "80",
      "databaseFilmTitle": "A Dirty Story",
      "FilmTitle": "A Dirty Story",
      "AlternateTitle": "Une sale histoire",
      "TitleArray": [
        "A Dirty Story",
        "Une sale histoire"
      ],
      "Year": "1977",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "81",
      "databaseFilmTitle": "A Dog's Life",
      "FilmTitle": "A Dog's Life",
      "AlternateTitle": "",
      "TitleArray": [
        "A Dog's Life"
      ],
      "Year": "1918",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "82",
      "databaseFilmTitle": "A Face in the Crowd",
      "FilmTitle": "A Face in the Crowd",
      "AlternateTitle": "",
      "TitleArray": [
        "A Face in the Crowd"
      ],
      "Year": "1957",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "83",
      "databaseFilmTitle": "A Family Finds Entertainment",
      "FilmTitle": "A Family Finds Entertainment",
      "AlternateTitle": "",
      "TitleArray": [
        "A Family Finds Entertainment"
      ],
      "Year": "2005",
      "Director": "Ryan Trecartin",
      "DirectorArray": [
        "Ryan Trecartin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "84",
      "databaseFilmTitle": "A Farewell to Arms",
      "FilmTitle": "A Farewell to Arms",
      "AlternateTitle": "",
      "TitleArray": [
        "A Farewell to Arms"
      ],
      "Year": "1932",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "85",
      "databaseFilmTitle": "A Few Good Men",
      "FilmTitle": "A Few Good Men",
      "AlternateTitle": "",
      "TitleArray": [
        "A Few Good Men"
      ],
      "Year": "1992",
      "Director": "Rob Reiner",
      "DirectorArray": [
        "Rob Reiner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "86",
      "databaseFilmTitle": "A Film Like Any Other",
      "FilmTitle": "A Film Like Any Other",
      "AlternateTitle": "Un film comme les autres",
      "TitleArray": [
        "A Film Like Any Other",
        "Un film comme les autres"
      ],
      "Year": "1968",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "87",
      "databaseFilmTitle": "A Fine Day",
      "FilmTitle": "A Fine Day",
      "AlternateTitle": "Der schöne Tag",
      "TitleArray": [
        "A Fine Day",
        "Der schöne Tag"
      ],
      "Year": "2001",
      "Director": "Thomas Arslan",
      "DirectorArray": [
        "Thomas Arslan"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "88",
      "databaseFilmTitle": "A Foreign Affair",
      "FilmTitle": "A Foreign Affair",
      "AlternateTitle": "",
      "TitleArray": [
        "A Foreign Affair"
      ],
      "Year": "1948",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "89",
      "databaseFilmTitle": "A Fugitive from the Past",
      "FilmTitle": "A Fugitive from the Past",
      "AlternateTitle": "Kiga kaikyō",
      "TitleArray": [
        "A Fugitive from the Past",
        "Kiga kaikyō"
      ],
      "Year": "1965",
      "Director": "Tomu Uchida",
      "DirectorArray": [
        "Tomu Uchida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "90",
      "databaseFilmTitle": "A Geisha",
      "FilmTitle": "A Geisha",
      "AlternateTitle": "Gion bayashi",
      "TitleArray": [
        "A Geisha",
        "Gion bayashi"
      ],
      "Year": "1953",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "91",
      "databaseFilmTitle": "A Generation",
      "FilmTitle": "A Generation",
      "AlternateTitle": "Pokolenie",
      "TitleArray": [
        "A Generation",
        "Pokolenie"
      ],
      "Year": "1955",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "92",
      "databaseFilmTitle": "A Gentle Woman",
      "FilmTitle": "A Gentle Woman",
      "AlternateTitle": "Une femme douce",
      "TitleArray": [
        "A Gentle Woman",
        "Une femme douce"
      ],
      "Year": "1969",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "93",
      "databaseFilmTitle": "A Ghost Story",
      "FilmTitle": "A Ghost Story",
      "AlternateTitle": "",
      "TitleArray": [
        "A Ghost Story"
      ],
      "Year": "2017",
      "Director": "David Lowery",
      "DirectorArray": [
        "David Lowery"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "94",
      "databaseFilmTitle": "A Girl and a Tree",
      "FilmTitle": "A Girl and a Tree",
      "AlternateTitle": "Deklica in Drevo",
      "TitleArray": [
        "A Girl and a Tree",
        "Deklica in Drevo"
      ],
      "Year": "2012",
      "Director": "Vlado Škafar",
      "DirectorArray": [
        "Vlado Škafar"
      ],
      "Country": "Slovenia",
      "CountryArray": [
        "Slovenia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "95",
      "databaseFilmTitle": "A Girl at My Door",
      "FilmTitle": "A Girl at My Door",
      "AlternateTitle": "Dohee-ya",
      "TitleArray": [
        "A Girl at My Door",
        "Dohee-ya"
      ],
      "Year": "2014",
      "Director": "July Jang",
      "DirectorArray": [
        "July Jang"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "96",
      "databaseFilmTitle": "A Girl Walks Home Alone at Night",
      "FilmTitle": "A Girl Walks Home Alone at Night",
      "AlternateTitle": "",
      "TitleArray": [
        "A Girl Walks Home Alone at Night"
      ],
      "Year": "2014",
      "Director": "Ana Lily Amirpour",
      "DirectorArray": [
        "Ana Lily Amirpour"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "97",
      "databaseFilmTitle": "A Grasscutter's Tale",
      "FilmTitle": "A Grasscutter's Tale",
      "AlternateTitle": "Kusatori kusagami",
      "TitleArray": [
        "A Grasscutter's Tale",
        "Kusatori kusagami"
      ],
      "Year": "1985",
      "Director": "Katsuhiko Fukuda",
      "DirectorArray": [
        "Katsuhiko Fukuda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "98",
      "databaseFilmTitle": "A Grin Without a Cat",
      "FilmTitle": "A Grin Without a Cat",
      "AlternateTitle": "Le fond de l'air est rouge",
      "TitleArray": [
        "A Grin Without a Cat",
        "Le fond de l'air est rouge"
      ],
      "Year": "1977",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "99",
      "databaseFilmTitle": "A Guest of Life: Alexander Csoma de Körös",
      "FilmTitle": "A Guest of Life: Alexander Csoma de Körös",
      "AlternateTitle": "Az élet vendége – Csoma legendárium",
      "TitleArray": [
        "A Guest of Life: Alexander Csoma de Körös",
        "Az élet vendége – Csoma legendárium"
      ],
      "Year": "2006",
      "Director": "Tibor Szemzö",
      "DirectorArray": [
        "Tibor Szemzö"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "100",
      "databaseFilmTitle": "A Hard Day's Night",
      "FilmTitle": "A Hard Day's Night",
      "AlternateTitle": "",
      "TitleArray": [
        "A Hard Day's Night"
      ],
      "Year": "1964",
      "Director": "Richard Lester",
      "DirectorArray": [
        "Richard Lester"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "101",
      "databaseFilmTitle": "A Heart in Winter",
      "FilmTitle": "A Heart in Winter",
      "AlternateTitle": "Un cœur en hiver",
      "TitleArray": [
        "A Heart in Winter",
        "Un cœur en hiver"
      ],
      "Year": "1992",
      "Director": "Claude Sautet",
      "DirectorArray": [
        "Claude Sautet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "102",
      "databaseFilmTitle": "A Hen in the Wind",
      "FilmTitle": "A Hen in the Wind",
      "AlternateTitle": "Kaze no naka no mendori",
      "TitleArray": [
        "A Hen in the Wind",
        "Kaze no naka no mendori"
      ],
      "Year": "1948",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "103",
      "databaseFilmTitle": "A Hidden Life",
      "FilmTitle": "A Hidden Life",
      "AlternateTitle": "",
      "TitleArray": [
        "A Hidden Life"
      ],
      "Year": "2019",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States, Germany",
      "CountryArray": [
        "United States",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "104",
      "databaseFilmTitle": "A History of Violence",
      "FilmTitle": "A History of Violence",
      "AlternateTitle": "",
      "TitleArray": [
        "A History of Violence"
      ],
      "Year": "2005",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "105",
      "databaseFilmTitle": "A Horse Is Not a Metaphor",
      "FilmTitle": "A Horse Is Not a Metaphor",
      "AlternateTitle": "",
      "TitleArray": [
        "A Horse Is Not a Metaphor"
      ],
      "Year": "2008",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "106",
      "databaseFilmTitle": "A King in New York",
      "FilmTitle": "A King in New York",
      "AlternateTitle": "",
      "TitleArray": [
        "A King in New York"
      ],
      "Year": "1957",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "107",
      "databaseFilmTitle": "A Letter from Beirut",
      "FilmTitle": "A Letter from Beirut",
      "AlternateTitle": "Rissala min Beirut",
      "TitleArray": [
        "A Letter from Beirut",
        "Rissala min Beirut"
      ],
      "Year": "1978",
      "Director": "Jocelyne Saab",
      "DirectorArray": [
        "Jocelyne Saab"
      ],
      "Country": "Lebanon",
      "CountryArray": [
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "108",
      "databaseFilmTitle": "A Life for a Life",
      "FilmTitle": "A Life for a Life",
      "AlternateTitle": "",
      "TitleArray": [
        "A Life for a Life"
      ],
      "Year": "1916",
      "Director": "Yevgeni Bauer",
      "DirectorArray": [
        "Yevgeni Bauer"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "109",
      "databaseFilmTitle": "A Lullaby to the Sorrowful Mystery",
      "FilmTitle": "A Lullaby to the Sorrowful Mystery",
      "AlternateTitle": "Hele sa Hiwagang Hapis",
      "TitleArray": [
        "A Lullaby to the Sorrowful Mystery",
        "Hele sa Hiwagang Hapis"
      ],
      "Year": "2016",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "110",
      "databaseFilmTitle": "A Man and a Woman",
      "FilmTitle": "A Man and a Woman",
      "AlternateTitle": "Un homme et une femme",
      "TitleArray": [
        "A Man and a Woman",
        "Un homme et une femme"
      ],
      "Year": "1966",
      "Director": "Claude Lelouch",
      "DirectorArray": [
        "Claude Lelouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "111",
      "databaseFilmTitle": "A Man Escaped",
      "FilmTitle": "A Man Escaped",
      "AlternateTitle": "Un condamné à mort s'est échappé ou Le vent souffle où il veut",
      "TitleArray": [
        "A Man Escaped",
        "Un condamné à mort s'est échappé ou Le vent souffle où il veut"
      ],
      "Year": "1956",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "69",
      "2012votes": "23",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "112",
      "databaseFilmTitle": "A Man for All Seasons",
      "FilmTitle": "A Man for All Seasons",
      "AlternateTitle": "",
      "TitleArray": [
        "A Man for All Seasons"
      ],
      "Year": "1966",
      "Director": "Fred Zinnemann",
      "DirectorArray": [
        "Fred Zinnemann"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "113",
      "databaseFilmTitle": "A Man There Was",
      "FilmTitle": "A Man There Was",
      "AlternateTitle": "Terje Vigen",
      "TitleArray": [
        "A Man There Was",
        "Terje Vigen"
      ],
      "Year": "1917",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "114",
      "databaseFilmTitle": "A Man Vanishes",
      "FilmTitle": "A Man Vanishes",
      "AlternateTitle": "Ningen jōhatsu",
      "TitleArray": [
        "A Man Vanishes",
        "Ningen jōhatsu"
      ],
      "Year": "1967",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "115",
      "databaseFilmTitle": "A Married Woman",
      "FilmTitle": "A Married Woman",
      "AlternateTitle": "Une femme mariée",
      "TitleArray": [
        "A Married Woman",
        "Une femme mariée"
      ],
      "Year": "1964",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "116",
      "databaseFilmTitle": "A Matter of Life and Death",
      "FilmTitle": "A Matter of Life and Death",
      "AlternateTitle": "",
      "TitleArray": [
        "A Matter of Life and Death"
      ],
      "Year": "1946",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "90",
      "2012votes": "18",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "117",
      "databaseFilmTitle": "A Matter of Time",
      "FilmTitle": "A Matter of Time",
      "AlternateTitle": "",
      "TitleArray": [
        "A Matter of Time"
      ],
      "Year": "1976",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "118",
      "databaseFilmTitle": "A Moment of Innocence",
      "FilmTitle": "A Moment of Innocence",
      "AlternateTitle": "Nun va Goldoon",
      "TitleArray": [
        "A Moment of Innocence",
        "Nun va Goldoon"
      ],
      "Year": "1996",
      "Director": "Mohsen Makhmalbaf",
      "DirectorArray": [
        "Mohsen Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "119",
      "databaseFilmTitle": "A Moment of Romance",
      "FilmTitle": "A Moment of Romance",
      "AlternateTitle": "Tiān Ruò Yǒu Qíng",
      "TitleArray": [
        "A Moment of Romance",
        "Tiān Ruò Yǒu Qíng"
      ],
      "Year": "1990",
      "Director": "Benny Chan",
      "DirectorArray": [
        "Benny Chan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "120",
      "databaseFilmTitle": "A Movie",
      "FilmTitle": "A Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "A Movie"
      ],
      "Year": "1958",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "121",
      "databaseFilmTitle": "A New Leaf",
      "FilmTitle": "A New Leaf",
      "AlternateTitle": "",
      "TitleArray": [
        "A New Leaf"
      ],
      "Year": "1971",
      "Director": "Elaine May",
      "DirectorArray": [
        "Elaine May"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "122",
      "databaseFilmTitle": "A Night at the Opera",
      "FilmTitle": "A Night at the Opera",
      "AlternateTitle": "",
      "TitleArray": [
        "A Night at the Opera"
      ],
      "Year": "1935",
      "Director": "Sam Wood",
      "DirectorArray": [
        "Sam Wood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "123",
      "databaseFilmTitle": "A Night of Knowing Nothing",
      "FilmTitle": "A Night of Knowing Nothing",
      "AlternateTitle": "",
      "TitleArray": [
        "A Night of Knowing Nothing"
      ],
      "Year": "2021",
      "Director": "Payal Kapadia",
      "DirectorArray": [
        "Payal Kapadia"
      ],
      "Country": "India, France",
      "CountryArray": [
        "India",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "124",
      "databaseFilmTitle": "A Night to Remember",
      "FilmTitle": "A Night to Remember",
      "AlternateTitle": "",
      "TitleArray": [
        "A Night to Remember"
      ],
      "Year": "1958",
      "Director": "Roy Ward Baker",
      "DirectorArray": [
        "Roy Ward Baker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "125",
      "databaseFilmTitle": "À nos amours",
      "FilmTitle": "À nos amours",
      "AlternateTitle": "",
      "TitleArray": [
        "À nos amours"
      ],
      "Year": "1983",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "126",
      "databaseFilmTitle": "À nous la liberté",
      "FilmTitle": "À nous la liberté",
      "AlternateTitle": "",
      "TitleArray": [
        "À nous la liberté"
      ],
      "Year": "1931",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "127",
      "databaseFilmTitle": "A Page of Madness",
      "FilmTitle": "A Page of Madness",
      "AlternateTitle": "Kurutta Ichipeiji",
      "TitleArray": [
        "A Page of Madness",
        "Kurutta Ichipeiji"
      ],
      "Year": "1926",
      "Director": "Teinosuke Kinugasa",
      "DirectorArray": [
        "Teinosuke Kinugasa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "128",
      "databaseFilmTitle": "A Pair of Tights",
      "FilmTitle": "A Pair of Tights",
      "AlternateTitle": "",
      "TitleArray": [
        "A Pair of Tights"
      ],
      "Year": "1929",
      "Director": "Hal Yates",
      "DirectorArray": [
        "Hal Yates"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "129",
      "databaseFilmTitle": "A Passage to India",
      "FilmTitle": "A Passage to India",
      "AlternateTitle": "",
      "TitleArray": [
        "A Passage to India"
      ],
      "Year": "1984",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "130",
      "databaseFilmTitle": "A Perfect World",
      "FilmTitle": "A Perfect World",
      "AlternateTitle": "",
      "TitleArray": [
        "A Perfect World"
      ],
      "Year": "1993",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "131",
      "databaseFilmTitle": "A Petal",
      "FilmTitle": "A Petal",
      "AlternateTitle": "Ggotip",
      "TitleArray": [
        "A Petal",
        "Ggotip"
      ],
      "Year": "1996",
      "Director": "Jang Sun-woo",
      "DirectorArray": [
        "Jang Sun-woo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "132",
      "databaseFilmTitle": "A Photographic Contortion",
      "FilmTitle": "A Photographic Contortion",
      "AlternateTitle": "The Big Swallow",
      "TitleArray": [
        "A Photographic Contortion",
        "The Big Swallow"
      ],
      "Year": "1901",
      "Director": "James Williamson",
      "DirectorArray": [
        "James Williamson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "133",
      "databaseFilmTitle": "A Pigeon Sat on a Branch Reflecting on Existence",
      "FilmTitle": "A Pigeon Sat on a Branch Reflecting on Existence",
      "AlternateTitle": "En duva satt på en gren och funderade på tillvaron",
      "TitleArray": [
        "A Pigeon Sat on a Branch Reflecting on Existence",
        "En duva satt på en gren och funderade på tillvaron"
      ],
      "Year": "2014",
      "Director": "Roy Andersson",
      "DirectorArray": [
        "Roy Andersson"
      ],
      "Country": "Sweden, Norway",
      "CountryArray": [
        "Sweden",
        "Norway"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "134",
      "databaseFilmTitle": "A Place in the Sun",
      "FilmTitle": "A Place in the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "A Place in the Sun"
      ],
      "Year": "1951",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "135",
      "databaseFilmTitle": "A Poet",
      "FilmTitle": "A Poet",
      "AlternateTitle": "Puisi Tak Terkuburkan",
      "TitleArray": [
        "A Poet",
        "Puisi Tak Terkuburkan"
      ],
      "Year": "2000",
      "Director": "Garin Nugroho",
      "DirectorArray": [
        "Garin Nugroho"
      ],
      "Country": "Indonesia",
      "CountryArray": [
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "136",
      "databaseFilmTitle": "A Portrait of Ga",
      "FilmTitle": "A Portrait of Ga",
      "AlternateTitle": "",
      "TitleArray": [
        "A Portrait of Ga"
      ],
      "Year": "1952",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "137",
      "databaseFilmTitle": "A Prairie Home Companion",
      "FilmTitle": "A Prairie Home Companion",
      "AlternateTitle": "",
      "TitleArray": [
        "A Prairie Home Companion"
      ],
      "Year": "2006",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "138",
      "databaseFilmTitle": "A Prophet",
      "FilmTitle": "A Prophet",
      "AlternateTitle": "Un prophète",
      "TitleArray": [
        "A Prophet",
        "Un prophète"
      ],
      "Year": "2009",
      "Director": "Jacques Audiard",
      "DirectorArray": [
        "Jacques Audiard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "139",
      "databaseFilmTitle": "À propos de Nice",
      "FilmTitle": "À propos de Nice",
      "AlternateTitle": "",
      "TitleArray": [
        "À propos de Nice"
      ],
      "Year": "1930",
      "Director": "Jean Vigo, Boris Kaufman",
      "DirectorArray": [
        "Jean Vigo",
        "Boris Kaufman"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "140",
      "databaseFilmTitle": "A Question of Silence",
      "FilmTitle": "A Question of Silence",
      "AlternateTitle": "De stilte rond Christine M",
      "TitleArray": [
        "A Question of Silence",
        "De stilte rond Christine M"
      ],
      "Year": "1982",
      "Director": "Marleen Gorris",
      "DirectorArray": [
        "Marleen Gorris"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "141",
      "databaseFilmTitle": "A Quiet Place in the Country",
      "FilmTitle": "A Quiet Place in the Country",
      "AlternateTitle": "Un tranquillo posto di campagna",
      "TitleArray": [
        "A Quiet Place in the Country",
        "Un tranquillo posto di campagna"
      ],
      "Year": "1968",
      "Director": "Elio Petri",
      "DirectorArray": [
        "Elio Petri"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "142",
      "databaseFilmTitle": "A Report on the Party and Guests",
      "FilmTitle": "A Report on the Party and Guests",
      "AlternateTitle": "O slavnosti a hostech",
      "TitleArray": [
        "A Report on the Party and Guests",
        "O slavnosti a hostech"
      ],
      "Year": "1966",
      "Director": "Jan Němec",
      "DirectorArray": [
        "Jan Němec"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "143",
      "databaseFilmTitle": "A River Called Titas",
      "FilmTitle": "A River Called Titas",
      "AlternateTitle": "Titash Ekti Nadir Naam",
      "TitleArray": [
        "A River Called Titas",
        "Titash Ekti Nadir Naam"
      ],
      "Year": "1973",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India, Bangladesh",
      "CountryArray": [
        "India",
        "Bangladesh"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "144",
      "databaseFilmTitle": "A Room in Town",
      "FilmTitle": "A Room in Town",
      "AlternateTitle": "Une chambre en ville",
      "TitleArray": [
        "A Room in Town",
        "Une chambre en ville"
      ],
      "Year": "1982",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "145",
      "databaseFilmTitle": "A Room with a View",
      "FilmTitle": "A Room with a View",
      "AlternateTitle": "",
      "TitleArray": [
        "A Room with a View"
      ],
      "Year": "1985",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "146",
      "databaseFilmTitle": "A Screaming Man",
      "FilmTitle": "A Screaming Man",
      "AlternateTitle": "Un homme qui crie",
      "TitleArray": [
        "A Screaming Man",
        "Un homme qui crie"
      ],
      "Year": "2010",
      "Director": "Mahamat-Saleh Haroun",
      "DirectorArray": [
        "Mahamat-Saleh Haroun"
      ],
      "Country": "Chad",
      "CountryArray": [
        "Chad"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "147",
      "databaseFilmTitle": "A Separation",
      "FilmTitle": "A Separation",
      "AlternateTitle": "Jodaeiye Nader az Simin",
      "TitleArray": [
        "A Separation",
        "Jodaeiye Nader az Simin"
      ],
      "Year": "2011",
      "Director": "Asghar Farhadi",
      "DirectorArray": [
        "Asghar Farhadi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "148",
      "databaseFilmTitle": "A Serbian Film",
      "FilmTitle": "A Serbian Film",
      "AlternateTitle": "Српски филм",
      "TitleArray": [
        "A Serbian Film",
        "Српски филм"
      ],
      "Year": "2009",
      "Director": "Srdjan Spasojevic",
      "DirectorArray": [
        "Srdjan Spasojevic"
      ],
      "Country": "Serbia",
      "CountryArray": [
        "Serbia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "149",
      "databaseFilmTitle": "A Serious Man",
      "FilmTitle": "A Serious Man",
      "AlternateTitle": "",
      "TitleArray": [
        "A Serious Man"
      ],
      "Year": "2009",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "150",
      "databaseFilmTitle": "A Severe Young Man",
      "FilmTitle": "A Severe Young Man",
      "AlternateTitle": "Стро́гий ю́ноша",
      "TitleArray": [
        "A Severe Young Man",
        "Стро́гий ю́ноша"
      ],
      "Year": "1935",
      "Director": "Abram Room",
      "DirectorArray": [
        "Abram Room"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "151",
      "databaseFilmTitle": "A Short Film About Killing",
      "FilmTitle": "A Short Film About Killing",
      "AlternateTitle": "A Short Film About Killing",
      "TitleArray": [
        "A Short Film About Killing",
        "A Short Film About Killing"
      ],
      "Year": "1988",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "152",
      "databaseFilmTitle": "A Short Film About Love",
      "FilmTitle": "A Short Film About Love",
      "AlternateTitle": "Krótki film o miłości",
      "TitleArray": [
        "A Short Film About Love",
        "Krótki film o miłości"
      ],
      "Year": "1988",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "153",
      "databaseFilmTitle": "A Short Film About the Indio Nacional (or the Prolonged Sorrow of the Filipinos)",
      "FilmTitle": "A Short Film About the Indio Nacional (or the Prolonged Sorrow of the Filipinos)",
      "AlternateTitle": "Maicling pelicula nañg ysañg Indio Nacional",
      "TitleArray": [
        "A Short Film About the Indio Nacional (or the Prolonged Sorrow of the Filipinos)",
        "Maicling pelicula nañg ysañg Indio Nacional"
      ],
      "Year": "2005",
      "Director": "Raya Martin",
      "DirectorArray": [
        "Raya Martin"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "154",
      "databaseFilmTitle": "A Simple Event",
      "FilmTitle": "A Simple Event",
      "AlternateTitle": "Yek Etefagh sadeh",
      "TitleArray": [
        "A Simple Event",
        "Yek Etefagh sadeh"
      ],
      "Year": "1973",
      "Director": "Sohrab Shahid Saless",
      "DirectorArray": [
        "Sohrab Shahid Saless"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "155",
      "databaseFilmTitle": "A Simple Life",
      "FilmTitle": "A Simple Life",
      "AlternateTitle": "",
      "TitleArray": [
        "A Simple Life"
      ],
      "Year": "2011",
      "Director": "Ann Hui",
      "DirectorArray": [
        "Ann Hui"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "156",
      "databaseFilmTitle": "A Simple Story",
      "FilmTitle": "A Simple Story",
      "AlternateTitle": "Une simple histoire",
      "TitleArray": [
        "A Simple Story",
        "Une simple histoire"
      ],
      "Year": "1959",
      "Director": "Marcel Hanoun",
      "DirectorArray": [
        "Marcel Hanoun"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "157",
      "databaseFilmTitle": "A Sixth Part of the World",
      "FilmTitle": "A Sixth Part of the World",
      "AlternateTitle": "Шеста́я часть ми́ра",
      "TitleArray": [
        "A Sixth Part of the World",
        "Шеста́я часть ми́ра"
      ],
      "Year": "1926",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "158",
      "databaseFilmTitle": "A Slave of Love",
      "FilmTitle": "A Slave of Love",
      "AlternateTitle": "",
      "TitleArray": [
        "A Slave of Love"
      ],
      "Year": "1976",
      "Director": "Nikita Mikhalkov",
      "DirectorArray": [
        "Nikita Mikhalkov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "159",
      "databaseFilmTitle": "A Soft Note on a Sharp Scale",
      "FilmTitle": "A Soft Note on a Sharp Scale",
      "AlternateTitle": "Komal Gandhar",
      "TitleArray": [
        "A Soft Note on a Sharp Scale",
        "Komal Gandhar"
      ],
      "Year": "1961",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "160",
      "databaseFilmTitle": "A Song of Love",
      "FilmTitle": "A Song of Love",
      "AlternateTitle": "Un chant d'amour",
      "TitleArray": [
        "A Song of Love",
        "Un chant d'amour"
      ],
      "Year": "1950",
      "Director": "Jean Genet",
      "DirectorArray": [
        "Jean Genet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "161",
      "databaseFilmTitle": "A Special Day",
      "FilmTitle": "A Special Day",
      "AlternateTitle": "Una giornata particolare",
      "TitleArray": [
        "A Special Day",
        "Una giornata particolare"
      ],
      "Year": "1977",
      "Director": "Ettore Scola",
      "DirectorArray": [
        "Ettore Scola"
      ],
      "Country": "Italy, Canada",
      "CountryArray": [
        "Italy",
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "162",
      "databaseFilmTitle": "A Star Is Born",
      "FilmTitle": "A Star Is Born",
      "AlternateTitle": "",
      "TitleArray": [
        "A Star Is Born"
      ],
      "Year": "1954",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "163",
      "databaseFilmTitle": "A Streetcar Named Desire",
      "FilmTitle": "A Streetcar Named Desire",
      "AlternateTitle": "",
      "TitleArray": [
        "A Streetcar Named Desire"
      ],
      "Year": "1951",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "164",
      "databaseFilmTitle": "A Summer's Tale",
      "FilmTitle": "A Summer's Tale",
      "AlternateTitle": "Conte d'été",
      "TitleArray": [
        "A Summer's Tale",
        "Conte d'été"
      ],
      "Year": "1996",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "165",
      "databaseFilmTitle": "A Sunday in the Country",
      "FilmTitle": "A Sunday in the Country",
      "AlternateTitle": "Un dimanche à la campagne",
      "TitleArray": [
        "A Sunday in the Country",
        "Un dimanche à la campagne"
      ],
      "Year": "1984",
      "Director": "Bertrand Tavernier",
      "DirectorArray": [
        "Bertrand Tavernier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "166",
      "databaseFilmTitle": "A Swedish Love Story",
      "FilmTitle": "A Swedish Love Story",
      "AlternateTitle": "En kärlekshistoria",
      "TitleArray": [
        "A Swedish Love Story",
        "En kärlekshistoria"
      ],
      "Year": "1970",
      "Director": "Roy Andersson",
      "DirectorArray": [
        "Roy Andersson"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "167",
      "databaseFilmTitle": "A Tale of the Wind",
      "FilmTitle": "A Tale of the Wind",
      "AlternateTitle": "Une histoire de vent",
      "TitleArray": [
        "A Tale of the Wind",
        "Une histoire de vent"
      ],
      "Year": "1988",
      "Director": "Joris Ivens",
      "DirectorArray": [
        "Joris Ivens"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "168",
      "databaseFilmTitle": "A Talking Picture",
      "FilmTitle": "A Talking Picture",
      "AlternateTitle": "Um Filme Falado",
      "TitleArray": [
        "A Talking Picture",
        "Um Filme Falado"
      ],
      "Year": "2003",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "169",
      "databaseFilmTitle": "A Taste of Honey",
      "FilmTitle": "A Taste of Honey",
      "AlternateTitle": "",
      "TitleArray": [
        "A Taste of Honey"
      ],
      "Year": "1961",
      "Director": "Tony Richardson",
      "DirectorArray": [
        "Tony Richardson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "170",
      "databaseFilmTitle": "A Thousand Suns",
      "FilmTitle": "A Thousand Suns",
      "AlternateTitle": "Mille soleils",
      "TitleArray": [
        "A Thousand Suns",
        "Mille soleils"
      ],
      "Year": "2013",
      "Director": "Mati Diop",
      "DirectorArray": [
        "Mati Diop"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "171",
      "databaseFilmTitle": "A Time out of War",
      "FilmTitle": "A Time out of War",
      "AlternateTitle": "",
      "TitleArray": [
        "A Time out of War"
      ],
      "Year": "1954",
      "Director": "Denis Sanders",
      "DirectorArray": [
        "Denis Sanders"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "172",
      "databaseFilmTitle": "A Time to Live and a Time to Die",
      "FilmTitle": "A Time to Live and a Time to Die",
      "AlternateTitle": "Tóngnián wangshì",
      "TitleArray": [
        "A Time to Live and a Time to Die",
        "Tóngnián wangshì"
      ],
      "Year": "1985",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "173",
      "databaseFilmTitle": "A Time to Love and a Time to Die",
      "FilmTitle": "A Time to Love and a Time to Die",
      "AlternateTitle": "",
      "TitleArray": [
        "A Time to Love and a Time to Die"
      ],
      "Year": "1958",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "174",
      "databaseFilmTitle": "A Touch of Sin",
      "FilmTitle": "A Touch of Sin",
      "AlternateTitle": "Tian zhu ding",
      "TitleArray": [
        "A Touch of Sin",
        "Tian zhu ding"
      ],
      "Year": "2013",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "175",
      "databaseFilmTitle": "A Touch of Zen",
      "FilmTitle": "A Touch of Zen",
      "AlternateTitle": "Xia nu",
      "TitleArray": [
        "A Touch of Zen",
        "Xia nu"
      ],
      "Year": "1971",
      "Director": "King Hu",
      "DirectorArray": [
        "King Hu"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "176",
      "databaseFilmTitle": "A Tree Grows in Brooklyn",
      "FilmTitle": "A Tree Grows in Brooklyn",
      "AlternateTitle": "",
      "TitleArray": [
        "A Tree Grows in Brooklyn"
      ],
      "Year": "1945",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "177",
      "databaseFilmTitle": "A Trip Down Market Street Before the Fire",
      "FilmTitle": "A Trip Down Market Street Before the Fire",
      "AlternateTitle": "",
      "TitleArray": [
        "A Trip Down Market Street Before the Fire"
      ],
      "Year": "1906",
      "Director": "Earle Miles, Harry Miles, Herbert Miles, Joseph Miles",
      "DirectorArray": [
        "Earle Miles",
        "Harry Miles",
        "Herbert Miles",
        "Joseph Miles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "178",
      "databaseFilmTitle": "A Trip to the Moon",
      "FilmTitle": "A Trip to the Moon",
      "AlternateTitle": "Le Voyage dans la Lune",
      "TitleArray": [
        "A Trip to the Moon",
        "Le Voyage dans la Lune"
      ],
      "Year": "1902",
      "Director": "Georges Méliès",
      "DirectorArray": [
        "Georges Méliès"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "179",
      "databaseFilmTitle": "A Very Curious Girl",
      "FilmTitle": "A Very Curious Girl",
      "AlternateTitle": "La fiancée du pirate",
      "TitleArray": [
        "A Very Curious Girl",
        "La fiancée du pirate"
      ],
      "Year": "1969",
      "Director": "Nelly Kaplan",
      "DirectorArray": [
        "Nelly Kaplan"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "180",
      "databaseFilmTitle": "A Visit to the Louvre",
      "FilmTitle": "A Visit to the Louvre",
      "AlternateTitle": "Une visite au Louvre",
      "TitleArray": [
        "A Visit to the Louvre",
        "Une visite au Louvre"
      ],
      "Year": "2004",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Germany, Italy",
      "CountryArray": [
        "Germany",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "181",
      "databaseFilmTitle": "A Walk in the Sun",
      "FilmTitle": "A Walk in the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "A Walk in the Sun"
      ],
      "Year": "1945",
      "Director": "Lewis Milestone",
      "DirectorArray": [
        "Lewis Milestone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "182",
      "databaseFilmTitle": "A Warm December",
      "FilmTitle": "A Warm December",
      "AlternateTitle": "",
      "TitleArray": [
        "A Warm December"
      ],
      "Year": "1973",
      "Director": "Sidney Poitier",
      "DirectorArray": [
        "Sidney Poitier"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "183",
      "databaseFilmTitle": "A Wedding",
      "FilmTitle": "A Wedding",
      "AlternateTitle": "",
      "TitleArray": [
        "A Wedding"
      ],
      "Year": "1978",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "184",
      "databaseFilmTitle": "A Wedding Suit",
      "FilmTitle": "A Wedding Suit",
      "AlternateTitle": "Lebassi Baraye Arossi",
      "TitleArray": [
        "A Wedding Suit",
        "Lebassi Baraye Arossi"
      ],
      "Year": "1976",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "185",
      "databaseFilmTitle": "A Woman Alone",
      "FilmTitle": "A Woman Alone",
      "AlternateTitle": "Kobieta Samotna",
      "TitleArray": [
        "A Woman Alone",
        "Kobieta Samotna"
      ],
      "Year": "1981",
      "Director": "Agnieszka Holland",
      "DirectorArray": [
        "Agnieszka Holland"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "186",
      "databaseFilmTitle": "A Woman in Love",
      "FilmTitle": "A Woman in Love",
      "AlternateTitle": "Enamorada",
      "TitleArray": [
        "A Woman in Love",
        "Enamorada"
      ],
      "Year": "1946",
      "Director": "Emilio Fernández",
      "DirectorArray": [
        "Emilio Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "187",
      "databaseFilmTitle": "A Woman Is a Woman",
      "FilmTitle": "A Woman Is a Woman",
      "AlternateTitle": "Une femme est une femme",
      "TitleArray": [
        "A Woman Is a Woman",
        "Une femme est une femme"
      ],
      "Year": "1961",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "188",
      "databaseFilmTitle": "A Woman of Paris",
      "FilmTitle": "A Woman of Paris",
      "AlternateTitle": "A Woman of Paris: A Drama of Fate",
      "TitleArray": [
        "A Woman of Paris",
        "A Woman of Paris: A Drama of Fate"
      ],
      "Year": "1923",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "189",
      "databaseFilmTitle": "A Woman Under the Influence",
      "FilmTitle": "A Woman Under the Influence",
      "AlternateTitle": "",
      "TitleArray": [
        "A Woman Under the Influence"
      ],
      "Year": "1974",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "114",
      "2022votes": "27"
    },
    {
      "key": "190",
      "databaseFilmTitle": "A Woman's Revenge",
      "FilmTitle": "A Woman's Revenge",
      "AlternateTitle": "A Vingança de Uma Mulher",
      "TitleArray": [
        "A Woman's Revenge",
        "A Vingança de Uma Mulher"
      ],
      "Year": "2012",
      "Director": "Rita Azevedo Gomes",
      "DirectorArray": [
        "Rita Azevedo Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "191",
      "databaseFilmTitle": "A Woman's Way",
      "FilmTitle": "A Woman's Way",
      "AlternateTitle": "Strella",
      "TitleArray": [
        "A Woman's Way",
        "Strella"
      ],
      "Year": "2009",
      "Director": "Panos H. Koutras",
      "DirectorArray": [
        "Panos H. Koutras"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "192",
      "databaseFilmTitle": "A World Not Ours",
      "FilmTitle": "A World Not Ours",
      "AlternateTitle": "Alam laysa lana",
      "TitleArray": [
        "A World Not Ours",
        "Alam laysa lana"
      ],
      "Year": "2012",
      "Director": "Mahdi Fleifel",
      "DirectorArray": [
        "Mahdi Fleifel"
      ],
      "Country": "United Kingdom, Lebanon",
      "CountryArray": [
        "United Kingdom",
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "193",
      "databaseFilmTitle": "A.I. Artificial Intelligence",
      "FilmTitle": "A.I. Artificial Intelligence",
      "AlternateTitle": "",
      "TitleArray": [
        "A.I. Artificial Intelligence"
      ],
      "Year": "2001",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "194",
      "databaseFilmTitle": "A.K.A. Serial Killer",
      "FilmTitle": "A.K.A. Serial Killer",
      "AlternateTitle": "Ryakushō: renzoku shasatsuma",
      "TitleArray": [
        "A.K.A. Serial Killer",
        "Ryakushō: renzoku shasatsuma"
      ],
      "Year": "1969",
      "Director": "Masao Adachi",
      "DirectorArray": [
        "Masao Adachi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "195",
      "databaseFilmTitle": "Aaaaaaaah!",
      "FilmTitle": "Aaaaaaaah!",
      "AlternateTitle": "",
      "TitleArray": [
        "Aaaaaaaah!"
      ],
      "Year": "2015",
      "Director": "Steve Oram",
      "DirectorArray": [
        "Steve Oram"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "196",
      "databaseFilmTitle": "Aaja Nachle",
      "FilmTitle": "Aaja Nachle",
      "AlternateTitle": "",
      "TitleArray": [
        "Aaja Nachle"
      ],
      "Year": "2007",
      "Director": "Anil Mehta",
      "DirectorArray": [
        "Anil Mehta"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "197",
      "databaseFilmTitle": "Abendland",
      "FilmTitle": "Abendland",
      "AlternateTitle": "",
      "TitleArray": [
        "Abendland"
      ],
      "Year": "2011",
      "Director": "Nikolaus Geyrhalter",
      "DirectorArray": [
        "Nikolaus Geyrhalter"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "198",
      "databaseFilmTitle": "Abolition",
      "FilmTitle": "Abolition",
      "AlternateTitle": "Abolição",
      "TitleArray": [
        "Abolition",
        "Abolição"
      ],
      "Year": "1988",
      "Director": "Zózimo Bulbul",
      "DirectorArray": [
        "Zózimo Bulbul"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "199",
      "databaseFilmTitle": "About Elly",
      "FilmTitle": "About Elly",
      "AlternateTitle": "Dar bāre-ye Elly",
      "TitleArray": [
        "About Elly",
        "Dar bāre-ye Elly"
      ],
      "Year": "2009",
      "Director": "Asghar Farhadi",
      "DirectorArray": [
        "Asghar Farhadi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "200",
      "databaseFilmTitle": "About Some Meaningless Events",
      "FilmTitle": "About Some Meaningless Events",
      "AlternateTitle": "De quelques événements sans signification",
      "TitleArray": [
        "About Some Meaningless Events",
        "De quelques événements sans signification"
      ],
      "Year": "1974",
      "Director": "Mostafa Derkaoui",
      "DirectorArray": [
        "Mostafa Derkaoui"
      ],
      "Country": "Morocco",
      "CountryArray": [
        "Morocco"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "201",
      "databaseFilmTitle": "Above the Law",
      "FilmTitle": "Above the Law",
      "AlternateTitle": "Righting Wrongs",
      "TitleArray": [
        "Above the Law",
        "Righting Wrongs"
      ],
      "Year": "1986",
      "Director": "Corey Yuen",
      "DirectorArray": [
        "Corey Yuen"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "202",
      "databaseFilmTitle": "Abraham Lincoln",
      "FilmTitle": "Abraham Lincoln",
      "AlternateTitle": "Studio One: Abraham Lincoln",
      "TitleArray": [
        "Abraham Lincoln",
        "Studio One: Abraham Lincoln"
      ],
      "Year": "1952",
      "Director": "Pail Nickell",
      "DirectorArray": [
        "Pail Nickell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "203",
      "databaseFilmTitle": "Abraham's Valley",
      "FilmTitle": "Abraham's Valley",
      "AlternateTitle": "Vale Abraão",
      "TitleArray": [
        "Abraham's Valley",
        "Vale Abraão"
      ],
      "Year": "1993",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "204",
      "databaseFilmTitle": "Accattone",
      "FilmTitle": "Accattone",
      "AlternateTitle": "",
      "TitleArray": [
        "Accattone"
      ],
      "Year": "1961",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "205",
      "databaseFilmTitle": "Accident",
      "FilmTitle": "Accident",
      "AlternateTitle": "",
      "TitleArray": [
        "Accident"
      ],
      "Year": "1967",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "206",
      "databaseFilmTitle": "Ace in the Hole",
      "FilmTitle": "Ace in the Hole",
      "AlternateTitle": "",
      "TitleArray": [
        "Ace in the Hole"
      ],
      "Year": "1951",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "207",
      "databaseFilmTitle": "Acrobatic Sisters Dainef",
      "FilmTitle": "Acrobatic Sisters Dainef",
      "AlternateTitle": "Les six soeurs Dainef",
      "TitleArray": [
        "Acrobatic Sisters Dainef",
        "Les six soeurs Dainef"
      ],
      "Year": "1903",
      "Director": "(unknown)",
      "DirectorArray": [
        "(unknown)"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "208",
      "databaseFilmTitle": "Acts of the Apostles",
      "FilmTitle": "Acts of the Apostles",
      "AlternateTitle": "Atti degli apostoli",
      "TitleArray": [
        "Acts of the Apostles",
        "Atti degli apostoli"
      ],
      "Year": "1969",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "209",
      "databaseFilmTitle": "Acuérdate de vivir",
      "FilmTitle": "Acuérdate de vivir",
      "AlternateTitle": "",
      "TitleArray": [
        "Acuérdate de vivir"
      ],
      "Year": "1953",
      "Director": "Roberto Gavaldón",
      "DirectorArray": [
        "Roberto Gavaldón"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "210",
      "databaseFilmTitle": "Adebar",
      "FilmTitle": "Adebar",
      "AlternateTitle": "",
      "TitleArray": [
        "Adebar"
      ],
      "Year": "1957",
      "Director": "Peter Kubelka",
      "DirectorArray": [
        "Peter Kubelka"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "211",
      "databaseFilmTitle": "Adieu Philippine",
      "FilmTitle": "Adieu Philippine",
      "AlternateTitle": "",
      "TitleArray": [
        "Adieu Philippine"
      ],
      "Year": "1962",
      "Director": "Jacques Rozier",
      "DirectorArray": [
        "Jacques Rozier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "212",
      "databaseFilmTitle": "Adoption",
      "FilmTitle": "Adoption",
      "AlternateTitle": "Örökbefogadás",
      "TitleArray": [
        "Adoption",
        "Örökbefogadás"
      ],
      "Year": "1975",
      "Director": "Márta Mészáros",
      "DirectorArray": [
        "Márta Mészáros"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "213",
      "databaseFilmTitle": "Adrift",
      "FilmTitle": "Adrift",
      "AlternateTitle": "Touha zvaná Anada",
      "TitleArray": [
        "Adrift",
        "Touha zvaná Anada"
      ],
      "Year": "1970",
      "Director": "Ján Kadár, Elmar Klos",
      "DirectorArray": [
        "Ján Kadár",
        "Elmar Klos"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "214",
      "databaseFilmTitle": "Adventures of Don Quixote",
      "FilmTitle": "Adventures of Don Quixote",
      "AlternateTitle": "",
      "TitleArray": [
        "Adventures of Don Quixote"
      ],
      "Year": "1933",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "215",
      "databaseFilmTitle": "Advise & Consent",
      "FilmTitle": "Advise & Consent",
      "AlternateTitle": "",
      "TitleArray": [
        "Advise & Consent"
      ],
      "Year": "1962",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "216",
      "databaseFilmTitle": "Africa addio",
      "FilmTitle": "Africa addio",
      "AlternateTitle": "",
      "TitleArray": [
        "Africa addio"
      ],
      "Year": "1966",
      "Director": "Gualtiero Jacopetti, Franco Prosperi",
      "DirectorArray": [
        "Gualtiero Jacopetti",
        "Franco Prosperi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "217",
      "databaseFilmTitle": "Afrique 50",
      "FilmTitle": "Afrique 50",
      "AlternateTitle": "",
      "TitleArray": [
        "Afrique 50"
      ],
      "Year": "1950",
      "Director": "René Vautier",
      "DirectorArray": [
        "René Vautier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "218",
      "databaseFilmTitle": "After Hours",
      "FilmTitle": "After Hours",
      "AlternateTitle": "",
      "TitleArray": [
        "After Hours"
      ],
      "Year": "1985",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "219",
      "databaseFilmTitle": "After Life",
      "FilmTitle": "After Life",
      "AlternateTitle": "Wandafuru Raifu",
      "TitleArray": [
        "After Life",
        "Wandafuru Raifu"
      ],
      "Year": "1998",
      "Director": "Hirokazu Koreeda",
      "DirectorArray": [
        "Hirokazu Koreeda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "220",
      "databaseFilmTitle": "After Lucía",
      "FilmTitle": "After Lucía",
      "AlternateTitle": "Después de Lucía",
      "TitleArray": [
        "After Lucía",
        "Después de Lucía"
      ],
      "Year": "2012",
      "Director": "Michel Franco",
      "DirectorArray": [
        "Michel Franco"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "221",
      "databaseFilmTitle": "Afterimage",
      "FilmTitle": "Afterimage",
      "AlternateTitle": "Powidoki",
      "TitleArray": [
        "Afterimage",
        "Powidoki"
      ],
      "Year": "2016",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "222",
      "databaseFilmTitle": "Afterword",
      "FilmTitle": "Afterword",
      "AlternateTitle": "",
      "TitleArray": [
        "Afterword"
      ],
      "Year": "1983",
      "Director": "Marlen Khutsiev",
      "DirectorArray": [
        "Marlen Khutsiev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "223",
      "databaseFilmTitle": "Aguirre, the Wrath of God",
      "FilmTitle": "Aguirre, the Wrath of God",
      "AlternateTitle": "Aguirre, der Zorn Gottes",
      "TitleArray": [
        "Aguirre, the Wrath of God",
        "Aguirre, der Zorn Gottes"
      ],
      "Year": "1972",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "90",
      "2012votes": "18",
      "2022rank": "118",
      "2022votes": "26"
    },
    {
      "key": "224",
      "databaseFilmTitle": "Ah Ying",
      "FilmTitle": "Ah Ying",
      "AlternateTitle": "Boon bin yen",
      "TitleArray": [
        "Ah Ying",
        "Boon bin yen"
      ],
      "Year": "1983",
      "Director": "Allen Fong",
      "DirectorArray": [
        "Allen Fong"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "225",
      "databaseFilmTitle": "Aido: Slave of Love",
      "FilmTitle": "Aido: Slave of Love",
      "AlternateTitle": "Aido",
      "TitleArray": [
        "Aido: Slave of Love",
        "Aido"
      ],
      "Year": "1969",
      "Director": "Susumu Hani",
      "DirectorArray": [
        "Susumu Hani"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "226",
      "databaseFilmTitle": "Airplane!",
      "FilmTitle": "Airplane!",
      "AlternateTitle": "",
      "TitleArray": [
        "Airplane!"
      ],
      "Year": "1980",
      "Director": "Jim Abrahams, David Zucker, Jerry Zucker",
      "DirectorArray": [
        "Jim Abrahams",
        "David Zucker",
        "Jerry Zucker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "227",
      "databaseFilmTitle": "Ajantrik",
      "FilmTitle": "Ajantrik",
      "AlternateTitle": "",
      "TitleArray": [
        "Ajantrik"
      ],
      "Year": "1958",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "228",
      "databaseFilmTitle": "Akira",
      "FilmTitle": "Akira",
      "AlternateTitle": "",
      "TitleArray": [
        "Akira"
      ],
      "Year": "1988",
      "Director": "Katsuhiro Ôtomo",
      "DirectorArray": [
        "Katsuhiro Ôtomo"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "229",
      "databaseFilmTitle": "Akira Kurosawa's Dreams",
      "FilmTitle": "Akira Kurosawa's Dreams",
      "AlternateTitle": "Yume",
      "TitleArray": [
        "Akira Kurosawa's Dreams",
        "Yume"
      ],
      "Year": "1990",
      "Director": "Akira Kurosawa, Ishirô Honda",
      "DirectorArray": [
        "Akira Kurosawa",
        "Ishirô Honda"
      ],
      "Country": "Japan, United States",
      "CountryArray": [
        "Japan",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "230",
      "databaseFilmTitle": "Alaya",
      "FilmTitle": "Alaya",
      "AlternateTitle": "",
      "TitleArray": [
        "Alaya"
      ],
      "Year": "1987",
      "Director": "Nataniel Dorsky",
      "DirectorArray": [
        "Nataniel Dorsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "231",
      "databaseFilmTitle": "Alex",
      "FilmTitle": "Alex",
      "AlternateTitle": "A Idade Maior",
      "TitleArray": [
        "Alex",
        "A Idade Maior"
      ],
      "Year": "1991",
      "Director": "Teresa Villaverde",
      "DirectorArray": [
        "Teresa Villaverde"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "232",
      "databaseFilmTitle": "Alexander Nevsky",
      "FilmTitle": "Alexander Nevsky",
      "AlternateTitle": "",
      "TitleArray": [
        "Alexander Nevsky"
      ],
      "Year": "1983",
      "Director": "Sergei Eisenstein",
      "DirectorArray": [
        "Sergei Eisenstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "233",
      "databaseFilmTitle": "Alexandria, Again and Forever",
      "FilmTitle": "Alexandria, Again and Forever",
      "AlternateTitle": "Iskanderija, kaman oue kaman",
      "TitleArray": [
        "Alexandria, Again and Forever",
        "Iskanderija, kaman oue kaman"
      ],
      "Year": "1989",
      "Director": "Youssef Chahine",
      "DirectorArray": [
        "Youssef Chahine"
      ],
      "Country": "France, Egypt",
      "CountryArray": [
        "France",
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "234",
      "databaseFilmTitle": "Ali in Wonderland",
      "FilmTitle": "Ali in Wonderland",
      "AlternateTitle": "Ali au pays des merveilles",
      "TitleArray": [
        "Ali in Wonderland",
        "Ali au pays des merveilles"
      ],
      "Year": "1975",
      "Director": "Djouhra Abouda, Alain Bonnamy",
      "DirectorArray": [
        "Djouhra Abouda",
        "Alain Bonnamy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "235",
      "databaseFilmTitle": "Ali: Fear Eats the Soul",
      "FilmTitle": "Ali: Fear Eats the Soul",
      "AlternateTitle": "Angst essen Seele auf",
      "TitleArray": [
        "Ali: Fear Eats the Soul",
        "Angst essen Seele auf"
      ],
      "Year": "1974",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "52",
      "2022votes": "45"
    },
    {
      "key": "236",
      "databaseFilmTitle": "Alice",
      "FilmTitle": "Alice",
      "AlternateTitle": "Něco z Alenky",
      "TitleArray": [
        "Alice",
        "Něco z Alenky"
      ],
      "Year": "1988",
      "Director": "Jan Švankmajer",
      "DirectorArray": [
        "Jan Švankmajer"
      ],
      "Country": "Czechoslovakia, Switzerland",
      "CountryArray": [
        "Czechoslovakia",
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "237",
      "databaseFilmTitle": "Alice Adams",
      "FilmTitle": "Alice Adams",
      "AlternateTitle": "",
      "TitleArray": [
        "Alice Adams"
      ],
      "Year": "1935",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "238",
      "databaseFilmTitle": "Alice Doesn't Live Here Anymore",
      "FilmTitle": "Alice Doesn't Live Here Anymore",
      "AlternateTitle": "",
      "TitleArray": [
        "Alice Doesn't Live Here Anymore"
      ],
      "Year": "1974",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "239",
      "databaseFilmTitle": "Alice in Russialand",
      "FilmTitle": "Alice in Russialand",
      "AlternateTitle": "",
      "TitleArray": [
        "Alice in Russialand"
      ],
      "Year": "1995",
      "Director": "Ken Russell",
      "DirectorArray": [
        "Ken Russell"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "240",
      "databaseFilmTitle": "Alice in the Cities",
      "FilmTitle": "Alice in the Cities",
      "AlternateTitle": "Alice in den Stätden",
      "TitleArray": [
        "Alice in the Cities",
        "Alice in den Stätden"
      ],
      "Year": "1974",
      "Director": "Win Wenders",
      "DirectorArray": [
        "Win Wenders"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "241",
      "databaseFilmTitle": "Alien",
      "FilmTitle": "Alien",
      "AlternateTitle": "",
      "TitleArray": [
        "Alien"
      ],
      "Year": "1979",
      "Director": "Ridley Scott",
      "DirectorArray": [
        "Ridley Scott"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "242",
      "databaseFilmTitle": "Aliens",
      "FilmTitle": "Aliens",
      "AlternateTitle": "",
      "TitleArray": [
        "Aliens"
      ],
      "Year": "1986",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "243",
      "databaseFilmTitle": "All about Eve",
      "FilmTitle": "All about Eve",
      "AlternateTitle": "",
      "TitleArray": [
        "All about Eve"
      ],
      "Year": "1950",
      "Director": "Joseph L. Mankiewicz",
      "DirectorArray": [
        "Joseph L. Mankiewicz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "244",
      "databaseFilmTitle": "All About My Mother",
      "FilmTitle": "All About My Mother",
      "AlternateTitle": "Todo sobre mi madre",
      "TitleArray": [
        "All About My Mother",
        "Todo sobre mi madre"
      ],
      "Year": "1999",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "245",
      "databaseFilmTitle": "All Around Us",
      "FilmTitle": "All Around Us",
      "AlternateTitle": "Gururi no koto",
      "TitleArray": [
        "All Around Us",
        "Gururi no koto"
      ],
      "Year": "2008",
      "Director": "Ryosuke Hashiguchi",
      "DirectorArray": [
        "Ryosuke Hashiguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "246",
      "databaseFilmTitle": "All Is Forgiven",
      "FilmTitle": "All Is Forgiven",
      "AlternateTitle": "Tout est pardonné",
      "TitleArray": [
        "All Is Forgiven",
        "Tout est pardonné"
      ],
      "Year": "2007",
      "Director": "Mia Hansen-Løve",
      "DirectorArray": [
        "Mia Hansen-Løve"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "247",
      "databaseFilmTitle": "All My Life",
      "FilmTitle": "All My Life",
      "AlternateTitle": "",
      "TitleArray": [
        "All My Life"
      ],
      "Year": "1966",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "248",
      "databaseFilmTitle": "All Night Long",
      "FilmTitle": "All Night Long",
      "AlternateTitle": "",
      "TitleArray": [
        "All Night Long"
      ],
      "Year": "1962",
      "Director": "Basil Dearden",
      "DirectorArray": [
        "Basil Dearden"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "249",
      "databaseFilmTitle": "All over Me",
      "FilmTitle": "All over Me",
      "AlternateTitle": "",
      "TitleArray": [
        "All over Me"
      ],
      "Year": "1997",
      "Director": "Alex Shichel",
      "DirectorArray": [
        "Alex Shichel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "250",
      "databaseFilmTitle": "All Quiet on the Western Front",
      "FilmTitle": "All Quiet on the Western Front",
      "AlternateTitle": "",
      "TitleArray": [
        "All Quiet on the Western Front"
      ],
      "Year": "1930",
      "Director": "Lewis Milestone",
      "DirectorArray": [
        "Lewis Milestone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "251",
      "databaseFilmTitle": "All That Heaven Allows",
      "FilmTitle": "All That Heaven Allows",
      "AlternateTitle": "",
      "TitleArray": [
        "All That Heaven Allows"
      ],
      "Year": "1955",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "252",
      "databaseFilmTitle": "All That Jazz",
      "FilmTitle": "All That Jazz",
      "AlternateTitle": "",
      "TitleArray": [
        "All That Jazz"
      ],
      "Year": "1979",
      "Director": "Bob Fosse",
      "DirectorArray": [
        "Bob Fosse"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "253",
      "databaseFilmTitle": "All the President's Men",
      "FilmTitle": "All the President's Men",
      "AlternateTitle": "",
      "TitleArray": [
        "All the President's Men"
      ],
      "Year": "1976",
      "Director": "Alan J. Pakula",
      "DirectorArray": [
        "Alan J. Pakula"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "254",
      "databaseFilmTitle": "All the World's Memories",
      "FilmTitle": "All the World's Memories",
      "AlternateTitle": "Toute la mémoire du monde",
      "TitleArray": [
        "All the World's Memories",
        "Toute la mémoire du monde"
      ],
      "Year": "1957",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "255",
      "databaseFilmTitle": "All This Can Happen",
      "FilmTitle": "All This Can Happen",
      "AlternateTitle": "",
      "TitleArray": [
        "All This Can Happen"
      ],
      "Year": "2013",
      "Director": "Siobhan Davies, David Hinton",
      "DirectorArray": [
        "Siobhan Davies",
        "David Hinton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "256",
      "databaseFilmTitle": "All Three, He Said",
      "FilmTitle": "All Three, He Said",
      "AlternateTitle": "Goft har se nafareshan",
      "TitleArray": [
        "All Three, He Said",
        "Goft har se nafareshan"
      ],
      "Year": "1979",
      "Director": "Gholamali Erfan",
      "DirectorArray": [
        "Gholamali Erfan"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "257",
      "databaseFilmTitle": "All Watched Over by Machines of Loving Grace",
      "FilmTitle": "All Watched Over by Machines of Loving Grace",
      "AlternateTitle": "",
      "TitleArray": [
        "All Watched Over by Machines of Loving Grace"
      ],
      "Year": "2011",
      "Director": "Adam Curtis",
      "DirectorArray": [
        "Adam Curtis"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "258",
      "databaseFilmTitle": "Almayer's Folly",
      "FilmTitle": "Almayer's Folly",
      "AlternateTitle": "La Folie Almayer",
      "TitleArray": [
        "Almayer's Folly",
        "La Folie Almayer"
      ],
      "Year": "2011",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "259",
      "databaseFilmTitle": "Almost Famous",
      "FilmTitle": "Almost Famous",
      "AlternateTitle": "",
      "TitleArray": [
        "Almost Famous"
      ],
      "Year": "2000",
      "Director": "Cameron Crowe",
      "DirectorArray": [
        "Cameron Crowe"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "260",
      "databaseFilmTitle": "Alpha",
      "FilmTitle": "Alpha",
      "AlternateTitle": "",
      "TitleArray": [
        "Alpha"
      ],
      "Year": "1972",
      "Director": "Ola Balogun",
      "DirectorArray": [
        "Ola Balogun"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "261",
      "databaseFilmTitle": "Alphaville",
      "FilmTitle": "Alphaville",
      "AlternateTitle": "Alphaville, une étrange aventure de Lemmy Caution",
      "TitleArray": [
        "Alphaville",
        "Alphaville, une étrange aventure de Lemmy Caution"
      ],
      "Year": "1965",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "262",
      "databaseFilmTitle": "Alpine Fire",
      "FilmTitle": "Alpine Fire",
      "AlternateTitle": "Höhenfeuer",
      "TitleArray": [
        "Alpine Fire",
        "Höhenfeuer"
      ],
      "Year": "1985",
      "Director": "Fredi M. Murer",
      "DirectorArray": [
        "Fredi M. Murer"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "263",
      "databaseFilmTitle": "Always for Pleasure",
      "FilmTitle": "Always for Pleasure",
      "AlternateTitle": "",
      "TitleArray": [
        "Always for Pleasure"
      ],
      "Year": "1978",
      "Director": "Les Blank",
      "DirectorArray": [
        "Les Blank"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "264",
      "databaseFilmTitle": "Amadeus",
      "FilmTitle": "Amadeus",
      "AlternateTitle": "",
      "TitleArray": [
        "Amadeus"
      ],
      "Year": "1984",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "265",
      "databaseFilmTitle": "Amar Akbar Anthony",
      "FilmTitle": "Amar Akbar Anthony",
      "AlternateTitle": "",
      "TitleArray": [
        "Amar Akbar Anthony"
      ],
      "Year": "1977",
      "Director": "Manmohan Desai",
      "DirectorArray": [
        "Manmohan Desai"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "266",
      "databaseFilmTitle": "Amarcord",
      "FilmTitle": "Amarcord",
      "AlternateTitle": "",
      "TitleArray": [
        "Amarcord"
      ],
      "Year": "1973",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "267",
      "databaseFilmTitle": "Amélie",
      "FilmTitle": "Amélie",
      "AlternateTitle": "Le fabuleux destin d'Amélie Poulain",
      "TitleArray": [
        "Amélie",
        "Le fabuleux destin d'Amélie Poulain"
      ],
      "Year": "2001",
      "Director": "Jean-Pierre Jeunet",
      "DirectorArray": [
        "Jean-Pierre Jeunet"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "268",
      "databaseFilmTitle": "America",
      "FilmTitle": "America",
      "AlternateTitle": "",
      "TitleArray": [
        "America"
      ],
      "Year": "2019",
      "Director": "Garrett Bradley",
      "DirectorArray": [
        "Garrett Bradley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "269",
      "databaseFilmTitle": "America, America",
      "FilmTitle": "America, America",
      "AlternateTitle": "",
      "TitleArray": [
        "America, America"
      ],
      "Year": "1963",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "270",
      "databaseFilmTitle": "American Dream",
      "FilmTitle": "American Dream",
      "AlternateTitle": "",
      "TitleArray": [
        "American Dream"
      ],
      "Year": "1990",
      "Director": "Barbara Kopple",
      "DirectorArray": [
        "Barbara Kopple"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "271",
      "databaseFilmTitle": "American Graffiti",
      "FilmTitle": "American Graffiti",
      "AlternateTitle": "",
      "TitleArray": [
        "American Graffiti"
      ],
      "Year": "1973",
      "Director": "George Lucas",
      "DirectorArray": [
        "George Lucas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "272",
      "databaseFilmTitle": "American Honey",
      "FilmTitle": "American Honey",
      "AlternateTitle": "",
      "TitleArray": [
        "American Honey"
      ],
      "Year": "2016",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "273",
      "databaseFilmTitle": "American Movie",
      "FilmTitle": "American Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "American Movie"
      ],
      "Year": "1999",
      "Director": "Chris Smith",
      "DirectorArray": [
        "Chris Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "274",
      "databaseFilmTitle": "American Psycho",
      "FilmTitle": "American Psycho",
      "AlternateTitle": "",
      "TitleArray": [
        "American Psycho"
      ],
      "Year": "2000",
      "Director": "Mary Harron",
      "DirectorArray": [
        "Mary Harron"
      ],
      "Country": "United States, Canada",
      "CountryArray": [
        "United States",
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "275",
      "databaseFilmTitle": "American Splendor",
      "FilmTitle": "American Splendor",
      "AlternateTitle": "",
      "TitleArray": [
        "American Splendor"
      ],
      "Year": "2003",
      "Director": "Shari Springer Berman, Robert Pulcini",
      "DirectorArray": [
        "Shari Springer Berman",
        "Robert Pulcini"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "276",
      "databaseFilmTitle": "American Stories, Food, Family and Philosophy",
      "FilmTitle": "American Stories, Food, Family and Philosophy",
      "AlternateTitle": "Histoires d'Amérique",
      "TitleArray": [
        "American Stories, Food, Family and Philosophy",
        "Histoires d'Amérique"
      ],
      "Year": "1989",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "277",
      "databaseFilmTitle": "Amistad",
      "FilmTitle": "Amistad",
      "AlternateTitle": "",
      "TitleArray": [
        "Amistad"
      ],
      "Year": "1997",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "278",
      "databaseFilmTitle": "Amor",
      "FilmTitle": "Amor",
      "AlternateTitle": "",
      "TitleArray": [
        "Amor"
      ],
      "Year": "1980",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "Italy, United States",
      "CountryArray": [
        "Italy",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "279",
      "databaseFilmTitle": "Amor Omnia",
      "FilmTitle": "Amor Omnia",
      "AlternateTitle": "",
      "TitleArray": [
        "Amor Omnia"
      ],
      "Year": "2019",
      "Director": "Yohei Yamakado",
      "DirectorArray": [
        "Yohei Yamakado"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "280",
      "databaseFilmTitle": "Amore",
      "FilmTitle": "Amore",
      "AlternateTitle": "",
      "TitleArray": [
        "Amore"
      ],
      "Year": "1978",
      "Director": "Klaus Lemke",
      "DirectorArray": [
        "Klaus Lemke"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "281",
      "databaseFilmTitle": "Amores perros",
      "FilmTitle": "Amores perros",
      "AlternateTitle": "",
      "TitleArray": [
        "Amores perros"
      ],
      "Year": "2000",
      "Director": "Alejandro González Iñárritu",
      "DirectorArray": [
        "Alejandro González Iñárritu"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "282",
      "databaseFilmTitle": "Amour",
      "FilmTitle": "Amour",
      "AlternateTitle": "",
      "TitleArray": [
        "Amour"
      ],
      "Year": "2012",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "France, Austria",
      "CountryArray": [
        "France",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "283",
      "databaseFilmTitle": "Amsterdam Global Village",
      "FilmTitle": "Amsterdam Global Village",
      "AlternateTitle": "",
      "TitleArray": [
        "Amsterdam Global Village"
      ],
      "Year": "1996",
      "Director": "Johan van der Keuken",
      "DirectorArray": [
        "Johan van der Keuken"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "284",
      "databaseFilmTitle": "Amy",
      "FilmTitle": "Amy",
      "AlternateTitle": "",
      "TitleArray": [
        "Amy"
      ],
      "Year": "2015",
      "Director": "Asif Kapadia",
      "DirectorArray": [
        "Asif Kapadia"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "285",
      "databaseFilmTitle": "Amy!",
      "FilmTitle": "Amy!",
      "AlternateTitle": "",
      "TitleArray": [
        "Amy!"
      ],
      "Year": "1979",
      "Director": "Laura Mulvey, Peter Wollen",
      "DirectorArray": [
        "Laura Mulvey",
        "Peter Wollen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "286",
      "databaseFilmTitle": "An Actor's Revenge",
      "FilmTitle": "An Actor's Revenge",
      "AlternateTitle": "Yukinojō henge",
      "TitleArray": [
        "An Actor's Revenge",
        "Yukinojō henge"
      ],
      "Year": "1963",
      "Director": "Kon Ichikawa",
      "DirectorArray": [
        "Kon Ichikawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "287",
      "databaseFilmTitle": "An Affair to Remember",
      "FilmTitle": "An Affair to Remember",
      "AlternateTitle": "",
      "TitleArray": [
        "An Affair to Remember"
      ],
      "Year": "1947",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "288",
      "databaseFilmTitle": "An American in Paris",
      "FilmTitle": "An American in Paris",
      "AlternateTitle": "",
      "TitleArray": [
        "An American in Paris"
      ],
      "Year": "1951",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "289",
      "databaseFilmTitle": "An American Tragedy",
      "FilmTitle": "An American Tragedy",
      "AlternateTitle": "",
      "TitleArray": [
        "An American Tragedy"
      ],
      "Year": "1931",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "290",
      "databaseFilmTitle": "An American Werewolf in London",
      "FilmTitle": "An American Werewolf in London",
      "AlternateTitle": "",
      "TitleArray": [
        "An American Werewolf in London"
      ],
      "Year": "1981",
      "Director": "John Landis",
      "DirectorArray": [
        "John Landis"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "291",
      "databaseFilmTitle": "An Angel at My Table",
      "FilmTitle": "An Angel at My Table",
      "AlternateTitle": "",
      "TitleArray": [
        "An Angel at My Table"
      ],
      "Year": "1990",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "292",
      "databaseFilmTitle": "An Autumn Afternoon",
      "FilmTitle": "An Autumn Afternoon",
      "AlternateTitle": "Sanma no Aji",
      "TitleArray": [
        "An Autumn Afternoon",
        "Sanma no Aji"
      ],
      "Year": "1962",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "293",
      "databaseFilmTitle": "An Autumn's Tale",
      "FilmTitle": "An Autumn's Tale",
      "AlternateTitle": "",
      "TitleArray": [
        "An Autumn's Tale"
      ],
      "Year": "1987",
      "Director": "Mabel Cheung",
      "DirectorArray": [
        "Mabel Cheung"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "294",
      "databaseFilmTitle": "An Ecstatic Experience",
      "FilmTitle": "An Ecstatic Experience",
      "AlternateTitle": "",
      "TitleArray": [
        "An Ecstatic Experience"
      ],
      "Year": "2015",
      "Director": "Ja'Tovia M. Gary",
      "DirectorArray": [
        "Ja'Tovia M. Gary"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "295",
      "databaseFilmTitle": "An Egyptian Story",
      "FilmTitle": "An Egyptian Story",
      "AlternateTitle": "Hadduta misrija",
      "TitleArray": [
        "An Egyptian Story",
        "Hadduta misrija"
      ],
      "Year": "1982",
      "Director": "Youssef Chahine",
      "DirectorArray": [
        "Youssef Chahine"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "296",
      "databaseFilmTitle": "An Elephant Sitting Still",
      "FilmTitle": "An Elephant Sitting Still",
      "AlternateTitle": "",
      "TitleArray": [
        "An Elephant Sitting Still"
      ],
      "Year": "2018",
      "Director": "Hu Bo",
      "DirectorArray": [
        "Hu Bo"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "297",
      "databaseFilmTitle": "An Inn in Tokyo",
      "FilmTitle": "An Inn in Tokyo",
      "AlternateTitle": "Tôkyô no yado",
      "TitleArray": [
        "An Inn in Tokyo",
        "Tôkyô no yado"
      ],
      "Year": "1935",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "298",
      "databaseFilmTitle": "An Inspector Calls (2015)",
      "FilmTitle": "An Inspector Calls",
      "AlternateTitle": "Fau wa yin",
      "TitleArray": [
        "An Inspector Calls",
        "Fau wa yin"
      ],
      "Year": "",
      "Director": "Herman Yau, Raymond Wong Bak-ming",
      "DirectorArray": [
        "Herman Yau",
        "Raymond Wong Bak-ming"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "299",
      "databaseFilmTitle": "An Unusual Summer",
      "FilmTitle": "An Unusual Summer",
      "AlternateTitle": "Seif gheir aadi",
      "TitleArray": [
        "An Unusual Summer",
        "Seif gheir aadi"
      ],
      "Year": "2020",
      "Director": "Kamal Aljafari",
      "DirectorArray": [
        "Kamal Aljafari"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "300",
      "databaseFilmTitle": "Ana",
      "FilmTitle": "Ana",
      "AlternateTitle": "",
      "TitleArray": [
        "Ana"
      ],
      "Year": "1982",
      "Director": "Margarida Cordeiro, António Reis",
      "DirectorArray": [
        "Margarida Cordeiro",
        "António Reis"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "301",
      "databaseFilmTitle": "Anaïs in Love",
      "FilmTitle": "Anaïs in Love",
      "AlternateTitle": "Les Amours d'Anaïs",
      "TitleArray": [
        "Anaïs in Love",
        "Les Amours d'Anaïs"
      ],
      "Year": "2021",
      "Director": "Charline Bourgeois-Tacquet",
      "DirectorArray": [
        "Charline Bourgeois-Tacquet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "302",
      "databaseFilmTitle": "Anatahan",
      "FilmTitle": "Anatahan",
      "AlternateTitle": "The Saga of Anatahan",
      "TitleArray": [
        "Anatahan",
        "The Saga of Anatahan"
      ],
      "Year": "1953",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "303",
      "databaseFilmTitle": "Anatomy of a Murder",
      "FilmTitle": "Anatomy of a Murder",
      "AlternateTitle": "",
      "TitleArray": [
        "Anatomy of a Murder"
      ],
      "Year": "1959",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "304",
      "databaseFilmTitle": "Anatomy of a Relationship",
      "FilmTitle": "Anatomy of a Relationship",
      "AlternateTitle": "Anatomie d'un rapport",
      "TitleArray": [
        "Anatomy of a Relationship",
        "Anatomie d'un rapport"
      ],
      "Year": "1976",
      "Director": "Luc Moullet, Antonietta Pizzorno",
      "DirectorArray": [
        "Luc Moullet",
        "Antonietta Pizzorno"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "305",
      "databaseFilmTitle": "Anatomy of Hell",
      "FilmTitle": "Anatomy of Hell",
      "AlternateTitle": "Anatomie de l'enfer",
      "TitleArray": [
        "Anatomy of Hell",
        "Anatomie de l'enfer"
      ],
      "Year": "2004",
      "Director": "Catherine Breillat",
      "DirectorArray": [
        "Catherine Breillat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "306",
      "databaseFilmTitle": "Anchorman: The Legend of Ron Burgundy",
      "FilmTitle": "Anchorman: The Legend of Ron Burgundy",
      "AlternateTitle": "",
      "TitleArray": [
        "Anchorman: The Legend of Ron Burgundy"
      ],
      "Year": "2004",
      "Director": "Adam McKay",
      "DirectorArray": [
        "Adam McKay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "307",
      "databaseFilmTitle": "And Life Goes On...",
      "FilmTitle": "And Life Goes On...",
      "AlternateTitle": "Zendegi va digar hich",
      "TitleArray": [
        "And Life Goes On...",
        "Zendegi va digar hich"
      ],
      "Year": "1992",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "308",
      "databaseFilmTitle": "And So It Is",
      "FilmTitle": "And So It Is",
      "AlternateTitle": "Ukamau",
      "TitleArray": [
        "And So It Is",
        "Ukamau"
      ],
      "Year": "1966",
      "Director": "Jorge Sanjinés",
      "DirectorArray": [
        "Jorge Sanjinés"
      ],
      "Country": "Bolivia",
      "CountryArray": [
        "Bolivia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "309",
      "databaseFilmTitle": "And the Ship Sails On",
      "FilmTitle": "And the Ship Sails On",
      "AlternateTitle": "E la nave va",
      "TitleArray": [
        "And the Ship Sails On",
        "E la nave va"
      ],
      "Year": "1983",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "310",
      "databaseFilmTitle": "And There Was Light",
      "FilmTitle": "And There Was Light",
      "AlternateTitle": "",
      "TitleArray": [
        "And There Was Light"
      ],
      "Year": "2020",
      "Director": "Kim Ji-seok",
      "DirectorArray": [
        "Kim Ji-seok"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "311",
      "databaseFilmTitle": "Andalucia",
      "FilmTitle": "Andalucia",
      "AlternateTitle": "",
      "TitleArray": [
        "Andalucia"
      ],
      "Year": "2007",
      "Director": "Alain Gomis",
      "DirectorArray": [
        "Alain Gomis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "312",
      "databaseFilmTitle": "Andaz",
      "FilmTitle": "Andaz",
      "AlternateTitle": "",
      "TitleArray": [
        "Andaz"
      ],
      "Year": "1949",
      "Director": "Mehboob Khan",
      "DirectorArray": [
        "Mehboob Khan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "313",
      "databaseFilmTitle": "Andrei Rublev",
      "FilmTitle": "Andrei Rublev",
      "AlternateTitle": "",
      "TitleArray": [
        "Andrei Rublev"
      ],
      "Year": "1966",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "24",
      "1972votes": "6",
      "1982rank": "12",
      "1982votes": "10",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "27",
      "2012votes": "41",
      "2022rank": "67",
      "2022votes": "38"
    },
    {
      "key": "314",
      "databaseFilmTitle": "Angel",
      "FilmTitle": "Angel",
      "AlternateTitle": "",
      "TitleArray": [
        "Angel"
      ],
      "Year": "1937",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "315",
      "databaseFilmTitle": "Angel Heart",
      "FilmTitle": "Angel Heart",
      "AlternateTitle": "",
      "TitleArray": [
        "Angel Heart"
      ],
      "Year": "1987",
      "Director": "Alan Parker",
      "DirectorArray": [
        "Alan Parker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "316",
      "databaseFilmTitle": "Angele",
      "FilmTitle": "Angele",
      "AlternateTitle": "Angèle",
      "TitleArray": [
        "Angele",
        "Angèle"
      ],
      "Year": "1934",
      "Director": "Marcel Pagnol",
      "DirectorArray": [
        "Marcel Pagnol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "317",
      "databaseFilmTitle": "Angels Wear White",
      "FilmTitle": "Angels Wear White",
      "AlternateTitle": "Jia nian hua",
      "TitleArray": [
        "Angels Wear White",
        "Jia nian hua"
      ],
      "Year": "2017",
      "Director": "Vivian Qu",
      "DirectorArray": [
        "Vivian Qu"
      ],
      "Country": "China, France",
      "CountryArray": [
        "China",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "318",
      "databaseFilmTitle": "Aniara",
      "FilmTitle": "Aniara",
      "AlternateTitle": "",
      "TitleArray": [
        "Aniara"
      ],
      "Year": "2018",
      "Director": "Pella Kågerman, Hugo Lilja",
      "DirectorArray": [
        "Pella Kågerman",
        "Hugo Lilja"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "319",
      "databaseFilmTitle": "Ankur",
      "FilmTitle": "Ankur",
      "AlternateTitle": "The Seedling",
      "TitleArray": [
        "Ankur",
        "The Seedling"
      ],
      "Year": "1974",
      "Director": "Shyam Benegal",
      "DirectorArray": [
        "Shyam Benegal"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "320",
      "databaseFilmTitle": "Anna",
      "FilmTitle": "Anna",
      "AlternateTitle": "",
      "TitleArray": [
        "Anna"
      ],
      "Year": "1975",
      "Director": "Alberto Grifi, Massimo Sarchielli",
      "DirectorArray": [
        "Alberto Grifi",
        "Massimo Sarchielli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "321",
      "databaseFilmTitle": "Anna and the Wolves",
      "FilmTitle": "Anna and the Wolves",
      "AlternateTitle": "Ana y los lobos",
      "TitleArray": [
        "Anna and the Wolves",
        "Ana y los lobos"
      ],
      "Year": "1973",
      "Director": "Carlos Saura",
      "DirectorArray": [
        "Carlos Saura"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "322",
      "databaseFilmTitle": "Anna Karenina",
      "FilmTitle": "Anna Karenina",
      "AlternateTitle": "",
      "TitleArray": [
        "Anna Karenina"
      ],
      "Year": "1961",
      "Director": "Rudolph Cartier",
      "DirectorArray": [
        "Rudolph Cartier"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "323",
      "databaseFilmTitle": "Anne Devlin",
      "FilmTitle": "Anne Devlin",
      "AlternateTitle": "",
      "TitleArray": [
        "Anne Devlin"
      ],
      "Year": "1984",
      "Director": "Pat Murphy",
      "DirectorArray": [
        "Pat Murphy"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "324",
      "databaseFilmTitle": "Anne of the Indies",
      "FilmTitle": "Anne of the Indies",
      "AlternateTitle": "",
      "TitleArray": [
        "Anne of the Indies"
      ],
      "Year": "1951",
      "Director": "acques Tourneur",
      "DirectorArray": [
        "acques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "325",
      "databaseFilmTitle": "Annelie",
      "FilmTitle": "Annelie",
      "AlternateTitle": "",
      "TitleArray": [
        "Annelie"
      ],
      "Year": "1941",
      "Director": "Josef von Báky",
      "DirectorArray": [
        "Josef von Báky"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "326",
      "databaseFilmTitle": "Annette",
      "FilmTitle": "Annette",
      "AlternateTitle": "",
      "TitleArray": [
        "Annette"
      ],
      "Year": "2021",
      "Director": "Leos Carax",
      "DirectorArray": [
        "Leos Carax"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "327",
      "databaseFilmTitle": "Annie Hall",
      "FilmTitle": "Annie Hall",
      "AlternateTitle": "",
      "TitleArray": [
        "Annie Hall"
      ],
      "Year": "1977",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "328",
      "databaseFilmTitle": "Anomalisa",
      "FilmTitle": "Anomalisa",
      "AlternateTitle": "",
      "TitleArray": [
        "Anomalisa"
      ],
      "Year": "2015",
      "Director": "Charlie Kaufman, Duke Johnson",
      "DirectorArray": [
        "Charlie Kaufman",
        "Duke Johnson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "329",
      "databaseFilmTitle": "Another Round",
      "FilmTitle": "Another Round",
      "AlternateTitle": "Druk",
      "TitleArray": [
        "Another Round",
        "Druk"
      ],
      "Year": "2020",
      "Director": "Thomas Vinterberg",
      "DirectorArray": [
        "Thomas Vinterberg"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "330",
      "databaseFilmTitle": "Another Way",
      "FilmTitle": "Another Way",
      "AlternateTitle": "Egymásra nézve",
      "TitleArray": [
        "Another Way",
        "Egymásra nézve"
      ],
      "Year": "1982",
      "Director": "Károly Makk, János Xantus",
      "DirectorArray": [
        "Károly Makk",
        "János Xantus"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "331",
      "databaseFilmTitle": "Another Woman",
      "FilmTitle": "Another Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Another Woman"
      ],
      "Year": "1988",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "332",
      "databaseFilmTitle": "Antichrist",
      "FilmTitle": "Antichrist",
      "AlternateTitle": "",
      "TitleArray": [
        "Antichrist"
      ],
      "Year": "2009",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "333",
      "databaseFilmTitle": "Anticipation of the Night",
      "FilmTitle": "Anticipation of the Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Anticipation of the Night"
      ],
      "Year": "1958",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "334",
      "databaseFilmTitle": "Antigone",
      "FilmTitle": "Antigone",
      "AlternateTitle": "Die Antigone des Sophokles nach der Hölderlinschen Übertragung für die Bühne bearbeitet von Brecht 1948",
      "TitleArray": [
        "Antigone",
        "Die Antigone des Sophokles nach der Hölderlinschen Übertragung für die Bühne bearbeitet von Brecht 1948"
      ],
      "Year": "1992",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Germany, France",
      "CountryArray": [
        "Germany",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "335",
      "databaseFilmTitle": "Antoine and Antoinette",
      "FilmTitle": "Antoine and Antoinette",
      "AlternateTitle": "Antoine and Antoinette",
      "TitleArray": [
        "Antoine and Antoinette",
        "Antoine and Antoinette"
      ],
      "Year": "1947",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "336",
      "databaseFilmTitle": "Antonia's Line",
      "FilmTitle": "Antonia's Line",
      "AlternateTitle": "Antonia",
      "TitleArray": [
        "Antonia's Line",
        "Antonia"
      ],
      "Year": "1995",
      "Director": "Marleen Gorris",
      "DirectorArray": [
        "Marleen Gorris"
      ],
      "Country": "Netherlands, Belgium",
      "CountryArray": [
        "Netherlands",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "337",
      "databaseFilmTitle": "Antônio das Mortes",
      "FilmTitle": "Antônio das Mortes",
      "AlternateTitle": "",
      "TitleArray": [
        "Antônio das Mortes"
      ],
      "Year": "1969",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "338",
      "databaseFilmTitle": "Anvil! The Story of Anvil",
      "FilmTitle": "Anvil! The Story of Anvil",
      "AlternateTitle": "",
      "TitleArray": [
        "Anvil! The Story of Anvil"
      ],
      "Year": "2008",
      "Director": "Sacha Gervasi",
      "DirectorArray": [
        "Sacha Gervasi"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "339",
      "databaseFilmTitle": "Any Old Port!",
      "FilmTitle": "Any Old Port!",
      "AlternateTitle": "",
      "TitleArray": [
        "Any Old Port!"
      ],
      "Year": "1932",
      "Director": "James W. Horne",
      "DirectorArray": [
        "James W. Horne"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "340",
      "databaseFilmTitle": "Anything Can Happen",
      "FilmTitle": "Anything Can Happen",
      "AlternateTitle": "Wszystko może się przytrafić",
      "TitleArray": [
        "Anything Can Happen",
        "Wszystko może się przytrafić"
      ],
      "Year": "1995",
      "Director": "Marcel Łoziński",
      "DirectorArray": [
        "Marcel Łoziński"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "341",
      "databaseFilmTitle": "Aparajito",
      "FilmTitle": "Aparajito",
      "AlternateTitle": "",
      "TitleArray": [
        "Aparajito"
      ],
      "Year": "1956",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "342",
      "databaseFilmTitle": "Apocalypse Now",
      "FilmTitle": "Apocalypse Now",
      "AlternateTitle": "",
      "TitleArray": [
        "Apocalypse Now"
      ],
      "Year": "1979",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "14",
      "2012votes": "53",
      "2022rank": "19",
      "2022votes": "72"
    },
    {
      "key": "343",
      "databaseFilmTitle": "Appropriate Behavior",
      "FilmTitle": "Appropriate Behavior",
      "AlternateTitle": "",
      "TitleArray": [
        "Appropriate Behavior"
      ],
      "Year": "2014",
      "Director": "Desiree Akhavan",
      "DirectorArray": [
        "Desiree Akhavan"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "344",
      "databaseFilmTitle": "Arabesque",
      "FilmTitle": "Arabesque",
      "AlternateTitle": "",
      "TitleArray": [
        "Arabesque"
      ],
      "Year": "1966",
      "Director": "Stanley Donen",
      "DirectorArray": [
        "Stanley Donen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "345",
      "databaseFilmTitle": "Arabian Nights",
      "FilmTitle": "Arabian Nights",
      "AlternateTitle": "Il fiore delle Mille e una notte",
      "TitleArray": [
        "Arabian Nights",
        "Il fiore delle Mille e una notte"
      ],
      "Year": "1974",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "346",
      "databaseFilmTitle": "Araya",
      "FilmTitle": "Araya",
      "AlternateTitle": "",
      "TitleArray": [
        "Araya"
      ],
      "Year": "1959",
      "Director": "Margot Benacerraf",
      "DirectorArray": [
        "Margot Benacerraf"
      ],
      "Country": "Venezuela",
      "CountryArray": [
        "Venezuela"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "347",
      "databaseFilmTitle": "Arcana",
      "FilmTitle": "Arcana",
      "AlternateTitle": "",
      "TitleArray": [
        "Arcana"
      ],
      "Year": "1972",
      "Director": "Giulio Questi",
      "DirectorArray": [
        "Giulio Questi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "348",
      "databaseFilmTitle": "Archipelago",
      "FilmTitle": "Archipelago",
      "AlternateTitle": "",
      "TitleArray": [
        "Archipelago"
      ],
      "Year": "2010",
      "Director": "Joanna Hogg",
      "DirectorArray": [
        "Joanna Hogg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "349",
      "databaseFilmTitle": "Army of Shadows",
      "FilmTitle": "Army of Shadows",
      "AlternateTitle": "L'Armée des ombres",
      "TitleArray": [
        "Army of Shadows",
        "L'Armée des ombres"
      ],
      "Year": "1969",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "350",
      "databaseFilmTitle": "Arne's Treasure",
      "FilmTitle": "Arne's Treasure",
      "AlternateTitle": "Herr Arnes pengar",
      "TitleArray": [
        "Arne's Treasure",
        "Herr Arnes pengar"
      ],
      "Year": "1919",
      "Director": "Mauritz Stiller",
      "DirectorArray": [
        "Mauritz Stiller"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "351",
      "databaseFilmTitle": "Arnulf Rainer",
      "FilmTitle": "Arnulf Rainer",
      "AlternateTitle": "",
      "TitleArray": [
        "Arnulf Rainer"
      ],
      "Year": "1969",
      "Director": "Peter Kubelka",
      "DirectorArray": [
        "Peter Kubelka"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "352",
      "databaseFilmTitle": "Arrival",
      "FilmTitle": "Arrival",
      "AlternateTitle": "",
      "TitleArray": [
        "Arrival"
      ],
      "Year": "2016",
      "Director": "Denis Villeneuve",
      "DirectorArray": [
        "Denis Villeneuve"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "353",
      "databaseFilmTitle": "Arsenal",
      "FilmTitle": "Arsenal",
      "AlternateTitle": "",
      "TitleArray": [
        "Arsenal"
      ],
      "Year": "1929",
      "Director": "Aleksandr Dovzhenko",
      "DirectorArray": [
        "Aleksandr Dovzhenko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "354",
      "databaseFilmTitle": "Arsenic and Old Lace",
      "FilmTitle": "Arsenic and Old Lace",
      "AlternateTitle": "",
      "TitleArray": [
        "Arsenic and Old Lace"
      ],
      "Year": "1944",
      "Director": "Frank Capra",
      "DirectorArray": [
        "Frank Capra"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "355",
      "databaseFilmTitle": "Artemis' Knee",
      "FilmTitle": "Artemis' Knee",
      "AlternateTitle": "Le genou d'Artémide",
      "TitleArray": [
        "Artemis' Knee",
        "Le genou d'Artémide"
      ],
      "Year": "2008",
      "Director": "Jean-Marie Straub",
      "DirectorArray": [
        "Jean-Marie Straub"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "356",
      "databaseFilmTitle": "Artists and Models",
      "FilmTitle": "Artists and Models",
      "AlternateTitle": "",
      "TitleArray": [
        "Artists and Models"
      ],
      "Year": "1955",
      "Director": "Frank Tashlin",
      "DirectorArray": [
        "Frank Tashlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "357",
      "databaseFilmTitle": "Artists under the Big Top: Perplexed",
      "FilmTitle": "Artists under the Big Top: Perplexed",
      "AlternateTitle": "Die Artisten in der Zirkuskuppel: ratlos",
      "TitleArray": [
        "Artists under the Big Top: Perplexed",
        "Die Artisten in der Zirkuskuppel: ratlos"
      ],
      "Year": "1968",
      "Director": "Alexander Kluge",
      "DirectorArray": [
        "Alexander Kluge"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "358",
      "databaseFilmTitle": "As I Was Moving Ahead Occasionally I Saw Brief Glimpses of Beauty",
      "FilmTitle": "As I Was Moving Ahead Occasionally I Saw Brief Glimpses of Beauty",
      "AlternateTitle": "",
      "TitleArray": [
        "As I Was Moving Ahead Occasionally I Saw Brief Glimpses of Beauty"
      ],
      "Year": "2000",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "359",
      "databaseFilmTitle": "As Tears Go By",
      "FilmTitle": "As Tears Go By",
      "AlternateTitle": "Wong Gok Ka Moon",
      "TitleArray": [
        "As Tears Go By",
        "Wong Gok Ka Moon"
      ],
      "Year": "1988",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "360",
      "databaseFilmTitle": "Asako I & II",
      "FilmTitle": "Asako I & II",
      "AlternateTitle": "Netemo sametemo",
      "TitleArray": [
        "Asako I & II",
        "Netemo sametemo"
      ],
      "Year": "2018",
      "Director": "Ryusuke Hamaguchi",
      "DirectorArray": [
        "Ryusuke Hamaguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "361",
      "databaseFilmTitle": "Ash Is Purest White",
      "FilmTitle": "Ash Is Purest White",
      "AlternateTitle": "Jiang hu er nü",
      "TitleArray": [
        "Ash Is Purest White",
        "Jiang hu er nü"
      ],
      "Year": "2018",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China, France",
      "CountryArray": [
        "China",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "362",
      "databaseFilmTitle": "Ashes and Diamonds",
      "FilmTitle": "Ashes and Diamonds",
      "AlternateTitle": "Popiół i diament",
      "TitleArray": [
        "Ashes and Diamonds",
        "Popiół i diament"
      ],
      "Year": "1958",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "363",
      "databaseFilmTitle": "Ashes of Time",
      "FilmTitle": "Ashes of Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Ashes of Time"
      ],
      "Year": "1994",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong, Taiwan",
      "CountryArray": [
        "Hong Kong",
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "364",
      "databaseFilmTitle": "Ask a Policeman",
      "FilmTitle": "Ask a Policeman",
      "AlternateTitle": "",
      "TitleArray": [
        "Ask a Policeman"
      ],
      "Year": "1939",
      "Director": "Marcel Varnel",
      "DirectorArray": [
        "Marcel Varnel"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "365",
      "databaseFilmTitle": "Asparagus",
      "FilmTitle": "Asparagus",
      "AlternateTitle": "",
      "TitleArray": [
        "Asparagus"
      ],
      "Year": "1979",
      "Director": "Suzan Pitt",
      "DirectorArray": [
        "Suzan Pitt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "366",
      "databaseFilmTitle": "Aspen",
      "FilmTitle": "Aspen",
      "AlternateTitle": "",
      "TitleArray": [
        "Aspen"
      ],
      "Year": "1991",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "367",
      "databaseFilmTitle": "Assassination",
      "FilmTitle": "Assassination",
      "AlternateTitle": "Ansatsu",
      "TitleArray": [
        "Assassination",
        "Ansatsu"
      ],
      "Year": "1964",
      "Director": "Masahiro Shinoda",
      "DirectorArray": [
        "Masahiro Shinoda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "368",
      "databaseFilmTitle": "Assault on Precinct 13",
      "FilmTitle": "Assault on Precinct 13",
      "AlternateTitle": "",
      "TitleArray": [
        "Assault on Precinct 13"
      ],
      "Year": "1976",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "369",
      "databaseFilmTitle": "Assumption",
      "FilmTitle": "Assumption",
      "AlternateTitle": "",
      "TitleArray": [
        "Assumption"
      ],
      "Year": "1997",
      "Director": "Peter Gidal",
      "DirectorArray": [
        "Peter Gidal"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "370",
      "databaseFilmTitle": "Asylum",
      "FilmTitle": "Asylum",
      "AlternateTitle": "",
      "TitleArray": [
        "Asylum"
      ],
      "Year": "1972",
      "Director": "Roy Ward Baker",
      "DirectorArray": [
        "Roy Ward Baker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "371",
      "databaseFilmTitle": "At Berkeley",
      "FilmTitle": "At Berkeley",
      "AlternateTitle": "",
      "TitleArray": [
        "At Berkeley"
      ],
      "Year": "2013",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "372",
      "databaseFilmTitle": "At Land",
      "FilmTitle": "At Land",
      "AlternateTitle": "",
      "TitleArray": [
        "At Land"
      ],
      "Year": "1944",
      "Director": "Maya Deren",
      "DirectorArray": [
        "Maya Deren"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "373",
      "databaseFilmTitle": "At Sea",
      "FilmTitle": "At Sea",
      "AlternateTitle": "",
      "TitleArray": [
        "At Sea"
      ],
      "Year": "2007",
      "Director": "Peter Hutton",
      "DirectorArray": [
        "Peter Hutton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "374",
      "databaseFilmTitle": "Atanarjuat: The Fast Runner",
      "FilmTitle": "Atanarjuat: The Fast Runner",
      "AlternateTitle": "Atanarjuat",
      "TitleArray": [
        "Atanarjuat: The Fast Runner",
        "Atanarjuat"
      ],
      "Year": "2001",
      "Director": "Zacharias Kunuk",
      "DirectorArray": [
        "Zacharias Kunuk"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "375",
      "databaseFilmTitle": "Athiest",
      "FilmTitle": "Athiest",
      "AlternateTitle": "Atheis",
      "TitleArray": [
        "Athiest",
        "Atheis"
      ],
      "Year": "1974",
      "Director": "Sjuman Djaya",
      "DirectorArray": [
        "Sjuman Djaya"
      ],
      "Country": "Indonesia",
      "CountryArray": [
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "376",
      "databaseFilmTitle": "Atlantic City",
      "FilmTitle": "Atlantic City",
      "AlternateTitle": "",
      "TitleArray": [
        "Atlantic City"
      ],
      "Year": "1980",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "377",
      "databaseFilmTitle": "Atlantic Rhapsody",
      "FilmTitle": "Atlantic Rhapsody",
      "AlternateTitle": "Atlantic Rhapsody 52 myndir úr Tórshavn",
      "TitleArray": [
        "Atlantic Rhapsody",
        "Atlantic Rhapsody 52 myndir úr Tórshavn"
      ],
      "Year": "1990",
      "Director": "Katrin Ottarsdóttir",
      "DirectorArray": [
        "Katrin Ottarsdóttir"
      ],
      "Country": "Faroe Islands, Denmark",
      "CountryArray": [
        "Faroe Islands",
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "378",
      "databaseFilmTitle": "Atlantiques",
      "FilmTitle": "Atlantiques",
      "AlternateTitle": "",
      "TitleArray": [
        "Atlantiques"
      ],
      "Year": "2009",
      "Director": "Mati Diop",
      "DirectorArray": [
        "Mati Diop"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "379",
      "databaseFilmTitle": "Atonement",
      "FilmTitle": "Atonement",
      "AlternateTitle": "",
      "TitleArray": [
        "Atonement"
      ],
      "Year": "2007",
      "Director": "Joe Wright",
      "DirectorArray": [
        "Joe Wright"
      ],
      "Country": "United States, France",
      "CountryArray": [
        "United States",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "380",
      "databaseFilmTitle": "Attack the Block",
      "FilmTitle": "Attack the Block",
      "AlternateTitle": "",
      "TitleArray": [
        "Attack the Block"
      ],
      "Year": "2011",
      "Director": "Joe Cornish",
      "DirectorArray": [
        "Joe Cornish"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "381",
      "databaseFilmTitle": "Attenberg",
      "FilmTitle": "Attenberg",
      "AlternateTitle": "",
      "TitleArray": [
        "Attenberg"
      ],
      "Year": "2010",
      "Director": "Athina Rachel Tsangari",
      "DirectorArray": [
        "Athina Rachel Tsangari"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "382",
      "databaseFilmTitle": "Attica",
      "FilmTitle": "Attica",
      "AlternateTitle": "",
      "TitleArray": [
        "Attica"
      ],
      "Year": "1974",
      "Director": "Cinda Firestone",
      "DirectorArray": [
        "Cinda Firestone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "383",
      "databaseFilmTitle": "Au bonheur des dames",
      "FilmTitle": "Au bonheur des dames",
      "AlternateTitle": "",
      "TitleArray": [
        "Au bonheur des dames"
      ],
      "Year": "1930",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "384",
      "databaseFilmTitle": "Au clair de la lune",
      "FilmTitle": "Au clair de la lune",
      "AlternateTitle": "",
      "TitleArray": [
        "Au clair de la lune"
      ],
      "Year": "1983",
      "Director": "André Forcier",
      "DirectorArray": [
        "André Forcier"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "385",
      "databaseFilmTitle": "Au hasard Balthazar",
      "FilmTitle": "Au hasard Balthazar",
      "AlternateTitle": "",
      "TitleArray": [
        "Au hasard Balthazar"
      ],
      "Year": "1966",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "20",
      "2002votes": "10",
      "2012rank": "16",
      "2012votes": "49",
      "2022rank": "25",
      "2022votes": "66"
    },
    {
      "key": "386",
      "databaseFilmTitle": "August in the Water",
      "FilmTitle": "August in the Water",
      "AlternateTitle": "Mizu no naka no hachigatsu",
      "TitleArray": [
        "August in the Water",
        "Mizu no naka no hachigatsu"
      ],
      "Year": "1995",
      "Director": "Gakuryû Ishii",
      "DirectorArray": [
        "Gakuryû Ishii"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "387",
      "databaseFilmTitle": "Auntie Mame",
      "FilmTitle": "Auntie Mame",
      "AlternateTitle": "",
      "TitleArray": [
        "Auntie Mame"
      ],
      "Year": "1958",
      "Director": "Morton DaCosta",
      "DirectorArray": [
        "Morton DaCosta"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "388",
      "databaseFilmTitle": "Aurora",
      "FilmTitle": "Aurora",
      "AlternateTitle": "",
      "TitleArray": [
        "Aurora"
      ],
      "Year": "2010",
      "Director": "Cristi Puiu",
      "DirectorArray": [
        "Cristi Puiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "389",
      "databaseFilmTitle": "Autumn Sonata",
      "FilmTitle": "Autumn Sonata",
      "AlternateTitle": "Höstsonaten",
      "TitleArray": [
        "Autumn Sonata",
        "Höstsonaten"
      ],
      "Year": "1978",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "390",
      "databaseFilmTitle": "Ava & Gabriel: A Love Story",
      "FilmTitle": "Ava & Gabriel: A Love Story",
      "AlternateTitle": "Ava & Gabriel - Un historia di amor",
      "TitleArray": [
        "Ava & Gabriel: A Love Story",
        "Ava & Gabriel - Un historia di amor"
      ],
      "Year": "1990",
      "Director": "Delix de Rooy",
      "DirectorArray": [
        "Delix de Rooy"
      ],
      "Country": "Netherlands, France",
      "CountryArray": [
        "Netherlands",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "391",
      "databaseFilmTitle": "Avalon",
      "FilmTitle": "Avalon",
      "AlternateTitle": "",
      "TitleArray": [
        "Avalon"
      ],
      "Year": "2001",
      "Director": "Mamoru Oshii",
      "DirectorArray": [
        "Mamoru Oshii"
      ],
      "Country": "Poland, Japan",
      "CountryArray": [
        "Poland",
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "392",
      "databaseFilmTitle": "Avanti!",
      "FilmTitle": "Avanti!",
      "AlternateTitle": "",
      "TitleArray": [
        "Avanti!"
      ],
      "Year": "1972",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "Italy, United States",
      "CountryArray": [
        "Italy",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "393",
      "databaseFilmTitle": "Avatar",
      "FilmTitle": "Avatar",
      "AlternateTitle": "",
      "TitleArray": [
        "Avatar"
      ],
      "Year": "2009",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "394",
      "databaseFilmTitle": "Avengers: Endgame",
      "FilmTitle": "Avengers: Endgame",
      "AlternateTitle": "",
      "TitleArray": [
        "Avengers: Endgame"
      ],
      "Year": "2019",
      "Director": "Anthony Russo, Joe Russo",
      "DirectorArray": [
        "Anthony Russo",
        "Joe Russo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "395",
      "databaseFilmTitle": "Aventurera",
      "FilmTitle": "Aventurera",
      "AlternateTitle": "",
      "TitleArray": [
        "Aventurera"
      ],
      "Year": "1950",
      "Director": "Alberto Gout",
      "DirectorArray": [
        "Alberto Gout"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "396",
      "databaseFilmTitle": "Baahubali: The Beginning",
      "FilmTitle": "Baahubali: The Beginning",
      "AlternateTitle": "",
      "TitleArray": [
        "Baahubali: The Beginning"
      ],
      "Year": "2015",
      "Director": "S.S. Rajamouli",
      "DirectorArray": [
        "S.S. Rajamouli"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "397",
      "databaseFilmTitle": "Babobilicons",
      "FilmTitle": "Babobilicons",
      "AlternateTitle": "",
      "TitleArray": [
        "Babobilicons"
      ],
      "Year": "1982",
      "Director": "Daina Krumins",
      "DirectorArray": [
        "Daina Krumins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "398",
      "databaseFilmTitle": "Baby Face",
      "FilmTitle": "Baby Face",
      "AlternateTitle": "",
      "TitleArray": [
        "Baby Face"
      ],
      "Year": "1933",
      "Director": "Alfred E. Green",
      "DirectorArray": [
        "Alfred E. Green"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "399",
      "databaseFilmTitle": "Baby, I Will Make You Sweat",
      "FilmTitle": "Baby, I Will Make You Sweat",
      "AlternateTitle": "",
      "TitleArray": [
        "Baby, I Will Make You Sweat"
      ],
      "Year": "1995",
      "Director": "Brigit Hein",
      "DirectorArray": [
        "Brigit Hein"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "400",
      "databaseFilmTitle": "Baby's Meal",
      "FilmTitle": "Baby's Meal",
      "AlternateTitle": "Repas de bébé",
      "TitleArray": [
        "Baby's Meal",
        "Repas de bébé"
      ],
      "Year": "1895",
      "Director": "Louis Lumière",
      "DirectorArray": [
        "Louis Lumière"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "401",
      "databaseFilmTitle": "Babylon",
      "FilmTitle": "Babylon",
      "AlternateTitle": "",
      "TitleArray": [
        "Babylon"
      ],
      "Year": "2022",
      "Director": "Damien Chazelle",
      "DirectorArray": [
        "Damien Chazelle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "402",
      "databaseFilmTitle": "Babymother",
      "FilmTitle": "Babymother",
      "AlternateTitle": "",
      "TitleArray": [
        "Babymother"
      ],
      "Year": "1998",
      "Director": "Julian Henriques",
      "DirectorArray": [
        "Julian Henriques"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "403",
      "databaseFilmTitle": "Babyteeth",
      "FilmTitle": "Babyteeth",
      "AlternateTitle": "",
      "TitleArray": [
        "Babyteeth"
      ],
      "Year": "2019",
      "Director": "Shannon Murphy",
      "DirectorArray": [
        "Shannon Murphy"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "404",
      "databaseFilmTitle": "Bachelor Mother",
      "FilmTitle": "Bachelor Mother",
      "AlternateTitle": "",
      "TitleArray": [
        "Bachelor Mother"
      ],
      "Year": "1939",
      "Director": "Garson Kanin",
      "DirectorArray": [
        "Garson Kanin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "405",
      "databaseFilmTitle": "Back to the Future",
      "FilmTitle": "Back to the Future",
      "AlternateTitle": "",
      "TitleArray": [
        "Back to the Future"
      ],
      "Year": "1985",
      "Director": "Robert Zemeckis",
      "DirectorArray": [
        "Robert Zemeckis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "406",
      "databaseFilmTitle": "Back to the Future Part II",
      "FilmTitle": "Back to the Future Part II",
      "AlternateTitle": "",
      "TitleArray": [
        "Back to the Future Part II"
      ],
      "Year": "1989",
      "Director": "Robert Zemeckis",
      "DirectorArray": [
        "Robert Zemeckis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "407",
      "databaseFilmTitle": "Bad Education",
      "FilmTitle": "Bad Education",
      "AlternateTitle": "La mala educación",
      "TitleArray": [
        "Bad Education",
        "La mala educación"
      ],
      "Year": "2004",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "408",
      "databaseFilmTitle": "Bad Girls Go to Hell",
      "FilmTitle": "Bad Girls Go to Hell",
      "AlternateTitle": "",
      "TitleArray": [
        "Bad Girls Go to Hell"
      ],
      "Year": "1965",
      "Director": "Doris Wishman",
      "DirectorArray": [
        "Doris Wishman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "409",
      "databaseFilmTitle": "Bad Luck Banging or Loony Porn",
      "FilmTitle": "Bad Luck Banging or Loony Porn",
      "AlternateTitle": "Babardeală cu bucluc sau porno balamuc",
      "TitleArray": [
        "Bad Luck Banging or Loony Porn",
        "Babardeală cu bucluc sau porno balamuc"
      ],
      "Year": "2021",
      "Director": "Radu Jude",
      "DirectorArray": [
        "Radu Jude"
      ],
      "Country": "Romania, Luxembourg",
      "CountryArray": [
        "Romania",
        "Luxembourg"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "410",
      "databaseFilmTitle": "Bad Timing",
      "FilmTitle": "Bad Timing",
      "AlternateTitle": "Bad Timing: A Sensual Obsession",
      "TitleArray": [
        "Bad Timing",
        "Bad Timing: A Sensual Obsession"
      ],
      "Year": "1980",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "411",
      "databaseFilmTitle": "Badlands",
      "FilmTitle": "Badlands",
      "AlternateTitle": "",
      "TitleArray": [
        "Badlands"
      ],
      "Year": "1973",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "412",
      "databaseFilmTitle": "balikbayan #1 memories of overdevelopment redux iii",
      "FilmTitle": "balikbayan #1 memories of overdevelopment redux iii",
      "AlternateTitle": "",
      "TitleArray": [
        "balikbayan #1 memories of overdevelopment redux iii"
      ],
      "Year": "2015",
      "Director": "Kidlat Tahimik",
      "DirectorArray": [
        "Kidlat Tahimik"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "413",
      "databaseFilmTitle": "Ballad of a Soldier",
      "FilmTitle": "Ballad of a Soldier",
      "AlternateTitle": "Ballada o soldate",
      "TitleArray": [
        "Ballad of a Soldier",
        "Ballada o soldate"
      ],
      "Year": "1959",
      "Director": "Grigori Chukhrai",
      "DirectorArray": [
        "Grigori Chukhrai"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "414",
      "databaseFilmTitle": "Balle traversant une bulle de savon",
      "FilmTitle": "Balle traversant une bulle de savon",
      "AlternateTitle": "",
      "TitleArray": [
        "Balle traversant une bulle de savon"
      ],
      "Year": "1982",
      "Director": "Lucien Georges Bull",
      "DirectorArray": [
        "Lucien Georges Bull"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "415",
      "databaseFilmTitle": "Ballet",
      "FilmTitle": "Ballet",
      "AlternateTitle": "",
      "TitleArray": [
        "Ballet"
      ],
      "Year": "1995",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "416",
      "databaseFilmTitle": "Ballet mécanique",
      "FilmTitle": "Ballet mécanique",
      "AlternateTitle": "",
      "TitleArray": [
        "Ballet mécanique"
      ],
      "Year": "1924",
      "Director": "Fernand Léger, Dudley Murphy",
      "DirectorArray": [
        "Fernand Léger",
        "Dudley Murphy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "417",
      "databaseFilmTitle": "Balzac and the Little Chinese Seamstress",
      "FilmTitle": "Balzac and the Little Chinese Seamstress",
      "AlternateTitle": "Xiao cai feng",
      "TitleArray": [
        "Balzac and the Little Chinese Seamstress",
        "Xiao cai feng"
      ],
      "Year": "2002",
      "Director": "Dai Sijie",
      "DirectorArray": [
        "Dai Sijie"
      ],
      "Country": "China, France",
      "CountryArray": [
        "China",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "418",
      "databaseFilmTitle": "Bamako",
      "FilmTitle": "Bamako",
      "AlternateTitle": "",
      "TitleArray": [
        "Bamako"
      ],
      "Year": "2006",
      "Director": "Abderrahmane Sissako",
      "DirectorArray": [
        "Abderrahmane Sissako"
      ],
      "Country": "Mali, United States",
      "CountryArray": [
        "Mali",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "419",
      "databaseFilmTitle": "Bambi",
      "FilmTitle": "Bambi",
      "AlternateTitle": "",
      "TitleArray": [
        "Bambi"
      ],
      "Year": "1942",
      "Director": "James Alger, Samuel Armstrong, David Hand, Graham Heid, Bill Roberts, Paul Satterfield, Norman Wright",
      "DirectorArray": [
        "James Alger",
        "Samuel Armstrong",
        "David Hand",
        "Graham Heid",
        "Bill Roberts",
        "Paul Satterfield",
        "Norman Wright"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "420",
      "databaseFilmTitle": "Bamboozled",
      "FilmTitle": "Bamboozled",
      "AlternateTitle": "",
      "TitleArray": [
        "Bamboozled"
      ],
      "Year": "2000",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "421",
      "databaseFilmTitle": "Banana Paradise",
      "FilmTitle": "Banana Paradise",
      "AlternateTitle": "Xiang jiao tian tang",
      "TitleArray": [
        "Banana Paradise",
        "Xiang jiao tian tang"
      ],
      "Year": "1989",
      "Director": "Wang Toon",
      "DirectorArray": [
        "Wang Toon"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "422",
      "databaseFilmTitle": "Band of Angels",
      "FilmTitle": "Band of Angels",
      "AlternateTitle": "",
      "TitleArray": [
        "Band of Angels"
      ],
      "Year": "1957",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "423",
      "databaseFilmTitle": "Band of Outsiders",
      "FilmTitle": "Band of Outsiders",
      "AlternateTitle": "Bande à part",
      "TitleArray": [
        "Band of Outsiders",
        "Bande à part"
      ],
      "Year": "1964",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "424",
      "databaseFilmTitle": "Bandit Queen",
      "FilmTitle": "Bandit Queen",
      "AlternateTitle": "",
      "TitleArray": [
        "Bandit Queen"
      ],
      "Year": "1994",
      "Director": "Shekhar Kapur",
      "DirectorArray": [
        "Shekhar Kapur"
      ],
      "Country": "India, United Kingdom",
      "CountryArray": [
        "India",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "425",
      "databaseFilmTitle": "Bandits of Orgosolo",
      "FilmTitle": "Bandits of Orgosolo",
      "AlternateTitle": "Banditi a Orgosolo",
      "TitleArray": [
        "Bandits of Orgosolo",
        "Banditi a Orgosolo"
      ],
      "Year": "1961",
      "Director": "Vittorio De Seta",
      "DirectorArray": [
        "Vittorio De Seta"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "426",
      "databaseFilmTitle": "Bang Bang",
      "FilmTitle": "Bang Bang",
      "AlternateTitle": "",
      "TitleArray": [
        "Bang Bang"
      ],
      "Year": "1971",
      "Director": "Andrea Tonacci",
      "DirectorArray": [
        "Andrea Tonacci"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "427",
      "databaseFilmTitle": "Bang!",
      "FilmTitle": "Bang!",
      "AlternateTitle": "",
      "TitleArray": [
        "Bang!"
      ],
      "Year": "1967",
      "Director": "Bob Godfrey",
      "DirectorArray": [
        "Bob Godfrey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "428",
      "databaseFilmTitle": "Bangkok Nites",
      "FilmTitle": "Bangkok Nites",
      "AlternateTitle": "",
      "TitleArray": [
        "Bangkok Nites"
      ],
      "Year": "2016",
      "Director": "Katsuya Tomita",
      "DirectorArray": [
        "Katsuya Tomita"
      ],
      "Country": "Japan, France",
      "CountryArray": [
        "Japan",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "429",
      "databaseFilmTitle": "Baraka",
      "FilmTitle": "Baraka",
      "AlternateTitle": "",
      "TitleArray": [
        "Baraka"
      ],
      "Year": "1992",
      "Director": "Ron Fricke",
      "DirectorArray": [
        "Ron Fricke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "430",
      "databaseFilmTitle": "Barbara",
      "FilmTitle": "Barbara",
      "AlternateTitle": "",
      "TitleArray": [
        "Barbara"
      ],
      "Year": "2012",
      "Director": "Christian Petzold",
      "DirectorArray": [
        "Christian Petzold"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "431",
      "databaseFilmTitle": "Barbarella",
      "FilmTitle": "Barbarella",
      "AlternateTitle": "",
      "TitleArray": [
        "Barbarella"
      ],
      "Year": "1968",
      "Director": "Roger Vadim",
      "DirectorArray": [
        "Roger Vadim"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "432",
      "databaseFilmTitle": "Barking Dogs Never Bite",
      "FilmTitle": "Barking Dogs Never Bite",
      "AlternateTitle": "Flandersui Gae",
      "TitleArray": [
        "Barking Dogs Never Bite",
        "Flandersui Gae"
      ],
      "Year": "2000",
      "Director": "Bong Joon Ho",
      "DirectorArray": [
        "Bong Joon Ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "433",
      "databaseFilmTitle": "Barravento",
      "FilmTitle": "Barravento",
      "AlternateTitle": "",
      "TitleArray": [
        "Barravento"
      ],
      "Year": "1962",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "434",
      "databaseFilmTitle": "Barren Lives",
      "FilmTitle": "Barren Lives",
      "AlternateTitle": "Vidas secas",
      "TitleArray": [
        "Barren Lives",
        "Vidas secas"
      ],
      "Year": "1963",
      "Director": "Nelson Pereira dos Santos",
      "DirectorArray": [
        "Nelson Pereira dos Santos"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "435",
      "databaseFilmTitle": "Barres",
      "FilmTitle": "Barres",
      "AlternateTitle": "",
      "TitleArray": [
        "Barres"
      ],
      "Year": "1984",
      "Director": "Luc Moullet",
      "DirectorArray": [
        "Luc Moullet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "436",
      "databaseFilmTitle": "Barrier",
      "FilmTitle": "Barrier",
      "AlternateTitle": "Bariera",
      "TitleArray": [
        "Barrier",
        "Bariera"
      ],
      "Year": "1966",
      "Director": "Jerzy Skolimowski",
      "DirectorArray": [
        "Jerzy Skolimowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "437",
      "databaseFilmTitle": "Barry Lyndon",
      "FilmTitle": "Barry Lyndon",
      "AlternateTitle": "",
      "TitleArray": [
        "Barry Lyndon"
      ],
      "Year": "1975",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "59",
      "2012votes": "25",
      "2022rank": "45",
      "2022votes": "49"
    },
    {
      "key": "438",
      "databaseFilmTitle": "Barton Fink",
      "FilmTitle": "Barton Fink",
      "AlternateTitle": "",
      "TitleArray": [
        "Barton Fink"
      ],
      "Year": "1991",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "439",
      "databaseFilmTitle": "Bashu, The Little Stranger",
      "FilmTitle": "Bashu, The Little Stranger",
      "AlternateTitle": "Bashu, Gharibeye Koochak",
      "TitleArray": [
        "Bashu, The Little Stranger",
        "Bashu, Gharibeye Koochak"
      ],
      "Year": "1989",
      "Director": "Bahram Beizai",
      "DirectorArray": [
        "Bahram Beizai"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "440",
      "databaseFilmTitle": "Basic Instinct",
      "FilmTitle": "Basic Instinct",
      "AlternateTitle": "",
      "TitleArray": [
        "Basic Instinct"
      ],
      "Year": "1992",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "United States, France",
      "CountryArray": [
        "United States",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "441",
      "databaseFilmTitle": "Basta",
      "FilmTitle": "Basta",
      "AlternateTitle": "",
      "TitleArray": [
        "Basta"
      ],
      "Year": "1969",
      "Director": "Ugo Ulive",
      "DirectorArray": [
        "Ugo Ulive"
      ],
      "Country": "Venezuela",
      "CountryArray": [
        "Venezuela"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "442",
      "databaseFilmTitle": "Bastards",
      "FilmTitle": "Bastards",
      "AlternateTitle": "Les salauds",
      "TitleArray": [
        "Bastards",
        "Les salauds"
      ],
      "Year": "2013",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "443",
      "databaseFilmTitle": "Bastille Day",
      "FilmTitle": "Bastille Day",
      "AlternateTitle": "Quatorze Juillet",
      "TitleArray": [
        "Bastille Day",
        "Quatorze Juillet"
      ],
      "Year": "1933",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "444",
      "databaseFilmTitle": "Batman Returns",
      "FilmTitle": "Batman Returns",
      "AlternateTitle": "",
      "TitleArray": [
        "Batman Returns"
      ],
      "Year": "1992",
      "Director": "Tim Burton",
      "DirectorArray": [
        "Tim Burton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "445",
      "databaseFilmTitle": "Battle in Heaven",
      "FilmTitle": "Battle in Heaven",
      "AlternateTitle": "Batalla en el cielo",
      "TitleArray": [
        "Battle in Heaven",
        "Batalla en el cielo"
      ],
      "Year": "2005",
      "Director": "Carlos Reygadas",
      "DirectorArray": [
        "Carlos Reygadas"
      ],
      "Country": "Mexico, France",
      "CountryArray": [
        "Mexico",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "446",
      "databaseFilmTitle": "Battle Royale",
      "FilmTitle": "Battle Royale",
      "AlternateTitle": "Batoru Rowaiaru",
      "TitleArray": [
        "Battle Royale",
        "Batoru Rowaiaru"
      ],
      "Year": "2000",
      "Director": "Kinji Fukasaku",
      "DirectorArray": [
        "Kinji Fukasaku"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "447",
      "databaseFilmTitle": "Battleship Potemkin",
      "FilmTitle": "Battleship Potemkin",
      "AlternateTitle": "",
      "TitleArray": [
        "Battleship Potemkin"
      ],
      "Year": "1925",
      "Director": "Sergei Eisenstein",
      "DirectorArray": [
        "Sergei Eisenstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "4",
      "1952votes": "16",
      "1962rank": "6",
      "1962votes": "16",
      "1972rank": "3",
      "1972votes": "16",
      "1982rank": "6",
      "1982votes": "13",
      "1992rank": "6",
      "1992votes": "15",
      "2002rank": "6",
      "2002votes": "19",
      "2012rank": "11",
      "2012votes": "63",
      "2022rank": "54",
      "2022votes": "44"
    },
    {
      "key": "448",
      "databaseFilmTitle": "Battling Butler",
      "FilmTitle": "Battling Butler",
      "AlternateTitle": "",
      "TitleArray": [
        "Battling Butler"
      ],
      "Year": "1926",
      "Director": "Buster Keaton",
      "DirectorArray": [
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "449",
      "databaseFilmTitle": "Bay of Angels",
      "FilmTitle": "Bay of Angels",
      "AlternateTitle": "La baie des anges",
      "TitleArray": [
        "Bay of Angels",
        "La baie des anges"
      ],
      "Year": "1963",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "450",
      "databaseFilmTitle": "Bay of Pigs",
      "FilmTitle": "Bay of Pigs",
      "AlternateTitle": "Girón",
      "TitleArray": [
        "Bay of Pigs",
        "Girón"
      ],
      "Year": "1972",
      "Director": "Manuel Herrera",
      "DirectorArray": [
        "Manuel Herrera"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "451",
      "databaseFilmTitle": "Beau travail",
      "FilmTitle": "Beau travail",
      "AlternateTitle": "",
      "TitleArray": [
        "Beau travail"
      ],
      "Year": "1999",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "78",
      "2012votes": "21",
      "2022rank": "7",
      "2022votes": "106"
    },
    {
      "key": "452",
      "databaseFilmTitle": "Beautiful Thing",
      "FilmTitle": "Beautiful Thing",
      "AlternateTitle": "",
      "TitleArray": [
        "Beautiful Thing"
      ],
      "Year": "1996",
      "Director": "Hettie Macdonald",
      "DirectorArray": [
        "Hettie Macdonald"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "453",
      "databaseFilmTitle": "Beauty #2",
      "FilmTitle": "Beauty #2",
      "AlternateTitle": "",
      "TitleArray": [
        "Beauty #2"
      ],
      "Year": "1965",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "454",
      "databaseFilmTitle": "Beauty and the Beast (1946)",
      "FilmTitle": "Beauty and the Beast",
      "AlternateTitle": "La Belle et la Bête",
      "TitleArray": [
        "Beauty and the Beast",
        "La Belle et la Bête"
      ],
      "Year": "1946",
      "Director": "Jean Cocteau, René Clément",
      "DirectorArray": [
        "Jean Cocteau",
        "René Clément"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "455",
      "databaseFilmTitle": "Beauty and the Beast (1991)",
      "FilmTitle": "Beauty and the Beast",
      "AlternateTitle": "",
      "TitleArray": [
        "Beauty and the Beast"
      ],
      "Year": "1991",
      "Director": "Gary Trousdale, Kirk Wise",
      "DirectorArray": [
        "Gary Trousdale",
        "Kirk Wise"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "456",
      "databaseFilmTitle": "Becky Sharp",
      "FilmTitle": "Becky Sharp",
      "AlternateTitle": "",
      "TitleArray": [
        "Becky Sharp"
      ],
      "Year": "1935",
      "Director": "Rouben Mamoulian",
      "DirectorArray": [
        "Rouben Mamoulian"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "457",
      "databaseFilmTitle": "Bed and Sofa",
      "FilmTitle": "Bed and Sofa",
      "AlternateTitle": "Tretya Meshchanskaya",
      "TitleArray": [
        "Bed and Sofa",
        "Tretya Meshchanskaya"
      ],
      "Year": "1927",
      "Director": "Abram Room",
      "DirectorArray": [
        "Abram Room"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "458",
      "databaseFilmTitle": "Bedevil",
      "FilmTitle": "Bedevil",
      "AlternateTitle": "",
      "TitleArray": [
        "Bedevil"
      ],
      "Year": "1993",
      "Director": "Tracey Moffatt",
      "DirectorArray": [
        "Tracey Moffatt"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "459",
      "databaseFilmTitle": "Beep, Beep",
      "FilmTitle": "Beep, Beep",
      "AlternateTitle": "",
      "TitleArray": [
        "Beep, Beep"
      ],
      "Year": "1952",
      "Director": "Chuck Jones",
      "DirectorArray": [
        "Chuck Jones"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "460",
      "databaseFilmTitle": "Before Need Redressed",
      "FilmTitle": "Before Need Redressed",
      "AlternateTitle": "",
      "TitleArray": [
        "Before Need Redressed"
      ],
      "Year": "1994",
      "Director": "Gunvor Nelson, Dorothy Wiley",
      "DirectorArray": [
        "Gunvor Nelson",
        "Dorothy Wiley"
      ],
      "Country": "Sweden, United States",
      "CountryArray": [
        "Sweden",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "461",
      "databaseFilmTitle": "Before Sunrise",
      "FilmTitle": "Before Sunrise",
      "AlternateTitle": "",
      "TitleArray": [
        "Before Sunrise"
      ],
      "Year": "1995",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "462",
      "databaseFilmTitle": "Before Sunset",
      "FilmTitle": "Before Sunset",
      "AlternateTitle": "",
      "TitleArray": [
        "Before Sunset"
      ],
      "Year": "2004",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "463",
      "databaseFilmTitle": "Before the Rain",
      "FilmTitle": "Before the Rain",
      "AlternateTitle": "Pred doždot",
      "TitleArray": [
        "Before the Rain",
        "Pred doždot"
      ],
      "Year": "1994",
      "Director": "Milcho Manchevski",
      "DirectorArray": [
        "Milcho Manchevski"
      ],
      "Country": "Macedonia",
      "CountryArray": [
        "Macedonia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "464",
      "databaseFilmTitle": "Begone Dull Care",
      "FilmTitle": "Begone Dull Care",
      "AlternateTitle": "",
      "TitleArray": [
        "Begone Dull Care"
      ],
      "Year": "1950",
      "Director": "Evelyn Lambart, Norman McLaren",
      "DirectorArray": [
        "Evelyn Lambart",
        "Norman McLaren"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "465",
      "databaseFilmTitle": "Behind the Green Door",
      "FilmTitle": "Behind the Green Door",
      "AlternateTitle": "",
      "TitleArray": [
        "Behind the Green Door"
      ],
      "Year": "1972",
      "Director": "Artie Mitchell, Jim Mitchell",
      "DirectorArray": [
        "Artie Mitchell",
        "Jim Mitchell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "466",
      "databaseFilmTitle": "Being John Malkovich",
      "FilmTitle": "Being John Malkovich",
      "AlternateTitle": "",
      "TitleArray": [
        "Being John Malkovich"
      ],
      "Year": "1999",
      "Director": "Spike Jonze",
      "DirectorArray": [
        "Spike Jonze"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "467",
      "databaseFilmTitle": "Being There",
      "FilmTitle": "Being There",
      "AlternateTitle": "",
      "TitleArray": [
        "Being There"
      ],
      "Year": "1979",
      "Director": "Hal Ashby",
      "DirectorArray": [
        "Hal Ashby"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "468",
      "databaseFilmTitle": "Being Women",
      "FilmTitle": "Being Women",
      "AlternateTitle": "Essere donne",
      "TitleArray": [
        "Being Women",
        "Essere donne"
      ],
      "Year": "1965",
      "Director": "Cecilia Mangini",
      "DirectorArray": [
        "Cecilia Mangini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "469",
      "databaseFilmTitle": "Beirut, My City",
      "FilmTitle": "Beirut, My City",
      "AlternateTitle": "Beyrouth, Ma Ville",
      "TitleArray": [
        "Beirut, My City",
        "Beyrouth, Ma Ville"
      ],
      "Year": "1982",
      "Director": "Jocelyne Saab",
      "DirectorArray": [
        "Jocelyne Saab"
      ],
      "Country": "Lebanon",
      "CountryArray": [
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "470",
      "databaseFilmTitle": "Belfast",
      "FilmTitle": "Belfast",
      "AlternateTitle": "",
      "TitleArray": [
        "Belfast"
      ],
      "Year": "2021",
      "Director": "Kenneth Branagh",
      "DirectorArray": [
        "Kenneth Branagh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "471",
      "databaseFilmTitle": "Belfast, Maine",
      "FilmTitle": "Belfast, Maine",
      "AlternateTitle": "",
      "TitleArray": [
        "Belfast, Maine"
      ],
      "Year": "1999",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "472",
      "databaseFilmTitle": "Belladonna of Sadness",
      "FilmTitle": "Belladonna of Sadness",
      "AlternateTitle": "Kanashimi no Beradonna",
      "TitleArray": [
        "Belladonna of Sadness",
        "Kanashimi no Beradonna"
      ],
      "Year": "1973",
      "Director": "Eiichi Yamamoto",
      "DirectorArray": [
        "Eiichi Yamamoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "473",
      "databaseFilmTitle": "Belle",
      "FilmTitle": "Belle",
      "AlternateTitle": "Ryū to Sobakasu no Hime",
      "TitleArray": [
        "Belle",
        "Ryū to Sobakasu no Hime"
      ],
      "Year": "2021",
      "Director": "Mamoru Hosoda",
      "DirectorArray": [
        "Mamoru Hosoda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "474",
      "databaseFilmTitle": "Belle de jour",
      "FilmTitle": "Belle de jour",
      "AlternateTitle": "",
      "TitleArray": [
        "Belle de jour"
      ],
      "Year": "1967",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "475",
      "databaseFilmTitle": "Bellissima",
      "FilmTitle": "Bellissima",
      "AlternateTitle": "",
      "TitleArray": [
        "Bellissima"
      ],
      "Year": "1951",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "476",
      "databaseFilmTitle": "Belly",
      "FilmTitle": "Belly",
      "AlternateTitle": "",
      "TitleArray": [
        "Belly"
      ],
      "Year": "1998",
      "Director": "Hype Williams",
      "DirectorArray": [
        "Hype Williams"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "477",
      "databaseFilmTitle": "Beloved Infidel",
      "FilmTitle": "Beloved Infidel",
      "AlternateTitle": "",
      "TitleArray": [
        "Beloved Infidel"
      ],
      "Year": "1959",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "478",
      "databaseFilmTitle": "Belphégor",
      "FilmTitle": "Belphégor",
      "AlternateTitle": "",
      "TitleArray": [
        "Belphégor"
      ],
      "Year": "1927",
      "Director": "Henri Desfontaines",
      "DirectorArray": [
        "Henri Desfontaines"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "479",
      "databaseFilmTitle": "Ben-Hur",
      "FilmTitle": "Ben-Hur",
      "AlternateTitle": "",
      "TitleArray": [
        "Ben-Hur"
      ],
      "Year": "1959",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "480",
      "databaseFilmTitle": "Bend it Like Beckham",
      "FilmTitle": "Bend it Like Beckham",
      "AlternateTitle": "",
      "TitleArray": [
        "Bend it Like Beckham"
      ],
      "Year": "2002",
      "Director": "Gurinder Chadha",
      "DirectorArray": [
        "Gurinder Chadha"
      ],
      "Country": "United Kingdom, Germany",
      "CountryArray": [
        "United Kingdom",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "481",
      "databaseFilmTitle": "Beneath the Valley of the Ultra-Vixens",
      "FilmTitle": "Beneath the Valley of the Ultra-Vixens",
      "AlternateTitle": "",
      "TitleArray": [
        "Beneath the Valley of the Ultra-Vixens"
      ],
      "Year": "1979",
      "Director": "Russ Meyer",
      "DirectorArray": [
        "Russ Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "482",
      "databaseFilmTitle": "Benilde or the Virgin Mother",
      "FilmTitle": "Benilde or the Virgin Mother",
      "AlternateTitle": "Benilde ou a Virgem Mãe",
      "TitleArray": [
        "Benilde or the Virgin Mother",
        "Benilde ou a Virgem Mãe"
      ],
      "Year": "1975",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "483",
      "databaseFilmTitle": "Bent Time",
      "FilmTitle": "Bent Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Bent Time"
      ],
      "Year": "1983",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "484",
      "databaseFilmTitle": "Bergman Island",
      "FilmTitle": "Bergman Island",
      "AlternateTitle": "",
      "TitleArray": [
        "Bergman Island"
      ],
      "Year": "2021",
      "Director": "Mia Hansen-Løve",
      "DirectorArray": [
        "Mia Hansen-Løve"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "485",
      "databaseFilmTitle": "Berkeley Square",
      "FilmTitle": "Berkeley Square",
      "AlternateTitle": "",
      "TitleArray": [
        "Berkeley Square"
      ],
      "Year": "1933",
      "Director": "Frank Lloyd",
      "DirectorArray": [
        "Frank Lloyd"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "486",
      "databaseFilmTitle": "Berlin Alexanderplatz",
      "FilmTitle": "Berlin Alexanderplatz",
      "AlternateTitle": "",
      "TitleArray": [
        "Berlin Alexanderplatz"
      ],
      "Year": "1980",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "487",
      "databaseFilmTitle": "Berlin: Symphony of a Great City",
      "FilmTitle": "Berlin: Symphony of a Great City",
      "AlternateTitle": "Berlin: Die Sinfonie der Großstadt",
      "TitleArray": [
        "Berlin: Symphony of a Great City",
        "Berlin: Die Sinfonie der Großstadt"
      ],
      "Year": "1927",
      "Director": "Walter Ruttmann",
      "DirectorArray": [
        "Walter Ruttmann"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "488",
      "databaseFilmTitle": "Beshkempir: The Adopted Son",
      "FilmTitle": "Beshkempir: The Adopted Son",
      "AlternateTitle": "Beshkempir",
      "TitleArray": [
        "Beshkempir: The Adopted Son",
        "Beshkempir"
      ],
      "Year": "1998",
      "Director": "Aktan Abdykalykov",
      "DirectorArray": [
        "Aktan Abdykalykov"
      ],
      "Country": "Kyrgyzstan, France",
      "CountryArray": [
        "Kyrgyzstan",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "489",
      "databaseFilmTitle": "Besieged",
      "FilmTitle": "Besieged",
      "AlternateTitle": "L'assedio",
      "TitleArray": [
        "Besieged",
        "L'assedio"
      ],
      "Year": "1998",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "490",
      "databaseFilmTitle": "Best in Show",
      "FilmTitle": "Best in Show",
      "AlternateTitle": "",
      "TitleArray": [
        "Best in Show"
      ],
      "Year": "2000",
      "Director": "Christopher Guest",
      "DirectorArray": [
        "Christopher Guest"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "491",
      "databaseFilmTitle": "Betty Blue",
      "FilmTitle": "Betty Blue",
      "AlternateTitle": "37°2 le matin",
      "TitleArray": [
        "Betty Blue",
        "37°2 le matin"
      ],
      "Year": "1986",
      "Director": "Jean-Jacques Beineix",
      "DirectorArray": [
        "Jean-Jacques Beineix"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "492",
      "databaseFilmTitle": "Betty's Boat",
      "FilmTitle": "Betty's Boat",
      "AlternateTitle": "Le bateau de Léontine",
      "TitleArray": [
        "Betty's Boat",
        "Le bateau de Léontine"
      ],
      "Year": "1911",
      "Director": "Romeo Bosetti",
      "DirectorArray": [
        "Romeo Bosetti"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "493",
      "databaseFilmTitle": "Between the Waves",
      "FilmTitle": "Between the Waves",
      "AlternateTitle": "",
      "TitleArray": [
        "Between the Waves"
      ],
      "Year": "2012",
      "Director": "Tejal Shah",
      "DirectorArray": [
        "Tejal Shah"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "494",
      "databaseFilmTitle": "Beware of a Holy Whore",
      "FilmTitle": "Beware of a Holy Whore",
      "AlternateTitle": "Warnung vor einer heiligen Nutte",
      "TitleArray": [
        "Beware of a Holy Whore",
        "Warnung vor einer heiligen Nutte"
      ],
      "Year": "1971",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "495",
      "databaseFilmTitle": "Beychella",
      "FilmTitle": "Beyoncé 2018 Coachella Performance",
      "AlternateTitle": "Beychella",
      "TitleArray": [
        "Beyoncé 2018 Coachella Performance",
        "Beychella"
      ],
      "Year": "2018",
      "Director": "JaQuel Knight, Todd Tourso",
      "DirectorArray": [
        "JaQuel Knight",
        "Todd Tourso"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "496",
      "databaseFilmTitle": "Beyond a Reasonable Doubt",
      "FilmTitle": "Beyond a Reasonable Doubt",
      "AlternateTitle": "",
      "TitleArray": [
        "Beyond a Reasonable Doubt"
      ],
      "Year": "1956",
      "Director": "Fritz Land",
      "DirectorArray": [
        "Fritz Land"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "497",
      "databaseFilmTitle": "Beyond the Darkness",
      "FilmTitle": "Beyond the Darkness",
      "AlternateTitle": "Buio Omega",
      "TitleArray": [
        "Beyond the Darkness",
        "Buio Omega"
      ],
      "Year": "1979",
      "Director": "Joe D'Amato",
      "DirectorArray": [
        "Joe D'Amato"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "498",
      "databaseFilmTitle": "Beyond the Forest",
      "FilmTitle": "Beyond the Forest",
      "AlternateTitle": "",
      "TitleArray": [
        "Beyond the Forest"
      ],
      "Year": "1949",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "499",
      "databaseFilmTitle": "Beyond the Infinite Two Minutes",
      "FilmTitle": "Beyond the Infinite Two Minutes",
      "AlternateTitle": "Droste no hate de bokura",
      "TitleArray": [
        "Beyond the Infinite Two Minutes",
        "Droste no hate de bokura"
      ],
      "Year": "2020",
      "Director": "Junta Yamaguchi",
      "DirectorArray": [
        "Junta Yamaguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "500",
      "databaseFilmTitle": "Beyond the Valley of the Dolls",
      "FilmTitle": "Beyond the Valley of the Dolls",
      "AlternateTitle": "",
      "TitleArray": [
        "Beyond the Valley of the Dolls"
      ],
      "Year": "1970",
      "Director": "Russ Meyer",
      "DirectorArray": [
        "Russ Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "501",
      "databaseFilmTitle": "Bicycle Thieves",
      "FilmTitle": "Bicycle Thieves",
      "AlternateTitle": "Ladri di biciclette",
      "TitleArray": [
        "Bicycle Thieves",
        "Ladri di biciclette"
      ],
      "Year": "1948",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "1",
      "1952votes": "25",
      "1962rank": "6",
      "1962votes": "16",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "11",
      "1992votes": "10",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "33",
      "2012votes": "37",
      "2022rank": "41",
      "2022votes": "52"
    },
    {
      "key": "502",
      "databaseFilmTitle": "Big Deal on Madonna Street",
      "FilmTitle": "Big Deal on Madonna Street",
      "AlternateTitle": "I soliti ignoti",
      "TitleArray": [
        "Big Deal on Madonna Street",
        "I soliti ignoti"
      ],
      "Year": "1958",
      "Director": "Mario Monicelli",
      "DirectorArray": [
        "Mario Monicelli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "503",
      "databaseFilmTitle": "Big Time Gambling Boss",
      "FilmTitle": "Big Time Gambling Boss",
      "AlternateTitle": "Bakuchiuci: Sôchô Tobaku",
      "TitleArray": [
        "Big Time Gambling Boss",
        "Bakuchiuci: Sôchô Tobaku"
      ],
      "Year": "1968",
      "Director": "Kôsaku Yamashita",
      "DirectorArray": [
        "Kôsaku Yamashita"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "504",
      "databaseFilmTitle": "Big Wednesday",
      "FilmTitle": "Big Wednesday",
      "AlternateTitle": "",
      "TitleArray": [
        "Big Wednesday"
      ],
      "Year": "1978",
      "Director": "John Milius",
      "DirectorArray": [
        "John Milius"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "505",
      "databaseFilmTitle": "Bigger Than Life",
      "FilmTitle": "Bigger Than Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Bigger Than Life"
      ],
      "Year": "1956",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "506",
      "databaseFilmTitle": "Bill and Ted's Excellent Adventure",
      "FilmTitle": "Bill and Ted's Excellent Adventure",
      "AlternateTitle": "",
      "TitleArray": [
        "Bill and Ted's Excellent Adventure"
      ],
      "Year": "1989",
      "Director": "Stephen Herek",
      "DirectorArray": [
        "Stephen Herek"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "507",
      "databaseFilmTitle": "Billy Elliot",
      "FilmTitle": "Billy Elliot",
      "AlternateTitle": "",
      "TitleArray": [
        "Billy Elliot"
      ],
      "Year": "2000",
      "Director": "Stephen Daldry",
      "DirectorArray": [
        "Stephen Daldry"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "508",
      "databaseFilmTitle": "Billy Liar",
      "FilmTitle": "Billy Liar",
      "AlternateTitle": "",
      "TitleArray": [
        "Billy Liar"
      ],
      "Year": "1963",
      "Director": "John Schlesigner",
      "DirectorArray": [
        "John Schlesigner"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "509",
      "databaseFilmTitle": "Billy Lynn's Long Halftime Walk",
      "FilmTitle": "Billy Lynn's Long Halftime Walk",
      "AlternateTitle": "",
      "TitleArray": [
        "Billy Lynn's Long Halftime Walk"
      ],
      "Year": "2016",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "510",
      "databaseFilmTitle": "Bimbo's Initiation",
      "FilmTitle": "Bimbo's Initiation",
      "AlternateTitle": "",
      "TitleArray": [
        "Bimbo's Initiation"
      ],
      "Year": "1931",
      "Director": "Dave Fleischer",
      "DirectorArray": [
        "Dave Fleischer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "511",
      "databaseFilmTitle": "Binding Sentiments",
      "FilmTitle": "Binding Sentiments",
      "AlternateTitle": "Holdudvar",
      "TitleArray": [
        "Binding Sentiments",
        "Holdudvar"
      ],
      "Year": "1969",
      "Director": "Márta Mészáros",
      "DirectorArray": [
        "Márta Mészáros"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "512",
      "databaseFilmTitle": "BioShock",
      "FilmTitle": "BioShock",
      "AlternateTitle": "",
      "TitleArray": [
        "BioShock"
      ],
      "Year": "2007",
      "Director": "Ken Levine",
      "DirectorArray": [
        "Ken Levine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "513",
      "databaseFilmTitle": "Bird",
      "FilmTitle": "Bird",
      "AlternateTitle": "",
      "TitleArray": [
        "Bird"
      ],
      "Year": "1988",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "514",
      "databaseFilmTitle": "Birds in Peru",
      "FilmTitle": "Birds in Peru",
      "AlternateTitle": "Les oiseaux vont mourir au Pérou",
      "TitleArray": [
        "Birds in Peru",
        "Les oiseaux vont mourir au Pérou"
      ],
      "Year": "1968",
      "Director": "Romain Gary",
      "DirectorArray": [
        "Romain Gary"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "515",
      "databaseFilmTitle": "Birds, Orphans and Fools",
      "FilmTitle": "Birds, Orphans and Fools",
      "AlternateTitle": "Vtáckovia, siroty a blázni",
      "TitleArray": [
        "Birds, Orphans and Fools",
        "Vtáckovia, siroty a blázni"
      ],
      "Year": "1969",
      "Director": "Juraj Jakubisko",
      "DirectorArray": [
        "Juraj Jakubisko"
      ],
      "Country": "Czechoslovakia, France",
      "CountryArray": [
        "Czechoslovakia",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "516",
      "databaseFilmTitle": "Birth",
      "FilmTitle": "Birth",
      "AlternateTitle": "",
      "TitleArray": [
        "Birth"
      ],
      "Year": "2004",
      "Director": "Jonathan Glazer",
      "DirectorArray": [
        "Jonathan Glazer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "517",
      "databaseFilmTitle": "Bitter Coffee",
      "FilmTitle": "Bitter Coffee",
      "AlternateTitle": "Secangkir Kopi Pahit",
      "TitleArray": [
        "Bitter Coffee",
        "Secangkir Kopi Pahit"
      ],
      "Year": "1985",
      "Director": "Teguh Karya",
      "DirectorArray": [
        "Teguh Karya"
      ],
      "Country": "Indonesia",
      "CountryArray": [
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "518",
      "databaseFilmTitle": "Bitter Moon",
      "FilmTitle": "Bitter Moon",
      "AlternateTitle": "",
      "TitleArray": [
        "Bitter Moon"
      ],
      "Year": "1992",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "519",
      "databaseFilmTitle": "Bitter Victory",
      "FilmTitle": "Bitter Victory",
      "AlternateTitle": "",
      "TitleArray": [
        "Bitter Victory"
      ],
      "Year": "1957",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States, France",
      "CountryArray": [
        "United States",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "520",
      "databaseFilmTitle": "Bizarre, Bizarre",
      "FilmTitle": "Bizarre, Bizarre",
      "AlternateTitle": "Drôle de drame",
      "TitleArray": [
        "Bizarre, Bizarre",
        "Drôle de drame"
      ],
      "Year": "1937",
      "Director": "Marcel Carné",
      "DirectorArray": [
        "Marcel Carné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "521",
      "databaseFilmTitle": "Black",
      "FilmTitle": "Black",
      "AlternateTitle": "",
      "TitleArray": [
        "Black"
      ],
      "Year": "2016",
      "Director": "Anouk De Clercq",
      "DirectorArray": [
        "Anouk De Clercq"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "522",
      "databaseFilmTitle": "Black Coal, Thin Ice",
      "FilmTitle": "Black Coal, Thin Ice",
      "AlternateTitle": "Bai ri yan huo",
      "TitleArray": [
        "Black Coal, Thin Ice",
        "Bai ri yan huo"
      ],
      "Year": "2014",
      "Director": "Diao Yi'nan",
      "DirectorArray": [
        "Diao Yi'nan"
      ],
      "Country": "China, Hong Kong",
      "CountryArray": [
        "China",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "523",
      "databaseFilmTitle": "Black Dynamite",
      "FilmTitle": "Black Dynamite",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Dynamite"
      ],
      "Year": "2009",
      "Director": "Scott Sanders",
      "DirectorArray": [
        "Scott Sanders"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "524",
      "databaseFilmTitle": "Black Film",
      "FilmTitle": "Black Film",
      "AlternateTitle": "Crni film",
      "TitleArray": [
        "Black Film",
        "Crni film"
      ],
      "Year": "1971",
      "Director": "Želimir Žilnik",
      "DirectorArray": [
        "Želimir Žilnik"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "525",
      "databaseFilmTitle": "Black Girl",
      "FilmTitle": "Black Girl",
      "AlternateTitle": "La noire de...",
      "TitleArray": [
        "Black Girl",
        "La noire de..."
      ],
      "Year": "1966",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal, France",
      "CountryArray": [
        "Senegal",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "526",
      "databaseFilmTitle": "Black God, White Devil",
      "FilmTitle": "Black God, White Devil",
      "AlternateTitle": "Deus e o Diabo na Terra do Sol",
      "TitleArray": [
        "Black God, White Devil",
        "Deus e o Diabo na Terra do Sol"
      ],
      "Year": "1964",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "527",
      "databaseFilmTitle": "Black Ice",
      "FilmTitle": "Black Ice",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Ice"
      ],
      "Year": "1994",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "528",
      "databaseFilmTitle": "Black Moon",
      "FilmTitle": "Black Moon",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Moon"
      ],
      "Year": "1975",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "529",
      "databaseFilmTitle": "Black Narcissus",
      "FilmTitle": "Black Narcissus",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Narcissus"
      ],
      "Year": "1947",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "530",
      "databaseFilmTitle": "Black Orpheus",
      "FilmTitle": "Black Orpheus",
      "AlternateTitle": "Orfeu negro",
      "TitleArray": [
        "Black Orpheus",
        "Orfeu negro"
      ],
      "Year": "1959",
      "Director": "Marcel Camus",
      "DirectorArray": [
        "Marcel Camus"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "531",
      "databaseFilmTitle": "Black Panther",
      "FilmTitle": "Black Panther",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Panther"
      ],
      "Year": "2018",
      "Director": "Ryan Coogler",
      "DirectorArray": [
        "Ryan Coogler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "532",
      "databaseFilmTitle": "Black Rain",
      "FilmTitle": "Black Rain",
      "AlternateTitle": "Kuroi ame",
      "TitleArray": [
        "Black Rain",
        "Kuroi ame"
      ],
      "Year": "1989",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "533",
      "databaseFilmTitle": "Black Rose is an Emblem of Sorrow, Red Rose is an Emblem of Love",
      "FilmTitle": "Black Rose is an Emblem of Sorrow, Red Rose is an Emblem of Love",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Rose is an Emblem of Sorrow, Red Rose is an Emblem of Love"
      ],
      "Year": "1989",
      "Director": "Sergei Solovyov",
      "DirectorArray": [
        "Sergei Solovyov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "534",
      "databaseFilmTitle": "Black Snow",
      "FilmTitle": "Black Snow",
      "AlternateTitle": "Ben ming nian",
      "TitleArray": [
        "Black Snow",
        "Ben ming nian"
      ],
      "Year": "1990",
      "Director": "Xie Fei",
      "DirectorArray": [
        "Xie Fei"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "535",
      "databaseFilmTitle": "Black Sunday",
      "FilmTitle": "Black Sunday",
      "AlternateTitle": "La maschera del demonio",
      "TitleArray": [
        "Black Sunday",
        "La maschera del demonio"
      ],
      "Year": "1960",
      "Director": "Mario Bava",
      "DirectorArray": [
        "Mario Bava"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "536",
      "databaseFilmTitle": "Black Swan",
      "FilmTitle": "Black Swan",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Swan"
      ],
      "Year": "2010",
      "Director": "Darren Aronofsky",
      "DirectorArray": [
        "Darren Aronofsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "537",
      "databaseFilmTitle": "Black TV",
      "FilmTitle": "Black TV",
      "AlternateTitle": "",
      "TitleArray": [
        "Black TV"
      ],
      "Year": "1968",
      "Director": "Aldo Tambellini",
      "DirectorArray": [
        "Aldo Tambellini"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "538",
      "databaseFilmTitle": "Black Widow",
      "FilmTitle": "Black Widow",
      "AlternateTitle": "",
      "TitleArray": [
        "Black Widow"
      ],
      "Year": "2021",
      "Director": "Cate Shortland",
      "DirectorArray": [
        "Cate Shortland"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "539",
      "databaseFilmTitle": "Blackberry Season",
      "FilmTitle": "Blackberry Season",
      "AlternateTitle": "",
      "TitleArray": [
        "Blackberry Season"
      ],
      "Year": "2021",
      "Director": "Hasim Aydemir",
      "DirectorArray": [
        "Hasim Aydemir"
      ],
      "Country": "Iraq",
      "CountryArray": [
        "Iraq"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "540",
      "databaseFilmTitle": "Blackboards",
      "FilmTitle": "Blackboards",
      "AlternateTitle": "Takhté siah",
      "TitleArray": [
        "Blackboards",
        "Takhté siah"
      ],
      "Year": "2000",
      "Director": "Samira Makhmalbaf",
      "DirectorArray": [
        "Samira Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "541",
      "databaseFilmTitle": "BlacKkKlansman",
      "FilmTitle": "BlacKkKlansman",
      "AlternateTitle": "",
      "TitleArray": [
        "BlacKkKlansman"
      ],
      "Year": "2018",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "542",
      "databaseFilmTitle": "Blackmail",
      "FilmTitle": "Blackmail",
      "AlternateTitle": "",
      "TitleArray": [
        "Blackmail"
      ],
      "Year": "1929",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "543",
      "databaseFilmTitle": "Blade Runner",
      "FilmTitle": "Blade Runner",
      "AlternateTitle": "",
      "TitleArray": [
        "Blade Runner"
      ],
      "Year": "1982",
      "Director": "Ridley Scott",
      "DirectorArray": [
        "Ridley Scott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "69",
      "2012votes": "23",
      "2022rank": "54",
      "2022votes": "44"
    },
    {
      "key": "544",
      "databaseFilmTitle": "Blaise Pascal",
      "FilmTitle": "Blaise Pascal",
      "AlternateTitle": "",
      "TitleArray": [
        "Blaise Pascal"
      ],
      "Year": "1972",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "545",
      "databaseFilmTitle": "Blazing Saddles",
      "FilmTitle": "Blazing Saddles",
      "AlternateTitle": "",
      "TitleArray": [
        "Blazing Saddles"
      ],
      "Year": "1974",
      "Director": "Mel Brooks",
      "DirectorArray": [
        "Mel Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "546",
      "databaseFilmTitle": "Bless Their Little Hearts",
      "FilmTitle": "Bless Their Little Hearts",
      "AlternateTitle": "",
      "TitleArray": [
        "Bless Their Little Hearts"
      ],
      "Year": "1983",
      "Director": "Billy Woodberry",
      "DirectorArray": [
        "Billy Woodberry"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "547",
      "databaseFilmTitle": "Bleu Shut",
      "FilmTitle": "Bleu Shut",
      "AlternateTitle": "",
      "TitleArray": [
        "Bleu Shut"
      ],
      "Year": "1970",
      "Director": "Robert Nelson",
      "DirectorArray": [
        "Robert Nelson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "548",
      "databaseFilmTitle": "Blight",
      "FilmTitle": "Blight",
      "AlternateTitle": "",
      "TitleArray": [
        "Blight"
      ],
      "Year": "1996",
      "Director": "John Smith",
      "DirectorArray": [
        "John Smith"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "549",
      "databaseFilmTitle": "Blind Beast",
      "FilmTitle": "Blind Beast",
      "AlternateTitle": "Mōjū",
      "TitleArray": [
        "Blind Beast",
        "Mōjū"
      ],
      "Year": "1969",
      "Director": "Yasuzô Masumura",
      "DirectorArray": [
        "Yasuzô Masumura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "550",
      "databaseFilmTitle": "Blind Chance",
      "FilmTitle": "Blind Chance",
      "AlternateTitle": "Przypadek?",
      "TitleArray": [
        "Blind Chance",
        "Przypadek?"
      ],
      "Year": "1987",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "551",
      "databaseFilmTitle": "Blind Spot",
      "FilmTitle": "Blind Spot",
      "AlternateTitle": "Die Reise nach Lyon",
      "TitleArray": [
        "Blind Spot",
        "Die Reise nach Lyon"
      ],
      "Year": "1981",
      "Director": "Claudia von Alemann",
      "DirectorArray": [
        "Claudia von Alemann"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "552",
      "databaseFilmTitle": "Bliss",
      "FilmTitle": "Bliss",
      "AlternateTitle": "",
      "TitleArray": [
        "Bliss"
      ],
      "Year": "1967",
      "Director": "Gregory J. Markopoulos",
      "DirectorArray": [
        "Gregory J. Markopoulos"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "553",
      "databaseFilmTitle": "Blissfully Yours",
      "FilmTitle": "Blissfully Yours",
      "AlternateTitle": "Sud saneha",
      "TitleArray": [
        "Blissfully Yours",
        "Sud saneha"
      ],
      "Year": "2002",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand, France",
      "CountryArray": [
        "Thailand",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "554",
      "databaseFilmTitle": "Blithe Spirit",
      "FilmTitle": "Blithe Spirit",
      "AlternateTitle": "",
      "TitleArray": [
        "Blithe Spirit"
      ],
      "Year": "1945",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "555",
      "databaseFilmTitle": "Blonde Death",
      "FilmTitle": "Blonde Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Blonde Death"
      ],
      "Year": "1984",
      "Director": "James Robert Baker",
      "DirectorArray": [
        "James Robert Baker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "556",
      "databaseFilmTitle": "Blonde Venus",
      "FilmTitle": "Blonde Venus",
      "AlternateTitle": "",
      "TitleArray": [
        "Blonde Venus"
      ],
      "Year": "1932",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "557",
      "databaseFilmTitle": "Blood",
      "FilmTitle": "Blood",
      "AlternateTitle": "",
      "TitleArray": [
        "Blood"
      ],
      "Year": "2013",
      "Director": "Alina Rudnitskaya",
      "DirectorArray": [
        "Alina Rudnitskaya"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "558",
      "databaseFilmTitle": "Blood for Dracula",
      "FilmTitle": "Blood for Dracula",
      "AlternateTitle": "Sangue per Dracula",
      "TitleArray": [
        "Blood for Dracula",
        "Sangue per Dracula"
      ],
      "Year": "1974",
      "Director": "Paul Morrissey",
      "DirectorArray": [
        "Paul Morrissey"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "559",
      "databaseFilmTitle": "Blood in the Streets",
      "FilmTitle": "Blood in the Streets",
      "AlternateTitle": "Revolver",
      "TitleArray": [
        "Blood in the Streets",
        "Revolver"
      ],
      "Year": "1973",
      "Director": "Sergio Sollima",
      "DirectorArray": [
        "Sergio Sollima"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "560",
      "databaseFilmTitle": "Blood of My Blood",
      "FilmTitle": "Blood of My Blood",
      "AlternateTitle": "Sangue del mio sangue",
      "TitleArray": [
        "Blood of My Blood",
        "Sangue del mio sangue"
      ],
      "Year": "2015",
      "Director": "Marco Bellocchino",
      "DirectorArray": [
        "Marco Bellocchino"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "561",
      "databaseFilmTitle": "Blood of the Beasts",
      "FilmTitle": "Blood of the Beasts",
      "AlternateTitle": "Le Sang des bêtes",
      "TitleArray": [
        "Blood of the Beasts",
        "Le Sang des bêtes"
      ],
      "Year": "1949",
      "Director": "Georges Franju",
      "DirectorArray": [
        "Georges Franju"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "562",
      "databaseFilmTitle": "Blood of the Condor",
      "FilmTitle": "Blood of the Condor",
      "AlternateTitle": "Yawar Mallku",
      "TitleArray": [
        "Blood of the Condor",
        "Yawar Mallku"
      ],
      "Year": "1969",
      "Director": "Jorge Sanjinés",
      "DirectorArray": [
        "Jorge Sanjinés"
      ],
      "Country": "Bolivia",
      "CountryArray": [
        "Bolivia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "563",
      "databaseFilmTitle": "Blood Simple",
      "FilmTitle": "Blood Simple",
      "AlternateTitle": "",
      "TitleArray": [
        "Blood Simple"
      ],
      "Year": "1984",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "564",
      "databaseFilmTitle": "BloodSisters: Leather, Dykes and Sadomasochism",
      "FilmTitle": "BloodSisters: Leather, Dykes and Sadomasochism",
      "AlternateTitle": "",
      "TitleArray": [
        "BloodSisters: Leather, Dykes and Sadomasochism"
      ],
      "Year": "1995",
      "Director": "Michelle Handelman",
      "DirectorArray": [
        "Michelle Handelman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "565",
      "databaseFilmTitle": "Bloody Beans",
      "FilmTitle": "Bloody Beans",
      "AlternateTitle": "Loubia hamra",
      "TitleArray": [
        "Bloody Beans",
        "Loubia hamra"
      ],
      "Year": "2013",
      "Director": "Narimane Mari",
      "DirectorArray": [
        "Narimane Mari"
      ],
      "Country": "Algeria, France",
      "CountryArray": [
        "Algeria",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "566",
      "databaseFilmTitle": "Blow Job",
      "FilmTitle": "Blow Job",
      "AlternateTitle": "",
      "TitleArray": [
        "Blow Job"
      ],
      "Year": "1964",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "567",
      "databaseFilmTitle": "Blow Out",
      "FilmTitle": "Blow Out",
      "AlternateTitle": "",
      "TitleArray": [
        "Blow Out"
      ],
      "Year": "1981",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "568",
      "databaseFilmTitle": "Blow Up My Town",
      "FilmTitle": "Blow Up My Town",
      "AlternateTitle": "Saute ma ville",
      "TitleArray": [
        "Blow Up My Town",
        "Saute ma ville"
      ],
      "Year": "1968",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "569",
      "databaseFilmTitle": "Blow-Up",
      "FilmTitle": "Blow-Up",
      "AlternateTitle": "Blowup",
      "TitleArray": [
        "Blow-Up",
        "Blowup"
      ],
      "Year": "1966",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "570",
      "databaseFilmTitle": "Blue",
      "FilmTitle": "Blue",
      "AlternateTitle": "",
      "TitleArray": [
        "Blue"
      ],
      "Year": "1993",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "571",
      "databaseFilmTitle": "Blue Black Permanent",
      "FilmTitle": "Blue Black Permanent",
      "AlternateTitle": "",
      "TitleArray": [
        "Blue Black Permanent"
      ],
      "Year": "1992",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "572",
      "databaseFilmTitle": "Blue Collar",
      "FilmTitle": "Blue Collar",
      "AlternateTitle": "",
      "TitleArray": [
        "Blue Collar"
      ],
      "Year": "1978",
      "Director": "Paul Schrader",
      "DirectorArray": [
        "Paul Schrader"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "573",
      "databaseFilmTitle": "Blue Is the Warmest Color",
      "FilmTitle": "Blue Is the Warmest Color",
      "AlternateTitle": "La Vie d'Adèle – Chapitres 1 & 2",
      "TitleArray": [
        "Blue Is the Warmest Color",
        "La Vie d'Adèle – Chapitres 1 & 2"
      ],
      "Year": "2013",
      "Director": "Abdellatif Kechiche",
      "DirectorArray": [
        "Abdellatif Kechiche"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "574",
      "databaseFilmTitle": "Blue Velvet",
      "FilmTitle": "Blue Velvet",
      "AlternateTitle": "",
      "TitleArray": [
        "Blue Velvet"
      ],
      "Year": "1986",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "69",
      "2012votes": "23",
      "2022rank": "85",
      "2022votes": "34"
    },
    {
      "key": "575",
      "databaseFilmTitle": "Bluebeard's Eighth Wife",
      "FilmTitle": "Bluebeard's Eighth Wife",
      "AlternateTitle": "",
      "TitleArray": [
        "Bluebeard's Eighth Wife"
      ],
      "Year": "1938",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "576",
      "databaseFilmTitle": "Blues Under the Skin",
      "FilmTitle": "Blues Under the Skin",
      "AlternateTitle": "Le blues entre les dents",
      "TitleArray": [
        "Blues Under the Skin",
        "Le blues entre les dents"
      ],
      "Year": "1973",
      "Director": "Roviros Manthoulis",
      "DirectorArray": [
        "Roviros Manthoulis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "577",
      "databaseFilmTitle": "Bo Burnham: Inside",
      "FilmTitle": "Bo Burnham: Inside",
      "AlternateTitle": "",
      "TitleArray": [
        "Bo Burnham: Inside"
      ],
      "Year": "2021",
      "Director": "Bo Buhrnham",
      "DirectorArray": [
        "Bo Buhrnham"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "578",
      "databaseFilmTitle": "Boardinghouse",
      "FilmTitle": "Boardinghouse",
      "AlternateTitle": "",
      "TitleArray": [
        "Boardinghouse"
      ],
      "Year": "1982",
      "Director": "John Wintergate",
      "DirectorArray": [
        "John Wintergate"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "579",
      "databaseFilmTitle": "Boat Leaving the Port",
      "FilmTitle": "Boat Leaving the Port",
      "AlternateTitle": "Barque sortant du port",
      "TitleArray": [
        "Boat Leaving the Port",
        "Barque sortant du port"
      ],
      "Year": "1985",
      "Director": "Louis Lumière",
      "DirectorArray": [
        "Louis Lumière"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "580",
      "databaseFilmTitle": "Bob le flambeur",
      "FilmTitle": "Bob le flambeur",
      "AlternateTitle": "",
      "TitleArray": [
        "Bob le flambeur"
      ],
      "Year": "1956",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "581",
      "databaseFilmTitle": "Body and Soul",
      "FilmTitle": "Body and Soul",
      "AlternateTitle": "",
      "TitleArray": [
        "Body and Soul"
      ],
      "Year": "1925",
      "Director": "Oscar Micheaux",
      "DirectorArray": [
        "Oscar Micheaux"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "582",
      "databaseFilmTitle": "Body Double",
      "FilmTitle": "Body Double",
      "AlternateTitle": "",
      "TitleArray": [
        "Body Double"
      ],
      "Year": "1984",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "583",
      "databaseFilmTitle": "Body Heat",
      "FilmTitle": "Body Heat",
      "AlternateTitle": "",
      "TitleArray": [
        "Body Heat"
      ],
      "Year": "1981",
      "Director": "Lawrence Kasdan",
      "DirectorArray": [
        "Lawrence Kasdan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "584",
      "databaseFilmTitle": "Bolívar, a Tropical Symphony",
      "FilmTitle": "Bolívar, a Tropical Symphony",
      "AlternateTitle": "Bolívar, sinfonía tropikal",
      "TitleArray": [
        "Bolívar, a Tropical Symphony",
        "Bolívar, sinfonía tropikal"
      ],
      "Year": "1979",
      "Director": "Diego Rísquez",
      "DirectorArray": [
        "Diego Rísquez"
      ],
      "Country": "Venezuela",
      "CountryArray": [
        "Venezuela"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "585",
      "databaseFilmTitle": "Bombay",
      "FilmTitle": "Bombay",
      "AlternateTitle": "Bumbai",
      "TitleArray": [
        "Bombay",
        "Bumbai"
      ],
      "Year": "1995",
      "Director": "Mani Ratnam",
      "DirectorArray": [
        "Mani Ratnam"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "586",
      "databaseFilmTitle": "Bonjour tristesse",
      "FilmTitle": "Bonjour tristesse",
      "AlternateTitle": "",
      "TitleArray": [
        "Bonjour tristesse"
      ],
      "Year": "1958",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "587",
      "databaseFilmTitle": "Bonnie and Clyde",
      "FilmTitle": "Bonnie and Clyde",
      "AlternateTitle": "",
      "TitleArray": [
        "Bonnie and Clyde"
      ],
      "Year": "1967",
      "Director": "Arthur Penn",
      "DirectorArray": [
        "Arthur Penn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "588",
      "databaseFilmTitle": "Boogie Nights",
      "FilmTitle": "Boogie Nights",
      "AlternateTitle": "",
      "TitleArray": [
        "Boogie Nights"
      ],
      "Year": "1997",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "589",
      "databaseFilmTitle": "Booksmart",
      "FilmTitle": "Booksmart",
      "AlternateTitle": "",
      "TitleArray": [
        "Booksmart"
      ],
      "Year": "2019",
      "Director": "Olivia Wilde",
      "DirectorArray": [
        "Olivia Wilde"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "590",
      "databaseFilmTitle": "Boomerang",
      "FilmTitle": "Boomerang",
      "AlternateTitle": "",
      "TitleArray": [
        "Boomerang"
      ],
      "Year": "1992",
      "Director": "Reginald Hudlin",
      "DirectorArray": [
        "Reginald Hudlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "591",
      "databaseFilmTitle": "Borat",
      "FilmTitle": "Borat",
      "AlternateTitle": "Borat: Cultural Learnings of America for Make Benefit Glorious Nation of Kazakhstan",
      "TitleArray": [
        "Borat",
        "Borat: Cultural Learnings of America for Make Benefit Glorious Nation of Kazakhstan"
      ],
      "Year": "2006",
      "Director": "Larry Charles",
      "DirectorArray": [
        "Larry Charles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "592",
      "databaseFilmTitle": "Borderline",
      "FilmTitle": "Borderline",
      "AlternateTitle": "",
      "TitleArray": [
        "Borderline"
      ],
      "Year": "1930",
      "Director": "Kenneth Macpherson",
      "DirectorArray": [
        "Kenneth Macpherson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "593",
      "databaseFilmTitle": "Born in Flames",
      "FilmTitle": "Born in Flames",
      "AlternateTitle": "",
      "TitleArray": [
        "Born in Flames"
      ],
      "Year": "1983",
      "Director": "Lizzie Borden",
      "DirectorArray": [
        "Lizzie Borden"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "594",
      "databaseFilmTitle": "Born on the Fourth of July",
      "FilmTitle": "Born on the Fourth of July",
      "AlternateTitle": "",
      "TitleArray": [
        "Born on the Fourth of July"
      ],
      "Year": "1989",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "595",
      "databaseFilmTitle": "Boudu Saved from Drowning",
      "FilmTitle": "Boudu Saved from Drowning",
      "AlternateTitle": "Boudu sauvé des eaux",
      "TitleArray": [
        "Boudu Saved from Drowning",
        "Boudu sauvé des eaux"
      ],
      "Year": "1932",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "596",
      "databaseFilmTitle": "Bound",
      "FilmTitle": "Bound",
      "AlternateTitle": "",
      "TitleArray": [
        "Bound"
      ],
      "Year": "1996",
      "Director": "Lilly Wachowski, Lana Wachowski",
      "DirectorArray": [
        "Lilly Wachowski",
        "Lana Wachowski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "597",
      "databaseFilmTitle": "Bouquets 1-10",
      "FilmTitle": "Bouquets 1-10",
      "AlternateTitle": "",
      "TitleArray": [
        "Bouquets 1-10"
      ],
      "Year": "1994",
      "Director": "Rose Lowder",
      "DirectorArray": [
        "Rose Lowder"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "598",
      "databaseFilmTitle": "Boy",
      "FilmTitle": "Boy",
      "AlternateTitle": "Shōnen",
      "TitleArray": [
        "Boy",
        "Shōnen"
      ],
      "Year": "1969",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "599",
      "databaseFilmTitle": "Boy and the World",
      "FilmTitle": "Boy and the World",
      "AlternateTitle": "O Menino e o Mundo",
      "TitleArray": [
        "Boy and the World",
        "O Menino e o Mundo"
      ],
      "Year": "2013",
      "Director": "Alê Abreu",
      "DirectorArray": [
        "Alê Abreu"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "600",
      "databaseFilmTitle": "Boyhood",
      "FilmTitle": "Boyhood",
      "AlternateTitle": "",
      "TitleArray": [
        "Boyhood"
      ],
      "Year": "2014",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "601",
      "databaseFilmTitle": "Boys Don't Cry",
      "FilmTitle": "Boys Don't Cry",
      "AlternateTitle": "",
      "TitleArray": [
        "Boys Don't Cry"
      ],
      "Year": "1999",
      "Director": "Kimberly Pierce",
      "DirectorArray": [
        "Kimberly Pierce"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "602",
      "databaseFilmTitle": "Boyz n the Hood",
      "FilmTitle": "Boyz n the Hood",
      "AlternateTitle": "",
      "TitleArray": [
        "Boyz n the Hood"
      ],
      "Year": "1991",
      "Director": "John Singleton",
      "DirectorArray": [
        "John Singleton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "603",
      "databaseFilmTitle": "BPM (Beats Per Minute)",
      "FilmTitle": "BPM (Beats Per Minute)",
      "AlternateTitle": "120 battements par minute",
      "TitleArray": [
        "BPM (Beats Per Minute)",
        "120 battements par minute"
      ],
      "Year": "2017",
      "Director": "Robin Campillo",
      "DirectorArray": [
        "Robin Campillo"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "604",
      "databaseFilmTitle": "Brainstorm",
      "FilmTitle": "Brainstorm",
      "AlternateTitle": "",
      "TitleArray": [
        "Brainstorm"
      ],
      "Year": "1965",
      "Director": "William Conrad",
      "DirectorArray": [
        "William Conrad"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "605",
      "databaseFilmTitle": "Bram Stoker's Dracula",
      "FilmTitle": "Bram Stoker's Dracula",
      "AlternateTitle": "Dracula",
      "TitleArray": [
        "Bram Stoker's Dracula",
        "Dracula"
      ],
      "Year": "1992",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "606",
      "databaseFilmTitle": "Branded to Kill",
      "FilmTitle": "Branded to Kill",
      "AlternateTitle": "Koroshi no rakuin",
      "TitleArray": [
        "Branded to Kill",
        "Koroshi no rakuin"
      ],
      "Year": "1967",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "607",
      "databaseFilmTitle": "Brazil",
      "FilmTitle": "Brazil",
      "AlternateTitle": "",
      "TitleArray": [
        "Brazil"
      ],
      "Year": "1985",
      "Director": "Terry Gilliam",
      "DirectorArray": [
        "Terry Gilliam"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "608",
      "databaseFilmTitle": "Bread Day",
      "FilmTitle": "Bread Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Bread Day"
      ],
      "Year": "1998",
      "Director": "Sergei Dvortsevoy",
      "DirectorArray": [
        "Sergei Dvortsevoy"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "609",
      "databaseFilmTitle": "Breakaway",
      "FilmTitle": "Breakaway",
      "AlternateTitle": "",
      "TitleArray": [
        "Breakaway"
      ],
      "Year": "1966",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "610",
      "databaseFilmTitle": "Breakdown",
      "FilmTitle": "Breakdown",
      "AlternateTitle": "",
      "TitleArray": [
        "Breakdown"
      ],
      "Year": "1997",
      "Director": "Jonathan Mostow",
      "DirectorArray": [
        "Jonathan Mostow"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "611",
      "databaseFilmTitle": "Breaker Morant",
      "FilmTitle": "Breaker Morant",
      "AlternateTitle": "",
      "TitleArray": [
        "Breaker Morant"
      ],
      "Year": "1980",
      "Director": "Bruce Beresford",
      "DirectorArray": [
        "Bruce Beresford"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "612",
      "databaseFilmTitle": "Breakfast (Table Top Dolly)",
      "FilmTitle": "Breakfast (Table Top Dolly)",
      "AlternateTitle": "",
      "TitleArray": [
        "Breakfast (Table Top Dolly)"
      ],
      "Year": "1976",
      "Director": "Michael Snow",
      "DirectorArray": [
        "Michael Snow"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "613",
      "databaseFilmTitle": "Breakfast at Tiffany's",
      "FilmTitle": "Breakfast at Tiffany's",
      "AlternateTitle": "",
      "TitleArray": [
        "Breakfast at Tiffany's"
      ],
      "Year": "1961",
      "Director": "Blake Edwards",
      "DirectorArray": [
        "Blake Edwards"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "614",
      "databaseFilmTitle": "Breakfast on the grass",
      "FilmTitle": "Breakfast on the grass",
      "AlternateTitle": "Eine murul",
      "TitleArray": [
        "Breakfast on the grass",
        "Eine murul"
      ],
      "Year": "1987",
      "Director": "Priit Pärn",
      "DirectorArray": [
        "Priit Pärn"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "615",
      "databaseFilmTitle": "Breakin'",
      "FilmTitle": "Breakin'",
      "AlternateTitle": "",
      "TitleArray": [
        "Breakin'"
      ],
      "Year": "1984",
      "Director": "Joel Silberg",
      "DirectorArray": [
        "Joel Silberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "616",
      "databaseFilmTitle": "Breaking the Waves",
      "FilmTitle": "Breaking the Waves",
      "AlternateTitle": "",
      "TitleArray": [
        "Breaking the Waves"
      ],
      "Year": "1996",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "617",
      "databaseFilmTitle": "Breathless",
      "FilmTitle": "Breathless",
      "AlternateTitle": "À bout de souffle",
      "TitleArray": [
        "Breathless",
        "À bout de souffle"
      ],
      "Year": "1960",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "16",
      "2002votes": "11",
      "2012rank": "13",
      "2012votes": "57",
      "2022rank": "38",
      "2022votes": "53"
    },
    {
      "key": "618",
      "databaseFilmTitle": "Bride of Frankenstein",
      "FilmTitle": "Bride of Frankenstein",
      "AlternateTitle": "",
      "TitleArray": [
        "Bride of Frankenstein"
      ],
      "Year": "1935",
      "Director": "James Whale",
      "DirectorArray": [
        "James Whale"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "619",
      "databaseFilmTitle": "Bridges-Go-Round",
      "FilmTitle": "Bridges-Go-Round",
      "AlternateTitle": "",
      "TitleArray": [
        "Bridges-Go-Round"
      ],
      "Year": "1958",
      "Director": "Shirley Clarke",
      "DirectorArray": [
        "Shirley Clarke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "620",
      "databaseFilmTitle": "Brief Encounter",
      "FilmTitle": "Brief Encounter",
      "AlternateTitle": "",
      "TitleArray": [
        "Brief Encounter"
      ],
      "Year": "1945",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "10",
      "1952votes": "10",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "621",
      "databaseFilmTitle": "Brief Encounters",
      "FilmTitle": "Brief Encounters",
      "AlternateTitle": "",
      "TitleArray": [
        "Brief Encounters"
      ],
      "Year": "1967",
      "Director": "Kira Muratova",
      "DirectorArray": [
        "Kira Muratova"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "622",
      "databaseFilmTitle": "Brigadoon",
      "FilmTitle": "Brigadoon",
      "AlternateTitle": "",
      "TitleArray": [
        "Brigadoon"
      ],
      "Year": "1954",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "623",
      "databaseFilmTitle": "Bright Future",
      "FilmTitle": "Bright Future",
      "AlternateTitle": "Akarui Mirai",
      "TitleArray": [
        "Bright Future",
        "Akarui Mirai"
      ],
      "Year": "2002",
      "Director": "Kiyoshi Kurosawa",
      "DirectorArray": [
        "Kiyoshi Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "624",
      "databaseFilmTitle": "Bright Star",
      "FilmTitle": "Bright Star",
      "AlternateTitle": "",
      "TitleArray": [
        "Bright Star"
      ],
      "Year": "2009",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "United Kingdom, Australia",
      "CountryArray": [
        "United Kingdom",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "625",
      "databaseFilmTitle": "Bring Me the Head of Alfredo Garcia",
      "FilmTitle": "Bring Me the Head of Alfredo Garcia",
      "AlternateTitle": "",
      "TitleArray": [
        "Bring Me the Head of Alfredo Garcia"
      ],
      "Year": "1974",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States, Mexico",
      "CountryArray": [
        "United States",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "626",
      "databaseFilmTitle": "Bringing Up Baby",
      "FilmTitle": "Bringing Up Baby",
      "AlternateTitle": "",
      "TitleArray": [
        "Bringing Up Baby"
      ],
      "Year": "1938",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "627",
      "databaseFilmTitle": "Britannia Hospital",
      "FilmTitle": "Britannia Hospital",
      "AlternateTitle": "",
      "TitleArray": [
        "Britannia Hospital"
      ],
      "Year": "1982",
      "Director": "Lindsay Anderson",
      "DirectorArray": [
        "Lindsay Anderson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "628",
      "databaseFilmTitle": "British Sounds",
      "FilmTitle": "British Sounds",
      "AlternateTitle": "",
      "TitleArray": [
        "British Sounds"
      ],
      "Year": "1969",
      "Director": "Groupe Dziga Vertov, Jean-Luc Godard, Jean-Henri Roger",
      "DirectorArray": [
        "Groupe Dziga Vertov",
        "Jean-Luc Godard",
        "Jean-Henri Roger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "629",
      "databaseFilmTitle": "Broadcast News",
      "FilmTitle": "Broadcast News",
      "AlternateTitle": "",
      "TitleArray": [
        "Broadcast News"
      ],
      "Year": "1987",
      "Director": "James L. Brooks",
      "DirectorArray": [
        "James L. Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "630",
      "databaseFilmTitle": "Brokeback Mountain",
      "FilmTitle": "Brokeback Mountain",
      "AlternateTitle": "",
      "TitleArray": [
        "Brokeback Mountain"
      ],
      "Year": "2005",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "United States, Canada",
      "CountryArray": [
        "United States",
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "631",
      "databaseFilmTitle": "Broken Blossoms",
      "FilmTitle": "Broken Blossoms",
      "AlternateTitle": "Broken Blossoms or the Yellow Man and the Girl",
      "TitleArray": [
        "Broken Blossoms",
        "Broken Blossoms or the Yellow Man and the Girl"
      ],
      "Year": "1919",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "21",
      "1952votes": "6",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "632",
      "databaseFilmTitle": "Broken Embraces",
      "FilmTitle": "Broken Embraces",
      "AlternateTitle": "Los abrazos rotos",
      "TitleArray": [
        "Broken Embraces",
        "Los abrazos rotos"
      ],
      "Year": "2009",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "633",
      "databaseFilmTitle": "Broken Lullaby",
      "FilmTitle": "Broken Lullaby",
      "AlternateTitle": "",
      "TitleArray": [
        "Broken Lullaby"
      ],
      "Year": "1932",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "634",
      "databaseFilmTitle": "Bronco Bullfrog",
      "FilmTitle": "Bronco Bullfrog",
      "AlternateTitle": "",
      "TitleArray": [
        "Bronco Bullfrog"
      ],
      "Year": "1970",
      "Director": "Barney Platts-Mills",
      "DirectorArray": [
        "Barney Platts-Mills"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "635",
      "databaseFilmTitle": "Brother",
      "FilmTitle": "Brother",
      "AlternateTitle": "",
      "TitleArray": [
        "Brother"
      ],
      "Year": "1991",
      "Director": "Bakhtyar Khudojnazarov",
      "DirectorArray": [
        "Bakhtyar Khudojnazarov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "636",
      "databaseFilmTitle": "Bruxelles-transit",
      "FilmTitle": "Bruxelles-transit",
      "AlternateTitle": "",
      "TitleArray": [
        "Bruxelles-transit"
      ],
      "Year": "1980",
      "Director": "Samy Szlingerbaum",
      "DirectorArray": [
        "Samy Szlingerbaum"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "637",
      "databaseFilmTitle": "Buddha Collapsed Out of Shame",
      "FilmTitle": "Buddha Collapsed Out of Shame",
      "AlternateTitle": "Buda as sharm foru rikht",
      "TitleArray": [
        "Buddha Collapsed Out of Shame",
        "Buda as sharm foru rikht"
      ],
      "Year": "2007",
      "Director": "Hana Makhmalbaf",
      "DirectorArray": [
        "Hana Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "638",
      "databaseFilmTitle": "Buffalo '66",
      "FilmTitle": "Buffalo '66",
      "AlternateTitle": "",
      "TitleArray": [
        "Buffalo '66"
      ],
      "Year": "1998",
      "Director": "Vincent Gallo",
      "DirectorArray": [
        "Vincent Gallo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "639",
      "databaseFilmTitle": "Buffalo Bill in 27 forms",
      "FilmTitle": "Buffalo Bill in 27 forms",
      "AlternateTitle": "",
      "TitleArray": [
        "Buffalo Bill in 27 forms"
      ],
      "Year": "1957",
      "Director": "Carl Fredrik Reuterswärd",
      "DirectorArray": [
        "Carl Fredrik Reuterswärd"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "640",
      "databaseFilmTitle": "Building the New Tyne Bridge",
      "FilmTitle": "Building the New Tyne Bridge",
      "AlternateTitle": "",
      "TitleArray": [
        "Building the New Tyne Bridge"
      ],
      "Year": "1928",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "641",
      "databaseFilmTitle": "Bulbbul",
      "FilmTitle": "Bulbbul",
      "AlternateTitle": "",
      "TitleArray": [
        "Bulbbul"
      ],
      "Year": "2020",
      "Director": "Anvita Duff",
      "DirectorArray": [
        "Anvita Duff"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "642",
      "databaseFilmTitle": "Bullet in the Head",
      "FilmTitle": "Bullet in the Head",
      "AlternateTitle": "Dip huet gai tau",
      "TitleArray": [
        "Bullet in the Head",
        "Dip huet gai tau"
      ],
      "Year": "1990",
      "Director": "John Woo",
      "DirectorArray": [
        "John Woo"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "643",
      "databaseFilmTitle": "Bunny Lake Is Missing",
      "FilmTitle": "Bunny Lake Is Missing",
      "AlternateTitle": "",
      "TitleArray": [
        "Bunny Lake Is Missing"
      ],
      "Year": "1965",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "644",
      "databaseFilmTitle": "Burn!",
      "FilmTitle": "Burn!",
      "AlternateTitle": "Queimada",
      "TitleArray": [
        "Burn!",
        "Queimada"
      ],
      "Year": "1969",
      "Director": "Gillo Pontecorvo",
      "DirectorArray": [
        "Gillo Pontecorvo"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "645",
      "databaseFilmTitle": "Burnham Beeches",
      "FilmTitle": "Burnham Beeches",
      "AlternateTitle": "",
      "TitleArray": [
        "Burnham Beeches"
      ],
      "Year": "1909",
      "Director": "Gaston Quiribet",
      "DirectorArray": [
        "Gaston Quiribet"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "646",
      "databaseFilmTitle": "Burning",
      "FilmTitle": "Burning",
      "AlternateTitle": "",
      "TitleArray": [
        "Burning"
      ],
      "Year": "2018",
      "Director": "Lee Chang-dong",
      "DirectorArray": [
        "Lee Chang-dong"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "647",
      "databaseFilmTitle": "Burning an Illusion",
      "FilmTitle": "Burning an Illusion",
      "AlternateTitle": "",
      "TitleArray": [
        "Burning an Illusion"
      ],
      "Year": "1981",
      "Director": "Menelik Shabazz",
      "DirectorArray": [
        "Menelik Shabazz"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "648",
      "databaseFilmTitle": "Burning Days",
      "FilmTitle": "Burning Days",
      "AlternateTitle": "Kurak Günler",
      "TitleArray": [
        "Burning Days",
        "Kurak Günler"
      ],
      "Year": "2022",
      "Director": "Emin Alper",
      "DirectorArray": [
        "Emin Alper"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "649",
      "databaseFilmTitle": "Burnt by the Sun",
      "FilmTitle": "Burnt by the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Burnt by the Sun"
      ],
      "Year": "1994",
      "Director": "Nikita Mikhalkov",
      "DirectorArray": [
        "Nikita Mikhalkov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "650",
      "databaseFilmTitle": "But I'm a Cheerleader",
      "FilmTitle": "But I'm a Cheerleader",
      "AlternateTitle": "",
      "TitleArray": [
        "But I'm a Cheerleader"
      ],
      "Year": "1999",
      "Director": "Jamie Babbit",
      "DirectorArray": [
        "Jamie Babbit"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "651",
      "databaseFilmTitle": "Butch Cassidy and the Sundance Kid",
      "FilmTitle": "Butch Cassidy and the Sundance Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "Butch Cassidy and the Sundance Kid"
      ],
      "Year": "1969",
      "Director": "George Roy Hill",
      "DirectorArray": [
        "George Roy Hill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "652",
      "databaseFilmTitle": "Butterflies and Flowers",
      "FilmTitle": "Butterflies and Flowers",
      "AlternateTitle": "Peesua lae dokmai",
      "TitleArray": [
        "Butterflies and Flowers",
        "Peesua lae dokmai"
      ],
      "Year": "1986",
      "Director": "Euthana Mukdasanit",
      "DirectorArray": [
        "Euthana Mukdasanit"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "653",
      "databaseFilmTitle": "Buud Yam",
      "FilmTitle": "Buud Yam",
      "AlternateTitle": "",
      "TitleArray": [
        "Buud Yam"
      ],
      "Year": "1997",
      "Director": "Gaston Kaboré",
      "DirectorArray": [
        "Gaston Kaboré"
      ],
      "Country": "Burkina Faso",
      "CountryArray": [
        "Burkina Faso"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "654",
      "databaseFilmTitle": "By Hook or by Crook",
      "FilmTitle": "By Hook or by Crook",
      "AlternateTitle": "",
      "TitleArray": [
        "By Hook or by Crook"
      ],
      "Year": "2001",
      "Director": "Harry Dodge, Silas Howard",
      "DirectorArray": [
        "Harry Dodge",
        "Silas Howard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "655",
      "databaseFilmTitle": "By the Bluest of Seas",
      "FilmTitle": "By the Bluest of Seas",
      "AlternateTitle": "",
      "TitleArray": [
        "By the Bluest of Seas"
      ],
      "Year": "1936",
      "Director": "Boris Barnet",
      "DirectorArray": [
        "Boris Barnet"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "656",
      "databaseFilmTitle": "By The Law",
      "FilmTitle": "By The Law",
      "AlternateTitle": "Po Zakonu",
      "TitleArray": [
        "By The Law",
        "Po Zakonu"
      ],
      "Year": "1926",
      "Director": "Lev Kuleshov",
      "DirectorArray": [
        "Lev Kuleshov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "657",
      "databaseFilmTitle": "By the Time It Gets Dark",
      "FilmTitle": "By the Time It Gets Dark",
      "AlternateTitle": "Dao Khanong",
      "TitleArray": [
        "By the Time It Gets Dark",
        "Dao Khanong"
      ],
      "Year": "2016",
      "Director": "Anocha Suwichakornpong",
      "DirectorArray": [
        "Anocha Suwichakornpong"
      ],
      "Country": "Thailand, Netherlands",
      "CountryArray": [
        "Thailand",
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "658",
      "databaseFilmTitle": "C'est l'aviron",
      "FilmTitle": "C'est l'aviron",
      "AlternateTitle": "",
      "TitleArray": [
        "C'est l'aviron"
      ],
      "Year": "1944",
      "Director": "Norman McLaren",
      "DirectorArray": [
        "Norman McLaren"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "659",
      "databaseFilmTitle": "Cabaret",
      "FilmTitle": "Cabaret",
      "AlternateTitle": "",
      "TitleArray": [
        "Cabaret"
      ],
      "Year": "1972",
      "Director": "Bob Fosse",
      "DirectorArray": [
        "Bob Fosse"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "660",
      "databaseFilmTitle": "Cabeza de Vaca",
      "FilmTitle": "Cabeza de Vaca",
      "AlternateTitle": "",
      "TitleArray": [
        "Cabeza de Vaca"
      ],
      "Year": "1991",
      "Director": "Nicolás Echevarría",
      "DirectorArray": [
        "Nicolás Echevarría"
      ],
      "Country": "Spain, United States",
      "CountryArray": [
        "Spain",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "661",
      "databaseFilmTitle": "Cabiria",
      "FilmTitle": "Cabiria",
      "AlternateTitle": "",
      "TitleArray": [
        "Cabiria"
      ],
      "Year": "1914",
      "Director": "Giovanni Pastrone",
      "DirectorArray": [
        "Giovanni Pastrone"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "662",
      "databaseFilmTitle": "Café Lumière",
      "FilmTitle": "Café Lumière",
      "AlternateTitle": "Kōhī Jikō",
      "TitleArray": [
        "Café Lumière",
        "Kōhī Jikō"
      ],
      "Year": "2003",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Japan, Taiwan",
      "CountryArray": [
        "Japan",
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "663",
      "databaseFilmTitle": "Cairo Station",
      "FilmTitle": "Cairo Station",
      "AlternateTitle": "Bab El Hadid",
      "TitleArray": [
        "Cairo Station",
        "Bab El Hadid"
      ],
      "Year": "1958",
      "Director": "Youssef Chahine",
      "DirectorArray": [
        "Youssef Chahine"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "664",
      "databaseFilmTitle": "Calamity Jane & Delphine Seyrig, a Story",
      "FilmTitle": "Calamity Jane & Delphine Seyrig, a Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Calamity Jane & Delphine Seyrig, a Story"
      ],
      "Year": "2020",
      "Director": "Babette Mangolte",
      "DirectorArray": [
        "Babette Mangolte"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "665",
      "databaseFilmTitle": "Calendar",
      "FilmTitle": "Calendar",
      "AlternateTitle": "",
      "TitleArray": [
        "Calendar"
      ],
      "Year": "1993",
      "Director": "Atom Egoyan",
      "DirectorArray": [
        "Atom Egoyan"
      ],
      "Country": "Germany, Armenia",
      "CountryArray": [
        "Germany",
        "Armenia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "666",
      "databaseFilmTitle": "California Split",
      "FilmTitle": "California Split",
      "AlternateTitle": "",
      "TitleArray": [
        "California Split"
      ],
      "Year": "1974",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "667",
      "databaseFilmTitle": "Call Me by Your Name",
      "FilmTitle": "Call Me by Your Name",
      "AlternateTitle": "",
      "TitleArray": [
        "Call Me by Your Name"
      ],
      "Year": "2017",
      "Director": "Luca Guadagnino",
      "DirectorArray": [
        "Luca Guadagnino"
      ],
      "Country": "Italy, United States",
      "CountryArray": [
        "Italy",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "668",
      "databaseFilmTitle": "Camera Buff",
      "FilmTitle": "Camera Buff",
      "AlternateTitle": "Amator",
      "TitleArray": [
        "Camera Buff",
        "Amator"
      ],
      "Year": "1979",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "669",
      "databaseFilmTitle": "Cameraperson",
      "FilmTitle": "Cameraperson",
      "AlternateTitle": "",
      "TitleArray": [
        "Cameraperson"
      ],
      "Year": "2016",
      "Director": "Kirsten Johnsom",
      "DirectorArray": [
        "Kirsten Johnsom"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "670",
      "databaseFilmTitle": "Camille",
      "FilmTitle": "Camille",
      "AlternateTitle": "",
      "TitleArray": [
        "Camille"
      ],
      "Year": "1936",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "671",
      "databaseFilmTitle": "Camouflage",
      "FilmTitle": "Camouflage",
      "AlternateTitle": "Barwy ochronne",
      "TitleArray": [
        "Camouflage",
        "Barwy ochronne"
      ],
      "Year": "1977",
      "Director": "Krzysztof Zanussi",
      "DirectorArray": [
        "Krzysztof Zanussi"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "672",
      "databaseFilmTitle": "Camp de Thiaroye",
      "FilmTitle": "Camp de Thiaroye",
      "AlternateTitle": "",
      "TitleArray": [
        "Camp de Thiaroye"
      ],
      "Year": "1987",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal, Algeria",
      "CountryArray": [
        "Senegal",
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "673",
      "databaseFilmTitle": "Candyman",
      "FilmTitle": "Candyman",
      "AlternateTitle": "",
      "TitleArray": [
        "Candyman"
      ],
      "Year": "1992",
      "Director": "Bernard Rose",
      "DirectorArray": [
        "Bernard Rose"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "674",
      "databaseFilmTitle": "Cannibal Holocaust",
      "FilmTitle": "Cannibal Holocaust",
      "AlternateTitle": "",
      "TitleArray": [
        "Cannibal Holocaust"
      ],
      "Year": "1980",
      "Director": "Ruggero Deodato",
      "DirectorArray": [
        "Ruggero Deodato"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "675",
      "databaseFilmTitle": "Canoa",
      "FilmTitle": "Canoa",
      "AlternateTitle": "",
      "TitleArray": [
        "Canoa"
      ],
      "Year": "1976",
      "Director": "Felipe Cazals",
      "DirectorArray": [
        "Felipe Cazals"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "676",
      "databaseFilmTitle": "Canyon Passage",
      "FilmTitle": "Canyon Passage",
      "AlternateTitle": "",
      "TitleArray": [
        "Canyon Passage"
      ],
      "Year": "1946",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "677",
      "databaseFilmTitle": "Capernaum",
      "FilmTitle": "Capernaum",
      "AlternateTitle": "Capernaüm",
      "TitleArray": [
        "Capernaum",
        "Capernaüm"
      ],
      "Year": "2018",
      "Director": "Nadine Labaki",
      "DirectorArray": [
        "Nadine Labaki"
      ],
      "Country": "Lebanon, France",
      "CountryArray": [
        "Lebanon",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "678",
      "databaseFilmTitle": "Capitalism: Slavery",
      "FilmTitle": "Capitalism: Slavery",
      "AlternateTitle": "",
      "TitleArray": [
        "Capitalism: Slavery"
      ],
      "Year": "2007",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "679",
      "databaseFilmTitle": "Caprice Italian Style",
      "FilmTitle": "Caprice Italian Style",
      "AlternateTitle": "Capriccio all'italiana",
      "TitleArray": [
        "Caprice Italian Style",
        "Capriccio all'italiana"
      ],
      "Year": "1968",
      "Director": "Mauro Bolognini, Mario Monicelli, Pier Paolo Pasolini, Steno, Pino Zac, Franco Rossi",
      "DirectorArray": [
        "Mauro Bolognini",
        "Mario Monicelli",
        "Pier Paolo Pasolini",
        "Steno",
        "Pino Zac",
        "Franco Rossi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "680",
      "databaseFilmTitle": "Captain Blood",
      "FilmTitle": "Captain Blood",
      "AlternateTitle": "",
      "TitleArray": [
        "Captain Blood"
      ],
      "Year": "1935",
      "Director": "Michael Curtiz",
      "DirectorArray": [
        "Michael Curtiz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "681",
      "databaseFilmTitle": "Captain Fracasse",
      "FilmTitle": "Captain Fracasse",
      "AlternateTitle": "Le capitaine Fracasse",
      "TitleArray": [
        "Captain Fracasse",
        "Le capitaine Fracasse"
      ],
      "Year": "1943",
      "Director": "Abel Gance",
      "DirectorArray": [
        "Abel Gance"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "682",
      "databaseFilmTitle": "Captain Volkonogov Escaped",
      "FilmTitle": "Captain Volkonogov Escaped",
      "AlternateTitle": "",
      "TitleArray": [
        "Captain Volkonogov Escaped"
      ],
      "Year": "2021",
      "Director": "Natalya Merkulova, Aleksey Chupov",
      "DirectorArray": [
        "Natalya Merkulova",
        "Aleksey Chupov"
      ],
      "Country": "Russia, Estonia",
      "CountryArray": [
        "Russia",
        "Estonia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "683",
      "databaseFilmTitle": "Caravaggio",
      "FilmTitle": "Caravaggio",
      "AlternateTitle": "",
      "TitleArray": [
        "Caravaggio"
      ],
      "Year": "1986",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "684",
      "databaseFilmTitle": "Careful",
      "FilmTitle": "Careful",
      "AlternateTitle": "",
      "TitleArray": [
        "Careful"
      ],
      "Year": "1992",
      "Director": "Guy Maddin",
      "DirectorArray": [
        "Guy Maddin"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "685",
      "databaseFilmTitle": "Cargo 200",
      "FilmTitle": "Cargo 200",
      "AlternateTitle": "",
      "TitleArray": [
        "Cargo 200"
      ],
      "Year": "2007",
      "Director": "Aleksey Balabanov",
      "DirectorArray": [
        "Aleksey Balabanov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "686",
      "databaseFilmTitle": "Caribs' Leap/Western Deep",
      "FilmTitle": "Caribs' Leap/Western Deep",
      "AlternateTitle": "",
      "TitleArray": [
        "Caribs' Leap/Western Deep"
      ],
      "Year": "2002",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "687",
      "databaseFilmTitle": "Carlito's Way",
      "FilmTitle": "Carlito's Way",
      "AlternateTitle": "",
      "TitleArray": [
        "Carlito's Way"
      ],
      "Year": "1993",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "688",
      "databaseFilmTitle": "Carlos",
      "FilmTitle": "Carlos",
      "AlternateTitle": "",
      "TitleArray": [
        "Carlos"
      ],
      "Year": "2010",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "689",
      "databaseFilmTitle": "Carmen",
      "FilmTitle": "Carmen",
      "AlternateTitle": "",
      "TitleArray": [
        "Carmen"
      ],
      "Year": "1915",
      "Director": "Cecil B. DeMille",
      "DirectorArray": [
        "Cecil B. DeMille"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "690",
      "databaseFilmTitle": "Carnival in Flanders",
      "FilmTitle": "Carnival in Flanders",
      "AlternateTitle": "La Kermesse héroïque",
      "TitleArray": [
        "Carnival in Flanders",
        "La Kermesse héroïque"
      ],
      "Year": "1935",
      "Director": "Jacques Feyder",
      "DirectorArray": [
        "Jacques Feyder"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "691",
      "databaseFilmTitle": "Carnival of Souls",
      "FilmTitle": "Carnival of Souls",
      "AlternateTitle": "",
      "TitleArray": [
        "Carnival of Souls"
      ],
      "Year": "1962",
      "Director": "Herk Harvey",
      "DirectorArray": [
        "Herk Harvey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "692",
      "databaseFilmTitle": "Carol",
      "FilmTitle": "Carol",
      "AlternateTitle": "",
      "TitleArray": [
        "Carol"
      ],
      "Year": "2015",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "693",
      "databaseFilmTitle": "Carriage Trade",
      "FilmTitle": "Carriage Trade",
      "AlternateTitle": "",
      "TitleArray": [
        "Carriage Trade"
      ],
      "Year": "1971",
      "Director": "Warren Sonbert",
      "DirectorArray": [
        "Warren Sonbert"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "694",
      "databaseFilmTitle": "Carrie",
      "FilmTitle": "Carrie",
      "AlternateTitle": "",
      "TitleArray": [
        "Carrie"
      ],
      "Year": "1976",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "695",
      "databaseFilmTitle": "Carry on Cleo",
      "FilmTitle": "Carry on Cleo",
      "AlternateTitle": "",
      "TitleArray": [
        "Carry on Cleo"
      ],
      "Year": "1964",
      "Director": "Gerald Thomas",
      "DirectorArray": [
        "Gerald Thomas"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "696",
      "databaseFilmTitle": "Carry on up the Khyber",
      "FilmTitle": "Carry on up the Khyber",
      "AlternateTitle": "",
      "TitleArray": [
        "Carry on up the Khyber"
      ],
      "Year": "1968",
      "Director": "Gerald Thomas",
      "DirectorArray": [
        "Gerald Thomas"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "697",
      "databaseFilmTitle": "Casablanca",
      "FilmTitle": "Casablanca",
      "AlternateTitle": "",
      "TitleArray": [
        "Casablanca"
      ],
      "Year": "1942",
      "Director": "Michael Curtiz",
      "DirectorArray": [
        "Michael Curtiz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "63",
      "2022votes": "40"
    },
    {
      "key": "698",
      "databaseFilmTitle": "Casino",
      "FilmTitle": "Casino",
      "AlternateTitle": "",
      "TitleArray": [
        "Casino"
      ],
      "Year": "1995",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "699",
      "databaseFilmTitle": "Casque d'or",
      "FilmTitle": "Casque d'or",
      "AlternateTitle": "",
      "TitleArray": [
        "Casque d'or"
      ],
      "Year": "1952",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "700",
      "databaseFilmTitle": "Casting a Glance",
      "FilmTitle": "Casting a Glance",
      "AlternateTitle": "",
      "TitleArray": [
        "Casting a Glance"
      ],
      "Year": "2007",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "701",
      "databaseFilmTitle": "Casting Blossoms to the Sky",
      "FilmTitle": "Casting Blossoms to the Sky",
      "AlternateTitle": "Kono sora no hana: Nagaoka hanabi monogatari",
      "TitleArray": [
        "Casting Blossoms to the Sky",
        "Kono sora no hana: Nagaoka hanabi monogatari"
      ],
      "Year": "2012",
      "Director": "Nobuhiko Ôbayashi",
      "DirectorArray": [
        "Nobuhiko Ôbayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "702",
      "databaseFilmTitle": "Castle in the Sky",
      "FilmTitle": "Castle in the Sky",
      "AlternateTitle": "Tenkû no shiro Rapyuta",
      "TitleArray": [
        "Castle in the Sky",
        "Tenkû no shiro Rapyuta"
      ],
      "Year": "1986",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "703",
      "databaseFilmTitle": "Castro Street",
      "FilmTitle": "Castro Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Castro Street"
      ],
      "Year": "1966",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "704",
      "databaseFilmTitle": "Cat People",
      "FilmTitle": "Cat People",
      "AlternateTitle": "",
      "TitleArray": [
        "Cat People"
      ],
      "Year": "1942",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "705",
      "databaseFilmTitle": "Cathy Come Home",
      "FilmTitle": "Cathy Come Home",
      "AlternateTitle": "The Wednesday Play [S01, E72]: Cathy Come Home",
      "TitleArray": [
        "Cathy Come Home",
        "The Wednesday Play [S01, E72]: Cathy Come Home"
      ],
      "Year": "1966",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "706",
      "databaseFilmTitle": "Cattle Queen of Montana",
      "FilmTitle": "Cattle Queen of Montana",
      "AlternateTitle": "",
      "TitleArray": [
        "Cattle Queen of Montana"
      ],
      "Year": "1954",
      "Director": "Allan Dwan",
      "DirectorArray": [
        "Allan Dwan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "707",
      "databaseFilmTitle": "Cavalcade",
      "FilmTitle": "Cavalcade",
      "AlternateTitle": "",
      "TitleArray": [
        "Cavalcade"
      ],
      "Year": "1933",
      "Director": "Frank Lloyd",
      "DirectorArray": [
        "Frank Lloyd"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "708",
      "databaseFilmTitle": "Cease to Exist",
      "FilmTitle": "Cease to Exist",
      "AlternateTitle": "",
      "TitleArray": [
        "Cease to Exist"
      ],
      "Year": "2007",
      "Director": "Ryan Oksenberg",
      "DirectorArray": [
        "Ryan Oksenberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "709",
      "databaseFilmTitle": "Ceddo",
      "FilmTitle": "Ceddo",
      "AlternateTitle": "",
      "TitleArray": [
        "Ceddo"
      ],
      "Year": "1977",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "710",
      "databaseFilmTitle": "Céline and Julie Go Boating",
      "FilmTitle": "Céline and Julie Go Boating",
      "AlternateTitle": "Céline et Julie vont en bateau",
      "TitleArray": [
        "Céline and Julie Go Boating",
        "Céline et Julie vont en bateau"
      ],
      "Year": "1974",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "711",
      "databaseFilmTitle": "Cell Phone",
      "FilmTitle": "Cell Phone",
      "AlternateTitle": "Shou ji",
      "TitleArray": [
        "Cell Phone",
        "Shou ji"
      ],
      "Year": "2003",
      "Director": "Feng Xiaogang",
      "DirectorArray": [
        "Feng Xiaogang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "712",
      "databaseFilmTitle": "Cemetery of Splendour",
      "FilmTitle": "Cemetery of Splendour",
      "AlternateTitle": "Rak ti Khon Kaen",
      "TitleArray": [
        "Cemetery of Splendour",
        "Rak ti Khon Kaen"
      ],
      "Year": "2015",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "713",
      "databaseFilmTitle": "Central Station",
      "FilmTitle": "Central Station",
      "AlternateTitle": "Central do Brasil",
      "TitleArray": [
        "Central Station",
        "Central do Brasil"
      ],
      "Year": "1998",
      "Director": "Walter Salles",
      "DirectorArray": [
        "Walter Salles"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "714",
      "databaseFilmTitle": "Century of Birthing",
      "FilmTitle": "Century of Birthing",
      "AlternateTitle": "Siglo ng pagluluwal",
      "TitleArray": [
        "Century of Birthing",
        "Siglo ng pagluluwal"
      ],
      "Year": "2011",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "715",
      "databaseFilmTitle": "Cerro Pelado",
      "FilmTitle": "Cerro Pelado",
      "AlternateTitle": "",
      "TitleArray": [
        "Cerro Pelado"
      ],
      "Year": "1966",
      "Director": "Santiago Álvarez",
      "DirectorArray": [
        "Santiago Álvarez"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "716",
      "databaseFilmTitle": "Certain Women",
      "FilmTitle": "Certain Women",
      "AlternateTitle": "",
      "TitleArray": [
        "Certain Women"
      ],
      "Year": "2016",
      "Director": "Kelly Reichardt",
      "DirectorArray": [
        "Kelly Reichardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "717",
      "databaseFilmTitle": "Certified Copy",
      "FilmTitle": "Certified Copy",
      "AlternateTitle": "Copie conforme",
      "TitleArray": [
        "Certified Copy",
        "Copie conforme"
      ],
      "Year": "2010",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "718",
      "databaseFilmTitle": "César",
      "FilmTitle": "César",
      "AlternateTitle": "",
      "TitleArray": [
        "César"
      ],
      "Year": "1936",
      "Director": "Marcel Pagnol",
      "DirectorArray": [
        "Marcel Pagnol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "719",
      "databaseFilmTitle": "César and Rosalie",
      "FilmTitle": "César and Rosalie",
      "AlternateTitle": "César et Rosalie",
      "TitleArray": [
        "César and Rosalie",
        "César et Rosalie"
      ],
      "Year": "1972",
      "Director": "Claude Sautet",
      "DirectorArray": [
        "Claude Sautet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "720",
      "databaseFilmTitle": "Cézanne",
      "FilmTitle": "Cézanne",
      "AlternateTitle": "",
      "TitleArray": [
        "Cézanne"
      ],
      "Year": "1989",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "721",
      "databaseFilmTitle": "Chameleon Street",
      "FilmTitle": "Chameleon Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Chameleon Street"
      ],
      "Year": "1990",
      "Director": "Wendell B. Harris Jr.",
      "DirectorArray": [
        "Wendell B. Harris Jr."
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "722",
      "databaseFilmTitle": "Chandralekha (1948)",
      "FilmTitle": "Chandralekha",
      "AlternateTitle": "",
      "TitleArray": [
        "Chandralekha"
      ],
      "Year": "1948",
      "Director": "S.S. Vasan",
      "DirectorArray": [
        "S.S. Vasan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "723",
      "databaseFilmTitle": "Change of Life",
      "FilmTitle": "Change of Life",
      "AlternateTitle": "Mudar de Vida",
      "TitleArray": [
        "Change of Life",
        "Mudar de Vida"
      ],
      "Year": "1966",
      "Director": "Paulo Rocha",
      "DirectorArray": [
        "Paulo Rocha"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "724",
      "databaseFilmTitle": "Chanson d'Armor",
      "FilmTitle": "Chanson d'Armor",
      "AlternateTitle": "",
      "TitleArray": [
        "Chanson d'Armor"
      ],
      "Year": "1934",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "725",
      "databaseFilmTitle": "Chapayev",
      "FilmTitle": "Chapayev",
      "AlternateTitle": "",
      "TitleArray": [
        "Chapayev"
      ],
      "Year": "1934",
      "Director": "Georgi Vasilyev, Sergei Vasilyev",
      "DirectorArray": [
        "Georgi Vasilyev",
        "Sergei Vasilyev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "726",
      "databaseFilmTitle": "Chaplin",
      "FilmTitle": "Chaplin",
      "AlternateTitle": "",
      "TitleArray": [
        "Chaplin"
      ],
      "Year": "1992",
      "Director": "Richard Attenborough",
      "DirectorArray": [
        "Richard Attenborough"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "727",
      "databaseFilmTitle": "Chappaqua",
      "FilmTitle": "Chappaqua",
      "AlternateTitle": "",
      "TitleArray": [
        "Chappaqua"
      ],
      "Year": "1966",
      "Director": "Conrad Rooks",
      "DirectorArray": [
        "Conrad Rooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "728",
      "databaseFilmTitle": "Character",
      "FilmTitle": "Character",
      "AlternateTitle": "Karakter",
      "TitleArray": [
        "Character",
        "Karakter"
      ],
      "Year": "1997",
      "Director": "Mike van Diem",
      "DirectorArray": [
        "Mike van Diem"
      ],
      "Country": "Netherlands, Belgium",
      "CountryArray": [
        "Netherlands",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "729",
      "databaseFilmTitle": "Charade",
      "FilmTitle": "Charade",
      "AlternateTitle": "",
      "TitleArray": [
        "Charade"
      ],
      "Year": "1963",
      "Director": "Stanley Donen",
      "DirectorArray": [
        "Stanley Donen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "730",
      "databaseFilmTitle": "Charlotte and Her Boyfriend",
      "FilmTitle": "Charlotte and Her Boyfriend",
      "AlternateTitle": "Charlotte et son Jules",
      "TitleArray": [
        "Charlotte and Her Boyfriend",
        "Charlotte et son Jules"
      ],
      "Year": "1958",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "731",
      "databaseFilmTitle": "Charulata",
      "FilmTitle": "Charulata",
      "AlternateTitle": "",
      "TitleArray": [
        "Charulata"
      ],
      "Year": "1964",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "732",
      "databaseFilmTitle": "Chasing Butterflies",
      "FilmTitle": "Chasing Butterflies",
      "AlternateTitle": "La chasse aux papillons",
      "TitleArray": [
        "Chasing Butterflies",
        "La chasse aux papillons"
      ],
      "Year": "1992",
      "Director": "Otar Iosseliani",
      "DirectorArray": [
        "Otar Iosseliani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "733",
      "databaseFilmTitle": "Chess of the Wind",
      "FilmTitle": "Chess of the Wind",
      "AlternateTitle": "Shatranj-e baad",
      "TitleArray": [
        "Chess of the Wind",
        "Shatranj-e baad"
      ],
      "Year": "1976",
      "Director": "Mohammad Reza Aslani",
      "DirectorArray": [
        "Mohammad Reza Aslani"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "734",
      "databaseFilmTitle": "Chess Story",
      "FilmTitle": "Chess Story",
      "AlternateTitle": "Schachnovelle",
      "TitleArray": [
        "Chess Story",
        "Schachnovelle"
      ],
      "Year": "2021",
      "Director": "Philipp Stölzl",
      "DirectorArray": [
        "Philipp Stölzl"
      ],
      "Country": "Germany, Austria",
      "CountryArray": [
        "Germany",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "735",
      "databaseFilmTitle": "Cheyenne Autumn",
      "FilmTitle": "Cheyenne Autumn",
      "AlternateTitle": "",
      "TitleArray": [
        "Cheyenne Autumn"
      ],
      "Year": "1964",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "736",
      "databaseFilmTitle": "Chez jolie coiffure",
      "FilmTitle": "Chez jolie coiffure",
      "AlternateTitle": "",
      "TitleArray": [
        "Chez jolie coiffure"
      ],
      "Year": "2018",
      "Director": "Rosine Mbakam",
      "DirectorArray": [
        "Rosine Mbakam"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "737",
      "databaseFilmTitle": "Child of Resistance",
      "FilmTitle": "Child of Resistance",
      "AlternateTitle": "",
      "TitleArray": [
        "Child of Resistance"
      ],
      "Year": "1973",
      "Director": "Haile Gerima",
      "DirectorArray": [
        "Haile Gerima"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "738",
      "databaseFilmTitle": "Children of Heaven",
      "FilmTitle": "Children of Heaven",
      "AlternateTitle": "Bacheha-Ye aseman",
      "TitleArray": [
        "Children of Heaven",
        "Bacheha-Ye aseman"
      ],
      "Year": "1997",
      "Director": "Majid Majidi",
      "DirectorArray": [
        "Majid Majidi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "739",
      "databaseFilmTitle": "Children of Men",
      "FilmTitle": "Children of Men",
      "AlternateTitle": "",
      "TitleArray": [
        "Children of Men"
      ],
      "Year": "2006",
      "Director": "Alfonso Cuarón",
      "DirectorArray": [
        "Alfonso Cuarón"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "740",
      "databaseFilmTitle": "Children of Paradise",
      "FilmTitle": "Children of Paradise",
      "AlternateTitle": "Les enfants du paradis",
      "TitleArray": [
        "Children of Paradise",
        "Les enfants du paradis"
      ],
      "Year": "1945",
      "Director": "Marcel Carné",
      "DirectorArray": [
        "Marcel Carné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "73",
      "2012votes": "22",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "741",
      "databaseFilmTitle": "Children of the Beehive",
      "FilmTitle": "Children of the Beehive",
      "AlternateTitle": "Hachi no su no kodomotachi",
      "TitleArray": [
        "Children of the Beehive",
        "Hachi no su no kodomotachi"
      ],
      "Year": "1948",
      "Director": "Hiroshi Shimizu",
      "DirectorArray": [
        "Hiroshi Shimizu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "742",
      "databaseFilmTitle": "Children Who Draw",
      "FilmTitle": "Children Who Draw",
      "AlternateTitle": "Te o kaku kodomotachi",
      "TitleArray": [
        "Children Who Draw",
        "Te o kaku kodomotachi"
      ],
      "Year": "1956",
      "Director": "Susumu Hani",
      "DirectorArray": [
        "Susumu Hani"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "743",
      "databaseFilmTitle": "Chimes at Midnight",
      "FilmTitle": "Chimes at Midnight",
      "AlternateTitle": "Campanadas a medianoche",
      "TitleArray": [
        "Chimes at Midnight",
        "Campanadas a medianoche"
      ],
      "Year": "1965",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "Spain, Switzerland",
      "CountryArray": [
        "Spain",
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "744",
      "databaseFilmTitle": "China Behind",
      "FilmTitle": "China Behind",
      "AlternateTitle": "",
      "TitleArray": [
        "China Behind"
      ],
      "Year": "1974",
      "Director": "Tang Shu-Shuen",
      "DirectorArray": [
        "Tang Shu-Shuen"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "745",
      "databaseFilmTitle": "Chinatown",
      "FilmTitle": "Chinatown",
      "AlternateTitle": "",
      "TitleArray": [
        "Chinatown"
      ],
      "Year": "1974",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "78",
      "2012votes": "21",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "746",
      "databaseFilmTitle": "Chinese Checkers",
      "FilmTitle": "Chinese Checkers",
      "AlternateTitle": "",
      "TitleArray": [
        "Chinese Checkers"
      ],
      "Year": "1964",
      "Director": "Stephen Dwoskin",
      "DirectorArray": [
        "Stephen Dwoskin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "747",
      "databaseFilmTitle": "Chinese Firedrill",
      "FilmTitle": "Chinese Firedrill",
      "AlternateTitle": "",
      "TitleArray": [
        "Chinese Firedrill"
      ],
      "Year": "1968",
      "Director": "Will Hindle",
      "DirectorArray": [
        "Will Hindle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "748",
      "databaseFilmTitle": "Chinese Roulette",
      "FilmTitle": "Chinese Roulette",
      "AlternateTitle": "Chinesisches Roulette",
      "TitleArray": [
        "Chinese Roulette",
        "Chinesisches Roulette"
      ],
      "Year": "1976",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "749",
      "databaseFilmTitle": "Chocolat",
      "FilmTitle": "Chocolat",
      "AlternateTitle": "",
      "TitleArray": [
        "Chocolat"
      ],
      "Year": "1988",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "750",
      "databaseFilmTitle": "Chopper",
      "FilmTitle": "Chopper",
      "AlternateTitle": "",
      "TitleArray": [
        "Chopper"
      ],
      "Year": "2000",
      "Director": "Andrew Dominik",
      "DirectorArray": [
        "Andrew Dominik"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "751",
      "databaseFilmTitle": "Christ Stopped at Eboli",
      "FilmTitle": "Christ Stopped at Eboli",
      "AlternateTitle": "Cristo si è fermato a Eboli",
      "TitleArray": [
        "Christ Stopped at Eboli",
        "Cristo si è fermato a Eboli"
      ],
      "Year": "1979",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "752",
      "databaseFilmTitle": "Christiane F.",
      "FilmTitle": "Christiane F.",
      "AlternateTitle": "Christiane F. - Wir Kinder vom Bahnhof Zoo",
      "TitleArray": [
        "Christiane F.",
        "Christiane F. - Wir Kinder vom Bahnhof Zoo"
      ],
      "Year": "1981",
      "Director": "Uli Edel",
      "DirectorArray": [
        "Uli Edel"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "753",
      "databaseFilmTitle": "Christine",
      "FilmTitle": "Christine",
      "AlternateTitle": "",
      "TitleArray": [
        "Christine"
      ],
      "Year": "1983",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "754",
      "databaseFilmTitle": "Christmas on Earth",
      "FilmTitle": "Christmas on Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "Christmas on Earth"
      ],
      "Year": "1963",
      "Director": "Barbara Rubin",
      "DirectorArray": [
        "Barbara Rubin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "755",
      "databaseFilmTitle": "Chronicle of a Boy Alone",
      "FilmTitle": "Chronicle of a Boy Alone",
      "AlternateTitle": "Crónica de un niño solo",
      "TitleArray": [
        "Chronicle of a Boy Alone",
        "Crónica de un niño solo"
      ],
      "Year": "1965",
      "Director": "Leonardo Favio",
      "DirectorArray": [
        "Leonardo Favio"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "756",
      "databaseFilmTitle": "Chronicle of a Disappearance",
      "FilmTitle": "Chronicle of a Disappearance",
      "AlternateTitle": "",
      "TitleArray": [
        "Chronicle of a Disappearance"
      ],
      "Year": "1996",
      "Director": "Elia Suleiman",
      "DirectorArray": [
        "Elia Suleiman"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "757",
      "databaseFilmTitle": "Chronicle of a Summer",
      "FilmTitle": "Chronicle of a Summer",
      "AlternateTitle": "Chronique d'un été",
      "TitleArray": [
        "Chronicle of a Summer",
        "Chronique d'un été"
      ],
      "Year": "1961",
      "Director": "Edgar Morin, Jean Rouch",
      "DirectorArray": [
        "Edgar Morin",
        "Jean Rouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "758",
      "databaseFilmTitle": "Chronicle of Anna Magdalena Bach",
      "FilmTitle": "Chronicle of Anna Magdalena Bach",
      "AlternateTitle": "Chronik der Anna Magdalena Bach",
      "TitleArray": [
        "Chronicle of Anna Magdalena Bach",
        "Chronik der Anna Magdalena Bach"
      ],
      "Year": "1968",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "759",
      "databaseFilmTitle": "Chronicles of a Lying Spirit (by Kelly Gabron)",
      "FilmTitle": "Chronicles of a Lying Spirit (by Kelly Gabron)",
      "AlternateTitle": "",
      "TitleArray": [
        "Chronicles of a Lying Spirit (by Kelly Gabron)"
      ],
      "Year": "1992",
      "Director": "Cauleen Smith",
      "DirectorArray": [
        "Cauleen Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "760",
      "databaseFilmTitle": "Chungking Express",
      "FilmTitle": "Chungking Express",
      "AlternateTitle": "Chung Hing sam lam",
      "TitleArray": [
        "Chungking Express",
        "Chung Hing sam lam"
      ],
      "Year": "1994",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "88",
      "2022votes": "33"
    },
    {
      "key": "761",
      "databaseFilmTitle": "Chunhyang",
      "FilmTitle": "Chunhyang",
      "AlternateTitle": "Chunhyangdyun",
      "TitleArray": [
        "Chunhyang",
        "Chunhyangdyun"
      ],
      "Year": "2000",
      "Director": "Im Kwon-taek",
      "DirectorArray": [
        "Im Kwon-taek"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "762",
      "databaseFilmTitle": "Cinderella",
      "FilmTitle": "Cinderella",
      "AlternateTitle": "Aschenputtel",
      "TitleArray": [
        "Cinderella",
        "Aschenputtel"
      ],
      "Year": "1922",
      "Director": "Lotte Reiniger",
      "DirectorArray": [
        "Lotte Reiniger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "763",
      "databaseFilmTitle": "Cinema Paradiso",
      "FilmTitle": "Cinema Paradiso",
      "AlternateTitle": "Nuovo Cinema Paradiso",
      "TitleArray": [
        "Cinema Paradiso",
        "Nuovo Cinema Paradiso"
      ],
      "Year": "1988",
      "Director": "Giuseppe Tornatore",
      "DirectorArray": [
        "Giuseppe Tornatore"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "764",
      "databaseFilmTitle": "Cinnamon",
      "FilmTitle": "Cinnamon",
      "AlternateTitle": "",
      "TitleArray": [
        "Cinnamon"
      ],
      "Year": "2006",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "765",
      "databaseFilmTitle": "Cisco Pike",
      "FilmTitle": "Cisco Pike",
      "AlternateTitle": "",
      "TitleArray": [
        "Cisco Pike"
      ],
      "Year": "1971",
      "Director": "Bill L. Norton",
      "DirectorArray": [
        "Bill L. Norton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "766",
      "databaseFilmTitle": "Citizen Dog",
      "FilmTitle": "Citizen Dog",
      "AlternateTitle": "Mah Nakorn",
      "TitleArray": [
        "Citizen Dog",
        "Mah Nakorn"
      ],
      "Year": "2004",
      "Director": "Wisit Sasanatieng",
      "DirectorArray": [
        "Wisit Sasanatieng"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "767",
      "databaseFilmTitle": "Citizen Kane",
      "FilmTitle": "Citizen Kane",
      "AlternateTitle": "",
      "TitleArray": [
        "Citizen Kane"
      ],
      "Year": "1941",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "13",
      "1952votes": "9",
      "1962rank": "1",
      "1962votes": "22",
      "1972rank": "1",
      "1972votes": "32",
      "1982rank": "1",
      "1982votes": "45",
      "1992rank": "1",
      "1992votes": "43",
      "2002rank": "1",
      "2002votes": "46",
      "2012rank": "2",
      "2012votes": "157",
      "2022rank": "3",
      "2022votes": "164"
    },
    {
      "key": "768",
      "databaseFilmTitle": "City After Dark",
      "FilmTitle": "City After Dark",
      "AlternateTitle": "Manila by Night",
      "TitleArray": [
        "City After Dark",
        "Manila by Night"
      ],
      "Year": "1980",
      "Director": "Ishmael Bernal",
      "DirectorArray": [
        "Ishmael Bernal"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "769",
      "databaseFilmTitle": "City Girl",
      "FilmTitle": "City Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "City Girl"
      ],
      "Year": "1930",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "770",
      "databaseFilmTitle": "City Hall",
      "FilmTitle": "City Hall",
      "AlternateTitle": "",
      "TitleArray": [
        "City Hall"
      ],
      "Year": "2020",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "771",
      "databaseFilmTitle": "City Lights",
      "FilmTitle": "City Lights",
      "AlternateTitle": "",
      "TitleArray": [
        "City Lights"
      ],
      "Year": "1931",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "2",
      "1952votes": "19",
      "1962rank": "14",
      "1962votes": "10",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "50",
      "2012votes": "29",
      "2022rank": "36",
      "2022votes": "55"
    },
    {
      "key": "772",
      "databaseFilmTitle": "City of Contrasts",
      "FilmTitle": "City of Contrasts",
      "AlternateTitle": "Contras' City",
      "TitleArray": [
        "City of Contrasts",
        "Contras' City"
      ],
      "Year": "1969",
      "Director": "Djibril Diop Mambéty",
      "DirectorArray": [
        "Djibril Diop Mambéty"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "773",
      "databaseFilmTitle": "City of God",
      "FilmTitle": "City of God",
      "AlternateTitle": "Cidade de Deus",
      "TitleArray": [
        "City of God",
        "Cidade de Deus"
      ],
      "Year": "2002",
      "Director": "Fernando Meirelles, Kátia Lund",
      "DirectorArray": [
        "Fernando Meirelles",
        "Kátia Lund"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "774",
      "databaseFilmTitle": "City of Light and Death",
      "FilmTitle": "City of Light and Death",
      "AlternateTitle": "Nanjing! Nanjing!",
      "TitleArray": [
        "City of Light and Death",
        "Nanjing! Nanjing!"
      ],
      "Year": "2009",
      "Director": "Lu Chuan",
      "DirectorArray": [
        "Lu Chuan"
      ],
      "Country": "Hong Kong, China",
      "CountryArray": [
        "Hong Kong",
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "775",
      "databaseFilmTitle": "City of Lost Souls",
      "FilmTitle": "City of Lost Souls",
      "AlternateTitle": "Stadt Der Verlorenen Seelen",
      "TitleArray": [
        "City of Lost Souls",
        "Stadt Der Verlorenen Seelen"
      ],
      "Year": "1983",
      "Director": "Rosa von Praunheim",
      "DirectorArray": [
        "Rosa von Praunheim"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "776",
      "databaseFilmTitle": "City of Pirates",
      "FilmTitle": "City of Pirates",
      "AlternateTitle": "La ville des pirates",
      "TitleArray": [
        "City of Pirates",
        "La ville des pirates"
      ],
      "Year": "1983",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "777",
      "databaseFilmTitle": "City of Women",
      "FilmTitle": "City of Women",
      "AlternateTitle": "La città delle donne",
      "TitleArray": [
        "City of Women",
        "La città delle donne"
      ],
      "Year": "1980",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "778",
      "databaseFilmTitle": "Claire's Knee",
      "FilmTitle": "Claire's Knee",
      "AlternateTitle": "Le genou de Claire",
      "TitleArray": [
        "Claire's Knee",
        "Le genou de Claire"
      ],
      "Year": "1970",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "779",
      "databaseFilmTitle": "Clash by Night",
      "FilmTitle": "Clash by Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Clash by Night"
      ],
      "Year": "1952",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "780",
      "databaseFilmTitle": "Class Relations",
      "FilmTitle": "Class Relations",
      "AlternateTitle": "Klassenverhältnisse",
      "TitleArray": [
        "Class Relations",
        "Klassenverhältnisse"
      ],
      "Year": "1984",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "West Germany, France",
      "CountryArray": [
        "West Germany",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "781",
      "databaseFilmTitle": "Classe tous risques",
      "FilmTitle": "Classe tous risques",
      "AlternateTitle": "",
      "TitleArray": [
        "Classe tous risques"
      ],
      "Year": "1960",
      "Director": "Claude Sautet",
      "DirectorArray": [
        "Claude Sautet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "782",
      "databaseFilmTitle": "Cléo from 5 to 7",
      "FilmTitle": "Cléo from 5 to 7",
      "AlternateTitle": "Cléo de 5 à 7",
      "TitleArray": [
        "Cléo from 5 to 7",
        "Cléo de 5 à 7"
      ],
      "Year": "1962",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "14",
      "2022votes": "81"
    },
    {
      "key": "783",
      "databaseFilmTitle": "Cleopatra",
      "FilmTitle": "Cleopatra",
      "AlternateTitle": "",
      "TitleArray": [
        "Cleopatra"
      ],
      "Year": "1963",
      "Director": "Joseph L. Mackiewicz",
      "DirectorArray": [
        "Joseph L. Mackiewicz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "784",
      "databaseFilmTitle": "Climates",
      "FilmTitle": "Climates",
      "AlternateTitle": "İklimler",
      "TitleArray": [
        "Climates",
        "İklimler"
      ],
      "Year": "2006",
      "Director": "Nuri Bilge Ceylan",
      "DirectorArray": [
        "Nuri Bilge Ceylan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "785",
      "databaseFilmTitle": "Close Encounters of the Third Kind",
      "FilmTitle": "Close Encounters of the Third Kind",
      "AlternateTitle": "",
      "TitleArray": [
        "Close Encounters of the Third Kind"
      ],
      "Year": "1977",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "786",
      "databaseFilmTitle": "Close-Up",
      "FilmTitle": "Close-Up",
      "AlternateTitle": "Nema-ye Nazdik",
      "TitleArray": [
        "Close-Up",
        "Nema-ye Nazdik"
      ],
      "Year": "1990",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "43",
      "2012votes": "31",
      "2022rank": "17",
      "2022votes": "78"
    },
    {
      "key": "787",
      "databaseFilmTitle": "Closely Watched Trains",
      "FilmTitle": "Closely Watched Trains",
      "AlternateTitle": "Ostře sledované vlaky",
      "TitleArray": [
        "Closely Watched Trains",
        "Ostře sledované vlaky"
      ],
      "Year": "1966",
      "Director": "Jirí Menzel",
      "DirectorArray": [
        "Jirí Menzel"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "788",
      "databaseFilmTitle": "Closeness",
      "FilmTitle": "Closeness",
      "AlternateTitle": "Techota",
      "TitleArray": [
        "Closeness",
        "Techota"
      ],
      "Year": "2017",
      "Director": "Kantemir Balagov",
      "DirectorArray": [
        "Kantemir Balagov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "789",
      "databaseFilmTitle": "Closes",
      "FilmTitle": "Closes",
      "AlternateTitle": "",
      "TitleArray": [
        "Closes"
      ],
      "Year": "1982",
      "Director": "Pedro Nunes",
      "DirectorArray": [
        "Pedro Nunes"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "790",
      "databaseFilmTitle": "Clouds of May",
      "FilmTitle": "Clouds of May",
      "AlternateTitle": "Mayis Sikintisi",
      "TitleArray": [
        "Clouds of May",
        "Mayis Sikintisi"
      ],
      "Year": "1999",
      "Director": "Nuri Bilge Ceylan",
      "DirectorArray": [
        "Nuri Bilge Ceylan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "791",
      "databaseFilmTitle": "Clouds of Sils Maria",
      "FilmTitle": "Clouds of Sils Maria",
      "AlternateTitle": "",
      "TitleArray": [
        "Clouds of Sils Maria"
      ],
      "Year": "2014",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "792",
      "databaseFilmTitle": "Club Havana",
      "FilmTitle": "Club Havana",
      "AlternateTitle": "",
      "TitleArray": [
        "Club Havana"
      ],
      "Year": "1945",
      "Director": "Edgar G. Ulmer",
      "DirectorArray": [
        "Edgar G. Ulmer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "793",
      "databaseFilmTitle": "Clueless",
      "FilmTitle": "Clueless",
      "AlternateTitle": "",
      "TitleArray": [
        "Clueless"
      ],
      "Year": "1995",
      "Director": "Amy Heckerling",
      "DirectorArray": [
        "Amy Heckerling"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "794",
      "databaseFilmTitle": "Cluny Brown",
      "FilmTitle": "Cluny Brown",
      "AlternateTitle": "",
      "TitleArray": [
        "Cluny Brown"
      ],
      "Year": "1946",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "795",
      "databaseFilmTitle": "Coach Carter",
      "FilmTitle": "Coach Carter",
      "AlternateTitle": "",
      "TitleArray": [
        "Coach Carter"
      ],
      "Year": "2005",
      "Director": "Thomas Carter",
      "DirectorArray": [
        "Thomas Carter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "796",
      "databaseFilmTitle": "Coal Face",
      "FilmTitle": "Coal Face",
      "AlternateTitle": "",
      "TitleArray": [
        "Coal Face"
      ],
      "Year": "1935",
      "Director": "Alberto Cavalcanti",
      "DirectorArray": [
        "Alberto Cavalcanti"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "797",
      "databaseFilmTitle": "Cock-A-Doodle-Doo! Mr Chicken",
      "FilmTitle": "Cock-A-Doodle-Doo! Mr Chicken",
      "AlternateTitle": "Cocorico! Monsieur Poulet",
      "TitleArray": [
        "Cock-A-Doodle-Doo! Mr Chicken",
        "Cocorico! Monsieur Poulet"
      ],
      "Year": "1974",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "Niger, France",
      "CountryArray": [
        "Niger",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "798",
      "databaseFilmTitle": "Cockfighter",
      "FilmTitle": "Cockfighter",
      "AlternateTitle": "",
      "TitleArray": [
        "Cockfighter"
      ],
      "Year": "1974",
      "Director": "Monte Hellman",
      "DirectorArray": [
        "Monte Hellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "799",
      "databaseFilmTitle": "Cocksucker Blues",
      "FilmTitle": "Cocksucker Blues",
      "AlternateTitle": "",
      "TitleArray": [
        "Cocksucker Blues"
      ],
      "Year": "1972",
      "Director": "Robert Frank",
      "DirectorArray": [
        "Robert Frank"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "800",
      "databaseFilmTitle": "Cocktail",
      "FilmTitle": "Cocktail",
      "AlternateTitle": "",
      "TitleArray": [
        "Cocktail"
      ],
      "Year": "1988",
      "Director": "Roger Donaldson",
      "DirectorArray": [
        "Roger Donaldson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "801",
      "databaseFilmTitle": "Code Unknown: Incomplete Tales of Several Journeys",
      "FilmTitle": "Code Unknown: Incomplete Tales of Several Journeys",
      "AlternateTitle": "Code inconnu: Récit incomplet de divers voyages",
      "TitleArray": [
        "Code Unknown: Incomplete Tales of Several Journeys",
        "Code inconnu: Récit incomplet de divers voyages"
      ],
      "Year": "2000",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "802",
      "databaseFilmTitle": "Coded Bias",
      "FilmTitle": "Coded Bias",
      "AlternateTitle": "",
      "TitleArray": [
        "Coded Bias"
      ],
      "Year": "2020",
      "Director": "Shalini Kantayya",
      "DirectorArray": [
        "Shalini Kantayya"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "803",
      "databaseFilmTitle": "Coffea arábiga",
      "FilmTitle": "Coffea arábiga",
      "AlternateTitle": "",
      "TitleArray": [
        "Coffea arábiga"
      ],
      "Year": "1968",
      "Director": "Nicolás Guillén Landrián",
      "DirectorArray": [
        "Nicolás Guillén Landrián"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "804",
      "databaseFilmTitle": "Coffee",
      "FilmTitle": "Coffee",
      "AlternateTitle": "",
      "TitleArray": [
        "Coffee"
      ],
      "Year": "1977",
      "Director": "Dorothy Wiley",
      "DirectorArray": [
        "Dorothy Wiley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "805",
      "databaseFilmTitle": "Cofralandes, Chilean Rhapsody",
      "FilmTitle": "Cofralandes, Chilean Rhapsody",
      "AlternateTitle": "Cofralandes, rapsodia chilena",
      "TitleArray": [
        "Cofralandes, Chilean Rhapsody",
        "Cofralandes, rapsodia chilena"
      ],
      "Year": "2002",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Chile, France",
      "CountryArray": [
        "Chile",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "806",
      "databaseFilmTitle": "Coherence",
      "FilmTitle": "Coherence",
      "AlternateTitle": "",
      "TitleArray": [
        "Coherence"
      ],
      "Year": "2013",
      "Director": "James Ward Byrkit",
      "DirectorArray": [
        "James Ward Byrkit"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "807",
      "databaseFilmTitle": "Cold Nights",
      "FilmTitle": "Cold Nights",
      "AlternateTitle": "Han ye",
      "TitleArray": [
        "Cold Nights",
        "Han ye"
      ],
      "Year": "1955",
      "Director": "Sun-fung Lee",
      "DirectorArray": [
        "Sun-fung Lee"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "808",
      "databaseFilmTitle": "Cold War",
      "FilmTitle": "Cold War",
      "AlternateTitle": "Zimna wojna",
      "TitleArray": [
        "Cold War",
        "Zimna wojna"
      ],
      "Year": "2018",
      "Director": "Paweł Pawlikowski",
      "DirectorArray": [
        "Paweł Pawlikowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "809",
      "databaseFilmTitle": "Cold Water",
      "FilmTitle": "Cold Water",
      "AlternateTitle": "L'eau froide",
      "TitleArray": [
        "Cold Water",
        "L'eau froide"
      ],
      "Year": "1994",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "810",
      "databaseFilmTitle": "Collective",
      "FilmTitle": "Collective",
      "AlternateTitle": "Colectiv",
      "TitleArray": [
        "Collective",
        "Colectiv"
      ],
      "Year": "2019",
      "Director": "Alexander Nanau",
      "DirectorArray": [
        "Alexander Nanau"
      ],
      "Country": "Romania, Luxembourg",
      "CountryArray": [
        "Romania",
        "Luxembourg"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "811",
      "databaseFilmTitle": "Color Series",
      "FilmTitle": "Color Series",
      "AlternateTitle": "",
      "TitleArray": [
        "Color Series"
      ],
      "Year": "2010",
      "Director": "Madison Brookshire",
      "DirectorArray": [
        "Madison Brookshire"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "812",
      "databaseFilmTitle": "Colorado Territory",
      "FilmTitle": "Colorado Territory",
      "AlternateTitle": "",
      "TitleArray": [
        "Colorado Territory"
      ],
      "Year": "1949",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "813",
      "databaseFilmTitle": "Colossal Youth",
      "FilmTitle": "Colossal Youth",
      "AlternateTitle": "Juventude em Marcha",
      "TitleArray": [
        "Colossal Youth",
        "Juventude em Marcha"
      ],
      "Year": "2006",
      "Director": "Pedro Costa",
      "DirectorArray": [
        "Pedro Costa"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "814",
      "databaseFilmTitle": "Colour Poems",
      "FilmTitle": "Colour Poems",
      "AlternateTitle": "",
      "TitleArray": [
        "Colour Poems"
      ],
      "Year": "1974",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "815",
      "databaseFilmTitle": "Come and Go",
      "FilmTitle": "Come and Go",
      "AlternateTitle": "Vai~E~Vem",
      "TitleArray": [
        "Come and Go",
        "Vai~E~Vem"
      ],
      "Year": "2003",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "816",
      "databaseFilmTitle": "Come and See",
      "FilmTitle": "Come and See",
      "AlternateTitle": "",
      "TitleArray": [
        "Come and See"
      ],
      "Year": "1985",
      "Director": "Elem Klimov",
      "DirectorArray": [
        "Elem Klimov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "104",
      "2022votes": "29"
    },
    {
      "key": "817",
      "databaseFilmTitle": "Come Back to the Five and Dime Jimmy Dean, Jimmy Dean",
      "FilmTitle": "Come Back to the Five and Dime Jimmy Dean, Jimmy Dean",
      "AlternateTitle": "",
      "TitleArray": [
        "Come Back to the Five and Dime Jimmy Dean, Jimmy Dean"
      ],
      "Year": "1982",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "818",
      "databaseFilmTitle": "Come Back, Africa",
      "FilmTitle": "Come Back, Africa",
      "AlternateTitle": "",
      "TitleArray": [
        "Come Back, Africa"
      ],
      "Year": "1959",
      "Director": "Lionel Rogosin",
      "DirectorArray": [
        "Lionel Rogosin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "819",
      "databaseFilmTitle": "Coming Forth by Day",
      "FilmTitle": "Coming Forth by Day",
      "AlternateTitle": "Al-Khoroug Lel-Nahar",
      "TitleArray": [
        "Coming Forth by Day",
        "Al-Khoroug Lel-Nahar"
      ],
      "Year": "2013",
      "Director": "Hala Lotfy",
      "DirectorArray": [
        "Hala Lotfy"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "820",
      "databaseFilmTitle": "Coming to America",
      "FilmTitle": "Coming to America",
      "AlternateTitle": "",
      "TitleArray": [
        "Coming to America"
      ],
      "Year": "1988",
      "Director": "John Landis",
      "DirectorArray": [
        "John Landis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "821",
      "databaseFilmTitle": "Commingled Containers",
      "FilmTitle": "Commingled Containers",
      "AlternateTitle": "",
      "TitleArray": [
        "Commingled Containers"
      ],
      "Year": "1997",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "822",
      "databaseFilmTitle": "Common Ground",
      "FilmTitle": "Common Ground",
      "AlternateTitle": "",
      "TitleArray": [
        "Common Ground"
      ],
      "Year": "2019",
      "Director": "Darren Emerson",
      "DirectorArray": [
        "Darren Emerson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "823",
      "databaseFilmTitle": "Communion",
      "FilmTitle": "Communion",
      "AlternateTitle": "",
      "TitleArray": [
        "Communion"
      ],
      "Year": "1989",
      "Director": "Philippe Mora",
      "DirectorArray": [
        "Philippe Mora"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "824",
      "databaseFilmTitle": "Compañeros",
      "FilmTitle": "Compañeros",
      "AlternateTitle": "",
      "TitleArray": [
        "Compañeros"
      ],
      "Year": "1970",
      "Director": "Sergio Corbucci",
      "DirectorArray": [
        "Sergio Corbucci"
      ],
      "Country": "Italy, Spain",
      "CountryArray": [
        "Italy",
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "825",
      "databaseFilmTitle": "Compartment No. 6",
      "FilmTitle": "Compartment No. 6",
      "AlternateTitle": "Hytti nro 6",
      "TitleArray": [
        "Compartment No. 6",
        "Hytti nro 6"
      ],
      "Year": "2021",
      "Director": "Juho Kuosmanen",
      "DirectorArray": [
        "Juho Kuosmanen"
      ],
      "Country": "Finland, Estonia",
      "CountryArray": [
        "Finland",
        "Estonia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "826",
      "databaseFilmTitle": "Compensation",
      "FilmTitle": "Compensation",
      "AlternateTitle": "",
      "TitleArray": [
        "Compensation"
      ],
      "Year": "1999",
      "Director": "Zeinabu irene Davis",
      "DirectorArray": [
        "Zeinabu irene Davis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "827",
      "databaseFilmTitle": "Comrades",
      "FilmTitle": "Comrades",
      "AlternateTitle": "",
      "TitleArray": [
        "Comrades"
      ],
      "Year": "1986",
      "Director": "Bill Douglas",
      "DirectorArray": [
        "Bill Douglas"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "828",
      "databaseFilmTitle": "Comrades: Almost a Love Story",
      "FilmTitle": "Comrades: Almost a Love Story",
      "AlternateTitle": "Tian Mi Mi",
      "TitleArray": [
        "Comrades: Almost a Love Story",
        "Tian Mi Mi"
      ],
      "Year": "1996",
      "Director": "Peter Ho-Sun Chan",
      "DirectorArray": [
        "Peter Ho-Sun Chan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "829",
      "databaseFilmTitle": "Comradeship",
      "FilmTitle": "Comradeship",
      "AlternateTitle": "Kameradschaft",
      "TitleArray": [
        "Comradeship",
        "Kameradschaft"
      ],
      "Year": "1931",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany, France",
      "CountryArray": [
        "Germany",
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "830",
      "databaseFilmTitle": "Conan the Barbarian",
      "FilmTitle": "Conan the Barbarian",
      "AlternateTitle": "",
      "TitleArray": [
        "Conan the Barbarian"
      ],
      "Year": "1982",
      "Director": "John Milius",
      "DirectorArray": [
        "John Milius"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "831",
      "databaseFilmTitle": "Concentration",
      "FilmTitle": "Concentration",
      "AlternateTitle": "La concentration",
      "TitleArray": [
        "Concentration",
        "La concentration"
      ],
      "Year": "1986",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "832",
      "databaseFilmTitle": "Configuration in Black and White",
      "FilmTitle": "Configuration in Black and White",
      "AlternateTitle": "Konfiguration schwarz und weiss",
      "TitleArray": [
        "Configuration in Black and White",
        "Konfiguration schwarz und weiss"
      ],
      "Year": "2017",
      "Director": "Helga Fanderl",
      "DirectorArray": [
        "Helga Fanderl"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "833",
      "databaseFilmTitle": "Confrontation",
      "FilmTitle": "Confrontation",
      "AlternateTitle": "Konfrontation",
      "TitleArray": [
        "Confrontation",
        "Konfrontation"
      ],
      "Year": "1974",
      "Director": "Rolf Lyssy",
      "DirectorArray": [
        "Rolf Lyssy"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "834",
      "databaseFilmTitle": "Contact High",
      "FilmTitle": "Contact High",
      "AlternateTitle": "",
      "TitleArray": [
        "Contact High"
      ],
      "Year": "2009",
      "Director": "Michael Glawogger",
      "DirectorArray": [
        "Michael Glawogger"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "835",
      "databaseFilmTitle": "Contempt",
      "FilmTitle": "Contempt",
      "AlternateTitle": "Le mépris",
      "TitleArray": [
        "Contempt",
        "Le mépris"
      ],
      "Year": "1963",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "22",
      "2002votes": "9",
      "2012rank": "21",
      "2012votes": "43",
      "2022rank": "54",
      "2022votes": "44"
    },
    {
      "key": "836",
      "databaseFilmTitle": "Conversation Piece",
      "FilmTitle": "Conversation Piece",
      "AlternateTitle": "Gruppo di famiglia in un interno",
      "TitleArray": [
        "Conversation Piece",
        "Gruppo di famiglia in un interno"
      ],
      "Year": "1974",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "837",
      "databaseFilmTitle": "Convoy",
      "FilmTitle": "Convoy",
      "AlternateTitle": "",
      "TitleArray": [
        "Convoy"
      ],
      "Year": "1978",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "838",
      "databaseFilmTitle": "Cooley High",
      "FilmTitle": "Cooley High",
      "AlternateTitle": "",
      "TitleArray": [
        "Cooley High"
      ],
      "Year": "1975",
      "Director": "Michael Schultz",
      "DirectorArray": [
        "Michael Schultz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "839",
      "databaseFilmTitle": "Cops",
      "FilmTitle": "Cops",
      "AlternateTitle": "",
      "TitleArray": [
        "Cops"
      ],
      "Year": "1922",
      "Director": "Buster Keaton, Edward F. Cline",
      "DirectorArray": [
        "Buster Keaton",
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "840",
      "databaseFilmTitle": "Corn in Parliament",
      "FilmTitle": "Corn in Parliament",
      "AlternateTitle": "Mais im Bundeshuus - le génie helvétique",
      "TitleArray": [
        "Corn in Parliament",
        "Mais im Bundeshuus - le génie helvétique"
      ],
      "Year": "2003",
      "Director": "Jean-Stéphane Bron",
      "DirectorArray": [
        "Jean-Stéphane Bron"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "841",
      "databaseFilmTitle": "Corsage",
      "FilmTitle": "Corsage",
      "AlternateTitle": "",
      "TitleArray": [
        "Corsage"
      ],
      "Year": "2022",
      "Director": "Marie Kreutzer",
      "DirectorArray": [
        "Marie Kreutzer"
      ],
      "Country": "Austria, France",
      "CountryArray": [
        "Austria",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "842",
      "databaseFilmTitle": "Cosmic Ray",
      "FilmTitle": "Cosmic Ray",
      "AlternateTitle": "",
      "TitleArray": [
        "Cosmic Ray"
      ],
      "Year": "1962",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "843",
      "databaseFilmTitle": "Cosmopolis",
      "FilmTitle": "Cosmopolis",
      "AlternateTitle": "",
      "TitleArray": [
        "Cosmopolis"
      ],
      "Year": "2012",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "844",
      "databaseFilmTitle": "County Hospital",
      "FilmTitle": "County Hospital",
      "AlternateTitle": "",
      "TitleArray": [
        "County Hospital"
      ],
      "Year": "1932",
      "Director": "James Parrott",
      "DirectorArray": [
        "James Parrott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "845",
      "databaseFilmTitle": "Coup de Grace",
      "FilmTitle": "Coup de Grace",
      "AlternateTitle": "Tiro de gracia",
      "TitleArray": [
        "Coup de Grace",
        "Tiro de gracia"
      ],
      "Year": "1969",
      "Director": "Ricardo Becher",
      "DirectorArray": [
        "Ricardo Becher"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "846",
      "databaseFilmTitle": "Court",
      "FilmTitle": "Court",
      "AlternateTitle": "",
      "TitleArray": [
        "Court"
      ],
      "Year": "2014",
      "Director": "Chaitanya Tamhane",
      "DirectorArray": [
        "Chaitanya Tamhane"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "847",
      "databaseFilmTitle": "Cousin",
      "FilmTitle": "Cousin",
      "AlternateTitle": "",
      "TitleArray": [
        "Cousin"
      ],
      "Year": "1998",
      "Director": "Adam Elliot",
      "DirectorArray": [
        "Adam Elliot"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "848",
      "databaseFilmTitle": "Cousins",
      "FilmTitle": "Cousins",
      "AlternateTitle": "",
      "TitleArray": [
        "Cousins"
      ],
      "Year": "2021",
      "Director": "Ainsley Gardiner, Briar Grace Smith",
      "DirectorArray": [
        "Ainsley Gardiner",
        "Briar Grace Smith"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "849",
      "databaseFilmTitle": "Cow",
      "FilmTitle": "Cow",
      "AlternateTitle": "",
      "TitleArray": [
        "Cow"
      ],
      "Year": "2021",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "850",
      "databaseFilmTitle": "Cracking Up",
      "FilmTitle": "Cracking Up",
      "AlternateTitle": "Smorgasbord",
      "TitleArray": [
        "Cracking Up",
        "Smorgasbord"
      ],
      "Year": "1983",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "851",
      "databaseFilmTitle": "Crash",
      "FilmTitle": "Crash",
      "AlternateTitle": "",
      "TitleArray": [
        "Crash"
      ],
      "Year": "1996",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "852",
      "databaseFilmTitle": "Crazy",
      "FilmTitle": "Crazy",
      "AlternateTitle": "",
      "TitleArray": [
        "Crazy"
      ],
      "Year": "1999",
      "Director": "Heddy Honigmann",
      "DirectorArray": [
        "Heddy Honigmann"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "853",
      "databaseFilmTitle": "Crazy Lee",
      "FilmTitle": "Crazy Lee",
      "AlternateTitle": "Dachimawa Lee",
      "TitleArray": [
        "Crazy Lee",
        "Dachimawa Lee"
      ],
      "Year": "2008",
      "Director": "Ryoo Seung-wan",
      "DirectorArray": [
        "Ryoo Seung-wan"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "854",
      "databaseFilmTitle": "Cremaster 1",
      "FilmTitle": "Cremaster 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Cremaster 1"
      ],
      "Year": "1996",
      "Director": "Matthew Barney",
      "DirectorArray": [
        "Matthew Barney"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "855",
      "databaseFilmTitle": "Cría cuervos...",
      "FilmTitle": "Cría cuervos...",
      "AlternateTitle": "",
      "TitleArray": [
        "Cría cuervos..."
      ],
      "Year": "1976",
      "Director": "Carlos Saura",
      "DirectorArray": [
        "Carlos Saura"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "856",
      "databaseFilmTitle": "Cries and Whispers",
      "FilmTitle": "Cries and Whispers",
      "AlternateTitle": "Viskningar och rop",
      "TitleArray": [
        "Cries and Whispers",
        "Viskningar och rop"
      ],
      "Year": "1972",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "857",
      "databaseFilmTitle": "Crimes and Misdemeanors",
      "FilmTitle": "Crimes and Misdemeanors",
      "AlternateTitle": "",
      "TitleArray": [
        "Crimes and Misdemeanors"
      ],
      "Year": "1989",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "858",
      "databaseFilmTitle": "Crimewave",
      "FilmTitle": "Crimewave",
      "AlternateTitle": "",
      "TitleArray": [
        "Crimewave"
      ],
      "Year": "1985",
      "Director": "Sam Raimi",
      "DirectorArray": [
        "Sam Raimi"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "859",
      "databaseFilmTitle": "Crimson Gold",
      "FilmTitle": "Crimson Gold",
      "AlternateTitle": "Talaye sorkh",
      "TitleArray": [
        "Crimson Gold",
        "Talaye sorkh"
      ],
      "Year": "2003",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "860",
      "databaseFilmTitle": "Crip Camp",
      "FilmTitle": "Crip Camp",
      "AlternateTitle": "",
      "TitleArray": [
        "Crip Camp"
      ],
      "Year": "2020",
      "Director": "Nicole Newnham, James Lebrecht",
      "DirectorArray": [
        "Nicole Newnham",
        "James Lebrecht"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "861",
      "databaseFilmTitle": "Crooklyn",
      "FilmTitle": "Crooklyn",
      "AlternateTitle": "",
      "TitleArray": [
        "Crooklyn"
      ],
      "Year": "1994",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "862",
      "databaseFilmTitle": "Crossroads",
      "FilmTitle": "Crossroads",
      "AlternateTitle": "",
      "TitleArray": [
        "Crossroads"
      ],
      "Year": "1976",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "863",
      "databaseFilmTitle": "Crouching Tiger, Hidden Dragon",
      "FilmTitle": "Crouching Tiger, Hidden Dragon",
      "AlternateTitle": "Wo hu cang long",
      "TitleArray": [
        "Crouching Tiger, Hidden Dragon",
        "Wo hu cang long"
      ],
      "Year": "2000",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "China, Hong Kong",
      "CountryArray": [
        "China",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "864",
      "databaseFilmTitle": "Croupier",
      "FilmTitle": "Croupier",
      "AlternateTitle": "",
      "TitleArray": [
        "Croupier"
      ],
      "Year": "1998",
      "Director": "Mike Hodges",
      "DirectorArray": [
        "Mike Hodges"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "865",
      "databaseFilmTitle": "Crows and Sparrows",
      "FilmTitle": "Crows and Sparrows",
      "AlternateTitle": "Wuya yu maque",
      "TitleArray": [
        "Crows and Sparrows",
        "Wuya yu maque"
      ],
      "Year": "1949",
      "Director": "Zheng Junli",
      "DirectorArray": [
        "Zheng Junli"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "866",
      "databaseFilmTitle": "Cruising",
      "FilmTitle": "Cruising",
      "AlternateTitle": "",
      "TitleArray": [
        "Cruising"
      ],
      "Year": "1980",
      "Director": "William Friedkin",
      "DirectorArray": [
        "William Friedkin"
      ],
      "Country": "United States, West Germany",
      "CountryArray": [
        "United States",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "867",
      "databaseFilmTitle": "Crumb",
      "FilmTitle": "Crumb",
      "AlternateTitle": "",
      "TitleArray": [
        "Crumb"
      ],
      "Year": "1994",
      "Director": "Terry Zwigoff",
      "DirectorArray": [
        "Terry Zwigoff"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "868",
      "databaseFilmTitle": "Crush and Blush",
      "FilmTitle": "Crush and Blush",
      "AlternateTitle": "Misseu Hongdangmu",
      "TitleArray": [
        "Crush and Blush",
        "Misseu Hongdangmu"
      ],
      "Year": "2008",
      "Director": "Lee Kyoung-mi",
      "DirectorArray": [
        "Lee Kyoung-mi"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "869",
      "databaseFilmTitle": "Cry Macho",
      "FilmTitle": "Cry Macho",
      "AlternateTitle": "",
      "TitleArray": [
        "Cry Macho"
      ],
      "Year": "2021",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "870",
      "databaseFilmTitle": "Cry When it Happens",
      "FilmTitle": "Cry When it Happens",
      "AlternateTitle": "Llora cuando te pase",
      "TitleArray": [
        "Cry When it Happens",
        "Llora cuando te pase"
      ],
      "Year": "2010",
      "Director": "Laida Lertxundi",
      "DirectorArray": [
        "Laida Lertxundi"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "871",
      "databaseFilmTitle": "Crystal Gazing",
      "FilmTitle": "Crystal Gazing",
      "AlternateTitle": "",
      "TitleArray": [
        "Crystal Gazing"
      ],
      "Year": "1982",
      "Director": "Laura Mulvey, Peter Wollen",
      "DirectorArray": [
        "Laura Mulvey",
        "Peter Wollen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "872",
      "databaseFilmTitle": "Crystallization",
      "FilmTitle": "Crystallization",
      "AlternateTitle": "",
      "TitleArray": [
        "Crystallization"
      ],
      "Year": "1974",
      "Director": "Carroll Ballard",
      "DirectorArray": [
        "Carroll Ballard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "873",
      "databaseFilmTitle": "Csontváry",
      "FilmTitle": "Csontváry",
      "AlternateTitle": "",
      "TitleArray": [
        "Csontváry"
      ],
      "Year": "1980",
      "Director": "Zoltán Huszárik",
      "DirectorArray": [
        "Zoltán Huszárik"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "874",
      "databaseFilmTitle": "CTRL",
      "FilmTitle": "CTRL",
      "AlternateTitle": "",
      "TitleArray": [
        "CTRL"
      ],
      "Year": "2016",
      "Director": "David Kaskel, Nigel Townsend",
      "DirectorArray": [
        "David Kaskel",
        "Nigel Townsend"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "875",
      "databaseFilmTitle": "Cul-de-sac",
      "FilmTitle": "Cul-de-sac",
      "AlternateTitle": "",
      "TitleArray": [
        "Cul-de-sac"
      ],
      "Year": "1966",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "876",
      "databaseFilmTitle": "Culloden",
      "FilmTitle": "Culloden",
      "AlternateTitle": "",
      "TitleArray": [
        "Culloden"
      ],
      "Year": "1964",
      "Director": "Peter Watkins",
      "DirectorArray": [
        "Peter Watkins"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "877",
      "databaseFilmTitle": "‎Cunégonde Receives Her Family",
      "FilmTitle": "‎Cunégonde Receives Her Family",
      "AlternateTitle": "Cunegonde reçoit sa famille",
      "TitleArray": [
        "‎Cunégonde Receives Her Family",
        "Cunegonde reçoit sa famille"
      ],
      "Year": "1912",
      "Director": "(unknown)",
      "DirectorArray": [
        "(unknown)"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "878",
      "databaseFilmTitle": "Cure",
      "FilmTitle": "Cure",
      "AlternateTitle": "Kyua",
      "TitleArray": [
        "Cure",
        "Kyua"
      ],
      "Year": "1997",
      "Director": "Kiyoshi Kurosawa",
      "DirectorArray": [
        "Kiyoshi Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "879",
      "databaseFilmTitle": "Custody",
      "FilmTitle": "Custody",
      "AlternateTitle": "Jusqu'à la garde",
      "TitleArray": [
        "Custody",
        "Jusqu'à la garde"
      ],
      "Year": "2017",
      "Director": "Xavier Legrand",
      "DirectorArray": [
        "Xavier Legrand"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "880",
      "databaseFilmTitle": "Cut",
      "FilmTitle": "Cut",
      "AlternateTitle": "",
      "TitleArray": [
        "Cut"
      ],
      "Year": "2013",
      "Director": "Christoph Girardet, Matthias Müller",
      "DirectorArray": [
        "Christoph Girardet",
        "Matthias Müller"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "881",
      "databaseFilmTitle": "Cut-Off Movie",
      "FilmTitle": "Cut-Off Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "Cut-Off Movie"
      ],
      "Year": "1969",
      "Director": "Jun'ichi Okuyama",
      "DirectorArray": [
        "Jun'ichi Okuyama"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "882",
      "databaseFilmTitle": "Cycling Chronicles: Landscapes the Boy Saw",
      "FilmTitle": "Cycling Chronicles: Landscapes the Boy Saw",
      "AlternateTitle": "",
      "TitleArray": [
        "Cycling Chronicles: Landscapes the Boy Saw"
      ],
      "Year": "2004",
      "Director": "Kôji Wakamatsu",
      "DirectorArray": [
        "Kôji Wakamatsu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "883",
      "databaseFilmTitle": "Cyrano de Bergerac",
      "FilmTitle": "Cyrano de Bergerac",
      "AlternateTitle": "",
      "TitleArray": [
        "Cyrano de Bergerac"
      ],
      "Year": "1990",
      "Director": "Jean-Paul Rappeneau",
      "DirectorArray": [
        "Jean-Paul Rappeneau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "884",
      "databaseFilmTitle": "Dad's Dead",
      "FilmTitle": "Dad's Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "Dad's Dead"
      ],
      "Year": "2003",
      "Director": "Chris Shepherd",
      "DirectorArray": [
        "Chris Shepherd"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "885",
      "databaseFilmTitle": "Daddy Nostalgia",
      "FilmTitle": "Daddy Nostalgia",
      "AlternateTitle": "Daddy Nostalgie",
      "TitleArray": [
        "Daddy Nostalgia",
        "Daddy Nostalgie"
      ],
      "Year": "1990",
      "Director": "Bertrand Tavernier",
      "DirectorArray": [
        "Bertrand Tavernier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "886",
      "databaseFilmTitle": "Daguerréotypes",
      "FilmTitle": "Daguerréotypes",
      "AlternateTitle": "",
      "TitleArray": [
        "Daguerréotypes"
      ],
      "Year": "1975",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "887",
      "databaseFilmTitle": "Daïnah la métisse",
      "FilmTitle": "Daïnah la métisse",
      "AlternateTitle": "",
      "TitleArray": [
        "Daïnah la métisse"
      ],
      "Year": "1932",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "888",
      "databaseFilmTitle": "Daisies",
      "FilmTitle": "Daisies",
      "AlternateTitle": "Sedmikrásky",
      "TitleArray": [
        "Daisies",
        "Sedmikrásky"
      ],
      "Year": "1966",
      "Director": "Věra Chytilová",
      "DirectorArray": [
        "Věra Chytilová"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "28",
      "2022votes": "63"
    },
    {
      "key": "889",
      "databaseFilmTitle": "Daisy Doodad's Dial",
      "FilmTitle": "Daisy Doodad's Dial",
      "AlternateTitle": "",
      "TitleArray": [
        "Daisy Doodad's Dial"
      ],
      "Year": "1914",
      "Director": "Laurence Trimble",
      "DirectorArray": [
        "Laurence Trimble"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "890",
      "databaseFilmTitle": "Daisy Kenyon",
      "FilmTitle": "Daisy Kenyon",
      "AlternateTitle": "",
      "TitleArray": [
        "Daisy Kenyon"
      ],
      "Year": "1947",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "891",
      "databaseFilmTitle": "Dakota",
      "FilmTitle": "Dakota",
      "AlternateTitle": "",
      "TitleArray": [
        "Dakota"
      ],
      "Year": "1974",
      "Director": "Wim Verstappen",
      "DirectorArray": [
        "Wim Verstappen"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "892",
      "databaseFilmTitle": "Damnation",
      "FilmTitle": "Damnation",
      "AlternateTitle": "Kárhozat",
      "TitleArray": [
        "Damnation",
        "Kárhozat"
      ],
      "Year": "1988",
      "Director": "Béla Tarr",
      "DirectorArray": [
        "Béla Tarr"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "893",
      "databaseFilmTitle": "Dance, Girl, Dance",
      "FilmTitle": "Dance, Girl, Dance",
      "AlternateTitle": "",
      "TitleArray": [
        "Dance, Girl, Dance"
      ],
      "Year": "1940",
      "Director": "Dorothy Arzner",
      "DirectorArray": [
        "Dorothy Arzner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "894",
      "databaseFilmTitle": "Dancer in the Dark",
      "FilmTitle": "Dancer in the Dark",
      "AlternateTitle": "",
      "TitleArray": [
        "Dancer in the Dark"
      ],
      "Year": "2000",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "895",
      "databaseFilmTitle": "Dancers, Buildings and People in the Street",
      "FilmTitle": "Dancers, Buildings and People in the Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Dancers, Buildings and People in the Street"
      ],
      "Year": "1986",
      "Director": "Rudolph Burckhardt",
      "DirectorArray": [
        "Rudolph Burckhardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "896",
      "databaseFilmTitle": "Dances with Wolves",
      "FilmTitle": "Dances with Wolves",
      "AlternateTitle": "",
      "TitleArray": [
        "Dances with Wolves"
      ],
      "Year": "1990",
      "Director": "Kevin Costner",
      "DirectorArray": [
        "Kevin Costner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "897",
      "databaseFilmTitle": "Dandy Dust",
      "FilmTitle": "Dandy Dust",
      "AlternateTitle": "",
      "TitleArray": [
        "Dandy Dust"
      ],
      "Year": "1998",
      "Director": "A. Hans Scheirl",
      "DirectorArray": [
        "A. Hans Scheirl"
      ],
      "Country": "United Kingdom, Austria",
      "CountryArray": [
        "United Kingdom",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "898",
      "databaseFilmTitle": "Danger: Diabolik",
      "FilmTitle": "Danger: Diabolik",
      "AlternateTitle": "Diabolik",
      "TitleArray": [
        "Danger: Diabolik",
        "Diabolik"
      ],
      "Year": "1968",
      "Director": "Mario Bava",
      "DirectorArray": [
        "Mario Bava"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "899",
      "databaseFilmTitle": "Dangerous Encounters of the First Kind",
      "FilmTitle": "Dangerous Encounters of the First Kind",
      "AlternateTitle": "Di yi lei xing wei xian",
      "TitleArray": [
        "Dangerous Encounters of the First Kind",
        "Di yi lei xing wei xian"
      ],
      "Year": "1980",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "900",
      "databaseFilmTitle": "Dangerous Liaisons",
      "FilmTitle": "Dangerous Liaisons",
      "AlternateTitle": "",
      "TitleArray": [
        "Dangerous Liaisons"
      ],
      "Year": "1988",
      "Director": "Stephen Frears",
      "DirectorArray": [
        "Stephen Frears"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "901",
      "databaseFilmTitle": "Dark Water",
      "FilmTitle": "Dark Water",
      "AlternateTitle": "Honogurai mizu no soko kara",
      "TitleArray": [
        "Dark Water",
        "Honogurai mizu no soko kara"
      ],
      "Year": "2002",
      "Director": "Hideo Nakata",
      "DirectorArray": [
        "Hideo Nakata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "902",
      "databaseFilmTitle": "Darling",
      "FilmTitle": "Darling",
      "AlternateTitle": "",
      "TitleArray": [
        "Darling"
      ],
      "Year": "1965",
      "Director": "John Schlesinger",
      "DirectorArray": [
        "John Schlesinger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "903",
      "databaseFilmTitle": "Darwin's Nightmare",
      "FilmTitle": "Darwin's Nightmare",
      "AlternateTitle": "",
      "TitleArray": [
        "Darwin's Nightmare"
      ],
      "Year": "2004",
      "Director": "Hubert Sauper",
      "DirectorArray": [
        "Hubert Sauper"
      ],
      "Country": "Austria, Belgium",
      "CountryArray": [
        "Austria",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "904",
      "databaseFilmTitle": "Daughter of the Nile",
      "FilmTitle": "Daughter of the Nile",
      "AlternateTitle": "",
      "TitleArray": [
        "Daughter of the Nile"
      ],
      "Year": "1987",
      "Director": "Hsiao-Hsien Hou",
      "DirectorArray": [
        "Hsiao-Hsien Hou"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "905",
      "databaseFilmTitle": "Daughter Rite",
      "FilmTitle": "Daughter Rite",
      "AlternateTitle": "",
      "TitleArray": [
        "Daughter Rite"
      ],
      "Year": "1980",
      "Director": "Michelle Citron",
      "DirectorArray": [
        "Michelle Citron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "906",
      "databaseFilmTitle": "Daughter-in-Law",
      "FilmTitle": "Daughter-in-Law",
      "AlternateTitle": "Nevestka",
      "TitleArray": [
        "Daughter-in-Law",
        "Nevestka"
      ],
      "Year": "1972",
      "Director": "Khodzha Kuli Narliyev",
      "DirectorArray": [
        "Khodzha Kuli Narliyev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "907",
      "databaseFilmTitle": "Daughters of Darkness",
      "FilmTitle": "Daughters of Darkness",
      "AlternateTitle": "Les lèvres rouges",
      "TitleArray": [
        "Daughters of Darkness",
        "Les lèvres rouges"
      ],
      "Year": "1971",
      "Director": "Harry Kümel",
      "DirectorArray": [
        "Harry Kümel"
      ],
      "Country": "Belgium, West Germany",
      "CountryArray": [
        "Belgium",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "908",
      "databaseFilmTitle": "Daughters of the Dust",
      "FilmTitle": "Daughters of the Dust",
      "AlternateTitle": "",
      "TitleArray": [
        "Daughters of the Dust"
      ],
      "Year": "1991",
      "Director": "Julie Dash",
      "DirectorArray": [
        "Julie Dash"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "60",
      "2022votes": "42"
    },
    {
      "key": "909",
      "databaseFilmTitle": "David Copperfield",
      "FilmTitle": "David Copperfield",
      "AlternateTitle": "",
      "TitleArray": [
        "David Copperfield"
      ],
      "Year": "1922",
      "Director": "A.W. Sandberg",
      "DirectorArray": [
        "A.W. Sandberg"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "910",
      "databaseFilmTitle": "David Holzman's Diary",
      "FilmTitle": "David Holzman's Diary",
      "AlternateTitle": "",
      "TitleArray": [
        "David Holzman's Diary"
      ],
      "Year": "1967",
      "Director": "Jim McBride",
      "DirectorArray": [
        "Jim McBride"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "911",
      "databaseFilmTitle": "Dawn Breaks, Which Is No Small Thing",
      "FilmTitle": "Dawn Breaks, Which Is No Small Thing",
      "AlternateTitle": "Amanece, que no es poco",
      "TitleArray": [
        "Dawn Breaks, Which Is No Small Thing",
        "Amanece, que no es poco"
      ],
      "Year": "1989",
      "Director": "José Luis Cuerda",
      "DirectorArray": [
        "José Luis Cuerda"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "912",
      "databaseFilmTitle": "Dawn of the Dead",
      "FilmTitle": "Dawn of the Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "Dawn of the Dead"
      ],
      "Year": "1978",
      "Director": "George A. Romero",
      "DirectorArray": [
        "George A. Romero"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "913",
      "databaseFilmTitle": "Dawson City: Frozen Time",
      "FilmTitle": "Dawson City: Frozen Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Dawson City: Frozen Time"
      ],
      "Year": "2016",
      "Director": "Bill Morrison",
      "DirectorArray": [
        "Bill Morrison"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "914",
      "databaseFilmTitle": "Day by Day",
      "FilmTitle": "Day by Day",
      "AlternateTitle": "Les grands enfants",
      "TitleArray": [
        "Day by Day",
        "Les grands enfants"
      ],
      "Year": "1980",
      "Director": "Paul Tana",
      "DirectorArray": [
        "Paul Tana"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "915",
      "databaseFilmTitle": "Day for Night",
      "FilmTitle": "Day for Night",
      "AlternateTitle": "La Nuit américaine",
      "TitleArray": [
        "Day for Night",
        "La Nuit américaine"
      ],
      "Year": "1973",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "916",
      "databaseFilmTitle": "Day of the Dead",
      "FilmTitle": "Day of the Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "Day of the Dead"
      ],
      "Year": "1985",
      "Director": "George A. Romero",
      "DirectorArray": [
        "George A. Romero"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "917",
      "databaseFilmTitle": "Day of Wrath",
      "FilmTitle": "Day of Wrath",
      "AlternateTitle": "Vredens Dag",
      "TitleArray": [
        "Day of Wrath",
        "Vredens Dag"
      ],
      "Year": "1943",
      "Director": "Carl Theodor Dreyer",
      "DirectorArray": [
        "Carl Theodor Dreyer"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "918",
      "databaseFilmTitle": "Daybreak",
      "FilmTitle": "Daybreak",
      "AlternateTitle": "Tianming",
      "TitleArray": [
        "Daybreak",
        "Tianming"
      ],
      "Year": "1933",
      "Director": "Sun Yu",
      "DirectorArray": [
        "Sun Yu"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "919",
      "databaseFilmTitle": "Days (2020)",
      "FilmTitle": "Days",
      "AlternateTitle": "Rizi",
      "TitleArray": [
        "Days",
        "Rizi"
      ],
      "Year": "2020",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "920",
      "databaseFilmTitle": "Days and Nights in the Forest",
      "FilmTitle": "Days and Nights in the Forest",
      "AlternateTitle": "Aranyer Din Tatri",
      "TitleArray": [
        "Days and Nights in the Forest",
        "Aranyer Din Tatri"
      ],
      "Year": "1970",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "921",
      "databaseFilmTitle": "Days of Being Wild",
      "FilmTitle": "Days of Being Wild",
      "AlternateTitle": "A Fei zheng chuan",
      "TitleArray": [
        "Days of Being Wild",
        "A Fei zheng chuan"
      ],
      "Year": "1990",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "922",
      "databaseFilmTitle": "Days of Heaven",
      "FilmTitle": "Days of Heaven",
      "AlternateTitle": "",
      "TitleArray": [
        "Days of Heaven"
      ],
      "Year": "1978",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "153",
      "2022votes": "19"
    },
    {
      "key": "923",
      "databaseFilmTitle": "Days of Hope",
      "FilmTitle": "Days of Hope",
      "AlternateTitle": "",
      "TitleArray": [
        "Days of Hope"
      ],
      "Year": "1975",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "924",
      "databaseFilmTitle": "Dazed and Confused",
      "FilmTitle": "Dazed and Confused",
      "AlternateTitle": "",
      "TitleArray": [
        "Dazed and Confused"
      ],
      "Year": "1993",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "925",
      "databaseFilmTitle": "De Son Appartement",
      "FilmTitle": "De Son Appartement",
      "AlternateTitle": "",
      "TitleArray": [
        "De Son Appartement"
      ],
      "Year": "2007",
      "Director": "Jean-Claude Rousseau",
      "DirectorArray": [
        "Jean-Claude Rousseau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "926",
      "databaseFilmTitle": "Dead Alive",
      "FilmTitle": "Dead Alive",
      "AlternateTitle": "Braindead",
      "TitleArray": [
        "Dead Alive",
        "Braindead"
      ],
      "Year": "1992",
      "Director": "Peter Jackson",
      "DirectorArray": [
        "Peter Jackson"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "927",
      "databaseFilmTitle": "Dead End",
      "FilmTitle": "Dead End",
      "AlternateTitle": "",
      "TitleArray": [
        "Dead End"
      ],
      "Year": "1937",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "928",
      "databaseFilmTitle": "Dead Man",
      "FilmTitle": "Dead Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Dead Man"
      ],
      "Year": "1995",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "929",
      "databaseFilmTitle": "Dead or Alive 2: Birds",
      "FilmTitle": "Dead or Alive 2: Birds",
      "AlternateTitle": "Dead or Alive 2: Tôbôsha",
      "TitleArray": [
        "Dead or Alive 2: Birds",
        "Dead or Alive 2: Tôbôsha"
      ],
      "Year": "2000",
      "Director": "Takashi Miike",
      "DirectorArray": [
        "Takashi Miike"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "930",
      "databaseFilmTitle": "Dead Pigs",
      "FilmTitle": "Dead Pigs",
      "AlternateTitle": "",
      "TitleArray": [
        "Dead Pigs"
      ],
      "Year": "2018",
      "Director": "Cathy Yan",
      "DirectorArray": [
        "Cathy Yan"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "931",
      "databaseFilmTitle": "Dead Ringers",
      "FilmTitle": "Dead Ringers",
      "AlternateTitle": "",
      "TitleArray": [
        "Dead Ringers"
      ],
      "Year": "1988",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "932",
      "databaseFilmTitle": "Dead Souls",
      "FilmTitle": "Dead Souls",
      "AlternateTitle": "Si ling hun",
      "TitleArray": [
        "Dead Souls",
        "Si ling hun"
      ],
      "Year": "2018",
      "Director": "Wang Bing",
      "DirectorArray": [
        "Wang Bing"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "933",
      "databaseFilmTitle": "Deadlier Than the Male",
      "FilmTitle": "Deadlier Than the Male",
      "AlternateTitle": "Voici le temps des assassins...",
      "TitleArray": [
        "Deadlier Than the Male",
        "Voici le temps des assassins..."
      ],
      "Year": "1956",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "934",
      "databaseFilmTitle": "Deadlock",
      "FilmTitle": "Deadlock",
      "AlternateTitle": "",
      "TitleArray": [
        "Deadlock"
      ],
      "Year": "1970",
      "Director": "Roland Klick",
      "DirectorArray": [
        "Roland Klick"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "935",
      "databaseFilmTitle": "Deadpan",
      "FilmTitle": "Deadpan",
      "AlternateTitle": "",
      "TitleArray": [
        "Deadpan"
      ],
      "Year": "1997",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "936",
      "databaseFilmTitle": "Dear Diary",
      "FilmTitle": "Dear Diary",
      "AlternateTitle": "Caro diario",
      "TitleArray": [
        "Dear Diary",
        "Caro diario"
      ],
      "Year": "1993",
      "Director": "Nanni Moretti",
      "DirectorArray": [
        "Nanni Moretti"
      ],
      "Country": "Italy,",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "937",
      "databaseFilmTitle": "Dear Prudence",
      "FilmTitle": "Dear Prudence",
      "AlternateTitle": "Belle Épine",
      "TitleArray": [
        "Dear Prudence",
        "Belle Épine"
      ],
      "Year": "2010",
      "Director": "Rebecca Zlotowski",
      "DirectorArray": [
        "Rebecca Zlotowski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "938",
      "databaseFilmTitle": "Death Becomes Her",
      "FilmTitle": "Death Becomes Her",
      "AlternateTitle": "",
      "TitleArray": [
        "Death Becomes Her"
      ],
      "Year": "1992",
      "Director": "Robert Zemeckis",
      "DirectorArray": [
        "Robert Zemeckis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "939",
      "databaseFilmTitle": "Death by Hanging",
      "FilmTitle": "Death by Hanging",
      "AlternateTitle": "Kōshikei",
      "TitleArray": [
        "Death by Hanging",
        "Kōshikei"
      ],
      "Year": "1968",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "940",
      "databaseFilmTitle": "Death in the Land of Encantos",
      "FilmTitle": "Death in the Land of Encantos",
      "AlternateTitle": "Kagadanan sa banwaan ning mga engkanto",
      "TitleArray": [
        "Death in the Land of Encantos",
        "Kagadanan sa banwaan ning mga engkanto"
      ],
      "Year": "2007",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "941",
      "databaseFilmTitle": "Death in Venice",
      "FilmTitle": "Death in Venice",
      "AlternateTitle": "Morte a Venezia",
      "TitleArray": [
        "Death in Venice",
        "Morte a Venezia"
      ],
      "Year": "1971",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "942",
      "databaseFilmTitle": "Death of a Bureaucrat",
      "FilmTitle": "Death of a Bureaucrat",
      "AlternateTitle": "La muerte de un burócrata",
      "TitleArray": [
        "Death of a Bureaucrat",
        "La muerte de un burócrata"
      ],
      "Year": "1966",
      "Director": "Tomás Gutiérrez Alea",
      "DirectorArray": [
        "Tomás Gutiérrez Alea"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "943",
      "databaseFilmTitle": "Death of a Nation: The Timor Conspiracy",
      "FilmTitle": "Death of a Nation: The Timor Conspiracy",
      "AlternateTitle": "",
      "TitleArray": [
        "Death of a Nation: The Timor Conspiracy"
      ],
      "Year": "1994",
      "Director": "David Munro",
      "DirectorArray": [
        "David Munro"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "944",
      "databaseFilmTitle": "Death of the President",
      "FilmTitle": "Death of the President",
      "AlternateTitle": "Śmierć prezydenta",
      "TitleArray": [
        "Death of the President",
        "Śmierć prezydenta"
      ],
      "Year": "1977",
      "Director": "Jerzy Kawalerowicz",
      "DirectorArray": [
        "Jerzy Kawalerowicz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "945",
      "databaseFilmTitle": "Death Proof",
      "FilmTitle": "Death Proof",
      "AlternateTitle": "",
      "TitleArray": [
        "Death Proof"
      ],
      "Year": "2007",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "946",
      "databaseFilmTitle": "Decasia",
      "FilmTitle": "Decasia",
      "AlternateTitle": "",
      "TitleArray": [
        "Decasia"
      ],
      "Year": "2002",
      "Director": "Bill Morrison",
      "DirectorArray": [
        "Bill Morrison"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "947",
      "databaseFilmTitle": "Decoy",
      "FilmTitle": "Decoy",
      "AlternateTitle": "",
      "TitleArray": [
        "Decoy"
      ],
      "Year": "1946",
      "Director": "Jack Bernhard",
      "DirectorArray": [
        "Jack Bernhard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "948",
      "databaseFilmTitle": "Deep End",
      "FilmTitle": "Deep End",
      "AlternateTitle": "",
      "TitleArray": [
        "Deep End"
      ],
      "Year": "1970",
      "Director": "Jerzy Skolimowski",
      "DirectorArray": [
        "Jerzy Skolimowski"
      ],
      "Country": "United Kingdom, West Germany",
      "CountryArray": [
        "United Kingdom",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "949",
      "databaseFilmTitle": "Deep Red",
      "FilmTitle": "Deep Red",
      "AlternateTitle": "Profondo rosso",
      "TitleArray": [
        "Deep Red",
        "Profondo rosso"
      ],
      "Year": "1975",
      "Director": "Dario Argento",
      "DirectorArray": [
        "Dario Argento"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "950",
      "databaseFilmTitle": "Deep Throat",
      "FilmTitle": "Deep Throat",
      "AlternateTitle": "",
      "TitleArray": [
        "Deep Throat"
      ],
      "Year": "1972",
      "Director": "Gerard Damiano",
      "DirectorArray": [
        "Gerard Damiano"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "951",
      "databaseFilmTitle": "Deewaar",
      "FilmTitle": "Deewaar",
      "AlternateTitle": "",
      "TitleArray": [
        "Deewaar"
      ],
      "Year": "1975",
      "Director": "Yash Chopra",
      "DirectorArray": [
        "Yash Chopra"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "952",
      "databaseFilmTitle": "Delhi Durbar",
      "FilmTitle": "Delhi Durbar",
      "AlternateTitle": "",
      "TitleArray": [
        "Delhi Durbar"
      ],
      "Year": "1912",
      "Director": "(Unknown)",
      "DirectorArray": [
        "(Unknown)"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "953",
      "databaseFilmTitle": "Delicatessen",
      "FilmTitle": "Delicatessen",
      "AlternateTitle": "",
      "TitleArray": [
        "Delicatessen"
      ],
      "Year": "1991",
      "Director": "Jean-Pierre Jeunet, Marc Caro",
      "DirectorArray": [
        "Jean-Pierre Jeunet",
        "Marc Caro"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "954",
      "databaseFilmTitle": "Deliverance",
      "FilmTitle": "Deliverance",
      "AlternateTitle": "",
      "TitleArray": [
        "Deliverance"
      ],
      "Year": "1972",
      "Director": "John Boorman",
      "DirectorArray": [
        "John Boorman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "955",
      "databaseFilmTitle": "Demon Lover Diary",
      "FilmTitle": "Demon Lover Diary",
      "AlternateTitle": "",
      "TitleArray": [
        "Demon Lover Diary"
      ],
      "Year": "1980",
      "Director": "Joel DeMott",
      "DirectorArray": [
        "Joel DeMott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "956",
      "databaseFilmTitle": "Demonlover",
      "FilmTitle": "Demonlover",
      "AlternateTitle": "",
      "TitleArray": [
        "Demonlover"
      ],
      "Year": "2002",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "957",
      "databaseFilmTitle": "Departures",
      "FilmTitle": "Departures",
      "AlternateTitle": "Okuribito",
      "TitleArray": [
        "Departures",
        "Okuribito"
      ],
      "Year": "2008",
      "Director": "Yôjirô Takita",
      "DirectorArray": [
        "Yôjirô Takita"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "958",
      "databaseFilmTitle": "Der Depp",
      "FilmTitle": "Der Depp",
      "AlternateTitle": "The Fool",
      "TitleArray": [
        "Der Depp",
        "The Fool"
      ],
      "Year": "1982",
      "Director": "Herbert Achternbusch",
      "DirectorArray": [
        "Herbert Achternbusch"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "959",
      "databaseFilmTitle": "Dersu Uzala",
      "FilmTitle": "Dersu Uzala",
      "AlternateTitle": "",
      "TitleArray": [
        "Dersu Uzala"
      ],
      "Year": "1975",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Soviet Union, Japan",
      "CountryArray": [
        "Soviet Union",
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "960",
      "databaseFilmTitle": "Desert Hearts",
      "FilmTitle": "Desert Hearts",
      "AlternateTitle": "",
      "TitleArray": [
        "Desert Hearts"
      ],
      "Year": "1985",
      "Director": "Donna Deitch",
      "DirectorArray": [
        "Donna Deitch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "961",
      "databaseFilmTitle": "Design for Living",
      "FilmTitle": "Design for Living",
      "AlternateTitle": "",
      "TitleArray": [
        "Design for Living"
      ],
      "Year": "1933",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "962",
      "databaseFilmTitle": "Desperately Seeking Susan",
      "FilmTitle": "Desperately Seeking Susan",
      "AlternateTitle": "",
      "TitleArray": [
        "Desperately Seeking Susan"
      ],
      "Year": "1985",
      "Director": "Susan Seidelman",
      "DirectorArray": [
        "Susan Seidelman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "963",
      "databaseFilmTitle": "Destiny (1921)",
      "FilmTitle": "Destiny",
      "AlternateTitle": "Der müde Tod",
      "TitleArray": [
        "Destiny",
        "Der müde Tod"
      ],
      "Year": "1921",
      "Director": "Frtiz Lang",
      "DirectorArray": [
        "Frtiz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "964",
      "databaseFilmTitle": "Destiny (2006)",
      "FilmTitle": "Destiny",
      "AlternateTitle": "Kader",
      "TitleArray": [
        "Destiny",
        "Kader"
      ],
      "Year": "2006",
      "Director": "Zeki Demirkubuz",
      "DirectorArray": [
        "Zeki Demirkubuz"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "965",
      "databaseFilmTitle": "Destroy, She Said",
      "FilmTitle": "Destroy, She Said",
      "AlternateTitle": "Détruire, dit-elle",
      "TitleArray": [
        "Destroy, She Said",
        "Détruire, dit-elle"
      ],
      "Year": "1969",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "966",
      "databaseFilmTitle": "Détective",
      "FilmTitle": "Détective",
      "AlternateTitle": "",
      "TitleArray": [
        "Détective"
      ],
      "Year": "1985",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "967",
      "databaseFilmTitle": "Detour",
      "FilmTitle": "Detour",
      "AlternateTitle": "",
      "TitleArray": [
        "Detour"
      ],
      "Year": "1945",
      "Director": "Edgar G. Ulmer",
      "DirectorArray": [
        "Edgar G. Ulmer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "968",
      "databaseFilmTitle": "Devdas (1955)",
      "FilmTitle": "Devdas",
      "AlternateTitle": "",
      "TitleArray": [
        "Devdas"
      ],
      "Year": "1955",
      "Director": "Bimal Roy",
      "DirectorArray": [
        "Bimal Roy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "969",
      "databaseFilmTitle": "Devdas (2002)",
      "FilmTitle": "Devdas",
      "AlternateTitle": "",
      "TitleArray": [
        "Devdas"
      ],
      "Year": "2002",
      "Director": "Sanjay Leela Bhansali",
      "DirectorArray": [
        "Sanjay Leela Bhansali"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "970",
      "databaseFilmTitle": "Devil in Miss Jones",
      "FilmTitle": "Devil in Miss Jones",
      "AlternateTitle": "",
      "TitleArray": [
        "Devil in Miss Jones"
      ],
      "Year": "1973",
      "Director": "Gerard Damiano",
      "DirectorArray": [
        "Gerard Damiano"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "971",
      "databaseFilmTitle": "Devil in the Flesh",
      "FilmTitle": "Devil in the Flesh",
      "AlternateTitle": "Le diable au corps",
      "TitleArray": [
        "Devil in the Flesh",
        "Le diable au corps"
      ],
      "Year": "1947",
      "Director": "Claude Autant-Lara",
      "DirectorArray": [
        "Claude Autant-Lara"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "972",
      "databaseFilmTitle": "Devils on the Doorstep",
      "FilmTitle": "Devils on the Doorstep",
      "AlternateTitle": "Guizi lai le",
      "TitleArray": [
        "Devils on the Doorstep",
        "Guizi lai le"
      ],
      "Year": "2000",
      "Director": "Jiang Wen",
      "DirectorArray": [
        "Jiang Wen"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "973",
      "databaseFilmTitle": "Di Cavalcanti",
      "FilmTitle": "Di Cavalcanti",
      "AlternateTitle": "",
      "TitleArray": [
        "Di Cavalcanti"
      ],
      "Year": "1977",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "974",
      "databaseFilmTitle": "Diabolique",
      "FilmTitle": "Diabolique",
      "AlternateTitle": "Les diaboliques",
      "TitleArray": [
        "Diabolique",
        "Les diaboliques"
      ],
      "Year": "1955",
      "Director": "Henri-Georges Clouzot",
      "DirectorArray": [
        "Henri-Georges Clouzot"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "975",
      "databaseFilmTitle": "Dialogue with a Woman Departed",
      "FilmTitle": "Dialogue with a Woman Departed",
      "AlternateTitle": "",
      "TitleArray": [
        "Dialogue with a Woman Departed"
      ],
      "Year": "1980",
      "Director": "Leo Hurwitz",
      "DirectorArray": [
        "Leo Hurwitz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "976",
      "databaseFilmTitle": "Diamonds of the Night",
      "FilmTitle": "Diamonds of the Night",
      "AlternateTitle": "Démanty noci",
      "TitleArray": [
        "Diamonds of the Night",
        "Démanty noci"
      ],
      "Year": "1964",
      "Director": "Jan Němec",
      "DirectorArray": [
        "Jan Němec"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "977",
      "databaseFilmTitle": "Diary",
      "FilmTitle": "Diary",
      "AlternateTitle": "",
      "TitleArray": [
        "Diary"
      ],
      "Year": "1983",
      "Director": "David Perlov",
      "DirectorArray": [
        "David Perlov"
      ],
      "Country": "Israel",
      "CountryArray": [
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "978",
      "databaseFilmTitle": "Diary for my Loves",
      "FilmTitle": "Diary for my Loves",
      "AlternateTitle": "Napló szerelmeimnek",
      "TitleArray": [
        "Diary for my Loves",
        "Napló szerelmeimnek"
      ],
      "Year": "1987",
      "Director": "Márta Mészáros",
      "DirectorArray": [
        "Márta Mészáros"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "979",
      "databaseFilmTitle": "Diary of a Country Priest",
      "FilmTitle": "Diary of a Country Priest",
      "AlternateTitle": "Journal d'un curé de campagne",
      "TitleArray": [
        "Diary of a Country Priest",
        "Journal d'un curé de campagne"
      ],
      "Year": "1951",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "980",
      "databaseFilmTitle": "Diary of a Mad Housewife",
      "FilmTitle": "Diary of a Mad Housewife",
      "AlternateTitle": "",
      "TitleArray": [
        "Diary of a Mad Housewife"
      ],
      "Year": "1970",
      "Director": "Frank Perry",
      "DirectorArray": [
        "Frank Perry"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "981",
      "databaseFilmTitle": "Diary of a Pregnant Woman",
      "FilmTitle": "Diary of a Pregnant Woman",
      "AlternateTitle": "L'opéra-mouffe",
      "TitleArray": [
        "Diary of a Pregnant Woman",
        "L'opéra-mouffe"
      ],
      "Year": "1958",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "982",
      "databaseFilmTitle": "Die Hard",
      "FilmTitle": "Die Hard",
      "AlternateTitle": "",
      "TitleArray": [
        "Die Hard"
      ],
      "Year": "1988",
      "Director": "John McTiernan",
      "DirectorArray": [
        "John McTiernan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "983",
      "databaseFilmTitle": "Die Nibelungen: Siegfried",
      "FilmTitle": "Die Nibelungen: Siegfried",
      "AlternateTitle": "",
      "TitleArray": [
        "Die Nibelungen: Siegfried"
      ],
      "Year": "1924",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "984",
      "databaseFilmTitle": "Different",
      "FilmTitle": "Different",
      "AlternateTitle": "Diferente",
      "TitleArray": [
        "Different",
        "Diferente"
      ],
      "Year": "1961",
      "Director": "Luis María Delgado",
      "DirectorArray": [
        "Luis María Delgado"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "985",
      "databaseFilmTitle": "Dignity",
      "FilmTitle": "Dignity",
      "AlternateTitle": "Jom (ou L'Histoire d'un peuple)",
      "TitleArray": [
        "Dignity",
        "Jom (ou L'Histoire d'un peuple)"
      ],
      "Year": "1982",
      "Director": "Ababacar Samb-Makharam",
      "DirectorArray": [
        "Ababacar Samb-Makharam"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "986",
      "databaseFilmTitle": "Dil Se",
      "FilmTitle": "Dil Se",
      "AlternateTitle": "From the Heart",
      "TitleArray": [
        "Dil Se",
        "From the Heart"
      ],
      "Year": "1998",
      "Director": "Mani Ratnam",
      "DirectorArray": [
        "Mani Ratnam"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "987",
      "databaseFilmTitle": "Dillinger Is Dead",
      "FilmTitle": "Dillinger Is Dead",
      "AlternateTitle": "Dillinger è morto",
      "TitleArray": [
        "Dillinger Is Dead",
        "Dillinger è morto"
      ],
      "Year": "1969",
      "Director": "Marco Ferreri",
      "DirectorArray": [
        "Marco Ferreri"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "988",
      "databaseFilmTitle": "Dilwale Dulhania Le Jayenge",
      "FilmTitle": "Dilwale Dulhania Le Jayenge",
      "AlternateTitle": "",
      "TitleArray": [
        "Dilwale Dulhania Le Jayenge"
      ],
      "Year": "1995",
      "Director": "Aditya Chopra",
      "DirectorArray": [
        "Aditya Chopra"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "989",
      "databaseFilmTitle": "Dimensions of Dialogue",
      "FilmTitle": "Dimensions of Dialogue",
      "AlternateTitle": "Možnosti dialogu",
      "TitleArray": [
        "Dimensions of Dialogue",
        "Možnosti dialogu"
      ],
      "Year": "1983",
      "Director": "Jan Švankmajer",
      "DirectorArray": [
        "Jan Švankmajer"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "990",
      "databaseFilmTitle": "Dirty Dancing",
      "FilmTitle": "Dirty Dancing",
      "AlternateTitle": "",
      "TitleArray": [
        "Dirty Dancing"
      ],
      "Year": "1987",
      "Director": "Emile Ardolino",
      "DirectorArray": [
        "Emile Ardolino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "991",
      "databaseFilmTitle": "Dirty Harry",
      "FilmTitle": "Dirty Harry",
      "AlternateTitle": "",
      "TitleArray": [
        "Dirty Harry"
      ],
      "Year": "1971",
      "Director": "Don Siegel",
      "DirectorArray": [
        "Don Siegel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "992",
      "databaseFilmTitle": "Dirty Ho",
      "FilmTitle": "Dirty Ho",
      "AlternateTitle": "Lan tou He",
      "TitleArray": [
        "Dirty Ho",
        "Lan tou He"
      ],
      "Year": "1979",
      "Director": "Liu Chia-Liang",
      "DirectorArray": [
        "Liu Chia-Liang"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "993",
      "databaseFilmTitle": "Dishonored",
      "FilmTitle": "Dishonored",
      "AlternateTitle": "",
      "TitleArray": [
        "Dishonored"
      ],
      "Year": "1931",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "994",
      "databaseFilmTitle": "Disorder",
      "FilmTitle": "Disorder",
      "AlternateTitle": "Désordre",
      "TitleArray": [
        "Disorder",
        "Désordre"
      ],
      "Year": "1986",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "995",
      "databaseFilmTitle": "Disperse Exclamatory Phase",
      "FilmTitle": "Disperse Exclamatory Phase",
      "AlternateTitle": "La verifica incerta",
      "TitleArray": [
        "Disperse Exclamatory Phase",
        "La verifica incerta"
      ],
      "Year": "1965",
      "Director": "Gianfranco Baruchello, Alberto Grifi",
      "DirectorArray": [
        "Gianfranco Baruchello",
        "Alberto Grifi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "996",
      "databaseFilmTitle": "Distant",
      "FilmTitle": "Distant",
      "AlternateTitle": "Uzak",
      "TitleArray": [
        "Distant",
        "Uzak"
      ],
      "Year": "2002",
      "Director": "Nuri Bilge Ceylan",
      "DirectorArray": [
        "Nuri Bilge Ceylan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "997",
      "databaseFilmTitle": "Distant Drums",
      "FilmTitle": "Distant Drums",
      "AlternateTitle": "",
      "TitleArray": [
        "Distant Drums"
      ],
      "Year": "1951",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "998",
      "databaseFilmTitle": "Distant Voices, Still Lives",
      "FilmTitle": "Distant Voices, Still Lives",
      "AlternateTitle": "",
      "TitleArray": [
        "Distant Voices, Still Lives"
      ],
      "Year": "1988",
      "Director": "Terence Davies",
      "DirectorArray": [
        "Terence Davies"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "999",
      "databaseFilmTitle": "Divine Intervention",
      "FilmTitle": "Divine Intervention",
      "AlternateTitle": "Yadon ilaheyya",
      "TitleArray": [
        "Divine Intervention",
        "Yadon ilaheyya"
      ],
      "Year": "2002",
      "Director": "Elia Suleiman",
      "DirectorArray": [
        "Elia Suleiman"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1000",
      "databaseFilmTitle": "Divinity Gratis",
      "FilmTitle": "Divinity Gratis",
      "AlternateTitle": "",
      "TitleArray": [
        "Divinity Gratis"
      ],
      "Year": "1996",
      "Director": "Betzy Bromberg",
      "DirectorArray": [
        "Betzy Bromberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1001",
      "databaseFilmTitle": "Django",
      "FilmTitle": "Django",
      "AlternateTitle": "",
      "TitleArray": [
        "Django"
      ],
      "Year": "1966",
      "Director": "Sergio Corbucci",
      "DirectorArray": [
        "Sergio Corbucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1002",
      "databaseFilmTitle": "Django Kill... If You Live, Shoot!",
      "FilmTitle": "Django Kill... If You Live, Shoot!",
      "AlternateTitle": "Se sei vivo spara",
      "TitleArray": [
        "Django Kill... If You Live, Shoot!",
        "Se sei vivo spara"
      ],
      "Year": "1967",
      "Director": "Giulio Questi",
      "DirectorArray": [
        "Giulio Questi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1003",
      "databaseFilmTitle": "Do the Right Thing",
      "FilmTitle": "Do the Right Thing",
      "AlternateTitle": "",
      "TitleArray": [
        "Do the Right Thing"
      ],
      "Year": "1989",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "24",
      "2022votes": "67"
    },
    {
      "key": "1004",
      "databaseFilmTitle": "Doctor Zhivago",
      "FilmTitle": "Doctor Zhivago",
      "AlternateTitle": "",
      "TitleArray": [
        "Doctor Zhivago"
      ],
      "Year": "1965",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1005",
      "databaseFilmTitle": "Documenteur",
      "FilmTitle": "Documenteur",
      "AlternateTitle": "",
      "TitleArray": [
        "Documenteur"
      ],
      "Year": "1981",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1006",
      "databaseFilmTitle": "Dodes'ka-den",
      "FilmTitle": "Dodes'ka-den",
      "AlternateTitle": "",
      "TitleArray": [
        "Dodes'ka-den"
      ],
      "Year": "1970",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1007",
      "databaseFilmTitle": "Dodsworth",
      "FilmTitle": "Dodsworth",
      "AlternateTitle": "",
      "TitleArray": [
        "Dodsworth"
      ],
      "Year": "1936",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1008",
      "databaseFilmTitle": "Dog Day Afternoon",
      "FilmTitle": "Dog Day Afternoon",
      "AlternateTitle": "",
      "TitleArray": [
        "Dog Day Afternoon"
      ],
      "Year": "1975",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1009",
      "databaseFilmTitle": "Dog Star Man",
      "FilmTitle": "Dog Star Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Dog Star Man"
      ],
      "Year": "1964",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1010",
      "databaseFilmTitle": "Dogra Magra",
      "FilmTitle": "Dogra Magra",
      "AlternateTitle": "",
      "TitleArray": [
        "Dogra Magra"
      ],
      "Year": "1988",
      "Director": "Toshio Matsumoto",
      "DirectorArray": [
        "Toshio Matsumoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1011",
      "databaseFilmTitle": "Dogs in Space",
      "FilmTitle": "Dogs in Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Dogs in Space"
      ],
      "Year": "1986",
      "Director": "Richard Lowenstein",
      "DirectorArray": [
        "Richard Lowenstein"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1012",
      "databaseFilmTitle": "Dogtooth",
      "FilmTitle": "Dogtooth",
      "AlternateTitle": "Kynodontas",
      "TitleArray": [
        "Dogtooth",
        "Kynodontas"
      ],
      "Year": "2009",
      "Director": "Yorgos Lanthimos",
      "DirectorArray": [
        "Yorgos Lanthimos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1013",
      "databaseFilmTitle": "Dogville",
      "FilmTitle": "Dogville",
      "AlternateTitle": "",
      "TitleArray": [
        "Dogville"
      ],
      "Year": "2003",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1014",
      "databaseFilmTitle": "Dok smo bili tu",
      "FilmTitle": "Dok smo bili tu",
      "AlternateTitle": "",
      "TitleArray": [
        "Dok smo bili tu"
      ],
      "Year": "2022",
      "Director": "Suncica Fradelic",
      "DirectorArray": [
        "Suncica Fradelic"
      ],
      "Country": "Croatia",
      "CountryArray": [
        "Croatia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1015",
      "databaseFilmTitle": "Dolemite",
      "FilmTitle": "Dolemite",
      "AlternateTitle": "",
      "TitleArray": [
        "Dolemite"
      ],
      "Year": "1975",
      "Director": "D'Urville Martin",
      "DirectorArray": [
        "D'Urville Martin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1016",
      "databaseFilmTitle": "Domenica sera",
      "FilmTitle": "Domenica sera",
      "AlternateTitle": "",
      "TitleArray": [
        "Domenica sera"
      ],
      "Year": "1962",
      "Director": "Franco Piavoli",
      "DirectorArray": [
        "Franco Piavoli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1017",
      "databaseFilmTitle": "Domestic Violence",
      "FilmTitle": "Domestic Violence",
      "AlternateTitle": "",
      "TitleArray": [
        "Domestic Violence"
      ],
      "Year": "2001",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1018",
      "databaseFilmTitle": "Domino",
      "FilmTitle": "Domino",
      "AlternateTitle": "",
      "TitleArray": [
        "Domino"
      ],
      "Year": "2005",
      "Director": "Tony Scott",
      "DirectorArray": [
        "Tony Scott"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1019",
      "databaseFilmTitle": "Don't Grieve",
      "FilmTitle": "Don't Grieve",
      "AlternateTitle": "",
      "TitleArray": [
        "Don't Grieve"
      ],
      "Year": "1970",
      "Director": "Georgi Daneliya",
      "DirectorArray": [
        "Georgi Daneliya"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1020",
      "databaseFilmTitle": "Don't Look Back",
      "FilmTitle": "Don't Look Back",
      "AlternateTitle": "",
      "TitleArray": [
        "Don't Look Back"
      ],
      "Year": "1967",
      "Director": "D.A. Pennebaker",
      "DirectorArray": [
        "D.A. Pennebaker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1021",
      "databaseFilmTitle": "Don't Look Now",
      "FilmTitle": "Don't Look Now",
      "AlternateTitle": "",
      "TitleArray": [
        "Don't Look Now"
      ],
      "Year": "1973",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "United Kingdom, Italy",
      "CountryArray": [
        "United Kingdom",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "114",
      "2022votes": "27"
    },
    {
      "key": "1022",
      "databaseFilmTitle": "Don't Look Up",
      "FilmTitle": "Don't Look Up",
      "AlternateTitle": "",
      "TitleArray": [
        "Don't Look Up"
      ],
      "Year": "2021",
      "Director": "Adam McKay",
      "DirectorArray": [
        "Adam McKay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1023",
      "databaseFilmTitle": "Don't Torture a Duckling",
      "FilmTitle": "Don't Torture a Duckling",
      "AlternateTitle": "Non si sevizia un paperino",
      "TitleArray": [
        "Don't Torture a Duckling",
        "Non si sevizia un paperino"
      ],
      "Year": "1972",
      "Director": "Lucio Fulci",
      "DirectorArray": [
        "Lucio Fulci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1024",
      "databaseFilmTitle": "Dong",
      "FilmTitle": "Dong",
      "AlternateTitle": "",
      "TitleArray": [
        "Dong"
      ],
      "Year": "2006",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1025",
      "databaseFilmTitle": "Donkey Skin",
      "FilmTitle": "Donkey Skin",
      "AlternateTitle": "Peau d'âne",
      "TitleArray": [
        "Donkey Skin",
        "Peau d'âne"
      ],
      "Year": "1970",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1026",
      "databaseFilmTitle": "Donnie Darko",
      "FilmTitle": "Donnie Darko",
      "AlternateTitle": "",
      "TitleArray": [
        "Donnie Darko"
      ],
      "Year": "2001",
      "Director": "Richard Kelly",
      "DirectorArray": [
        "Richard Kelly"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1027",
      "databaseFilmTitle": "Donovan's Reef",
      "FilmTitle": "Donovan's Reef",
      "AlternateTitle": "",
      "TitleArray": [
        "Donovan's Reef"
      ],
      "Year": "1963",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1028",
      "databaseFilmTitle": "Doomed Love",
      "FilmTitle": "Doomed Love",
      "AlternateTitle": "Amor de Perdição",
      "TitleArray": [
        "Doomed Love",
        "Amor de Perdição"
      ],
      "Year": "1978",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1029",
      "databaseFilmTitle": "Dots",
      "FilmTitle": "Dots",
      "AlternateTitle": "",
      "TitleArray": [
        "Dots"
      ],
      "Year": "1940",
      "Director": "Norman McLaren",
      "DirectorArray": [
        "Norman McLaren"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1030",
      "databaseFilmTitle": "Double Indemnity",
      "FilmTitle": "Double Indemnity",
      "AlternateTitle": "",
      "TitleArray": [
        "Double Indemnity"
      ],
      "Year": "1944",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "1031",
      "databaseFilmTitle": "Double messieurs",
      "FilmTitle": "Double messieurs",
      "AlternateTitle": "",
      "TitleArray": [
        "Double messieurs"
      ],
      "Year": "1986",
      "Director": "Jean-François Stévenin",
      "DirectorArray": [
        "Jean-François Stévenin"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1032",
      "databaseFilmTitle": "Double Tide",
      "FilmTitle": "Double Tide",
      "AlternateTitle": "",
      "TitleArray": [
        "Double Tide"
      ],
      "Year": "2009",
      "Director": "Sharon Lockhart",
      "DirectorArray": [
        "Sharon Lockhart"
      ],
      "Country": "United States, Australia",
      "CountryArray": [
        "United States",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1033",
      "databaseFilmTitle": "Down and out in America",
      "FilmTitle": "Down and out in America",
      "AlternateTitle": "",
      "TitleArray": [
        "Down and out in America"
      ],
      "Year": "1986",
      "Director": "Lee Grant",
      "DirectorArray": [
        "Lee Grant"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1034",
      "databaseFilmTitle": "Down by Law",
      "FilmTitle": "Down by Law",
      "AlternateTitle": "",
      "TitleArray": [
        "Down by Law"
      ],
      "Year": "1986",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1035",
      "databaseFilmTitle": "Down Hear",
      "FilmTitle": "Down Hear",
      "AlternateTitle": "",
      "TitleArray": [
        "Down Hear"
      ],
      "Year": "1972",
      "Director": "Mike Henderson",
      "DirectorArray": [
        "Mike Henderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1036",
      "databaseFilmTitle": "Down There",
      "FilmTitle": "Down There",
      "AlternateTitle": "Là-bas",
      "TitleArray": [
        "Down There",
        "Là-bas"
      ],
      "Year": "2006",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1037",
      "databaseFilmTitle": "Dr. Jekyll and Mr. Hyde",
      "FilmTitle": "Dr. Jekyll and Mr. Hyde",
      "AlternateTitle": "",
      "TitleArray": [
        "Dr. Jekyll and Mr. Hyde"
      ],
      "Year": "1931",
      "Director": "Rouben Mamoulian",
      "DirectorArray": [
        "Rouben Mamoulian"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1038",
      "databaseFilmTitle": "Dr. Mabuse: the Gambler",
      "FilmTitle": "Dr. Mabuse: the Gambler",
      "AlternateTitle": "Dr. Mabuse, der Spieler",
      "TitleArray": [
        "Dr. Mabuse: the Gambler",
        "Dr. Mabuse, der Spieler"
      ],
      "Year": "1922",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1039",
      "databaseFilmTitle": "Dr. Strangelove, or: How I Learned to Stop Worrying and Love the Bomb",
      "FilmTitle": "Dr. Strangelove, or: How I Learned to Stop Worrying and Love the Bomb",
      "AlternateTitle": "",
      "TitleArray": [
        "Dr. Strangelove, or: How I Learned to Stop Worrying and Love the Bomb"
      ],
      "Year": "1964",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "1040",
      "databaseFilmTitle": "Dracula",
      "FilmTitle": "Dracula",
      "AlternateTitle": "",
      "TitleArray": [
        "Dracula"
      ],
      "Year": "1931",
      "Director": "Tod Browning",
      "DirectorArray": [
        "Tod Browning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1041",
      "databaseFilmTitle": "Dragnet Girl",
      "FilmTitle": "Dragnet Girl",
      "AlternateTitle": "Hijôsen no onna",
      "TitleArray": [
        "Dragnet Girl",
        "Hijôsen no onna"
      ],
      "Year": "1933",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1042",
      "databaseFilmTitle": "Dragon Inn",
      "FilmTitle": "Dragon Inn",
      "AlternateTitle": "Long men kezhan",
      "TitleArray": [
        "Dragon Inn",
        "Long men kezhan"
      ],
      "Year": "1967",
      "Director": "King Hu",
      "DirectorArray": [
        "King Hu"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1043",
      "databaseFilmTitle": "Dream of the Rarebit Fiend",
      "FilmTitle": "Dream of the Rarebit Fiend",
      "AlternateTitle": "",
      "TitleArray": [
        "Dream of the Rarebit Fiend"
      ],
      "Year": "1906",
      "Director": "Wallace McCutcheon, Edwin S. Porter",
      "DirectorArray": [
        "Wallace McCutcheon",
        "Edwin S. Porter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1044",
      "databaseFilmTitle": "Dream Street",
      "FilmTitle": "Dream Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Dream Street"
      ],
      "Year": "1921",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1045",
      "databaseFilmTitle": "Dreaming Rivers",
      "FilmTitle": "Dreaming Rivers",
      "AlternateTitle": "",
      "TitleArray": [
        "Dreaming Rivers"
      ],
      "Year": "1989",
      "Director": "Martina Attille",
      "DirectorArray": [
        "Martina Attille"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1046",
      "databaseFilmTitle": "Dreams of a Life",
      "FilmTitle": "Dreams of a Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Dreams of a Life"
      ],
      "Year": "2011",
      "Director": "Carol Morley",
      "DirectorArray": [
        "Carol Morley"
      ],
      "Country": "United Kingdom, Ireland",
      "CountryArray": [
        "United Kingdom",
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1047",
      "databaseFilmTitle": "Dresden Dynamo",
      "FilmTitle": "Dresden Dynamo",
      "AlternateTitle": "",
      "TitleArray": [
        "Dresden Dynamo"
      ],
      "Year": "1971",
      "Director": "Los Rhodes",
      "DirectorArray": [
        "Los Rhodes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1048",
      "databaseFilmTitle": "Drifting Clouds",
      "FilmTitle": "Drifting Clouds",
      "AlternateTitle": "Kauas pilvet karkaavat",
      "TitleArray": [
        "Drifting Clouds",
        "Kauas pilvet karkaavat"
      ],
      "Year": "1996",
      "Director": "Aki Kaurismäki",
      "DirectorArray": [
        "Aki Kaurismäki"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1049",
      "databaseFilmTitle": "Drive",
      "FilmTitle": "Drive",
      "AlternateTitle": "",
      "TitleArray": [
        "Drive"
      ],
      "Year": "2011",
      "Director": "Nicolas Winding Refn",
      "DirectorArray": [
        "Nicolas Winding Refn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1050",
      "databaseFilmTitle": "Drive My Car",
      "FilmTitle": "Drive My Car",
      "AlternateTitle": "",
      "TitleArray": [
        "Drive My Car"
      ],
      "Year": "2021",
      "Director": "Ryusuke Hamaguchi",
      "DirectorArray": [
        "Ryusuke Hamaguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1051",
      "databaseFilmTitle": "Drug War",
      "FilmTitle": "Drug War",
      "AlternateTitle": "Du zhan",
      "TitleArray": [
        "Drug War",
        "Du zhan"
      ],
      "Year": "2012",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong, China",
      "CountryArray": [
        "Hong Kong",
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1052",
      "databaseFilmTitle": "Drugstore Romance",
      "FilmTitle": "Drugstore Romance",
      "AlternateTitle": "Corps à cœur",
      "TitleArray": [
        "Drugstore Romance",
        "Corps à cœur"
      ],
      "Year": "1979",
      "Director": "Paul Vecchiali",
      "DirectorArray": [
        "Paul Vecchiali"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1053",
      "databaseFilmTitle": "Drunken Angel",
      "FilmTitle": "Drunken Angel",
      "AlternateTitle": "Yoidore tenshi",
      "TitleArray": [
        "Drunken Angel",
        "Yoidore tenshi"
      ],
      "Year": "1948",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1054",
      "databaseFilmTitle": "Drunken Master II",
      "FilmTitle": "Drunken Master II",
      "AlternateTitle": "Jui kuien II",
      "TitleArray": [
        "Drunken Master II",
        "Jui kuien II"
      ],
      "Year": "1994",
      "Director": "Lau Kar-leung",
      "DirectorArray": [
        "Lau Kar-leung"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1055",
      "databaseFilmTitle": "Drunktown's Finest",
      "FilmTitle": "Drunktown's Finest",
      "AlternateTitle": "",
      "TitleArray": [
        "Drunktown's Finest"
      ],
      "Year": "2014",
      "Director": "Sydney Freeland",
      "DirectorArray": [
        "Sydney Freeland"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1056",
      "databaseFilmTitle": "Dry Season",
      "FilmTitle": "Dry Season",
      "AlternateTitle": "Daratt",
      "TitleArray": [
        "Dry Season",
        "Daratt"
      ],
      "Year": "2006",
      "Director": "Mahamat-Saleh Haroun",
      "DirectorArray": [
        "Mahamat-Saleh Haroun"
      ],
      "Country": "Chad, France",
      "CountryArray": [
        "Chad",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1057",
      "databaseFilmTitle": "Du côté d'Orouët",
      "FilmTitle": "Du côté d'Orouët",
      "AlternateTitle": "",
      "TitleArray": [
        "Du côté d'Orouët"
      ],
      "Year": "1973",
      "Director": "Jacques Rozier",
      "DirectorArray": [
        "Jacques Rozier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1058",
      "databaseFilmTitle": "Duck Amuck",
      "FilmTitle": "Duck Amuck",
      "AlternateTitle": "",
      "TitleArray": [
        "Duck Amuck"
      ],
      "Year": "1953",
      "Director": "Chuck Jones",
      "DirectorArray": [
        "Chuck Jones"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1059",
      "databaseFilmTitle": "Duck Soup",
      "FilmTitle": "Duck Soup",
      "AlternateTitle": "",
      "TitleArray": [
        "Duck Soup"
      ],
      "Year": "1933",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "1060",
      "databaseFilmTitle": "Duel",
      "FilmTitle": "Duel",
      "AlternateTitle": "",
      "TitleArray": [
        "Duel"
      ],
      "Year": "1971",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1061",
      "databaseFilmTitle": "Duel in the Sun",
      "FilmTitle": "Duel in the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Duel in the Sun"
      ],
      "Year": "1946",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1062",
      "databaseFilmTitle": "Duelle",
      "FilmTitle": "Duelle",
      "AlternateTitle": "une quarantaine",
      "TitleArray": [
        "Duelle",
        "une quarantaine"
      ],
      "Year": "1976",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1063",
      "databaseFilmTitle": "Dumbo",
      "FilmTitle": "Dumbo",
      "AlternateTitle": "",
      "TitleArray": [
        "Dumbo"
      ],
      "Year": "1941",
      "Director": "Samuel Armstrong, Norman Ferguson, Wilfred Jackson, Jack Kinney, Bill Roberts, Ben Sharpsteen",
      "DirectorArray": [
        "Samuel Armstrong",
        "Norman Ferguson",
        "Wilfred Jackson",
        "Jack Kinney",
        "Bill Roberts",
        "Ben Sharpsteen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1064",
      "databaseFilmTitle": "Dumplings",
      "FilmTitle": "Dumplings",
      "AlternateTitle": "Gau ji",
      "TitleArray": [
        "Dumplings",
        "Gau ji"
      ],
      "Year": "2004",
      "Director": "Fruit Chan",
      "DirectorArray": [
        "Fruit Chan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1065",
      "databaseFilmTitle": "Dune (1984)",
      "FilmTitle": "Dune",
      "AlternateTitle": "",
      "TitleArray": [
        "Dune"
      ],
      "Year": "1984",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1066",
      "databaseFilmTitle": "Dust",
      "FilmTitle": "Dust",
      "AlternateTitle": "",
      "TitleArray": [
        "Dust"
      ],
      "Year": "1985",
      "Director": "Marion Hänsel",
      "DirectorArray": [
        "Marion Hänsel"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1067",
      "databaseFilmTitle": "Dust in the Wind",
      "FilmTitle": "Dust in the Wind",
      "AlternateTitle": "Liàn liàn fengchén",
      "TitleArray": [
        "Dust in the Wind",
        "Liàn liàn fengchén"
      ],
      "Year": "1986",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1068",
      "databaseFilmTitle": "Duvidha",
      "FilmTitle": "Duvidha",
      "AlternateTitle": "",
      "TitleArray": [
        "Duvidha"
      ],
      "Year": "1973",
      "Director": "Mani Kaul",
      "DirectorArray": [
        "Mani Kaul"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1069",
      "databaseFilmTitle": "Dwelling in the Fuchun Mountains",
      "FilmTitle": "Dwelling in the Fuchun Mountains",
      "AlternateTitle": "Chun jiang shui nuan",
      "TitleArray": [
        "Dwelling in the Fuchun Mountains",
        "Chun jiang shui nuan"
      ],
      "Year": "2019",
      "Director": "Gu Xiaogang",
      "DirectorArray": [
        "Gu Xiaogang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1070",
      "databaseFilmTitle": "Dyketactics",
      "FilmTitle": "Dyketactics",
      "AlternateTitle": "",
      "TitleArray": [
        "Dyketactics"
      ],
      "Year": "1973",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1071",
      "databaseFilmTitle": "E.T.: The Extra-Terrestrial",
      "FilmTitle": "E.T.: The Extra-Terrestrial",
      "AlternateTitle": "",
      "TitleArray": [
        "E.T.: The Extra-Terrestrial"
      ],
      "Year": "1982",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1072",
      "databaseFilmTitle": "ear for eye",
      "FilmTitle": "ear for eye",
      "AlternateTitle": "",
      "TitleArray": [
        "ear for eye"
      ],
      "Year": "2021",
      "Director": "Debbie Tucker Green",
      "DirectorArray": [
        "Debbie Tucker Green"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1073",
      "databaseFilmTitle": "Early Summer",
      "FilmTitle": "Early Summer",
      "AlternateTitle": "Bakushū",
      "TitleArray": [
        "Early Summer",
        "Bakushū"
      ],
      "Year": "1951",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1074",
      "databaseFilmTitle": "Ears, Nose and Throat",
      "FilmTitle": "Ears, Nose and Throat",
      "AlternateTitle": "",
      "TitleArray": [
        "Ears, Nose and Throat"
      ],
      "Year": "2016",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1075",
      "databaseFilmTitle": "Earth",
      "FilmTitle": "Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "Earth"
      ],
      "Year": "1930",
      "Director": "Aleksandr Dovzhenko",
      "DirectorArray": [
        "Aleksandr Dovzhenko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "19",
      "1952votes": "7",
      "1962rank": "18",
      "1962votes": "8",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "1076",
      "databaseFilmTitle": "Earth II",
      "FilmTitle": "Earth II",
      "AlternateTitle": "",
      "TitleArray": [
        "Earth II"
      ],
      "Year": "2022",
      "Director": "Anti-Banality Union",
      "DirectorArray": [
        "Anti-Banality Union"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1077",
      "databaseFilmTitle": "Earthlings",
      "FilmTitle": "Earthlings",
      "AlternateTitle": "",
      "TitleArray": [
        "Earthlings"
      ],
      "Year": "2007",
      "Director": "Shaun Monson",
      "DirectorArray": [
        "Shaun Monson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1078",
      "databaseFilmTitle": "East of Eden",
      "FilmTitle": "East of Eden",
      "AlternateTitle": "",
      "TitleArray": [
        "East of Eden"
      ],
      "Year": "1955",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1079",
      "databaseFilmTitle": "Easter Parade",
      "FilmTitle": "Easter Parade",
      "AlternateTitle": "",
      "TitleArray": [
        "Easter Parade"
      ],
      "Year": "1948",
      "Director": "Charles Walters",
      "DirectorArray": [
        "Charles Walters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1080",
      "databaseFilmTitle": "Easy Living",
      "FilmTitle": "Easy Living",
      "AlternateTitle": "",
      "TitleArray": [
        "Easy Living"
      ],
      "Year": "1937",
      "Director": "Mitchell Leisen",
      "DirectorArray": [
        "Mitchell Leisen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1081",
      "databaseFilmTitle": "Easy Rider",
      "FilmTitle": "Easy Rider",
      "AlternateTitle": "",
      "TitleArray": [
        "Easy Rider"
      ],
      "Year": "1969",
      "Director": "Dennis Hopper",
      "DirectorArray": [
        "Dennis Hopper"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1082",
      "databaseFilmTitle": "Easy Street",
      "FilmTitle": "Easy Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Easy Street"
      ],
      "Year": "1917",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1083",
      "databaseFilmTitle": "Ebola Syndrome",
      "FilmTitle": "Ebola Syndrome",
      "AlternateTitle": "Yi boh lai beng duk",
      "TitleArray": [
        "Ebola Syndrome",
        "Yi boh lai beng duk"
      ],
      "Year": "1996",
      "Director": "Herman Yau",
      "DirectorArray": [
        "Herman Yau"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1084",
      "databaseFilmTitle": "Ecstasy of the Angels",
      "FilmTitle": "Ecstasy of the Angels",
      "AlternateTitle": "Tenshi no kokotsu",
      "TitleArray": [
        "Ecstasy of the Angels",
        "Tenshi no kokotsu"
      ],
      "Year": "1972",
      "Director": "Kôji Wakamatsu",
      "DirectorArray": [
        "Kôji Wakamatsu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1085",
      "databaseFilmTitle": "Ed Wood",
      "FilmTitle": "Ed Wood",
      "AlternateTitle": "",
      "TitleArray": [
        "Ed Wood"
      ],
      "Year": "1994",
      "Director": "Tim Burton",
      "DirectorArray": [
        "Tim Burton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1086",
      "databaseFilmTitle": "Eden",
      "FilmTitle": "Eden",
      "AlternateTitle": "",
      "TitleArray": [
        "Eden"
      ],
      "Year": "2014",
      "Director": "Mia Hansen-Løve",
      "DirectorArray": [
        "Mia Hansen-Løve"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1087",
      "databaseFilmTitle": "Edvard Munch",
      "FilmTitle": "Edvard Munch",
      "AlternateTitle": "",
      "TitleArray": [
        "Edvard Munch"
      ],
      "Year": "1974",
      "Director": "Peter Watkins",
      "DirectorArray": [
        "Peter Watkins"
      ],
      "Country": "Norway, Sweden",
      "CountryArray": [
        "Norway",
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1088",
      "databaseFilmTitle": "Edward and Caroline",
      "FilmTitle": "Edward and Caroline",
      "AlternateTitle": "Édouard et Caroline",
      "TitleArray": [
        "Edward and Caroline",
        "Édouard et Caroline"
      ],
      "Year": "1951",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1089",
      "databaseFilmTitle": "Edward II",
      "FilmTitle": "Edward II",
      "AlternateTitle": "",
      "TitleArray": [
        "Edward II"
      ],
      "Year": "1991",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1090",
      "databaseFilmTitle": "Edward Scissorhands",
      "FilmTitle": "Edward Scissorhands",
      "AlternateTitle": "",
      "TitleArray": [
        "Edward Scissorhands"
      ],
      "Year": "1990",
      "Director": "Tim Burton",
      "DirectorArray": [
        "Tim Burton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1091",
      "databaseFilmTitle": "Eega",
      "FilmTitle": "Eega",
      "AlternateTitle": "",
      "TitleArray": [
        "Eega"
      ],
      "Year": "2012",
      "Director": "S.S. Rajamouli, J. V. V. Sathyanarayana Murthi",
      "DirectorArray": [
        "S.S. Rajamouli",
        "J. V. V. Sathyanarayana Murthi"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1092",
      "databaseFilmTitle": "Effi Briest",
      "FilmTitle": "Effi Briest",
      "AlternateTitle": "Fontane Effi Briest",
      "TitleArray": [
        "Effi Briest",
        "Fontane Effi Briest"
      ],
      "Year": "1974",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1093",
      "databaseFilmTitle": "Egyptian Series",
      "FilmTitle": "Egyptian Series",
      "AlternateTitle": "",
      "TitleArray": [
        "Egyptian Series"
      ],
      "Year": "1984",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1094",
      "databaseFilmTitle": "Eight Deadly Shots",
      "FilmTitle": "Eight Deadly Shots",
      "AlternateTitle": "Kahdeksan surmanluotia",
      "TitleArray": [
        "Eight Deadly Shots",
        "Kahdeksan surmanluotia"
      ],
      "Year": "1972",
      "Director": "Mikko Niskanen",
      "DirectorArray": [
        "Mikko Niskanen"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1095",
      "databaseFilmTitle": "Eijanaika",
      "FilmTitle": "Eijanaika",
      "AlternateTitle": "",
      "TitleArray": [
        "Eijanaika"
      ],
      "Year": "1981",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1096",
      "databaseFilmTitle": "Eika Katappa",
      "FilmTitle": "Eika Katappa",
      "AlternateTitle": "",
      "TitleArray": [
        "Eika Katappa"
      ],
      "Year": "1969",
      "Director": "Werner Schroeter",
      "DirectorArray": [
        "Werner Schroeter"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1097",
      "databaseFilmTitle": "Él",
      "FilmTitle": "Él",
      "AlternateTitle": "This Strange Passion",
      "TitleArray": [
        "Él",
        "This Strange Passion"
      ],
      "Year": "1953",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1098",
      "databaseFilmTitle": "El Cid",
      "FilmTitle": "El Cid",
      "AlternateTitle": "",
      "TitleArray": [
        "El Cid"
      ],
      "Year": "1961",
      "Director": "Anthony Mann",
      "DirectorArray": [
        "Anthony Mann"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1099",
      "databaseFilmTitle": "El Dorado",
      "FilmTitle": "El Dorado",
      "AlternateTitle": "",
      "TitleArray": [
        "El Dorado"
      ],
      "Year": "1967",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1100",
      "databaseFilmTitle": "El Norte",
      "FilmTitle": "El Norte",
      "AlternateTitle": "",
      "TitleArray": [
        "El Norte"
      ],
      "Year": "1983",
      "Director": "Gregory Nava",
      "DirectorArray": [
        "Gregory Nava"
      ],
      "Country": "Guatemala, United States",
      "CountryArray": [
        "Guatemala",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1101",
      "databaseFilmTitle": "El sur",
      "FilmTitle": "El sur",
      "AlternateTitle": "",
      "TitleArray": [
        "El sur"
      ],
      "Year": "1983",
      "Director": "Víctor Erice",
      "DirectorArray": [
        "Víctor Erice"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1102",
      "databaseFilmTitle": "El topo",
      "FilmTitle": "El topo",
      "AlternateTitle": "",
      "TitleArray": [
        "El topo"
      ],
      "Year": "1970",
      "Director": "Alejandro Jodorowsky",
      "DirectorArray": [
        "Alejandro Jodorowsky"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1103",
      "databaseFilmTitle": "Election",
      "FilmTitle": "Election",
      "AlternateTitle": "Hak se wooi",
      "TitleArray": [
        "Election",
        "Hak se wooi"
      ],
      "Year": "2005",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1104",
      "databaseFilmTitle": "Elena and Her Men",
      "FilmTitle": "Elena and Her Men",
      "AlternateTitle": "Elena et les hommes",
      "TitleArray": [
        "Elena and Her Men",
        "Elena et les hommes"
      ],
      "Year": "1956",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1105",
      "databaseFilmTitle": "Elephant",
      "FilmTitle": "Elephant",
      "AlternateTitle": "",
      "TitleArray": [
        "Elephant"
      ],
      "Year": "2003",
      "Director": "Gus Van Sant",
      "DirectorArray": [
        "Gus Van Sant"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1106",
      "databaseFilmTitle": "Elevator Girls in Bondage",
      "FilmTitle": "Elevator Girls in Bondage",
      "AlternateTitle": "",
      "TitleArray": [
        "Elevator Girls in Bondage"
      ],
      "Year": "1972",
      "Director": "Michael Kalman",
      "DirectorArray": [
        "Michael Kalman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1107",
      "databaseFilmTitle": "Elevator to the Gallows",
      "FilmTitle": "Elevator to the Gallows",
      "AlternateTitle": "Ascenseur pour l'échafaud",
      "TitleArray": [
        "Elevator to the Gallows",
        "Ascenseur pour l'échafaud"
      ],
      "Year": "1958",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1108",
      "databaseFilmTitle": "Eleven Miles",
      "FilmTitle": "Eleven Miles",
      "AlternateTitle": "Egaro Mile",
      "TitleArray": [
        "Eleven Miles",
        "Egaro Mile"
      ],
      "Year": "1991",
      "Director": "Ruchir Joshi",
      "DirectorArray": [
        "Ruchir Joshi"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1109",
      "databaseFilmTitle": "Elite Squad",
      "FilmTitle": "Elite Squad",
      "AlternateTitle": "Tropa de Elite",
      "TitleArray": [
        "Elite Squad",
        "Tropa de Elite"
      ],
      "Year": "2007",
      "Director": "José Padilha",
      "DirectorArray": [
        "José Padilha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1110",
      "databaseFilmTitle": "Elle",
      "FilmTitle": "Elle",
      "AlternateTitle": "",
      "TitleArray": [
        "Elle"
      ],
      "Year": "2016",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1111",
      "databaseFilmTitle": "Elvira Madigan",
      "FilmTitle": "Elvira Madigan",
      "AlternateTitle": "",
      "TitleArray": [
        "Elvira Madigan"
      ],
      "Year": "1967",
      "Director": "Bo Widerberg",
      "DirectorArray": [
        "Bo Widerberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1112",
      "databaseFilmTitle": "Elysium",
      "FilmTitle": "Elysium",
      "AlternateTitle": "",
      "TitleArray": [
        "Elysium"
      ],
      "Year": "2013",
      "Director": "Neill Blomkamp",
      "DirectorArray": [
        "Neill Blomkamp"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1113",
      "databaseFilmTitle": "Embrace of the Serpent",
      "FilmTitle": "Embrace of the Serpent",
      "AlternateTitle": "El abrazo de la serpiente",
      "TitleArray": [
        "Embrace of the Serpent",
        "El abrazo de la serpiente"
      ],
      "Year": "2015",
      "Director": "Ciro Guerra",
      "DirectorArray": [
        "Ciro Guerra"
      ],
      "Country": "Colombia, Venezuela",
      "CountryArray": [
        "Colombia",
        "Venezuela"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1114",
      "databaseFilmTitle": "Emitaï",
      "FilmTitle": "Emitaï",
      "AlternateTitle": "",
      "TitleArray": [
        "Emitaï"
      ],
      "Year": "1971",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1115",
      "databaseFilmTitle": "Emmanuelle",
      "FilmTitle": "Emmanuelle",
      "AlternateTitle": "",
      "TitleArray": [
        "Emmanuelle"
      ],
      "Year": "1974",
      "Director": "Just Jaeckin",
      "DirectorArray": [
        "Just Jaeckin"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1116",
      "databaseFilmTitle": "Emperor of the North Pole",
      "FilmTitle": "Emperor of the North Pole",
      "AlternateTitle": "",
      "TitleArray": [
        "Emperor of the North Pole"
      ],
      "Year": "1973",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1117",
      "databaseFilmTitle": "Emperor Tomato Ketchup",
      "FilmTitle": "Emperor Tomato Ketchup",
      "AlternateTitle": "Tomato Kecchappu Kôtei",
      "TitleArray": [
        "Emperor Tomato Ketchup",
        "Tomato Kecchappu Kôtei"
      ],
      "Year": "1971",
      "Director": "Shûji Terayama",
      "DirectorArray": [
        "Shûji Terayama"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1118",
      "databaseFilmTitle": "Empire",
      "FilmTitle": "Empire",
      "AlternateTitle": "",
      "TitleArray": [
        "Empire"
      ],
      "Year": "1964",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1119",
      "databaseFilmTitle": "Empire of the Sun",
      "FilmTitle": "Empire of the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Empire of the Sun"
      ],
      "Year": "1987",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1120",
      "databaseFilmTitle": "Empty Metal",
      "FilmTitle": "Empty Metal",
      "AlternateTitle": "",
      "TitleArray": [
        "Empty Metal"
      ],
      "Year": "2018",
      "Director": "Adam Khalil, Bayley Sweitzer",
      "DirectorArray": [
        "Adam Khalil",
        "Bayley Sweitzer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1121",
      "databaseFilmTitle": "Enemy",
      "FilmTitle": "Enemy",
      "AlternateTitle": "",
      "TitleArray": [
        "Enemy"
      ],
      "Year": "2013",
      "Director": "Denis Villeneuve",
      "DirectorArray": [
        "Denis Villeneuve"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1122",
      "databaseFilmTitle": "Eniaios",
      "FilmTitle": "Eniaios",
      "AlternateTitle": "",
      "TitleArray": [
        "Eniaios"
      ],
      "Year": "1990",
      "Director": "Gregory J. Markopoulos",
      "DirectorArray": [
        "Gregory J. Markopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1123",
      "databaseFilmTitle": "Enter the Dragon",
      "FilmTitle": "Enter the Dragon",
      "AlternateTitle": "",
      "TitleArray": [
        "Enter the Dragon"
      ],
      "Year": "1973",
      "Director": "Robert Clouse",
      "DirectorArray": [
        "Robert Clouse"
      ],
      "Country": "Hong Kong, United States",
      "CountryArray": [
        "Hong Kong",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1124",
      "databaseFilmTitle": "Enter the Void",
      "FilmTitle": "Enter the Void",
      "AlternateTitle": "",
      "TitleArray": [
        "Enter the Void"
      ],
      "Year": "2009",
      "Director": "Gaspar Noé",
      "DirectorArray": [
        "Gaspar Noé"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1125",
      "databaseFilmTitle": "Enthusiasm",
      "FilmTitle": "Enthusiasm",
      "AlternateTitle": "Simfoniya Donbassa",
      "TitleArray": [
        "Enthusiasm",
        "Simfoniya Donbassa"
      ],
      "Year": "1930",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1126",
      "databaseFilmTitle": "Entranced Earth",
      "FilmTitle": "Entranced Earth",
      "AlternateTitle": "Terra em Transe",
      "TitleArray": [
        "Entranced Earth",
        "Terra em Transe"
      ],
      "Year": "1967",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1127",
      "databaseFilmTitle": "Ephemerality",
      "FilmTitle": "Ephemerality",
      "AlternateTitle": "",
      "TitleArray": [
        "Ephemerality"
      ],
      "Year": "1979",
      "Director": "Marian Wallace",
      "DirectorArray": [
        "Marian Wallace"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1128",
      "databaseFilmTitle": "Epidemic",
      "FilmTitle": "Epidemic",
      "AlternateTitle": "",
      "TitleArray": [
        "Epidemic"
      ],
      "Year": "1987",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1129",
      "databaseFilmTitle": "Episode 3: 'Enjoy Poverty'",
      "FilmTitle": "Episode 3: 'Enjoy Poverty'",
      "AlternateTitle": "",
      "TitleArray": [
        "Episode 3: 'Enjoy Poverty'"
      ],
      "Year": "2008",
      "Director": "Renzo Martens",
      "DirectorArray": [
        "Renzo Martens"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1130",
      "databaseFilmTitle": "Equinox Flower",
      "FilmTitle": "Equinox Flower",
      "AlternateTitle": "Higanbana",
      "TitleArray": [
        "Equinox Flower",
        "Higanbana"
      ],
      "Year": "1958",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1131",
      "databaseFilmTitle": "Eraserhead",
      "FilmTitle": "Eraserhead",
      "AlternateTitle": "",
      "TitleArray": [
        "Eraserhead"
      ],
      "Year": "1977",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1132",
      "databaseFilmTitle": "Ere Erera Baleibu Icik Subua Aruaren",
      "FilmTitle": "Ere Erera Baleibu Icik Subua Aruaren",
      "AlternateTitle": "",
      "TitleArray": [
        "Ere Erera Baleibu Icik Subua Aruaren"
      ],
      "Year": "1970",
      "Director": "José Antonio Sistiaga",
      "DirectorArray": [
        "José Antonio Sistiaga"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1133",
      "databaseFilmTitle": "Erie",
      "FilmTitle": "Erie",
      "AlternateTitle": "",
      "TitleArray": [
        "Erie"
      ],
      "Year": "2010",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1134",
      "databaseFilmTitle": "Eros + Massacre",
      "FilmTitle": "Eros + Massacre",
      "AlternateTitle": "Erosu purasu gyakusatsu",
      "TitleArray": [
        "Eros + Massacre",
        "Erosu purasu gyakusatsu"
      ],
      "Year": "1969",
      "Director": "Yoshishige Yoshida",
      "DirectorArray": [
        "Yoshishige Yoshida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1135",
      "databaseFilmTitle": "Erotikon",
      "FilmTitle": "Erotikon",
      "AlternateTitle": "",
      "TitleArray": [
        "Erotikon"
      ],
      "Year": "1920",
      "Director": "Mauritz Stiller",
      "DirectorArray": [
        "Mauritz Stiller"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1136",
      "databaseFilmTitle": "Escape from Alcatraz",
      "FilmTitle": "Escape from Alcatraz",
      "AlternateTitle": "",
      "TitleArray": [
        "Escape from Alcatraz"
      ],
      "Year": "1979",
      "Director": "Don Siegel",
      "DirectorArray": [
        "Don Siegel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1137",
      "databaseFilmTitle": "Escape from New York",
      "FilmTitle": "Escape from New York",
      "AlternateTitle": "",
      "TitleArray": [
        "Escape from New York"
      ],
      "Year": "1981",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1138",
      "databaseFilmTitle": "Essene",
      "FilmTitle": "Essene",
      "AlternateTitle": "",
      "TitleArray": [
        "Essene"
      ],
      "Year": "1972",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1139",
      "databaseFilmTitle": "Esther",
      "FilmTitle": "Esther",
      "AlternateTitle": "",
      "TitleArray": [
        "Esther"
      ],
      "Year": "1986",
      "Director": "Amos Gitaï",
      "DirectorArray": [
        "Amos Gitaï"
      ],
      "Country": "Austria, Israel",
      "CountryArray": [
        "Austria",
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1140",
      "databaseFilmTitle": "Eternal Homecoming",
      "FilmTitle": "Eternal Homecoming",
      "AlternateTitle": "",
      "TitleArray": [
        "Eternal Homecoming"
      ],
      "Year": "2012",
      "Director": "Kira Muratova",
      "DirectorArray": [
        "Kira Muratova"
      ],
      "Country": "Ukraine",
      "CountryArray": [
        "Ukraine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1141",
      "databaseFilmTitle": "Eternal Sunshine of the Spotless Mind",
      "FilmTitle": "Eternal Sunshine of the Spotless Mind",
      "AlternateTitle": "",
      "TitleArray": [
        "Eternal Sunshine of the Spotless Mind"
      ],
      "Year": "2004",
      "Director": "Michel Gondry",
      "DirectorArray": [
        "Michel Gondry"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1142",
      "databaseFilmTitle": "Eternity and a Day",
      "FilmTitle": "Eternity and a Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Eternity and a Day"
      ],
      "Year": "1998",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1143",
      "databaseFilmTitle": "Eureka",
      "FilmTitle": "Eureka",
      "AlternateTitle": "",
      "TitleArray": [
        "Eureka"
      ],
      "Year": "1983",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1144",
      "databaseFilmTitle": "Europa",
      "FilmTitle": "Europa",
      "AlternateTitle": "",
      "TitleArray": [
        "Europa"
      ],
      "Year": "1991",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1145",
      "databaseFilmTitle": "Europa Europa",
      "FilmTitle": "Europa Europa",
      "AlternateTitle": "",
      "TitleArray": [
        "Europa Europa"
      ],
      "Year": "1990",
      "Director": "Agnieszka Holland",
      "DirectorArray": [
        "Agnieszka Holland"
      ],
      "Country": "Germany, France, Poland",
      "CountryArray": [
        "Germany",
        "France",
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1146",
      "databaseFilmTitle": "Europa, \"Based on a True Story\"",
      "FilmTitle": "Europa, \"Based on a True Story\"",
      "AlternateTitle": "",
      "TitleArray": [
        "Europa, \"Based on a True Story\""
      ],
      "Year": "2019",
      "Director": "Kivu Ruhorahoza",
      "DirectorArray": [
        "Kivu Ruhorahoza"
      ],
      "Country": "Rwanda, United Kingdom",
      "CountryArray": [
        "Rwanda",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1147",
      "databaseFilmTitle": "Europe '51",
      "FilmTitle": "Europe '51",
      "AlternateTitle": "Euopra '51",
      "TitleArray": [
        "Europe '51",
        "Euopra '51"
      ],
      "Year": "1952",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1148",
      "databaseFilmTitle": "Eva",
      "FilmTitle": "Eva",
      "AlternateTitle": "",
      "TitleArray": [
        "Eva"
      ],
      "Year": "1962",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1149",
      "databaseFilmTitle": "Eve's Bayou",
      "FilmTitle": "Eve's Bayou",
      "AlternateTitle": "",
      "TitleArray": [
        "Eve's Bayou"
      ],
      "Year": "1997",
      "Director": "Kasi Lemmons",
      "DirectorArray": [
        "Kasi Lemmons"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1150",
      "databaseFilmTitle": "Even Dwarfs Started Small",
      "FilmTitle": "Even Dwarfs Started Small",
      "AlternateTitle": "Auch Zwerge haben klein angefangen",
      "TitleArray": [
        "Even Dwarfs Started Small",
        "Auch Zwerge haben klein angefangen"
      ],
      "Year": "1970",
      "Director": "Wener Herzog",
      "DirectorArray": [
        "Wener Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1151",
      "databaseFilmTitle": "Evening Rain",
      "FilmTitle": "Evening Rain",
      "AlternateTitle": "Ba shan ye yu",
      "TitleArray": [
        "Evening Rain",
        "Ba shan ye yu"
      ],
      "Year": "1980",
      "Director": "Wu Yigong, Wu Yonggang",
      "DirectorArray": [
        "Wu Yigong",
        "Wu Yonggang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1152",
      "databaseFilmTitle": "Every Man for Himself",
      "FilmTitle": "Every Man for Himself",
      "AlternateTitle": "Sauve qui peut (la vie)",
      "TitleArray": [
        "Every Man for Himself",
        "Sauve qui peut (la vie)"
      ],
      "Year": "1980",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1153",
      "databaseFilmTitle": "Every Picture Tells a Story",
      "FilmTitle": "Every Picture Tells a Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Every Picture Tells a Story"
      ],
      "Year": "1984",
      "Director": "James Scott",
      "DirectorArray": [
        "James Scott"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1154",
      "databaseFilmTitle": "Everybody Go Home",
      "FilmTitle": "Everybody Go Home",
      "AlternateTitle": "Tutti a casa",
      "TitleArray": [
        "Everybody Go Home",
        "Tutti a casa"
      ],
      "Year": "1960",
      "Director": "Luigi Comencini",
      "DirectorArray": [
        "Luigi Comencini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1155",
      "databaseFilmTitle": "Everyday Life in a Syrian Village",
      "FilmTitle": "Everyday Life in a Syrian Village",
      "AlternateTitle": "Al hayatt al yawmiyah fi quariah suriyah",
      "TitleArray": [
        "Everyday Life in a Syrian Village",
        "Al hayatt al yawmiyah fi quariah suriyah"
      ],
      "Year": "1974",
      "Director": "Omar Amiralay",
      "DirectorArray": [
        "Omar Amiralay"
      ],
      "Country": "Syria",
      "CountryArray": [
        "Syria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1156",
      "databaseFilmTitle": "Everything Everywhere All at Once",
      "FilmTitle": "Everything Everywhere All at Once",
      "AlternateTitle": "",
      "TitleArray": [
        "Everything Everywhere All at Once"
      ],
      "Year": "2022",
      "Director": "Dan Kwan, Daniel Scheinert",
      "DirectorArray": [
        "Dan Kwan",
        "Daniel Scheinert"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1157",
      "databaseFilmTitle": "Everything Goes Wrong",
      "FilmTitle": "Everything Goes Wrong",
      "AlternateTitle": "Subete ga kurutteru",
      "TitleArray": [
        "Everything Goes Wrong",
        "Subete ga kurutteru"
      ],
      "Year": "1960",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1158",
      "databaseFilmTitle": "Everything Will Be OK",
      "FilmTitle": "Everything Will Be OK",
      "AlternateTitle": "",
      "TitleArray": [
        "Everything Will Be OK"
      ],
      "Year": "2022",
      "Director": "Rithy Panh",
      "DirectorArray": [
        "Rithy Panh"
      ],
      "Country": "France, Cambodia",
      "CountryArray": [
        "France",
        "Cambodia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1159",
      "databaseFilmTitle": "Evolution",
      "FilmTitle": "Evolution",
      "AlternateTitle": "Évolution",
      "TitleArray": [
        "Evolution",
        "Évolution"
      ],
      "Year": "2015",
      "Director": "Lucile Hadžihalilović",
      "DirectorArray": [
        "Lucile Hadžihalilović"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1160",
      "databaseFilmTitle": "Evolution of a Filipino Family",
      "FilmTitle": "Evolution of a Filipino Family",
      "AlternateTitle": "Ebolusyon ng isang pamilyang Pilipino",
      "TitleArray": [
        "Evolution of a Filipino Family",
        "Ebolusyon ng isang pamilyang Pilipino"
      ],
      "Year": "2005",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1161",
      "databaseFilmTitle": "Ex Libris: The New York Public Library",
      "FilmTitle": "Ex Libris: The New York Public Library",
      "AlternateTitle": "",
      "TitleArray": [
        "Ex Libris: The New York Public Library"
      ],
      "Year": "2017",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1162",
      "databaseFilmTitle": "Exiled",
      "FilmTitle": "Exiled",
      "AlternateTitle": "Fong juk",
      "TitleArray": [
        "Exiled",
        "Fong juk"
      ],
      "Year": "2006",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1163",
      "databaseFilmTitle": "eXistenZ",
      "FilmTitle": "eXistenZ",
      "AlternateTitle": "",
      "TitleArray": [
        "eXistenZ"
      ],
      "Year": "1999",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1164",
      "databaseFilmTitle": "Exodus",
      "FilmTitle": "Exodus",
      "AlternateTitle": "",
      "TitleArray": [
        "Exodus"
      ],
      "Year": "1960",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1165",
      "databaseFilmTitle": "Exotica",
      "FilmTitle": "Exotica",
      "AlternateTitle": "",
      "TitleArray": [
        "Exotica"
      ],
      "Year": "1994",
      "Director": "Atom Egoyan",
      "DirectorArray": [
        "Atom Egoyan"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1166",
      "databaseFilmTitle": "Extraordinary Stories",
      "FilmTitle": "Extraordinary Stories",
      "AlternateTitle": "Historias extraordinarias",
      "TitleArray": [
        "Extraordinary Stories",
        "Historias extraordinarias"
      ],
      "Year": "2008",
      "Director": "Mariano Llinás",
      "DirectorArray": [
        "Mariano Llinás"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1167",
      "databaseFilmTitle": "Extreme Private Eros: Love Song 1974",
      "FilmTitle": "Extreme Private Eros: Love Song 1974",
      "AlternateTitle": "Gokushiteki erosu: Renka 1974",
      "TitleArray": [
        "Extreme Private Eros: Love Song 1974",
        "Gokushiteki erosu: Renka 1974"
      ],
      "Year": "1974",
      "Director": "Kazuo Hara",
      "DirectorArray": [
        "Kazuo Hara"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1168",
      "databaseFilmTitle": "Eyes Do Not Want to Close at All Times, or, Perhaps One Day Rome Will Allow Herself to Choose in Her Turn",
      "FilmTitle": "Eyes Do Not Want to Close at All Times, or, Perhaps One Day Rome Will Allow Herself to Choose in Her Turn",
      "AlternateTitle": "Les yeux ne veulent pas en tout temps se fermer ou Peut-être qu'un jour Rome se permettra de choisir à son tour",
      "TitleArray": [
        "Eyes Do Not Want to Close at All Times, or, Perhaps One Day Rome Will Allow Herself to Choose in Her Turn",
        "Les yeux ne veulent pas en tout temps se fermer ou Peut-être qu'un jour Rome se permettra de choisir à son tour"
      ],
      "Year": "1970",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "West Germany, Italy",
      "CountryArray": [
        "West Germany",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1169",
      "databaseFilmTitle": "Eyes of Fire",
      "FilmTitle": "Eyes of Fire",
      "AlternateTitle": "",
      "TitleArray": [
        "Eyes of Fire"
      ],
      "Year": "1983",
      "Director": "Avery Crounse",
      "DirectorArray": [
        "Avery Crounse"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1170",
      "databaseFilmTitle": "Eyes Wide Shut",
      "FilmTitle": "Eyes Wide Shut",
      "AlternateTitle": "",
      "TitleArray": [
        "Eyes Wide Shut"
      ],
      "Year": "1999",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1171",
      "databaseFilmTitle": "Eyes Without a Face",
      "FilmTitle": "Eyes Without a Face",
      "AlternateTitle": "Les yeux sans visage",
      "TitleArray": [
        "Eyes Without a Face",
        "Les yeux sans visage"
      ],
      "Year": "1960",
      "Director": "Georges Franju",
      "DirectorArray": [
        "Georges Franju"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1172",
      "databaseFilmTitle": "F for Fake",
      "FilmTitle": "F for Fake",
      "AlternateTitle": "Vérités et Mensonges",
      "TitleArray": [
        "F for Fake",
        "Vérités et Mensonges"
      ],
      "Year": "1973",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1173",
      "databaseFilmTitle": "Fabian: Going to the Dogs",
      "FilmTitle": "Fabian: Going to the Dogs",
      "AlternateTitle": "Fabian oder Der Gang vor die Hunde",
      "TitleArray": [
        "Fabian: Going to the Dogs",
        "Fabian oder Der Gang vor die Hunde"
      ],
      "Year": "2021",
      "Director": "Dominik Graf",
      "DirectorArray": [
        "Dominik Graf"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1174",
      "databaseFilmTitle": "Faces",
      "FilmTitle": "Faces",
      "AlternateTitle": "",
      "TitleArray": [
        "Faces"
      ],
      "Year": "1968",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1175",
      "databaseFilmTitle": "Faces of Women",
      "FilmTitle": "Faces of Women",
      "AlternateTitle": "Visages de femmes",
      "TitleArray": [
        "Faces of Women",
        "Visages de femmes"
      ],
      "Year": "1985",
      "Director": "Desire Ecaré",
      "DirectorArray": [
        "Desire Ecaré"
      ],
      "Country": "Ivory Coast, France",
      "CountryArray": [
        "Ivory Coast",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1176",
      "databaseFilmTitle": "Faces Places",
      "FilmTitle": "Faces Places",
      "AlternateTitle": "Visages villages",
      "TitleArray": [
        "Faces Places",
        "Visages villages"
      ],
      "Year": "2017",
      "Director": "Agnès Varda, JR",
      "DirectorArray": [
        "Agnès Varda",
        "JR"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1177",
      "databaseFilmTitle": "Facing the Judgment of History",
      "FilmTitle": "Facing the Judgment of History",
      "AlternateTitle": "Pered sudom istorii",
      "TitleArray": [
        "Facing the Judgment of History",
        "Pered sudom istorii"
      ],
      "Year": "1965",
      "Director": "Fridrikh Ermler",
      "DirectorArray": [
        "Fridrikh Ermler"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1178",
      "databaseFilmTitle": "Faithful Heart",
      "FilmTitle": "Faithful Heart",
      "AlternateTitle": "Cœur fidèle",
      "TitleArray": [
        "Faithful Heart",
        "Cœur fidèle"
      ],
      "Year": "1923",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1179",
      "databaseFilmTitle": "Fallen Blossoms",
      "FilmTitle": "Fallen Blossoms",
      "AlternateTitle": "Hana chirinu",
      "TitleArray": [
        "Fallen Blossoms",
        "Hana chirinu"
      ],
      "Year": "1938",
      "Director": "Tamizo Ishida",
      "DirectorArray": [
        "Tamizo Ishida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1180",
      "databaseFilmTitle": "Falling Lessons",
      "FilmTitle": "Falling Lessons",
      "AlternateTitle": "",
      "TitleArray": [
        "Falling Lessons"
      ],
      "Year": "1992",
      "Director": "Amy Halpern",
      "DirectorArray": [
        "Amy Halpern"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1181",
      "databaseFilmTitle": "Family Diary",
      "FilmTitle": "Family Diary",
      "AlternateTitle": "Cronaca familiare",
      "TitleArray": [
        "Family Diary",
        "Cronaca familiare"
      ],
      "Year": "1962",
      "Director": "Valerio Zurlini",
      "DirectorArray": [
        "Valerio Zurlini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1182",
      "databaseFilmTitle": "Fanny and Alexander",
      "FilmTitle": "Fanny and Alexander",
      "AlternateTitle": "Fanny och Alexander",
      "TitleArray": [
        "Fanny and Alexander",
        "Fanny och Alexander"
      ],
      "Year": "1982",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "129",
      "2022votes": "23"
    },
    {
      "key": "1183",
      "databaseFilmTitle": "Fantasia",
      "FilmTitle": "Fantasia",
      "AlternateTitle": "",
      "TitleArray": [
        "Fantasia"
      ],
      "Year": "1940",
      "Director": "James Algar, Samuel Armstrong, Ford Beebe, Norman Ferguson, Jim Handley, T. Hee, Wilfred Jackson, Hamilton Luske, Bill Roberts, Paul Satterfield, Ben Sharpsteen",
      "DirectorArray": [
        "James Algar",
        "Samuel Armstrong",
        "Ford Beebe",
        "Norman Ferguson",
        "Jim Handley",
        "T. Hee",
        "Wilfred Jackson",
        "Hamilton Luske",
        "Bill Roberts",
        "Paul Satterfield",
        "Ben Sharpsteen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1184",
      "databaseFilmTitle": "Fantastic Mr. Fox",
      "FilmTitle": "Fantastic Mr. Fox",
      "AlternateTitle": "",
      "TitleArray": [
        "Fantastic Mr. Fox"
      ],
      "Year": "2009",
      "Director": "Wes Anderson",
      "DirectorArray": [
        "Wes Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1185",
      "databaseFilmTitle": "Fantastic Planet",
      "FilmTitle": "Fantastic Planet",
      "AlternateTitle": "La Planète sauvage",
      "TitleArray": [
        "Fantastic Planet",
        "La Planète sauvage"
      ],
      "Year": "1973",
      "Director": "René Laloux",
      "DirectorArray": [
        "René Laloux"
      ],
      "Country": "France, Czechoslovakia",
      "CountryArray": [
        "France",
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1186",
      "databaseFilmTitle": "Fantômas",
      "FilmTitle": "Fantômas",
      "AlternateTitle": "",
      "TitleArray": [
        "Fantômas"
      ],
      "Year": "1913",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1187",
      "databaseFilmTitle": "Far from Heaven",
      "FilmTitle": "Far from Heaven",
      "AlternateTitle": "",
      "TitleArray": [
        "Far from Heaven"
      ],
      "Year": "2002",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1188",
      "databaseFilmTitle": "Far from Vietnam",
      "FilmTitle": "Far from Vietnam",
      "AlternateTitle": "Loin du Vietnam",
      "TitleArray": [
        "Far from Vietnam",
        "Loin du Vietnam"
      ],
      "Year": "1967",
      "Director": "Joris Ivens, William Klein, Claude Lelouch, Agnès Varda, Jean-Luc Godard, Chris Marker, Alain Resnais",
      "DirectorArray": [
        "Joris Ivens",
        "William Klein",
        "Claude Lelouch",
        "Agnès Varda",
        "Jean-Luc Godard",
        "Chris Marker",
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1189",
      "databaseFilmTitle": "Farewell (1930)",
      "FilmTitle": "Farewell",
      "AlternateTitle": "Abschied",
      "TitleArray": [
        "Farewell",
        "Abschied"
      ],
      "Year": "1930",
      "Director": "Robert Siodmak",
      "DirectorArray": [
        "Robert Siodmak"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1190",
      "databaseFilmTitle": "Farewell (1983)",
      "FilmTitle": "Farewell",
      "AlternateTitle": "Proshchanie",
      "TitleArray": [
        "Farewell",
        "Proshchanie"
      ],
      "Year": "1983",
      "Director": "Elem Klimov",
      "DirectorArray": [
        "Elem Klimov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1191",
      "databaseFilmTitle": "Farewell My Concubine",
      "FilmTitle": "Farewell My Concubine",
      "AlternateTitle": "Ba wang bie ji",
      "TitleArray": [
        "Farewell My Concubine",
        "Ba wang bie ji"
      ],
      "Year": "1993",
      "Director": "Chen Kaige",
      "DirectorArray": [
        "Chen Kaige"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1192",
      "databaseFilmTitle": "Fargo",
      "FilmTitle": "Fargo",
      "AlternateTitle": "",
      "TitleArray": [
        "Fargo"
      ],
      "Year": "1996",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1193",
      "databaseFilmTitle": "Farming",
      "FilmTitle": "Farming",
      "AlternateTitle": "",
      "TitleArray": [
        "Farming"
      ],
      "Year": "2018",
      "Director": "Adewale Akinnuoye-Agbaje",
      "DirectorArray": [
        "Adewale Akinnuoye-Agbaje"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1194",
      "databaseFilmTitle": "Farrebique: The Four Seasons",
      "FilmTitle": "Farrebique: The Four Seasons",
      "AlternateTitle": "Farrebique ou Les quatre saisons",
      "TitleArray": [
        "Farrebique: The Four Seasons",
        "Farrebique ou Les quatre saisons"
      ],
      "Year": "1946",
      "Director": "Georges Rouquier",
      "DirectorArray": [
        "Georges Rouquier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1195",
      "databaseFilmTitle": "Fascination",
      "FilmTitle": "Fascination",
      "AlternateTitle": "",
      "TitleArray": [
        "Fascination"
      ],
      "Year": "1979",
      "Director": "Jean Rollin",
      "DirectorArray": [
        "Jean Rollin"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1196",
      "databaseFilmTitle": "Fast Times at Ridgemont High",
      "FilmTitle": "Fast Times at Ridgemont High",
      "AlternateTitle": "",
      "TitleArray": [
        "Fast Times at Ridgemont High"
      ],
      "Year": "1982",
      "Director": "Amy Heckerling",
      "DirectorArray": [
        "Amy Heckerling"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1197",
      "databaseFilmTitle": "Faster, Pussycat! Kill! Kill!",
      "FilmTitle": "Faster, Pussycat! Kill! Kill!",
      "AlternateTitle": "",
      "TitleArray": [
        "Faster, Pussycat! Kill! Kill!"
      ],
      "Year": "1965",
      "Director": "Russ Meyer",
      "DirectorArray": [
        "Russ Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1198",
      "databaseFilmTitle": "Fat City",
      "FilmTitle": "Fat City",
      "AlternateTitle": "",
      "TitleArray": [
        "Fat City"
      ],
      "Year": "1972",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1199",
      "databaseFilmTitle": "Fata Morgana",
      "FilmTitle": "Fata Morgana",
      "AlternateTitle": "",
      "TitleArray": [
        "Fata Morgana"
      ],
      "Year": "1971",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1200",
      "databaseFilmTitle": "Fate",
      "FilmTitle": "Fate",
      "AlternateTitle": "Yazgi",
      "TitleArray": [
        "Fate",
        "Yazgi"
      ],
      "Year": "2001",
      "Director": "Zeki Demirkubuz",
      "DirectorArray": [
        "Zeki Demirkubuz"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1201",
      "databaseFilmTitle": "Father",
      "FilmTitle": "Father",
      "AlternateTitle": "Apa",
      "TitleArray": [
        "Father",
        "Apa"
      ],
      "Year": "1966",
      "Director": "István Szabó",
      "DirectorArray": [
        "István Szabó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1202",
      "databaseFilmTitle": "Father of a Soldier",
      "FilmTitle": "Father of a Soldier",
      "AlternateTitle": "",
      "TitleArray": [
        "Father of a Soldier"
      ],
      "Year": "1965",
      "Director": "Rezo Chkheidze",
      "DirectorArray": [
        "Rezo Chkheidze"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1203",
      "databaseFilmTitle": "Father's Garden: The Love of My Parents",
      "FilmTitle": "Father's Garden: The Love of My Parents",
      "AlternateTitle": "Vaters Garten – Die Liebe meiner Eltern",
      "TitleArray": [
        "Father's Garden: The Love of My Parents",
        "Vaters Garten – Die Liebe meiner Eltern"
      ],
      "Year": "2013",
      "Director": "Peter Liechti",
      "DirectorArray": [
        "Peter Liechti"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1204",
      "databaseFilmTitle": "Fatima's Letter",
      "FilmTitle": "Fatima's Letter",
      "AlternateTitle": "",
      "TitleArray": [
        "Fatima's Letter"
      ],
      "Year": "1991",
      "Director": "Alia Syed",
      "DirectorArray": [
        "Alia Syed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1205",
      "databaseFilmTitle": "Faust",
      "FilmTitle": "Faust",
      "AlternateTitle": "Faust: Eine deutsche Volkssage",
      "TitleArray": [
        "Faust",
        "Faust: Eine deutsche Volkssage"
      ],
      "Year": "1926",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1206",
      "databaseFilmTitle": "Favorites of the Moon",
      "FilmTitle": "Favorites of the Moon",
      "AlternateTitle": "Les favoris de la lune",
      "TitleArray": [
        "Favorites of the Moon",
        "Les favoris de la lune"
      ],
      "Year": "1984",
      "Director": "Otar Iosseliani",
      "DirectorArray": [
        "Otar Iosseliani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1207",
      "databaseFilmTitle": "Faya Dayi",
      "FilmTitle": "Faya Dayi",
      "AlternateTitle": "",
      "TitleArray": [
        "Faya Dayi"
      ],
      "Year": "2021",
      "Director": "Jessica Beshir",
      "DirectorArray": [
        "Jessica Beshir"
      ],
      "Country": "Ethiopia, United States",
      "CountryArray": [
        "Ethiopia",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1208",
      "databaseFilmTitle": "Fear and Loathing in Las Vegas",
      "FilmTitle": "Fear and Loathing in Las Vegas",
      "AlternateTitle": "",
      "TitleArray": [
        "Fear and Loathing in Las Vegas"
      ],
      "Year": "1998",
      "Director": "Terry Gilliam",
      "DirectorArray": [
        "Terry Gilliam"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1209",
      "databaseFilmTitle": "Fearless",
      "FilmTitle": "Fearless",
      "AlternateTitle": "",
      "TitleArray": [
        "Fearless"
      ],
      "Year": "1993",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1210",
      "databaseFilmTitle": "Fedora",
      "FilmTitle": "Fedora",
      "AlternateTitle": "",
      "TitleArray": [
        "Fedora"
      ],
      "Year": "1978",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States, West Germany",
      "CountryArray": [
        "United States",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1211",
      "databaseFilmTitle": "Fellini Satyricon",
      "FilmTitle": "Fellini Satyricon",
      "AlternateTitle": "Fellini-Satyricon",
      "TitleArray": [
        "Fellini Satyricon",
        "Fellini-Satyricon"
      ],
      "Year": "1969",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1212",
      "databaseFilmTitle": "Fellini's Casanova",
      "FilmTitle": "Fellini's Casanova",
      "AlternateTitle": "Il Casanova di Federico Fellini",
      "TitleArray": [
        "Fellini's Casanova",
        "Il Casanova di Federico Fellini"
      ],
      "Year": "1976",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1213",
      "databaseFilmTitle": "Fellini's Roma",
      "FilmTitle": "Fellini's Roma",
      "AlternateTitle": "Roma",
      "TitleArray": [
        "Fellini's Roma",
        "Roma"
      ],
      "Year": "1972",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1214",
      "databaseFilmTitle": "Female Trouble",
      "FilmTitle": "Female Trouble",
      "AlternateTitle": "",
      "TitleArray": [
        "Female Trouble"
      ],
      "Year": "1974",
      "Director": "John Waters",
      "DirectorArray": [
        "John Waters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1215",
      "databaseFilmTitle": "Femme Fatale",
      "FilmTitle": "Femme Fatale",
      "AlternateTitle": "",
      "TitleArray": [
        "Femme Fatale"
      ],
      "Year": "2002",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1216",
      "databaseFilmTitle": "Femmes femmes",
      "FilmTitle": "Femmes femmes",
      "AlternateTitle": "",
      "TitleArray": [
        "Femmes femmes"
      ],
      "Year": "1974",
      "Director": "Paul Vecchiali",
      "DirectorArray": [
        "Paul Vecchiali"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1217",
      "databaseFilmTitle": "Ferocious Saint Lord of Gobi",
      "FilmTitle": "Ferocious Saint Lord of Gobi",
      "AlternateTitle": "Dogshin hutagtin sakhius",
      "TitleArray": [
        "Ferocious Saint Lord of Gobi",
        "Dogshin hutagtin sakhius"
      ],
      "Year": "1998",
      "Director": "I. Nyamgavaa",
      "DirectorArray": [
        "I. Nyamgavaa"
      ],
      "Country": "Mongolia",
      "CountryArray": [
        "Mongolia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1218",
      "databaseFilmTitle": "Ferris Bueller's Day Off",
      "FilmTitle": "Ferris Bueller's Day Off",
      "AlternateTitle": "",
      "TitleArray": [
        "Ferris Bueller's Day Off"
      ],
      "Year": "1986",
      "Director": "John Hughes",
      "DirectorArray": [
        "John Hughes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1219",
      "databaseFilmTitle": "Fertile Memory",
      "FilmTitle": "Fertile Memory",
      "AlternateTitle": "Al Dhakira Al Khasba",
      "TitleArray": [
        "Fertile Memory",
        "Al Dhakira Al Khasba"
      ],
      "Year": "1980",
      "Director": "Michel Khleifi",
      "DirectorArray": [
        "Michel Khleifi"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1220",
      "databaseFilmTitle": "Festen",
      "FilmTitle": "Festen",
      "AlternateTitle": "",
      "TitleArray": [
        "Festen"
      ],
      "Year": "1998",
      "Director": "Thomas Vinterberg",
      "DirectorArray": [
        "Thomas Vinterberg"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1221",
      "databaseFilmTitle": "Field Niggas",
      "FilmTitle": "Field Niggas",
      "AlternateTitle": "",
      "TitleArray": [
        "Field Niggas"
      ],
      "Year": "2015",
      "Director": "Khalik Allah",
      "DirectorArray": [
        "Khalik Allah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1222",
      "databaseFilmTitle": "Fieldwork Footage",
      "FilmTitle": "Fieldwork Footage",
      "AlternateTitle": "",
      "TitleArray": [
        "Fieldwork Footage"
      ],
      "Year": "1929",
      "Director": "Zora Neale Hurston",
      "DirectorArray": [
        "Zora Neale Hurston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1223",
      "databaseFilmTitle": "Fight Club",
      "FilmTitle": "Fight Club",
      "AlternateTitle": "",
      "TitleArray": [
        "Fight Club"
      ],
      "Year": "1999",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1224",
      "databaseFilmTitle": "Film",
      "FilmTitle": "Film",
      "AlternateTitle": "",
      "TitleArray": [
        "Film"
      ],
      "Year": "1965",
      "Director": "Alan Schneider",
      "DirectorArray": [
        "Alan Schneider"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1225",
      "databaseFilmTitle": "Film about a Woman Who...",
      "FilmTitle": "Film about a Woman Who...",
      "AlternateTitle": "",
      "TitleArray": [
        "Film about a Woman Who..."
      ],
      "Year": "1974",
      "Director": "Yvonne Rainer",
      "DirectorArray": [
        "Yvonne Rainer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1226",
      "databaseFilmTitle": "Film ist. 1-6",
      "FilmTitle": "Film ist. 1-6",
      "AlternateTitle": "",
      "TitleArray": [
        "Film ist. 1-6"
      ],
      "Year": "1998",
      "Director": "Gustav Deutsch",
      "DirectorArray": [
        "Gustav Deutsch"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1227",
      "databaseFilmTitle": "Film ist. 7-12",
      "FilmTitle": "Film ist. 7-12",
      "AlternateTitle": "",
      "TitleArray": [
        "Film ist. 7-12"
      ],
      "Year": "2002",
      "Director": "Gustav Deutsch",
      "DirectorArray": [
        "Gustav Deutsch"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1228",
      "databaseFilmTitle": "Film Socialisme",
      "FilmTitle": "Film Socialisme",
      "AlternateTitle": "",
      "TitleArray": [
        "Film Socialisme"
      ],
      "Year": "2010",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1229",
      "databaseFilmTitle": "Filmemigration aus Nazideutschland",
      "FilmTitle": "Filmemigration aus Nazideutschland",
      "AlternateTitle": "",
      "TitleArray": [
        "Filmemigration aus Nazideutschland"
      ],
      "Year": "1975",
      "Director": "Günter Peter Straschek",
      "DirectorArray": [
        "Günter Peter Straschek"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1230",
      "databaseFilmTitle": "Final Flesh",
      "FilmTitle": "Final Flesh",
      "AlternateTitle": "",
      "TitleArray": [
        "Final Flesh"
      ],
      "Year": "2009",
      "Director": "Vernon Chatman, Ike Sanders",
      "DirectorArray": [
        "Vernon Chatman",
        "Ike Sanders"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1231",
      "databaseFilmTitle": "Finally Got the News",
      "FilmTitle": "Finally Got the News",
      "AlternateTitle": "",
      "TitleArray": [
        "Finally Got the News"
      ],
      "Year": "1970",
      "Director": "Stewart Bird, Peter Gessner, René Lichtman",
      "DirectorArray": [
        "Stewart Bird",
        "Peter Gessner",
        "René Lichtman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1232",
      "databaseFilmTitle": "Fingers",
      "FilmTitle": "Fingers",
      "AlternateTitle": "",
      "TitleArray": [
        "Fingers"
      ],
      "Year": "1978",
      "Director": "James Toback",
      "DirectorArray": [
        "James Toback"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1233",
      "databaseFilmTitle": "Finis terrae",
      "FilmTitle": "Finis terrae",
      "AlternateTitle": "",
      "TitleArray": [
        "Finis terrae"
      ],
      "Year": "1929",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1234",
      "databaseFilmTitle": "Fire in Castilla (Tactilvision from the Moor of the Fright)",
      "FilmTitle": "Fire in Castilla (Tactilvision from the Moor of the Fright)",
      "AlternateTitle": "Fuego en Castilla (Tactilvisión del páramo del espanto)",
      "TitleArray": [
        "Fire in Castilla (Tactilvision from the Moor of the Fright)",
        "Fuego en Castilla (Tactilvisión del páramo del espanto)"
      ],
      "Year": "1961",
      "Director": "José Val del Omar",
      "DirectorArray": [
        "José Val del Omar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1235",
      "databaseFilmTitle": "Fire Will Come",
      "FilmTitle": "Fire Will Come",
      "AlternateTitle": "O que arde",
      "TitleArray": [
        "Fire Will Come",
        "O que arde"
      ],
      "Year": "2019",
      "Director": "Oliver Laxe",
      "DirectorArray": [
        "Oliver Laxe"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1236",
      "databaseFilmTitle": "Fires on the Plain",
      "FilmTitle": "Fires on the Plain",
      "AlternateTitle": "Nobi",
      "TitleArray": [
        "Fires on the Plain",
        "Nobi"
      ],
      "Year": "1959",
      "Director": "Kon Ichikawa",
      "DirectorArray": [
        "Kon Ichikawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1237",
      "databaseFilmTitle": "Fires Were Started",
      "FilmTitle": "Fires Were Started",
      "AlternateTitle": "I Was a Fireman",
      "TitleArray": [
        "Fires Were Started",
        "I Was a Fireman"
      ],
      "Year": "1943",
      "Director": "Humphrey Jennings",
      "DirectorArray": [
        "Humphrey Jennings"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1238",
      "databaseFilmTitle": "Fireworks (1947)",
      "FilmTitle": "Fireworks",
      "AlternateTitle": "",
      "TitleArray": [
        "Fireworks"
      ],
      "Year": "1947",
      "Director": "Kenneth Anger",
      "DirectorArray": [
        "Kenneth Anger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1239",
      "databaseFilmTitle": "Fireworks (1997)",
      "FilmTitle": "Fireworks",
      "AlternateTitle": "Hana-bi",
      "TitleArray": [
        "Fireworks",
        "Hana-bi"
      ],
      "Year": "1997",
      "Director": "Takeshi Kitano",
      "DirectorArray": [
        "Takeshi Kitano"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1240",
      "databaseFilmTitle": "First Case, Second Case",
      "FilmTitle": "First Case, Second Case",
      "AlternateTitle": "Ghazieh-e Shekl-e Aval, Ghazieh-e Shekl-e Dou Wom",
      "TitleArray": [
        "First Case, Second Case",
        "Ghazieh-e Shekl-e Aval, Ghazieh-e Shekl-e Dou Wom"
      ],
      "Year": "1979",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1241",
      "databaseFilmTitle": "First Cow",
      "FilmTitle": "First Cow",
      "AlternateTitle": "",
      "TitleArray": [
        "First Cow"
      ],
      "Year": "2019",
      "Director": "Kelly Reichardt",
      "DirectorArray": [
        "Kelly Reichardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1242",
      "databaseFilmTitle": "First Man",
      "FilmTitle": "First Man",
      "AlternateTitle": "",
      "TitleArray": [
        "First Man"
      ],
      "Year": "2018",
      "Director": "Damien Chazelle",
      "DirectorArray": [
        "Damien Chazelle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1243",
      "databaseFilmTitle": "First Name: Carmen",
      "FilmTitle": "First Name: Carmen",
      "AlternateTitle": "Prénom Carmen",
      "TitleArray": [
        "First Name: Carmen",
        "Prénom Carmen"
      ],
      "Year": "1983",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1244",
      "databaseFilmTitle": "First Reformed",
      "FilmTitle": "First Reformed",
      "AlternateTitle": "",
      "TitleArray": [
        "First Reformed"
      ],
      "Year": "2017",
      "Director": "Paul Schrader",
      "DirectorArray": [
        "Paul Schrader"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1245",
      "databaseFilmTitle": "Fish Tank",
      "FilmTitle": "Fish Tank",
      "AlternateTitle": "",
      "TitleArray": [
        "Fish Tank"
      ],
      "Year": "2009",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1246",
      "databaseFilmTitle": "Fists in the Pocket",
      "FilmTitle": "Fists in the Pocket",
      "AlternateTitle": "I pugni in tasca",
      "TitleArray": [
        "Fists in the Pocket",
        "I pugni in tasca"
      ],
      "Year": "1965",
      "Director": "Marco Bellocchio",
      "DirectorArray": [
        "Marco Bellocchio"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1247",
      "databaseFilmTitle": "Fitzcarraldo",
      "FilmTitle": "Fitzcarraldo",
      "AlternateTitle": "",
      "TitleArray": [
        "Fitzcarraldo"
      ],
      "Year": "1982",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1248",
      "databaseFilmTitle": "Five Easy Pieces",
      "FilmTitle": "Five Easy Pieces",
      "AlternateTitle": "",
      "TitleArray": [
        "Five Easy Pieces"
      ],
      "Year": "1970",
      "Director": "Bob Rafelson",
      "DirectorArray": [
        "Bob Rafelson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1249",
      "databaseFilmTitle": "Five Graves to Cairo",
      "FilmTitle": "Five Graves to Cairo",
      "AlternateTitle": "",
      "TitleArray": [
        "Five Graves to Cairo"
      ],
      "Year": "1943",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1250",
      "databaseFilmTitle": "Five Men in the Circus",
      "FilmTitle": "Five Men in the Circus",
      "AlternateTitle": "Saakasu goningumi",
      "TitleArray": [
        "Five Men in the Circus",
        "Saakasu goningumi"
      ],
      "Year": "1935",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1251",
      "databaseFilmTitle": "Five Year Diary",
      "FilmTitle": "Five Year Diary",
      "AlternateTitle": "",
      "TitleArray": [
        "Five Year Diary"
      ],
      "Year": "1981",
      "Director": "Anne Charlotte Robertson",
      "DirectorArray": [
        "Anne Charlotte Robertson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1252",
      "databaseFilmTitle": "Flame of My Love",
      "FilmTitle": "Flame of My Love",
      "AlternateTitle": "Waga koi wa moenu",
      "TitleArray": [
        "Flame of My Love",
        "Waga koi wa moenu"
      ],
      "Year": "1949",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1253",
      "databaseFilmTitle": "Flaming Creatures",
      "FilmTitle": "Flaming Creatures",
      "AlternateTitle": "",
      "TitleArray": [
        "Flaming Creatures"
      ],
      "Year": "1963",
      "Director": "Jack Smith",
      "DirectorArray": [
        "Jack Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1254",
      "databaseFilmTitle": "Flammes",
      "FilmTitle": "Flammes",
      "AlternateTitle": "",
      "TitleArray": [
        "Flammes"
      ],
      "Year": "1978",
      "Director": "Adolfo Arrieta",
      "DirectorArray": [
        "Adolfo Arrieta"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1255",
      "databaseFilmTitle": "Flesh",
      "FilmTitle": "Flesh",
      "AlternateTitle": "",
      "TitleArray": [
        "Flesh"
      ],
      "Year": "1968",
      "Director": "Paul Morrissey",
      "DirectorArray": [
        "Paul Morrissey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1256",
      "databaseFilmTitle": "Flesh for Frankenstein",
      "FilmTitle": "Flesh for Frankenstein",
      "AlternateTitle": "Andy Warhol's Frankenstein",
      "TitleArray": [
        "Flesh for Frankenstein",
        "Andy Warhol's Frankenstein"
      ],
      "Year": "1973",
      "Director": "Paul Morrissey, Antonio Margheriti",
      "DirectorArray": [
        "Paul Morrissey",
        "Antonio Margheriti"
      ],
      "Country": "United States, Italy, France",
      "CountryArray": [
        "United States",
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1257",
      "databaseFilmTitle": "Floating Clouds",
      "FilmTitle": "Floating Clouds",
      "AlternateTitle": "Ukigumo",
      "TitleArray": [
        "Floating Clouds",
        "Ukigumo"
      ],
      "Year": "1955",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1258",
      "databaseFilmTitle": "Floating Life",
      "FilmTitle": "Floating Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Floating Life"
      ],
      "Year": "1996",
      "Director": "Clara Law",
      "DirectorArray": [
        "Clara Law"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1259",
      "databaseFilmTitle": "Floating Weeds",
      "FilmTitle": "Floating Weeds",
      "AlternateTitle": "Ukigusa",
      "TitleArray": [
        "Floating Weeds",
        "Ukigusa"
      ],
      "Year": "1959",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1260",
      "databaseFilmTitle": "Florentina Hubaldo, CTE",
      "FilmTitle": "Florentina Hubaldo, CTE",
      "AlternateTitle": "",
      "TitleArray": [
        "Florentina Hubaldo, CTE"
      ],
      "Year": "2012",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1261",
      "databaseFilmTitle": "Flowers of Shanghai",
      "FilmTitle": "Flowers of Shanghai",
      "AlternateTitle": "Hai shang hua",
      "TitleArray": [
        "Flowers of Shanghai",
        "Hai shang hua"
      ],
      "Year": "1998",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1262",
      "databaseFilmTitle": "Flowing",
      "FilmTitle": "Flowing",
      "AlternateTitle": "Nagareru",
      "TitleArray": [
        "Flowing",
        "Nagareru"
      ],
      "Year": "1956",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1263",
      "databaseFilmTitle": "Fly",
      "FilmTitle": "Fly",
      "AlternateTitle": "",
      "TitleArray": [
        "Fly"
      ],
      "Year": "2019",
      "Director": "Charlotte Mikkelborg",
      "DirectorArray": [
        "Charlotte Mikkelborg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1264",
      "databaseFilmTitle": "Foghorn",
      "FilmTitle": "Foghorn",
      "AlternateTitle": "Muteki",
      "TitleArray": [
        "Foghorn",
        "Muteki"
      ],
      "Year": "1934",
      "Director": "Minoru Murata",
      "DirectorArray": [
        "Minoru Murata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1265",
      "databaseFilmTitle": "Food",
      "FilmTitle": "Food",
      "AlternateTitle": "Jídlo",
      "TitleArray": [
        "Food",
        "Jídlo"
      ],
      "Year": "1992",
      "Director": "Jan Švankmajer",
      "DirectorArray": [
        "Jan Švankmajer"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1266",
      "databaseFilmTitle": "Foolish Wives",
      "FilmTitle": "Foolish Wives",
      "AlternateTitle": "",
      "TitleArray": [
        "Foolish Wives"
      ],
      "Year": "1922",
      "Director": "Erich von Stroheim",
      "DirectorArray": [
        "Erich von Stroheim"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1267",
      "databaseFilmTitle": "For a Few Dollars More",
      "FilmTitle": "For a Few Dollars More",
      "AlternateTitle": "Per qualche dollaro in più",
      "TitleArray": [
        "For a Few Dollars More",
        "Per qualche dollaro in più"
      ],
      "Year": "1965",
      "Director": "Sergio Leone",
      "DirectorArray": [
        "Sergio Leone"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1268",
      "databaseFilmTitle": "For Happiness",
      "FilmTitle": "For Happiness",
      "AlternateTitle": "",
      "TitleArray": [
        "For Happiness"
      ],
      "Year": "1917",
      "Director": "Yevgeni Bauer",
      "DirectorArray": [
        "Yevgeni Bauer"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1269",
      "databaseFilmTitle": "For Memory",
      "FilmTitle": "For Memory",
      "AlternateTitle": "",
      "TitleArray": [
        "For Memory"
      ],
      "Year": "1986",
      "Director": "Marc Karlin",
      "DirectorArray": [
        "Marc Karlin"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1270",
      "databaseFilmTitle": "For Sama",
      "FilmTitle": "For Sama",
      "AlternateTitle": "",
      "TitleArray": [
        "For Sama"
      ],
      "Year": "2019",
      "Director": "Waad Al-Khateab, Edward Watts",
      "DirectorArray": [
        "Waad Al-Khateab",
        "Edward Watts"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1271",
      "databaseFilmTitle": "For the Damaged Right Eye",
      "FilmTitle": "For the Damaged Right Eye",
      "AlternateTitle": "Tsuburekakatta migime no tame ni",
      "TitleArray": [
        "For the Damaged Right Eye",
        "Tsuburekakatta migime no tame ni"
      ],
      "Year": "1968",
      "Director": "Toshio Matsumoto",
      "DirectorArray": [
        "Toshio Matsumoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1272",
      "databaseFilmTitle": "Forbidden Games",
      "FilmTitle": "Forbidden Games",
      "AlternateTitle": "Jeux interdits",
      "TitleArray": [
        "Forbidden Games",
        "Jeux interdits"
      ],
      "Year": "1952",
      "Director": "René Clément",
      "DirectorArray": [
        "René Clément"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1273",
      "databaseFilmTitle": "Forbidden Zone",
      "FilmTitle": "Forbidden Zone",
      "AlternateTitle": "",
      "TitleArray": [
        "Forbidden Zone"
      ],
      "Year": "1980",
      "Director": "Richard Elfman",
      "DirectorArray": [
        "Richard Elfman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1274",
      "databaseFilmTitle": "Force Majeure",
      "FilmTitle": "Force Majeure",
      "AlternateTitle": "Turist",
      "TitleArray": [
        "Force Majeure",
        "Turist"
      ],
      "Year": "2014",
      "Director": "Ruben Östlund",
      "DirectorArray": [
        "Ruben Östlund"
      ],
      "Country": "Sweden, France",
      "CountryArray": [
        "Sweden",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1275",
      "databaseFilmTitle": "Force of Evil",
      "FilmTitle": "Force of Evil",
      "AlternateTitle": "",
      "TitleArray": [
        "Force of Evil"
      ],
      "Year": "1948",
      "Director": "Abraham Polonsky",
      "DirectorArray": [
        "Abraham Polonsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1276",
      "databaseFilmTitle": "Foreign Correspondent",
      "FilmTitle": "Foreign Correspondent",
      "AlternateTitle": "",
      "TitleArray": [
        "Foreign Correspondent"
      ],
      "Year": "1940",
      "Director": "Alfred Hitckcock",
      "DirectorArray": [
        "Alfred Hitckcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1277",
      "databaseFilmTitle": "Forest of Bliss",
      "FilmTitle": "Forest of Bliss",
      "AlternateTitle": "",
      "TitleArray": [
        "Forest of Bliss"
      ],
      "Year": "1986",
      "Director": "Robert Gardner",
      "DirectorArray": [
        "Robert Gardner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1278",
      "databaseFilmTitle": "Forever Amber",
      "FilmTitle": "Forever Amber",
      "AlternateTitle": "",
      "TitleArray": [
        "Forever Amber"
      ],
      "Year": "1947",
      "Director": "Otto Preminger, John M. Stahl",
      "DirectorArray": [
        "Otto Preminger",
        "John M. Stahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1279",
      "databaseFilmTitle": "Forgotten Silver",
      "FilmTitle": "Forgotten Silver",
      "AlternateTitle": "",
      "TitleArray": [
        "Forgotten Silver"
      ],
      "Year": "1995",
      "Director": "Costa Botes, Peter Jackson",
      "DirectorArray": [
        "Costa Botes",
        "Peter Jackson"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1280",
      "databaseFilmTitle": "Fort Apache",
      "FilmTitle": "Fort Apache",
      "AlternateTitle": "",
      "TitleArray": [
        "Fort Apache"
      ],
      "Year": "1948",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1281",
      "databaseFilmTitle": "Fort Tilden",
      "FilmTitle": "Fort Tilden",
      "AlternateTitle": "",
      "TitleArray": [
        "Fort Tilden"
      ],
      "Year": "2014",
      "Director": "Sarah-Violet Bliss, Charles Rogers",
      "DirectorArray": [
        "Sarah-Violet Bliss",
        "Charles Rogers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1282",
      "databaseFilmTitle": "Fortini/Cani",
      "FilmTitle": "Fortini/Cani",
      "AlternateTitle": "",
      "TitleArray": [
        "Fortini/Cani"
      ],
      "Year": "1976",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1283",
      "databaseFilmTitle": "Forward, Soviet!",
      "FilmTitle": "Forward, Soviet!",
      "AlternateTitle": "Shagay, Sovet!",
      "TitleArray": [
        "Forward, Soviet!",
        "Shagay, Sovet!"
      ],
      "Year": "1926",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1284",
      "databaseFilmTitle": "Four Adventures of Reinette and Mirabelle",
      "FilmTitle": "Four Adventures of Reinette and Mirabelle",
      "AlternateTitle": "4 aventures de Reinette et Mirabelle",
      "TitleArray": [
        "Four Adventures of Reinette and Mirabelle",
        "4 aventures de Reinette et Mirabelle"
      ],
      "Year": "1987",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1285",
      "databaseFilmTitle": "Four Friends",
      "FilmTitle": "Four Friends",
      "AlternateTitle": "",
      "TitleArray": [
        "Four Friends"
      ],
      "Year": "1981",
      "Director": "Arthur Penn",
      "DirectorArray": [
        "Arthur Penn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1286",
      "databaseFilmTitle": "Four Horsemen of the Apocalypse",
      "FilmTitle": "Four Horsemen of the Apocalypse",
      "AlternateTitle": "",
      "TitleArray": [
        "Four Horsemen of the Apocalypse"
      ],
      "Year": "1921",
      "Director": "Rex Ingram",
      "DirectorArray": [
        "Rex Ingram"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1287",
      "databaseFilmTitle": "Four Nights of a Dreamer",
      "FilmTitle": "Four Nights of a Dreamer",
      "AlternateTitle": "Quatre nuits d'un rêveur",
      "TitleArray": [
        "Four Nights of a Dreamer",
        "Quatre nuits d'un rêveur"
      ],
      "Year": "1971",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1288",
      "databaseFilmTitle": "Four Seasons of Children",
      "FilmTitle": "Four Seasons of Children",
      "AlternateTitle": "Kodomo no shiki",
      "TitleArray": [
        "Four Seasons of Children",
        "Kodomo no shiki"
      ],
      "Year": "1939",
      "Director": "Hiroshi Shimizu",
      "DirectorArray": [
        "Hiroshi Shimizu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1289",
      "databaseFilmTitle": "Fox and His Friends",
      "FilmTitle": "Fox and His Friends",
      "AlternateTitle": "Faustrecht der Freiheit",
      "TitleArray": [
        "Fox and His Friends",
        "Faustrecht der Freiheit"
      ],
      "Year": "1975",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1290",
      "databaseFilmTitle": "Fragile as the World",
      "FilmTitle": "Fragile as the World",
      "AlternateTitle": "Frágil Como o Mundo",
      "TitleArray": [
        "Fragile as the World",
        "Frágil Como o Mundo"
      ],
      "Year": "2001",
      "Director": "Rita Azevedo Gomes",
      "DirectorArray": [
        "Rita Azevedo Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1291",
      "databaseFilmTitle": "Fragment of an Empire",
      "FilmTitle": "Fragment of an Empire",
      "AlternateTitle": "Oblomok imperii",
      "TitleArray": [
        "Fragment of an Empire",
        "Oblomok imperii"
      ],
      "Year": "1929",
      "Director": "Fridrikh Ermler",
      "DirectorArray": [
        "Fridrikh Ermler"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1292",
      "databaseFilmTitle": "France, Here We Are!!!",
      "FilmTitle": "France, Here We Are!!!",
      "AlternateTitle": "Frankreich, Wir Kommen!!!",
      "TitleArray": [
        "France, Here We Are!!!",
        "Frankreich, Wir Kommen!!!"
      ],
      "Year": "1999",
      "Director": "Michael Glawogger",
      "DirectorArray": [
        "Michael Glawogger"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1293",
      "databaseFilmTitle": "Frances Ha",
      "FilmTitle": "Frances Ha",
      "AlternateTitle": "",
      "TitleArray": [
        "Frances Ha"
      ],
      "Year": "2012",
      "Director": "Noah Baumbach",
      "DirectorArray": [
        "Noah Baumbach"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1294",
      "databaseFilmTitle": "Francisca",
      "FilmTitle": "Francisca",
      "AlternateTitle": "",
      "TitleArray": [
        "Francisca"
      ],
      "Year": "1981",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1295",
      "databaseFilmTitle": "Frank Film",
      "FilmTitle": "Frank Film",
      "AlternateTitle": "",
      "TitleArray": [
        "Frank Film"
      ],
      "Year": "1973",
      "Director": "Caroline Mouris, Frank Mouris",
      "DirectorArray": [
        "Caroline Mouris",
        "Frank Mouris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1296",
      "databaseFilmTitle": "Frankenstein",
      "FilmTitle": "Frankenstein",
      "AlternateTitle": "",
      "TitleArray": [
        "Frankenstein"
      ],
      "Year": "1931",
      "Director": "James Whale",
      "DirectorArray": [
        "James Whale"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1297",
      "databaseFilmTitle": "Frankenstein Unbound",
      "FilmTitle": "Frankenstein Unbound",
      "AlternateTitle": "Roger Corman's Frankenstein Unbound",
      "TitleArray": [
        "Frankenstein Unbound",
        "Roger Corman's Frankenstein Unbound"
      ],
      "Year": "1990",
      "Director": "Roger Corman",
      "DirectorArray": [
        "Roger Corman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1298",
      "databaseFilmTitle": "Frantz",
      "FilmTitle": "Frantz",
      "AlternateTitle": "",
      "TitleArray": [
        "Frantz"
      ],
      "Year": "2016",
      "Director": "François Ozon",
      "DirectorArray": [
        "François Ozon"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1299",
      "databaseFilmTitle": "Freak Orlando",
      "FilmTitle": "Freak Orlando",
      "AlternateTitle": "",
      "TitleArray": [
        "Freak Orlando"
      ],
      "Year": "1981",
      "Director": "Ulrike Ottinger",
      "DirectorArray": [
        "Ulrike Ottinger"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1300",
      "databaseFilmTitle": "Freaks",
      "FilmTitle": "Freaks",
      "AlternateTitle": "",
      "TitleArray": [
        "Freaks"
      ],
      "Year": "1932",
      "Director": "Tod Browning",
      "DirectorArray": [
        "Tod Browning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1301",
      "databaseFilmTitle": "Free Radicals",
      "FilmTitle": "Free Radicals",
      "AlternateTitle": "",
      "TitleArray": [
        "Free Radicals"
      ],
      "Year": "1958",
      "Director": "Len Lye",
      "DirectorArray": [
        "Len Lye"
      ],
      "Country": "United States, New Zealand",
      "CountryArray": [
        "United States",
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1302",
      "databaseFilmTitle": "Freedom Song",
      "FilmTitle": "Freedom Song",
      "AlternateTitle": "",
      "TitleArray": [
        "Freedom Song"
      ],
      "Year": "2000",
      "Director": "Phil Alden Robinson",
      "DirectorArray": [
        "Phil Alden Robinson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1303",
      "databaseFilmTitle": "French Cancan",
      "FilmTitle": "French Cancan",
      "AlternateTitle": "",
      "TitleArray": [
        "French Cancan"
      ],
      "Year": "1955",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1304",
      "databaseFilmTitle": "Frenzy",
      "FilmTitle": "Frenzy",
      "AlternateTitle": "",
      "TitleArray": [
        "Frenzy"
      ],
      "Year": "1972",
      "Director": "Alfred Hitckcock",
      "DirectorArray": [
        "Alfred Hitckcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1305",
      "databaseFilmTitle": "Frida",
      "FilmTitle": "Frida",
      "AlternateTitle": "",
      "TitleArray": [
        "Frida"
      ],
      "Year": "2002",
      "Director": "Julie Taymor",
      "DirectorArray": [
        "Julie Taymor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1306",
      "databaseFilmTitle": "Friedemann Bach",
      "FilmTitle": "Friedemann Bach",
      "AlternateTitle": "",
      "TitleArray": [
        "Friedemann Bach"
      ],
      "Year": "1941",
      "Director": "Traugott Müller, Gustaf Gründgens",
      "DirectorArray": [
        "Traugott Müller",
        "Gustaf Gründgens"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1307",
      "databaseFilmTitle": "Friendly Persuasion",
      "FilmTitle": "Friendly Persuasion",
      "AlternateTitle": "",
      "TitleArray": [
        "Friendly Persuasion"
      ],
      "Year": "1956",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1308",
      "databaseFilmTitle": "Friendship's Death",
      "FilmTitle": "Friendship's Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Friendship's Death"
      ],
      "Year": "1987",
      "Director": "Peter Wollen",
      "DirectorArray": [
        "Peter Wollen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1309",
      "databaseFilmTitle": "From Here to Eternity",
      "FilmTitle": "From Here to Eternity",
      "AlternateTitle": "",
      "TitleArray": [
        "From Here to Eternity"
      ],
      "Year": "1953",
      "Director": "Fred Zinnemann",
      "DirectorArray": [
        "Fred Zinnemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1310",
      "databaseFilmTitle": "From Russia with Love",
      "FilmTitle": "From Russia with Love",
      "AlternateTitle": "",
      "TitleArray": [
        "From Russia with Love"
      ],
      "Year": "1963",
      "Director": "Terence Young",
      "DirectorArray": [
        "Terence Young"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1311",
      "databaseFilmTitle": "From Saturday to Sunday",
      "FilmTitle": "From Saturday to Sunday",
      "AlternateTitle": "Ze soboty na nedeli",
      "TitleArray": [
        "From Saturday to Sunday",
        "Ze soboty na nedeli"
      ],
      "Year": "1931",
      "Director": "Gustav Machatý",
      "DirectorArray": [
        "Gustav Machatý"
      ],
      "Country": "Austria, Czechoslovakia",
      "CountryArray": [
        "Austria",
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1312",
      "databaseFilmTitle": "From the Clouds to the Resistance",
      "FilmTitle": "From the Clouds to the Resistance",
      "AlternateTitle": "Dalla nube alla resistenza",
      "TitleArray": [
        "From the Clouds to the Resistance",
        "Dalla nube alla resistenza"
      ],
      "Year": "1979",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1313",
      "databaseFilmTitle": "From the East",
      "FilmTitle": "From the East",
      "AlternateTitle": "D'est",
      "TitleArray": [
        "From the East",
        "D'est"
      ],
      "Year": "1993",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1314",
      "databaseFilmTitle": "From the Notebook of...",
      "FilmTitle": "From the Notebook of...",
      "AlternateTitle": "",
      "TitleArray": [
        "From the Notebook of..."
      ],
      "Year": "1971",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1315",
      "databaseFilmTitle": "From the Other Side",
      "FilmTitle": "From the Other Side",
      "AlternateTitle": "De l'autre côté",
      "TitleArray": [
        "From the Other Side",
        "De l'autre côté"
      ],
      "Year": "2002",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, Australia",
      "CountryArray": [
        "Belgium",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1316",
      "databaseFilmTitle": "From the Pole to the Equator",
      "FilmTitle": "From the Pole to the Equator",
      "AlternateTitle": "Dal polo all'equatore",
      "TitleArray": [
        "From the Pole to the Equator",
        "Dal polo all'equatore"
      ],
      "Year": "1987",
      "Director": "Yervant Gianikian, Angela Ricci Lucchi",
      "DirectorArray": [
        "Yervant Gianikian",
        "Angela Ricci Lucchi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1317",
      "databaseFilmTitle": "From Today Until Tomorrow",
      "FilmTitle": "From Today Until Tomorrow",
      "AlternateTitle": "Von heute auf morgen",
      "TitleArray": [
        "From Today Until Tomorrow",
        "Von heute auf morgen"
      ],
      "Year": "1997",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1318",
      "databaseFilmTitle": "Frozen",
      "FilmTitle": "Frozen",
      "AlternateTitle": "",
      "TitleArray": [
        "Frozen"
      ],
      "Year": "2013",
      "Director": "Chris Buck, Jennifer Lee",
      "DirectorArray": [
        "Chris Buck",
        "Jennifer Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1319",
      "databaseFilmTitle": "Frozen II",
      "FilmTitle": "Frozen II",
      "AlternateTitle": "",
      "TitleArray": [
        "Frozen II"
      ],
      "Year": "2019",
      "Director": "Chris Buck, Jennifer Lee",
      "DirectorArray": [
        "Chris Buck",
        "Jennifer Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1320",
      "databaseFilmTitle": "Fruit of Paradise",
      "FilmTitle": "Fruit of Paradise",
      "AlternateTitle": "Ovoce stromů rajských jíme",
      "TitleArray": [
        "Fruit of Paradise",
        "Ovoce stromů rajských jíme"
      ],
      "Year": "1970",
      "Director": "Věra Chytilová",
      "DirectorArray": [
        "Věra Chytilová"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1321",
      "databaseFilmTitle": "Fruitvale Station",
      "FilmTitle": "Fruitvale Station",
      "AlternateTitle": "Fruitvale",
      "TitleArray": [
        "Fruitvale Station",
        "Fruitvale"
      ],
      "Year": "2013",
      "Director": "Ryan Coogler",
      "DirectorArray": [
        "Ryan Coogler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1322",
      "databaseFilmTitle": "Full Metal Jacket",
      "FilmTitle": "Full Metal Jacket",
      "AlternateTitle": "",
      "TitleArray": [
        "Full Metal Jacket"
      ],
      "Year": "1987",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1323",
      "databaseFilmTitle": "Full Moon in Paris",
      "FilmTitle": "Full Moon in Paris",
      "AlternateTitle": "Les Nuits de la pleine lune",
      "TitleArray": [
        "Full Moon in Paris",
        "Les Nuits de la pleine lune"
      ],
      "Year": "1984",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1324",
      "databaseFilmTitle": "Funeral Parade of Roses",
      "FilmTitle": "Funeral Parade of Roses",
      "AlternateTitle": "Bara no Sōretsu",
      "TitleArray": [
        "Funeral Parade of Roses",
        "Bara no Sōretsu"
      ],
      "Year": "1969",
      "Director": "Toshio Matsumoto",
      "DirectorArray": [
        "Toshio Matsumoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1325",
      "databaseFilmTitle": "Funny Face",
      "FilmTitle": "Funny Face",
      "AlternateTitle": "",
      "TitleArray": [
        "Funny Face"
      ],
      "Year": "1957",
      "Director": "Stanley Donen",
      "DirectorArray": [
        "Stanley Donen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1326",
      "databaseFilmTitle": "Funny Games",
      "FilmTitle": "Funny Games",
      "AlternateTitle": "",
      "TitleArray": [
        "Funny Games"
      ],
      "Year": "1997",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1327",
      "databaseFilmTitle": "Funny Girl",
      "FilmTitle": "Funny Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Funny Girl"
      ],
      "Year": "1968",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1328",
      "databaseFilmTitle": "Further Beyond",
      "FilmTitle": "Further Beyond",
      "AlternateTitle": "",
      "TitleArray": [
        "Further Beyond"
      ],
      "Year": "2016",
      "Director": "Christine Molloy, Joe Lawlor",
      "DirectorArray": [
        "Christine Molloy",
        "Joe Lawlor"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1329",
      "databaseFilmTitle": "Fuses",
      "FilmTitle": "Fuses",
      "AlternateTitle": "",
      "TitleArray": [
        "Fuses"
      ],
      "Year": "1967",
      "Director": "Carolee Schneemann",
      "DirectorArray": [
        "Carolee Schneemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1330",
      "databaseFilmTitle": "Gabbeh",
      "FilmTitle": "Gabbeh",
      "AlternateTitle": "",
      "TitleArray": [
        "Gabbeh"
      ],
      "Year": "1996",
      "Director": "Mohsen Makhmalbaf",
      "DirectorArray": [
        "Mohsen Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1331",
      "databaseFilmTitle": "Gallivant",
      "FilmTitle": "Gallivant",
      "AlternateTitle": "",
      "TitleArray": [
        "Gallivant"
      ],
      "Year": "1997",
      "Director": "Andrew Kötting",
      "DirectorArray": [
        "Andrew Kötting"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1332",
      "databaseFilmTitle": "Game of Thrones",
      "FilmTitle": "Game of Thrones",
      "AlternateTitle": "",
      "TitleArray": [
        "Game of Thrones"
      ],
      "Year": "2011-2019",
      "Director": "David Benioff, D. B. Weiss",
      "DirectorArray": [
        "David Benioff",
        "D. B. Weiss"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1333",
      "databaseFilmTitle": "Gammelion",
      "FilmTitle": "Gammelion",
      "AlternateTitle": "",
      "TitleArray": [
        "Gammelion"
      ],
      "Year": "1967",
      "Director": "Gregory J. Markopoulos",
      "DirectorArray": [
        "Gregory J. Markopoulos"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1334",
      "databaseFilmTitle": "Gandhi",
      "FilmTitle": "Gandhi",
      "AlternateTitle": "",
      "TitleArray": [
        "Gandhi"
      ],
      "Year": "1982",
      "Director": "Richard Attenborough",
      "DirectorArray": [
        "Richard Attenborough"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1335",
      "databaseFilmTitle": "Gangs of New York",
      "FilmTitle": "Gangs of New York",
      "AlternateTitle": "",
      "TitleArray": [
        "Gangs of New York"
      ],
      "Year": "2002",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1336",
      "databaseFilmTitle": "Gangs of Wasseypur",
      "FilmTitle": "Gangs of Wasseypur",
      "AlternateTitle": "",
      "TitleArray": [
        "Gangs of Wasseypur"
      ],
      "Year": "2012",
      "Director": "Anurag Kashyap",
      "DirectorArray": [
        "Anurag Kashyap"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1337",
      "databaseFilmTitle": "Ganja & Hess",
      "FilmTitle": "Ganja & Hess",
      "AlternateTitle": "",
      "TitleArray": [
        "Ganja & Hess"
      ],
      "Year": "1973",
      "Director": "Bill Gunn",
      "DirectorArray": [
        "Bill Gunn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1338",
      "databaseFilmTitle": "Garden Pieces",
      "FilmTitle": "Garden Pieces",
      "AlternateTitle": "",
      "TitleArray": [
        "Garden Pieces"
      ],
      "Year": "1998",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1339",
      "databaseFilmTitle": "Gas, Food Lodging",
      "FilmTitle": "Gas, Food Lodging",
      "AlternateTitle": "Gas Food Lodging",
      "TitleArray": [
        "Gas, Food Lodging",
        "Gas Food Lodging"
      ],
      "Year": "1992",
      "Director": "Allison Anders",
      "DirectorArray": [
        "Allison Anders"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1340",
      "databaseFilmTitle": "Gaslight",
      "FilmTitle": "Gaslight",
      "AlternateTitle": "",
      "TitleArray": [
        "Gaslight"
      ],
      "Year": "1944",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1341",
      "databaseFilmTitle": "Gasman",
      "FilmTitle": "Gasman",
      "AlternateTitle": "",
      "TitleArray": [
        "Gasman"
      ],
      "Year": "1998",
      "Director": "Lynne Ramsay",
      "DirectorArray": [
        "Lynne Ramsay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1342",
      "databaseFilmTitle": "Gate of Flesh",
      "FilmTitle": "Gate of Flesh",
      "AlternateTitle": "Nikutai no Mon",
      "TitleArray": [
        "Gate of Flesh",
        "Nikutai no Mon"
      ],
      "Year": "1964",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1343",
      "databaseFilmTitle": "Gattaca",
      "FilmTitle": "Gattaca",
      "AlternateTitle": "",
      "TitleArray": [
        "Gattaca"
      ],
      "Year": "1997",
      "Director": "Andrew Niccol",
      "DirectorArray": [
        "Andrew Niccol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1344",
      "databaseFilmTitle": "Gebet für die Linke",
      "FilmTitle": "Gebet für die Linke",
      "AlternateTitle": "",
      "TitleArray": [
        "Gebet für die Linke"
      ],
      "Year": "1974",
      "Director": "Walter Marti, Reni Mertens",
      "DirectorArray": [
        "Walter Marti",
        "Reni Mertens"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1345",
      "databaseFilmTitle": "Gebo and the Shadow",
      "FilmTitle": "Gebo and the Shadow",
      "AlternateTitle": "O Gebo e a sombra",
      "TitleArray": [
        "Gebo and the Shadow",
        "O Gebo e a sombra"
      ],
      "Year": "2012",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal, France",
      "CountryArray": [
        "Portugal",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1346",
      "databaseFilmTitle": "Gedächtnis",
      "FilmTitle": "Gedächtnis",
      "AlternateTitle": "Gedächtnis: Ein Film für Curt Bois und Bernhard Minetti",
      "TitleArray": [
        "Gedächtnis",
        "Gedächtnis: Ein Film für Curt Bois und Bernhard Minetti"
      ],
      "Year": "1982",
      "Director": "Bruno Ganz, Otto Sander",
      "DirectorArray": [
        "Bruno Ganz",
        "Otto Sander"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1347",
      "databaseFilmTitle": "Geethanjali",
      "FilmTitle": "Geethanjali",
      "AlternateTitle": "",
      "TitleArray": [
        "Geethanjali"
      ],
      "Year": "1989",
      "Director": "Mani Ratnam",
      "DirectorArray": [
        "Mani Ratnam"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1348",
      "databaseFilmTitle": "Gentleman Jim",
      "FilmTitle": "Gentleman Jim",
      "AlternateTitle": "",
      "TitleArray": [
        "Gentleman Jim"
      ],
      "Year": "1942",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1349",
      "databaseFilmTitle": "Gentlemen Prefer Blondes",
      "FilmTitle": "Gentlemen Prefer Blondes",
      "AlternateTitle": "",
      "TitleArray": [
        "Gentlemen Prefer Blondes"
      ],
      "Year": "1953",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1350",
      "databaseFilmTitle": "Gently Down the Stream",
      "FilmTitle": "Gently Down the Stream",
      "AlternateTitle": "",
      "TitleArray": [
        "Gently Down the Stream"
      ],
      "Year": "1981",
      "Director": "Su Friedrich",
      "DirectorArray": [
        "Su Friedrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1351",
      "databaseFilmTitle": "German Concentration Camps Factual Survey",
      "FilmTitle": "German Concentration Camps Factual Survey",
      "AlternateTitle": "",
      "TitleArray": [
        "German Concentration Camps Factual Survey"
      ],
      "Year": "2014",
      "Director": "Sidney Bernstein, Alfred Hitchcock",
      "DirectorArray": [
        "Sidney Bernstein",
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1352",
      "databaseFilmTitle": "Germany in Autumn",
      "FilmTitle": "Germany in Autumn",
      "AlternateTitle": "Deutschland im Herbst",
      "TitleArray": [
        "Germany in Autumn",
        "Deutschland im Herbst"
      ],
      "Year": "1978",
      "Director": "Rainer Werner Fassbinder, Alexander Kluge, Edgar Reitz, Bernhard Sinkel, Alf Brustellin, Hans Peter Cloos, Katja Rupé, Peter Schubert, Volker Schlöndorff",
      "DirectorArray": [
        "Rainer Werner Fassbinder",
        "Alexander Kluge",
        "Edgar Reitz",
        "Bernhard Sinkel",
        "Alf Brustellin",
        "Hans Peter Cloos",
        "Katja Rupé",
        "Peter Schubert",
        "Volker Schlöndorff"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1353",
      "databaseFilmTitle": "Germany Pale Mother",
      "FilmTitle": "Germany Pale Mother",
      "AlternateTitle": "Deutschland bleiche Mutter",
      "TitleArray": [
        "Germany Pale Mother",
        "Deutschland bleiche Mutter"
      ],
      "Year": "1980",
      "Director": "Helma Sanders-Brahms",
      "DirectorArray": [
        "Helma Sanders-Brahms"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1354",
      "databaseFilmTitle": "Germany Year 90 Nine Zero",
      "FilmTitle": "Germany Year 90 Nine Zero",
      "AlternateTitle": "Allemagne année 90 neuf zéro",
      "TitleArray": [
        "Germany Year 90 Nine Zero",
        "Allemagne année 90 neuf zéro"
      ],
      "Year": "1991",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1355",
      "databaseFilmTitle": "Germany Year Zero",
      "FilmTitle": "Germany Year Zero",
      "AlternateTitle": "Deutschland im Jahre Null",
      "TitleArray": [
        "Germany Year Zero",
        "Deutschland im Jahre Null"
      ],
      "Year": "1948",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy, Germany",
      "CountryArray": [
        "Italy",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1356",
      "databaseFilmTitle": "Germinal",
      "FilmTitle": "Germinal",
      "AlternateTitle": "",
      "TitleArray": [
        "Germinal"
      ],
      "Year": "1913",
      "Director": "Albert Capellani",
      "DirectorArray": [
        "Albert Capellani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1357",
      "databaseFilmTitle": "Gertrud",
      "FilmTitle": "Gertrud",
      "AlternateTitle": "",
      "TitleArray": [
        "Gertrud"
      ],
      "Year": "1964",
      "Director": "Carl Theodor Dreyer",
      "DirectorArray": [
        "Carl Theodor Dreyer"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "43",
      "2012votes": "31",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "1358",
      "databaseFilmTitle": "Get Carter",
      "FilmTitle": "Get Carter",
      "AlternateTitle": "",
      "TitleArray": [
        "Get Carter"
      ],
      "Year": "1971",
      "Director": "Mike Hodges",
      "DirectorArray": [
        "Mike Hodges"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1359",
      "databaseFilmTitle": "Get Out",
      "FilmTitle": "Get Out",
      "AlternateTitle": "",
      "TitleArray": [
        "Get Out"
      ],
      "Year": "2017",
      "Director": "Jordan Peele",
      "DirectorArray": [
        "Jordan Peele"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "1360",
      "databaseFilmTitle": "Getting to Know the Big Wide World",
      "FilmTitle": "Getting to Know the Big Wide World",
      "AlternateTitle": "Poznavaya belyi svet",
      "TitleArray": [
        "Getting to Know the Big Wide World",
        "Poznavaya belyi svet"
      ],
      "Year": "1979",
      "Director": "Kira Muratova",
      "DirectorArray": [
        "Kira Muratova"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1361",
      "databaseFilmTitle": "Ghandi",
      "FilmTitle": "Ghandi",
      "AlternateTitle": "",
      "TitleArray": [
        "Ghandi"
      ],
      "Year": "1982",
      "Director": "Richard Attenborough",
      "DirectorArray": [
        "Richard Attenborough"
      ],
      "Country": "India, United Kingdom",
      "CountryArray": [
        "India",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1362",
      "databaseFilmTitle": "Ghost in the Shell",
      "FilmTitle": "Ghost in the Shell",
      "AlternateTitle": "Kôkaku kidôtai",
      "TitleArray": [
        "Ghost in the Shell",
        "Kôkaku kidôtai"
      ],
      "Year": "1995",
      "Director": "Mamoru Oshii",
      "DirectorArray": [
        "Mamoru Oshii"
      ],
      "Country": "Japan, United Kingdom",
      "CountryArray": [
        "Japan",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1363",
      "databaseFilmTitle": "Ghost World",
      "FilmTitle": "Ghost World",
      "AlternateTitle": "",
      "TitleArray": [
        "Ghost World"
      ],
      "Year": "2001",
      "Director": "Terry Zwigoff",
      "DirectorArray": [
        "Terry Zwigoff"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1364",
      "databaseFilmTitle": "Giant",
      "FilmTitle": "Giant",
      "AlternateTitle": "",
      "TitleArray": [
        "Giant"
      ],
      "Year": "1956",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1365",
      "databaseFilmTitle": "Giants and Toys",
      "FilmTitle": "Giants and Toys",
      "AlternateTitle": "Kyojin to gangu",
      "TitleArray": [
        "Giants and Toys",
        "Kyojin to gangu"
      ],
      "Year": "1958",
      "Director": "Yasuzō Masumura",
      "DirectorArray": [
        "Yasuzō Masumura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1366",
      "databaseFilmTitle": "Gilda",
      "FilmTitle": "Gilda",
      "AlternateTitle": "",
      "TitleArray": [
        "Gilda"
      ],
      "Year": "1946",
      "Director": "Charles Vidor",
      "DirectorArray": [
        "Charles Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1367",
      "databaseFilmTitle": "Gimme Shelter",
      "FilmTitle": "Gimme Shelter",
      "AlternateTitle": "",
      "TitleArray": [
        "Gimme Shelter"
      ],
      "Year": "1970",
      "Director": "Albert Maysles, David Maysles, Charlotte Zwerin",
      "DirectorArray": [
        "Albert Maysles",
        "David Maysles",
        "Charlotte Zwerin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1368",
      "databaseFilmTitle": "Ginger Snaps",
      "FilmTitle": "Ginger Snaps",
      "AlternateTitle": "",
      "TitleArray": [
        "Ginger Snaps"
      ],
      "Year": "2000",
      "Director": "John Fawcett",
      "DirectorArray": [
        "John Fawcett"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1369",
      "databaseFilmTitle": "Girl on the Bridge",
      "FilmTitle": "Girl on the Bridge",
      "AlternateTitle": "La fille sur le pont",
      "TitleArray": [
        "Girl on the Bridge",
        "La fille sur le pont"
      ],
      "Year": "1999",
      "Director": "Patrice Leconte",
      "DirectorArray": [
        "Patrice Leconte"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1370",
      "databaseFilmTitle": "Girl with a Suitcase",
      "FilmTitle": "Girl with a Suitcase",
      "AlternateTitle": "La ragazza con la valigia",
      "TitleArray": [
        "Girl with a Suitcase",
        "La ragazza con la valigia"
      ],
      "Year": "1961",
      "Director": "Valerio Zurlini",
      "DirectorArray": [
        "Valerio Zurlini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1371",
      "databaseFilmTitle": "Girlfriends",
      "FilmTitle": "Girlfriends",
      "AlternateTitle": "",
      "TitleArray": [
        "Girlfriends"
      ],
      "Year": "1978",
      "Director": "Claudia Weill",
      "DirectorArray": [
        "Claudia Weill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1372",
      "databaseFilmTitle": "Girlhood",
      "FilmTitle": "Girlhood",
      "AlternateTitle": "Bande de filles",
      "TitleArray": [
        "Girlhood",
        "Bande de filles"
      ],
      "Year": "2014",
      "Director": "Céline Sciamma",
      "DirectorArray": [
        "Céline Sciamma"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1373",
      "databaseFilmTitle": "Girls of the Night",
      "FilmTitle": "Girls of the Night",
      "AlternateTitle": "Onna bakari no yoru",
      "TitleArray": [
        "Girls of the Night",
        "Onna bakari no yoru"
      ],
      "Year": "1961",
      "Director": "Kinuyo Tanaka",
      "DirectorArray": [
        "Kinuyo Tanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1374",
      "databaseFilmTitle": "Give Us a Smile",
      "FilmTitle": "Give Us a Smile",
      "AlternateTitle": "",
      "TitleArray": [
        "Give Us a Smile"
      ],
      "Year": "1983",
      "Director": "Leeds Animation Workshop",
      "DirectorArray": [
        "Leeds Animation Workshop"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1375",
      "databaseFilmTitle": "Glen or Glenda",
      "FilmTitle": "Glen or Glenda",
      "AlternateTitle": "I Changed My Sex",
      "TitleArray": [
        "Glen or Glenda",
        "I Changed My Sex"
      ],
      "Year": "1953",
      "Director": "Edward D. Wood Jr.",
      "DirectorArray": [
        "Edward D. Wood Jr."
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1376",
      "databaseFilmTitle": "Gletscher",
      "FilmTitle": "Gletscher",
      "AlternateTitle": "",
      "TitleArray": [
        "Gletscher"
      ],
      "Year": "2006",
      "Director": "Helga Fanderl",
      "DirectorArray": [
        "Helga Fanderl"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1377",
      "databaseFilmTitle": "Glimpse",
      "FilmTitle": "Glimpse",
      "AlternateTitle": "",
      "TitleArray": [
        "Glimpse"
      ],
      "Year": "2021",
      "Director": "Benjamin Cleary, Michael O'Connor",
      "DirectorArray": [
        "Benjamin Cleary",
        "Michael O'Connor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1378",
      "databaseFilmTitle": "Gloomy Eyes",
      "FilmTitle": "Gloomy Eyes",
      "AlternateTitle": "",
      "TitleArray": [
        "Gloomy Eyes"
      ],
      "Year": "2019",
      "Director": "Fernando Maldonado, Jorge Tereso",
      "DirectorArray": [
        "Fernando Maldonado",
        "Jorge Tereso"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1379",
      "databaseFilmTitle": "Gloria",
      "FilmTitle": "Gloria",
      "AlternateTitle": "",
      "TitleArray": [
        "Gloria"
      ],
      "Year": "1980",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1380",
      "databaseFilmTitle": "Gloria!",
      "FilmTitle": "Gloria!",
      "AlternateTitle": "",
      "TitleArray": [
        "Gloria!"
      ],
      "Year": "1979",
      "Director": "Hollis Frampton",
      "DirectorArray": [
        "Hollis Frampton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1381",
      "databaseFilmTitle": "Go Fish",
      "FilmTitle": "Go Fish",
      "AlternateTitle": "",
      "TitleArray": [
        "Go Fish"
      ],
      "Year": "1994",
      "Director": "Rose Troche",
      "DirectorArray": [
        "Rose Troche"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1382",
      "databaseFilmTitle": "Go West",
      "FilmTitle": "Go West",
      "AlternateTitle": "",
      "TitleArray": [
        "Go West"
      ],
      "Year": "1925",
      "Director": "Buster Keaton",
      "DirectorArray": [
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1383",
      "databaseFilmTitle": "God Told Me To",
      "FilmTitle": "God Told Me To",
      "AlternateTitle": "",
      "TitleArray": [
        "God Told Me To"
      ],
      "Year": "1976",
      "Director": "Larry Cohen",
      "DirectorArray": [
        "Larry Cohen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1384",
      "databaseFilmTitle": "God's Comedy",
      "FilmTitle": "God's Comedy",
      "AlternateTitle": "A Comédia de Deus",
      "TitleArray": [
        "God's Comedy",
        "A Comédia de Deus"
      ],
      "Year": "1995",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1385",
      "databaseFilmTitle": "God's Gift",
      "FilmTitle": "God's Gift",
      "AlternateTitle": "Wend Kuuni",
      "TitleArray": [
        "God's Gift",
        "Wend Kuuni"
      ],
      "Year": "1982",
      "Director": "Gaston Kaboré",
      "DirectorArray": [
        "Gaston Kaboré"
      ],
      "Country": "Burkina Faso",
      "CountryArray": [
        "Burkina Faso"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1386",
      "databaseFilmTitle": "God's Own Country",
      "FilmTitle": "God's Own Country",
      "AlternateTitle": "",
      "TitleArray": [
        "God's Own Country"
      ],
      "Year": "2017",
      "Director": "Francis Lee",
      "DirectorArray": [
        "Francis Lee"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1387",
      "databaseFilmTitle": "God's Step Children",
      "FilmTitle": "God's Step Children",
      "AlternateTitle": "",
      "TitleArray": [
        "God's Step Children"
      ],
      "Year": "1938",
      "Director": "Oscar Micheaux",
      "DirectorArray": [
        "Oscar Micheaux"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1388",
      "databaseFilmTitle": "God's Wedding",
      "FilmTitle": "God's Wedding",
      "AlternateTitle": "As Bodas de Deus",
      "TitleArray": [
        "God's Wedding",
        "As Bodas de Deus"
      ],
      "Year": "1999",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1389",
      "databaseFilmTitle": "Godzilla",
      "FilmTitle": "Godzilla",
      "AlternateTitle": "Gojira",
      "TitleArray": [
        "Godzilla",
        "Gojira"
      ],
      "Year": "1954",
      "Director": "Ishirô Honda",
      "DirectorArray": [
        "Ishirô Honda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1390",
      "databaseFilmTitle": "Going My Way",
      "FilmTitle": "Going My Way",
      "AlternateTitle": "",
      "TitleArray": [
        "Going My Way"
      ],
      "Year": "1944",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1391",
      "databaseFilmTitle": "Going Places",
      "FilmTitle": "Going Places",
      "AlternateTitle": "Les valseuses",
      "TitleArray": [
        "Going Places",
        "Les valseuses"
      ],
      "Year": "1974",
      "Director": "Bertrand Blier",
      "DirectorArray": [
        "Bertrand Blier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1392",
      "databaseFilmTitle": "Gold Diggers of 1933",
      "FilmTitle": "Gold Diggers of 1933",
      "AlternateTitle": "",
      "TitleArray": [
        "Gold Diggers of 1933"
      ],
      "Year": "1933",
      "Director": "Mervyn LeRoy",
      "DirectorArray": [
        "Mervyn LeRoy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1393",
      "databaseFilmTitle": "Gold Diggers of 1935",
      "FilmTitle": "Gold Diggers of 1935",
      "AlternateTitle": "",
      "TitleArray": [
        "Gold Diggers of 1935"
      ],
      "Year": "1935",
      "Director": "Busby Berkeley",
      "DirectorArray": [
        "Busby Berkeley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1394",
      "databaseFilmTitle": "Golden Eighties",
      "FilmTitle": "Golden Eighties",
      "AlternateTitle": "",
      "TitleArray": [
        "Golden Eighties"
      ],
      "Year": "1986",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1395",
      "databaseFilmTitle": "Golden Parable",
      "FilmTitle": "Golden Parable",
      "AlternateTitle": "Parabola d'oro",
      "TitleArray": [
        "Golden Parable",
        "Parabola d'oro"
      ],
      "Year": "1955",
      "Director": "Vittorio De Seta",
      "DirectorArray": [
        "Vittorio De Seta"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1396",
      "databaseFilmTitle": "Goldfinger",
      "FilmTitle": "Goldfinger",
      "AlternateTitle": "",
      "TitleArray": [
        "Goldfinger"
      ],
      "Year": "1964",
      "Director": "Guy Hamilton",
      "DirectorArray": [
        "Guy Hamilton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1397",
      "databaseFilmTitle": "Gone Girl",
      "FilmTitle": "Gone Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Gone Girl"
      ],
      "Year": "2014",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1398",
      "databaseFilmTitle": "Gone to Earth",
      "FilmTitle": "Gone to Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "Gone to Earth"
      ],
      "Year": "1950",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1399",
      "databaseFilmTitle": "Gone with the Wind",
      "FilmTitle": "Gone with the Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "Gone with the Wind"
      ],
      "Year": "1939",
      "Director": "Victor Fleming",
      "DirectorArray": [
        "Victor Fleming"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1400",
      "databaseFilmTitle": "Good Bye Lenin!",
      "FilmTitle": "Good Bye Lenin!",
      "AlternateTitle": "",
      "TitleArray": [
        "Good Bye Lenin!"
      ],
      "Year": "2003",
      "Director": "Wolfgang Becker",
      "DirectorArray": [
        "Wolfgang Becker"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1401",
      "databaseFilmTitle": "Good Luck",
      "FilmTitle": "Good Luck",
      "AlternateTitle": "Bonne chance!",
      "TitleArray": [
        "Good Luck",
        "Bonne chance!"
      ],
      "Year": "1935",
      "Director": "Sacha Guitry, Fernand Rivers",
      "DirectorArray": [
        "Sacha Guitry",
        "Fernand Rivers"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1402",
      "databaseFilmTitle": "Good Men, Good Women",
      "FilmTitle": "Good Men, Good Women",
      "AlternateTitle": "Hao nan hao nu",
      "TitleArray": [
        "Good Men, Good Women",
        "Hao nan hao nu"
      ],
      "Year": "1995",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1403",
      "databaseFilmTitle": "Good Morning",
      "FilmTitle": "Good Morning",
      "AlternateTitle": "Ohayō",
      "TitleArray": [
        "Good Morning",
        "Ohayō"
      ],
      "Year": "1959",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1404",
      "databaseFilmTitle": "Good Morning, Boys",
      "FilmTitle": "Good Morning, Boys",
      "AlternateTitle": "",
      "TitleArray": [
        "Good Morning, Boys"
      ],
      "Year": "1937",
      "Director": "Marcel Varnel",
      "DirectorArray": [
        "Marcel Varnel"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1405",
      "databaseFilmTitle": "Good Morning, Night",
      "FilmTitle": "Good Morning, Night",
      "AlternateTitle": "Buongiorno, notte",
      "TitleArray": [
        "Good Morning, Night",
        "Buongiorno, notte"
      ],
      "Year": "2003",
      "Director": "Marco Bellocchio",
      "DirectorArray": [
        "Marco Bellocchio"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1406",
      "databaseFilmTitle": "Good News",
      "FilmTitle": "Good News",
      "AlternateTitle": "",
      "TitleArray": [
        "Good News"
      ],
      "Year": "1947",
      "Director": "Charles Walters",
      "DirectorArray": [
        "Charles Walters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1407",
      "databaseFilmTitle": "Good Sam",
      "FilmTitle": "Good Sam",
      "AlternateTitle": "",
      "TitleArray": [
        "Good Sam"
      ],
      "Year": "1948",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1408",
      "databaseFilmTitle": "Good Weather, But Stormy Late This Afternoon",
      "FilmTitle": "Good Weather, But Stormy Late This Afternoon",
      "AlternateTitle": "Beau temps mais orageux en fin de journée",
      "TitleArray": [
        "Good Weather, But Stormy Late This Afternoon",
        "Beau temps mais orageux en fin de journée"
      ],
      "Year": "1985",
      "Director": "Gérard Frot-Coutaz",
      "DirectorArray": [
        "Gérard Frot-Coutaz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1409",
      "databaseFilmTitle": "Good Will Hunting",
      "FilmTitle": "Good Will Hunting",
      "AlternateTitle": "",
      "TitleArray": [
        "Good Will Hunting"
      ],
      "Year": "1997",
      "Director": "Gus Van Sant",
      "DirectorArray": [
        "Gus Van Sant"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1410",
      "databaseFilmTitle": "Goodbye First Love",
      "FilmTitle": "Goodbye First Love",
      "AlternateTitle": "Un amour de jeunesse",
      "TitleArray": [
        "Goodbye First Love",
        "Un amour de jeunesse"
      ],
      "Year": "2011",
      "Director": "Mia Hansen-Løve",
      "DirectorArray": [
        "Mia Hansen-Løve"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1411",
      "databaseFilmTitle": "Goodbye South, Goodbye",
      "FilmTitle": "Goodbye South, Goodbye",
      "AlternateTitle": "Nan guo zai jian, nan guo",
      "TitleArray": [
        "Goodbye South, Goodbye",
        "Nan guo zai jian, nan guo"
      ],
      "Year": "1996",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1412",
      "databaseFilmTitle": "Goodbye to Language",
      "FilmTitle": "Goodbye to Language",
      "AlternateTitle": "Adieu au langage",
      "TitleArray": [
        "Goodbye to Language",
        "Adieu au langage"
      ],
      "Year": "2014",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1413",
      "databaseFilmTitle": "Goodbye, Children",
      "FilmTitle": "Goodbye, Children",
      "AlternateTitle": "Au revoir les enfants",
      "TitleArray": [
        "Goodbye, Children",
        "Au revoir les enfants"
      ],
      "Year": "1987",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1414",
      "databaseFilmTitle": "Goodbye, Dragon Inn",
      "FilmTitle": "Goodbye, Dragon Inn",
      "AlternateTitle": "Bu san",
      "TitleArray": [
        "Goodbye, Dragon Inn",
        "Bu san"
      ],
      "Year": "2003",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "1415",
      "databaseFilmTitle": "Goodfellas",
      "FilmTitle": "Goodfellas",
      "AlternateTitle": "",
      "TitleArray": [
        "Goodfellas"
      ],
      "Year": "1990",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "63",
      "2022votes": "40"
    },
    {
      "key": "1416",
      "databaseFilmTitle": "Goon",
      "FilmTitle": "Goon",
      "AlternateTitle": "",
      "TitleArray": [
        "Goon"
      ],
      "Year": "2011",
      "Director": "Michael Dowse",
      "DirectorArray": [
        "Michael Dowse"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1417",
      "databaseFilmTitle": "Goto, Island of Love",
      "FilmTitle": "Goto, Island of Love",
      "AlternateTitle": "Goto, l'île d'amour",
      "TitleArray": [
        "Goto, Island of Love",
        "Goto, l'île d'amour"
      ],
      "Year": "1969",
      "Director": "Walerian Borowczyk",
      "DirectorArray": [
        "Walerian Borowczyk"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1418",
      "databaseFilmTitle": "Gran Torino",
      "FilmTitle": "Gran Torino",
      "AlternateTitle": "",
      "TitleArray": [
        "Gran Torino"
      ],
      "Year": "2008",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1419",
      "databaseFilmTitle": "Grand Illusion",
      "FilmTitle": "Grand Illusion",
      "AlternateTitle": "La grande illusion",
      "TitleArray": [
        "Grand Illusion",
        "La grande illusion"
      ],
      "Year": "1937",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "13",
      "1952votes": "9",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "73",
      "2012votes": "22",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "1420",
      "databaseFilmTitle": "Grass: A Nation's Battle for Life",
      "FilmTitle": "Grass: A Nation's Battle for Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Grass: A Nation's Battle for Life"
      ],
      "Year": "1925",
      "Director": "Merian C. Cooper, Ernest B. Schoedsack",
      "DirectorArray": [
        "Merian C. Cooper",
        "Ernest B. Schoedsack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1421",
      "databaseFilmTitle": "Grave of the Fireflies",
      "FilmTitle": "Grave of the Fireflies",
      "AlternateTitle": "Hotaru no haka",
      "TitleArray": [
        "Grave of the Fireflies",
        "Hotaru no haka"
      ],
      "Year": "1988",
      "Director": "Isao Takahata",
      "DirectorArray": [
        "Isao Takahata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1422",
      "databaseFilmTitle": "Gravity",
      "FilmTitle": "Gravity",
      "AlternateTitle": "",
      "TitleArray": [
        "Gravity"
      ],
      "Year": "2013",
      "Director": "Alfonso Cuarón",
      "DirectorArray": [
        "Alfonso Cuarón"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1423",
      "databaseFilmTitle": "Grease",
      "FilmTitle": "Grease",
      "AlternateTitle": "",
      "TitleArray": [
        "Grease"
      ],
      "Year": "1978",
      "Director": "Randal Kleiser",
      "DirectorArray": [
        "Randal Kleiser"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1424",
      "databaseFilmTitle": "Great Citizen",
      "FilmTitle": "Great Citizen",
      "AlternateTitle": "Velikiy grazhdanin",
      "TitleArray": [
        "Great Citizen",
        "Velikiy grazhdanin"
      ],
      "Year": "1938",
      "Director": "Fridrikh Ermler",
      "DirectorArray": [
        "Fridrikh Ermler"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1425",
      "databaseFilmTitle": "Great Day",
      "FilmTitle": "Great Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Great Day"
      ],
      "Year": "1945",
      "Director": "Lance Comfort",
      "DirectorArray": [
        "Lance Comfort"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1426",
      "databaseFilmTitle": "Great Expectations",
      "FilmTitle": "Great Expectations",
      "AlternateTitle": "",
      "TitleArray": [
        "Great Expectations"
      ],
      "Year": "1946",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1427",
      "databaseFilmTitle": "Great Freedom",
      "FilmTitle": "Great Freedom",
      "AlternateTitle": "Große Freiheit",
      "TitleArray": [
        "Great Freedom",
        "Große Freiheit"
      ],
      "Year": "2021",
      "Director": "Sebastian Meise",
      "DirectorArray": [
        "Sebastian Meise"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1428",
      "databaseFilmTitle": "Great Society",
      "FilmTitle": "Great Society",
      "AlternateTitle": "",
      "TitleArray": [
        "Great Society"
      ],
      "Year": "1967",
      "Director": "Masanori Oe",
      "DirectorArray": [
        "Masanori Oe"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1429",
      "databaseFilmTitle": "Greed",
      "FilmTitle": "Greed",
      "AlternateTitle": "",
      "TitleArray": [
        "Greed"
      ],
      "Year": "1924",
      "Director": "Erich von Stroheim",
      "DirectorArray": [
        "Erich von Stroheim"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "7",
      "1952votes": "11",
      "1962rank": "4",
      "1962votes": "17",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "14",
      "1982votes": "9",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "1430",
      "databaseFilmTitle": "Greenberg",
      "FilmTitle": "Greenberg",
      "AlternateTitle": "",
      "TitleArray": [
        "Greenberg"
      ],
      "Year": "2010",
      "Director": "Noah Baumbach",
      "DirectorArray": [
        "Noah Baumbach"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1431",
      "databaseFilmTitle": "Gregory's Girl",
      "FilmTitle": "Gregory's Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Gregory's Girl"
      ],
      "Year": "1980",
      "Director": "Bill Forsyth",
      "DirectorArray": [
        "Bill Forsyth"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1432",
      "databaseFilmTitle": "Gremlins 2: The New Batch",
      "FilmTitle": "Gremlins 2: The New Batch",
      "AlternateTitle": "",
      "TitleArray": [
        "Gremlins 2: The New Batch"
      ],
      "Year": "1990",
      "Director": "Joe Dante",
      "DirectorArray": [
        "Joe Dante"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1433",
      "databaseFilmTitle": "Grey Gardens",
      "FilmTitle": "Grey Gardens",
      "AlternateTitle": "",
      "TitleArray": [
        "Grey Gardens"
      ],
      "Year": "1975",
      "Director": "Albert Maysles, David Maysles, Ellen Hovde, Muffie Meyer",
      "DirectorArray": [
        "Albert Maysles",
        "David Maysles",
        "Ellen Hovde",
        "Muffie Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1434",
      "databaseFilmTitle": "Grey Morning",
      "FilmTitle": "Grey Morning",
      "AlternateTitle": "Manhã Cinzenta",
      "TitleArray": [
        "Grey Morning",
        "Manhã Cinzenta"
      ],
      "Year": "1969",
      "Director": "Olney São Paulo",
      "DirectorArray": [
        "Olney São Paulo"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1435",
      "databaseFilmTitle": "Grizzly Man",
      "FilmTitle": "Grizzly Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Grizzly Man"
      ],
      "Year": "2005",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1436",
      "databaseFilmTitle": "Groundhog Day",
      "FilmTitle": "Groundhog Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Groundhog Day"
      ],
      "Year": "1993",
      "Director": "Harold Ramis",
      "DirectorArray": [
        "Harold Ramis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1437",
      "databaseFilmTitle": "Guelwaar",
      "FilmTitle": "Guelwaar",
      "AlternateTitle": "",
      "TitleArray": [
        "Guelwaar"
      ],
      "Year": "1992",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1438",
      "databaseFilmTitle": "Guernica",
      "FilmTitle": "Guernica",
      "AlternateTitle": "",
      "TitleArray": [
        "Guernica"
      ],
      "Year": "1951",
      "Director": "Robert Hessens, Alain Resnais",
      "DirectorArray": [
        "Robert Hessens",
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1439",
      "databaseFilmTitle": "Guess Who's Coming to Dinner",
      "FilmTitle": "Guess Who's Coming to Dinner",
      "AlternateTitle": "",
      "TitleArray": [
        "Guess Who's Coming to Dinner"
      ],
      "Year": "1967",
      "Director": "Stanley Kramer",
      "DirectorArray": [
        "Stanley Kramer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1440",
      "databaseFilmTitle": "Guided by Voices",
      "FilmTitle": "Guided by Voices",
      "AlternateTitle": "",
      "TitleArray": [
        "Guided by Voices"
      ],
      "Year": "2000",
      "Director": "Stom Sogo",
      "DirectorArray": [
        "Stom Sogo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1441",
      "databaseFilmTitle": "Gummo",
      "FilmTitle": "Gummo",
      "AlternateTitle": "",
      "TitleArray": [
        "Gummo"
      ],
      "Year": "1997",
      "Director": "Harmony Korine",
      "DirectorArray": [
        "Harmony Korine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1442",
      "databaseFilmTitle": "Gun Crazy",
      "FilmTitle": "Gun Crazy",
      "AlternateTitle": "Deadly is the Female",
      "TitleArray": [
        "Gun Crazy",
        "Deadly is the Female"
      ],
      "Year": "1950",
      "Director": "Joseph H. Lewis",
      "DirectorArray": [
        "Joseph H. Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1443",
      "databaseFilmTitle": "Gunnar Hedes Saga",
      "FilmTitle": "Gunnar Hedes Saga",
      "AlternateTitle": "",
      "TitleArray": [
        "Gunnar Hedes Saga"
      ],
      "Year": "1923",
      "Director": "Mauritz Stiller",
      "DirectorArray": [
        "Mauritz Stiller"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1444",
      "databaseFilmTitle": "Guns of the Trees",
      "FilmTitle": "Guns of the Trees",
      "AlternateTitle": "",
      "TitleArray": [
        "Guns of the Trees"
      ],
      "Year": "1962",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1445",
      "databaseFilmTitle": "Guys and Dolls",
      "FilmTitle": "Guys and Dolls",
      "AlternateTitle": "",
      "TitleArray": [
        "Guys and Dolls"
      ],
      "Year": "1955",
      "Director": "Joseph L. Mankiewicz",
      "DirectorArray": [
        "Joseph L. Mankiewicz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1446",
      "databaseFilmTitle": "Hail the Conquering Hero",
      "FilmTitle": "Hail the Conquering Hero",
      "AlternateTitle": "",
      "TitleArray": [
        "Hail the Conquering Hero"
      ],
      "Year": "1944",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1447",
      "databaseFilmTitle": "Hair",
      "FilmTitle": "Hair",
      "AlternateTitle": "",
      "TitleArray": [
        "Hair"
      ],
      "Year": "1979",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1448",
      "databaseFilmTitle": "Haircut",
      "FilmTitle": "Haircut",
      "AlternateTitle": "Corte de Cabelo",
      "TitleArray": [
        "Haircut",
        "Corte de Cabelo"
      ],
      "Year": "1995",
      "Director": "Joaquim Sapinho",
      "DirectorArray": [
        "Joaquim Sapinho"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1449",
      "databaseFilmTitle": "Hairspray",
      "FilmTitle": "Hairspray",
      "AlternateTitle": "",
      "TitleArray": [
        "Hairspray"
      ],
      "Year": "1988",
      "Director": "John Waters",
      "DirectorArray": [
        "John Waters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1450",
      "databaseFilmTitle": "Hallelujah!",
      "FilmTitle": "Hallelujah!",
      "AlternateTitle": "",
      "TitleArray": [
        "Hallelujah!"
      ],
      "Year": "1929",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "21",
      "1952votes": "6",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1451",
      "databaseFilmTitle": "Halloween",
      "FilmTitle": "Halloween",
      "AlternateTitle": "",
      "TitleArray": [
        "Halloween"
      ],
      "Year": "1978",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1452",
      "databaseFilmTitle": "Hamlet (1948)",
      "FilmTitle": "Hamlet",
      "AlternateTitle": "",
      "TitleArray": [
        "Hamlet"
      ],
      "Year": "1948",
      "Director": "Laurence Olivier",
      "DirectorArray": [
        "Laurence Olivier"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1453",
      "databaseFilmTitle": "Hamlet (1964)",
      "FilmTitle": "Hamlet",
      "AlternateTitle": "Gamlet",
      "TitleArray": [
        "Hamlet",
        "Gamlet"
      ],
      "Year": "1964",
      "Director": "Grigori Kozintsev",
      "DirectorArray": [
        "Grigori Kozintsev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1454",
      "databaseFilmTitle": "Hana and Alice",
      "FilmTitle": "Hana and Alice",
      "AlternateTitle": "Hana to Arisu",
      "TitleArray": [
        "Hana and Alice",
        "Hana to Arisu"
      ],
      "Year": "2004",
      "Director": "Shunji Iwai",
      "DirectorArray": [
        "Shunji Iwai"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1455",
      "databaseFilmTitle": "Hand Movie",
      "FilmTitle": "Hand Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "Hand Movie"
      ],
      "Year": "1966",
      "Director": "Yvonne Rainer",
      "DirectorArray": [
        "Yvonne Rainer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1456",
      "databaseFilmTitle": "Hands Over the City",
      "FilmTitle": "Hands Over the City",
      "AlternateTitle": "Le mani sulla città",
      "TitleArray": [
        "Hands Over the City",
        "Le mani sulla città"
      ],
      "Year": "1963",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1457",
      "databaseFilmTitle": "Handsworth Songs",
      "FilmTitle": "Handsworth Songs",
      "AlternateTitle": "",
      "TitleArray": [
        "Handsworth Songs"
      ],
      "Year": "1986",
      "Director": "John Akomfrah, Black Audio Film Collective",
      "DirectorArray": [
        "John Akomfrah",
        "Black Audio Film Collective"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "1458",
      "databaseFilmTitle": "Hangmen Also Die!",
      "FilmTitle": "Hangmen Also Die!",
      "AlternateTitle": "",
      "TitleArray": [
        "Hangmen Also Die!"
      ],
      "Year": "1943",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1459",
      "databaseFilmTitle": "Hannah and Her Sisters",
      "FilmTitle": "Hannah and Her Sisters",
      "AlternateTitle": "",
      "TitleArray": [
        "Hannah and Her Sisters"
      ],
      "Year": "1986",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1460",
      "databaseFilmTitle": "Hanoi, Tuesday 13th",
      "FilmTitle": "Hanoi, Tuesday 13th",
      "AlternateTitle": "Hanoi, martes 13",
      "TitleArray": [
        "Hanoi, Tuesday 13th",
        "Hanoi, martes 13"
      ],
      "Year": "1967",
      "Director": "Santiago Álvarez",
      "DirectorArray": [
        "Santiago Álvarez"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1461",
      "databaseFilmTitle": "Hapax Legomena I: Nostalgia",
      "FilmTitle": "Hapax Legomena I: Nostalgia",
      "AlternateTitle": "(Nostalgia)",
      "TitleArray": [
        "Hapax Legomena I: Nostalgia",
        "(Nostalgia)"
      ],
      "Year": "1971",
      "Director": "Hollis Frampton",
      "DirectorArray": [
        "Hollis Frampton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1462",
      "databaseFilmTitle": "Happiness (1935)",
      "FilmTitle": "Happiness",
      "AlternateTitle": "Schaste",
      "TitleArray": [
        "Happiness",
        "Schaste"
      ],
      "Year": "1935",
      "Director": "Aleksandr Medvedkin",
      "DirectorArray": [
        "Aleksandr Medvedkin"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1463",
      "databaseFilmTitle": "Happiness (1998)",
      "FilmTitle": "Happiness",
      "AlternateTitle": "",
      "TitleArray": [
        "Happiness"
      ],
      "Year": "1998",
      "Director": "Todd Solondz",
      "DirectorArray": [
        "Todd Solondz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1464",
      "databaseFilmTitle": "Happy as Lazzaro",
      "FilmTitle": "Happy as Lazzaro",
      "AlternateTitle": "Lazzaro felice",
      "TitleArray": [
        "Happy as Lazzaro",
        "Lazzaro felice"
      ],
      "Year": "2018",
      "Director": "Alice Rohrwacher",
      "DirectorArray": [
        "Alice Rohrwacher"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1465",
      "databaseFilmTitle": "Happy End",
      "FilmTitle": "Happy End",
      "AlternateTitle": "",
      "TitleArray": [
        "Happy End"
      ],
      "Year": "2017",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "France, Austria",
      "CountryArray": [
        "France",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1466",
      "databaseFilmTitle": "Happy Hour",
      "FilmTitle": "Happy Hour",
      "AlternateTitle": "",
      "TitleArray": [
        "Happy Hour"
      ],
      "Year": "2015",
      "Director": "Ryusuke Hamaguchi",
      "DirectorArray": [
        "Ryusuke Hamaguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1467",
      "databaseFilmTitle": "Happy Together",
      "FilmTitle": "Happy Together",
      "AlternateTitle": "Chun gwong cha sit",
      "TitleArray": [
        "Happy Together",
        "Chun gwong cha sit"
      ],
      "Year": "1997",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1468",
      "databaseFilmTitle": "Harakiri",
      "FilmTitle": "Harakiri",
      "AlternateTitle": "Seppuku",
      "TitleArray": [
        "Harakiri",
        "Seppuku"
      ],
      "Year": "1962",
      "Director": "Masaki Kobayashi",
      "DirectorArray": [
        "Masaki Kobayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1469",
      "databaseFilmTitle": "Hard Boiled",
      "FilmTitle": "Hard Boiled",
      "AlternateTitle": "Lat sau san taam",
      "TitleArray": [
        "Hard Boiled",
        "Lat sau san taam"
      ],
      "Year": "1992",
      "Director": "John Woo",
      "DirectorArray": [
        "John Woo"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1470",
      "databaseFilmTitle": "Hard to Be a God",
      "FilmTitle": "Hard to Be a God",
      "AlternateTitle": "",
      "TitleArray": [
        "Hard to Be a God"
      ],
      "Year": "2013",
      "Director": "Aleksei German",
      "DirectorArray": [
        "Aleksei German"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1471",
      "databaseFilmTitle": "Hardwood Process",
      "FilmTitle": "Hardwood Process",
      "AlternateTitle": "",
      "TitleArray": [
        "Hardwood Process"
      ],
      "Year": "1996",
      "Director": "David Gatten",
      "DirectorArray": [
        "David Gatten"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1472",
      "databaseFilmTitle": "Harlan County USA",
      "FilmTitle": "Harlan County USA",
      "AlternateTitle": "",
      "TitleArray": [
        "Harlan County USA"
      ],
      "Year": "1976",
      "Director": "Barbara Kopple",
      "DirectorArray": [
        "Barbara Kopple"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1473",
      "databaseFilmTitle": "Harmony Lessons",
      "FilmTitle": "Harmony Lessons",
      "AlternateTitle": "Aslannyn sabaktary",
      "TitleArray": [
        "Harmony Lessons",
        "Aslannyn sabaktary"
      ],
      "Year": "2013",
      "Director": "Emir Baigazin",
      "DirectorArray": [
        "Emir Baigazin"
      ],
      "Country": "Kazakhstan, Germany",
      "CountryArray": [
        "Kazakhstan",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1474",
      "databaseFilmTitle": "Harold and Maude",
      "FilmTitle": "Harold and Maude",
      "AlternateTitle": "",
      "TitleArray": [
        "Harold and Maude"
      ],
      "Year": "1971",
      "Director": "Hal Ashby",
      "DirectorArray": [
        "Hal Ashby"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1475",
      "databaseFilmTitle": "Harvest",
      "FilmTitle": "Harvest",
      "AlternateTitle": "Regain",
      "TitleArray": [
        "Harvest",
        "Regain"
      ],
      "Year": "1937",
      "Director": "Marcel Pagnol",
      "DirectorArray": [
        "Marcel Pagnol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1476",
      "databaseFilmTitle": "Harvest: 3000 Years",
      "FilmTitle": "Harvest: 3000 Years",
      "AlternateTitle": "Mirt Sost Shi Amit",
      "TitleArray": [
        "Harvest: 3000 Years",
        "Mirt Sost Shi Amit"
      ],
      "Year": "1976",
      "Director": "Haile Gerima",
      "DirectorArray": [
        "Haile Gerima"
      ],
      "Country": "Ethiopia",
      "CountryArray": [
        "Ethiopia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1477",
      "databaseFilmTitle": "Hatari!",
      "FilmTitle": "Hatari!",
      "AlternateTitle": "",
      "TitleArray": [
        "Hatari!"
      ],
      "Year": "1962",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1478",
      "databaseFilmTitle": "Häxan: Witchcraft Through the Ages",
      "FilmTitle": "Häxan: Witchcraft Through the Ages",
      "AlternateTitle": "Häxan",
      "TitleArray": [
        "Häxan: Witchcraft Through the Ages",
        "Häxan"
      ],
      "Year": "1922",
      "Director": "Benjamin Christensen",
      "DirectorArray": [
        "Benjamin Christensen"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1479",
      "databaseFilmTitle": "He Stands in a Desert Counting the Seconds of His Life",
      "FilmTitle": "He Stands in a Desert Counting the Seconds of His Life",
      "AlternateTitle": "",
      "TitleArray": [
        "He Stands in a Desert Counting the Seconds of His Life"
      ],
      "Year": "1986",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1480",
      "databaseFilmTitle": "He Who Gets Slapped",
      "FilmTitle": "He Who Gets Slapped",
      "AlternateTitle": "",
      "TitleArray": [
        "He Who Gets Slapped"
      ],
      "Year": "1924",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1481",
      "databaseFilmTitle": "Head",
      "FilmTitle": "Head",
      "AlternateTitle": "",
      "TitleArray": [
        "Head"
      ],
      "Year": "1968",
      "Director": "Bob Rafelson",
      "DirectorArray": [
        "Bob Rafelson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1482",
      "databaseFilmTitle": "Head-On",
      "FilmTitle": "Head-On",
      "AlternateTitle": "Gegen die Wand",
      "TitleArray": [
        "Head-On",
        "Gegen die Wand"
      ],
      "Year": "2004",
      "Director": "Faith Akin",
      "DirectorArray": [
        "Faith Akin"
      ],
      "Country": "Germany, Turkey",
      "CountryArray": [
        "Germany",
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1483",
      "databaseFilmTitle": "Healthy People for Pastime",
      "FilmTitle": "Healthy People for Pastime",
      "AlternateTitle": "Zdravi ljudi za razonodu",
      "TitleArray": [
        "Healthy People for Pastime",
        "Zdravi ljudi za razonodu"
      ],
      "Year": "1971",
      "Director": "Karpo Ačimović-Godina",
      "DirectorArray": [
        "Karpo Ačimović-Godina"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1484",
      "databaseFilmTitle": "Heart of a Dog",
      "FilmTitle": "Heart of a Dog",
      "AlternateTitle": "",
      "TitleArray": [
        "Heart of a Dog"
      ],
      "Year": "2015",
      "Director": "Laurie Anderson",
      "DirectorArray": [
        "Laurie Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1485",
      "databaseFilmTitle": "Heart, Beating in the Dark",
      "FilmTitle": "Heart, Beating in the Dark",
      "AlternateTitle": "Yami utsu shinzô",
      "TitleArray": [
        "Heart, Beating in the Dark",
        "Yami utsu shinzô"
      ],
      "Year": "1982",
      "Director": "Shunichi Nagasaki",
      "DirectorArray": [
        "Shunichi Nagasaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1486",
      "databaseFilmTitle": "Hearts and Minds",
      "FilmTitle": "Hearts and Minds",
      "AlternateTitle": "",
      "TitleArray": [
        "Hearts and Minds"
      ],
      "Year": "1974",
      "Director": "Peter Davis",
      "DirectorArray": [
        "Peter Davis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1487",
      "databaseFilmTitle": "Heat",
      "FilmTitle": "Heat",
      "AlternateTitle": "",
      "TitleArray": [
        "Heat"
      ],
      "Year": "1995",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "1488",
      "databaseFilmTitle": "Heaven and Earth Magic",
      "FilmTitle": "Heaven and Earth Magic",
      "AlternateTitle": "",
      "TitleArray": [
        "Heaven and Earth Magic"
      ],
      "Year": "1962",
      "Director": "Harry Smith",
      "DirectorArray": [
        "Harry Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1489",
      "databaseFilmTitle": "Heaven Can Wait",
      "FilmTitle": "Heaven Can Wait",
      "AlternateTitle": "",
      "TitleArray": [
        "Heaven Can Wait"
      ],
      "Year": "1943",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1490",
      "databaseFilmTitle": "Heaven Knows, Mr. Allison",
      "FilmTitle": "Heaven Knows, Mr. Allison",
      "AlternateTitle": "",
      "TitleArray": [
        "Heaven Knows, Mr. Allison"
      ],
      "Year": "1957",
      "Director": "Jonhn Huston",
      "DirectorArray": [
        "Jonhn Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1491",
      "databaseFilmTitle": "Heaven's Gate",
      "FilmTitle": "Heaven's Gate",
      "AlternateTitle": "",
      "TitleArray": [
        "Heaven's Gate"
      ],
      "Year": "1980",
      "Director": "Michael Cimino",
      "DirectorArray": [
        "Michael Cimino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "1492",
      "databaseFilmTitle": "Heavenly Creatures",
      "FilmTitle": "Heavenly Creatures",
      "AlternateTitle": "",
      "TitleArray": [
        "Heavenly Creatures"
      ],
      "Year": "1994",
      "Director": "Peter Jackson",
      "DirectorArray": [
        "Peter Jackson"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1493",
      "databaseFilmTitle": "Hedgehog in the Fog",
      "FilmTitle": "Hedgehog in the Fog",
      "AlternateTitle": "",
      "TitleArray": [
        "Hedgehog in the Fog"
      ],
      "Year": "1975",
      "Director": "Yuri Norstein",
      "DirectorArray": [
        "Yuri Norstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1494",
      "databaseFilmTitle": "Hedi",
      "FilmTitle": "Hedi",
      "AlternateTitle": "",
      "TitleArray": [
        "Hedi"
      ],
      "Year": "2016",
      "Director": "Mohamed Ben Attia",
      "DirectorArray": [
        "Mohamed Ben Attia"
      ],
      "Country": "Tunisia",
      "CountryArray": [
        "Tunisia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1495",
      "databaseFilmTitle": "Heimat II: A Chronicle of a Generation",
      "FilmTitle": "Heimat II: A Chronicle of a Generation",
      "AlternateTitle": "Die Zweite Heimat – Chronik einer Jugend",
      "TitleArray": [
        "Heimat II: A Chronicle of a Generation",
        "Die Zweite Heimat – Chronik einer Jugend"
      ],
      "Year": "1992",
      "Director": "Edgar Reitz",
      "DirectorArray": [
        "Edgar Reitz"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1496",
      "databaseFilmTitle": "Heimat: A Chronicle of Germany",
      "FilmTitle": "Heimat: A Chronicle of Germany",
      "AlternateTitle": "Heimat – Eine deutsche Chronik",
      "TitleArray": [
        "Heimat: A Chronicle of Germany",
        "Heimat – Eine deutsche Chronik"
      ],
      "Year": "1984",
      "Director": "Edgar Reitz",
      "DirectorArray": [
        "Edgar Reitz"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1497",
      "databaseFilmTitle": "Heir to an Execution",
      "FilmTitle": "Heir to an Execution",
      "AlternateTitle": "",
      "TitleArray": [
        "Heir to an Execution"
      ],
      "Year": "2004",
      "Director": "Ivy Meeropol",
      "DirectorArray": [
        "Ivy Meeropol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1498",
      "databaseFilmTitle": "Hellbound: Hellraiser II",
      "FilmTitle": "Hellbound: Hellraiser II",
      "AlternateTitle": "",
      "TitleArray": [
        "Hellbound: Hellraiser II"
      ],
      "Year": "1988",
      "Director": "Tony Randel",
      "DirectorArray": [
        "Tony Randel"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1499",
      "databaseFilmTitle": "Hellraiser",
      "FilmTitle": "Hellraiser",
      "AlternateTitle": "",
      "TitleArray": [
        "Hellraiser"
      ],
      "Year": "1987",
      "Director": "Clive Barker",
      "DirectorArray": [
        "Clive Barker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1500",
      "databaseFilmTitle": "Hellzapoppin'",
      "FilmTitle": "Hellzapoppin'",
      "AlternateTitle": "",
      "TitleArray": [
        "Hellzapoppin'"
      ],
      "Year": "1941",
      "Director": "H.C. Potter",
      "DirectorArray": [
        "H.C. Potter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1501",
      "databaseFilmTitle": "Help!",
      "FilmTitle": "Help!",
      "AlternateTitle": "Au secours!",
      "TitleArray": [
        "Help!",
        "Au secours!"
      ],
      "Year": "1924",
      "Director": "Abel Gance",
      "DirectorArray": [
        "Abel Gance"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1502",
      "databaseFilmTitle": "Helpmates",
      "FilmTitle": "Helpmates",
      "AlternateTitle": "",
      "TitleArray": [
        "Helpmates"
      ],
      "Year": "1932",
      "Director": "James Parrott",
      "DirectorArray": [
        "James Parrott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1503",
      "databaseFilmTitle": "Hen, His Wife",
      "FilmTitle": "Hen, His Wife",
      "AlternateTitle": "Yego zhena kuritsa",
      "TitleArray": [
        "Hen, His Wife",
        "Yego zhena kuritsa"
      ],
      "Year": "1990",
      "Director": "Igor Kovalyov",
      "DirectorArray": [
        "Igor Kovalyov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1504",
      "databaseFilmTitle": "Henry Fool",
      "FilmTitle": "Henry Fool",
      "AlternateTitle": "",
      "TitleArray": [
        "Henry Fool"
      ],
      "Year": "1997",
      "Director": "Hal Hartley",
      "DirectorArray": [
        "Hal Hartley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1505",
      "databaseFilmTitle": "Henry Geldzahler",
      "FilmTitle": "Henry Geldzahler",
      "AlternateTitle": "",
      "TitleArray": [
        "Henry Geldzahler"
      ],
      "Year": "1964",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1506",
      "databaseFilmTitle": "Henry V",
      "FilmTitle": "Henry V",
      "AlternateTitle": "The Chronicle History of King Henry the Fift with his battell fought at Agincourt in France",
      "TitleArray": [
        "Henry V",
        "The Chronicle History of King Henry the Fift with his battell fought at Agincourt in France"
      ],
      "Year": "1944",
      "Director": "Laurence Olivier",
      "DirectorArray": [
        "Laurence Olivier"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1507",
      "databaseFilmTitle": "Her Man",
      "FilmTitle": "Her Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Her Man"
      ],
      "Year": "1930",
      "Director": "Tay Garnett",
      "DirectorArray": [
        "Tay Garnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1508",
      "databaseFilmTitle": "Here and Elsewhere",
      "FilmTitle": "Here and Elsewhere",
      "AlternateTitle": "Ici et ailleurs",
      "TitleArray": [
        "Here and Elsewhere",
        "Ici et ailleurs"
      ],
      "Year": "1976",
      "Director": "Jean-Luc Godard, Jean-Pierre Gorin, Groupe Dziga Vertov, Anne-Marie Miéville",
      "DirectorArray": [
        "Jean-Luc Godard",
        "Jean-Pierre Gorin",
        "Groupe Dziga Vertov",
        "Anne-Marie Miéville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1509",
      "databaseFilmTitle": "Hereafter",
      "FilmTitle": "Hereafter",
      "AlternateTitle": "",
      "TitleArray": [
        "Hereafter"
      ],
      "Year": "2010",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1510",
      "databaseFilmTitle": "Heremias (Book One: The Legend of the Lizard Princess)",
      "FilmTitle": "Heremias (Book One: The Legend of the Lizard Princess)",
      "AlternateTitle": "Unang Aklat: Ang Alamat ng Prinsesang Bayawak",
      "TitleArray": [
        "Heremias (Book One: The Legend of the Lizard Princess)",
        "Unang Aklat: Ang Alamat ng Prinsesang Bayawak"
      ],
      "Year": "2006",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1511",
      "databaseFilmTitle": "Hero (1987)",
      "FilmTitle": "Hero",
      "AlternateTitle": "Nayakan",
      "TitleArray": [
        "Hero",
        "Nayakan"
      ],
      "Year": "1987",
      "Director": "Mani Ratnam",
      "DirectorArray": [
        "Mani Ratnam"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1512",
      "databaseFilmTitle": "Hero (2002)",
      "FilmTitle": "Hero",
      "AlternateTitle": "Yīngxióng",
      "TitleArray": [
        "Hero",
        "Yīngxióng"
      ],
      "Year": "2002",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1513",
      "databaseFilmTitle": "Herod's Law",
      "FilmTitle": "Herod's Law",
      "AlternateTitle": "La ley de Herodes",
      "TitleArray": [
        "Herod's Law",
        "La ley de Herodes"
      ],
      "Year": "1999",
      "Director": "Luis Estrada",
      "DirectorArray": [
        "Luis Estrada"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1514",
      "databaseFilmTitle": "Heroic Purgatory",
      "FilmTitle": "Heroic Purgatory",
      "AlternateTitle": "Rengoku eroica",
      "TitleArray": [
        "Heroic Purgatory",
        "Rengoku eroica"
      ],
      "Year": "1970",
      "Director": "Yoshishige Yoshida",
      "DirectorArray": [
        "Yoshishige Yoshida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1515",
      "databaseFilmTitle": "Heroism",
      "FilmTitle": "Heroism",
      "AlternateTitle": "Erioca",
      "TitleArray": [
        "Heroism",
        "Erioca"
      ],
      "Year": "1957",
      "Director": "Andrzej Munk",
      "DirectorArray": [
        "Andrzej Munk"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1516",
      "databaseFilmTitle": "Hester Street",
      "FilmTitle": "Hester Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Hester Street"
      ],
      "Year": "1975",
      "Director": "Joan Micklin Silver",
      "DirectorArray": [
        "Joan Micklin Silver"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1517",
      "databaseFilmTitle": "Hi, Mom!",
      "FilmTitle": "Hi, Mom!",
      "AlternateTitle": "",
      "TitleArray": [
        "Hi, Mom!"
      ],
      "Year": "1970",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1518",
      "databaseFilmTitle": "Hidden",
      "FilmTitle": "Hidden",
      "AlternateTitle": "Caché",
      "TitleArray": [
        "Hidden",
        "Caché"
      ],
      "Year": "2005",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "France, Austria",
      "CountryArray": [
        "France",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1519",
      "databaseFilmTitle": "High and Low",
      "FilmTitle": "High and Low",
      "AlternateTitle": "Tengoku to Jigoku",
      "TitleArray": [
        "High and Low",
        "Tengoku to Jigoku"
      ],
      "Year": "1963",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1520",
      "databaseFilmTitle": "High Heels",
      "FilmTitle": "High Heels",
      "AlternateTitle": "Tacones lejanos",
      "TitleArray": [
        "High Heels",
        "Tacones lejanos"
      ],
      "Year": "1991",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1521",
      "databaseFilmTitle": "High Life",
      "FilmTitle": "High Life",
      "AlternateTitle": "",
      "TitleArray": [
        "High Life"
      ],
      "Year": "2018",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1522",
      "databaseFilmTitle": "High Noon",
      "FilmTitle": "High Noon",
      "AlternateTitle": "",
      "TitleArray": [
        "High Noon"
      ],
      "Year": "1952",
      "Director": "Fred Zinnemann",
      "DirectorArray": [
        "Fred Zinnemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1523",
      "databaseFilmTitle": "High School",
      "FilmTitle": "High School",
      "AlternateTitle": "",
      "TitleArray": [
        "High School"
      ],
      "Year": "1968",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1524",
      "databaseFilmTitle": "High Sierra",
      "FilmTitle": "High Sierra",
      "AlternateTitle": "",
      "TitleArray": [
        "High Sierra"
      ],
      "Year": "1941",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1525",
      "databaseFilmTitle": "High Tide",
      "FilmTitle": "High Tide",
      "AlternateTitle": "",
      "TitleArray": [
        "High Tide"
      ],
      "Year": "1987",
      "Director": "Gillian Armstrong",
      "DirectorArray": [
        "Gillian Armstrong"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1526",
      "databaseFilmTitle": "Hindered",
      "FilmTitle": "Hindered",
      "AlternateTitle": "Behindert",
      "TitleArray": [
        "Hindered",
        "Behindert"
      ],
      "Year": "1974",
      "Director": "Stephen Dwoskin",
      "DirectorArray": [
        "Stephen Dwoskin"
      ],
      "Country": "West Germany, United Kingdom",
      "CountryArray": [
        "West Germany",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1527",
      "databaseFilmTitle": "Hiroshima mon amour",
      "FilmTitle": "Hiroshima mon amour",
      "AlternateTitle": "",
      "TitleArray": [
        "Hiroshima mon amour"
      ],
      "Year": "1959",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "11",
      "1962votes": "11",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "1528",
      "databaseFilmTitle": "His Butler's Sister",
      "FilmTitle": "His Butler's Sister",
      "AlternateTitle": "",
      "TitleArray": [
        "His Butler's Sister"
      ],
      "Year": "1943",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1529",
      "databaseFilmTitle": "His Girl Friday",
      "FilmTitle": "His Girl Friday",
      "AlternateTitle": "",
      "TitleArray": [
        "His Girl Friday"
      ],
      "Year": "1940",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "129",
      "2022votes": "23"
    },
    {
      "key": "1530",
      "databaseFilmTitle": "Histoire(s) du cinéma",
      "FilmTitle": "Histoire(s) du cinéma",
      "AlternateTitle": "",
      "TitleArray": [
        "Histoire(s) du cinéma"
      ],
      "Year": "1989",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "48",
      "2012votes": "30",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "1531",
      "databaseFilmTitle": "History Is Made at Night",
      "FilmTitle": "History Is Made at Night",
      "AlternateTitle": "",
      "TitleArray": [
        "History Is Made at Night"
      ],
      "Year": "1937",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1532",
      "databaseFilmTitle": "History Lessons",
      "FilmTitle": "History Lessons",
      "AlternateTitle": "Geschichtsunterricht",
      "TitleArray": [
        "History Lessons",
        "Geschichtsunterricht"
      ],
      "Year": "1972",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1533",
      "databaseFilmTitle": "History of Night",
      "FilmTitle": "History of Night",
      "AlternateTitle": "Geschichte der Nacht",
      "TitleArray": [
        "History of Night",
        "Geschichte der Nacht"
      ],
      "Year": "1978",
      "Director": "Clemens Klopfenstein",
      "DirectorArray": [
        "Clemens Klopfenstein"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1534",
      "databaseFilmTitle": "Hit the Road",
      "FilmTitle": "Hit the Road",
      "AlternateTitle": "Jadde Khaki",
      "TitleArray": [
        "Hit the Road",
        "Jadde Khaki"
      ],
      "Year": "2021",
      "Director": "Panah Panahi",
      "DirectorArray": [
        "Panah Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1535",
      "databaseFilmTitle": "Hitlerpinochet",
      "FilmTitle": "Hitlerpinochet",
      "AlternateTitle": "",
      "TitleArray": [
        "Hitlerpinochet"
      ],
      "Year": "1975",
      "Director": "Juan Forch, Jörg Herrmann",
      "DirectorArray": [
        "Juan Forch",
        "Jörg Herrmann"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1536",
      "databaseFilmTitle": "Hitman",
      "FilmTitle": "Hitman",
      "AlternateTitle": "",
      "TitleArray": [
        "Hitman"
      ],
      "Year": "2007",
      "Director": "Xavier Gens",
      "DirectorArray": [
        "Xavier Gens"
      ],
      "Country": "United States, France",
      "CountryArray": [
        "United States",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1537",
      "databaseFilmTitle": "Hoffa",
      "FilmTitle": "Hoffa",
      "AlternateTitle": "",
      "TitleArray": [
        "Hoffa"
      ],
      "Year": "1992",
      "Director": "Danny DeVito",
      "DirectorArray": [
        "Danny DeVito"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1538",
      "databaseFilmTitle": "Hold Me While I'm Naked",
      "FilmTitle": "Hold Me While I'm Naked",
      "AlternateTitle": "",
      "TitleArray": [
        "Hold Me While I'm Naked"
      ],
      "Year": "1966",
      "Director": "George Kuchar",
      "DirectorArray": [
        "George Kuchar"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1539",
      "databaseFilmTitle": "Holiday",
      "FilmTitle": "Holiday",
      "AlternateTitle": "",
      "TitleArray": [
        "Holiday"
      ],
      "Year": "1938",
      "Director": "George Cuckor",
      "DirectorArray": [
        "George Cuckor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1540",
      "databaseFilmTitle": "Hollywood or Bust",
      "FilmTitle": "Hollywood or Bust",
      "AlternateTitle": "",
      "TitleArray": [
        "Hollywood or Bust"
      ],
      "Year": "1956",
      "Director": "Frank Tashlin",
      "DirectorArray": [
        "Frank Tashlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1541",
      "databaseFilmTitle": "Holy Motors",
      "FilmTitle": "Holy Motors",
      "AlternateTitle": "",
      "TitleArray": [
        "Holy Motors"
      ],
      "Year": "2012",
      "Director": "Leos Carax",
      "DirectorArray": [
        "Leos Carax"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "1542",
      "databaseFilmTitle": "Home A VR Spacewalk",
      "FilmTitle": "Home A VR Spacewalk",
      "AlternateTitle": "",
      "TitleArray": [
        "Home A VR Spacewalk"
      ],
      "Year": "2016",
      "Director": "Kate Bartlett",
      "DirectorArray": [
        "Kate Bartlett"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1543",
      "databaseFilmTitle": "Home from the Hill",
      "FilmTitle": "Home from the Hill",
      "AlternateTitle": "",
      "TitleArray": [
        "Home from the Hill"
      ],
      "Year": "1960",
      "Director": "Vinvente Minnelli",
      "DirectorArray": [
        "Vinvente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1544",
      "databaseFilmTitle": "Homeland (Iraq Year Zero)",
      "FilmTitle": "Homeland (Iraq Year Zero)",
      "AlternateTitle": "",
      "TitleArray": [
        "Homeland (Iraq Year Zero)"
      ],
      "Year": "2015",
      "Director": "Abbas Fahdel",
      "DirectorArray": [
        "Abbas Fahdel"
      ],
      "Country": "France, Iraq",
      "CountryArray": [
        "France",
        "Iraq"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1545",
      "databaseFilmTitle": "Homework",
      "FilmTitle": "Homework",
      "AlternateTitle": "Mashgh-e Shab",
      "TitleArray": [
        "Homework",
        "Mashgh-e Shab"
      ],
      "Year": "1989",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1546",
      "databaseFilmTitle": "Honeyland",
      "FilmTitle": "Honeyland",
      "AlternateTitle": "Medena zemja",
      "TitleArray": [
        "Honeyland",
        "Medena zemja"
      ],
      "Year": "2019",
      "Director": "Ljubomir Stefanov, Tamara Kotevska",
      "DirectorArray": [
        "Ljubomir Stefanov",
        "Tamara Kotevska"
      ],
      "Country": "Macedonia",
      "CountryArray": [
        "Macedonia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1547",
      "databaseFilmTitle": "Hong Kong 1941",
      "FilmTitle": "Hong Kong 1941",
      "AlternateTitle": "Dang doi lai ming",
      "TitleArray": [
        "Hong Kong 1941",
        "Dang doi lai ming"
      ],
      "Year": "1984",
      "Director": "Leong Po-Chih",
      "DirectorArray": [
        "Leong Po-Chih"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1548",
      "databaseFilmTitle": "Hoop Dreams",
      "FilmTitle": "Hoop Dreams",
      "AlternateTitle": "",
      "TitleArray": [
        "Hoop Dreams"
      ],
      "Year": "1994",
      "Director": "Steve James",
      "DirectorArray": [
        "Steve James"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1549",
      "databaseFilmTitle": "Hope",
      "FilmTitle": "Hope",
      "AlternateTitle": "Umut",
      "TitleArray": [
        "Hope",
        "Umut"
      ],
      "Year": "1970",
      "Director": "Yılmaz Güney",
      "DirectorArray": [
        "Yılmaz Güney"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1550",
      "databaseFilmTitle": "Hope and Glory",
      "FilmTitle": "Hope and Glory",
      "AlternateTitle": "",
      "TitleArray": [
        "Hope and Glory"
      ],
      "Year": "1987",
      "Director": "John Boorman",
      "DirectorArray": [
        "John Boorman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1551",
      "databaseFilmTitle": "Hors-Chant",
      "FilmTitle": "Hors-Chant",
      "AlternateTitle": "",
      "TitleArray": [
        "Hors-Chant"
      ],
      "Year": "2010",
      "Director": "Renaud de Putter",
      "DirectorArray": [
        "Renaud de Putter"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1552",
      "databaseFilmTitle": "Horse Feathers",
      "FilmTitle": "Horse Feathers",
      "AlternateTitle": "",
      "TitleArray": [
        "Horse Feathers"
      ],
      "Year": "1932",
      "Director": "Norman Z. McLeod",
      "DirectorArray": [
        "Norman Z. McLeod"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1553",
      "databaseFilmTitle": "Hotel America",
      "FilmTitle": "Hotel America",
      "AlternateTitle": "Hôtel des Amériques",
      "TitleArray": [
        "Hotel America",
        "Hôtel des Amériques"
      ],
      "Year": "1981",
      "Director": "André Téchiné",
      "DirectorArray": [
        "André Téchiné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1554",
      "databaseFilmTitle": "Hôtel des Invalides",
      "FilmTitle": "Hôtel des Invalides",
      "AlternateTitle": "",
      "TitleArray": [
        "Hôtel des Invalides"
      ],
      "Year": "1952",
      "Director": "Georges Franju",
      "DirectorArray": [
        "Georges Franju"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1555",
      "databaseFilmTitle": "Hôtel Terminus: The Life and Times of Klaus Barbie",
      "FilmTitle": "Hôtel Terminus: The Life and Times of Klaus Barbie",
      "AlternateTitle": "Hôtel Terminus",
      "TitleArray": [
        "Hôtel Terminus: The Life and Times of Klaus Barbie",
        "Hôtel Terminus"
      ],
      "Year": "1988",
      "Director": "Marcel Ophüls",
      "DirectorArray": [
        "Marcel Ophüls"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1556",
      "databaseFilmTitle": "Hour of the Star",
      "FilmTitle": "Hour of the Star",
      "AlternateTitle": "A hora da estrela",
      "TitleArray": [
        "Hour of the Star",
        "A hora da estrela"
      ],
      "Year": "1985",
      "Director": "Suzana Amaral",
      "DirectorArray": [
        "Suzana Amaral"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1557",
      "databaseFilmTitle": "Hour of the Wolf",
      "FilmTitle": "Hour of the Wolf",
      "AlternateTitle": "Vargtimmen",
      "TitleArray": [
        "Hour of the Wolf",
        "Vargtimmen"
      ],
      "Year": "1968",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1558",
      "databaseFilmTitle": "Hours for Jerome",
      "FilmTitle": "Hours for Jerome",
      "AlternateTitle": "",
      "TitleArray": [
        "Hours for Jerome"
      ],
      "Year": "1982",
      "Director": "Nathaniel Dorsky",
      "DirectorArray": [
        "Nathaniel Dorsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1559",
      "databaseFilmTitle": "House (1957)",
      "FilmTitle": "House",
      "AlternateTitle": "Dom",
      "TitleArray": [
        "House",
        "Dom"
      ],
      "Year": "1957",
      "Director": "Walerian Borowczyk, Jan Lenica",
      "DirectorArray": [
        "Walerian Borowczyk",
        "Jan Lenica"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1560",
      "databaseFilmTitle": "House (1977)",
      "FilmTitle": "House",
      "AlternateTitle": "Hausu",
      "TitleArray": [
        "House",
        "Hausu"
      ],
      "Year": "1977",
      "Director": "Nobuhiko Ôbayashi",
      "DirectorArray": [
        "Nobuhiko Ôbayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1561",
      "databaseFilmTitle": "House of Flying Daggers",
      "FilmTitle": "House of Flying Daggers",
      "AlternateTitle": "Shi mian mai fu",
      "TitleArray": [
        "House of Flying Daggers",
        "Shi mian mai fu"
      ],
      "Year": "2004",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1562",
      "databaseFilmTitle": "House of Hummingbird",
      "FilmTitle": "House of Hummingbird",
      "AlternateTitle": "",
      "TitleArray": [
        "House of Hummingbird"
      ],
      "Year": "2018",
      "Director": "Kim Bora",
      "DirectorArray": [
        "Kim Bora"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1563",
      "databaseFilmTitle": "House on the Sand",
      "FilmTitle": "House on the Sand",
      "AlternateTitle": "Kuća na pijesku",
      "TitleArray": [
        "House on the Sand",
        "Kuća na pijesku"
      ],
      "Year": "1985",
      "Director": "Ivan Martinac",
      "DirectorArray": [
        "Ivan Martinac"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1564",
      "databaseFilmTitle": "House Party",
      "FilmTitle": "House Party",
      "AlternateTitle": "",
      "TitleArray": [
        "House Party"
      ],
      "Year": "1990",
      "Director": "Reginald Hudlin",
      "DirectorArray": [
        "Reginald Hudlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1565",
      "databaseFilmTitle": "Housekeeping",
      "FilmTitle": "Housekeeping",
      "AlternateTitle": "",
      "TitleArray": [
        "Housekeeping"
      ],
      "Year": "1987",
      "Director": "Bill Forsyth",
      "DirectorArray": [
        "Bill Forsyth"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1566",
      "databaseFilmTitle": "How Green Was My Valley",
      "FilmTitle": "How Green Was My Valley",
      "AlternateTitle": "",
      "TitleArray": [
        "How Green Was My Valley"
      ],
      "Year": "1941",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1567",
      "databaseFilmTitle": "How I Won the War",
      "FilmTitle": "How I Won the War",
      "AlternateTitle": "",
      "TitleArray": [
        "How I Won the War"
      ],
      "Year": "1967",
      "Director": "Richard Lester",
      "DirectorArray": [
        "Richard Lester"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1568",
      "databaseFilmTitle": "How Tasty Was My Little Frenchman",
      "FilmTitle": "How Tasty Was My Little Frenchman",
      "AlternateTitle": "Como Era Gostoso o Meu Francês",
      "TitleArray": [
        "How Tasty Was My Little Frenchman",
        "Como Era Gostoso o Meu Francês"
      ],
      "Year": "1971",
      "Director": "Nelson Pereira dos Santos",
      "DirectorArray": [
        "Nelson Pereira dos Santos"
      ],
      "Country": "Algeria, Brazil",
      "CountryArray": [
        "Algeria",
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1569",
      "databaseFilmTitle": "How the Sausage Dog Works",
      "FilmTitle": "How the Sausage Dog Works",
      "AlternateTitle": "Jak działa jamniczek",
      "TitleArray": [
        "How the Sausage Dog Works",
        "Jak działa jamniczek"
      ],
      "Year": "1971",
      "Director": "Julian Józef Antonisz",
      "DirectorArray": [
        "Julian Józef Antonisz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1570",
      "databaseFilmTitle": "How to Be Loved",
      "FilmTitle": "How to Be Loved",
      "AlternateTitle": "Jak być kochaną",
      "TitleArray": [
        "How to Be Loved",
        "Jak być kochaną"
      ],
      "Year": "1962",
      "Director": "Wojciech Has",
      "DirectorArray": [
        "Wojciech Has"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1571",
      "databaseFilmTitle": "How to Build a Molotov Cocktail",
      "FilmTitle": "How to Build a Molotov Cocktail",
      "AlternateTitle": "Wie baue ich einen Molotow-Cocktail?",
      "TitleArray": [
        "How to Build a Molotov Cocktail",
        "Wie baue ich einen Molotow-Cocktail?"
      ],
      "Year": "1968",
      "Director": "Holger Meins",
      "DirectorArray": [
        "Holger Meins"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1572",
      "databaseFilmTitle": "How to Live in the German Federal Republic",
      "FilmTitle": "How to Live in the German Federal Republic",
      "AlternateTitle": "Leben - BRD",
      "TitleArray": [
        "How to Live in the German Federal Republic",
        "Leben - BRD"
      ],
      "Year": "1990",
      "Director": "Harun Farocki",
      "DirectorArray": [
        "Harun Farocki"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1573",
      "databaseFilmTitle": "Howards End",
      "FilmTitle": "Howards End",
      "AlternateTitle": "",
      "TitleArray": [
        "Howards End"
      ],
      "Year": "1992",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1574",
      "databaseFilmTitle": "Howl's Moving Castle",
      "FilmTitle": "Howl's Moving Castle",
      "AlternateTitle": "Hauru no ugoku shiro",
      "TitleArray": [
        "Howl's Moving Castle",
        "Hauru no ugoku shiro"
      ],
      "Year": "2004",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1575",
      "databaseFilmTitle": "Howls for Sade",
      "FilmTitle": "Howls for Sade",
      "AlternateTitle": "Hurlements en faveur de Sade",
      "TitleArray": [
        "Howls for Sade",
        "Hurlements en faveur de Sade"
      ],
      "Year": "1952",
      "Director": "Guy Debord",
      "DirectorArray": [
        "Guy Debord"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1576",
      "databaseFilmTitle": "Hue and Cry",
      "FilmTitle": "Hue and Cry",
      "AlternateTitle": "",
      "TitleArray": [
        "Hue and Cry"
      ],
      "Year": "1947",
      "Director": "Charles Crichton",
      "DirectorArray": [
        "Charles Crichton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1577",
      "databaseFilmTitle": "Hugo",
      "FilmTitle": "Hugo",
      "AlternateTitle": "",
      "TitleArray": [
        "Hugo"
      ],
      "Year": "2011",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1578",
      "databaseFilmTitle": "Hukkle",
      "FilmTitle": "Hukkle",
      "AlternateTitle": "",
      "TitleArray": [
        "Hukkle"
      ],
      "Year": "2002",
      "Director": "György Pálfi",
      "DirectorArray": [
        "György Pálfi"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1579",
      "databaseFilmTitle": "Hullabaloo over Georgie and Bonnie's Pictures",
      "FilmTitle": "Hullabaloo over Georgie and Bonnie's Pictures",
      "AlternateTitle": "",
      "TitleArray": [
        "Hullabaloo over Georgie and Bonnie's Pictures"
      ],
      "Year": "1978",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1580",
      "databaseFilmTitle": "Human Being",
      "FilmTitle": "Human Being",
      "AlternateTitle": "Insan",
      "TitleArray": [
        "Human Being",
        "Insan"
      ],
      "Year": "1994",
      "Director": "Ibrahim Shaddad",
      "DirectorArray": [
        "Ibrahim Shaddad"
      ],
      "Country": "Sudan",
      "CountryArray": [
        "Sudan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1581",
      "databaseFilmTitle": "Human Remains",
      "FilmTitle": "Human Remains",
      "AlternateTitle": "",
      "TitleArray": [
        "Human Remains"
      ],
      "Year": "1997",
      "Director": "Jay Rosenblatt",
      "DirectorArray": [
        "Jay Rosenblatt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1582",
      "databaseFilmTitle": "Humanity and Paper Balloons",
      "FilmTitle": "Humanity and Paper Balloons",
      "AlternateTitle": "Ninjô kami fûsen",
      "TitleArray": [
        "Humanity and Paper Balloons",
        "Ninjô kami fûsen"
      ],
      "Year": "1937",
      "Director": "Sadao Yamanaka",
      "DirectorArray": [
        "Sadao Yamanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1583",
      "databaseFilmTitle": "Hunger",
      "FilmTitle": "Hunger",
      "AlternateTitle": "",
      "TitleArray": [
        "Hunger"
      ],
      "Year": "2008",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1584",
      "databaseFilmTitle": "Hunt for the Wilderpeople",
      "FilmTitle": "Hunt for the Wilderpeople",
      "AlternateTitle": "",
      "TitleArray": [
        "Hunt for the Wilderpeople"
      ],
      "Year": "2016",
      "Director": "Taika Waititi",
      "DirectorArray": [
        "Taika Waititi"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1585",
      "databaseFilmTitle": "Husbands",
      "FilmTitle": "Husbands",
      "AlternateTitle": "",
      "TitleArray": [
        "Husbands"
      ],
      "Year": "1970",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1586",
      "databaseFilmTitle": "Husbands and Wives",
      "FilmTitle": "Husbands and Wives",
      "AlternateTitle": "",
      "TitleArray": [
        "Husbands and Wives"
      ],
      "Year": "1992",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1587",
      "databaseFilmTitle": "Hyenas",
      "FilmTitle": "Hyenas",
      "AlternateTitle": "Hyènes",
      "TitleArray": [
        "Hyenas",
        "Hyènes"
      ],
      "Year": "1992",
      "Director": "Djibril Diop Mambéty",
      "DirectorArray": [
        "Djibril Diop Mambéty"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1588",
      "databaseFilmTitle": "I Am",
      "FilmTitle": "I Am",
      "AlternateTitle": "Jestem",
      "TitleArray": [
        "I Am",
        "Jestem"
      ],
      "Year": "2005",
      "Director": "Dorota Kędzierzawska",
      "DirectorArray": [
        "Dorota Kędzierzawska"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1589",
      "databaseFilmTitle": "I Am a Fugitive from a Chain Gang",
      "FilmTitle": "I Am a Fugitive from a Chain Gang",
      "AlternateTitle": "",
      "TitleArray": [
        "I Am a Fugitive from a Chain Gang"
      ],
      "Year": "1932",
      "Director": "Mervyn LeRoy",
      "DirectorArray": [
        "Mervyn LeRoy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1590",
      "databaseFilmTitle": "I Am Cuba",
      "FilmTitle": "I Am Cuba",
      "AlternateTitle": "Soy Cuba",
      "TitleArray": [
        "I Am Cuba",
        "Soy Cuba"
      ],
      "Year": "1964",
      "Director": "Mikhail Kalatozov",
      "DirectorArray": [
        "Mikhail Kalatozov"
      ],
      "Country": "Cuba, Soviet Union",
      "CountryArray": [
        "Cuba",
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1591",
      "databaseFilmTitle": "I Am Curious—Yellow",
      "FilmTitle": "I Am Curious—Yellow",
      "AlternateTitle": "Jag är nyfiken – en film i gult",
      "TitleArray": [
        "I Am Curious—Yellow",
        "Jag är nyfiken – en film i gult"
      ],
      "Year": "1967",
      "Director": "Vilgot Sjöman",
      "DirectorArray": [
        "Vilgot Sjöman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1592",
      "databaseFilmTitle": "I Am Not Your Negro",
      "FilmTitle": "I Am Not Your Negro",
      "AlternateTitle": "",
      "TitleArray": [
        "I Am Not Your Negro"
      ],
      "Year": "2016",
      "Director": "Raoul Peck",
      "DirectorArray": [
        "Raoul Peck"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1593",
      "databaseFilmTitle": "I Am Somebody",
      "FilmTitle": "I Am Somebody",
      "AlternateTitle": "",
      "TitleArray": [
        "I Am Somebody"
      ],
      "Year": "1970",
      "Director": "Madeline Anderson",
      "DirectorArray": [
        "Madeline Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1594",
      "databaseFilmTitle": "I Am the One Who Brings Flowers to Her Grave",
      "FilmTitle": "I Am the One Who Brings Flowers to Her Grave",
      "AlternateTitle": "Ana alati tahmol azouhour ila qabriha",
      "TitleArray": [
        "I Am the One Who Brings Flowers to Her Grave",
        "Ana alati tahmol azouhour ila qabriha"
      ],
      "Year": "2006",
      "Director": "Hala Al Abdallah, Ammar Al Beik",
      "DirectorArray": [
        "Hala Al Abdallah",
        "Ammar Al Beik"
      ],
      "Country": "France, Syria",
      "CountryArray": [
        "France",
        "Syria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1595",
      "databaseFilmTitle": "I Am Twenty",
      "FilmTitle": "I Am Twenty",
      "AlternateTitle": "",
      "TitleArray": [
        "I Am Twenty"
      ],
      "Year": "1965",
      "Director": "Marlen Khutsiev",
      "DirectorArray": [
        "Marlen Khutsiev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1596",
      "databaseFilmTitle": "I Are You, You Am Me",
      "FilmTitle": "I Are You, You Am Me",
      "AlternateTitle": "Tenkosei",
      "TitleArray": [
        "I Are You, You Am Me",
        "Tenkosei"
      ],
      "Year": "1982",
      "Director": "Nobuhiko Ôbayashi",
      "DirectorArray": [
        "Nobuhiko Ôbayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1597",
      "databaseFilmTitle": "I Don't Want to Sleep Alone",
      "FilmTitle": "I Don't Want to Sleep Alone",
      "AlternateTitle": "Hei yanquan",
      "TitleArray": [
        "I Don't Want to Sleep Alone",
        "Hei yanquan"
      ],
      "Year": "2006",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1598",
      "databaseFilmTitle": "I Even Met Happy Gypsies",
      "FilmTitle": "I Even Met Happy Gypsies",
      "AlternateTitle": "Skupljači perja",
      "TitleArray": [
        "I Even Met Happy Gypsies",
        "Skupljači perja"
      ],
      "Year": "1967",
      "Director": "Aleksandar Petrović",
      "DirectorArray": [
        "Aleksandar Petrović"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1599",
      "databaseFilmTitle": "I for India",
      "FilmTitle": "I for India",
      "AlternateTitle": "",
      "TitleArray": [
        "I for India"
      ],
      "Year": "2005",
      "Director": "Sandhya Suri",
      "DirectorArray": [
        "Sandhya Suri"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1600",
      "databaseFilmTitle": "I Hired a Contract Killer",
      "FilmTitle": "I Hired a Contract Killer",
      "AlternateTitle": "",
      "TitleArray": [
        "I Hired a Contract Killer"
      ],
      "Year": "1990",
      "Director": "Aki Kaurismäki",
      "DirectorArray": [
        "Aki Kaurismäki"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1601",
      "databaseFilmTitle": "I Killed My Mother",
      "FilmTitle": "I Killed My Mother",
      "AlternateTitle": "J'ai tué ma mère",
      "TitleArray": [
        "I Killed My Mother",
        "J'ai tué ma mère"
      ],
      "Year": "2009",
      "Director": "Xavier Dolan",
      "DirectorArray": [
        "Xavier Dolan"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1602",
      "databaseFilmTitle": "I Knew Her Well",
      "FilmTitle": "I Knew Her Well",
      "AlternateTitle": "Io la conoscveno bene",
      "TitleArray": [
        "I Knew Her Well",
        "Io la conoscveno bene"
      ],
      "Year": "1965",
      "Director": "Antonio Pietrangeli",
      "DirectorArray": [
        "Antonio Pietrangeli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1603",
      "databaseFilmTitle": "I Know Where I'm Going!",
      "FilmTitle": "I Know Where I'm Going!",
      "AlternateTitle": "",
      "TitleArray": [
        "I Know Where I'm Going!"
      ],
      "Year": "1945",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "1604",
      "databaseFilmTitle": "I Only Want You To Love Me",
      "FilmTitle": "I Only Want You To Love Me",
      "AlternateTitle": "Ich will doch nur, dass ihr mich liebt",
      "TitleArray": [
        "I Only Want You To Love Me",
        "Ich will doch nur, dass ihr mich liebt"
      ],
      "Year": "1976",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1605",
      "databaseFilmTitle": "I See the Sun",
      "FilmTitle": "I See the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "I See the Sun"
      ],
      "Year": "1965",
      "Director": "Lana Ghoghoberidze",
      "DirectorArray": [
        "Lana Ghoghoberidze"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1606",
      "databaseFilmTitle": "I Think They Call Him John",
      "FilmTitle": "I Think They Call Him John",
      "AlternateTitle": "",
      "TitleArray": [
        "I Think They Call Him John"
      ],
      "Year": "1964",
      "Director": "John Krish",
      "DirectorArray": [
        "John Krish"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1607",
      "databaseFilmTitle": "I vitelloni",
      "FilmTitle": "I vitelloni",
      "AlternateTitle": "",
      "TitleArray": [
        "I vitelloni"
      ],
      "Year": "1953",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1608",
      "databaseFilmTitle": "I Walked With a Zombie",
      "FilmTitle": "I Walked With a Zombie",
      "AlternateTitle": "",
      "TitleArray": [
        "I Walked With a Zombie"
      ],
      "Year": "1943",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1609",
      "databaseFilmTitle": "I Was a Teenage Serial Killer",
      "FilmTitle": "I Was a Teenage Serial Killer",
      "AlternateTitle": "",
      "TitleArray": [
        "I Was a Teenage Serial Killer"
      ],
      "Year": "1993",
      "Director": "Sarah Jacobson",
      "DirectorArray": [
        "Sarah Jacobson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1610",
      "databaseFilmTitle": "I Was Born, But...",
      "FilmTitle": "I Was Born, But...",
      "AlternateTitle": "Otona no miru ehon - Umarete wa mita keredo",
      "TitleArray": [
        "I Was Born, But...",
        "Otona no miru ehon - Umarete wa mita keredo"
      ],
      "Year": "1932",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1611",
      "databaseFilmTitle": "I was Nineteen",
      "FilmTitle": "I was Nineteen",
      "AlternateTitle": "Ich war neunzehn",
      "TitleArray": [
        "I was Nineteen",
        "Ich war neunzehn"
      ],
      "Year": "1968",
      "Director": "Konrad Wolf",
      "DirectorArray": [
        "Konrad Wolf"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1612",
      "databaseFilmTitle": "I, the Executioner",
      "FilmTitle": "I, the Executioner",
      "AlternateTitle": "Minagoroshi no reika",
      "TitleArray": [
        "I, the Executioner",
        "Minagoroshi no reika"
      ],
      "Year": "1968",
      "Director": "Tai Katô",
      "DirectorArray": [
        "Tai Katô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1613",
      "databaseFilmTitle": "I'm Not There",
      "FilmTitle": "I'm Not There",
      "AlternateTitle": "",
      "TitleArray": [
        "I'm Not There"
      ],
      "Year": "2007",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1614",
      "databaseFilmTitle": "I'm Your Man",
      "FilmTitle": "I'm Your Man",
      "AlternateTitle": "Ich bin dein Mensch",
      "TitleArray": [
        "I'm Your Man",
        "Ich bin dein Mensch"
      ],
      "Year": "2021",
      "Director": "Maria Schrader",
      "DirectorArray": [
        "Maria Schrader"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1615",
      "databaseFilmTitle": "Ice",
      "FilmTitle": "Ice",
      "AlternateTitle": "",
      "TitleArray": [
        "Ice"
      ],
      "Year": "1970",
      "Director": "Robert Kramer",
      "DirectorArray": [
        "Robert Kramer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1616",
      "databaseFilmTitle": "Ida",
      "FilmTitle": "Ida",
      "AlternateTitle": "",
      "TitleArray": [
        "Ida"
      ],
      "Year": "2013",
      "Director": "Paweł Pawlikowski",
      "DirectorArray": [
        "Paweł Pawlikowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1617",
      "databaseFilmTitle": "Idiocracy",
      "FilmTitle": "Idiocracy",
      "AlternateTitle": "",
      "TitleArray": [
        "Idiocracy"
      ],
      "Year": "2006",
      "Director": "Mike Judge",
      "DirectorArray": [
        "Mike Judge"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1618",
      "databaseFilmTitle": "If Beale Street Could Talk",
      "FilmTitle": "If Beale Street Could Talk",
      "AlternateTitle": "",
      "TitleArray": [
        "If Beale Street Could Talk"
      ],
      "Year": "2018",
      "Director": "Barry Jenkins",
      "DirectorArray": [
        "Barry Jenkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1619",
      "databaseFilmTitle": "If I Had Four Dromedaries",
      "FilmTitle": "If I Had Four Dromedaries",
      "AlternateTitle": "Si j'avais quatre dromadaires",
      "TitleArray": [
        "If I Had Four Dromedaries",
        "Si j'avais quatre dromadaires"
      ],
      "Year": "1966",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1620",
      "databaseFilmTitle": "If...",
      "FilmTitle": "If...",
      "AlternateTitle": "",
      "TitleArray": [
        "If..."
      ],
      "Year": "1968",
      "Director": "Lindsay Anderson",
      "DirectorArray": [
        "Lindsay Anderson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1621",
      "databaseFilmTitle": "Iguana",
      "FilmTitle": "Iguana",
      "AlternateTitle": "",
      "TitleArray": [
        "Iguana"
      ],
      "Year": "1988",
      "Director": "Monte Hellman",
      "DirectorArray": [
        "Monte Hellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1622",
      "databaseFilmTitle": "Ikiru",
      "FilmTitle": "Ikiru",
      "AlternateTitle": "",
      "TitleArray": [
        "Ikiru"
      ],
      "Year": "1952",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "1623",
      "databaseFilmTitle": "Il bidone",
      "FilmTitle": "Il bidone",
      "AlternateTitle": "",
      "TitleArray": [
        "Il bidone"
      ],
      "Year": "1955",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1624",
      "databaseFilmTitle": "Il divo",
      "FilmTitle": "Il divo",
      "AlternateTitle": "",
      "TitleArray": [
        "Il divo"
      ],
      "Year": "2008",
      "Director": "Paolo Sorrentino",
      "DirectorArray": [
        "Paolo Sorrentino"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1625",
      "databaseFilmTitle": "Il grido",
      "FilmTitle": "Il grido",
      "AlternateTitle": "",
      "TitleArray": [
        "Il grido"
      ],
      "Year": "1957",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1626",
      "databaseFilmTitle": "Il Mare",
      "FilmTitle": "Il Mare",
      "AlternateTitle": "Siworae",
      "TitleArray": [
        "Il Mare",
        "Siworae"
      ],
      "Year": "2000",
      "Director": "Lee Hyun-seung",
      "DirectorArray": [
        "Lee Hyun-seung"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1627",
      "databaseFilmTitle": "Il posto",
      "FilmTitle": "Il posto",
      "AlternateTitle": "",
      "TitleArray": [
        "Il posto"
      ],
      "Year": "1961",
      "Director": "Ermanno Olmi",
      "DirectorArray": [
        "Ermanno Olmi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1628",
      "databaseFilmTitle": "Illumination",
      "FilmTitle": "Illumination",
      "AlternateTitle": "Sous le grand ciel",
      "TitleArray": [
        "Illumination",
        "Sous le grand ciel"
      ],
      "Year": "2004",
      "Director": "Pascale Breton",
      "DirectorArray": [
        "Pascale Breton"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1629",
      "databaseFilmTitle": "Illusion Travels by Streetcar",
      "FilmTitle": "Illusion Travels by Streetcar",
      "AlternateTitle": "La ilusión viaja en tranvía",
      "TitleArray": [
        "Illusion Travels by Streetcar",
        "La ilusión viaja en tranvía"
      ],
      "Year": "1954",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1630",
      "databaseFilmTitle": "Illusions",
      "FilmTitle": "Illusions",
      "AlternateTitle": "",
      "TitleArray": [
        "Illusions"
      ],
      "Year": "1982",
      "Director": "Julie Dash",
      "DirectorArray": [
        "Julie Dash"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1631",
      "databaseFilmTitle": "Illustrious Corpses",
      "FilmTitle": "Illustrious Corpses",
      "AlternateTitle": "Cadaveri eccellenti",
      "TitleArray": [
        "Illustrious Corpses",
        "Cadaveri eccellenti"
      ],
      "Year": "1976",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1632",
      "databaseFilmTitle": "Imagens do Silêncio",
      "FilmTitle": "Imagens do Silêncio",
      "AlternateTitle": "",
      "TitleArray": [
        "Imagens do Silêncio"
      ],
      "Year": "1973",
      "Director": "Luiz Rosemberg Filho",
      "DirectorArray": [
        "Luiz Rosemberg Filho"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1633",
      "databaseFilmTitle": "Images of the World and the Inscription of War",
      "FilmTitle": "Images of the World and the Inscription of War",
      "AlternateTitle": "Bilder der Welt und Inschrift des Krieges",
      "TitleArray": [
        "Images of the World and the Inscription of War",
        "Bilder der Welt und Inschrift des Krieges"
      ],
      "Year": "1989",
      "Director": "Harun Farocki",
      "DirectorArray": [
        "Harun Farocki"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1634",
      "databaseFilmTitle": "Imitation of Life (1934)",
      "FilmTitle": "Imitation of Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Imitation of Life"
      ],
      "Year": "1934",
      "Director": "John M. Stahl",
      "DirectorArray": [
        "John M. Stahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1635",
      "databaseFilmTitle": "Imitation of Life (1959)",
      "FilmTitle": "Imitation of Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Imitation of Life"
      ],
      "Year": "1959",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "75",
      "2022votes": "36"
    },
    {
      "key": "1636",
      "databaseFilmTitle": "Import/Export",
      "FilmTitle": "Import/Export",
      "AlternateTitle": "",
      "TitleArray": [
        "Import/Export"
      ],
      "Year": "2007",
      "Director": "Ulrich Seidl",
      "DirectorArray": [
        "Ulrich Seidl"
      ],
      "Country": "Austria, Slovakia",
      "CountryArray": [
        "Austria",
        "Slovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1637",
      "databaseFilmTitle": "Impressions",
      "FilmTitle": "Impressions",
      "AlternateTitle": "",
      "TitleArray": [
        "Impressions"
      ],
      "Year": "2012",
      "Director": "Jacques Perconte",
      "DirectorArray": [
        "Jacques Perconte"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1638",
      "databaseFilmTitle": "In a Lonely Place",
      "FilmTitle": "In a Lonely Place",
      "AlternateTitle": "",
      "TitleArray": [
        "In a Lonely Place"
      ],
      "Year": "1950",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "1639",
      "databaseFilmTitle": "In a Year with 13 Moons",
      "FilmTitle": "In a Year with 13 Moons",
      "AlternateTitle": "In einem Jahr mit 13 Monden",
      "TitleArray": [
        "In a Year with 13 Moons",
        "In einem Jahr mit 13 Monden"
      ],
      "Year": "1978",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1640",
      "databaseFilmTitle": "In Bruges",
      "FilmTitle": "In Bruges",
      "AlternateTitle": "",
      "TitleArray": [
        "In Bruges"
      ],
      "Year": "2008",
      "Director": "Martin McDonagh",
      "DirectorArray": [
        "Martin McDonagh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1641",
      "databaseFilmTitle": "In Camera",
      "FilmTitle": "In Camera",
      "AlternateTitle": "The Wednesday Play: In Camera",
      "TitleArray": [
        "In Camera",
        "The Wednesday Play: In Camera"
      ],
      "Year": "1964",
      "Director": "Philip Saville",
      "DirectorArray": [
        "Philip Saville"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1642",
      "databaseFilmTitle": "In Darkness",
      "FilmTitle": "In Darkness",
      "AlternateTitle": "W ciemności",
      "TitleArray": [
        "In Darkness",
        "W ciemności"
      ],
      "Year": "2011",
      "Director": "Agnieszka Holland",
      "DirectorArray": [
        "Agnieszka Holland"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1643",
      "databaseFilmTitle": "In der Fremde",
      "FilmTitle": "In der Fremde",
      "AlternateTitle": "",
      "TitleArray": [
        "In der Fremde"
      ],
      "Year": "1967",
      "Director": "Klaus Wildenhahn",
      "DirectorArray": [
        "Klaus Wildenhahn"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1644",
      "databaseFilmTitle": "In Front of Your Face",
      "FilmTitle": "In Front of Your Face",
      "AlternateTitle": "Dangsin-eolgul-apeseo",
      "TitleArray": [
        "In Front of Your Face",
        "Dangsin-eolgul-apeseo"
      ],
      "Year": "2021",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1645",
      "databaseFilmTitle": "In Jackson Heights",
      "FilmTitle": "In Jackson Heights",
      "AlternateTitle": "",
      "TitleArray": [
        "In Jackson Heights"
      ],
      "Year": "2015",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1646",
      "databaseFilmTitle": "In Praise of Love",
      "FilmTitle": "In Praise of Love",
      "AlternateTitle": "Éloge de l'amour",
      "TitleArray": [
        "In Praise of Love",
        "Éloge de l'amour"
      ],
      "Year": "2001",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1647",
      "databaseFilmTitle": "In Spring",
      "FilmTitle": "In Spring",
      "AlternateTitle": "",
      "TitleArray": [
        "In Spring"
      ],
      "Year": "1929",
      "Director": "Mikhail Kaufman",
      "DirectorArray": [
        "Mikhail Kaufman"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1648",
      "databaseFilmTitle": "In the City of Sylvia",
      "FilmTitle": "In the City of Sylvia",
      "AlternateTitle": "En la ciudad de Sylvia",
      "TitleArray": [
        "In the City of Sylvia",
        "En la ciudad de Sylvia"
      ],
      "Year": "2007",
      "Director": "José Luis Guerín",
      "DirectorArray": [
        "José Luis Guerín"
      ],
      "Country": "Spain, France",
      "CountryArray": [
        "Spain",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1649",
      "databaseFilmTitle": "In the Company of Men",
      "FilmTitle": "In the Company of Men",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Company of Men"
      ],
      "Year": "1997",
      "Director": "Neil LaBute",
      "DirectorArray": [
        "Neil LaBute"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1650",
      "databaseFilmTitle": "In the Cut",
      "FilmTitle": "In the Cut",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Cut"
      ],
      "Year": "2003",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1651",
      "databaseFilmTitle": "In the Dark",
      "FilmTitle": "In the Dark",
      "AlternateTitle": "B Temhote",
      "TitleArray": [
        "In the Dark",
        "B Temhote"
      ],
      "Year": "2004",
      "Director": "Sergei Dvortsevoy",
      "DirectorArray": [
        "Sergei Dvortsevoy"
      ],
      "Country": "Russia, Finland",
      "CountryArray": [
        "Russia",
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1652",
      "databaseFilmTitle": "In the Darkness of Time",
      "FilmTitle": "In the Darkness of Time",
      "AlternateTitle": "Dans le noir du temps",
      "TitleArray": [
        "In the Darkness of Time",
        "Dans le noir du temps"
      ],
      "Year": "2002",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1653",
      "databaseFilmTitle": "In the Heat of the Night",
      "FilmTitle": "In the Heat of the Night",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Heat of the Night"
      ],
      "Year": "1967",
      "Director": "Norman Jewison",
      "DirectorArray": [
        "Norman Jewison"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1654",
      "databaseFilmTitle": "In the Heat of the Sun",
      "FilmTitle": "In the Heat of the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Heat of the Sun"
      ],
      "Year": "1994",
      "Director": "Jiang Wen",
      "DirectorArray": [
        "Jiang Wen"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1655",
      "databaseFilmTitle": "In The Last Days of the City",
      "FilmTitle": "In The Last Days of the City",
      "AlternateTitle": "Akher Ayyam el-Madinah",
      "TitleArray": [
        "In The Last Days of the City",
        "Akher Ayyam el-Madinah"
      ],
      "Year": "2016",
      "Director": "Tamer El Said",
      "DirectorArray": [
        "Tamer El Said"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1656",
      "databaseFilmTitle": "In the Lohmgrund",
      "FilmTitle": "In the Lohmgrund",
      "AlternateTitle": "Im Lohmgrund",
      "TitleArray": [
        "In the Lohmgrund",
        "Im Lohmgrund"
      ],
      "Year": "1977",
      "Director": "Jürgen Böttcher",
      "DirectorArray": [
        "Jürgen Böttcher"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1657",
      "databaseFilmTitle": "In the Mood for Love",
      "FilmTitle": "In the Mood for Love",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Mood for Love"
      ],
      "Year": "2000",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "24",
      "2012votes": "42",
      "2022rank": "5",
      "2022votes": "141"
    },
    {
      "key": "1658",
      "databaseFilmTitle": "In the Name of the Father",
      "FilmTitle": "In the Name of the Father",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Name of the Father"
      ],
      "Year": "1993",
      "Director": "Jim Sheridan",
      "DirectorArray": [
        "Jim Sheridan"
      ],
      "Country": "United Kingdom, Ireland",
      "CountryArray": [
        "United Kingdom",
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1659",
      "databaseFilmTitle": "In the Realm of the Senses",
      "FilmTitle": "In the Realm of the Senses",
      "AlternateTitle": "Ai no Korīda",
      "TitleArray": [
        "In the Realm of the Senses",
        "Ai no Korīda"
      ],
      "Year": "1976",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan, France",
      "CountryArray": [
        "Japan",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1660",
      "databaseFilmTitle": "In the Shadow of the Sun",
      "FilmTitle": "In the Shadow of the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Shadow of the Sun"
      ],
      "Year": "1980",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1661",
      "databaseFilmTitle": "In the Stone House",
      "FilmTitle": "In the Stone House",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Stone House"
      ],
      "Year": "2012",
      "Director": "Jerome Hiler",
      "DirectorArray": [
        "Jerome Hiler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1662",
      "databaseFilmTitle": "In the Street",
      "FilmTitle": "In the Street",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Street"
      ],
      "Year": "1948",
      "Director": "James Agee, Helen Levitt, Janice Loeb",
      "DirectorArray": [
        "James Agee",
        "Helen Levitt",
        "Janice Loeb"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1663",
      "databaseFilmTitle": "In the Year of the Pig",
      "FilmTitle": "In the Year of the Pig",
      "AlternateTitle": "",
      "TitleArray": [
        "In the Year of the Pig"
      ],
      "Year": "1968",
      "Director": "Emile de Antonio",
      "DirectorArray": [
        "Emile de Antonio"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1664",
      "databaseFilmTitle": "In Vanda's Room",
      "FilmTitle": "In Vanda's Room",
      "AlternateTitle": "No quarto da Vanda",
      "TitleArray": [
        "In Vanda's Room",
        "No quarto da Vanda"
      ],
      "Year": "2000",
      "Director": "Pedro Costa",
      "DirectorArray": [
        "Pedro Costa"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "1665",
      "databaseFilmTitle": "In Which we Serve",
      "FilmTitle": "In Which we Serve",
      "AlternateTitle": "",
      "TitleArray": [
        "In Which we Serve"
      ],
      "Year": "1942",
      "Director": "David Lean, Noël Coward",
      "DirectorArray": [
        "David Lean",
        "Noël Coward"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1666",
      "databaseFilmTitle": "Inception",
      "FilmTitle": "Inception",
      "AlternateTitle": "",
      "TitleArray": [
        "Inception"
      ],
      "Year": "2010",
      "Director": "Christopher Nolan",
      "DirectorArray": [
        "Christopher Nolan"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1667",
      "databaseFilmTitle": "Incredible But True",
      "FilmTitle": "Incredible But True",
      "AlternateTitle": "Incroyable mais vrai",
      "TitleArray": [
        "Incredible But True",
        "Incroyable mais vrai"
      ],
      "Year": "2022",
      "Director": "Quentin Dupieux",
      "DirectorArray": [
        "Quentin Dupieux"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1668",
      "databaseFilmTitle": "Independence",
      "FilmTitle": "Independence",
      "AlternateTitle": "Independencia",
      "TitleArray": [
        "Independence",
        "Independencia"
      ],
      "Year": "2009",
      "Director": "Raya Martin",
      "DirectorArray": [
        "Raya Martin"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1669",
      "databaseFilmTitle": "India Song",
      "FilmTitle": "India Song",
      "AlternateTitle": "",
      "TitleArray": [
        "India Song"
      ],
      "Year": "1975",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "1670",
      "databaseFilmTitle": "India: Matri Bhumi",
      "FilmTitle": "India: Matri Bhumi",
      "AlternateTitle": "",
      "TitleArray": [
        "India: Matri Bhumi"
      ],
      "Year": "1959",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1671",
      "databaseFilmTitle": "Indian Summer",
      "FilmTitle": "Indian Summer",
      "AlternateTitle": "La prima notte di quiete",
      "TitleArray": [
        "Indian Summer",
        "La prima notte di quiete"
      ],
      "Year": "1972",
      "Director": "Valerio Zurlini",
      "DirectorArray": [
        "Valerio Zurlini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1672",
      "databaseFilmTitle": "Indiana Jones and the Last Crusade",
      "FilmTitle": "Indiana Jones and the Last Crusade",
      "AlternateTitle": "",
      "TitleArray": [
        "Indiana Jones and the Last Crusade"
      ],
      "Year": "1989",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1673",
      "databaseFilmTitle": "Indiana Jones and the Temple of Doom",
      "FilmTitle": "Indiana Jones and the Temple of Doom",
      "AlternateTitle": "",
      "TitleArray": [
        "Indiana Jones and the Temple of Doom"
      ],
      "Year": "1984",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1674",
      "databaseFilmTitle": "Infernal Affairs",
      "FilmTitle": "Infernal Affairs",
      "AlternateTitle": "Mou gaan dou",
      "TitleArray": [
        "Infernal Affairs",
        "Mou gaan dou"
      ],
      "Year": "2002",
      "Director": "Andrew Lau Wai-keung, Alan Mak",
      "DirectorArray": [
        "Andrew Lau Wai-keung",
        "Alan Mak"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1675",
      "databaseFilmTitle": "Inferno",
      "FilmTitle": "Inferno",
      "AlternateTitle": "",
      "TitleArray": [
        "Inferno"
      ],
      "Year": "1980",
      "Director": "Dario Argento",
      "DirectorArray": [
        "Dario Argento"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1676",
      "databaseFilmTitle": "Infinity (1992)",
      "FilmTitle": "Infinity",
      "AlternateTitle": "",
      "TitleArray": [
        "Infinity"
      ],
      "Year": "1992",
      "Director": "Marlen Khutsiev",
      "DirectorArray": [
        "Marlen Khutsiev"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1677",
      "databaseFilmTitle": "Ingeborg Holm",
      "FilmTitle": "Ingeborg Holm",
      "AlternateTitle": "",
      "TitleArray": [
        "Ingeborg Holm"
      ],
      "Year": "1913",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1678",
      "databaseFilmTitle": "Inglourious Basterds",
      "FilmTitle": "Inglourious Basterds",
      "AlternateTitle": "",
      "TitleArray": [
        "Inglourious Basterds"
      ],
      "Year": "2009",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1679",
      "databaseFilmTitle": "Inherent Vice",
      "FilmTitle": "Inherent Vice",
      "AlternateTitle": "",
      "TitleArray": [
        "Inherent Vice"
      ],
      "Year": "2014",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1680",
      "databaseFilmTitle": "Inherit the Wind",
      "FilmTitle": "Inherit the Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "Inherit the Wind"
      ],
      "Year": "1960",
      "Director": "Stanley Kramer",
      "DirectorArray": [
        "Stanley Kramer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1681",
      "databaseFilmTitle": "Inland (2008)",
      "FilmTitle": "Inland",
      "AlternateTitle": "Gabbla",
      "TitleArray": [
        "Inland",
        "Gabbla"
      ],
      "Year": "2008",
      "Director": "Tariq Teguia",
      "DirectorArray": [
        "Tariq Teguia"
      ],
      "Country": "Algeria",
      "CountryArray": [
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1682",
      "databaseFilmTitle": "Inland Empire",
      "FilmTitle": "Inland Empire",
      "AlternateTitle": "",
      "TitleArray": [
        "Inland Empire"
      ],
      "Year": "2006",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "1683",
      "databaseFilmTitle": "Inland Sea",
      "FilmTitle": "Inland Sea",
      "AlternateTitle": "Minatomachi",
      "TitleArray": [
        "Inland Sea",
        "Minatomachi"
      ],
      "Year": "2018",
      "Director": "Kazuhiro Soda",
      "DirectorArray": [
        "Kazuhiro Soda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1684",
      "databaseFilmTitle": "Innocence",
      "FilmTitle": "Innocence",
      "AlternateTitle": "",
      "TitleArray": [
        "Innocence"
      ],
      "Year": "2004",
      "Director": "Lucile Hadžihalilović",
      "DirectorArray": [
        "Lucile Hadžihalilović"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1685",
      "databaseFilmTitle": "Innocence Unprotected",
      "FilmTitle": "Innocence Unprotected",
      "AlternateTitle": "Nevinost bez zaštite",
      "TitleArray": [
        "Innocence Unprotected",
        "Nevinost bez zaštite"
      ],
      "Year": "1968",
      "Director": "Dušan Makavejev",
      "DirectorArray": [
        "Dušan Makavejev"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1686",
      "databaseFilmTitle": "Inside Llewyn Davis",
      "FilmTitle": "Inside Llewyn Davis",
      "AlternateTitle": "",
      "TitleArray": [
        "Inside Llewyn Davis"
      ],
      "Year": "2013",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1687",
      "databaseFilmTitle": "Inside Out",
      "FilmTitle": "Inside Out",
      "AlternateTitle": "",
      "TitleArray": [
        "Inside Out"
      ],
      "Year": "2015",
      "Director": "Pete Docter, Ronnie Del Carmen",
      "DirectorArray": [
        "Pete Docter",
        "Ronnie Del Carmen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1688",
      "databaseFilmTitle": "Inside the Red Brick Wall",
      "FilmTitle": "Inside the Red Brick Wall",
      "AlternateTitle": "",
      "TitleArray": [
        "Inside the Red Brick Wall"
      ],
      "Year": "2020",
      "Director": "Hong Kong Documentary Filmmakers",
      "DirectorArray": [
        "Hong Kong Documentary Filmmakers"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1689",
      "databaseFilmTitle": "Institute Benjamenta, or This Dream People Call Human Life",
      "FilmTitle": "Institute Benjamenta, or This Dream People Call Human Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Institute Benjamenta, or This Dream People Call Human Life"
      ],
      "Year": "1995",
      "Director": "Stephen Quay, Timothy Quay",
      "DirectorArray": [
        "Stephen Quay",
        "Timothy Quay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1690",
      "databaseFilmTitle": "Instructions for a Light and Sound Machine",
      "FilmTitle": "Instructions for a Light and Sound Machine",
      "AlternateTitle": "",
      "TitleArray": [
        "Instructions for a Light and Sound Machine"
      ],
      "Year": "2005",
      "Director": "Peter Tscherkassky",
      "DirectorArray": [
        "Peter Tscherkassky"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1691",
      "databaseFilmTitle": "Intentions of Murder",
      "FilmTitle": "Intentions of Murder",
      "AlternateTitle": "Akai Satsui",
      "TitleArray": [
        "Intentions of Murder",
        "Akai Satsui"
      ],
      "Year": "1964",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1692",
      "databaseFilmTitle": "Interrogation",
      "FilmTitle": "Interrogation",
      "AlternateTitle": "Przesluchanie",
      "TitleArray": [
        "Interrogation",
        "Przesluchanie"
      ],
      "Year": "1982",
      "Director": "Ryszard Bugajski",
      "DirectorArray": [
        "Ryszard Bugajski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1693",
      "databaseFilmTitle": "Interstellar",
      "FilmTitle": "Interstellar",
      "AlternateTitle": "",
      "TitleArray": [
        "Interstellar"
      ],
      "Year": "2014",
      "Director": "Christopher Nolan",
      "DirectorArray": [
        "Christopher Nolan"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1694",
      "databaseFilmTitle": "Interview",
      "FilmTitle": "Interview",
      "AlternateTitle": "",
      "TitleArray": [
        "Interview"
      ],
      "Year": "1971",
      "Director": "Mrinal Sen",
      "DirectorArray": [
        "Mrinal Sen"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1695",
      "databaseFilmTitle": "Intimacy",
      "FilmTitle": "Intimacy",
      "AlternateTitle": "",
      "TitleArray": [
        "Intimacy"
      ],
      "Year": "2001",
      "Director": "Patrice Chéreau",
      "DirectorArray": [
        "Patrice Chéreau"
      ],
      "Country": "United Kingdom, France",
      "CountryArray": [
        "United Kingdom",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1696",
      "databaseFilmTitle": "Intimate Lighting",
      "FilmTitle": "Intimate Lighting",
      "AlternateTitle": "Intimni osvetlni",
      "TitleArray": [
        "Intimate Lighting",
        "Intimni osvetlni"
      ],
      "Year": "1965",
      "Director": "Ivan Passer",
      "DirectorArray": [
        "Ivan Passer"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1697",
      "databaseFilmTitle": "Into the Night",
      "FilmTitle": "Into the Night",
      "AlternateTitle": "Dans la nuit",
      "TitleArray": [
        "Into the Night",
        "Dans la nuit"
      ],
      "Year": "1929",
      "Director": "Charles Vanel",
      "DirectorArray": [
        "Charles Vanel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1698",
      "databaseFilmTitle": "Intolerance",
      "FilmTitle": "Intolerance",
      "AlternateTitle": "Intolerance: Love's Struggle Throughout the Ages",
      "TitleArray": [
        "Intolerance",
        "Intolerance: Love's Struggle Throughout the Ages"
      ],
      "Year": "1916",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "5",
      "1952votes": "12",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "26",
      "1992votes": "7",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1699",
      "databaseFilmTitle": "Introduction",
      "FilmTitle": "Introduction",
      "AlternateTitle": "Inteurodeoksyeon",
      "TitleArray": [
        "Introduction",
        "Inteurodeoksyeon"
      ],
      "Year": "2021",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1700",
      "databaseFilmTitle": "Introduction to Arnold Schoenberg's Accompaniment to a Cinematic Scene",
      "FilmTitle": "Introduction to Arnold Schoenberg's Accompaniment to a Cinematic Scene",
      "AlternateTitle": "Einleitung zu Arnold Schönbergs Begleitmusik zu einer Lichtspielscene",
      "TitleArray": [
        "Introduction to Arnold Schoenberg's Accompaniment to a Cinematic Scene",
        "Einleitung zu Arnold Schönbergs Begleitmusik zu einer Lichtspielscene"
      ],
      "Year": "1973",
      "Director": "Jean-Marie Straub",
      "DirectorArray": [
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1701",
      "databaseFilmTitle": "Invasión",
      "FilmTitle": "Invasión",
      "AlternateTitle": "",
      "TitleArray": [
        "Invasión"
      ],
      "Year": "1969",
      "Director": "Hugo Santiago",
      "DirectorArray": [
        "Hugo Santiago"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1702",
      "databaseFilmTitle": "Invasion of the Body Snatchers",
      "FilmTitle": "Invasion of the Body Snatchers",
      "AlternateTitle": "",
      "TitleArray": [
        "Invasion of the Body Snatchers"
      ],
      "Year": "1956",
      "Director": "Don Siegel",
      "DirectorArray": [
        "Don Siegel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1703",
      "databaseFilmTitle": "Invention for Destruction",
      "FilmTitle": "Invention for Destruction",
      "AlternateTitle": "Vynález zkázy",
      "TitleArray": [
        "Invention for Destruction",
        "Vynález zkázy"
      ],
      "Year": "1958",
      "Director": "Karel Zeman",
      "DirectorArray": [
        "Karel Zeman"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1704",
      "databaseFilmTitle": "Investigation of a Citizen Above Suspicion",
      "FilmTitle": "Investigation of a Citizen Above Suspicion",
      "AlternateTitle": "Indagine su un cittadino al di sopra di ogni sospetto",
      "TitleArray": [
        "Investigation of a Citizen Above Suspicion",
        "Indagine su un cittadino al di sopra di ogni sospetto"
      ],
      "Year": "1970",
      "Director": "Elio Petri",
      "DirectorArray": [
        "Elio Petri"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1705",
      "databaseFilmTitle": "Invisible Adversaries",
      "FilmTitle": "Invisible Adversaries",
      "AlternateTitle": "Unsichtbare Gegner",
      "TitleArray": [
        "Invisible Adversaries",
        "Unsichtbare Gegner"
      ],
      "Year": "1977",
      "Director": "Valie Export",
      "DirectorArray": [
        "Valie Export"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1706",
      "databaseFilmTitle": "Invitation to a Journey",
      "FilmTitle": "Invitation to a Journey",
      "AlternateTitle": "L'invitation au voyage",
      "TitleArray": [
        "Invitation to a Journey",
        "L'invitation au voyage"
      ],
      "Year": "1927",
      "Director": "Germaine Dulac",
      "DirectorArray": [
        "Germaine Dulac"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1707",
      "databaseFilmTitle": "Invocation of My Demon Brother",
      "FilmTitle": "Invocation of My Demon Brother",
      "AlternateTitle": "",
      "TitleArray": [
        "Invocation of My Demon Brother"
      ],
      "Year": "1969",
      "Director": "Kenneth Anger",
      "DirectorArray": [
        "Kenneth Anger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1708",
      "databaseFilmTitle": "Io Island",
      "FilmTitle": "Io Island",
      "AlternateTitle": "Iodo",
      "TitleArray": [
        "Io Island",
        "Iodo"
      ],
      "Year": "1977",
      "Director": "Kim Ki-young",
      "DirectorArray": [
        "Kim Ki-young"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1709",
      "databaseFilmTitle": "Iris and the Lieutenant",
      "FilmTitle": "Iris and the Lieutenant",
      "AlternateTitle": "Iris och löjtnantshjärta",
      "TitleArray": [
        "Iris and the Lieutenant",
        "Iris och löjtnantshjärta"
      ],
      "Year": "1946",
      "Director": "Alf Sjöberg",
      "DirectorArray": [
        "Alf Sjöberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1710",
      "databaseFilmTitle": "Irma Vep",
      "FilmTitle": "Irma Vep",
      "AlternateTitle": "",
      "TitleArray": [
        "Irma Vep"
      ],
      "Year": "1996",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1711",
      "databaseFilmTitle": "Irreversible",
      "FilmTitle": "Irreversible",
      "AlternateTitle": "Irréversible",
      "TitleArray": [
        "Irreversible",
        "Irréversible"
      ],
      "Year": "2002",
      "Director": "Gaspar Noé",
      "DirectorArray": [
        "Gaspar Noé"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1712",
      "databaseFilmTitle": "Iruvar",
      "FilmTitle": "Iruvar",
      "AlternateTitle": "The Duo",
      "TitleArray": [
        "Iruvar",
        "The Duo"
      ],
      "Year": "1997",
      "Director": "Mani Ratnam",
      "DirectorArray": [
        "Mani Ratnam"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1713",
      "databaseFilmTitle": "Is This Just a Story?",
      "FilmTitle": "Is This Just a Story?",
      "AlternateTitle": "Idhi Katha Matramena",
      "TitleArray": [
        "Is This Just a Story?",
        "Idhi Katha Matramena"
      ],
      "Year": "1983",
      "Director": "Yugantar",
      "DirectorArray": [
        "Yugantar"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1714",
      "databaseFilmTitle": "Ishtar",
      "FilmTitle": "Ishtar",
      "AlternateTitle": "",
      "TitleArray": [
        "Ishtar"
      ],
      "Year": "1987",
      "Director": "Elaine May",
      "DirectorArray": [
        "Elaine May"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1715",
      "databaseFilmTitle": "Island in the Lagoon",
      "FilmTitle": "Island in the Lagoon",
      "AlternateTitle": "Isole nella laguna",
      "TitleArray": [
        "Island in the Lagoon",
        "Isole nella laguna"
      ],
      "Year": "1948",
      "Director": "Luciano Emmer, Enrico Gras",
      "DirectorArray": [
        "Luciano Emmer",
        "Enrico Gras"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1716",
      "databaseFilmTitle": "Island of Lost Souls",
      "FilmTitle": "Island of Lost Souls",
      "AlternateTitle": "",
      "TitleArray": [
        "Island of Lost Souls"
      ],
      "Year": "1932",
      "Director": "Erle C. Kenton",
      "DirectorArray": [
        "Erle C. Kenton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1717",
      "databaseFilmTitle": "Island of Loves",
      "FilmTitle": "Island of Loves",
      "AlternateTitle": "A Ilha dos Amores",
      "TitleArray": [
        "Island of Loves",
        "A Ilha dos Amores"
      ],
      "Year": "1982",
      "Director": "Paulo Rocha",
      "DirectorArray": [
        "Paulo Rocha"
      ],
      "Country": "Portugal, Japan",
      "CountryArray": [
        "Portugal",
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1718",
      "databaseFilmTitle": "Islands of Fire",
      "FilmTitle": "Islands of Fire",
      "AlternateTitle": "Isole di fuoco",
      "TitleArray": [
        "Islands of Fire",
        "Isole di fuoco"
      ],
      "Year": "1955",
      "Director": "Vittorio De Seta",
      "DirectorArray": [
        "Vittorio De Seta"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1719",
      "databaseFilmTitle": "Isle of Flowers",
      "FilmTitle": "Isle of Flowers",
      "AlternateTitle": "Ilha das Flores",
      "TitleArray": [
        "Isle of Flowers",
        "Ilha das Flores"
      ],
      "Year": "1989",
      "Director": "Jorge Furtado",
      "DirectorArray": [
        "Jorge Furtado"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1720",
      "databaseFilmTitle": "Isn't Life Wonderful",
      "FilmTitle": "Isn't Life Wonderful",
      "AlternateTitle": "",
      "TitleArray": [
        "Isn't Life Wonderful"
      ],
      "Year": "1924",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1721",
      "databaseFilmTitle": "It Happened One Night",
      "FilmTitle": "It Happened One Night",
      "AlternateTitle": "",
      "TitleArray": [
        "It Happened One Night"
      ],
      "Year": "1934",
      "Director": "Frank Capra",
      "DirectorArray": [
        "Frank Capra"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "1722",
      "databaseFilmTitle": "It has to be lived once and dreamed twice",
      "FilmTitle": "It has to be lived once and dreamed twice",
      "AlternateTitle": "",
      "TitleArray": [
        "It has to be lived once and dreamed twice"
      ],
      "Year": "2019",
      "Director": "Rainer Kohlberger",
      "DirectorArray": [
        "Rainer Kohlberger"
      ],
      "Country": "Germany, Austria",
      "CountryArray": [
        "Germany",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1723",
      "databaseFilmTitle": "It Should Happen to You",
      "FilmTitle": "It Should Happen to You",
      "AlternateTitle": "",
      "TitleArray": [
        "It Should Happen to You"
      ],
      "Year": "1954",
      "Director": "George Cuckor",
      "DirectorArray": [
        "George Cuckor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1724",
      "databaseFilmTitle": "It Will Never Happen Again",
      "FilmTitle": "It Will Never Happen Again",
      "AlternateTitle": "Unzere Kinder",
      "TitleArray": [
        "It Will Never Happen Again",
        "Unzere Kinder"
      ],
      "Year": "1951",
      "Director": "Natan Gross",
      "DirectorArray": [
        "Natan Gross"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1725",
      "databaseFilmTitle": "It's a Big Country: An American Anthology",
      "FilmTitle": "It's a Big Country: An American Anthology",
      "AlternateTitle": "",
      "TitleArray": [
        "It's a Big Country: An American Anthology"
      ],
      "Year": "1951",
      "Director": "Clarence Brown, Don Hartman, John Sturges, Richard Thorpe, Charles Vidor, Don Weis, William A. Wellman",
      "DirectorArray": [
        "Clarence Brown",
        "Don Hartman",
        "John Sturges",
        "Richard Thorpe",
        "Charles Vidor",
        "Don Weis",
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1726",
      "databaseFilmTitle": "It's a Gift",
      "FilmTitle": "It's a Gift",
      "AlternateTitle": "",
      "TitleArray": [
        "It's a Gift"
      ],
      "Year": "1934",
      "Director": "Norman Z. McLeod",
      "DirectorArray": [
        "Norman Z. McLeod"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1727",
      "databaseFilmTitle": "It's a Mad, Mad, Mad, Mad World",
      "FilmTitle": "It's a Mad, Mad, Mad, Mad World",
      "AlternateTitle": "",
      "TitleArray": [
        "It's a Mad, Mad, Mad, Mad World"
      ],
      "Year": "1963",
      "Director": "Stanley Kramer",
      "DirectorArray": [
        "Stanley Kramer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1728",
      "databaseFilmTitle": "It's a Wonderful Life",
      "FilmTitle": "It's a Wonderful Life",
      "AlternateTitle": "",
      "TitleArray": [
        "It's a Wonderful Life"
      ],
      "Year": "1946",
      "Director": "Frank Capra",
      "DirectorArray": [
        "Frank Capra"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "133",
      "2022votes": "22"
    },
    {
      "key": "1729",
      "databaseFilmTitle": "It's Always Fair Weather",
      "FilmTitle": "It's Always Fair Weather",
      "AlternateTitle": "",
      "TitleArray": [
        "It's Always Fair Weather"
      ],
      "Year": "1955",
      "Director": "Stanley Donen, Gene Kelly",
      "DirectorArray": [
        "Stanley Donen",
        "Gene Kelly"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1730",
      "databaseFilmTitle": "It's Such A Beautiful Day",
      "FilmTitle": "It's Such A Beautiful Day",
      "AlternateTitle": "",
      "TitleArray": [
        "It's Such A Beautiful Day"
      ],
      "Year": "2012",
      "Director": "Don Hertzfeldt",
      "DirectorArray": [
        "Don Hertzfeldt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1731",
      "databaseFilmTitle": "Itinerary of a Spoiled Child",
      "FilmTitle": "Itinerary of a Spoiled Child",
      "AlternateTitle": "Itinéraire d'un enfant gâté",
      "TitleArray": [
        "Itinerary of a Spoiled Child",
        "Itinéraire d'un enfant gâté"
      ],
      "Year": "1988",
      "Director": "Claude Lelouch",
      "DirectorArray": [
        "Claude Lelouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1732",
      "databaseFilmTitle": "Ivan",
      "FilmTitle": "Ivan",
      "AlternateTitle": "",
      "TitleArray": [
        "Ivan"
      ],
      "Year": "1932",
      "Director": "Aleksandr Dovzhenko",
      "DirectorArray": [
        "Aleksandr Dovzhenko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1733",
      "databaseFilmTitle": "Ivan the Terrible",
      "FilmTitle": "Ivan the Terrible",
      "AlternateTitle": "",
      "TitleArray": [
        "Ivan the Terrible"
      ],
      "Year": "1944",
      "Director": "Sergei Eisenstein",
      "DirectorArray": [
        "Sergei Eisenstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "6",
      "1962votes": "16",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1734",
      "databaseFilmTitle": "Ivan the Terrible, Part II",
      "FilmTitle": "Ivan the Terrible, Part II",
      "AlternateTitle": "",
      "TitleArray": [
        "Ivan the Terrible, Part II"
      ],
      "Year": "1958",
      "Director": "Sergei Eisenstein",
      "DirectorArray": [
        "Sergei Eisenstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1735",
      "databaseFilmTitle": "Ivan's Childhood",
      "FilmTitle": "Ivan's Childhood",
      "AlternateTitle": "",
      "TitleArray": [
        "Ivan's Childhood"
      ],
      "Year": "1962",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1736",
      "databaseFilmTitle": "Ixcanul",
      "FilmTitle": "Ixcanul",
      "AlternateTitle": "",
      "TitleArray": [
        "Ixcanul"
      ],
      "Year": "2015",
      "Director": "Jayro Bustamante",
      "DirectorArray": [
        "Jayro Bustamante"
      ],
      "Country": "Guatemala",
      "CountryArray": [
        "Guatemala"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1737",
      "databaseFilmTitle": "J'accuse",
      "FilmTitle": "J'accuse",
      "AlternateTitle": "",
      "TitleArray": [
        "J'accuse"
      ],
      "Year": "1919",
      "Director": "Abel Gance",
      "DirectorArray": [
        "Abel Gance"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1738",
      "databaseFilmTitle": "Jackass 3",
      "FilmTitle": "Jackass 3",
      "AlternateTitle": "Jackass 3D",
      "TitleArray": [
        "Jackass 3",
        "Jackass 3D"
      ],
      "Year": "2010",
      "Director": "Jeff Tremaine",
      "DirectorArray": [
        "Jeff Tremaine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1739",
      "databaseFilmTitle": "Jaguar",
      "FilmTitle": "Jaguar",
      "AlternateTitle": "",
      "TitleArray": [
        "Jaguar"
      ],
      "Year": "1967",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1740",
      "databaseFilmTitle": "Jane B. par Agnès V.",
      "FilmTitle": "Jane B. par Agnès V.",
      "AlternateTitle": "",
      "TitleArray": [
        "Jane B. par Agnès V."
      ],
      "Year": "1988",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1741",
      "databaseFilmTitle": "Jane Eyre",
      "FilmTitle": "Jane Eyre",
      "AlternateTitle": "",
      "TitleArray": [
        "Jane Eyre"
      ],
      "Year": "1943",
      "Director": "Robert Stevenson",
      "DirectorArray": [
        "Robert Stevenson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1742",
      "databaseFilmTitle": "Japanese Girls at the Harbor",
      "FilmTitle": "Japanese Girls at the Harbor",
      "AlternateTitle": "Minato no nihonmusume",
      "TitleArray": [
        "Japanese Girls at the Harbor",
        "Minato no nihonmusume"
      ],
      "Year": "1933",
      "Director": "Hiroshi Shimizu",
      "DirectorArray": [
        "Hiroshi Shimizu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1743",
      "databaseFilmTitle": "Jason and the Argonauts",
      "FilmTitle": "Jason and the Argonauts",
      "AlternateTitle": "",
      "TitleArray": [
        "Jason and the Argonauts"
      ],
      "Year": "1963",
      "Director": "Don Chaffey",
      "DirectorArray": [
        "Don Chaffey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1744",
      "databaseFilmTitle": "Jaws",
      "FilmTitle": "Jaws",
      "AlternateTitle": "",
      "TitleArray": [
        "Jaws"
      ],
      "Year": "1975",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "104",
      "2022votes": "29"
    },
    {
      "key": "1745",
      "databaseFilmTitle": "Jazzclub",
      "FilmTitle": "Jazzclub",
      "AlternateTitle": "Jazzclub - Der frühe Vogel fängt den Wurm",
      "TitleArray": [
        "Jazzclub",
        "Jazzclub - Der frühe Vogel fängt den Wurm"
      ],
      "Year": "2004",
      "Director": "Helge Schneider",
      "DirectorArray": [
        "Helge Schneider"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1746",
      "databaseFilmTitle": "Je t'aime, je t'aime",
      "FilmTitle": "Je t'aime, je t'aime",
      "AlternateTitle": "",
      "TitleArray": [
        "Je t'aime, je t'aime"
      ],
      "Year": "1968",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1747",
      "databaseFilmTitle": "Je tu il elle",
      "FilmTitle": "Je tu il elle",
      "AlternateTitle": "",
      "TitleArray": [
        "Je tu il elle"
      ],
      "Year": "1974",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "1748",
      "databaseFilmTitle": "Jeanne Dielman, 23, Quai du Commerce, 1080 Bruxelles",
      "FilmTitle": "Jeanne Dielman, 23, Quai du Commerce, 1080 Bruxelles",
      "AlternateTitle": "",
      "TitleArray": [
        "Jeanne Dielman, 23, Quai du Commerce, 1080 Bruxelles"
      ],
      "Year": "1975",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "36",
      "2012votes": "34",
      "2022rank": "1",
      "2022votes": "215"
    },
    {
      "key": "1749",
      "databaseFilmTitle": "Jersey Boys",
      "FilmTitle": "Jersey Boys",
      "AlternateTitle": "",
      "TitleArray": [
        "Jersey Boys"
      ],
      "Year": "2014",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1750",
      "databaseFilmTitle": "Jesse James",
      "FilmTitle": "Jesse James",
      "AlternateTitle": "",
      "TitleArray": [
        "Jesse James"
      ],
      "Year": "1939",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1751",
      "databaseFilmTitle": "Jesus Christ Superstar",
      "FilmTitle": "Jesus Christ Superstar",
      "AlternateTitle": "",
      "TitleArray": [
        "Jesus Christ Superstar"
      ],
      "Year": "1973",
      "Director": "Norman Jewison",
      "DirectorArray": [
        "Norman Jewison"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1752",
      "databaseFilmTitle": "Jesus of Montreal",
      "FilmTitle": "Jesus of Montreal",
      "AlternateTitle": "Jésus de Montréal",
      "TitleArray": [
        "Jesus of Montreal",
        "Jésus de Montréal"
      ],
      "Year": "1989",
      "Director": "Denys Arcand",
      "DirectorArray": [
        "Denys Arcand"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1753",
      "databaseFilmTitle": "Jesus Shows You the Way to the Highway",
      "FilmTitle": "Jesus Shows You the Way to the Highway",
      "AlternateTitle": "",
      "TitleArray": [
        "Jesus Shows You the Way to the Highway"
      ],
      "Year": "2019",
      "Director": "Miguel Llansó",
      "DirectorArray": [
        "Miguel Llansó"
      ],
      "Country": "Spain, Estonia",
      "CountryArray": [
        "Spain",
        "Estonia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1754",
      "databaseFilmTitle": "JFK",
      "FilmTitle": "JFK",
      "AlternateTitle": "",
      "TitleArray": [
        "JFK"
      ],
      "Year": "1991",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1755",
      "databaseFilmTitle": "Jin-Roh: The Wolf Brigade",
      "FilmTitle": "Jin-Roh: The Wolf Brigade",
      "AlternateTitle": "",
      "TitleArray": [
        "Jin-Roh: The Wolf Brigade"
      ],
      "Year": "1999",
      "Director": "Hiroyuki Okiura",
      "DirectorArray": [
        "Hiroyuki Okiura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1756",
      "databaseFilmTitle": "Jo",
      "FilmTitle": "Jo",
      "AlternateTitle": "",
      "TitleArray": [
        "Jo"
      ],
      "Year": "1971",
      "Director": "Jean Girault",
      "DirectorArray": [
        "Jean Girault"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1757",
      "databaseFilmTitle": "Johanna d'Arc of Mongolia",
      "FilmTitle": "Johanna d'Arc of Mongolia",
      "AlternateTitle": "",
      "TitleArray": [
        "Johanna d'Arc of Mongolia"
      ],
      "Year": "1989",
      "Director": "Ulrike Ottinger",
      "DirectorArray": [
        "Ulrike Ottinger"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1758",
      "databaseFilmTitle": "John C. Depp, II v. Amber Laura Heard",
      "FilmTitle": "John C. Depp, II v. Amber Laura Heard",
      "AlternateTitle": "",
      "TitleArray": [
        "John C. Depp, II v. Amber Laura Heard"
      ],
      "Year": "2022",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1759",
      "databaseFilmTitle": "John Wick",
      "FilmTitle": "John Wick",
      "AlternateTitle": "",
      "TitleArray": [
        "John Wick"
      ],
      "Year": "2014",
      "Director": "Chad Stahelski, David Leitch",
      "DirectorArray": [
        "Chad Stahelski",
        "David Leitch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1760",
      "databaseFilmTitle": "Johnny Cash: Hurt [MV]",
      "FilmTitle": "Johnny Cash: Hurt [MV]",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Cash: Hurt [MV]"
      ],
      "Year": "2003",
      "Director": "Mark Romanek",
      "DirectorArray": [
        "Mark Romanek"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1761",
      "databaseFilmTitle": "Johnny Flash",
      "FilmTitle": "Johnny Flash",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Flash"
      ],
      "Year": "1986",
      "Director": "Werner Nekes",
      "DirectorArray": [
        "Werner Nekes"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1762",
      "databaseFilmTitle": "Johnny Gaddaar",
      "FilmTitle": "Johnny Gaddaar",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Gaddaar"
      ],
      "Year": "2007",
      "Director": "Sriram Raghavan",
      "DirectorArray": [
        "Sriram Raghavan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1763",
      "databaseFilmTitle": "Johnny Got His Gun",
      "FilmTitle": "Johnny Got His Gun",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Got His Gun"
      ],
      "Year": "1971",
      "Director": "Dalton Trumbo",
      "DirectorArray": [
        "Dalton Trumbo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1764",
      "databaseFilmTitle": "Johnny Guitar",
      "FilmTitle": "Johnny Guitar",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Guitar"
      ],
      "Year": "1954",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "123",
      "2022votes": "25"
    },
    {
      "key": "1765",
      "databaseFilmTitle": "Johnny Suede",
      "FilmTitle": "Johnny Suede",
      "AlternateTitle": "",
      "TitleArray": [
        "Johnny Suede"
      ],
      "Year": "1991",
      "Director": "Tom DiCillo",
      "DirectorArray": [
        "Tom DiCillo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1766",
      "databaseFilmTitle": "Joker",
      "FilmTitle": "Joker",
      "AlternateTitle": "",
      "TitleArray": [
        "Joker"
      ],
      "Year": "2019",
      "Director": "Todd Phillips",
      "DirectorArray": [
        "Todd Phillips"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1767",
      "databaseFilmTitle": "Jonah Who Will Be 25 in the Year 2000",
      "FilmTitle": "Jonah Who Will Be 25 in the Year 2000",
      "AlternateTitle": "Jonas qui aura 25 ans en l'an 2000",
      "TitleArray": [
        "Jonah Who Will Be 25 in the Year 2000",
        "Jonas qui aura 25 ans en l'an 2000"
      ],
      "Year": "1976",
      "Director": "Alain Tanner",
      "DirectorArray": [
        "Alain Tanner"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1768",
      "databaseFilmTitle": "Journey on the Hour Hand",
      "FilmTitle": "Journey on the Hour Hand",
      "AlternateTitle": "Akrebin Yolculuğu",
      "TitleArray": [
        "Journey on the Hour Hand",
        "Akrebin Yolculuğu"
      ],
      "Year": "1997",
      "Director": "Ömer Kavur",
      "DirectorArray": [
        "Ömer Kavur"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1769",
      "databaseFilmTitle": "Journey to Italy",
      "FilmTitle": "Journey to Italy",
      "AlternateTitle": "Viaggio in Italia",
      "TitleArray": [
        "Journey to Italy",
        "Viaggio in Italia"
      ],
      "Year": "1954",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "34",
      "1962votes": "4",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "41",
      "2012votes": "32",
      "2022rank": "72",
      "2022votes": "37"
    },
    {
      "key": "1770",
      "databaseFilmTitle": "Journey to the Lost City",
      "FilmTitle": "Journey to the Lost City",
      "AlternateTitle": "",
      "TitleArray": [
        "Journey to the Lost City"
      ],
      "Year": "1960",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1771",
      "databaseFilmTitle": "Journey to the West",
      "FilmTitle": "Journey to the West",
      "AlternateTitle": "Xi You",
      "TitleArray": [
        "Journey to the West",
        "Xi You"
      ],
      "Year": "2014",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1772",
      "databaseFilmTitle": "Journeys from Berlin/1971",
      "FilmTitle": "Journeys from Berlin/1971",
      "AlternateTitle": "",
      "TitleArray": [
        "Journeys from Berlin/1971"
      ],
      "Year": "1980",
      "Director": "Yvonne Rainer",
      "DirectorArray": [
        "Yvonne Rainer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1773",
      "databaseFilmTitle": "Joy of Living",
      "FilmTitle": "Joy of Living",
      "AlternateTitle": "",
      "TitleArray": [
        "Joy of Living"
      ],
      "Year": "1938",
      "Director": "Tay Garnett",
      "DirectorArray": [
        "Tay Garnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1774",
      "databaseFilmTitle": "Ju Dou",
      "FilmTitle": "Ju Dou",
      "AlternateTitle": "",
      "TitleArray": [
        "Ju Dou"
      ],
      "Year": "1990",
      "Director": "Zhang Yimou, Yang Fengliang",
      "DirectorArray": [
        "Zhang Yimou",
        "Yang Fengliang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1775",
      "databaseFilmTitle": "Juan Moreira",
      "FilmTitle": "Juan Moreira",
      "AlternateTitle": "",
      "TitleArray": [
        "Juan Moreira"
      ],
      "Year": "1973",
      "Director": "Leonardo Favio",
      "DirectorArray": [
        "Leonardo Favio"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1776",
      "databaseFilmTitle": "Judex (1916)",
      "FilmTitle": "Judex",
      "AlternateTitle": "",
      "TitleArray": [
        "Judex"
      ],
      "Year": "1916",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1777",
      "databaseFilmTitle": "Judex (1963)",
      "FilmTitle": "Judex",
      "AlternateTitle": "",
      "TitleArray": [
        "Judex"
      ],
      "Year": "1963",
      "Director": "Georges Franju",
      "DirectorArray": [
        "Georges Franju"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1778",
      "databaseFilmTitle": "Juice",
      "FilmTitle": "Juice",
      "AlternateTitle": "",
      "TitleArray": [
        "Juice"
      ],
      "Year": "1992",
      "Director": "Ernest R. Dickerson",
      "DirectorArray": [
        "Ernest R. Dickerson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1779",
      "databaseFilmTitle": "Jules and Jim",
      "FilmTitle": "Jules and Jim",
      "AlternateTitle": "Jules et Jim",
      "TitleArray": [
        "Jules and Jim",
        "Jules et Jim"
      ],
      "Year": "1962",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "14",
      "1982votes": "9",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "20",
      "2002votes": "10",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1780",
      "databaseFilmTitle": "Juliet of the Spirits",
      "FilmTitle": "Juliet of the Spirits",
      "AlternateTitle": "Giulietta degli spiriti",
      "TitleArray": [
        "Juliet of the Spirits",
        "Giulietta degli spiriti"
      ],
      "Year": "1965",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1781",
      "databaseFilmTitle": "July",
      "FilmTitle": "July",
      "AlternateTitle": "Shilde",
      "TitleArray": [
        "July",
        "Shilde"
      ],
      "Year": "1988",
      "Director": "Darezhan Omirbayev",
      "DirectorArray": [
        "Darezhan Omirbayev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1782",
      "databaseFilmTitle": "July Rain",
      "FilmTitle": "July Rain",
      "AlternateTitle": "",
      "TitleArray": [
        "July Rain"
      ],
      "Year": "1967",
      "Director": "Marlen Khutsiev",
      "DirectorArray": [
        "Marlen Khutsiev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1783",
      "databaseFilmTitle": "Jungle Fever",
      "FilmTitle": "Jungle Fever",
      "AlternateTitle": "",
      "TitleArray": [
        "Jungle Fever"
      ],
      "Year": "1991",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1784",
      "databaseFilmTitle": "Jurassic Park",
      "FilmTitle": "Jurassic Park",
      "AlternateTitle": "",
      "TitleArray": [
        "Jurassic Park"
      ],
      "Year": "1993",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "1785",
      "databaseFilmTitle": "Just Another Girl on the I.R.T.",
      "FilmTitle": "Just Another Girl on the I.R.T.",
      "AlternateTitle": "",
      "TitleArray": [
        "Just Another Girl on the I.R.T."
      ],
      "Year": "1992",
      "Director": "Leslie Harris",
      "DirectorArray": [
        "Leslie Harris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1786",
      "databaseFilmTitle": "Just Before Nightfall",
      "FilmTitle": "Just Before Nightfall",
      "AlternateTitle": "Juste avant la nuit",
      "TitleArray": [
        "Just Before Nightfall",
        "Juste avant la nuit"
      ],
      "Year": "1971",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1787",
      "databaseFilmTitle": "Just Don't Fuck",
      "FilmTitle": "Just Don't Fuck",
      "AlternateTitle": "Y'a qu'à pas baiser",
      "TitleArray": [
        "Just Don't Fuck",
        "Y'a qu'à pas baiser"
      ],
      "Year": "1971",
      "Director": "Carole Roussopoulos",
      "DirectorArray": [
        "Carole Roussopoulos"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1788",
      "databaseFilmTitle": "Juvenile Court",
      "FilmTitle": "Juvenile Court",
      "AlternateTitle": "",
      "TitleArray": [
        "Juvenile Court"
      ],
      "Year": "1973",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1789",
      "databaseFilmTitle": "K",
      "FilmTitle": "K",
      "AlternateTitle": "",
      "TitleArray": [
        "K"
      ],
      "Year": "1989",
      "Director": "Jayne Parker",
      "DirectorArray": [
        "Jayne Parker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1790",
      "databaseFilmTitle": "Kaagaz Ke Phool",
      "FilmTitle": "Kaagaz Ke Phool",
      "AlternateTitle": "",
      "TitleArray": [
        "Kaagaz Ke Phool"
      ],
      "Year": "1959",
      "Director": "Guru Dutt",
      "DirectorArray": [
        "Guru Dutt"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1791",
      "databaseFilmTitle": "Kadosh",
      "FilmTitle": "Kadosh",
      "AlternateTitle": "",
      "TitleArray": [
        "Kadosh"
      ],
      "Year": "1999",
      "Director": "Amos Gitaï",
      "DirectorArray": [
        "Amos Gitaï"
      ],
      "Country": "Israel",
      "CountryArray": [
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1792",
      "databaseFilmTitle": "Kagemusha",
      "FilmTitle": "Kagemusha",
      "AlternateTitle": "",
      "TitleArray": [
        "Kagemusha"
      ],
      "Year": "1980",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1793",
      "databaseFilmTitle": "Kaidan",
      "FilmTitle": "Kaidan",
      "AlternateTitle": "",
      "TitleArray": [
        "Kaidan"
      ],
      "Year": "2007",
      "Director": "Hideo Nakata",
      "DirectorArray": [
        "Hideo Nakata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1794",
      "databaseFilmTitle": "Kaili Blues",
      "FilmTitle": "Kaili Blues",
      "AlternateTitle": "Lu bian ye can",
      "TitleArray": [
        "Kaili Blues",
        "Lu bian ye can"
      ],
      "Year": "2015",
      "Director": "Bi Gan",
      "DirectorArray": [
        "Bi Gan"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1795",
      "databaseFilmTitle": "Kaldalon",
      "FilmTitle": "Kaldalon",
      "AlternateTitle": "",
      "TitleArray": [
        "Kaldalon"
      ],
      "Year": "1971",
      "Director": "Dore O.",
      "DirectorArray": [
        "Dore O."
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1796",
      "databaseFilmTitle": "Kalendar",
      "FilmTitle": "Kalendar",
      "AlternateTitle": "",
      "TitleArray": [
        "Kalendar"
      ],
      "Year": "2008",
      "Director": "Naomi Uman",
      "DirectorArray": [
        "Naomi Uman"
      ],
      "Country": "United States, Ukraine",
      "CountryArray": [
        "United States",
        "Ukraine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1797",
      "databaseFilmTitle": "Kalpana",
      "FilmTitle": "Kalpana",
      "AlternateTitle": "",
      "TitleArray": [
        "Kalpana"
      ],
      "Year": "1948",
      "Director": "Uday Shankar",
      "DirectorArray": [
        "Uday Shankar"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1798",
      "databaseFilmTitle": "Kanal",
      "FilmTitle": "Kanal",
      "AlternateTitle": "",
      "TitleArray": [
        "Kanal"
      ],
      "Year": "1957",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1799",
      "databaseFilmTitle": "Kanchenjungha",
      "FilmTitle": "Kanchenjungha",
      "AlternateTitle": "",
      "TitleArray": [
        "Kanchenjungha"
      ],
      "Year": "1962",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1800",
      "databaseFilmTitle": "Kanehsatake: 270 Years of Resistance",
      "FilmTitle": "Kanehsatake: 270 Years of Resistance",
      "AlternateTitle": "",
      "TitleArray": [
        "Kanehsatake: 270 Years of Resistance"
      ],
      "Year": "1993",
      "Director": "Alanis Obomsawin",
      "DirectorArray": [
        "Alanis Obomsawin"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1801",
      "databaseFilmTitle": "Kaos",
      "FilmTitle": "Kaos",
      "AlternateTitle": "",
      "TitleArray": [
        "Kaos"
      ],
      "Year": "1984",
      "Director": "Paolo Taviani, Vittorio Taviani",
      "DirectorArray": [
        "Paolo Taviani",
        "Vittorio Taviani"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1802",
      "databaseFilmTitle": "Katatsumori",
      "FilmTitle": "Katatsumori",
      "AlternateTitle": "",
      "TitleArray": [
        "Katatsumori"
      ],
      "Year": "1994",
      "Director": "Naomi Kawase",
      "DirectorArray": [
        "Naomi Kawase"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1803",
      "databaseFilmTitle": "Kenny",
      "FilmTitle": "Kenny",
      "AlternateTitle": "",
      "TitleArray": [
        "Kenny"
      ],
      "Year": "2006",
      "Director": "Clayton Jacobson",
      "DirectorArray": [
        "Clayton Jacobson"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1804",
      "databaseFilmTitle": "Kes",
      "FilmTitle": "Kes",
      "AlternateTitle": "",
      "TitleArray": [
        "Kes"
      ],
      "Year": "1969",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1805",
      "databaseFilmTitle": "Khal Nayak",
      "FilmTitle": "Khal Nayak",
      "AlternateTitle": "",
      "TitleArray": [
        "Khal Nayak"
      ],
      "Year": "1993",
      "Director": "Subhash Ghai",
      "DirectorArray": [
        "Subhash Ghai"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1806",
      "databaseFilmTitle": "Khrustalyov, My Car!",
      "FilmTitle": "Khrustalyov, My Car!",
      "AlternateTitle": "",
      "TitleArray": [
        "Khrustalyov, My Car!"
      ],
      "Year": "1998",
      "Director": "Aleksei German",
      "DirectorArray": [
        "Aleksei German"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1807",
      "databaseFilmTitle": "Kid Auto Races At Venice",
      "FilmTitle": "Kid Auto Races At Venice",
      "AlternateTitle": "",
      "TitleArray": [
        "Kid Auto Races At Venice"
      ],
      "Year": "1914",
      "Director": "Henry Lehrman",
      "DirectorArray": [
        "Henry Lehrman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1808",
      "databaseFilmTitle": "Kids",
      "FilmTitle": "Kids",
      "AlternateTitle": "",
      "TitleArray": [
        "Kids"
      ],
      "Year": "1995",
      "Director": "Larry Clark",
      "DirectorArray": [
        "Larry Clark"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1809",
      "databaseFilmTitle": "Kiki's Delivery Service",
      "FilmTitle": "Kiki's Delivery Service",
      "AlternateTitle": "Majo no takkyūbin",
      "TitleArray": [
        "Kiki's Delivery Service",
        "Majo no takkyūbin"
      ],
      "Year": "1989",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1810",
      "databaseFilmTitle": "Kill Bill: Vol. 1",
      "FilmTitle": "Kill Bill: Vol. 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Kill Bill: Vol. 1"
      ],
      "Year": "2003",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1811",
      "databaseFilmTitle": "Killer of Sheep",
      "FilmTitle": "Killer of Sheep",
      "AlternateTitle": "",
      "TitleArray": [
        "Killer of Sheep"
      ],
      "Year": "1978",
      "Director": "Charles Burnett",
      "DirectorArray": [
        "Charles Burnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "43",
      "2022votes": "51"
    },
    {
      "key": "1812",
      "databaseFilmTitle": "Killer's Kiss",
      "FilmTitle": "Killer's Kiss",
      "AlternateTitle": "",
      "TitleArray": [
        "Killer's Kiss"
      ],
      "Year": "1955",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1813",
      "databaseFilmTitle": "Kind Hearts and Coronets",
      "FilmTitle": "Kind Hearts and Coronets",
      "AlternateTitle": "",
      "TitleArray": [
        "Kind Hearts and Coronets"
      ],
      "Year": "1949",
      "Director": "Robert Hamer",
      "DirectorArray": [
        "Robert Hamer"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1814",
      "databaseFilmTitle": "King Kong",
      "FilmTitle": "King Kong",
      "AlternateTitle": "",
      "TitleArray": [
        "King Kong"
      ],
      "Year": "1933",
      "Director": "Merian C. Cooper, Ernest B. Schoedsack",
      "DirectorArray": [
        "Merian C. Cooper",
        "Ernest B. Schoedsack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1815",
      "databaseFilmTitle": "King Lear (1971)",
      "FilmTitle": "King Lear",
      "AlternateTitle": "",
      "TitleArray": [
        "King Lear"
      ],
      "Year": "1971",
      "Director": "Peter Brook",
      "DirectorArray": [
        "Peter Brook"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1816",
      "databaseFilmTitle": "King Lear (1987)",
      "FilmTitle": "King Lear",
      "AlternateTitle": "",
      "TitleArray": [
        "King Lear"
      ],
      "Year": "1987",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1817",
      "databaseFilmTitle": "King of the Children",
      "FilmTitle": "King of the Children",
      "AlternateTitle": "Hai zi wang",
      "TitleArray": [
        "King of the Children",
        "Hai zi wang"
      ],
      "Year": "1987",
      "Director": "Chen Kaige",
      "DirectorArray": [
        "Chen Kaige"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1818",
      "databaseFilmTitle": "King-Size Canary",
      "FilmTitle": "King-Size Canary",
      "AlternateTitle": "",
      "TitleArray": [
        "King-Size Canary"
      ],
      "Year": "1947",
      "Director": "Tex Avery",
      "DirectorArray": [
        "Tex Avery"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1819",
      "databaseFilmTitle": "Kingdom and the Beauty",
      "FilmTitle": "Kingdom and the Beauty",
      "AlternateTitle": "Jiang shan mei ren",
      "TitleArray": [
        "Kingdom and the Beauty",
        "Jiang shan mei ren"
      ],
      "Year": "1959",
      "Director": "Li Han-Hsiang",
      "DirectorArray": [
        "Li Han-Hsiang"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1820",
      "databaseFilmTitle": "Kings of the Road",
      "FilmTitle": "Kings of the Road",
      "AlternateTitle": "Im Lauf der Zeit",
      "TitleArray": [
        "Kings of the Road",
        "Im Lauf der Zeit"
      ],
      "Year": "1976",
      "Director": "Wim Wenders",
      "DirectorArray": [
        "Wim Wenders"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1821",
      "databaseFilmTitle": "Kino-Pravda",
      "FilmTitle": "Kino-Pravda",
      "AlternateTitle": "",
      "TitleArray": [
        "Kino-Pravda"
      ],
      "Year": "1922",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1822",
      "databaseFilmTitle": "Kirikou and the Sorceress",
      "FilmTitle": "Kirikou and the Sorceress",
      "AlternateTitle": "Kirikou et la Sorcière",
      "TitleArray": [
        "Kirikou and the Sorceress",
        "Kirikou et la Sorcière"
      ],
      "Year": "1998",
      "Director": "Michel Ocelot",
      "DirectorArray": [
        "Michel Ocelot"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1823",
      "databaseFilmTitle": "Kisapmata",
      "FilmTitle": "Kisapmata",
      "AlternateTitle": "",
      "TitleArray": [
        "Kisapmata"
      ],
      "Year": "1981",
      "Director": "Mike De Leon",
      "DirectorArray": [
        "Mike De Leon"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1824",
      "databaseFilmTitle": "Kiss",
      "FilmTitle": "Kiss",
      "AlternateTitle": "",
      "TitleArray": [
        "Kiss"
      ],
      "Year": "1963",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1825",
      "databaseFilmTitle": "Kiss Me",
      "FilmTitle": "Kiss Me",
      "AlternateTitle": "Kyss Mig",
      "TitleArray": [
        "Kiss Me",
        "Kyss Mig"
      ],
      "Year": "2011",
      "Director": "Alexandra-Therese Keining",
      "DirectorArray": [
        "Alexandra-Therese Keining"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1826",
      "databaseFilmTitle": "Kiss Me Deadly",
      "FilmTitle": "Kiss Me Deadly",
      "AlternateTitle": "",
      "TitleArray": [
        "Kiss Me Deadly"
      ],
      "Year": "1955",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1827",
      "databaseFilmTitle": "Kiss Me, Stupid",
      "FilmTitle": "Kiss Me, Stupid",
      "AlternateTitle": "",
      "TitleArray": [
        "Kiss Me, Stupid"
      ],
      "Year": "1964",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1828",
      "databaseFilmTitle": "Kiss of the Spider Woman",
      "FilmTitle": "Kiss of the Spider Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Kiss of the Spider Woman"
      ],
      "Year": "1985",
      "Director": "Héctor Babenco",
      "DirectorArray": [
        "Héctor Babenco"
      ],
      "Country": "Brazil, United States",
      "CountryArray": [
        "Brazil",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1829",
      "databaseFilmTitle": "Kissed",
      "FilmTitle": "Kissed",
      "AlternateTitle": "",
      "TitleArray": [
        "Kissed"
      ],
      "Year": "1996",
      "Director": "Lynne Stopkewich",
      "DirectorArray": [
        "Lynne Stopkewich"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1830",
      "databaseFilmTitle": "Kitch's Last Meal",
      "FilmTitle": "Kitch's Last Meal",
      "AlternateTitle": "",
      "TitleArray": [
        "Kitch's Last Meal"
      ],
      "Year": "1978",
      "Director": "Carolee Schneemann",
      "DirectorArray": [
        "Carolee Schneemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1831",
      "databaseFilmTitle": "Klipperty Klopp",
      "FilmTitle": "Klipperty Klopp",
      "AlternateTitle": "",
      "TitleArray": [
        "Klipperty Klopp"
      ],
      "Year": "1984",
      "Director": "Andrew Kötting",
      "DirectorArray": [
        "Andrew Kötting"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1832",
      "databaseFilmTitle": "Klute",
      "FilmTitle": "Klute",
      "AlternateTitle": "",
      "TitleArray": [
        "Klute"
      ],
      "Year": "1971",
      "Director": "Alan J. Pakula",
      "DirectorArray": [
        "Alan J. Pakula"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1833",
      "databaseFilmTitle": "Knife in the Water",
      "FilmTitle": "Knife in the Water",
      "AlternateTitle": "NÓŻ W WODZIE",
      "TitleArray": [
        "Knife in the Water",
        "NÓŻ W WODZIE"
      ],
      "Year": "1962",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1834",
      "databaseFilmTitle": "Knight of Cups",
      "FilmTitle": "Knight of Cups",
      "AlternateTitle": "",
      "TitleArray": [
        "Knight of Cups"
      ],
      "Year": "2015",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1835",
      "databaseFilmTitle": "Komissary",
      "FilmTitle": "Komissary",
      "AlternateTitle": "",
      "TitleArray": [
        "Komissary"
      ],
      "Year": "1969",
      "Director": "Nikolaj Maščenko",
      "DirectorArray": [
        "Nikolaj Maščenko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1836",
      "databaseFilmTitle": "Korczak",
      "FilmTitle": "Korczak",
      "AlternateTitle": "",
      "TitleArray": [
        "Korczak"
      ],
      "Year": "1990",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland, West Germany",
      "CountryArray": [
        "Poland",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1837",
      "databaseFilmTitle": "Koyaanisqatsi",
      "FilmTitle": "Koyaanisqatsi",
      "AlternateTitle": "",
      "TitleArray": [
        "Koyaanisqatsi"
      ],
      "Year": "1982",
      "Director": "Godfrey Reggio",
      "DirectorArray": [
        "Godfrey Reggio"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1838",
      "databaseFilmTitle": "Kuhle Wampe or Who Owns the World?",
      "FilmTitle": "Kuhle Wampe or Who Owns the World?",
      "AlternateTitle": "Kuhle Wampe, oder: Wem gehört die Welt?",
      "TitleArray": [
        "Kuhle Wampe or Who Owns the World?",
        "Kuhle Wampe, oder: Wem gehört die Welt?"
      ],
      "Year": "1932",
      "Director": "Slatan Dudow",
      "DirectorArray": [
        "Slatan Dudow"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1839",
      "databaseFilmTitle": "Kummatty",
      "FilmTitle": "Kummatty",
      "AlternateTitle": "",
      "TitleArray": [
        "Kummatty"
      ],
      "Year": "1979",
      "Director": "Govindan Aravindan",
      "DirectorArray": [
        "Govindan Aravindan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1840",
      "databaseFilmTitle": "Kung Fu Hustle",
      "FilmTitle": "Kung Fu Hustle",
      "AlternateTitle": "",
      "TitleArray": [
        "Kung Fu Hustle"
      ],
      "Year": "2004",
      "Director": "Stephen Chow",
      "DirectorArray": [
        "Stephen Chow"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1841",
      "databaseFilmTitle": "Kuroneko",
      "FilmTitle": "Kuroneko",
      "AlternateTitle": "Yabu no naka no kuroneko",
      "TitleArray": [
        "Kuroneko",
        "Yabu no naka no kuroneko"
      ],
      "Year": "1968",
      "Director": "Kaneto Shindô",
      "DirectorArray": [
        "Kaneto Shindô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1842",
      "databaseFilmTitle": "Kwaidan",
      "FilmTitle": "Kwaidan",
      "AlternateTitle": "",
      "TitleArray": [
        "Kwaidan"
      ],
      "Year": "1964",
      "Director": "Masaki Kobayashi",
      "DirectorArray": [
        "Masaki Kobayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1843",
      "databaseFilmTitle": "L. Cohen",
      "FilmTitle": "L. Cohen",
      "AlternateTitle": "",
      "TitleArray": [
        "L. Cohen"
      ],
      "Year": "2017",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1844",
      "databaseFilmTitle": "L'âge d'or",
      "FilmTitle": "L'âge d'or",
      "AlternateTitle": "",
      "TitleArray": [
        "L'âge d'or"
      ],
      "Year": "1930",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1845",
      "databaseFilmTitle": "L'amore",
      "FilmTitle": "L'amore",
      "AlternateTitle": "",
      "TitleArray": [
        "L'amore"
      ],
      "Year": "1948",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1846",
      "databaseFilmTitle": "L'amour fou",
      "FilmTitle": "L'amour fou",
      "AlternateTitle": "",
      "TitleArray": [
        "L'amour fou"
      ],
      "Year": "1969",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1847",
      "databaseFilmTitle": "L'ange",
      "FilmTitle": "L'ange",
      "AlternateTitle": "",
      "TitleArray": [
        "L'ange"
      ],
      "Year": "1982",
      "Director": "Patrick Bokanowski",
      "DirectorArray": [
        "Patrick Bokanowski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1848",
      "databaseFilmTitle": "L'argent (1928)",
      "FilmTitle": "L'argent",
      "AlternateTitle": "Money",
      "TitleArray": [
        "L'argent",
        "Money"
      ],
      "Year": "1928",
      "Director": "Marcel L'Herbier",
      "DirectorArray": [],
      "Country": "France",
      "CountryArray": [],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1849",
      "databaseFilmTitle": "L'argent (1983)",
      "FilmTitle": "L'argent",
      "AlternateTitle": "",
      "TitleArray": [
        "L'argent"
      ],
      "Year": "1983",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "1850",
      "databaseFilmTitle": "L'assommoir",
      "FilmTitle": "L'assommoir",
      "AlternateTitle": "",
      "TitleArray": [
        "L'assommoir"
      ],
      "Year": "1909",
      "Director": "Albert Capellani",
      "DirectorArray": [
        "Albert Capellani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1851",
      "databaseFilmTitle": "L'Atalante",
      "FilmTitle": "L'Atalante",
      "AlternateTitle": "",
      "TitleArray": [
        "L'Atalante"
      ],
      "Year": "1934",
      "Director": "Jean Vigo",
      "DirectorArray": [
        "Jean Vigo"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "10",
      "1962votes": "13",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "6",
      "1992votes": "15",
      "2002rank": "16",
      "2002votes": "11",
      "2012rank": "12",
      "2012votes": "58",
      "2022rank": "34",
      "2022votes": "58"
    },
    {
      "key": "1852",
      "databaseFilmTitle": "L'avventura",
      "FilmTitle": "L'avventura",
      "AlternateTitle": "",
      "TitleArray": [
        "L'avventura"
      ],
      "Year": "1960",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "2",
      "1962votes": "20",
      "1972rank": "5",
      "1972votes": "12",
      "1982rank": "7",
      "1982votes": "12",
      "1992rank": "15",
      "1992votes": "9",
      "2002rank": "22",
      "2002votes": "9",
      "2012rank": "21",
      "2012votes": "43",
      "2022rank": "72",
      "2022votes": "37"
    },
    {
      "key": "1853",
      "databaseFilmTitle": "L'enfant",
      "FilmTitle": "L'enfant",
      "AlternateTitle": "",
      "TitleArray": [
        "L'enfant"
      ],
      "Year": "2005",
      "Director": "Jean-Pierre Dardenne, Luc Dardenne",
      "DirectorArray": [
        "Jean-Pierre Dardenne",
        "Luc Dardenne"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1854",
      "databaseFilmTitle": "L'enfant secret",
      "FilmTitle": "L'enfant secret",
      "AlternateTitle": "",
      "TitleArray": [
        "L'enfant secret"
      ],
      "Year": "1979",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1855",
      "databaseFilmTitle": "L'homme atlantique",
      "FilmTitle": "L'homme atlantique",
      "AlternateTitle": "",
      "TitleArray": [
        "L'homme atlantique"
      ],
      "Year": "1981",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1856",
      "databaseFilmTitle": "L'Inhumaine",
      "FilmTitle": "L'Inhumaine",
      "AlternateTitle": "",
      "TitleArray": [
        "L'Inhumaine"
      ],
      "Year": "1924",
      "Director": "Marcel L'Herbier",
      "DirectorArray": [
        "Marcel L'Herbier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1857",
      "databaseFilmTitle": "L'innocente",
      "FilmTitle": "L'innocente",
      "AlternateTitle": "",
      "TitleArray": [
        "L'innocente"
      ],
      "Year": "1976",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1858",
      "databaseFilmTitle": "La Belle Noiseuse",
      "FilmTitle": "La Belle Noiseuse",
      "AlternateTitle": "",
      "TitleArray": [
        "La Belle Noiseuse"
      ],
      "Year": "1991",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1859",
      "databaseFilmTitle": "La bête humaine",
      "FilmTitle": "La bête humaine",
      "AlternateTitle": "",
      "TitleArray": [
        "La bête humaine"
      ],
      "Year": "1938",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1860",
      "databaseFilmTitle": "La celosía",
      "FilmTitle": "La celosía",
      "AlternateTitle": "",
      "TitleArray": [
        "La celosía"
      ],
      "Year": "1972",
      "Director": "Isidoro Valcárcel Medina",
      "DirectorArray": [
        "Isidoro Valcárcel Medina"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1861",
      "databaseFilmTitle": "La cérémonie",
      "FilmTitle": "La cérémonie",
      "AlternateTitle": "",
      "TitleArray": [
        "La cérémonie"
      ],
      "Year": "1995",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1862",
      "databaseFilmTitle": "La chienne",
      "FilmTitle": "La chienne",
      "AlternateTitle": "",
      "TitleArray": [
        "La chienne"
      ],
      "Year": "1931",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1863",
      "databaseFilmTitle": "La chinoise",
      "FilmTitle": "La chinoise",
      "AlternateTitle": "La Chinoise, ou plutôt à la Chinoise: un film en train de se faire",
      "TitleArray": [
        "La chinoise",
        "La Chinoise, ou plutôt à la Chinoise: un film en train de se faire"
      ],
      "Year": "1967",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1864",
      "databaseFilmTitle": "La ciénaga",
      "FilmTitle": "La ciénaga",
      "AlternateTitle": "",
      "TitleArray": [
        "La ciénaga"
      ],
      "Year": "2001",
      "Director": "Lucrecia Martel",
      "DirectorArray": [
        "Lucrecia Martel"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "1865",
      "databaseFilmTitle": "La collectionneuse",
      "FilmTitle": "La collectionneuse",
      "AlternateTitle": "",
      "TitleArray": [
        "La collectionneuse"
      ],
      "Year": "1967",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1866",
      "databaseFilmTitle": "La commune (Paris, 1871)",
      "FilmTitle": "La commune (Paris, 1871)",
      "AlternateTitle": "",
      "TitleArray": [
        "La commune (Paris, 1871)"
      ],
      "Year": "2000",
      "Director": "Peter Watkins",
      "DirectorArray": [
        "Peter Watkins"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "1867",
      "databaseFilmTitle": "La dolce vita",
      "FilmTitle": "La dolce vita",
      "AlternateTitle": "",
      "TitleArray": [
        "La dolce vita"
      ],
      "Year": "1960",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "25",
      "2002votes": "8",
      "2012rank": "39",
      "2012votes": "33",
      "2022rank": "60",
      "2022votes": "42"
    },
    {
      "key": "1868",
      "databaseFilmTitle": "La Flor",
      "FilmTitle": "La Flor",
      "AlternateTitle": "",
      "TitleArray": [
        "La Flor"
      ],
      "Year": "2018",
      "Director": "Mariano Llinás",
      "DirectorArray": [
        "Mariano Llinás"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1869",
      "databaseFilmTitle": "La Haine",
      "FilmTitle": "La Haine",
      "AlternateTitle": "",
      "TitleArray": [
        "La Haine"
      ],
      "Year": "1995",
      "Director": "Mathieu Kassovitz",
      "DirectorArray": [
        "Mathieu Kassovitz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1870",
      "databaseFilmTitle": "La jetée",
      "FilmTitle": "La jetée",
      "AlternateTitle": "",
      "TitleArray": [
        "La jetée"
      ],
      "Year": "1962",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "50",
      "2012votes": "29",
      "2022rank": "67",
      "2022votes": "38"
    },
    {
      "key": "1871",
      "databaseFilmTitle": "La La Land",
      "FilmTitle": "La La Land",
      "AlternateTitle": "",
      "TitleArray": [
        "La La Land"
      ],
      "Year": "2016",
      "Director": "Damien Chazelle",
      "DirectorArray": [
        "Damien Chazelle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1872",
      "databaseFilmTitle": "La lettre",
      "FilmTitle": "La lettre",
      "AlternateTitle": "",
      "TitleArray": [
        "La lettre"
      ],
      "Year": "1999",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "France, Portugal",
      "CountryArray": [
        "France",
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1873",
      "databaseFilmTitle": "La libertad",
      "FilmTitle": "La libertad",
      "AlternateTitle": "",
      "TitleArray": [
        "La libertad"
      ],
      "Year": "2001",
      "Director": "Lisandro Alonso",
      "DirectorArray": [
        "Lisandro Alonso"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1874",
      "databaseFilmTitle": "La luna",
      "FilmTitle": "La luna",
      "AlternateTitle": "",
      "TitleArray": [
        "La luna"
      ],
      "Year": "1979",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy, United States",
      "CountryArray": [
        "Italy",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1875",
      "databaseFilmTitle": "La Marseillaise",
      "FilmTitle": "La Marseillaise",
      "AlternateTitle": "",
      "TitleArray": [
        "La Marseillaise"
      ],
      "Year": "1938",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1876",
      "databaseFilmTitle": "La morte rouge",
      "FilmTitle": "La morte rouge",
      "AlternateTitle": "",
      "TitleArray": [
        "La morte rouge"
      ],
      "Year": "2006",
      "Director": "Victor Erice",
      "DirectorArray": [
        "Victor Erice"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1877",
      "databaseFilmTitle": "La París",
      "FilmTitle": "La París",
      "AlternateTitle": "",
      "TitleArray": [
        "La París"
      ],
      "Year": "2018",
      "Director": "Jaime Guerra",
      "DirectorArray": [
        "Jaime Guerra"
      ],
      "Country": "Dominican Republic",
      "CountryArray": [
        "Dominican Republic"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1878",
      "databaseFilmTitle": "La pile électrique de Léontine",
      "FilmTitle": "La pile électrique de Léontine",
      "AlternateTitle": "",
      "TitleArray": [
        "La pile électrique de Léontine"
      ],
      "Year": "1910",
      "Director": "(unknown)",
      "DirectorArray": [
        "(unknown)"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1879",
      "databaseFilmTitle": "LA Plays Itself",
      "FilmTitle": "LA Plays Itself",
      "AlternateTitle": "",
      "TitleArray": [
        "LA Plays Itself"
      ],
      "Year": "1972",
      "Director": "Fred Halsted",
      "DirectorArray": [
        "Fred Halsted"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1880",
      "databaseFilmTitle": "La Pointe Courte",
      "FilmTitle": "La Pointe Courte",
      "AlternateTitle": "",
      "TitleArray": [
        "La Pointe Courte"
      ],
      "Year": "1955",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1881",
      "databaseFilmTitle": "La poulette grise",
      "FilmTitle": "La poulette grise",
      "AlternateTitle": "",
      "TitleArray": [
        "La poulette grise"
      ],
      "Year": "1947",
      "Director": "Norman LcLaren",
      "DirectorArray": [
        "Norman LcLaren"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1882",
      "databaseFilmTitle": "La Prisonnière",
      "FilmTitle": "La Prisonnière",
      "AlternateTitle": "",
      "TitleArray": [
        "La Prisonnière"
      ],
      "Year": "1968",
      "Director": "Henri-Georges Clouzot",
      "DirectorArray": [
        "Henri-Georges Clouzot"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1883",
      "databaseFilmTitle": "La région centrale",
      "FilmTitle": "La région centrale",
      "AlternateTitle": "",
      "TitleArray": [
        "La région centrale"
      ],
      "Year": "1971",
      "Director": "Michael Snow",
      "DirectorArray": [
        "Michael Snow"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "1884",
      "databaseFilmTitle": "La ricotta",
      "FilmTitle": "La ricotta",
      "AlternateTitle": "",
      "TitleArray": [
        "La ricotta"
      ],
      "Year": "1963",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1885",
      "databaseFilmTitle": "La Ronde",
      "FilmTitle": "La Ronde",
      "AlternateTitle": "",
      "TitleArray": [
        "La Ronde"
      ],
      "Year": "1950",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1886",
      "databaseFilmTitle": "La roue",
      "FilmTitle": "La roue",
      "AlternateTitle": "",
      "TitleArray": [
        "La roue"
      ],
      "Year": "1923",
      "Director": "Abel Gance",
      "DirectorArray": [
        "Abel Gance"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1887",
      "databaseFilmTitle": "La signora di tutti",
      "FilmTitle": "La signora di tutti",
      "AlternateTitle": "",
      "TitleArray": [
        "La signora di tutti"
      ],
      "Year": "1934",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1888",
      "databaseFilmTitle": "La strada",
      "FilmTitle": "La strada",
      "AlternateTitle": "",
      "TitleArray": [
        "La strada"
      ],
      "Year": "1954",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1889",
      "databaseFilmTitle": "La Terra Trema",
      "FilmTitle": "La Terra Trema",
      "AlternateTitle": "",
      "TitleArray": [
        "La Terra Trema"
      ],
      "Year": "1948",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "9",
      "1962votes": "14",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1890",
      "databaseFilmTitle": "La vida perra de Juanita Narboni",
      "FilmTitle": "La vida perra de Juanita Narboni",
      "AlternateTitle": "",
      "TitleArray": [
        "La vida perra de Juanita Narboni"
      ],
      "Year": "2005",
      "Director": "Farida Belyazid",
      "DirectorArray": [
        "Farida Belyazid"
      ],
      "Country": "Morocco, Spain",
      "CountryArray": [
        "Morocco",
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1891",
      "databaseFilmTitle": "Labour Party General Election social media launch video",
      "FilmTitle": "Labour Party General Election social media launch video",
      "AlternateTitle": "https://twitter.com/i/status/1189276879292960768",
      "TitleArray": [
        "Labour Party General Election social media launch video",
        "https://twitter.com/i/status/1189276879292960768"
      ],
      "Year": "2019",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1892",
      "databaseFilmTitle": "Lacombe, Lucien",
      "FilmTitle": "Lacombe, Lucien",
      "AlternateTitle": "",
      "TitleArray": [
        "Lacombe, Lucien"
      ],
      "Year": "1974",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1893",
      "databaseFilmTitle": "Ladies Lake",
      "FilmTitle": "Ladies Lake",
      "AlternateTitle": "Lac aux dames",
      "TitleArray": [
        "Ladies Lake",
        "Lac aux dames"
      ],
      "Year": "1934",
      "Director": "Marc Allégret",
      "DirectorArray": [
        "Marc Allégret"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1894",
      "databaseFilmTitle": "Lady Bird",
      "FilmTitle": "Lady Bird",
      "AlternateTitle": "",
      "TitleArray": [
        "Lady Bird"
      ],
      "Year": "2017",
      "Director": "Greta Gerwig",
      "DirectorArray": [
        "Greta Gerwig"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1895",
      "databaseFilmTitle": "Lady Jane",
      "FilmTitle": "Lady Jane",
      "AlternateTitle": "",
      "TitleArray": [
        "Lady Jane"
      ],
      "Year": "2008",
      "Director": "Robert Guédiguian",
      "DirectorArray": [
        "Robert Guédiguian"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1896",
      "databaseFilmTitle": "Lady Killer",
      "FilmTitle": "Lady Killer",
      "AlternateTitle": "Guele d'amour",
      "TitleArray": [
        "Lady Killer",
        "Guele d'amour"
      ],
      "Year": "1937",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1897",
      "databaseFilmTitle": "Lady Lazarus",
      "FilmTitle": "Lady Lazarus",
      "AlternateTitle": "",
      "TitleArray": [
        "Lady Lazarus"
      ],
      "Year": "1991",
      "Director": "Sandra Lahire",
      "DirectorArray": [
        "Sandra Lahire"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1898",
      "databaseFilmTitle": "Lady of the Night",
      "FilmTitle": "Lady of the Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Lady of the Night"
      ],
      "Year": "1925",
      "Director": "Monta Bell",
      "DirectorArray": [
        "Monta Bell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1899",
      "databaseFilmTitle": "Lady Vengeance",
      "FilmTitle": "Lady Vengeance",
      "AlternateTitle": "Chinjeolhan geumjassi",
      "TitleArray": [
        "Lady Vengeance",
        "Chinjeolhan geumjassi"
      ],
      "Year": "2005",
      "Director": "Park Chan-wook",
      "DirectorArray": [
        "Park Chan-wook"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1900",
      "databaseFilmTitle": "Lady Windermere's Fan",
      "FilmTitle": "Lady Windermere's Fan",
      "AlternateTitle": "",
      "TitleArray": [
        "Lady Windermere's Fan"
      ],
      "Year": "1925",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1901",
      "databaseFilmTitle": "Lagareh - The Last Born",
      "FilmTitle": "Lagareh - The Last Born",
      "AlternateTitle": "",
      "TitleArray": [
        "Lagareh - The Last Born"
      ],
      "Year": "2022",
      "Director": "Alberta Whittle",
      "DirectorArray": [
        "Alberta Whittle"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1902",
      "databaseFilmTitle": "Lago Gatún",
      "FilmTitle": "Lago Gatún",
      "AlternateTitle": "",
      "TitleArray": [
        "Lago Gatún"
      ],
      "Year": "2021",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1903",
      "databaseFilmTitle": "Lamentations: A Monument to the Dead World, Part 1: The Dream of the Last Historian",
      "FilmTitle": "Lamentations: A Monument to the Dead World, Part 1: The Dream of the Last Historian",
      "AlternateTitle": "",
      "TitleArray": [
        "Lamentations: A Monument to the Dead World, Part 1: The Dream of the Last Historian"
      ],
      "Year": "1985",
      "Director": "R. Bruce Elder",
      "DirectorArray": [
        "R. Bruce Elder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1904",
      "databaseFilmTitle": "Lancelot du Lac",
      "FilmTitle": "Lancelot du Lac",
      "AlternateTitle": "",
      "TitleArray": [
        "Lancelot du Lac"
      ],
      "Year": "1974",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1905",
      "databaseFilmTitle": "Land and Freedom",
      "FilmTitle": "Land and Freedom",
      "AlternateTitle": "",
      "TitleArray": [
        "Land and Freedom"
      ],
      "Year": "1995",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom, Spain",
      "CountryArray": [
        "United Kingdom",
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1906",
      "databaseFilmTitle": "Land of Silence and Darkness",
      "FilmTitle": "Land of Silence and Darkness",
      "AlternateTitle": "Land des Schweigens und der Dunkelheit",
      "TitleArray": [
        "Land of Silence and Darkness",
        "Land des Schweigens und der Dunkelheit"
      ],
      "Year": "1971",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1907",
      "databaseFilmTitle": "Land Without Bread",
      "FilmTitle": "Land Without Bread",
      "AlternateTitle": "Las Hurdes: Tierra Sin Pan",
      "TitleArray": [
        "Land Without Bread",
        "Las Hurdes: Tierra Sin Pan"
      ],
      "Year": "1933",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1908",
      "databaseFilmTitle": "Land Without Evil",
      "FilmTitle": "Land Without Evil",
      "AlternateTitle": "La tierra sin mal",
      "TitleArray": [
        "Land Without Evil",
        "La tierra sin mal"
      ],
      "Year": "--",
      "Director": "Beatriz Palacios",
      "DirectorArray": [
        "Beatriz Palacios"
      ],
      "Country": "Bolivia",
      "CountryArray": [
        "Bolivia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1909",
      "databaseFilmTitle": "Landscape in the Mist",
      "FilmTitle": "Landscape in the Mist",
      "AlternateTitle": "Topio stin omichli",
      "TitleArray": [
        "Landscape in the Mist",
        "Topio stin omichli"
      ],
      "Year": "1988",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "1910",
      "databaseFilmTitle": "Landscape Suicide",
      "FilmTitle": "Landscape Suicide",
      "AlternateTitle": "",
      "TitleArray": [
        "Landscape Suicide"
      ],
      "Year": "1987",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1911",
      "databaseFilmTitle": "Language Lessons",
      "FilmTitle": "Language Lessons",
      "AlternateTitle": "",
      "TitleArray": [
        "Language Lessons"
      ],
      "Year": "2021",
      "Director": "Natalie Morales",
      "DirectorArray": [
        "Natalie Morales"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1912",
      "databaseFilmTitle": "Larks on a String",
      "FilmTitle": "Larks on a String",
      "AlternateTitle": "Skrivánci na niti",
      "TitleArray": [
        "Larks on a String",
        "Skrivánci na niti"
      ],
      "Year": "1969",
      "Director": "Jirí Menzel",
      "DirectorArray": [
        "Jirí Menzel"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1913",
      "databaseFilmTitle": "Last Diva",
      "FilmTitle": "Last Diva",
      "AlternateTitle": "Assunta Spina",
      "TitleArray": [
        "Last Diva",
        "Assunta Spina"
      ],
      "Year": "1915",
      "Director": "Francesca Bertini, Gustavo Serena",
      "DirectorArray": [
        "Francesca Bertini",
        "Gustavo Serena"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1914",
      "databaseFilmTitle": "Last Exit to Brooklyn",
      "FilmTitle": "Last Exit to Brooklyn",
      "AlternateTitle": "",
      "TitleArray": [
        "Last Exit to Brooklyn"
      ],
      "Year": "1989",
      "Director": "Uli Edel",
      "DirectorArray": [
        "Uli Edel"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1915",
      "databaseFilmTitle": "Last Night",
      "FilmTitle": "Last Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Last Night"
      ],
      "Year": "1998",
      "Director": "Don McKellar",
      "DirectorArray": [
        "Don McKellar"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1916",
      "databaseFilmTitle": "Last Tango in Paris",
      "FilmTitle": "Last Tango in Paris",
      "AlternateTitle": "Ultimo tango a Parigi",
      "TitleArray": [
        "Last Tango in Paris",
        "Ultimo tango a Parigi"
      ],
      "Year": "1972",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1917",
      "databaseFilmTitle": "Last Train Home",
      "FilmTitle": "Last Train Home",
      "AlternateTitle": "Gui tu lie che",
      "TitleArray": [
        "Last Train Home",
        "Gui tu lie che"
      ],
      "Year": "2009",
      "Director": "Lixin Fan",
      "DirectorArray": [
        "Lixin Fan"
      ],
      "Country": "Canada, China",
      "CountryArray": [
        "Canada",
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1918",
      "databaseFilmTitle": "Last Words",
      "FilmTitle": "Last Words",
      "AlternateTitle": "Letzte Worte",
      "TitleArray": [
        "Last Words",
        "Letzte Worte"
      ],
      "Year": "1968",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1919",
      "databaseFilmTitle": "Last Year at Marienbad",
      "FilmTitle": "Last Year at Marienbad",
      "AlternateTitle": "L'Année dernière à Marienbad",
      "TitleArray": [
        "Last Year at Marienbad",
        "L'Année dernière à Marienbad"
      ],
      "Year": "1961",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "1920",
      "databaseFilmTitle": "Late August, Early September",
      "FilmTitle": "Late August, Early September",
      "AlternateTitle": "Fin août, début septembre",
      "TitleArray": [
        "Late August, Early September",
        "Fin août, début septembre"
      ],
      "Year": "1998",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1921",
      "databaseFilmTitle": "Late Autumn",
      "FilmTitle": "Late Autumn",
      "AlternateTitle": "Akibiyori",
      "TitleArray": [
        "Late Autumn",
        "Akibiyori"
      ],
      "Year": "1960",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1922",
      "databaseFilmTitle": "Late Chrysanthemums",
      "FilmTitle": "Late Chrysanthemums",
      "AlternateTitle": "Bangiku",
      "TitleArray": [
        "Late Chrysanthemums",
        "Bangiku"
      ],
      "Year": "1954",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1923",
      "databaseFilmTitle": "Late Spring",
      "FilmTitle": "Late Spring",
      "AlternateTitle": "Banshun",
      "TitleArray": [
        "Late Spring",
        "Banshun"
      ],
      "Year": "1949",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "15",
      "2012votes": "50",
      "2022rank": "22",
      "2022votes": "70"
    },
    {
      "key": "1924",
      "databaseFilmTitle": "Latino Bar",
      "FilmTitle": "Latino Bar",
      "AlternateTitle": "",
      "TitleArray": [
        "Latino Bar"
      ],
      "Year": "1991",
      "Director": "Paul Leduc",
      "DirectorArray": [
        "Paul Leduc"
      ],
      "Country": "Venezuela, Cuba",
      "CountryArray": [
        "Venezuela",
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1925",
      "databaseFilmTitle": "Laughing Gas",
      "FilmTitle": "Laughing Gas",
      "AlternateTitle": "",
      "TitleArray": [
        "Laughing Gas"
      ],
      "Year": "1907",
      "Director": "Edwin S. Porter",
      "DirectorArray": [
        "Edwin S. Porter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1926",
      "databaseFilmTitle": "Launch",
      "FilmTitle": "Launch",
      "AlternateTitle": "",
      "TitleArray": [
        "Launch"
      ],
      "Year": "1974",
      "Director": "Murray Martin, Peter Roberts",
      "DirectorArray": [
        "Murray Martin",
        "Peter Roberts"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1927",
      "databaseFilmTitle": "Laura",
      "FilmTitle": "Laura",
      "AlternateTitle": "",
      "TitleArray": [
        "Laura"
      ],
      "Year": "1944",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1928",
      "databaseFilmTitle": "Law of Desire",
      "FilmTitle": "Law of Desire",
      "AlternateTitle": "La ley del deseo",
      "TitleArray": [
        "Law of Desire",
        "La ley del deseo"
      ],
      "Year": "1987",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1929",
      "databaseFilmTitle": "Lawrence of Arabia",
      "FilmTitle": "Lawrence of Arabia",
      "AlternateTitle": "",
      "TitleArray": [
        "Lawrence of Arabia"
      ],
      "Year": "1962",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "81",
      "2012votes": "20",
      "2022rank": "133",
      "2022votes": "22"
    },
    {
      "key": "1930",
      "databaseFilmTitle": "Lazybones",
      "FilmTitle": "Lazybones",
      "AlternateTitle": "",
      "TitleArray": [
        "Lazybones"
      ],
      "Year": "1925",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1931",
      "databaseFilmTitle": "Le amiche",
      "FilmTitle": "Le amiche",
      "AlternateTitle": "",
      "TitleArray": [
        "Le amiche"
      ],
      "Year": "1955",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1932",
      "databaseFilmTitle": "Le bonheur",
      "FilmTitle": "Le bonheur",
      "AlternateTitle": "",
      "TitleArray": [
        "Le bonheur"
      ],
      "Year": "1965",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "153",
      "2022votes": "19"
    },
    {
      "key": "1933",
      "databaseFilmTitle": "Le Corbeau",
      "FilmTitle": "Le Corbeau",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Corbeau"
      ],
      "Year": "1943",
      "Director": "Henri-Georges Clouzot",
      "DirectorArray": [
        "Henri-Georges Clouzot"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1934",
      "databaseFilmTitle": "Le coupable",
      "FilmTitle": "Le coupable",
      "AlternateTitle": "",
      "TitleArray": [
        "Le coupable"
      ],
      "Year": "1917",
      "Director": "André Antoine",
      "DirectorArray": [
        "André Antoine"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1935",
      "databaseFilmTitle": "Le doulos",
      "FilmTitle": "Le doulos",
      "AlternateTitle": "",
      "TitleArray": [
        "Le doulos"
      ],
      "Year": "1962",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1936",
      "databaseFilmTitle": "Le Film est déjà Commencé?",
      "FilmTitle": "Le Film est déjà Commencé?",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Film est déjà Commencé?"
      ],
      "Year": "1951",
      "Director": "Maurice Lemaître",
      "DirectorArray": [
        "Maurice Lemaître"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1937",
      "databaseFilmTitle": "Le garçu",
      "FilmTitle": "Le garçu",
      "AlternateTitle": "",
      "TitleArray": [
        "Le garçu"
      ],
      "Year": "1995",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1938",
      "databaseFilmTitle": "Le Havre",
      "FilmTitle": "Le Havre",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Havre"
      ],
      "Year": "2011",
      "Director": "Aki Kaurismäki",
      "DirectorArray": [
        "Aki Kaurismäki"
      ],
      "Country": "Finland, France",
      "CountryArray": [
        "Finland",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1939",
      "databaseFilmTitle": "Le joli mai",
      "FilmTitle": "Le joli mai",
      "AlternateTitle": "",
      "TitleArray": [
        "Le joli mai"
      ],
      "Year": "1963",
      "Director": "Chris Marker, Peirre Lhomme",
      "DirectorArray": [
        "Chris Marker",
        "Peirre Lhomme"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1940",
      "databaseFilmTitle": "Le jour se lève",
      "FilmTitle": "Le jour se lève",
      "AlternateTitle": "",
      "TitleArray": [
        "Le jour se lève"
      ],
      "Year": "1939",
      "Director": "Marcel Carné",
      "DirectorArray": [
        "Marcel Carné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "7",
      "1952votes": "11",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1941",
      "databaseFilmTitle": "Le million",
      "FilmTitle": "Le million",
      "AlternateTitle": "",
      "TitleArray": [
        "Le million"
      ],
      "Year": "1931",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "10",
      "1952votes": "10",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1942",
      "databaseFilmTitle": "Le navire Night",
      "FilmTitle": "Le navire Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Le navire Night"
      ],
      "Year": "1979",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1943",
      "databaseFilmTitle": "Le plaisir",
      "FilmTitle": "Le plaisir",
      "AlternateTitle": "",
      "TitleArray": [
        "Le plaisir"
      ],
      "Year": "1952",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1944",
      "databaseFilmTitle": "Le Pont du Nord",
      "FilmTitle": "Le Pont du Nord",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Pont du Nord"
      ],
      "Year": "1981",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "1945",
      "databaseFilmTitle": "Le samouraï",
      "FilmTitle": "Le samouraï",
      "AlternateTitle": "",
      "TitleArray": [
        "Le samouraï"
      ],
      "Year": "1967",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "1946",
      "databaseFilmTitle": "Le Schpountz",
      "FilmTitle": "Le Schpountz",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Schpountz"
      ],
      "Year": "1999",
      "Director": "Gérard Oury",
      "DirectorArray": [
        "Gérard Oury"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1947",
      "databaseFilmTitle": "Le théâtre des matières",
      "FilmTitle": "Le théâtre des matières",
      "AlternateTitle": "",
      "TitleArray": [
        "Le théâtre des matières"
      ],
      "Year": "1977",
      "Director": "Jean-Claude Biette",
      "DirectorArray": [
        "Jean-Claude Biette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1948",
      "databaseFilmTitle": "Le Tonnelier",
      "FilmTitle": "Le Tonnelier",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Tonnelier"
      ],
      "Year": "1942",
      "Director": "Georges Rouquier",
      "DirectorArray": [
        "Georges Rouquier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1949",
      "databaseFilmTitle": "Le trou",
      "FilmTitle": "Le trou",
      "AlternateTitle": "",
      "TitleArray": [
        "Le trou"
      ],
      "Year": "1960",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1950",
      "databaseFilmTitle": "Le vampire",
      "FilmTitle": "Le vampire",
      "AlternateTitle": "",
      "TitleArray": [
        "Le vampire"
      ],
      "Year": "1945",
      "Director": "Jean Painlevé",
      "DirectorArray": [
        "Jean Painlevé"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1951",
      "databaseFilmTitle": "Le Village de Namo",
      "FilmTitle": "Le Village de Namo",
      "AlternateTitle": "",
      "TitleArray": [
        "Le Village de Namo"
      ],
      "Year": "1900",
      "Director": "Gabriel Veyre",
      "DirectorArray": [
        "Gabriel Veyre"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1952",
      "databaseFilmTitle": "Lea and the bobbin",
      "FilmTitle": "Lea and the bobbin",
      "AlternateTitle": "Lea e il gomitolo",
      "TitleArray": [
        "Lea and the bobbin",
        "Lea e il gomitolo"
      ],
      "Year": "1913",
      "Director": "Anonymous",
      "DirectorArray": [
        "Anonymous"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1953",
      "databaseFilmTitle": "Learned Tamil",
      "FilmTitle": "Learned Tamil",
      "AlternateTitle": "Kattradhu Thamizh",
      "TitleArray": [
        "Learned Tamil",
        "Kattradhu Thamizh"
      ],
      "Year": "2007",
      "Director": "Ram",
      "DirectorArray": [
        "Ram"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1954",
      "databaseFilmTitle": "Leave Her to Heaven",
      "FilmTitle": "Leave Her to Heaven",
      "AlternateTitle": "",
      "TitleArray": [
        "Leave Her to Heaven"
      ],
      "Year": "1945",
      "Director": "John M. Stahl",
      "DirectorArray": [
        "John M. Stahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1955",
      "databaseFilmTitle": "Leave No Trace",
      "FilmTitle": "Leave No Trace",
      "AlternateTitle": "",
      "TitleArray": [
        "Leave No Trace"
      ],
      "Year": "2018",
      "Director": "Debra Grankik",
      "DirectorArray": [
        "Debra Grankik"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1956",
      "databaseFilmTitle": "Legacy",
      "FilmTitle": "Legacy",
      "AlternateTitle": "Zaveštanje",
      "TitleArray": [
        "Legacy",
        "Zaveštanje"
      ],
      "Year": "2016",
      "Director": "Ivan Jovic",
      "DirectorArray": [
        "Ivan Jovic"
      ],
      "Country": "Serbia",
      "CountryArray": [
        "Serbia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1957",
      "databaseFilmTitle": "Leila and the Wolves",
      "FilmTitle": "Leila and the Wolves",
      "AlternateTitle": "Leila wal al ziap",
      "TitleArray": [
        "Leila and the Wolves",
        "Leila wal al ziap"
      ],
      "Year": "1984",
      "Director": "Heiny Srour",
      "DirectorArray": [
        "Heiny Srour"
      ],
      "Country": "Lebanon, Palestine",
      "CountryArray": [
        "Lebanon",
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1958",
      "databaseFilmTitle": "Lemon",
      "FilmTitle": "Lemon",
      "AlternateTitle": "",
      "TitleArray": [
        "Lemon"
      ],
      "Year": "1969",
      "Director": "Hollis Frampton",
      "DirectorArray": [
        "Hollis Frampton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1959",
      "databaseFilmTitle": "Lemonade",
      "FilmTitle": "Lemonade",
      "AlternateTitle": "",
      "TitleArray": [
        "Lemonade"
      ],
      "Year": "2016",
      "Director": "Beyoncé Knowles-Carter, Kahlil Joseph, Melina Matsoukas, Dikayl Rimmasch, Mark Romanek, Todd Tourso, Jonas Akerlund",
      "DirectorArray": [
        "Beyoncé Knowles-Carter",
        "Kahlil Joseph",
        "Melina Matsoukas",
        "Dikayl Rimmasch",
        "Mark Romanek",
        "Todd Tourso",
        "Jonas Akerlund"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1960",
      "databaseFilmTitle": "Léon G. Damas",
      "FilmTitle": "Léon G. Damas",
      "AlternateTitle": "",
      "TitleArray": [
        "Léon G. Damas"
      ],
      "Year": "1994",
      "Director": "Sarah Maldoror",
      "DirectorArray": [
        "Sarah Maldoror"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1961",
      "databaseFilmTitle": "Léon Morin, Priest",
      "FilmTitle": "Léon Morin, Priest",
      "AlternateTitle": "Léon Morin, prêtre",
      "TitleArray": [
        "Léon Morin, Priest",
        "Léon Morin, prêtre"
      ],
      "Year": "1961",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1962",
      "databaseFilmTitle": "Léon: The Professional",
      "FilmTitle": "Léon: The Professional",
      "AlternateTitle": "Léon",
      "TitleArray": [
        "Léon: The Professional",
        "Léon"
      ],
      "Year": "1994",
      "Director": "Luc Besson",
      "DirectorArray": [
        "Luc Besson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1963",
      "databaseFilmTitle": "Léontine s'envole",
      "FilmTitle": "Léontine s'envole",
      "AlternateTitle": "",
      "TitleArray": [
        "Léontine s'envole"
      ],
      "Year": "1911",
      "Director": "(unknown)",
      "DirectorArray": [
        "(unknown)"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1964",
      "databaseFilmTitle": "Les bonnes femmes",
      "FilmTitle": "Les bonnes femmes",
      "AlternateTitle": "",
      "TitleArray": [
        "Les bonnes femmes"
      ],
      "Year": "1960",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1965",
      "databaseFilmTitle": "Les dames du Bois de Boulogne",
      "FilmTitle": "Les dames du Bois de Boulogne",
      "AlternateTitle": "",
      "TitleArray": [
        "Les dames du Bois de Boulogne"
      ],
      "Year": "1945",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "21",
      "1952votes": "6",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1966",
      "databaseFilmTitle": "Les Enfants Terribles",
      "FilmTitle": "Les Enfants Terribles",
      "AlternateTitle": "",
      "TitleArray": [
        "Les Enfants Terribles"
      ],
      "Year": "1950",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1967",
      "databaseFilmTitle": "Les hautes solitudes",
      "FilmTitle": "Les hautes solitudes",
      "AlternateTitle": "",
      "TitleArray": [
        "Les hautes solitudes"
      ],
      "Year": "1974",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1968",
      "databaseFilmTitle": "Les misérables",
      "FilmTitle": "Les misérables",
      "AlternateTitle": "",
      "TitleArray": [
        "Les misérables"
      ],
      "Year": "1912",
      "Director": "Albert Capellani",
      "DirectorArray": [
        "Albert Capellani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1969",
      "databaseFilmTitle": "Les travailleurs de la mer",
      "FilmTitle": "Les travailleurs de la mer",
      "AlternateTitle": "",
      "TitleArray": [
        "Les travailleurs de la mer"
      ],
      "Year": "1918",
      "Director": "André Antoine, Léonard Antoine",
      "DirectorArray": [
        "André Antoine",
        "Léonard Antoine"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1970",
      "databaseFilmTitle": "Les tricheurs",
      "FilmTitle": "Les tricheurs",
      "AlternateTitle": "",
      "TitleArray": [
        "Les tricheurs"
      ],
      "Year": "2022",
      "Director": "Louis Godbout",
      "DirectorArray": [
        "Louis Godbout"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1971",
      "databaseFilmTitle": "Les uns et les autres",
      "FilmTitle": "Les uns et les autres",
      "AlternateTitle": "",
      "TitleArray": [
        "Les uns et les autres"
      ],
      "Year": "1981",
      "Director": "Claude Lelouch",
      "DirectorArray": [
        "Claude Lelouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1972",
      "databaseFilmTitle": "Les vampires",
      "FilmTitle": "Les vampires",
      "AlternateTitle": "",
      "TitleArray": [
        "Les vampires"
      ],
      "Year": "1915",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "1973",
      "databaseFilmTitle": "Lessons from the Garbage",
      "FilmTitle": "Lessons from the Garbage",
      "AlternateTitle": "Nyamanton",
      "TitleArray": [
        "Lessons from the Garbage",
        "Nyamanton"
      ],
      "Year": "1986",
      "Director": "Cheick Oumar Sissoko",
      "DirectorArray": [
        "Cheick Oumar Sissoko"
      ],
      "Country": "Mali",
      "CountryArray": [
        "Mali"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1974",
      "databaseFilmTitle": "Lessons of Darkness",
      "FilmTitle": "Lessons of Darkness",
      "AlternateTitle": "Lektionen in Finsternis",
      "TitleArray": [
        "Lessons of Darkness",
        "Lektionen in Finsternis"
      ],
      "Year": "1992",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1975",
      "databaseFilmTitle": "Let Me Die a Woman",
      "FilmTitle": "Let Me Die a Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Let Me Die a Woman"
      ],
      "Year": "1977",
      "Director": "Doris Wishman",
      "DirectorArray": [
        "Doris Wishman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1976",
      "databaseFilmTitle": "Let the Bullets Fly",
      "FilmTitle": "Let the Bullets Fly",
      "AlternateTitle": "",
      "TitleArray": [
        "Let the Bullets Fly"
      ],
      "Year": "2010",
      "Director": "Jiang Wen",
      "DirectorArray": [
        "Jiang Wen"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1977",
      "databaseFilmTitle": "Let There Be City!",
      "FilmTitle": "Let There Be City!",
      "AlternateTitle": "Es werde Stadt! 50 Jahre Grimme-Preis in Marl",
      "TitleArray": [
        "Let There Be City!",
        "Es werde Stadt! 50 Jahre Grimme-Preis in Marl"
      ],
      "Year": "2014",
      "Director": "Dominik Graf, Martin Farkas",
      "DirectorArray": [
        "Dominik Graf",
        "Martin Farkas"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1978",
      "databaseFilmTitle": "Let Your Light Shine",
      "FilmTitle": "Let Your Light Shine",
      "AlternateTitle": "",
      "TitleArray": [
        "Let Your Light Shine"
      ],
      "Year": "2013",
      "Director": "Jodie Mack",
      "DirectorArray": [
        "Jodie Mack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1979",
      "databaseFilmTitle": "Let's Get Lost",
      "FilmTitle": "Let's Get Lost",
      "AlternateTitle": "",
      "TitleArray": [
        "Let's Get Lost"
      ],
      "Year": "1988",
      "Director": "Bruce Weber",
      "DirectorArray": [
        "Bruce Weber"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1980",
      "databaseFilmTitle": "Let's Go with Pancho Villa",
      "FilmTitle": "Let's Go with Pancho Villa",
      "AlternateTitle": "¡Vámonos con Pancho Villa!",
      "TitleArray": [
        "Let's Go with Pancho Villa",
        "¡Vámonos con Pancho Villa!"
      ],
      "Year": "1936",
      "Director": "Fernando de Fuentes",
      "DirectorArray": [
        "Fernando de Fuentes"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1981",
      "databaseFilmTitle": "Let's Scare Jessica to Death",
      "FilmTitle": "Let's Scare Jessica to Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Let's Scare Jessica to Death"
      ],
      "Year": "1971",
      "Director": "John D. Hancock",
      "DirectorArray": [
        "John D. Hancock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1982",
      "databaseFilmTitle": "Leto",
      "FilmTitle": "Leto",
      "AlternateTitle": "",
      "TitleArray": [
        "Leto"
      ],
      "Year": "2018",
      "Director": "Kirill Serebrennikov",
      "DirectorArray": [
        "Kirill Serebrennikov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1983",
      "databaseFilmTitle": "Letter from an Unknown Woman",
      "FilmTitle": "Letter from an Unknown Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Letter from an Unknown Woman"
      ],
      "Year": "1948",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "1984",
      "databaseFilmTitle": "Letter from My Village",
      "FilmTitle": "Letter from My Village",
      "AlternateTitle": "Kaddu Beykat",
      "TitleArray": [
        "Letter from My Village",
        "Kaddu Beykat"
      ],
      "Year": "1976",
      "Director": "Safi Faye",
      "DirectorArray": [
        "Safi Faye"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1985",
      "databaseFilmTitle": "Letter from Siberia",
      "FilmTitle": "Letter from Siberia",
      "AlternateTitle": "Lettre de Sibérie",
      "TitleArray": [
        "Letter from Siberia",
        "Lettre de Sibérie"
      ],
      "Year": "1958",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1986",
      "databaseFilmTitle": "Letter of Introduction",
      "FilmTitle": "Letter of Introduction",
      "AlternateTitle": "",
      "TitleArray": [
        "Letter of Introduction"
      ],
      "Year": "1938",
      "Director": "John M. Stahl",
      "DirectorArray": [
        "John M. Stahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "1987",
      "databaseFilmTitle": "letter to a friend",
      "FilmTitle": "letter to a friend",
      "AlternateTitle": "",
      "TitleArray": [
        "letter to a friend"
      ],
      "Year": "2019",
      "Director": "Emily Jacir",
      "DirectorArray": [
        "Emily Jacir"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1988",
      "databaseFilmTitle": "Letters from Iwo Jima",
      "FilmTitle": "Letters from Iwo Jima",
      "AlternateTitle": "",
      "TitleArray": [
        "Letters from Iwo Jima"
      ],
      "Year": "2006",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1989",
      "databaseFilmTitle": "Letters from Panduranga",
      "FilmTitle": "Letters from Panduranga",
      "AlternateTitle": "",
      "TitleArray": [
        "Letters from Panduranga"
      ],
      "Year": "2015",
      "Director": "Thi Trinh Nguyen",
      "DirectorArray": [
        "Thi Trinh Nguyen"
      ],
      "Country": "Vietnam",
      "CountryArray": [
        "Vietnam"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1990",
      "databaseFilmTitle": "Leviathan",
      "FilmTitle": "Leviathan",
      "AlternateTitle": "",
      "TitleArray": [
        "Leviathan"
      ],
      "Year": "2012",
      "Director": "Lucien Castaing-Taylor, Véréna Paravel",
      "DirectorArray": [
        "Lucien Castaing-Taylor",
        "Véréna Paravel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "1991",
      "databaseFilmTitle": "Li per li",
      "FilmTitle": "Li per li",
      "AlternateTitle": "",
      "TitleArray": [
        "Li per li"
      ],
      "Year": "1994",
      "Director": "Pierre Léon",
      "DirectorArray": [
        "Pierre Léon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1992",
      "databaseFilmTitle": "Libera Me",
      "FilmTitle": "Libera Me",
      "AlternateTitle": "",
      "TitleArray": [
        "Libera Me"
      ],
      "Year": "1993",
      "Director": "Alain Cavalier",
      "DirectorArray": [
        "Alain Cavalier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1993",
      "databaseFilmTitle": "Liberté, la nuit",
      "FilmTitle": "Liberté, la nuit",
      "AlternateTitle": "",
      "TitleArray": [
        "Liberté, la nuit"
      ],
      "Year": "1983",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1994",
      "databaseFilmTitle": "Liberty",
      "FilmTitle": "Liberty",
      "AlternateTitle": "",
      "TitleArray": [
        "Liberty"
      ],
      "Year": "1929",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1995",
      "databaseFilmTitle": "Lichtspiel: Opus 1",
      "FilmTitle": "Lichtspiel: Opus 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Lichtspiel: Opus 1"
      ],
      "Year": "1921",
      "Director": "Walter Ruttmann",
      "DirectorArray": [
        "Walter Ruttmann"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1996",
      "databaseFilmTitle": "Liebelei",
      "FilmTitle": "Liebelei",
      "AlternateTitle": "",
      "TitleArray": [
        "Liebelei"
      ],
      "Year": "1933",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1997",
      "databaseFilmTitle": "Life and Nothing But",
      "FilmTitle": "Life and Nothing But",
      "AlternateTitle": "La vie et rien d'autre",
      "TitleArray": [
        "Life and Nothing But",
        "La vie et rien d'autre"
      ],
      "Year": "1989",
      "Director": "Bertrand Tavernier",
      "DirectorArray": [
        "Bertrand Tavernier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "1998",
      "databaseFilmTitle": "Life and Nothing More",
      "FilmTitle": "Life and Nothing More",
      "AlternateTitle": "La vida y nada más",
      "TitleArray": [
        "Life and Nothing More",
        "La vida y nada más"
      ],
      "Year": "2017",
      "Director": "Antonio Mendez Esparza",
      "DirectorArray": [
        "Antonio Mendez Esparza"
      ],
      "Country": "Spain, United States",
      "CountryArray": [
        "Spain",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "1999",
      "databaseFilmTitle": "Life Classes",
      "FilmTitle": "Life Classes",
      "AlternateTitle": "",
      "TitleArray": [
        "Life Classes"
      ],
      "Year": "1988",
      "Director": "William D. MacGillivray",
      "DirectorArray": [
        "William D. MacGillivray"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2000",
      "databaseFilmTitle": "Life Dances On",
      "FilmTitle": "Life Dances On",
      "AlternateTitle": "Un carnet de bal",
      "TitleArray": [
        "Life Dances On",
        "Un carnet de bal"
      ],
      "Year": "1937",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2001",
      "databaseFilmTitle": "Life in Shadows",
      "FilmTitle": "Life in Shadows",
      "AlternateTitle": "Vida en sombras",
      "TitleArray": [
        "Life in Shadows",
        "Vida en sombras"
      ],
      "Year": "1949",
      "Director": "Lorenzo Llobet Gracia",
      "DirectorArray": [
        "Lorenzo Llobet Gracia"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2002",
      "databaseFilmTitle": "Life on Earth",
      "FilmTitle": "Life on Earth",
      "AlternateTitle": "La vie sue terre",
      "TitleArray": [
        "Life on Earth",
        "La vie sue terre"
      ],
      "Year": "1998",
      "Director": "Abderrahmane Sissako",
      "DirectorArray": [
        "Abderrahmane Sissako"
      ],
      "Country": "Mali",
      "CountryArray": [
        "Mali"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2003",
      "databaseFilmTitle": "Life/Expectancy",
      "FilmTitle": "Life/Expectancy",
      "AlternateTitle": "",
      "TitleArray": [
        "Life/Expectancy"
      ],
      "Year": "1999",
      "Director": "Shellie Fleming",
      "DirectorArray": [
        "Shellie Fleming"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2004",
      "databaseFilmTitle": "Light Cavalry Girl",
      "FilmTitle": "Light Cavalry Girl",
      "AlternateTitle": "Qīngqí gūniáng",
      "TitleArray": [
        "Light Cavalry Girl",
        "Qīngqí gūniáng"
      ],
      "Year": "1980",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2005",
      "databaseFilmTitle": "Light Music",
      "FilmTitle": "Light Music",
      "AlternateTitle": "",
      "TitleArray": [
        "Light Music"
      ],
      "Year": "1975",
      "Director": "Lis Rhodes",
      "DirectorArray": [
        "Lis Rhodes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2006",
      "databaseFilmTitle": "Light Reading",
      "FilmTitle": "Light Reading",
      "AlternateTitle": "",
      "TitleArray": [
        "Light Reading"
      ],
      "Year": "1978",
      "Director": "Lis Rhodes",
      "DirectorArray": [
        "Lis Rhodes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2007",
      "databaseFilmTitle": "Light Sleeper",
      "FilmTitle": "Light Sleeper",
      "AlternateTitle": "",
      "TitleArray": [
        "Light Sleeper"
      ],
      "Year": "1992",
      "Director": "Paul Schrader",
      "DirectorArray": [
        "Paul Schrader"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2008",
      "databaseFilmTitle": "Lightning",
      "FilmTitle": "Lightning",
      "AlternateTitle": "Inazuma",
      "TitleArray": [
        "Lightning",
        "Inazuma"
      ],
      "Year": "1952",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2009",
      "databaseFilmTitle": "Like Grains of Sand",
      "FilmTitle": "Like Grains of Sand",
      "AlternateTitle": "Nagisa no Shindobaddo",
      "TitleArray": [
        "Like Grains of Sand",
        "Nagisa no Shindobaddo"
      ],
      "Year": "1995",
      "Director": "Ryosuke Hashiguchi",
      "DirectorArray": [
        "Ryosuke Hashiguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2010",
      "databaseFilmTitle": "Like You Know It All",
      "FilmTitle": "Like You Know It All",
      "AlternateTitle": "Jal al-ji-do mot-ha-myeon-seo",
      "TitleArray": [
        "Like You Know It All",
        "Jal al-ji-do mot-ha-myeon-seo"
      ],
      "Year": "2009",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2011",
      "databaseFilmTitle": "Lilith",
      "FilmTitle": "Lilith",
      "AlternateTitle": "",
      "TitleArray": [
        "Lilith"
      ],
      "Year": "1964",
      "Director": "Robert Rossen",
      "DirectorArray": [
        "Robert Rossen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2012",
      "databaseFilmTitle": "Lilo & Stitch",
      "FilmTitle": "Lilo & Stitch",
      "AlternateTitle": "",
      "TitleArray": [
        "Lilo & Stitch"
      ],
      "Year": "2002",
      "Director": "Chris Sanders, Dean DeBlois",
      "DirectorArray": [
        "Chris Sanders",
        "Dean DeBlois"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2013",
      "databaseFilmTitle": "Lilya 4-ever",
      "FilmTitle": "Lilya 4-ever",
      "AlternateTitle": "Lilja 4-ever",
      "TitleArray": [
        "Lilya 4-ever",
        "Lilja 4-ever"
      ],
      "Year": "2002",
      "Director": "Lukas Moodysson",
      "DirectorArray": [
        "Lukas Moodysson"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2014",
      "databaseFilmTitle": "Limelight",
      "FilmTitle": "Limelight",
      "AlternateTitle": "",
      "TitleArray": [
        "Limelight"
      ],
      "Year": "1952",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2015",
      "databaseFilmTitle": "Limit",
      "FilmTitle": "Limit",
      "AlternateTitle": "Limite",
      "TitleArray": [
        "Limit",
        "Limite"
      ],
      "Year": "1931",
      "Director": "Mário Peixoto",
      "DirectorArray": [
        "Mário Peixoto"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "2016",
      "databaseFilmTitle": "Linda Linda Linda",
      "FilmTitle": "Linda Linda Linda",
      "AlternateTitle": "",
      "TitleArray": [
        "Linda Linda Linda"
      ],
      "Year": "2005",
      "Director": "Yamashita Nobuhiro",
      "DirectorArray": [
        "Yamashita Nobuhiro"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2017",
      "databaseFilmTitle": "Line Describing a Cone",
      "FilmTitle": "Line Describing a Cone",
      "AlternateTitle": "",
      "TitleArray": [
        "Line Describing a Cone"
      ],
      "Year": "1973",
      "Director": "Anthony McCall",
      "DirectorArray": [
        "Anthony McCall"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2018",
      "databaseFilmTitle": "Line Describing a Cone 2.0",
      "FilmTitle": "Line Describing a Cone 2.0",
      "AlternateTitle": "",
      "TitleArray": [
        "Line Describing a Cone 2.0"
      ],
      "Year": "2011",
      "Director": "Anthony McCall",
      "DirectorArray": [
        "Anthony McCall"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2019",
      "databaseFilmTitle": "Line of Destiny",
      "FilmTitle": "Line of Destiny",
      "AlternateTitle": "Rekava",
      "TitleArray": [
        "Line of Destiny",
        "Rekava"
      ],
      "Year": "1956",
      "Director": "Lester James Peries",
      "DirectorArray": [
        "Lester James Peries"
      ],
      "Country": "Sri Lanka",
      "CountryArray": [
        "Sri Lanka"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2020",
      "databaseFilmTitle": "Lingua franca",
      "FilmTitle": "Lingua franca",
      "AlternateTitle": "",
      "TitleArray": [
        "Lingua franca"
      ],
      "Year": "2019",
      "Director": "Isabel Sandoval",
      "DirectorArray": [
        "Isabel Sandoval"
      ],
      "Country": "United States, Philippines",
      "CountryArray": [
        "United States",
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2021",
      "databaseFilmTitle": "Liquid Sky",
      "FilmTitle": "Liquid Sky",
      "AlternateTitle": "",
      "TitleArray": [
        "Liquid Sky"
      ],
      "Year": "1982",
      "Director": "Slava Tsukerman",
      "DirectorArray": [
        "Slava Tsukerman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2022",
      "databaseFilmTitle": "Listen to Britain",
      "FilmTitle": "Listen to Britain",
      "AlternateTitle": "",
      "TitleArray": [
        "Listen to Britain"
      ],
      "Year": "1942",
      "Director": "Humphrey Jennings, Stewart McAllister",
      "DirectorArray": [
        "Humphrey Jennings",
        "Stewart McAllister"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2023",
      "databaseFilmTitle": "Little by Little",
      "FilmTitle": "Little by Little",
      "AlternateTitle": "Petit à petit",
      "TitleArray": [
        "Little by Little",
        "Petit à petit"
      ],
      "Year": "1970",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "France, Niger",
      "CountryArray": [
        "France",
        "Niger"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2024",
      "databaseFilmTitle": "Little Fugitive",
      "FilmTitle": "Little Fugitive",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Fugitive"
      ],
      "Year": "1953",
      "Director": "Morris Engel, Ray Ashley, Ruth Orkin",
      "DirectorArray": [
        "Morris Engel",
        "Ray Ashley",
        "Ruth Orkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2025",
      "databaseFilmTitle": "Little Indi",
      "FilmTitle": "Little Indi",
      "AlternateTitle": "Petit Indi",
      "TitleArray": [
        "Little Indi",
        "Petit Indi"
      ],
      "Year": "2009",
      "Director": "Marc Recha",
      "DirectorArray": [
        "Marc Recha"
      ],
      "Country": "Spain, France",
      "CountryArray": [
        "Spain",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2026",
      "databaseFilmTitle": "Little Miss Sunshine",
      "FilmTitle": "Little Miss Sunshine",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Miss Sunshine"
      ],
      "Year": "2006",
      "Director": "Jonathan Dayton, Valerie Faris",
      "DirectorArray": [
        "Jonathan Dayton",
        "Valerie Faris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2027",
      "databaseFilmTitle": "Little Odessa",
      "FilmTitle": "Little Odessa",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Odessa"
      ],
      "Year": "1994",
      "Director": "James Gray",
      "DirectorArray": [
        "James Gray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2028",
      "databaseFilmTitle": "Little Shop of Horrors",
      "FilmTitle": "Little Shop of Horrors",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Shop of Horrors"
      ],
      "Year": "1986",
      "Director": "Frank Oz",
      "DirectorArray": [
        "Frank Oz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2029",
      "databaseFilmTitle": "Little Stabs at Happiness",
      "FilmTitle": "Little Stabs at Happiness",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Stabs at Happiness"
      ],
      "Year": "1963",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2030",
      "databaseFilmTitle": "Little Wars",
      "FilmTitle": "Little Wars",
      "AlternateTitle": "Les petites guerres",
      "TitleArray": [
        "Little Wars",
        "Les petites guerres"
      ],
      "Year": "1982",
      "Director": "Maroun Bagdadi",
      "DirectorArray": [
        "Maroun Bagdadi"
      ],
      "Country": "Lebanon",
      "CountryArray": [
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2031",
      "databaseFilmTitle": "Little White Dove",
      "FilmTitle": "Little White Dove",
      "AlternateTitle": "Palomita blanca",
      "TitleArray": [
        "Little White Dove",
        "Palomita blanca"
      ],
      "Year": "1973",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2032",
      "databaseFilmTitle": "Little Women",
      "FilmTitle": "Little Women",
      "AlternateTitle": "",
      "TitleArray": [
        "Little Women"
      ],
      "Year": "2019",
      "Director": "Greta Gerwig",
      "DirectorArray": [
        "Greta Gerwig"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2033",
      "databaseFilmTitle": "Liu Pi-Chia",
      "FilmTitle": "Liu Pi-Chia",
      "AlternateTitle": "",
      "TitleArray": [
        "Liu Pi-Chia"
      ],
      "Year": "1967",
      "Director": "Chen Yao-Chi",
      "DirectorArray": [
        "Chen Yao-Chi"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2034",
      "databaseFilmTitle": "Lives of Performers",
      "FilmTitle": "Lives of Performers",
      "AlternateTitle": "",
      "TitleArray": [
        "Lives of Performers"
      ],
      "Year": "1972",
      "Director": "Yvonne Rainer",
      "DirectorArray": [
        "Yvonne Rainer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2035",
      "databaseFilmTitle": "Living in Seville",
      "FilmTitle": "Living in Seville",
      "AlternateTitle": "Vivir en Sevilla",
      "TitleArray": [
        "Living in Seville",
        "Vivir en Sevilla"
      ],
      "Year": "1978",
      "Director": "Gonzalo García Pelayo",
      "DirectorArray": [
        "Gonzalo García Pelayo"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2036",
      "databaseFilmTitle": "Living on the Edge",
      "FilmTitle": "Living on the Edge",
      "AlternateTitle": "",
      "TitleArray": [
        "Living on the Edge"
      ],
      "Year": "1987",
      "Director": "Michael Grigsby",
      "DirectorArray": [
        "Michael Grigsby"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2037",
      "databaseFilmTitle": "Llacquiy Huata",
      "FilmTitle": "Llacquiy Huata",
      "AlternateTitle": "",
      "TitleArray": [
        "Llacquiy Huata"
      ],
      "Year": "1983",
      "Director": "Magdaleno Nina",
      "DirectorArray": [
        "Magdaleno Nina"
      ],
      "Country": "Bolivia",
      "CountryArray": [
        "Bolivia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2038",
      "databaseFilmTitle": "Local Color",
      "FilmTitle": "Local Color",
      "AlternateTitle": "",
      "TitleArray": [
        "Local Color"
      ],
      "Year": "1977",
      "Director": "Mark Rappaport",
      "DirectorArray": [
        "Mark Rappaport"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2039",
      "databaseFilmTitle": "Local Hero",
      "FilmTitle": "Local Hero",
      "AlternateTitle": "",
      "TitleArray": [
        "Local Hero"
      ],
      "Year": "1983",
      "Director": "Bill Forsyth",
      "DirectorArray": [
        "Bill Forsyth"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2040",
      "databaseFilmTitle": "Local Legends",
      "FilmTitle": "Local Legends",
      "AlternateTitle": "",
      "TitleArray": [
        "Local Legends"
      ],
      "Year": "2013",
      "Director": "Matt Farley",
      "DirectorArray": [
        "Matt Farley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2041",
      "databaseFilmTitle": "Lock, Stock and Two Smoking Barrels",
      "FilmTitle": "Lock, Stock and Two Smoking Barrels",
      "AlternateTitle": "",
      "TitleArray": [
        "Lock, Stock and Two Smoking Barrels"
      ],
      "Year": "1998",
      "Director": "Guy Ritchie",
      "DirectorArray": [
        "Guy Ritchie"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2042",
      "databaseFilmTitle": "Logan's Run",
      "FilmTitle": "Logan's Run",
      "AlternateTitle": "",
      "TitleArray": [
        "Logan's Run"
      ],
      "Year": "1976",
      "Director": "Michael Anderson",
      "DirectorArray": [
        "Michael Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2043",
      "databaseFilmTitle": "Lola",
      "FilmTitle": "Lola",
      "AlternateTitle": "",
      "TitleArray": [
        "Lola"
      ],
      "Year": "1961",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2044",
      "databaseFilmTitle": "Lola Montès",
      "FilmTitle": "Lola Montès",
      "AlternateTitle": "",
      "TitleArray": [
        "Lola Montès"
      ],
      "Year": "1955",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2045",
      "databaseFilmTitle": "Lolita",
      "FilmTitle": "Lolita",
      "AlternateTitle": "",
      "TitleArray": [
        "Lolita"
      ],
      "Year": "1962",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2046",
      "databaseFilmTitle": "London",
      "FilmTitle": "London",
      "AlternateTitle": "",
      "TitleArray": [
        "London"
      ],
      "Year": "1994",
      "Director": "Patrick Keiller",
      "DirectorArray": [
        "Patrick Keiller"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2047",
      "databaseFilmTitle": "Lone Star",
      "FilmTitle": "Lone Star",
      "AlternateTitle": "",
      "TitleArray": [
        "Lone Star"
      ],
      "Year": "1996",
      "Director": "John Sayles",
      "DirectorArray": [
        "John Sayles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2048",
      "databaseFilmTitle": "Lonely Are the Brave",
      "FilmTitle": "Lonely Are the Brave",
      "AlternateTitle": "",
      "TitleArray": [
        "Lonely Are the Brave"
      ],
      "Year": "1962",
      "Director": "David Miller",
      "DirectorArray": [
        "David Miller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2049",
      "databaseFilmTitle": "Lonesome",
      "FilmTitle": "Lonesome",
      "AlternateTitle": "",
      "TitleArray": [
        "Lonesome"
      ],
      "Year": "1928",
      "Director": "Pál Fejös",
      "DirectorArray": [
        "Pál Fejös"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2050",
      "databaseFilmTitle": "Long Day's Journey Into Night (2018)",
      "FilmTitle": "Long Day's Journey Into Night",
      "AlternateTitle": "Di qiu zui hou de ye wan",
      "TitleArray": [
        "Long Day's Journey Into Night",
        "Di qiu zui hou de ye wan"
      ],
      "Year": "2018",
      "Director": "Bi Gan",
      "DirectorArray": [
        "Bi Gan"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2051",
      "databaseFilmTitle": "Long Film for Ambient Light",
      "FilmTitle": "Long Film for Ambient Light",
      "AlternateTitle": "",
      "TitleArray": [
        "Long Film for Ambient Light"
      ],
      "Year": "1975",
      "Director": "Anthony McCall",
      "DirectorArray": [
        "Anthony McCall"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2052",
      "databaseFilmTitle": "Long Live the Hobos!",
      "FilmTitle": "Long Live the Hobos!",
      "AlternateTitle": "¡Que vivan los crotos!",
      "TitleArray": [
        "Long Live the Hobos!",
        "¡Que vivan los crotos!"
      ],
      "Year": "1995",
      "Director": "Ana Poliak",
      "DirectorArray": [
        "Ana Poliak"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2053",
      "databaseFilmTitle": "Long Live the Lady!",
      "FilmTitle": "Long Live the Lady!",
      "AlternateTitle": "Lunga vita alla signora!",
      "TitleArray": [
        "Long Live the Lady!",
        "Lunga vita alla signora!"
      ],
      "Year": "1987",
      "Director": "Ermanno Olmi",
      "DirectorArray": [
        "Ermanno Olmi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2054",
      "databaseFilmTitle": "Looking for Langston",
      "FilmTitle": "Looking for Langston",
      "AlternateTitle": "",
      "TitleArray": [
        "Looking for Langston"
      ],
      "Year": "1989",
      "Director": "Isaac Julien",
      "DirectorArray": [
        "Isaac Julien"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2055",
      "databaseFilmTitle": "Looking for Mushrooms",
      "FilmTitle": "Looking for Mushrooms",
      "AlternateTitle": "",
      "TitleArray": [
        "Looking for Mushrooms"
      ],
      "Year": "1996",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "Mexico, United States",
      "CountryArray": [
        "Mexico",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2056",
      "databaseFilmTitle": "Looper",
      "FilmTitle": "Looper",
      "AlternateTitle": "",
      "TitleArray": [
        "Looper"
      ],
      "Year": "2012",
      "Director": "Rian Johson",
      "DirectorArray": [
        "Rian Johson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2057",
      "databaseFilmTitle": "Lord of the Flies",
      "FilmTitle": "Lord of the Flies",
      "AlternateTitle": "",
      "TitleArray": [
        "Lord of the Flies"
      ],
      "Year": "1963",
      "Director": "Peter Brook",
      "DirectorArray": [
        "Peter Brook"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2058",
      "databaseFilmTitle": "Lore",
      "FilmTitle": "Lore",
      "AlternateTitle": "",
      "TitleArray": [
        "Lore"
      ],
      "Year": "2012",
      "Director": "Cate Shortland",
      "DirectorArray": [
        "Cate Shortland"
      ],
      "Country": "Germany, Australia",
      "CountryArray": [
        "Germany",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2059",
      "databaseFilmTitle": "Los",
      "FilmTitle": "Los",
      "AlternateTitle": "",
      "TitleArray": [
        "Los"
      ],
      "Year": "2001",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2060",
      "databaseFilmTitle": "Los Angeles Plays Itself",
      "FilmTitle": "Los Angeles Plays Itself",
      "AlternateTitle": "",
      "TitleArray": [
        "Los Angeles Plays Itself"
      ],
      "Year": "2003",
      "Director": "Thom Andersen",
      "DirectorArray": [
        "Thom Andersen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2061",
      "databaseFilmTitle": "Los olvidados",
      "FilmTitle": "Los olvidados",
      "AlternateTitle": "",
      "TitleArray": [
        "Los olvidados"
      ],
      "Year": "1950",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "2062",
      "databaseFilmTitle": "Losing Ground",
      "FilmTitle": "Losing Ground",
      "AlternateTitle": "",
      "TitleArray": [
        "Losing Ground"
      ],
      "Year": "1982",
      "Director": "Kathleen Collins",
      "DirectorArray": [
        "Kathleen Collins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2063",
      "databaseFilmTitle": "Losses to Be Expected",
      "FilmTitle": "Losses to Be Expected",
      "AlternateTitle": "Mit Verlust ist zu rechnen",
      "TitleArray": [
        "Losses to Be Expected",
        "Mit Verlust ist zu rechnen"
      ],
      "Year": "1992",
      "Director": "Ulrich Seidl",
      "DirectorArray": [
        "Ulrich Seidl"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2064",
      "databaseFilmTitle": "Lost Book Found",
      "FilmTitle": "Lost Book Found",
      "AlternateTitle": "",
      "TitleArray": [
        "Lost Book Found"
      ],
      "Year": "1996",
      "Director": "Jem Cohen",
      "DirectorArray": [
        "Jem Cohen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2065",
      "databaseFilmTitle": "Lost Highway",
      "FilmTitle": "Lost Highway",
      "AlternateTitle": "",
      "TitleArray": [
        "Lost Highway"
      ],
      "Year": "1997",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2066",
      "databaseFilmTitle": "Lost in Translation",
      "FilmTitle": "Lost in Translation",
      "AlternateTitle": "",
      "TitleArray": [
        "Lost in Translation"
      ],
      "Year": "2003",
      "Director": "Sofia Coppola",
      "DirectorArray": [
        "Sofia Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2067",
      "databaseFilmTitle": "Lost, Lost, Lost",
      "FilmTitle": "Lost, Lost, Lost",
      "AlternateTitle": "",
      "TitleArray": [
        "Lost, Lost, Lost"
      ],
      "Year": "1976",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2068",
      "databaseFilmTitle": "Louis Lumière",
      "FilmTitle": "Louis Lumière",
      "AlternateTitle": "Les frères Lumière",
      "TitleArray": [
        "Louis Lumière",
        "Les frères Lumière"
      ],
      "Year": "1968",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2069",
      "databaseFilmTitle": "Louisa",
      "FilmTitle": "Louisa",
      "AlternateTitle": "Loviisa, Niskavuoren nuori emäntä",
      "TitleArray": [
        "Louisa",
        "Loviisa, Niskavuoren nuori emäntä"
      ],
      "Year": "1946",
      "Director": "Valentin Vaala",
      "DirectorArray": [
        "Valentin Vaala"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2070",
      "databaseFilmTitle": "Louisiana Story",
      "FilmTitle": "Louisiana Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Louisiana Story"
      ],
      "Year": "1948",
      "Director": "Robert J. Flaherty",
      "DirectorArray": [
        "Robert J. Flaherty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "5",
      "1952votes": "12",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2071",
      "databaseFilmTitle": "Loulou",
      "FilmTitle": "Loulou",
      "AlternateTitle": "",
      "TitleArray": [
        "Loulou"
      ],
      "Year": "1980",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2072",
      "databaseFilmTitle": "Love",
      "FilmTitle": "Love",
      "AlternateTitle": "Szerelem",
      "TitleArray": [
        "Love",
        "Szerelem"
      ],
      "Year": "1971",
      "Director": "Károly Makk",
      "DirectorArray": [
        "Károly Makk"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2073",
      "databaseFilmTitle": "Love & Basketball",
      "FilmTitle": "Love & Basketball",
      "AlternateTitle": "",
      "TitleArray": [
        "Love & Basketball"
      ],
      "Year": "2000",
      "Director": "Gina Prince-Bythewood",
      "DirectorArray": [
        "Gina Prince-Bythewood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2074",
      "databaseFilmTitle": "Love Affair",
      "FilmTitle": "Love Affair",
      "AlternateTitle": "",
      "TitleArray": [
        "Love Affair"
      ],
      "Year": "1939",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2075",
      "databaseFilmTitle": "Love Affair, or the Case of the Missing Switchboard Operator",
      "FilmTitle": "Love Affair, or the Case of the Missing Switchboard Operator",
      "AlternateTitle": "Ljubavni slucaj ili tragedija sluzbenice PTT",
      "TitleArray": [
        "Love Affair, or the Case of the Missing Switchboard Operator",
        "Ljubavni slucaj ili tragedija sluzbenice PTT"
      ],
      "Year": "1967",
      "Director": "Dušan Makavejev",
      "DirectorArray": [
        "Dušan Makavejev"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2076",
      "databaseFilmTitle": "Love and Anarchy",
      "FilmTitle": "Love and Anarchy",
      "AlternateTitle": "Film d'amore e d'anarchia, Ovvero 'Stamattina alle 10 in via dei Fiori nella nota casa di tolleranza...'",
      "TitleArray": [
        "Love and Anarchy",
        "Film d'amore e d'anarchia, Ovvero 'Stamattina alle 10 in via dei Fiori nella nota casa di tolleranza...'"
      ],
      "Year": "1973",
      "Director": "Lina Wertmüller",
      "DirectorArray": [
        "Lina Wertmüller"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2077",
      "databaseFilmTitle": "Love and Death",
      "FilmTitle": "Love and Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Love and Death"
      ],
      "Year": "1975",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2078",
      "databaseFilmTitle": "Love and Duty",
      "FilmTitle": "Love and Duty",
      "AlternateTitle": "Lian ai yu yi wu",
      "TitleArray": [
        "Love and Duty",
        "Lian ai yu yi wu"
      ],
      "Year": "1931",
      "Director": "Bu Wancang",
      "DirectorArray": [
        "Bu Wancang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2079",
      "databaseFilmTitle": "Love Exposure",
      "FilmTitle": "Love Exposure",
      "AlternateTitle": "Ai no mukidashi",
      "TitleArray": [
        "Love Exposure",
        "Ai no mukidashi"
      ],
      "Year": "2008",
      "Director": "Sion Sono",
      "DirectorArray": [
        "Sion Sono"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2080",
      "databaseFilmTitle": "Love Hotel",
      "FilmTitle": "Love Hotel",
      "AlternateTitle": "Rabu hoteru",
      "TitleArray": [
        "Love Hotel",
        "Rabu hoteru"
      ],
      "Year": "1985",
      "Director": "Shinji Sômai",
      "DirectorArray": [
        "Shinji Sômai"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2081",
      "databaseFilmTitle": "Love Is The Message, The Message Is Death",
      "FilmTitle": "Love Is The Message, The Message Is Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Love Is The Message, The Message Is Death"
      ],
      "Year": "2016",
      "Director": "Arthur Jafa",
      "DirectorArray": [
        "Arthur Jafa"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2082",
      "databaseFilmTitle": "Love Letter",
      "FilmTitle": "Love Letter",
      "AlternateTitle": "Koibumi",
      "TitleArray": [
        "Love Letter",
        "Koibumi"
      ],
      "Year": "1953",
      "Director": "Kinuyo Tanaka",
      "DirectorArray": [
        "Kinuyo Tanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2083",
      "databaseFilmTitle": "Love Me Tonight",
      "FilmTitle": "Love Me Tonight",
      "AlternateTitle": "",
      "TitleArray": [
        "Love Me Tonight"
      ],
      "Year": "1932",
      "Director": "Rouben Mamoulian",
      "DirectorArray": [
        "Rouben Mamoulian"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2084",
      "databaseFilmTitle": "Love of Jeanne Ney",
      "FilmTitle": "Love of Jeanne Ney",
      "AlternateTitle": "Die Liebe der Jeanne Ney",
      "TitleArray": [
        "Love of Jeanne Ney",
        "Die Liebe der Jeanne Ney"
      ],
      "Year": "1927",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2085",
      "databaseFilmTitle": "Love Still Exists",
      "FilmTitle": "Love Still Exists",
      "AlternateTitle": "L'amour existe",
      "TitleArray": [
        "Love Still Exists",
        "L'amour existe"
      ],
      "Year": "1960",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2086",
      "databaseFilmTitle": "Love Story",
      "FilmTitle": "Love Story",
      "AlternateTitle": "Douce",
      "TitleArray": [
        "Love Story",
        "Douce"
      ],
      "Year": "1943",
      "Director": "Claude Autant-Lara",
      "DirectorArray": [
        "Claude Autant-Lara"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2087",
      "databaseFilmTitle": "Love Streams",
      "FilmTitle": "Love Streams",
      "AlternateTitle": "",
      "TitleArray": [
        "Love Streams"
      ],
      "Year": "1984",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "2088",
      "databaseFilmTitle": "Love Unto Death",
      "FilmTitle": "Love Unto Death",
      "AlternateTitle": "L'amour à mort",
      "TitleArray": [
        "Love Unto Death",
        "L'amour à mort"
      ],
      "Year": "1984",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2089",
      "databaseFilmTitle": "Love, Be with Humanity",
      "FilmTitle": "Love, Be with Humanity",
      "AlternateTitle": "Ai yo jinrui to tomo ni are",
      "TitleArray": [
        "Love, Be with Humanity",
        "Ai yo jinrui to tomo ni are"
      ],
      "Year": "1931",
      "Director": "Yasujirō Shimazu",
      "DirectorArray": [
        "Yasujirō Shimazu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2090",
      "databaseFilmTitle": "Loveless",
      "FilmTitle": "Loveless",
      "AlternateTitle": "",
      "TitleArray": [
        "Loveless"
      ],
      "Year": "2017",
      "Director": "Andrey Zvyagintsev",
      "DirectorArray": [
        "Andrey Zvyagintsev"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2091",
      "databaseFilmTitle": "Loves of a Blonde",
      "FilmTitle": "Loves of a Blonde",
      "AlternateTitle": "Lásky jedné plavovlásky",
      "TitleArray": [
        "Loves of a Blonde",
        "Lásky jedné plavovlásky"
      ],
      "Year": "1965",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2092",
      "databaseFilmTitle": "Loving Couples",
      "FilmTitle": "Loving Couples",
      "AlternateTitle": "Älskande par",
      "TitleArray": [
        "Loving Couples",
        "Älskande par"
      ],
      "Year": "1964",
      "Director": "Mai Zetterling",
      "DirectorArray": [
        "Mai Zetterling"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2093",
      "databaseFilmTitle": "Lucía",
      "FilmTitle": "Lucía",
      "AlternateTitle": "",
      "TitleArray": [
        "Lucía"
      ],
      "Year": "1968",
      "Director": "Humberto Solás",
      "DirectorArray": [
        "Humberto Solás"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2094",
      "databaseFilmTitle": "Lucky Star",
      "FilmTitle": "Lucky Star",
      "AlternateTitle": "",
      "TitleArray": [
        "Lucky Star"
      ],
      "Year": "1929",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2095",
      "databaseFilmTitle": "Ludwig",
      "FilmTitle": "Ludwig",
      "AlternateTitle": "",
      "TitleArray": [
        "Ludwig"
      ],
      "Year": "1973",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2096",
      "databaseFilmTitle": "Luka's Jovana",
      "FilmTitle": "Luka's Jovana",
      "AlternateTitle": "Jovana Lukina",
      "TitleArray": [
        "Luka's Jovana",
        "Jovana Lukina"
      ],
      "Year": "1979",
      "Director": "Živko Nikolić",
      "DirectorArray": [
        "Živko Nikolić"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2097",
      "databaseFilmTitle": "Lumière ! L'aventure commence",
      "FilmTitle": "Lumière ! L'aventure commence",
      "AlternateTitle": "",
      "TitleArray": [
        "Lumière ! L'aventure commence"
      ],
      "Year": "2016",
      "Director": "Theirry Fremaux",
      "DirectorArray": [
        "Theirry Fremaux"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2098",
      "databaseFilmTitle": "Lumière d'été",
      "FilmTitle": "Lumière d'été",
      "AlternateTitle": "",
      "TitleArray": [
        "Lumière d'été"
      ],
      "Year": "1943",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2099",
      "databaseFilmTitle": "Lumumba",
      "FilmTitle": "Lumumba",
      "AlternateTitle": "",
      "TitleArray": [
        "Lumumba"
      ],
      "Year": "2000",
      "Director": "Raoul Peck",
      "DirectorArray": [
        "Raoul Peck"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2100",
      "databaseFilmTitle": "Lunacy",
      "FilmTitle": "Lunacy",
      "AlternateTitle": "Šílení",
      "TitleArray": [
        "Lunacy",
        "Šílení"
      ],
      "Year": "2005",
      "Director": "Jan Švankmajer",
      "DirectorArray": [
        "Jan Švankmajer"
      ],
      "Country": "Czech Republic",
      "CountryArray": [
        "Czech Republic"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2101",
      "databaseFilmTitle": "Lust, Caution",
      "FilmTitle": "Lust, Caution",
      "AlternateTitle": "Se, jie",
      "TitleArray": [
        "Lust, Caution",
        "Se, jie"
      ],
      "Year": "2007",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "United States, Hong Kong",
      "CountryArray": [
        "United States",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2102",
      "databaseFilmTitle": "Lyrical Nitrate",
      "FilmTitle": "Lyrical Nitrate",
      "AlternateTitle": "Lyrisch nitraat",
      "TitleArray": [
        "Lyrical Nitrate",
        "Lyrisch nitraat"
      ],
      "Year": "1991",
      "Director": "Peter Delpeut",
      "DirectorArray": [
        "Peter Delpeut"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2103",
      "databaseFilmTitle": "M",
      "FilmTitle": "M",
      "AlternateTitle": "",
      "TitleArray": [
        "M"
      ],
      "Year": "1931",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "25",
      "2002votes": "8",
      "2012rank": "56",
      "2012votes": "27",
      "2022rank": "36",
      "2022votes": "55"
    },
    {
      "key": "2104",
      "databaseFilmTitle": "M*A*S*H",
      "FilmTitle": "M*A*S*H",
      "AlternateTitle": "",
      "TitleArray": [
        "M*A*S*H"
      ],
      "Year": "1970",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2105",
      "databaseFilmTitle": "Ma'loul Celebrates Its Destruction",
      "FilmTitle": "Ma'loul Celebrates Its Destruction",
      "AlternateTitle": "",
      "TitleArray": [
        "Ma'loul Celebrates Its Destruction"
      ],
      "Year": "1984",
      "Director": "Michel Khleifi",
      "DirectorArray": [
        "Michel Khleifi"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2106",
      "databaseFilmTitle": "Maborosi",
      "FilmTitle": "Maborosi",
      "AlternateTitle": "Maboroshi No Hikari",
      "TitleArray": [
        "Maborosi",
        "Maboroshi No Hikari"
      ],
      "Year": "1995",
      "Director": "Hirokazu Kore-eda",
      "DirectorArray": [
        "Hirokazu Kore-eda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2107",
      "databaseFilmTitle": "Macario",
      "FilmTitle": "Macario",
      "AlternateTitle": "",
      "TitleArray": [
        "Macario"
      ],
      "Year": "1960",
      "Director": "Roberto Gavaldón",
      "DirectorArray": [
        "Roberto Gavaldón"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2108",
      "databaseFilmTitle": "Macbeth",
      "FilmTitle": "Macbeth",
      "AlternateTitle": "",
      "TitleArray": [
        "Macbeth"
      ],
      "Year": "1971",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2109",
      "databaseFilmTitle": "Maciste in Hell",
      "FilmTitle": "Maciste in Hell",
      "AlternateTitle": "Maciste all'inferno",
      "TitleArray": [
        "Maciste in Hell",
        "Maciste all'inferno"
      ],
      "Year": "1925",
      "Director": "Guido Brignone",
      "DirectorArray": [
        "Guido Brignone"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2110",
      "databaseFilmTitle": "Macunaíma",
      "FilmTitle": "Macunaíma",
      "AlternateTitle": "",
      "TitleArray": [
        "Macunaíma"
      ],
      "Year": "1969",
      "Director": "Joaquim Pedro de Andrade",
      "DirectorArray": [
        "Joaquim Pedro de Andrade"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2111",
      "databaseFilmTitle": "Mad Max",
      "FilmTitle": "Mad Max",
      "AlternateTitle": "",
      "TitleArray": [
        "Mad Max"
      ],
      "Year": "1979",
      "Director": "George Miller",
      "DirectorArray": [
        "George Miller"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2112",
      "databaseFilmTitle": "Mad Max 2: The Road Warrior",
      "FilmTitle": "Mad Max 2: The Road Warrior",
      "AlternateTitle": "",
      "TitleArray": [
        "Mad Max 2: The Road Warrior"
      ],
      "Year": "1981",
      "Director": "George Miller",
      "DirectorArray": [
        "George Miller"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2113",
      "databaseFilmTitle": "Mad Max: Fury Road",
      "FilmTitle": "Mad Max: Fury Road",
      "AlternateTitle": "",
      "TitleArray": [
        "Mad Max: Fury Road"
      ],
      "Year": "2015",
      "Director": "George Miller",
      "DirectorArray": [
        "George Miller"
      ],
      "Country": "Australia, United States",
      "CountryArray": [
        "Australia",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "2114",
      "databaseFilmTitle": "Madam Satan",
      "FilmTitle": "Madam Satan",
      "AlternateTitle": "",
      "TitleArray": [
        "Madam Satan"
      ],
      "Year": "1930",
      "Director": "Cecil B. DeMille",
      "DirectorArray": [
        "Cecil B. DeMille"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2115",
      "databaseFilmTitle": "Madame DuBarry",
      "FilmTitle": "Madame DuBarry",
      "AlternateTitle": "",
      "TitleArray": [
        "Madame DuBarry"
      ],
      "Year": "1919",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2116",
      "databaseFilmTitle": "Madame Freedom",
      "FilmTitle": "Madame Freedom",
      "AlternateTitle": "Jayu buin",
      "TitleArray": [
        "Madame Freedom",
        "Jayu buin"
      ],
      "Year": "1956",
      "Director": "Hyeong-mo Han",
      "DirectorArray": [
        "Hyeong-mo Han"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2117",
      "databaseFilmTitle": "Madame Satã",
      "FilmTitle": "Madame Satã",
      "AlternateTitle": "",
      "TitleArray": [
        "Madame Satã"
      ],
      "Year": "2002",
      "Director": "Karim Aïnouz",
      "DirectorArray": [
        "Karim Aïnouz"
      ],
      "Country": "France, Brazil",
      "CountryArray": [
        "France",
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2118",
      "databaseFilmTitle": "Mädchen in Uniform",
      "FilmTitle": "Mädchen in Uniform",
      "AlternateTitle": "",
      "TitleArray": [
        "Mädchen in Uniform"
      ],
      "Year": "1931",
      "Director": "Leontine Sagan, Carl Froelich",
      "DirectorArray": [
        "Leontine Sagan",
        "Carl Froelich"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2119",
      "databaseFilmTitle": "Made in Germany and U.S.A.",
      "FilmTitle": "Made in Germany and U.S.A.",
      "AlternateTitle": "",
      "TitleArray": [
        "Made in Germany and U.S.A."
      ],
      "Year": "1974",
      "Director": "Rudolf Thome",
      "DirectorArray": [
        "Rudolf Thome"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2120",
      "databaseFilmTitle": "Made in Hong Kong",
      "FilmTitle": "Made in Hong Kong",
      "AlternateTitle": "Heung Gong jai jo",
      "TitleArray": [
        "Made in Hong Kong",
        "Heung Gong jai jo"
      ],
      "Year": "1997",
      "Director": "Fruit Chan",
      "DirectorArray": [
        "Fruit Chan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2121",
      "databaseFilmTitle": "Madeline's Madeline",
      "FilmTitle": "Madeline's Madeline",
      "AlternateTitle": "",
      "TitleArray": [
        "Madeline's Madeline"
      ],
      "Year": "2018",
      "Director": "Josephine Decker",
      "DirectorArray": [
        "Josephine Decker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2122",
      "databaseFilmTitle": "Mademoiselle Chambon",
      "FilmTitle": "Mademoiselle Chambon",
      "AlternateTitle": "",
      "TitleArray": [
        "Mademoiselle Chambon"
      ],
      "Year": "2009",
      "Director": "Stéphane Brizé",
      "DirectorArray": [
        "Stéphane Brizé"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2123",
      "databaseFilmTitle": "Madhumati",
      "FilmTitle": "Madhumati",
      "AlternateTitle": "",
      "TitleArray": [
        "Madhumati"
      ],
      "Year": "1958",
      "Director": "Bimal Roy",
      "DirectorArray": [
        "Bimal Roy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2124",
      "databaseFilmTitle": "Maeve",
      "FilmTitle": "Maeve",
      "AlternateTitle": "",
      "TitleArray": [
        "Maeve"
      ],
      "Year": "1981",
      "Director": "Pat Murphy, John Davies",
      "DirectorArray": [
        "Pat Murphy",
        "John Davies"
      ],
      "Country": "United Kingdom, Ireland",
      "CountryArray": [
        "United Kingdom",
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2125",
      "databaseFilmTitle": "Mafrouza - Oh Night!",
      "FilmTitle": "Mafrouza - Oh Night!",
      "AlternateTitle": "Mafrouza - Oh la nuit!",
      "TitleArray": [
        "Mafrouza - Oh Night!",
        "Mafrouza - Oh la nuit!"
      ],
      "Year": "2007",
      "Director": "Emmanuelle Demoris",
      "DirectorArray": [
        "Emmanuelle Demoris"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2126",
      "databaseFilmTitle": "Magic Mike XXL",
      "FilmTitle": "Magic Mike XXL",
      "AlternateTitle": "",
      "TitleArray": [
        "Magic Mike XXL"
      ],
      "Year": "2015",
      "Director": "Gregory Jacobs",
      "DirectorArray": [
        "Gregory Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2127",
      "databaseFilmTitle": "Magick Lantern Cycle",
      "FilmTitle": "Magick Lantern Cycle",
      "AlternateTitle": "",
      "TitleArray": [
        "Magick Lantern Cycle"
      ],
      "Year": "2009",
      "Director": "Kenneth Anger",
      "DirectorArray": [
        "Kenneth Anger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2128",
      "databaseFilmTitle": "Magino Village: A Tale",
      "FilmTitle": "Magino Village: A Tale",
      "AlternateTitle": "1000-nen kizami no hidokei",
      "TitleArray": [
        "Magino Village: A Tale",
        "1000-nen kizami no hidokei"
      ],
      "Year": "1987",
      "Director": "Shinsuke Ogawa",
      "DirectorArray": [
        "Shinsuke Ogawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2129",
      "databaseFilmTitle": "Magnificent Obsession",
      "FilmTitle": "Magnificent Obsession",
      "AlternateTitle": "",
      "TitleArray": [
        "Magnificent Obsession"
      ],
      "Year": "1954",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2130",
      "databaseFilmTitle": "Magnolia",
      "FilmTitle": "Magnolia",
      "AlternateTitle": "",
      "TitleArray": [
        "Magnolia"
      ],
      "Year": "1999",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "2131",
      "databaseFilmTitle": "Mahal",
      "FilmTitle": "Mahal",
      "AlternateTitle": "",
      "TitleArray": [
        "Mahal"
      ],
      "Year": "1969",
      "Director": "Shankar Mukherjee",
      "DirectorArray": [
        "Shankar Mukherjee"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2132",
      "databaseFilmTitle": "Mahjong",
      "FilmTitle": "Mahjong",
      "AlternateTitle": "Ma Jiang",
      "TitleArray": [
        "Mahjong",
        "Ma Jiang"
      ],
      "Year": "1996",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2133",
      "databaseFilmTitle": "Major Dundee",
      "FilmTitle": "Major Dundee",
      "AlternateTitle": "",
      "TitleArray": [
        "Major Dundee"
      ],
      "Year": "1965",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2134",
      "databaseFilmTitle": "Make Way for Tomorrow",
      "FilmTitle": "Make Way for Tomorrow",
      "AlternateTitle": "",
      "TitleArray": [
        "Make Way for Tomorrow"
      ],
      "Year": "1937",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2135",
      "databaseFilmTitle": "Makwayela",
      "FilmTitle": "Makwayela",
      "AlternateTitle": "",
      "TitleArray": [
        "Makwayela"
      ],
      "Year": "1977",
      "Director": "Jacques d'Arthuys, Jean Rouch",
      "DirectorArray": [
        "Jacques d'Arthuys",
        "Jean Rouch"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2136",
      "databaseFilmTitle": "Malcolm X",
      "FilmTitle": "Malcolm X",
      "AlternateTitle": "",
      "TitleArray": [
        "Malcolm X"
      ],
      "Year": "1992",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2137",
      "databaseFilmTitle": "Malombra",
      "FilmTitle": "Malombra",
      "AlternateTitle": "",
      "TitleArray": [
        "Malombra"
      ],
      "Year": "1942",
      "Director": "Mario Soldati",
      "DirectorArray": [
        "Mario Soldati"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2138",
      "databaseFilmTitle": "Mamma Roma",
      "FilmTitle": "Mamma Roma",
      "AlternateTitle": "",
      "TitleArray": [
        "Mamma Roma"
      ],
      "Year": "1962",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2139",
      "databaseFilmTitle": "Man About Town",
      "FilmTitle": "Man About Town",
      "AlternateTitle": "Le silence est d'or",
      "TitleArray": [
        "Man About Town",
        "Le silence est d'or"
      ],
      "Year": "1947",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2140",
      "databaseFilmTitle": "Man Bites Dog",
      "FilmTitle": "Man Bites Dog",
      "AlternateTitle": "C'est arrivé près de chez vous",
      "TitleArray": [
        "Man Bites Dog",
        "C'est arrivé près de chez vous"
      ],
      "Year": "1992",
      "Director": "Rémy Belvaux, André Bonzel, Benoît Poelvoorde",
      "DirectorArray": [
        "Rémy Belvaux",
        "André Bonzel",
        "Benoît Poelvoorde"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2141",
      "databaseFilmTitle": "Man Is Not a Bird",
      "FilmTitle": "Man Is Not a Bird",
      "AlternateTitle": "Čovek nije tica",
      "TitleArray": [
        "Man Is Not a Bird",
        "Čovek nije tica"
      ],
      "Year": "1965",
      "Director": "Dušan Makavejev",
      "DirectorArray": [
        "Dušan Makavejev"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2142",
      "databaseFilmTitle": "Man of Aran",
      "FilmTitle": "Man of Aran",
      "AlternateTitle": "",
      "TitleArray": [
        "Man of Aran"
      ],
      "Year": "1934",
      "Director": "Robert J. Flaherty",
      "DirectorArray": [
        "Robert J. Flaherty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2143",
      "databaseFilmTitle": "Man of Marble",
      "FilmTitle": "Man of Marble",
      "AlternateTitle": "Człowiek z marmuru",
      "TitleArray": [
        "Man of Marble",
        "Człowiek z marmuru"
      ],
      "Year": "1977",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2144",
      "databaseFilmTitle": "Man of the West",
      "FilmTitle": "Man of the West",
      "AlternateTitle": "",
      "TitleArray": [
        "Man of the West"
      ],
      "Year": "1958",
      "Director": "Anthony Mann",
      "DirectorArray": [
        "Anthony Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2145",
      "databaseFilmTitle": "Man on Wire",
      "FilmTitle": "Man on Wire",
      "AlternateTitle": "",
      "TitleArray": [
        "Man on Wire"
      ],
      "Year": "2008",
      "Director": "James Marsh",
      "DirectorArray": [
        "James Marsh"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2146",
      "databaseFilmTitle": "Man With a Movie Camera",
      "FilmTitle": "Man With a Movie Camera",
      "AlternateTitle": "",
      "TitleArray": [
        "Man With a Movie Camera"
      ],
      "Year": "1929",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "8",
      "2012votes": "68",
      "2022rank": "9",
      "2022votes": "100"
    },
    {
      "key": "2147",
      "databaseFilmTitle": "Man with No Name",
      "FilmTitle": "Man with No Name",
      "AlternateTitle": "Wu ming zhe",
      "TitleArray": [
        "Man with No Name",
        "Wu ming zhe"
      ],
      "Year": "2009",
      "Director": "Wang Bing",
      "DirectorArray": [
        "Wang Bing"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2148",
      "databaseFilmTitle": "Man, Woman and Beast",
      "FilmTitle": "Man, Woman and Beast",
      "AlternateTitle": "L'uomo la donna e la bestia - Spell, dolce mattatoio",
      "TitleArray": [
        "Man, Woman and Beast",
        "L'uomo la donna e la bestia - Spell, dolce mattatoio"
      ],
      "Year": "1977",
      "Director": "Alberto Caballone",
      "DirectorArray": [
        "Alberto Caballone"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2149",
      "databaseFilmTitle": "Man's Castle",
      "FilmTitle": "Man's Castle",
      "AlternateTitle": "",
      "TitleArray": [
        "Man's Castle"
      ],
      "Year": "1933",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2150",
      "databaseFilmTitle": "Man's Favorite Sport?",
      "FilmTitle": "Man's Favorite Sport?",
      "AlternateTitle": "",
      "TitleArray": [
        "Man's Favorite Sport?"
      ],
      "Year": "1964",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2151",
      "databaseFilmTitle": "Man's Hope",
      "FilmTitle": "Man's Hope",
      "AlternateTitle": "espoir",
      "TitleArray": [
        "Man's Hope",
        "espoir"
      ],
      "Year": "1945",
      "Director": "André Malraux",
      "DirectorArray": [
        "André Malraux"
      ],
      "Country": "Spain, France",
      "CountryArray": [
        "Spain",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2152",
      "databaseFilmTitle": "Manakamana",
      "FilmTitle": "Manakamana",
      "AlternateTitle": "",
      "TitleArray": [
        "Manakamana"
      ],
      "Year": "2013",
      "Director": "Stephanie Spray, Pacho Velez",
      "DirectorArray": [
        "Stephanie Spray",
        "Pacho Velez"
      ],
      "Country": "Nepal, United States",
      "CountryArray": [
        "Nepal",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2153",
      "databaseFilmTitle": "Mandabi",
      "FilmTitle": "Mandabi",
      "AlternateTitle": "",
      "TitleArray": [
        "Mandabi"
      ],
      "Year": "1968",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2154",
      "databaseFilmTitle": "Mandara",
      "FilmTitle": "Mandara",
      "AlternateTitle": "Mandala",
      "TitleArray": [
        "Mandara",
        "Mandala"
      ],
      "Year": "1981",
      "Director": "Im Kwon-taek",
      "DirectorArray": [
        "Im Kwon-taek"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2155",
      "databaseFilmTitle": "Manhattan",
      "FilmTitle": "Manhattan",
      "AlternateTitle": "",
      "TitleArray": [
        "Manhattan"
      ],
      "Year": "1979",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2156",
      "databaseFilmTitle": "Manhunter",
      "FilmTitle": "Manhunter",
      "AlternateTitle": "",
      "TitleArray": [
        "Manhunter"
      ],
      "Year": "1986",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2157",
      "databaseFilmTitle": "Manila in the Claws of Light",
      "FilmTitle": "Manila in the Claws of Light",
      "AlternateTitle": "Maynila: Sa mga Kuko ng Liwanag",
      "TitleArray": [
        "Manila in the Claws of Light",
        "Maynila: Sa mga Kuko ng Liwanag"
      ],
      "Year": "1975",
      "Director": "Lino Brocka",
      "DirectorArray": [
        "Lino Brocka"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2158",
      "databaseFilmTitle": "Manuel on the Island of Wonders",
      "FilmTitle": "Manuel on the Island of Wonders",
      "AlternateTitle": "Manoel dans l'île des merveilles",
      "TitleArray": [
        "Manuel on the Island of Wonders",
        "Manoel dans l'île des merveilles"
      ],
      "Year": "1984",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Portugal, France",
      "CountryArray": [
        "Portugal",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2159",
      "databaseFilmTitle": "Manuela",
      "FilmTitle": "Manuela",
      "AlternateTitle": "",
      "TitleArray": [
        "Manuela"
      ],
      "Year": "1976",
      "Director": "Gonzalo García Pelayo",
      "DirectorArray": [
        "Gonzalo García Pelayo"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2160",
      "databaseFilmTitle": "Mapantsula",
      "FilmTitle": "Mapantsula",
      "AlternateTitle": "",
      "TitleArray": [
        "Mapantsula"
      ],
      "Year": "1988",
      "Director": "Oliver Schmitz",
      "DirectorArray": [
        "Oliver Schmitz"
      ],
      "Country": "South Africa",
      "CountryArray": [
        "South Africa"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2161",
      "databaseFilmTitle": "Maqbool",
      "FilmTitle": "Maqbool",
      "AlternateTitle": "",
      "TitleArray": [
        "Maqbool"
      ],
      "Year": "2003",
      "Director": "Vishal Bhardwaj",
      "DirectorArray": [
        "Vishal Bhardwaj"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2162",
      "databaseFilmTitle": "Marat/Sade",
      "FilmTitle": "Marat/Sade",
      "AlternateTitle": "The Persecution and Assassination of Jean-Paul Marat as Performed by the Inmates of the Asylum of Charenton Under the Direction of the Marquis de Sade",
      "TitleArray": [
        "Marat/Sade",
        "The Persecution and Assassination of Jean-Paul Marat as Performed by the Inmates of the Asylum of Charenton Under the Direction of the Marquis de Sade"
      ],
      "Year": "1967",
      "Director": "Peter Brook",
      "DirectorArray": [
        "Peter Brook"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2163",
      "databaseFilmTitle": "Marble Ass",
      "FilmTitle": "Marble Ass",
      "AlternateTitle": "Dupe od mramora",
      "TitleArray": [
        "Marble Ass",
        "Dupe od mramora"
      ],
      "Year": "1995",
      "Director": "Želimir Žilnik",
      "DirectorArray": [
        "Želimir Žilnik"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2164",
      "databaseFilmTitle": "Mare",
      "FilmTitle": "Mare",
      "AlternateTitle": "",
      "TitleArray": [
        "Mare"
      ],
      "Year": "2020",
      "Director": "Andrea Štaka",
      "DirectorArray": [
        "Andrea Štaka"
      ],
      "Country": "Switzerland, Croatia",
      "CountryArray": [
        "Switzerland",
        "Croatia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2165",
      "databaseFilmTitle": "Mare's Tail",
      "FilmTitle": "Mare's Tail",
      "AlternateTitle": "",
      "TitleArray": [
        "Mare's Tail"
      ],
      "Year": "1969",
      "Director": "David Larcher",
      "DirectorArray": [
        "David Larcher"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2166",
      "databaseFilmTitle": "Margaret",
      "FilmTitle": "Margaret",
      "AlternateTitle": "",
      "TitleArray": [
        "Margaret"
      ],
      "Year": "2011",
      "Director": "Kenneth Lonergan",
      "DirectorArray": [
        "Kenneth Lonergan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2167",
      "databaseFilmTitle": "Maria",
      "FilmTitle": "Maria",
      "AlternateTitle": "Mariya",
      "TitleArray": [
        "Maria",
        "Mariya"
      ],
      "Year": "1988",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2168",
      "databaseFilmTitle": "Marie Antoinette",
      "FilmTitle": "Marie Antoinette",
      "AlternateTitle": "",
      "TitleArray": [
        "Marie Antoinette"
      ],
      "Year": "2006",
      "Director": "Sofia Coppola",
      "DirectorArray": [
        "Sofia Coppola"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2169",
      "databaseFilmTitle": "Mark Twain",
      "FilmTitle": "Mark Twain",
      "AlternateTitle": "",
      "TitleArray": [
        "Mark Twain"
      ],
      "Year": "2001",
      "Director": "Ken Burns",
      "DirectorArray": [
        "Ken Burns"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2170",
      "databaseFilmTitle": "Marketa Lazarová",
      "FilmTitle": "Marketa Lazarová",
      "AlternateTitle": "",
      "TitleArray": [
        "Marketa Lazarová"
      ],
      "Year": "1967",
      "Director": "František Vláčil",
      "DirectorArray": [
        "František Vláčil"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2171",
      "databaseFilmTitle": "Marlina the Murderer in Four Acts",
      "FilmTitle": "Marlina the Murderer in Four Acts",
      "AlternateTitle": "Marlina Si Pembunuh Dalam Empat Babak",
      "TitleArray": [
        "Marlina the Murderer in Four Acts",
        "Marlina Si Pembunuh Dalam Empat Babak"
      ],
      "Year": "2017",
      "Director": "Mouly Surya",
      "DirectorArray": [
        "Mouly Surya"
      ],
      "Country": "Indonesia",
      "CountryArray": [
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2172",
      "databaseFilmTitle": "Marnie",
      "FilmTitle": "Marnie",
      "AlternateTitle": "",
      "TitleArray": [
        "Marnie"
      ],
      "Year": "1964",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2173",
      "databaseFilmTitle": "Martha",
      "FilmTitle": "Martha",
      "AlternateTitle": "",
      "TitleArray": [
        "Martha"
      ],
      "Year": "1974",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2174",
      "databaseFilmTitle": "Martin",
      "FilmTitle": "Martin",
      "AlternateTitle": "",
      "TitleArray": [
        "Martin"
      ],
      "Year": "1977",
      "Director": "George A. Romero",
      "DirectorArray": [
        "George A. Romero"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2175",
      "databaseFilmTitle": "Martin Eden",
      "FilmTitle": "Martin Eden",
      "AlternateTitle": "",
      "TitleArray": [
        "Martin Eden"
      ],
      "Year": "2019",
      "Director": "Pietro Marcello",
      "DirectorArray": [
        "Pietro Marcello"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2176",
      "databaseFilmTitle": "Martyrs",
      "FilmTitle": "Martyrs",
      "AlternateTitle": "",
      "TitleArray": [
        "Martyrs"
      ],
      "Year": "2008",
      "Director": "Pascal Laughier",
      "DirectorArray": [
        "Pascal Laughier"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2177",
      "databaseFilmTitle": "Marvo Movie",
      "FilmTitle": "Marvo Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "Marvo Movie"
      ],
      "Year": "1970",
      "Director": "Jeff Keen",
      "DirectorArray": [
        "Jeff Keen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2178",
      "databaseFilmTitle": "Mary and Max",
      "FilmTitle": "Mary and Max",
      "AlternateTitle": "",
      "TitleArray": [
        "Mary and Max"
      ],
      "Year": "2009",
      "Director": "Adam Elliot",
      "DirectorArray": [
        "Adam Elliot"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2179",
      "databaseFilmTitle": "Mary Koszmary",
      "FilmTitle": "Mary Koszmary",
      "AlternateTitle": "",
      "TitleArray": [
        "Mary Koszmary"
      ],
      "Year": "2008",
      "Director": "Yael Bartana",
      "DirectorArray": [
        "Yael Bartana"
      ],
      "Country": "Poland, Israel",
      "CountryArray": [
        "Poland",
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2180",
      "databaseFilmTitle": "Mary Poppins",
      "FilmTitle": "Mary Poppins",
      "AlternateTitle": "",
      "TitleArray": [
        "Mary Poppins"
      ],
      "Year": "1964",
      "Director": "Robert Stevenson",
      "DirectorArray": [
        "Robert Stevenson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2181",
      "databaseFilmTitle": "Masculin féminin",
      "FilmTitle": "Masculin féminin",
      "AlternateTitle": "",
      "TitleArray": [
        "Masculin féminin"
      ],
      "Year": "1966",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2182",
      "databaseFilmTitle": "Maskerade",
      "FilmTitle": "Maskerade",
      "AlternateTitle": "",
      "TitleArray": [
        "Maskerade"
      ],
      "Year": "1934",
      "Director": "Willi Frost",
      "DirectorArray": [
        "Willi Frost"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2183",
      "databaseFilmTitle": "Mass for the Dakota Sioux",
      "FilmTitle": "Mass for the Dakota Sioux",
      "AlternateTitle": "",
      "TitleArray": [
        "Mass for the Dakota Sioux"
      ],
      "Year": "1964",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2184",
      "databaseFilmTitle": "Master and Commander The Far Side of the World",
      "FilmTitle": "Master and Commander The Far Side of the World",
      "AlternateTitle": "",
      "TitleArray": [
        "Master and Commander The Far Side of the World"
      ],
      "Year": "2003",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2185",
      "databaseFilmTitle": "Master of the Flying Guillotine",
      "FilmTitle": "Master of the Flying Guillotine",
      "AlternateTitle": "Di bi quan wang da po xue di zi",
      "TitleArray": [
        "Master of the Flying Guillotine",
        "Di bi quan wang da po xue di zi"
      ],
      "Year": "1975",
      "Director": "Jimmy Wang Yu",
      "DirectorArray": [
        "Jimmy Wang Yu"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2186",
      "databaseFilmTitle": "Match Point",
      "FilmTitle": "Match Point",
      "AlternateTitle": "",
      "TitleArray": [
        "Match Point"
      ],
      "Year": "2005",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United Kingdom, Ireland",
      "CountryArray": [
        "United Kingdom",
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2187",
      "databaseFilmTitle": "Material",
      "FilmTitle": "Material",
      "AlternateTitle": "",
      "TitleArray": [
        "Material"
      ],
      "Year": "2009",
      "Director": "Thomas Heise",
      "DirectorArray": [
        "Thomas Heise"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2188",
      "databaseFilmTitle": "Materialfilme",
      "FilmTitle": "Materialfilme",
      "AlternateTitle": "",
      "TitleArray": [
        "Materialfilme"
      ],
      "Year": "1976",
      "Director": "Wilhelm Hein, Birgit Hein",
      "DirectorArray": [
        "Wilhelm Hein",
        "Birgit Hein"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2189",
      "databaseFilmTitle": "Matewan",
      "FilmTitle": "Matewan",
      "AlternateTitle": "",
      "TitleArray": [
        "Matewan"
      ],
      "Year": "1987",
      "Director": "John Sayles",
      "DirectorArray": [
        "John Sayles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2190",
      "databaseFilmTitle": "Matinée",
      "FilmTitle": "Matinée",
      "AlternateTitle": "",
      "TitleArray": [
        "Matinée"
      ],
      "Year": "1977",
      "Director": "Jaime Humberto Hermosillo",
      "DirectorArray": [
        "Jaime Humberto Hermosillo"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2191",
      "databaseFilmTitle": "Maurice",
      "FilmTitle": "Maurice",
      "AlternateTitle": "",
      "TitleArray": [
        "Maurice"
      ],
      "Year": "1987",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2192",
      "databaseFilmTitle": "Mauvais Sang",
      "FilmTitle": "Mauvais Sang",
      "AlternateTitle": "",
      "TitleArray": [
        "Mauvais Sang"
      ],
      "Year": "1986",
      "Director": "Leos Carax",
      "DirectorArray": [
        "Leos Carax"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2193",
      "databaseFilmTitle": "Max mon amour",
      "FilmTitle": "Max mon amour",
      "AlternateTitle": "",
      "TitleArray": [
        "Max mon amour"
      ],
      "Year": "1986",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2194",
      "databaseFilmTitle": "Mayabazar",
      "FilmTitle": "Mayabazar",
      "AlternateTitle": "",
      "TitleArray": [
        "Mayabazar"
      ],
      "Year": "1957",
      "Director": "Kadri Venkata Reddy",
      "DirectorArray": [
        "Kadri Venkata Reddy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2195",
      "databaseFilmTitle": "McCabe & Mrs. Miller",
      "FilmTitle": "McCabe & Mrs. Miller",
      "AlternateTitle": "",
      "TitleArray": [
        "McCabe & Mrs. Miller"
      ],
      "Year": "1971",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2196",
      "databaseFilmTitle": "Me and My Gal",
      "FilmTitle": "Me and My Gal",
      "AlternateTitle": "",
      "TitleArray": [
        "Me and My Gal"
      ],
      "Year": "1932",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2197",
      "databaseFilmTitle": "Me and You and Everyone We Know",
      "FilmTitle": "Me and You and Everyone We Know",
      "AlternateTitle": "",
      "TitleArray": [
        "Me and You and Everyone We Know"
      ],
      "Year": "2005",
      "Director": "Miranda July",
      "DirectorArray": [
        "Miranda July"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2198",
      "databaseFilmTitle": "Me at the Zoo",
      "FilmTitle": "Me at the Zoo",
      "AlternateTitle": "",
      "TitleArray": [
        "Me at the Zoo"
      ],
      "Year": "2005",
      "Director": "Jawed Karim, Yakov Lapitsky",
      "DirectorArray": [
        "Jawed Karim",
        "Yakov Lapitsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2199",
      "databaseFilmTitle": "Mean Girls",
      "FilmTitle": "Mean Girls",
      "AlternateTitle": "",
      "TitleArray": [
        "Mean Girls"
      ],
      "Year": "2004",
      "Director": "Mark Waters",
      "DirectorArray": [
        "Mark Waters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2200",
      "databaseFilmTitle": "Mean Streets",
      "FilmTitle": "Mean Streets",
      "AlternateTitle": "",
      "TitleArray": [
        "Mean Streets"
      ],
      "Year": "1973",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2201",
      "databaseFilmTitle": "Meantime",
      "FilmTitle": "Meantime",
      "AlternateTitle": "",
      "TitleArray": [
        "Meantime"
      ],
      "Year": "1984",
      "Director": "Mike Leigh",
      "DirectorArray": [
        "Mike Leigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2202",
      "databaseFilmTitle": "Measures of Distance",
      "FilmTitle": "Measures of Distance",
      "AlternateTitle": "",
      "TitleArray": [
        "Measures of Distance"
      ],
      "Year": "1988",
      "Director": "Mona Hatoum",
      "DirectorArray": [
        "Mona Hatoum"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2203",
      "databaseFilmTitle": "Medea",
      "FilmTitle": "Medea",
      "AlternateTitle": "",
      "TitleArray": [
        "Medea"
      ],
      "Year": "1969",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2204",
      "databaseFilmTitle": "Medicine for Melancholy",
      "FilmTitle": "Medicine for Melancholy",
      "AlternateTitle": "",
      "TitleArray": [
        "Medicine for Melancholy"
      ],
      "Year": "2008",
      "Director": "Barry Jenkins",
      "DirectorArray": [
        "Barry Jenkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2205",
      "databaseFilmTitle": "Meditation on Violence",
      "FilmTitle": "Meditation on Violence",
      "AlternateTitle": "",
      "TitleArray": [
        "Meditation on Violence"
      ],
      "Year": "1949",
      "Director": "Maya Deren",
      "DirectorArray": [
        "Maya Deren"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2206",
      "databaseFilmTitle": "Méditerranée",
      "FilmTitle": "Méditerranée",
      "AlternateTitle": "",
      "TitleArray": [
        "Méditerranée"
      ],
      "Year": "1963",
      "Director": "Jean-Daniel Pollet, Volker Schlöndorff",
      "DirectorArray": [
        "Jean-Daniel Pollet",
        "Volker Schlöndorff"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2207",
      "databaseFilmTitle": "Meek's Cutoff",
      "FilmTitle": "Meek's Cutoff",
      "AlternateTitle": "",
      "TitleArray": [
        "Meek's Cutoff"
      ],
      "Year": "2010",
      "Director": "Kelly Reichardt",
      "DirectorArray": [
        "Kelly Reichardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2208",
      "databaseFilmTitle": "Meet Me in St. Louis",
      "FilmTitle": "Meet Me in St. Louis",
      "AlternateTitle": "",
      "TitleArray": [
        "Meet Me in St. Louis"
      ],
      "Year": "1944",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2209",
      "databaseFilmTitle": "Melancholia (2008)",
      "FilmTitle": "Melancholia",
      "AlternateTitle": "",
      "TitleArray": [
        "Melancholia"
      ],
      "Year": "2008",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2210",
      "databaseFilmTitle": "Melancholia (2011)",
      "FilmTitle": "Melancholia",
      "AlternateTitle": "",
      "TitleArray": [
        "Melancholia"
      ],
      "Year": "2011",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark, Sweden",
      "CountryArray": [
        "Denmark",
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "2211",
      "databaseFilmTitle": "Memento",
      "FilmTitle": "Memento",
      "AlternateTitle": "",
      "TitleArray": [
        "Memento"
      ],
      "Year": "2000",
      "Director": "Christopher Nolan",
      "DirectorArray": [
        "Christopher Nolan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2212",
      "databaseFilmTitle": "Memoria",
      "FilmTitle": "Memoria",
      "AlternateTitle": "",
      "TitleArray": [
        "Memoria"
      ],
      "Year": "2021",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Colombia, Thailand",
      "CountryArray": [
        "Colombia",
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2213",
      "databaseFilmTitle": "Memories of Murder",
      "FilmTitle": "Memories of Murder",
      "AlternateTitle": "Salinui chueok",
      "TitleArray": [
        "Memories of Murder",
        "Salinui chueok"
      ],
      "Year": "2003",
      "Director": "Bong Joon Ho",
      "DirectorArray": [
        "Bong Joon Ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2214",
      "databaseFilmTitle": "Memories of Underdevelopment",
      "FilmTitle": "Memories of Underdevelopment",
      "AlternateTitle": "Memorias del subdesarrollo",
      "TitleArray": [
        "Memories of Underdevelopment",
        "Memorias del subdesarrollo"
      ],
      "Year": "1968",
      "Director": "Tomás Gutiérrez Alea",
      "DirectorArray": [
        "Tomás Gutiérrez Alea"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "2215",
      "databaseFilmTitle": "Memory of the Camps",
      "FilmTitle": "Memory of the Camps",
      "AlternateTitle": "",
      "TitleArray": [
        "Memory of the Camps"
      ],
      "Year": "1985",
      "Director": "Sidney Bernstein",
      "DirectorArray": [
        "Sidney Bernstein"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2216",
      "databaseFilmTitle": "Men of Consett",
      "FilmTitle": "Men of Consett",
      "AlternateTitle": "",
      "TitleArray": [
        "Men of Consett"
      ],
      "Year": "1959",
      "Director": "Thomas Stobart",
      "DirectorArray": [
        "Thomas Stobart"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2217",
      "databaseFilmTitle": "Menace II Society",
      "FilmTitle": "Menace II Society",
      "AlternateTitle": "",
      "TitleArray": [
        "Menace II Society"
      ],
      "Year": "1993",
      "Director": "Allen Hughes, Albert Hughes",
      "DirectorArray": [
        "Allen Hughes",
        "Albert Hughes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2218",
      "databaseFilmTitle": "Ménilmontant",
      "FilmTitle": "Ménilmontant",
      "AlternateTitle": "",
      "TitleArray": [
        "Ménilmontant"
      ],
      "Year": "1926",
      "Director": "Dimitiri Kirsanoff",
      "DirectorArray": [
        "Dimitiri Kirsanoff"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2219",
      "databaseFilmTitle": "Mephisto",
      "FilmTitle": "Mephisto",
      "AlternateTitle": "",
      "TitleArray": [
        "Mephisto"
      ],
      "Year": "1981",
      "Director": "István Szabó",
      "DirectorArray": [
        "István Szabó"
      ],
      "Country": "Austria, West Germany",
      "CountryArray": [
        "Austria",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2220",
      "databaseFilmTitle": "Mercedes",
      "FilmTitle": "Mercedes",
      "AlternateTitle": "Marcides",
      "TitleArray": [
        "Mercedes",
        "Marcides"
      ],
      "Year": "1993",
      "Director": "Yousry Nasrallah",
      "DirectorArray": [
        "Yousry Nasrallah"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2221",
      "databaseFilmTitle": "Merci pour le chocolat",
      "FilmTitle": "Merci pour le chocolat",
      "AlternateTitle": "",
      "TitleArray": [
        "Merci pour le chocolat"
      ],
      "Year": "2000",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2222",
      "databaseFilmTitle": "Mercuriales",
      "FilmTitle": "Mercuriales",
      "AlternateTitle": "",
      "TitleArray": [
        "Mercuriales"
      ],
      "Year": "2014",
      "Director": "Virgil Vernier",
      "DirectorArray": [
        "Virgil Vernier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2223",
      "databaseFilmTitle": "Merlusse",
      "FilmTitle": "Merlusse",
      "AlternateTitle": "",
      "TitleArray": [
        "Merlusse"
      ],
      "Year": "1938",
      "Director": "Marcel Pagnol",
      "DirectorArray": [
        "Marcel Pagnol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2224",
      "databaseFilmTitle": "Merrily We Go to Hell",
      "FilmTitle": "Merrily We Go to Hell",
      "AlternateTitle": "",
      "TitleArray": [
        "Merrily We Go to Hell"
      ],
      "Year": "1932",
      "Director": "Dorothy Arzner",
      "DirectorArray": [
        "Dorothy Arzner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2225",
      "databaseFilmTitle": "Merry Christmas, Mr. Lawrence",
      "FilmTitle": "Merry Christmas, Mr. Lawrence",
      "AlternateTitle": "",
      "TitleArray": [
        "Merry Christmas, Mr. Lawrence"
      ],
      "Year": "1983",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "United Kingdom, Japan",
      "CountryArray": [
        "United Kingdom",
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2226",
      "databaseFilmTitle": "Merry-Go-Round",
      "FilmTitle": "Merry-Go-Round",
      "AlternateTitle": "Körhinta",
      "TitleArray": [
        "Merry-Go-Round",
        "Körhinta"
      ],
      "Year": "1956",
      "Director": "Zoltán Fábri",
      "DirectorArray": [
        "Zoltán Fábri"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2227",
      "databaseFilmTitle": "Meshes of the Afternoon",
      "FilmTitle": "Meshes of the Afternoon",
      "AlternateTitle": "",
      "TitleArray": [
        "Meshes of the Afternoon"
      ],
      "Year": "1943",
      "Director": "Maya Deren, Alexander Hammid",
      "DirectorArray": [
        "Maya Deren",
        "Alexander Hammid"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "16",
      "2022votes": "79"
    },
    {
      "key": "2228",
      "databaseFilmTitle": "Messidor",
      "FilmTitle": "Messidor",
      "AlternateTitle": "",
      "TitleArray": [
        "Messidor"
      ],
      "Year": "1979",
      "Director": "Alain Tanner",
      "DirectorArray": [
        "Alain Tanner"
      ],
      "Country": "Switzerland, France",
      "CountryArray": [
        "Switzerland",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2229",
      "databaseFilmTitle": "Metal and Melancholy",
      "FilmTitle": "Metal and Melancholy",
      "AlternateTitle": "Metaal en melancholie",
      "TitleArray": [
        "Metal and Melancholy",
        "Metaal en melancholie"
      ],
      "Year": "1993",
      "Director": "Heddy Honigmann",
      "DirectorArray": [
        "Heddy Honigmann"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2230",
      "databaseFilmTitle": "Metallica: Some Kind of Monster",
      "FilmTitle": "Metallica: Some Kind of Monster",
      "AlternateTitle": "",
      "TitleArray": [
        "Metallica: Some Kind of Monster"
      ],
      "Year": "2004",
      "Director": "Joe Berlinger, Bruce Sinofsky",
      "DirectorArray": [
        "Joe Berlinger",
        "Bruce Sinofsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2231",
      "databaseFilmTitle": "Metropolis",
      "FilmTitle": "Metropolis",
      "AlternateTitle": "",
      "TitleArray": [
        "Metropolis"
      ],
      "Year": "1927",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "36",
      "2012votes": "34",
      "2022rank": "67",
      "2022votes": "38"
    },
    {
      "key": "2232",
      "databaseFilmTitle": "Miami Vice",
      "FilmTitle": "Miami Vice",
      "AlternateTitle": "",
      "TitleArray": [
        "Miami Vice"
      ],
      "Year": "2006",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2233",
      "databaseFilmTitle": "Midnight",
      "FilmTitle": "Midnight",
      "AlternateTitle": "",
      "TitleArray": [
        "Midnight"
      ],
      "Year": "1939",
      "Director": "Mitchell Leisen",
      "DirectorArray": [
        "Mitchell Leisen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2234",
      "databaseFilmTitle": "Midnight Cowboy",
      "FilmTitle": "Midnight Cowboy",
      "AlternateTitle": "",
      "TitleArray": [
        "Midnight Cowboy"
      ],
      "Year": "1969",
      "Director": "John Schlesinger",
      "DirectorArray": [
        "John Schlesinger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2235",
      "databaseFilmTitle": "Midsommar",
      "FilmTitle": "Midsommar",
      "AlternateTitle": "",
      "TitleArray": [
        "Midsommar"
      ],
      "Year": "2019",
      "Director": "Ari Aster",
      "DirectorArray": [
        "Ari Aster"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2236",
      "databaseFilmTitle": "Mikey and Nicky",
      "FilmTitle": "Mikey and Nicky",
      "AlternateTitle": "",
      "TitleArray": [
        "Mikey and Nicky"
      ],
      "Year": "1976",
      "Director": "Elaine May",
      "DirectorArray": [
        "Elaine May"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2237",
      "databaseFilmTitle": "Mildred Pierce",
      "FilmTitle": "Mildred Pierce",
      "AlternateTitle": "",
      "TitleArray": [
        "Mildred Pierce"
      ],
      "Year": "1945",
      "Director": "Michael Curtiz",
      "DirectorArray": [
        "Michael Curtiz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2238",
      "databaseFilmTitle": "Milestones",
      "FilmTitle": "Milestones",
      "AlternateTitle": "",
      "TitleArray": [
        "Milestones"
      ],
      "Year": "1975",
      "Director": "Robert Kramer, John Douglas",
      "DirectorArray": [
        "Robert Kramer",
        "John Douglas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2239",
      "databaseFilmTitle": "Millennium Actress",
      "FilmTitle": "Millennium Actress",
      "AlternateTitle": "Sennen joyû",
      "TitleArray": [
        "Millennium Actress",
        "Sennen joyû"
      ],
      "Year": "2001",
      "Director": "Satoshi Kon",
      "DirectorArray": [
        "Satoshi Kon"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2240",
      "databaseFilmTitle": "Millennium Mambo",
      "FilmTitle": "Millennium Mambo",
      "AlternateTitle": "Qian xi man po",
      "TitleArray": [
        "Millennium Mambo",
        "Qian xi man po"
      ],
      "Year": "2001",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2241",
      "databaseFilmTitle": "Miller's Crossing",
      "FilmTitle": "Miller's Crossing",
      "AlternateTitle": "",
      "TitleArray": [
        "Miller's Crossing"
      ],
      "Year": "1990",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2242",
      "databaseFilmTitle": "Million Dollar Baby",
      "FilmTitle": "Million Dollar Baby",
      "AlternateTitle": "",
      "TitleArray": [
        "Million Dollar Baby"
      ],
      "Year": "2004",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2243",
      "databaseFilmTitle": "Millions Like Us",
      "FilmTitle": "Millions Like Us",
      "AlternateTitle": "",
      "TitleArray": [
        "Millions Like Us"
      ],
      "Year": "1943",
      "Director": "Sidney Gilliat, Frank Launder",
      "DirectorArray": [
        "Sidney Gilliat",
        "Frank Launder"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2244",
      "databaseFilmTitle": "Minamata: The Victims and Their World",
      "FilmTitle": "Minamata: The Victims and Their World",
      "AlternateTitle": "Minamata: kanjo-san to sono sekai",
      "TitleArray": [
        "Minamata: The Victims and Their World",
        "Minamata: kanjo-san to sono sekai"
      ],
      "Year": "1971",
      "Director": "Noriaki Tsuchimoto",
      "DirectorArray": [
        "Noriaki Tsuchimoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2245",
      "databaseFilmTitle": "Minari",
      "FilmTitle": "Minari",
      "AlternateTitle": "",
      "TitleArray": [
        "Minari"
      ],
      "Year": "2020",
      "Director": "Lee Isaac Chung",
      "DirectorArray": [
        "Lee Isaac Chung"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2246",
      "databaseFilmTitle": "Mining Review 36th Year No. 5",
      "FilmTitle": "Mining Review 36th Year No. 5",
      "AlternateTitle": "Out of the Darkness, Light",
      "TitleArray": [
        "Mining Review 36th Year No. 5",
        "Out of the Darkness, Light"
      ],
      "Year": "1983",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2247",
      "databaseFilmTitle": "Mining Review 7th Year No. 12",
      "FilmTitle": "Mining Review 7th Year No. 12",
      "AlternateTitle": "Balletomines",
      "TitleArray": [
        "Mining Review 7th Year No. 12",
        "Balletomines"
      ],
      "Year": "1954",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2248",
      "databaseFilmTitle": "Ministry of Fear",
      "FilmTitle": "Ministry of Fear",
      "AlternateTitle": "",
      "TitleArray": [
        "Ministry of Fear"
      ],
      "Year": "1944",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2249",
      "databaseFilmTitle": "Minne, l'ingenue libertine",
      "FilmTitle": "Minne, l'ingenue libertine",
      "AlternateTitle": "",
      "TitleArray": [
        "Minne, l'ingenue libertine"
      ],
      "Year": "1950",
      "Director": "Jacqueline Audry",
      "DirectorArray": [
        "Jacqueline Audry"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2250",
      "databaseFilmTitle": "Minnie and Moskowitz",
      "FilmTitle": "Minnie and Moskowitz",
      "AlternateTitle": "",
      "TitleArray": [
        "Minnie and Moskowitz"
      ],
      "Year": "1971",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2251",
      "databaseFilmTitle": "Minority Report",
      "FilmTitle": "Minority Report",
      "AlternateTitle": "",
      "TitleArray": [
        "Minority Report"
      ],
      "Year": "2002",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2252",
      "databaseFilmTitle": "Miracle in Milan",
      "FilmTitle": "Miracle in Milan",
      "AlternateTitle": "Miracolo a Milano",
      "TitleArray": [
        "Miracle in Milan",
        "Miracolo a Milano"
      ],
      "Year": "1951",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2253",
      "databaseFilmTitle": "Miracle Mile",
      "FilmTitle": "Miracle Mile",
      "AlternateTitle": "",
      "TitleArray": [
        "Miracle Mile"
      ],
      "Year": "1988",
      "Director": "Steve De Jarnatt",
      "DirectorArray": [
        "Steve De Jarnatt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2254",
      "databaseFilmTitle": "Mirror",
      "FilmTitle": "Mirror",
      "AlternateTitle": "Zerkalo",
      "TitleArray": [
        "Mirror",
        "Zerkalo"
      ],
      "Year": "1975",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "19",
      "2012votes": "47",
      "2022rank": "31",
      "2022votes": "59"
    },
    {
      "key": "2255",
      "databaseFilmTitle": "Mirror Animations",
      "FilmTitle": "Mirror Animations",
      "AlternateTitle": "",
      "TitleArray": [
        "Mirror Animations"
      ],
      "Year": "1957",
      "Director": "Harry Smith",
      "DirectorArray": [
        "Harry Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2256",
      "databaseFilmTitle": "Mishima: A Life in Four Chapters",
      "FilmTitle": "Mishima: A Life in Four Chapters",
      "AlternateTitle": "",
      "TitleArray": [
        "Mishima: A Life in Four Chapters"
      ],
      "Year": "1985",
      "Director": "Paul Schrader",
      "DirectorArray": [
        "Paul Schrader"
      ],
      "Country": "Japan, United States",
      "CountryArray": [
        "Japan",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2257",
      "databaseFilmTitle": "Miss Julie",
      "FilmTitle": "Miss Julie",
      "AlternateTitle": "Fröken Julie",
      "TitleArray": [
        "Miss Julie",
        "Fröken Julie"
      ],
      "Year": "1951",
      "Director": "Alf Sjöberg",
      "DirectorArray": [
        "Alf Sjöberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2258",
      "databaseFilmTitle": "Miss Oyu",
      "FilmTitle": "Miss Oyu",
      "AlternateTitle": "Oyū-sama",
      "TitleArray": [
        "Miss Oyu",
        "Oyū-sama"
      ],
      "Year": "1951",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2259",
      "databaseFilmTitle": "Miss Universe in Peru",
      "FilmTitle": "Miss Universe in Peru",
      "AlternateTitle": "Miss Universo en el Perú",
      "TitleArray": [
        "Miss Universe in Peru",
        "Miss Universo en el Perú"
      ],
      "Year": "1982",
      "Director": "Grupo Chaski",
      "DirectorArray": [
        "Grupo Chaski"
      ],
      "Country": "Peru",
      "CountryArray": [
        "Peru"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2260",
      "databaseFilmTitle": "Missing",
      "FilmTitle": "Missing",
      "AlternateTitle": "",
      "TitleArray": [
        "Missing"
      ],
      "Year": "1982",
      "Director": "Costa-Gavras",
      "DirectorArray": [
        "Costa-Gavras"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2261",
      "databaseFilmTitle": "Mission: Impossible",
      "FilmTitle": "Mission: Impossible",
      "AlternateTitle": "",
      "TitleArray": [
        "Mission: Impossible"
      ],
      "Year": "1996",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2262",
      "databaseFilmTitle": "Mississippi Masala",
      "FilmTitle": "Mississippi Masala",
      "AlternateTitle": "",
      "TitleArray": [
        "Mississippi Masala"
      ],
      "Year": "1991",
      "Director": "Mira Nair",
      "DirectorArray": [
        "Mira Nair"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2263",
      "databaseFilmTitle": "Missy Elliott: The Rain (Supa Dupa Fly) [MV]",
      "FilmTitle": "Missy Elliott: The Rain (Supa Dupa Fly) [MV]",
      "AlternateTitle": "",
      "TitleArray": [
        "Missy Elliott: The Rain (Supa Dupa Fly) [MV]"
      ],
      "Year": "1997",
      "Director": "Hype Williams",
      "DirectorArray": [
        "Hype Williams"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2264",
      "databaseFilmTitle": "Misunderstood",
      "FilmTitle": "Misunderstood",
      "AlternateTitle": "Incompreso",
      "TitleArray": [
        "Misunderstood",
        "Incompreso"
      ],
      "Year": "1966",
      "Director": "Luigi Comencini",
      "DirectorArray": [
        "Luigi Comencini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2265",
      "databaseFilmTitle": "Moana",
      "FilmTitle": "Moana",
      "AlternateTitle": "Moana: A Story of the South Seas",
      "TitleArray": [
        "Moana",
        "Moana: A Story of the South Seas"
      ],
      "Year": "1926",
      "Director": "Robert J. Flaherty, Frances H. Flaherty",
      "DirectorArray": [
        "Robert J. Flaherty",
        "Frances H. Flaherty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2266",
      "databaseFilmTitle": "Model Shop",
      "FilmTitle": "Model Shop",
      "AlternateTitle": "",
      "TitleArray": [
        "Model Shop"
      ],
      "Year": "1969",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2267",
      "databaseFilmTitle": "Modern Romance",
      "FilmTitle": "Modern Romance",
      "AlternateTitle": "",
      "TitleArray": [
        "Modern Romance"
      ],
      "Year": "1981",
      "Director": "Albert Brooks",
      "DirectorArray": [
        "Albert Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2268",
      "databaseFilmTitle": "Modern Times",
      "FilmTitle": "Modern Times",
      "AlternateTitle": "",
      "TitleArray": [
        "Modern Times"
      ],
      "Year": "1936",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "2269",
      "databaseFilmTitle": "Moi Ivan, toi Abraham",
      "FilmTitle": "Moi Ivan, toi Abraham",
      "AlternateTitle": "",
      "TitleArray": [
        "Moi Ivan, toi Abraham"
      ],
      "Year": "1993",
      "Director": "Yolande Zauberman",
      "DirectorArray": [
        "Yolande Zauberman"
      ],
      "Country": "France, Belarus",
      "CountryArray": [
        "France",
        "Belarus"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2270",
      "databaseFilmTitle": "Moi, un noir",
      "FilmTitle": "Moi, un noir",
      "AlternateTitle": "",
      "TitleArray": [
        "Moi, un noir"
      ],
      "Year": "1958",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "Ivory Coast, France",
      "CountryArray": [
        "Ivory Coast",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2271",
      "databaseFilmTitle": "Moliére",
      "FilmTitle": "Moliére",
      "AlternateTitle": "",
      "TitleArray": [
        "Moliére"
      ],
      "Year": "1978",
      "Director": "Ariane Mnouchkine",
      "DirectorArray": [
        "Ariane Mnouchkine"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2272",
      "databaseFilmTitle": "Mon oncle",
      "FilmTitle": "Mon oncle",
      "AlternateTitle": "",
      "TitleArray": [
        "Mon oncle"
      ],
      "Year": "1958",
      "Director": "Jacques Tati",
      "DirectorArray": [
        "Jacques Tati"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2273",
      "databaseFilmTitle": "Monkey Business (1931)",
      "FilmTitle": "Monkey Business",
      "AlternateTitle": "",
      "TitleArray": [
        "Monkey Business"
      ],
      "Year": "1931",
      "Director": "Norman Z. McLeod",
      "DirectorArray": [
        "Norman Z. McLeod"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2274",
      "databaseFilmTitle": "Monkey Business (1952)",
      "FilmTitle": "Monkey Business",
      "AlternateTitle": "",
      "TitleArray": [
        "Monkey Business"
      ],
      "Year": "1952",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2275",
      "databaseFilmTitle": "Monkeyshines, No. 1",
      "FilmTitle": "Monkeyshines, No. 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Monkeyshines, No. 1"
      ],
      "Year": "1890",
      "Director": "William K.L. Dickson, William Heise",
      "DirectorArray": [
        "William K.L. Dickson",
        "William Heise"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2276",
      "databaseFilmTitle": "Monologue",
      "FilmTitle": "Monologue",
      "AlternateTitle": "Anantharam",
      "TitleArray": [
        "Monologue",
        "Anantharam"
      ],
      "Year": "1987",
      "Director": "Adoor Gopalakrishnan",
      "DirectorArray": [
        "Adoor Gopalakrishnan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2277",
      "databaseFilmTitle": "Monsieur Hulot's Holiday",
      "FilmTitle": "Monsieur Hulot's Holiday",
      "AlternateTitle": "Les vacances de Monsieur Hulot",
      "TitleArray": [
        "Monsieur Hulot's Holiday",
        "Les vacances de Monsieur Hulot"
      ],
      "Year": "1953",
      "Director": "Jacques Tati",
      "DirectorArray": [
        "Jacques Tati"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2278",
      "databaseFilmTitle": "Monsieur Verdoux",
      "FilmTitle": "Monsieur Verdoux",
      "AlternateTitle": "",
      "TitleArray": [
        "Monsieur Verdoux"
      ],
      "Year": "1947",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "16",
      "1952votes": "8",
      "1962rank": "18",
      "1962votes": "8",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2279",
      "databaseFilmTitle": "Monsoon Wedding",
      "FilmTitle": "Monsoon Wedding",
      "AlternateTitle": "",
      "TitleArray": [
        "Monsoon Wedding"
      ],
      "Year": "2001",
      "Director": "Mira Nair",
      "DirectorArray": [
        "Mira Nair"
      ],
      "Country": "India, United States",
      "CountryArray": [
        "India",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2280",
      "databaseFilmTitle": "Monsters, Inc.",
      "FilmTitle": "Monsters, Inc.",
      "AlternateTitle": "",
      "TitleArray": [
        "Monsters, Inc."
      ],
      "Year": "2001",
      "Director": "Pete Docter, Lee Unkrich, David Silverman",
      "DirectorArray": [
        "Pete Docter",
        "Lee Unkrich",
        "David Silverman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2281",
      "databaseFilmTitle": "Monty Python and the Holy Grail",
      "FilmTitle": "Monty Python and the Holy Grail",
      "AlternateTitle": "",
      "TitleArray": [
        "Monty Python and the Holy Grail"
      ],
      "Year": "1975",
      "Director": "Terry Gilliam, Terry Jones",
      "DirectorArray": [
        "Terry Gilliam",
        "Terry Jones"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2282",
      "databaseFilmTitle": "Monty Python's Life of Brian",
      "FilmTitle": "Monty Python's Life of Brian",
      "AlternateTitle": "",
      "TitleArray": [
        "Monty Python's Life of Brian"
      ],
      "Year": "1979",
      "Director": "Terry Jones",
      "DirectorArray": [
        "Terry Jones"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2283",
      "databaseFilmTitle": "Monty Python's The Meaning of Life",
      "FilmTitle": "Monty Python's The Meaning of Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Monty Python's The Meaning of Life"
      ],
      "Year": "1983",
      "Director": "Terry Jones",
      "DirectorArray": [
        "Terry Jones"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2284",
      "databaseFilmTitle": "Moolaadé",
      "FilmTitle": "Moolaadé",
      "AlternateTitle": "",
      "TitleArray": [
        "Moolaadé"
      ],
      "Year": "2004",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Burkina Faso, Cameroon",
      "CountryArray": [
        "Burkina Faso",
        "Cameroon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2285",
      "databaseFilmTitle": "Moon's Pool",
      "FilmTitle": "Moon's Pool",
      "AlternateTitle": "",
      "TitleArray": [
        "Moon's Pool"
      ],
      "Year": "1973",
      "Director": "Gunvor Nelson",
      "DirectorArray": [
        "Gunvor Nelson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2286",
      "databaseFilmTitle": "Moonfleet",
      "FilmTitle": "Moonfleet",
      "AlternateTitle": "",
      "TitleArray": [
        "Moonfleet"
      ],
      "Year": "1955",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2287",
      "databaseFilmTitle": "Moonlight",
      "FilmTitle": "Moonlight",
      "AlternateTitle": "",
      "TitleArray": [
        "Moonlight"
      ],
      "Year": "2016",
      "Director": "Barry Jenkins",
      "DirectorArray": [
        "Barry Jenkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "60",
      "2022votes": "42"
    },
    {
      "key": "2288",
      "databaseFilmTitle": "Moonrise",
      "FilmTitle": "Moonrise",
      "AlternateTitle": "",
      "TitleArray": [
        "Moonrise"
      ],
      "Year": "1948",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2289",
      "databaseFilmTitle": "Moonrise Kingdom",
      "FilmTitle": "Moonrise Kingdom",
      "AlternateTitle": "",
      "TitleArray": [
        "Moonrise Kingdom"
      ],
      "Year": "2012",
      "Director": "Wes Anderson",
      "DirectorArray": [
        "Wes Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2290",
      "databaseFilmTitle": "Moonstruck",
      "FilmTitle": "Moonstruck",
      "AlternateTitle": "",
      "TitleArray": [
        "Moonstruck"
      ],
      "Year": "1987",
      "Director": "Norman Jewison",
      "DirectorArray": [
        "Norman Jewison"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2291",
      "databaseFilmTitle": "Morocco",
      "FilmTitle": "Morocco",
      "AlternateTitle": "",
      "TitleArray": [
        "Morocco"
      ],
      "Year": "1930",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2292",
      "databaseFilmTitle": "Morphine",
      "FilmTitle": "Morphine",
      "AlternateTitle": "",
      "TitleArray": [
        "Morphine"
      ],
      "Year": "2008",
      "Director": "Aleksey Balabanov",
      "DirectorArray": [
        "Aleksey Balabanov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2293",
      "databaseFilmTitle": "Morvern Callar",
      "FilmTitle": "Morvern Callar",
      "AlternateTitle": "",
      "TitleArray": [
        "Morvern Callar"
      ],
      "Year": "2002",
      "Director": "Lynne Ramsay",
      "DirectorArray": [
        "Lynne Ramsay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2294",
      "databaseFilmTitle": "Moses and Aaron",
      "FilmTitle": "Moses and Aaron",
      "AlternateTitle": "Moses und Aron",
      "TitleArray": [
        "Moses and Aaron",
        "Moses und Aron"
      ],
      "Year": "1975",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2295",
      "databaseFilmTitle": "Mother (1926)",
      "FilmTitle": "Mother",
      "AlternateTitle": "Mat",
      "TitleArray": [
        "Mother",
        "Mat"
      ],
      "Year": "1926",
      "Director": "Vsevolod Pudovkin",
      "DirectorArray": [
        "Vsevolod Pudovkin"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2296",
      "databaseFilmTitle": "Mother (1952)",
      "FilmTitle": "Mother",
      "AlternateTitle": "Okaasan",
      "TitleArray": [
        "Mother",
        "Okaasan"
      ],
      "Year": "1952",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2297",
      "databaseFilmTitle": "Mother (2002)",
      "FilmTitle": "Mother",
      "AlternateTitle": "Mutter",
      "TitleArray": [
        "Mother",
        "Mutter"
      ],
      "Year": "2002",
      "Director": "Miklós Gimes",
      "DirectorArray": [
        "Miklós Gimes"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2298",
      "databaseFilmTitle": "Mother (2009)",
      "FilmTitle": "Mother",
      "AlternateTitle": "Madeo",
      "TitleArray": [
        "Mother",
        "Madeo"
      ],
      "Year": "2009",
      "Director": "Bong Joon Ho",
      "DirectorArray": [
        "Bong Joon Ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2299",
      "databaseFilmTitle": "Mother and Son",
      "FilmTitle": "Mother and Son",
      "AlternateTitle": "Mat i syn",
      "TitleArray": [
        "Mother and Son",
        "Mat i syn"
      ],
      "Year": "1997",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2300",
      "databaseFilmTitle": "Mother India",
      "FilmTitle": "Mother India",
      "AlternateTitle": "Bharat Mata",
      "TitleArray": [
        "Mother India",
        "Bharat Mata"
      ],
      "Year": "1957",
      "Director": "Mahboob Khan",
      "DirectorArray": [
        "Mahboob Khan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2301",
      "databaseFilmTitle": "Mother Joan of the Angels",
      "FilmTitle": "Mother Joan of the Angels",
      "AlternateTitle": "Matka Joanna od Aniołów",
      "TitleArray": [
        "Mother Joan of the Angels",
        "Matka Joanna od Aniołów"
      ],
      "Year": "1961",
      "Director": "Jerzy Kawalerowicz",
      "DirectorArray": [
        "Jerzy Kawalerowicz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2302",
      "databaseFilmTitle": "Mother Krause's Journey to Happiness",
      "FilmTitle": "Mother Krause's Journey to Happiness",
      "AlternateTitle": "Mutter Krausens Fahrt ins Glück",
      "TitleArray": [
        "Mother Krause's Journey to Happiness",
        "Mutter Krausens Fahrt ins Glück"
      ],
      "Year": "1929",
      "Director": "Phil Jutzi",
      "DirectorArray": [
        "Phil Jutzi"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2303",
      "databaseFilmTitle": "Mother Küsters Goes to Heaven",
      "FilmTitle": "Mother Küsters Goes to Heaven",
      "AlternateTitle": "Mutter Küsters' Fahrt zum Himmel",
      "TitleArray": [
        "Mother Küsters Goes to Heaven",
        "Mutter Küsters' Fahrt zum Himmel"
      ],
      "Year": "1975",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2304",
      "databaseFilmTitle": "Mothlight",
      "FilmTitle": "Mothlight",
      "AlternateTitle": "",
      "TitleArray": [
        "Mothlight"
      ],
      "Year": "1963",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2305",
      "databaseFilmTitle": "Motion Painting No. 1",
      "FilmTitle": "Motion Painting No. 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Motion Painting No. 1"
      ],
      "Year": "1947",
      "Director": "Oskar Fischinger",
      "DirectorArray": [
        "Oskar Fischinger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2306",
      "databaseFilmTitle": "Mouchette",
      "FilmTitle": "Mouchette",
      "AlternateTitle": "",
      "TitleArray": [
        "Mouchette"
      ],
      "Year": "1967",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2307",
      "databaseFilmTitle": "Moulin Rouge",
      "FilmTitle": "Moulin Rouge",
      "AlternateTitle": "",
      "TitleArray": [
        "Moulin Rouge"
      ],
      "Year": "1952",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2308",
      "databaseFilmTitle": "Moulin Rouge!",
      "FilmTitle": "Moulin Rouge!",
      "AlternateTitle": "",
      "TitleArray": [
        "Moulin Rouge!"
      ],
      "Year": "2001",
      "Director": "Baz Luhrmann",
      "DirectorArray": [
        "Baz Luhrmann"
      ],
      "Country": "Australia, United States",
      "CountryArray": [
        "Australia",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2309",
      "databaseFilmTitle": "Mouth to Mouth",
      "FilmTitle": "Mouth to Mouth",
      "AlternateTitle": "",
      "TitleArray": [
        "Mouth to Mouth"
      ],
      "Year": "1975",
      "Director": "Theresa Hak Kyung Cha",
      "DirectorArray": [
        "Theresa Hak Kyung Cha"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2310",
      "databaseFilmTitle": "Moving",
      "FilmTitle": "Moving",
      "AlternateTitle": "Ohikkoshi",
      "TitleArray": [
        "Moving",
        "Ohikkoshi"
      ],
      "Year": "1993",
      "Director": "Shinji Sômai",
      "DirectorArray": [
        "Shinji Sômai"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2311",
      "databaseFilmTitle": "Mr. & Mrs. '55",
      "FilmTitle": "Mr. & Mrs. '55",
      "AlternateTitle": "",
      "TitleArray": [
        "Mr. & Mrs. '55"
      ],
      "Year": "1955",
      "Director": "Guru Dutt",
      "DirectorArray": [
        "Guru Dutt"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2312",
      "databaseFilmTitle": "Mr. & Mrs. Bridge",
      "FilmTitle": "Mr. & Mrs. Bridge",
      "AlternateTitle": "",
      "TitleArray": [
        "Mr. & Mrs. Bridge"
      ],
      "Year": "1990",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2313",
      "databaseFilmTitle": "Mr. Arkadin",
      "FilmTitle": "Mr. Arkadin",
      "AlternateTitle": "Confidential Report",
      "TitleArray": [
        "Mr. Arkadin",
        "Confidential Report"
      ],
      "Year": "1955",
      "Director": "Osron Welles",
      "DirectorArray": [
        "Osron Welles"
      ],
      "Country": "France, Spain, Switzerland",
      "CountryArray": [
        "France",
        "Spain",
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2314",
      "databaseFilmTitle": "Mr. Bachmann and His Class",
      "FilmTitle": "Mr. Bachmann and His Class",
      "AlternateTitle": "Herr Bachmann und seine Klasse",
      "TitleArray": [
        "Mr. Bachmann and His Class",
        "Herr Bachmann und seine Klasse"
      ],
      "Year": "2021",
      "Director": "Maria Speth",
      "DirectorArray": [
        "Maria Speth"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2315",
      "databaseFilmTitle": "Mr. Klein",
      "FilmTitle": "Mr. Klein",
      "AlternateTitle": "Monsieur Klein",
      "TitleArray": [
        "Mr. Klein",
        "Monsieur Klein"
      ],
      "Year": "1976",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2316",
      "databaseFilmTitle": "Mr. Smith Goes to Washington",
      "FilmTitle": "Mr. Smith Goes to Washington",
      "AlternateTitle": "",
      "TitleArray": [
        "Mr. Smith Goes to Washington"
      ],
      "Year": "1939",
      "Director": "Frank Capra",
      "DirectorArray": [
        "Frank Capra"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2317",
      "databaseFilmTitle": "Mr. Zwilling and Mrs. Zuckermann",
      "FilmTitle": "Mr. Zwilling and Mrs. Zuckermann",
      "AlternateTitle": "Herr Zwilling und Frau Zuckermann",
      "TitleArray": [
        "Mr. Zwilling and Mrs. Zuckermann",
        "Herr Zwilling und Frau Zuckermann"
      ],
      "Year": "1999",
      "Director": "Volker Koepp",
      "DirectorArray": [
        "Volker Koepp"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2318",
      "databaseFilmTitle": "Muhammad Ali, The Greatest",
      "FilmTitle": "Muhammad Ali, The Greatest",
      "AlternateTitle": "",
      "TitleArray": [
        "Muhammad Ali, The Greatest"
      ],
      "Year": "1969",
      "Director": "William Klein",
      "DirectorArray": [
        "William Klein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2319",
      "databaseFilmTitle": "Mulholland Drive",
      "FilmTitle": "Mulholland Drive",
      "AlternateTitle": "Mulholland Dr.",
      "TitleArray": [
        "Mulholland Drive",
        "Mulholland Dr."
      ],
      "Year": "2001",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "28",
      "2012votes": "40",
      "2022rank": "8",
      "2022votes": "105"
    },
    {
      "key": "2320",
      "databaseFilmTitle": "Multiple Maniacs",
      "FilmTitle": "Multiple Maniacs",
      "AlternateTitle": "",
      "TitleArray": [
        "Multiple Maniacs"
      ],
      "Year": "1970",
      "Director": "John Waters",
      "DirectorArray": [
        "John Waters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2321",
      "databaseFilmTitle": "Multiple Sidosis",
      "FilmTitle": "Multiple Sidosis",
      "AlternateTitle": "",
      "TitleArray": [
        "Multiple Sidosis"
      ],
      "Year": "1970",
      "Director": "Sid Laverents",
      "DirectorArray": [
        "Sid Laverents"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2322",
      "databaseFilmTitle": "Mumblecore",
      "FilmTitle": "Mumblecore",
      "AlternateTitle": "",
      "TitleArray": [
        "Mumblecore"
      ],
      "Year": "2001",
      "Director": "Tao Lin, Megan Boyle",
      "DirectorArray": [
        "Tao Lin",
        "Megan Boyle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2323",
      "databaseFilmTitle": "München-Berlin Wanderung",
      "FilmTitle": "München-Berlin Wanderung",
      "AlternateTitle": "",
      "TitleArray": [
        "München-Berlin Wanderung"
      ],
      "Year": "1927",
      "Director": "Oskar Fischinger",
      "DirectorArray": [
        "Oskar Fischinger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2324",
      "databaseFilmTitle": "Muppet Treasure Island",
      "FilmTitle": "Muppet Treasure Island",
      "AlternateTitle": "",
      "TitleArray": [
        "Muppet Treasure Island"
      ],
      "Year": "1996",
      "Director": "Brian Henson",
      "DirectorArray": [
        "Brian Henson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2325",
      "databaseFilmTitle": "Muriel, or The Time of Return",
      "FilmTitle": "Muriel, or The Time of Return",
      "AlternateTitle": "Muriel ou le Temps d'un retour",
      "TitleArray": [
        "Muriel, or The Time of Return",
        "Muriel ou le Temps d'un retour"
      ],
      "Year": "1963",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2326",
      "databaseFilmTitle": "Muriel's Wedding",
      "FilmTitle": "Muriel's Wedding",
      "AlternateTitle": "",
      "TitleArray": [
        "Muriel's Wedding"
      ],
      "Year": "1994",
      "Director": "P.J. Hogan",
      "DirectorArray": [
        "P.J. Hogan"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2327",
      "databaseFilmTitle": "Murmur of the Heart",
      "FilmTitle": "Murmur of the Heart",
      "AlternateTitle": "Le Souffle au cœur",
      "TitleArray": [
        "Murmur of the Heart",
        "Le Souffle au cœur"
      ],
      "Year": "1971",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2328",
      "databaseFilmTitle": "Museum Hours",
      "FilmTitle": "Museum Hours",
      "AlternateTitle": "",
      "TitleArray": [
        "Museum Hours"
      ],
      "Year": "2012",
      "Director": "Jem Cohen",
      "DirectorArray": [
        "Jem Cohen"
      ],
      "Country": "Austria, United States",
      "CountryArray": [
        "Austria",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2329",
      "databaseFilmTitle": "Mutiny on the Bounty",
      "FilmTitle": "Mutiny on the Bounty",
      "AlternateTitle": "",
      "TitleArray": [
        "Mutiny on the Bounty"
      ],
      "Year": "1935",
      "Director": "Frank Lloyd",
      "DirectorArray": [
        "Frank Lloyd"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2330",
      "databaseFilmTitle": "My Ain Folk",
      "FilmTitle": "My Ain Folk",
      "AlternateTitle": "",
      "TitleArray": [
        "My Ain Folk"
      ],
      "Year": "1973",
      "Director": "Bill Douglas",
      "DirectorArray": [
        "Bill Douglas"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2331",
      "databaseFilmTitle": "My American Uncle",
      "FilmTitle": "My American Uncle",
      "AlternateTitle": "Mon oncle d'Amérique",
      "TitleArray": [
        "My American Uncle",
        "Mon oncle d'Amérique"
      ],
      "Year": "1980",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2332",
      "databaseFilmTitle": "My Apprenticeship",
      "FilmTitle": "My Apprenticeship",
      "AlternateTitle": "",
      "TitleArray": [
        "My Apprenticeship"
      ],
      "Year": "1939",
      "Director": "Mark Donskoy",
      "DirectorArray": [
        "Mark Donskoy"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2333",
      "databaseFilmTitle": "My Beautiful Laundrette",
      "FilmTitle": "My Beautiful Laundrette",
      "AlternateTitle": "",
      "TitleArray": [
        "My Beautiful Laundrette"
      ],
      "Year": "1985",
      "Director": "Stephen Frears",
      "DirectorArray": [
        "Stephen Frears"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2334",
      "databaseFilmTitle": "My Brilliant Career",
      "FilmTitle": "My Brilliant Career",
      "AlternateTitle": "",
      "TitleArray": [
        "My Brilliant Career"
      ],
      "Year": "1979",
      "Director": "Gillian Armstrong",
      "DirectorArray": [
        "Gillian Armstrong"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2335",
      "databaseFilmTitle": "My Brother's Wedding",
      "FilmTitle": "My Brother's Wedding",
      "AlternateTitle": "",
      "TitleArray": [
        "My Brother's Wedding"
      ],
      "Year": "1983",
      "Director": "Charles Burnett",
      "DirectorArray": [
        "Charles Burnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2336",
      "databaseFilmTitle": "My Childhood",
      "FilmTitle": "My Childhood",
      "AlternateTitle": "",
      "TitleArray": [
        "My Childhood"
      ],
      "Year": "1972",
      "Director": "Bill Douglas",
      "DirectorArray": [
        "Bill Douglas"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2337",
      "databaseFilmTitle": "My Country, My Country",
      "FilmTitle": "My Country, My Country",
      "AlternateTitle": "",
      "TitleArray": [
        "My Country, My Country"
      ],
      "Year": "2006",
      "Director": "Laura Poitras",
      "DirectorArray": [
        "Laura Poitras"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2338",
      "databaseFilmTitle": "My Darling Clementine",
      "FilmTitle": "My Darling Clementine",
      "AlternateTitle": "",
      "TitleArray": [
        "My Darling Clementine"
      ],
      "Year": "1946",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2339",
      "databaseFilmTitle": "My Dinner with André",
      "FilmTitle": "My Dinner with André",
      "AlternateTitle": "",
      "TitleArray": [
        "My Dinner with André"
      ],
      "Year": "1981",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2340",
      "databaseFilmTitle": "My Failing Eyesight",
      "FilmTitle": "My Failing Eyesight",
      "AlternateTitle": "Rabun",
      "TitleArray": [
        "My Failing Eyesight",
        "Rabun"
      ],
      "Year": "2003",
      "Director": "Yasmin Ahmad",
      "DirectorArray": [
        "Yasmin Ahmad"
      ],
      "Country": "Malaysia",
      "CountryArray": [
        "Malaysia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2341",
      "databaseFilmTitle": "My Fair Lady",
      "FilmTitle": "My Fair Lady",
      "AlternateTitle": "",
      "TitleArray": [
        "My Fair Lady"
      ],
      "Year": "1964",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2342",
      "databaseFilmTitle": "My Father Was Right",
      "FilmTitle": "My Father Was Right",
      "AlternateTitle": "Mon père avait raison",
      "TitleArray": [
        "My Father Was Right",
        "Mon père avait raison"
      ],
      "Year": "1936",
      "Director": "Sacha Guitry",
      "DirectorArray": [
        "Sacha Guitry"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2343",
      "databaseFilmTitle": "My Friend Ivan Lapshin",
      "FilmTitle": "My Friend Ivan Lapshin",
      "AlternateTitle": "Moy drug Ivan Lapshin",
      "TitleArray": [
        "My Friend Ivan Lapshin",
        "Moy drug Ivan Lapshin"
      ],
      "Year": "1985",
      "Director": "Aleksei German",
      "DirectorArray": [
        "Aleksei German"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2344",
      "databaseFilmTitle": "My Friends",
      "FilmTitle": "My Friends",
      "AlternateTitle": "Amici miei",
      "TitleArray": [
        "My Friends",
        "Amici miei"
      ],
      "Year": "1975",
      "Director": "Mario Monicelli",
      "DirectorArray": [
        "Mario Monicelli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2345",
      "databaseFilmTitle": "My Friends Part 2",
      "FilmTitle": "My Friends Part 2",
      "AlternateTitle": "Amici mieie atto II",
      "TitleArray": [
        "My Friends Part 2",
        "Amici mieie atto II"
      ],
      "Year": "1982",
      "Director": "Mario Monicelli",
      "DirectorArray": [
        "Mario Monicelli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2346",
      "databaseFilmTitle": "My Hand Outstretched to the Winged Distance and Sightless Measure",
      "FilmTitle": "My Hand Outstretched to the Winged Distance and Sightless Measure",
      "AlternateTitle": "",
      "TitleArray": [
        "My Hand Outstretched to the Winged Distance and Sightless Measure"
      ],
      "Year": "2005",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2347",
      "databaseFilmTitle": "My Heart Is That Eternal Rose",
      "FilmTitle": "My Heart Is That Eternal Rose",
      "AlternateTitle": "Sha shou hu die meng",
      "TitleArray": [
        "My Heart Is That Eternal Rose",
        "Sha shou hu die meng"
      ],
      "Year": "1989",
      "Director": "Patrick Tam",
      "DirectorArray": [
        "Patrick Tam"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2348",
      "databaseFilmTitle": "My Homeland",
      "FilmTitle": "My Homeland",
      "AlternateTitle": "Memleketim",
      "TitleArray": [
        "My Homeland",
        "Memleketim"
      ],
      "Year": "1974",
      "Director": "Yücel Çakmaklı",
      "DirectorArray": [
        "Yücel Çakmaklı"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2349",
      "databaseFilmTitle": "My Hustler",
      "FilmTitle": "My Hustler",
      "AlternateTitle": "",
      "TitleArray": [
        "My Hustler"
      ],
      "Year": "1965",
      "Director": "Andy Warhol, Chuck Wein",
      "DirectorArray": [
        "Andy Warhol",
        "Chuck Wein"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2350",
      "databaseFilmTitle": "My Left Foot: The Story of Christy Brown",
      "FilmTitle": "My Left Foot: The Story of Christy Brown",
      "AlternateTitle": "",
      "TitleArray": [
        "My Left Foot: The Story of Christy Brown"
      ],
      "Year": "1989",
      "Director": "Jim Sheridan",
      "DirectorArray": [
        "Jim Sheridan"
      ],
      "Country": "Ireland, United Kingdom",
      "CountryArray": [
        "Ireland",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2351",
      "databaseFilmTitle": "My Little Loves",
      "FilmTitle": "My Little Loves",
      "AlternateTitle": "Mes petites amoureuses",
      "TitleArray": [
        "My Little Loves",
        "Mes petites amoureuses"
      ],
      "Year": "1974",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2352",
      "databaseFilmTitle": "My Man Godfrey",
      "FilmTitle": "My Man Godfrey",
      "AlternateTitle": "",
      "TitleArray": [
        "My Man Godfrey"
      ],
      "Year": "1939",
      "Director": "Gregory La Cava",
      "DirectorArray": [
        "Gregory La Cava"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2353",
      "databaseFilmTitle": "My Mother's Castle",
      "FilmTitle": "My Mother's Castle",
      "AlternateTitle": "Le château de ma mère",
      "TitleArray": [
        "My Mother's Castle",
        "Le château de ma mère"
      ],
      "Year": "1990",
      "Director": "Yves Robert",
      "DirectorArray": [
        "Yves Robert"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2354",
      "databaseFilmTitle": "My Mother's Smile",
      "FilmTitle": "My Mother's Smile",
      "AlternateTitle": "L'ora di religione (Il sorriso di mia madre)",
      "TitleArray": [
        "My Mother's Smile",
        "L'ora di religione (Il sorriso di mia madre)"
      ],
      "Year": "2002",
      "Director": "Marco Bellocchio",
      "DirectorArray": [
        "Marco Bellocchio"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2355",
      "databaseFilmTitle": "My Name is Tonho",
      "FilmTitle": "My Name is Tonho",
      "AlternateTitle": "Meu Nome é Tonho",
      "TitleArray": [
        "My Name is Tonho",
        "Meu Nome é Tonho"
      ],
      "Year": "1969",
      "Director": "Ozualdo Ribeiro Candeias",
      "DirectorArray": [
        "Ozualdo Ribeiro Candeias"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2356",
      "databaseFilmTitle": "My Neighbor Totoro",
      "FilmTitle": "My Neighbor Totoro",
      "AlternateTitle": "Tonari no Totoro",
      "TitleArray": [
        "My Neighbor Totoro",
        "Tonari no Totoro"
      ],
      "Year": "1988",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "72",
      "2022votes": "37"
    },
    {
      "key": "2357",
      "databaseFilmTitle": "My Night at Maud's",
      "FilmTitle": "My Night at Maud's",
      "AlternateTitle": "Ma nuit chez Maud",
      "TitleArray": [
        "My Night at Maud's",
        "Ma nuit chez Maud"
      ],
      "Year": "1969",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2358",
      "databaseFilmTitle": "My Nights Are More Beautiful Than Your Days",
      "FilmTitle": "My Nights Are More Beautiful Than Your Days",
      "AlternateTitle": "Mes nuits sont plus belles que vos jours",
      "TitleArray": [
        "My Nights Are More Beautiful Than Your Days",
        "Mes nuits sont plus belles que vos jours"
      ],
      "Year": "1989",
      "Director": "Andrzej Żuławski",
      "DirectorArray": [
        "Andrzej Żuławski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2359",
      "databaseFilmTitle": "My Own Private Idaho",
      "FilmTitle": "My Own Private Idaho",
      "AlternateTitle": "",
      "TitleArray": [
        "My Own Private Idaho"
      ],
      "Year": "1991",
      "Director": "Gus Van Sant",
      "DirectorArray": [
        "Gus Van Sant"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2360",
      "databaseFilmTitle": "My Son, the Hero",
      "FilmTitle": "My Son, the Hero",
      "AlternateTitle": "Los hermanos del heirro",
      "TitleArray": [
        "My Son, the Hero",
        "Los hermanos del heirro"
      ],
      "Year": "1961",
      "Director": "Ismael Rodríguez",
      "DirectorArray": [
        "Ismael Rodríguez"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2361",
      "databaseFilmTitle": "My Survival as an Aboriginal",
      "FilmTitle": "My Survival as an Aboriginal",
      "AlternateTitle": "",
      "TitleArray": [
        "My Survival as an Aboriginal"
      ],
      "Year": "1979",
      "Director": "Essie Coffey",
      "DirectorArray": [
        "Essie Coffey"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2362",
      "databaseFilmTitle": "My Twentieth Century",
      "FilmTitle": "My Twentieth Century",
      "AlternateTitle": "Az én XX. századom",
      "TitleArray": [
        "My Twentieth Century",
        "Az én XX. századom"
      ],
      "Year": "1989",
      "Director": "Ildikó Enyedi",
      "DirectorArray": [
        "Ildikó Enyedi"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2363",
      "databaseFilmTitle": "My Universities",
      "FilmTitle": "My Universities",
      "AlternateTitle": "",
      "TitleArray": [
        "My Universities"
      ],
      "Year": "1940",
      "Director": "Mark Donskoy",
      "DirectorArray": [
        "Mark Donskoy"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2364",
      "databaseFilmTitle": "My Winnipeg",
      "FilmTitle": "My Winnipeg",
      "AlternateTitle": "",
      "TitleArray": [
        "My Winnipeg"
      ],
      "Year": "2007",
      "Director": "Guy Maddin",
      "DirectorArray": [
        "Guy Maddin"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2365",
      "databaseFilmTitle": "Mysteries of Lisbon",
      "FilmTitle": "Mysteries of Lisbon",
      "AlternateTitle": "Mistérios de Lisboa",
      "TitleArray": [
        "Mysteries of Lisbon",
        "Mistérios de Lisboa"
      ],
      "Year": "2010",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2366",
      "databaseFilmTitle": "Mysterious Mr. Moto",
      "FilmTitle": "Mysterious Mr. Moto",
      "AlternateTitle": "",
      "TitleArray": [
        "Mysterious Mr. Moto"
      ],
      "Year": "1938",
      "Director": "Norman Foster",
      "DirectorArray": [
        "Norman Foster"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2367",
      "databaseFilmTitle": "Mysterious Object at Noon",
      "FilmTitle": "Mysterious Object at Noon",
      "AlternateTitle": "Dokfa nai meuman",
      "TitleArray": [
        "Mysterious Object at Noon",
        "Dokfa nai meuman"
      ],
      "Year": "2000",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2368",
      "databaseFilmTitle": "Mysterious Skin",
      "FilmTitle": "Mysterious Skin",
      "AlternateTitle": "",
      "TitleArray": [
        "Mysterious Skin"
      ],
      "Year": "2004",
      "Director": "Greg Araki",
      "DirectorArray": [
        "Greg Araki"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2369",
      "databaseFilmTitle": "Mystery Train",
      "FilmTitle": "Mystery Train",
      "AlternateTitle": "",
      "TitleArray": [
        "Mystery Train"
      ],
      "Year": "1989",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2370",
      "databaseFilmTitle": "Nahla",
      "FilmTitle": "Nahla",
      "AlternateTitle": "",
      "TitleArray": [
        "Nahla"
      ],
      "Year": "1979",
      "Director": "Farouk Beloufa",
      "DirectorArray": [
        "Farouk Beloufa"
      ],
      "Country": "Algeria",
      "CountryArray": [
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2371",
      "databaseFilmTitle": "Naked",
      "FilmTitle": "Naked",
      "AlternateTitle": "",
      "TitleArray": [
        "Naked"
      ],
      "Year": "1993",
      "Director": "Mike Leigh",
      "DirectorArray": [
        "Mike Leigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2372",
      "databaseFilmTitle": "Naked Childhood",
      "FilmTitle": "Naked Childhood",
      "AlternateTitle": "L'enfance nue",
      "TitleArray": [
        "Naked Childhood",
        "L'enfance nue"
      ],
      "Year": "1968",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2373",
      "databaseFilmTitle": "Naked Spaces: Living Is Round",
      "FilmTitle": "Naked Spaces: Living Is Round",
      "AlternateTitle": "",
      "TitleArray": [
        "Naked Spaces: Living Is Round"
      ],
      "Year": "1985",
      "Director": "T. Minh-ha Trinh",
      "DirectorArray": [
        "T. Minh-ha Trinh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2374",
      "databaseFilmTitle": "Nana (1926)",
      "FilmTitle": "Nana",
      "AlternateTitle": "",
      "TitleArray": [
        "Nana"
      ],
      "Year": "1926",
      "Director": "Jean Renior",
      "DirectorArray": [
        "Jean Renior"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2375",
      "databaseFilmTitle": "Nana (2011)",
      "FilmTitle": "Nana",
      "AlternateTitle": "",
      "TitleArray": [
        "Nana"
      ],
      "Year": "2011",
      "Director": "Valérie Massadian",
      "DirectorArray": [
        "Valérie Massadian"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2376",
      "databaseFilmTitle": "Nanook of the North",
      "FilmTitle": "Nanook of the North",
      "AlternateTitle": "",
      "TitleArray": [
        "Nanook of the North"
      ],
      "Year": "1922",
      "Director": "Robert J. Flaherty",
      "DirectorArray": [
        "Robert J. Flaherty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2377",
      "databaseFilmTitle": "Napoléon",
      "FilmTitle": "Napoléon",
      "AlternateTitle": "",
      "TitleArray": [
        "Napoléon"
      ],
      "Year": "1927",
      "Director": "Abel Gance",
      "DirectorArray": [
        "Abel Gance"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "2378",
      "databaseFilmTitle": "Nargess",
      "FilmTitle": "Nargess",
      "AlternateTitle": "",
      "TitleArray": [
        "Nargess"
      ],
      "Year": "1992",
      "Director": "Rakhshan Bani-Etemad",
      "DirectorArray": [
        "Rakhshan Bani-Etemad"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2379",
      "databaseFilmTitle": "Narita: Heta Village",
      "FilmTitle": "Narita: Heta Village",
      "AlternateTitle": "Sanrizuka: Heta buraku",
      "TitleArray": [
        "Narita: Heta Village",
        "Sanrizuka: Heta buraku"
      ],
      "Year": "1973",
      "Director": "Shinsuke Ogawa",
      "DirectorArray": [
        "Shinsuke Ogawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2380",
      "databaseFilmTitle": "Narita: Peasants of the Second Fortress",
      "FilmTitle": "Narita: Peasants of the Second Fortress",
      "AlternateTitle": "Sanrizuka: Dainitoride no hitobito",
      "TitleArray": [
        "Narita: Peasants of the Second Fortress",
        "Sanrizuka: Dainitoride no hitobito"
      ],
      "Year": "1971",
      "Director": "Shinsuke Ogawa",
      "DirectorArray": [
        "Shinsuke Ogawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2381",
      "databaseFilmTitle": "Nashville",
      "FilmTitle": "Nashville",
      "AlternateTitle": "",
      "TitleArray": [
        "Nashville"
      ],
      "Year": "1975",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "73",
      "2012votes": "22",
      "2022rank": "114",
      "2022votes": "27"
    },
    {
      "key": "2382",
      "databaseFilmTitle": "Nathalie Granger",
      "FilmTitle": "Nathalie Granger",
      "AlternateTitle": "",
      "TitleArray": [
        "Nathalie Granger"
      ],
      "Year": "1972",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2383",
      "databaseFilmTitle": "Natural Born Killers",
      "FilmTitle": "Natural Born Killers",
      "AlternateTitle": "",
      "TitleArray": [
        "Natural Born Killers"
      ],
      "Year": "1994",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2384",
      "databaseFilmTitle": "Nausicaä of the Valley of the Wind",
      "FilmTitle": "Nausicaä of the Valley of the Wind",
      "AlternateTitle": "Kaze no tano no Naushika",
      "TitleArray": [
        "Nausicaä of the Valley of the Wind",
        "Kaze no tano no Naushika"
      ],
      "Year": "1984",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2385",
      "databaseFilmTitle": "Nazareno Cruz and the Wolf",
      "FilmTitle": "Nazareno Cruz and the Wolf",
      "AlternateTitle": "Nazareno Cruz y el lobo",
      "TitleArray": [
        "Nazareno Cruz and the Wolf",
        "Nazareno Cruz y el lobo"
      ],
      "Year": "1975",
      "Director": "Leonardo Favio",
      "DirectorArray": [
        "Leonardo Favio"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2386",
      "databaseFilmTitle": "Nazarin",
      "FilmTitle": "Nazarin",
      "AlternateTitle": "",
      "TitleArray": [
        "Nazarin"
      ],
      "Year": "1959",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2387",
      "databaseFilmTitle": "Ne change rien",
      "FilmTitle": "Ne change rien",
      "AlternateTitle": "",
      "TitleArray": [
        "Ne change rien"
      ],
      "Year": "2009",
      "Director": "Pedro Costa",
      "DirectorArray": [
        "Pedro Costa"
      ],
      "Country": "France, Portugal",
      "CountryArray": [
        "France",
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2388",
      "databaseFilmTitle": "Near Dark",
      "FilmTitle": "Near Dark",
      "AlternateTitle": "",
      "TitleArray": [
        "Near Dark"
      ],
      "Year": "1987",
      "Director": "Kathryn Bigelow",
      "DirectorArray": [
        "Kathryn Bigelow"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2389",
      "databaseFilmTitle": "Near Death",
      "FilmTitle": "Near Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Near Death"
      ],
      "Year": "1989",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2390",
      "databaseFilmTitle": "Neighbors",
      "FilmTitle": "Neighbors",
      "AlternateTitle": "",
      "TitleArray": [
        "Neighbors"
      ],
      "Year": "1920",
      "Director": "Buster Keaton, Edward F. Cline",
      "DirectorArray": [
        "Buster Keaton",
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2391",
      "databaseFilmTitle": "Neighbouring Sounds",
      "FilmTitle": "Neighbouring Sounds",
      "AlternateTitle": "O Som ao Redor",
      "TitleArray": [
        "Neighbouring Sounds",
        "O Som ao Redor"
      ],
      "Year": "2012",
      "Director": "Kleber Mendonça Filho",
      "DirectorArray": [
        "Kleber Mendonça Filho"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2392",
      "databaseFilmTitle": "Nekromantik",
      "FilmTitle": "Nekromantik",
      "AlternateTitle": "",
      "TitleArray": [
        "Nekromantik"
      ],
      "Year": "1988",
      "Director": "Jörg Buttgereit",
      "DirectorArray": [
        "Jörg Buttgereit"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2393",
      "databaseFilmTitle": "Nelly & Monsieur Arnaud",
      "FilmTitle": "Nelly & Monsieur Arnaud",
      "AlternateTitle": "Nelly et Monsieur Arnaud",
      "TitleArray": [
        "Nelly & Monsieur Arnaud",
        "Nelly et Monsieur Arnaud"
      ],
      "Year": "1995",
      "Director": "Claude Sautet",
      "DirectorArray": [
        "Claude Sautet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2394",
      "databaseFilmTitle": "Nervous Translation",
      "FilmTitle": "Nervous Translation",
      "AlternateTitle": "",
      "TitleArray": [
        "Nervous Translation"
      ],
      "Year": "2017",
      "Director": "Shireen Seno",
      "DirectorArray": [
        "Shireen Seno"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2395",
      "databaseFilmTitle": "Network",
      "FilmTitle": "Network",
      "AlternateTitle": "",
      "TitleArray": [
        "Network"
      ],
      "Year": "1976",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2396",
      "databaseFilmTitle": "Neurasia",
      "FilmTitle": "Neurasia",
      "AlternateTitle": "",
      "TitleArray": [
        "Neurasia"
      ],
      "Year": "1969",
      "Director": "Werner Schroeter",
      "DirectorArray": [
        "Werner Schroeter"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2397",
      "databaseFilmTitle": "Never Give a Sucker an Even Break",
      "FilmTitle": "Never Give a Sucker an Even Break",
      "AlternateTitle": "",
      "TitleArray": [
        "Never Give a Sucker an Even Break"
      ],
      "Year": "1941",
      "Director": "Edward F. Cline",
      "DirectorArray": [
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2398",
      "databaseFilmTitle": "Never Let Me Go",
      "FilmTitle": "Never Let Me Go",
      "AlternateTitle": "",
      "TitleArray": [
        "Never Let Me Go"
      ],
      "Year": "2010",
      "Director": "Mark Romanek",
      "DirectorArray": [
        "Mark Romanek"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2399",
      "databaseFilmTitle": "Never Rarely Sometimes Always",
      "FilmTitle": "Never Rarely Sometimes Always",
      "AlternateTitle": "",
      "TitleArray": [
        "Never Rarely Sometimes Always"
      ],
      "Year": "2020",
      "Director": "Eliza Hittman",
      "DirectorArray": [
        "Eliza Hittman"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2400",
      "databaseFilmTitle": "New Hyperion or Liberty, Equality, Brotherhood",
      "FilmTitle": "New Hyperion or Liberty, Equality, Brotherhood",
      "AlternateTitle": "Nový Hyperion aneb Volnost, rovnost, bratrství",
      "TitleArray": [
        "New Hyperion or Liberty, Equality, Brotherhood",
        "Nový Hyperion aneb Volnost, rovnost, bratrství"
      ],
      "Year": "1992",
      "Director": "Karel Vachek",
      "DirectorArray": [
        "Karel Vachek"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2401",
      "databaseFilmTitle": "New Order: The Perfect Kiss [MV]",
      "FilmTitle": "New Order: The Perfect Kiss [MV]",
      "AlternateTitle": "",
      "TitleArray": [
        "New Order: The Perfect Kiss [MV]"
      ],
      "Year": "1985",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2402",
      "databaseFilmTitle": "New Rose Hotel",
      "FilmTitle": "New Rose Hotel",
      "AlternateTitle": "",
      "TitleArray": [
        "New Rose Hotel"
      ],
      "Year": "1998",
      "Director": "Abel Ferrara",
      "DirectorArray": [
        "Abel Ferrara"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2403",
      "databaseFilmTitle": "New Year's Eve",
      "FilmTitle": "New Year's Eve",
      "AlternateTitle": "Sylvester: Tragödie einer Nacht",
      "TitleArray": [
        "New Year's Eve",
        "Sylvester: Tragödie einer Nacht"
      ],
      "Year": "1924",
      "Director": "Lupa Pick",
      "DirectorArray": [
        "Lupa Pick"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2404",
      "databaseFilmTitle": "New York Portrait, Chapter II",
      "FilmTitle": "New York Portrait, Chapter II",
      "AlternateTitle": "",
      "TitleArray": [
        "New York Portrait, Chapter II"
      ],
      "Year": "1981",
      "Director": "Petter Hutton",
      "DirectorArray": [
        "Petter Hutton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2405",
      "databaseFilmTitle": "New York street scenes and noises--outtakes",
      "FilmTitle": "New York street scenes and noises--outtakes",
      "AlternateTitle": "",
      "TitleArray": [
        "New York street scenes and noises--outtakes"
      ],
      "Year": "1929",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2406",
      "databaseFilmTitle": "New York, New York",
      "FilmTitle": "New York, New York",
      "AlternateTitle": "",
      "TitleArray": [
        "New York, New York"
      ],
      "Year": "1977",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2407",
      "databaseFilmTitle": "News from Home",
      "FilmTitle": "News from Home",
      "AlternateTitle": "",
      "TitleArray": [
        "News from Home"
      ],
      "Year": "1976",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "52",
      "2022votes": "45"
    },
    {
      "key": "2408",
      "databaseFilmTitle": "News from Ideological Antiquity",
      "FilmTitle": "News from Ideological Antiquity",
      "AlternateTitle": "Nachrichten aus der ideologischen Antike - Marx/Eisenstein/Das Kapital",
      "TitleArray": [
        "News from Ideological Antiquity",
        "Nachrichten aus der ideologischen Antike - Marx/Eisenstein/Das Kapital"
      ],
      "Year": "2008",
      "Director": "Alexander Kluge",
      "DirectorArray": [
        "Alexander Kluge"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2409",
      "databaseFilmTitle": "News Items",
      "FilmTitle": "News Items",
      "AlternateTitle": "Faits divers",
      "TitleArray": [
        "News Items",
        "Faits divers"
      ],
      "Year": "1983",
      "Director": "Raymond Depardon",
      "DirectorArray": [
        "Raymond Depardon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2410",
      "databaseFilmTitle": "Ngati",
      "FilmTitle": "Ngati",
      "AlternateTitle": "",
      "TitleArray": [
        "Ngati"
      ],
      "Year": "1987",
      "Director": "Barry Barclay",
      "DirectorArray": [
        "Barry Barclay"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2411",
      "databaseFilmTitle": "Niagara",
      "FilmTitle": "Niagara",
      "AlternateTitle": "",
      "TitleArray": [
        "Niagara"
      ],
      "Year": "1953",
      "Director": "Henry Hathaway",
      "DirectorArray": [
        "Henry Hathaway"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2412",
      "databaseFilmTitle": "Nice Coloured Girls",
      "FilmTitle": "Nice Coloured Girls",
      "AlternateTitle": "",
      "TitleArray": [
        "Nice Coloured Girls"
      ],
      "Year": "1987",
      "Director": "Tracey Moffat",
      "DirectorArray": [
        "Tracey Moffat"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2413",
      "databaseFilmTitle": "Night and Day",
      "FilmTitle": "Night and Day",
      "AlternateTitle": "Nuit et jour",
      "TitleArray": [
        "Night and Day",
        "Nuit et jour"
      ],
      "Year": "1991",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2414",
      "databaseFilmTitle": "Night and Fog",
      "FilmTitle": "Night and Fog",
      "AlternateTitle": "Nuit et brouillard",
      "TitleArray": [
        "Night and Fog",
        "Nuit et brouillard"
      ],
      "Year": "1956",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2415",
      "databaseFilmTitle": "Night and Fog in Japan",
      "FilmTitle": "Night and Fog in Japan",
      "AlternateTitle": "Night and Fog in Japan",
      "TitleArray": [
        "Night and Fog in Japan",
        "Night and Fog in Japan"
      ],
      "Year": "1960",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2416",
      "databaseFilmTitle": "Night and the City",
      "FilmTitle": "Night and the City",
      "AlternateTitle": "",
      "TitleArray": [
        "Night and the City"
      ],
      "Year": "1950",
      "Director": "Jules Dassin",
      "DirectorArray": [
        "Jules Dassin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2417",
      "databaseFilmTitle": "Night at the Crossroads",
      "FilmTitle": "Night at the Crossroads",
      "AlternateTitle": "La nuit du carrefour",
      "TitleArray": [
        "Night at the Crossroads",
        "La nuit du carrefour"
      ],
      "Year": "1932",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2418",
      "databaseFilmTitle": "Night Cries: A Rural Tragedy",
      "FilmTitle": "Night Cries: A Rural Tragedy",
      "AlternateTitle": "",
      "TitleArray": [
        "Night Cries: A Rural Tragedy"
      ],
      "Year": "1990",
      "Director": "Tracey Moffatt",
      "DirectorArray": [
        "Tracey Moffatt"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2419",
      "databaseFilmTitle": "Night Falls on Manhattan",
      "FilmTitle": "Night Falls on Manhattan",
      "AlternateTitle": "",
      "TitleArray": [
        "Night Falls on Manhattan"
      ],
      "Year": "1996",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2420",
      "databaseFilmTitle": "Night Games",
      "FilmTitle": "Night Games",
      "AlternateTitle": "Nattlek",
      "TitleArray": [
        "Night Games",
        "Nattlek"
      ],
      "Year": "1966",
      "Director": "Mai Zetterling",
      "DirectorArray": [
        "Mai Zetterling"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2421",
      "databaseFilmTitle": "Night Mail",
      "FilmTitle": "Night Mail",
      "AlternateTitle": "",
      "TitleArray": [
        "Night Mail"
      ],
      "Year": "1936",
      "Director": "Harry Watt, Basil Wright",
      "DirectorArray": [
        "Harry Watt",
        "Basil Wright"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2422",
      "databaseFilmTitle": "Night Moves",
      "FilmTitle": "Night Moves",
      "AlternateTitle": "",
      "TitleArray": [
        "Night Moves"
      ],
      "Year": "1975",
      "Director": "Arthur Penn",
      "DirectorArray": [
        "Arthur Penn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2423",
      "databaseFilmTitle": "Night of the Demon",
      "FilmTitle": "Night of the Demon",
      "AlternateTitle": "",
      "TitleArray": [
        "Night of the Demon"
      ],
      "Year": "1957",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2424",
      "databaseFilmTitle": "Night of the Hunter (1991)",
      "FilmTitle": "Night of the Hunter",
      "AlternateTitle": "",
      "TitleArray": [
        "Night of the Hunter"
      ],
      "Year": "1991",
      "Director": "David Greene",
      "DirectorArray": [
        "David Greene"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2425",
      "databaseFilmTitle": "Night of the Living Dead",
      "FilmTitle": "Night of the Living Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "Night of the Living Dead"
      ],
      "Year": "1968",
      "Director": "George A. Romero",
      "DirectorArray": [
        "George A. Romero"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2426",
      "databaseFilmTitle": "Night on Earth",
      "FilmTitle": "Night on Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "Night on Earth"
      ],
      "Year": "1991",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2427",
      "databaseFilmTitle": "Night Train",
      "FilmTitle": "Night Train",
      "AlternateTitle": "Pociag",
      "TitleArray": [
        "Night Train",
        "Pociag"
      ],
      "Year": "1959",
      "Director": "Jerzy Kawalerowicz",
      "DirectorArray": [
        "Jerzy Kawalerowicz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2428",
      "databaseFilmTitle": "Nightmare Alley",
      "FilmTitle": "Nightmare Alley",
      "AlternateTitle": "",
      "TitleArray": [
        "Nightmare Alley"
      ],
      "Year": "1947",
      "Director": "Edmund Goulding",
      "DirectorArray": [
        "Edmund Goulding"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2429",
      "databaseFilmTitle": "Nights and Weekends",
      "FilmTitle": "Nights and Weekends",
      "AlternateTitle": "",
      "TitleArray": [
        "Nights and Weekends"
      ],
      "Year": "2008",
      "Director": "Gerta Gerwig, Joe Swanberg",
      "DirectorArray": [
        "Gerta Gerwig",
        "Joe Swanberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2430",
      "databaseFilmTitle": "Nights of Cabiria",
      "FilmTitle": "Nights of Cabiria",
      "AlternateTitle": "Le notti di Cabiria",
      "TitleArray": [
        "Nights of Cabiria",
        "Le notti di Cabiria"
      ],
      "Year": "1957",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2431",
      "databaseFilmTitle": "Nightsongs",
      "FilmTitle": "Nightsongs",
      "AlternateTitle": "Die Nacht singt ihre Lieder",
      "TitleArray": [
        "Nightsongs",
        "Die Nacht singt ihre Lieder"
      ],
      "Year": "2004",
      "Director": "Romuald Karmakar",
      "DirectorArray": [
        "Romuald Karmakar"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2432",
      "databaseFilmTitle": "Niki and Flo",
      "FilmTitle": "Niki and Flo",
      "AlternateTitle": "Niki Ardelean, colonel în rezerva",
      "TitleArray": [
        "Niki and Flo",
        "Niki Ardelean, colonel în rezerva"
      ],
      "Year": "2003",
      "Director": "Lucian Pintilie",
      "DirectorArray": [
        "Lucian Pintilie"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2433",
      "databaseFilmTitle": "Nikita Lavretski",
      "FilmTitle": "Nikita Lavretski",
      "AlternateTitle": "",
      "TitleArray": [
        "Nikita Lavretski"
      ],
      "Year": "2019",
      "Director": "Nikita Lavretski",
      "DirectorArray": [
        "Nikita Lavretski"
      ],
      "Country": "Belarus",
      "CountryArray": [
        "Belarus"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2434",
      "databaseFilmTitle": "Nine Queens",
      "FilmTitle": "Nine Queens",
      "AlternateTitle": "Nueve reinas",
      "TitleArray": [
        "Nine Queens",
        "Nueve reinas"
      ],
      "Year": "2000",
      "Director": "Fabián Bielinsky",
      "DirectorArray": [
        "Fabián Bielinsky"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2435",
      "databaseFilmTitle": "Ninotchka",
      "FilmTitle": "Ninotchka",
      "AlternateTitle": "",
      "TitleArray": [
        "Ninotchka"
      ],
      "Year": "1939",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2436",
      "databaseFilmTitle": "Nitrate Kisses",
      "FilmTitle": "Nitrate Kisses",
      "AlternateTitle": "",
      "TitleArray": [
        "Nitrate Kisses"
      ],
      "Year": "1992",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2437",
      "databaseFilmTitle": "No",
      "FilmTitle": "No",
      "AlternateTitle": "",
      "TitleArray": [
        "No"
      ],
      "Year": "2012",
      "Director": "Pablo Larraín",
      "DirectorArray": [
        "Pablo Larraín"
      ],
      "Country": "Chile, Mexico",
      "CountryArray": [
        "Chile",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2438",
      "databaseFilmTitle": "No Country for Old Men",
      "FilmTitle": "No Country for Old Men",
      "AlternateTitle": "",
      "TitleArray": [
        "No Country for Old Men"
      ],
      "Year": "2007",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2439",
      "databaseFilmTitle": "No End",
      "FilmTitle": "No End",
      "AlternateTitle": "Bez końca",
      "TitleArray": [
        "No End",
        "Bez końca"
      ],
      "Year": "1985",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2440",
      "databaseFilmTitle": "No Greater Glory",
      "FilmTitle": "No Greater Glory",
      "AlternateTitle": "",
      "TitleArray": [
        "No Greater Glory"
      ],
      "Year": "1934",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2441",
      "databaseFilmTitle": "No Home Movie",
      "FilmTitle": "No Home Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "No Home Movie"
      ],
      "Year": "2015",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2442",
      "databaseFilmTitle": "No Place Like Home",
      "FilmTitle": "No Place Like Home",
      "AlternateTitle": "",
      "TitleArray": [
        "No Place Like Home"
      ],
      "Year": "2006",
      "Director": "Perry Henzell",
      "DirectorArray": [
        "Perry Henzell"
      ],
      "Country": "United States, Jamaica",
      "CountryArray": [
        "United States",
        "Jamaica"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2443",
      "databaseFilmTitle": "No Regret",
      "FilmTitle": "No Regret",
      "AlternateTitle": "Non, je ne regrette rien",
      "TitleArray": [
        "No Regret",
        "Non, je ne regrette rien"
      ],
      "Year": "1993",
      "Director": "Marlon Riggs",
      "DirectorArray": [
        "Marlon Riggs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2444",
      "databaseFilmTitle": "No Sex Last Night",
      "FilmTitle": "No Sex Last Night",
      "AlternateTitle": "",
      "TitleArray": [
        "No Sex Last Night"
      ],
      "Year": "1996",
      "Director": "Sophie Calle, Greg Shephard",
      "DirectorArray": [
        "Sophie Calle",
        "Greg Shephard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2445",
      "databaseFilmTitle": "Noël de guerre",
      "FilmTitle": "Noël de guerre",
      "AlternateTitle": "",
      "TitleArray": [
        "Noël de guerre"
      ],
      "Year": "1918",
      "Director": "(unknown)",
      "DirectorArray": [
        "(unknown)"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2446",
      "databaseFilmTitle": "Nomadland",
      "FilmTitle": "Nomadland",
      "AlternateTitle": "",
      "TitleArray": [
        "Nomadland"
      ],
      "Year": "2020",
      "Director": "Chloé Zhao",
      "DirectorArray": [
        "Chloé Zhao"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2447",
      "databaseFilmTitle": "Noon",
      "FilmTitle": "Noon",
      "AlternateTitle": "Meio-Dia",
      "TitleArray": [
        "Noon",
        "Meio-Dia"
      ],
      "Year": "1969",
      "Director": "Helena Solberg",
      "DirectorArray": [
        "Helena Solberg"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2448",
      "databaseFilmTitle": "Normal Love",
      "FilmTitle": "Normal Love",
      "AlternateTitle": "",
      "TitleArray": [
        "Normal Love"
      ],
      "Year": "1963",
      "Director": "Jack Smith",
      "DirectorArray": [
        "Jack Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2449",
      "databaseFilmTitle": "North by Northwest",
      "FilmTitle": "North by Northwest",
      "AlternateTitle": "",
      "TitleArray": [
        "North by Northwest"
      ],
      "Year": "1959",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "53",
      "2012votes": "28",
      "2022rank": "45",
      "2022votes": "49"
    },
    {
      "key": "2450",
      "databaseFilmTitle": "Nosferatu",
      "FilmTitle": "Nosferatu",
      "AlternateTitle": "Nosferatu – Eine Symphonie des Grauens",
      "TitleArray": [
        "Nosferatu",
        "Nosferatu – Eine Symphonie des Grauens"
      ],
      "Year": "1922",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "2451",
      "databaseFilmTitle": "Nosferatu the Vampyre",
      "FilmTitle": "Nosferatu the Vampyre",
      "AlternateTitle": "Nosferatu: Phantom der Nacht",
      "TitleArray": [
        "Nosferatu the Vampyre",
        "Nosferatu: Phantom der Nacht"
      ],
      "Year": "1979",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2452",
      "databaseFilmTitle": "Nostalghia",
      "FilmTitle": "Nostalghia",
      "AlternateTitle": "",
      "TitleArray": [
        "Nostalghia"
      ],
      "Year": "1983",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Italy, Soviet Union",
      "CountryArray": [
        "Italy",
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2453",
      "databaseFilmTitle": "Nostalgia for the Light",
      "FilmTitle": "Nostalgia for the Light",
      "AlternateTitle": "Nostalgia de la luz",
      "TitleArray": [
        "Nostalgia for the Light",
        "Nostalgia de la luz"
      ],
      "Year": "2010",
      "Director": "Patricio Guzmán",
      "DirectorArray": [
        "Patricio Guzmán"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2454",
      "databaseFilmTitle": "Not Even Nothing Can Be Free Of Ghosts",
      "FilmTitle": "Not Even Nothing Can Be Free Of Ghosts",
      "AlternateTitle": "",
      "TitleArray": [
        "Not Even Nothing Can Be Free Of Ghosts"
      ],
      "Year": "2016",
      "Director": "Rainer Kohlberger",
      "DirectorArray": [
        "Rainer Kohlberger"
      ],
      "Country": "Austria, Germany",
      "CountryArray": [
        "Austria",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2455",
      "databaseFilmTitle": "Not One Less",
      "FilmTitle": "Not One Less",
      "AlternateTitle": "Yi ge dou bu neng shao",
      "TitleArray": [
        "Not One Less",
        "Yi ge dou bu neng shao"
      ],
      "Year": "1999",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2456",
      "databaseFilmTitle": "Not Reconciled, Or Only Violence Helps Where Violence Rules",
      "FilmTitle": "Not Reconciled, Or Only Violence Helps Where Violence Rules",
      "AlternateTitle": "Nicht versöhnt oder Es hilft nur Gewalt, wo Gewalt herrscht",
      "TitleArray": [
        "Not Reconciled, Or Only Violence Helps Where Violence Rules",
        "Nicht versöhnt oder Es hilft nur Gewalt, wo Gewalt herrscht"
      ],
      "Year": "1965",
      "Director": "Jean-Marie Straub",
      "DirectorArray": [
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2457",
      "databaseFilmTitle": "Not Wanted",
      "FilmTitle": "Not Wanted",
      "AlternateTitle": "",
      "TitleArray": [
        "Not Wanted"
      ],
      "Year": "1949",
      "Director": "Ida Lupino, Elmer Clifton",
      "DirectorArray": [
        "Ida Lupino",
        "Elmer Clifton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2458",
      "databaseFilmTitle": "Notebook",
      "FilmTitle": "Notebook",
      "AlternateTitle": "",
      "TitleArray": [
        "Notebook"
      ],
      "Year": "1963",
      "Director": "Marie Menken",
      "DirectorArray": [
        "Marie Menken"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2459",
      "databaseFilmTitle": "Notes on a True Story",
      "FilmTitle": "Notes on a True Story",
      "AlternateTitle": "Appunti su un fatto di cronaca",
      "TitleArray": [
        "Notes on a True Story",
        "Appunti su un fatto di cronaca"
      ],
      "Year": "1951",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2460",
      "databaseFilmTitle": "Notes on Blindness: Into Darkness",
      "FilmTitle": "Notes on Blindness: Into Darkness",
      "AlternateTitle": "",
      "TitleArray": [
        "Notes on Blindness: Into Darkness"
      ],
      "Year": "2016",
      "Director": "Arnaud Colinart, Amaury La Burthe, Peter Middleton, James Spinney",
      "DirectorArray": [
        "Arnaud Colinart",
        "Amaury La Burthe",
        "Peter Middleton",
        "James Spinney"
      ],
      "Country": "France, United Kingdom",
      "CountryArray": [
        "France",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2461",
      "databaseFilmTitle": "Notes Towards an African Orestes",
      "FilmTitle": "Notes Towards an African Orestes",
      "AlternateTitle": "Appunti per un'Orestiade africana",
      "TitleArray": [
        "Notes Towards an African Orestes",
        "Appunti per un'Orestiade africana"
      ],
      "Year": "1970",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2462",
      "databaseFilmTitle": "Nothing but a Man",
      "FilmTitle": "Nothing but a Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Nothing but a Man"
      ],
      "Year": "1964",
      "Director": "Michael Roemer",
      "DirectorArray": [
        "Michael Roemer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2463",
      "databaseFilmTitle": "Nothing but Time",
      "FilmTitle": "Nothing but Time",
      "AlternateTitle": "Rien que les hueres",
      "TitleArray": [
        "Nothing but Time",
        "Rien que les hueres"
      ],
      "Year": "1926",
      "Director": "Alberto Cavalcanti",
      "DirectorArray": [
        "Alberto Cavalcanti"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2464",
      "databaseFilmTitle": "Nothing Lasts Forever",
      "FilmTitle": "Nothing Lasts Forever",
      "AlternateTitle": "",
      "TitleArray": [
        "Nothing Lasts Forever"
      ],
      "Year": "1984",
      "Director": "Tom Schiller",
      "DirectorArray": [
        "Tom Schiller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2465",
      "databaseFilmTitle": "Nothing Sacred",
      "FilmTitle": "Nothing Sacred",
      "AlternateTitle": "",
      "TitleArray": [
        "Nothing Sacred"
      ],
      "Year": "1937",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2466",
      "databaseFilmTitle": "Notorious",
      "FilmTitle": "Notorious",
      "AlternateTitle": "",
      "TitleArray": [
        "Notorious"
      ],
      "Year": "1946",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "133",
      "2022votes": "22"
    },
    {
      "key": "2467",
      "databaseFilmTitle": "Nouvelle vague",
      "FilmTitle": "Nouvelle vague",
      "AlternateTitle": "",
      "TitleArray": [
        "Nouvelle vague"
      ],
      "Year": "1990",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2468",
      "databaseFilmTitle": "Now, Voyager",
      "FilmTitle": "Now, Voyager",
      "AlternateTitle": "",
      "TitleArray": [
        "Now, Voyager"
      ],
      "Year": "1942",
      "Director": "Irving Rapper",
      "DirectorArray": [
        "Irving Rapper"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2469",
      "databaseFilmTitle": "Now!",
      "FilmTitle": "Now!",
      "AlternateTitle": "",
      "TitleArray": [
        "Now!"
      ],
      "Year": "1965",
      "Director": "Santiago Álvarez",
      "DirectorArray": [
        "Santiago Álvarez"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2470",
      "databaseFilmTitle": "Nowhere",
      "FilmTitle": "Nowhere",
      "AlternateTitle": "",
      "TitleArray": [
        "Nowhere"
      ],
      "Year": "1997",
      "Director": "Gregg Araki",
      "DirectorArray": [
        "Gregg Araki"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2471",
      "databaseFilmTitle": "Nũhũ Yãg Mũ Yõg Hãm: This Land Is Our Land!",
      "FilmTitle": "Nũhũ Yãg Mũ Yõg Hãm: This Land Is Our Land!",
      "AlternateTitle": "Nũhũ yãg mu yõg hãm: Essa Terra É Nossa!",
      "TitleArray": [
        "Nũhũ Yãg Mũ Yõg Hãm: This Land Is Our Land!",
        "Nũhũ yãg mu yõg hãm: Essa Terra É Nossa!"
      ],
      "Year": "2020",
      "Director": "Isael Maxakali, Sueli Maxakali, Carolina Canguçu, Roberto Romero",
      "DirectorArray": [
        "Isael Maxakali",
        "Sueli Maxakali",
        "Carolina Canguçu",
        "Roberto Romero"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2472",
      "databaseFilmTitle": "Numéro deux",
      "FilmTitle": "Numéro deux",
      "AlternateTitle": "",
      "TitleArray": [
        "Numéro deux"
      ],
      "Year": "1975",
      "Director": "Jean-Luc Godard, Anne-Marie Miéville",
      "DirectorArray": [
        "Jean-Luc Godard",
        "Anne-Marie Miéville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2473",
      "databaseFilmTitle": "Numéro zéro",
      "FilmTitle": "Numéro zéro",
      "AlternateTitle": "",
      "TitleArray": [
        "Numéro zéro"
      ],
      "Year": "1971",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2474",
      "databaseFilmTitle": "Nuts in May",
      "FilmTitle": "Nuts in May",
      "AlternateTitle": "Play for Today: Nuts in May",
      "TitleArray": [
        "Nuts in May",
        "Play for Today: Nuts in May"
      ],
      "Year": "1976",
      "Director": "Mike Leigh",
      "DirectorArray": [
        "Mike Leigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2475",
      "databaseFilmTitle": "O Amor Natural",
      "FilmTitle": "O Amor Natural",
      "AlternateTitle": "",
      "TitleArray": [
        "O Amor Natural"
      ],
      "Year": "1996",
      "Director": "Heddy Honigmann",
      "DirectorArray": [
        "Heddy Honigmann"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2476",
      "databaseFilmTitle": "O Brother, Where Art Thou?",
      "FilmTitle": "O Brother, Where Art Thou?",
      "AlternateTitle": "",
      "TitleArray": [
        "O Brother, Where Art Thou?"
      ],
      "Year": "2000",
      "Director": "Joel Coen, Ethan Coen",
      "DirectorArray": [
        "Joel Coen",
        "Ethan Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2477",
      "databaseFilmTitle": "O Dreamland",
      "FilmTitle": "O Dreamland",
      "AlternateTitle": "",
      "TitleArray": [
        "O Dreamland"
      ],
      "Year": "1953",
      "Director": "Lindsay Anderson",
      "DirectorArray": [
        "Lindsay Anderson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2478",
      "databaseFilmTitle": "O Fantasma",
      "FilmTitle": "O Fantasma",
      "AlternateTitle": "",
      "TitleArray": [
        "O Fantasma"
      ],
      "Year": "2000",
      "Director": "João Pedro Rodrigues",
      "DirectorArray": [
        "João Pedro Rodrigues"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2479",
      "databaseFilmTitle": "O Lucky Man!",
      "FilmTitle": "O Lucky Man!",
      "AlternateTitle": "",
      "TitleArray": [
        "O Lucky Man!"
      ],
      "Year": "1973",
      "Director": "Lindsay Anderson",
      "DirectorArray": [
        "Lindsay Anderson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2480",
      "databaseFilmTitle": "O. J.: Made in America",
      "FilmTitle": "O. J.: Made in America",
      "AlternateTitle": "",
      "TitleArray": [
        "O. J.: Made in America"
      ],
      "Year": "2016",
      "Director": "Ezra Edelman",
      "DirectorArray": [
        "Ezra Edelman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2481",
      "databaseFilmTitle": "Objective, Burma!",
      "FilmTitle": "Objective, Burma!",
      "AlternateTitle": "",
      "TitleArray": [
        "Objective, Burma!"
      ],
      "Year": "1945",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2482",
      "databaseFilmTitle": "Obscure Light",
      "FilmTitle": "Obscure Light",
      "AlternateTitle": "Luz obscura",
      "TitleArray": [
        "Obscure Light",
        "Luz obscura"
      ],
      "Year": "2017",
      "Director": "Susana de Sousa Dias",
      "DirectorArray": [
        "Susana de Sousa Dias"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2483",
      "databaseFilmTitle": "Occidente",
      "FilmTitle": "Occidente",
      "AlternateTitle": "",
      "TitleArray": [
        "Occidente"
      ],
      "Year": "2015",
      "Director": "Ana Vaz",
      "DirectorArray": [
        "Ana Vaz"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2484",
      "databaseFilmTitle": "October (Ten Days That Shook the World)",
      "FilmTitle": "October (Ten Days That Shook the World)",
      "AlternateTitle": "",
      "TitleArray": [
        "October (Ten Days That Shook the World)"
      ],
      "Year": "1927",
      "Director": "Sergei Eisenstein, Grigori Aleksandrov",
      "DirectorArray": [
        "Sergei Eisenstein",
        "Grigori Aleksandrov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2485",
      "databaseFilmTitle": "Odd Man Out",
      "FilmTitle": "Odd Man Out",
      "AlternateTitle": "",
      "TitleArray": [
        "Odd Man Out"
      ],
      "Year": "1947",
      "Director": "Carol Reed",
      "DirectorArray": [
        "Carol Reed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2486",
      "databaseFilmTitle": "Oedipus Rex",
      "FilmTitle": "Oedipus Rex",
      "AlternateTitle": "Edipo Re",
      "TitleArray": [
        "Oedipus Rex",
        "Edipo Re"
      ],
      "Year": "1967",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2487",
      "databaseFilmTitle": "Of Freaks and Men",
      "FilmTitle": "Of Freaks and Men",
      "AlternateTitle": "Pro urodov i lyudey",
      "TitleArray": [
        "Of Freaks and Men",
        "Pro urodov i lyudey"
      ],
      "Year": "1998",
      "Director": "Aleksey Balabanov",
      "DirectorArray": [
        "Aleksey Balabanov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2488",
      "databaseFilmTitle": "Of Gods and Men",
      "FilmTitle": "Of Gods and Men",
      "AlternateTitle": "Des hommes et des dieux",
      "TitleArray": [
        "Of Gods and Men",
        "Des hommes et des dieux"
      ],
      "Year": "2010",
      "Director": "Xavier Beauvois",
      "DirectorArray": [
        "Xavier Beauvois"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2489",
      "databaseFilmTitle": "Of Gods and the Undead",
      "FilmTitle": "Of Gods and the Undead",
      "AlternateTitle": "Os Deuses e os Mortos",
      "TitleArray": [
        "Of Gods and the Undead",
        "Os Deuses e os Mortos"
      ],
      "Year": "1970",
      "Director": "Ruy Guerra",
      "DirectorArray": [
        "Ruy Guerra"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2490",
      "databaseFilmTitle": "Of Whales, the Moon and Men",
      "FilmTitle": "Of Whales, the Moon and Men",
      "AlternateTitle": "Pour la suite du monde",
      "TitleArray": [
        "Of Whales, the Moon and Men",
        "Pour la suite du monde"
      ],
      "Year": "1963",
      "Director": "Michel Brault, Marcel Carrière, Pierre Perrault",
      "DirectorArray": [
        "Michel Brault",
        "Marcel Carrière",
        "Pierre Perrault"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2491",
      "databaseFilmTitle": "Office Space",
      "FilmTitle": "Office Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Office Space"
      ],
      "Year": "1999",
      "Director": "Mike Judge",
      "DirectorArray": [
        "Mike Judge"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2492",
      "databaseFilmTitle": "Offside",
      "FilmTitle": "Offside",
      "AlternateTitle": "",
      "TitleArray": [
        "Offside"
      ],
      "Year": "2006",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2493",
      "databaseFilmTitle": "Ofrenda",
      "FilmTitle": "Ofrenda",
      "AlternateTitle": "",
      "TitleArray": [
        "Ofrenda"
      ],
      "Year": "1978",
      "Director": "Claudio Caldini",
      "DirectorArray": [
        "Claudio Caldini"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2494",
      "databaseFilmTitle": "Oh Willy…",
      "FilmTitle": "Oh Willy…",
      "AlternateTitle": "",
      "TitleArray": [
        "Oh Willy…"
      ],
      "Year": "2012",
      "Director": "Emma De Swaef, Marc James Roels",
      "DirectorArray": [
        "Emma De Swaef",
        "Marc James Roels"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2495",
      "databaseFilmTitle": "Oh, Sun",
      "FilmTitle": "Oh, Sun",
      "AlternateTitle": "Soleil Ô",
      "TitleArray": [
        "Oh, Sun",
        "Soleil Ô"
      ],
      "Year": "1970",
      "Director": "Med Hondo",
      "DirectorArray": [
        "Med Hondo"
      ],
      "Country": "Mauritania, France",
      "CountryArray": [
        "Mauritania",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2496",
      "databaseFilmTitle": "Oh! Man",
      "FilmTitle": "Oh! Man",
      "AlternateTitle": "Oh! Uoma",
      "TitleArray": [
        "Oh! Man",
        "Oh! Uoma"
      ],
      "Year": "2004",
      "Director": "Yervant Gianikian, Angela Ricci Lucchi",
      "DirectorArray": [
        "Yervant Gianikian",
        "Angela Ricci Lucchi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2497",
      "databaseFilmTitle": "Oki's Movie",
      "FilmTitle": "Oki's Movie",
      "AlternateTitle": "Ok-hui-ui Yeonghwa",
      "TitleArray": [
        "Oki's Movie",
        "Ok-hui-ui Yeonghwa"
      ],
      "Year": "2010",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2498",
      "databaseFilmTitle": "Old and New",
      "FilmTitle": "Old and New",
      "AlternateTitle": "",
      "TitleArray": [
        "Old and New"
      ],
      "Year": "1929",
      "Director": "Sergei Eisenstein, Grigori Aleksandrov",
      "DirectorArray": [
        "Sergei Eisenstein",
        "Grigori Aleksandrov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2499",
      "databaseFilmTitle": "Old Joy",
      "FilmTitle": "Old Joy",
      "AlternateTitle": "",
      "TitleArray": [
        "Old Joy"
      ],
      "Year": "2006",
      "Director": "Kelly Reichardt",
      "DirectorArray": [
        "Kelly Reichardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2500",
      "databaseFilmTitle": "Oldboy",
      "FilmTitle": "Oldboy",
      "AlternateTitle": "",
      "TitleArray": [
        "Oldboy"
      ],
      "Year": "2003",
      "Director": "Park Chan-wook",
      "DirectorArray": [
        "Park Chan-wook"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2501",
      "databaseFilmTitle": "Oliver Twist",
      "FilmTitle": "Oliver Twist",
      "AlternateTitle": "",
      "TitleArray": [
        "Oliver Twist"
      ],
      "Year": "1948",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2502",
      "databaseFilmTitle": "Olivia",
      "FilmTitle": "Olivia",
      "AlternateTitle": "",
      "TitleArray": [
        "Olivia"
      ],
      "Year": "1951",
      "Director": "Jacqueline Audry",
      "DirectorArray": [
        "Jacqueline Audry"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2503",
      "databaseFilmTitle": "Olympia: Festival of the Nations",
      "FilmTitle": "Olympia: Festival of the Nations",
      "AlternateTitle": "",
      "TitleArray": [
        "Olympia: Festival of the Nations"
      ],
      "Year": "1938",
      "Director": "Leni Riefenstahl",
      "DirectorArray": [
        "Leni Riefenstahl"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2504",
      "databaseFilmTitle": "Om Dar-B-Dar",
      "FilmTitle": "Om Dar-B-Dar",
      "AlternateTitle": "",
      "TitleArray": [
        "Om Dar-B-Dar"
      ],
      "Year": "1988",
      "Director": "Kamal Swaroop",
      "DirectorArray": [
        "Kamal Swaroop"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2505",
      "databaseFilmTitle": "Om Shanti Om",
      "FilmTitle": "Om Shanti Om",
      "AlternateTitle": "",
      "TitleArray": [
        "Om Shanti Om"
      ],
      "Year": "2007",
      "Director": "Farah Khan",
      "DirectorArray": [
        "Farah Khan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2506",
      "databaseFilmTitle": "On Body and Soul",
      "FilmTitle": "On Body and Soul",
      "AlternateTitle": "Testről és lélekről",
      "TitleArray": [
        "On Body and Soul",
        "Testről és lélekről"
      ],
      "Year": "2017",
      "Director": "Ildikó Enyedi",
      "DirectorArray": [
        "Ildikó Enyedi"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2507",
      "databaseFilmTitle": "On Company Business",
      "FilmTitle": "On Company Business",
      "AlternateTitle": "",
      "TitleArray": [
        "On Company Business"
      ],
      "Year": "1980",
      "Director": "Allan Francovich",
      "DirectorArray": [
        "Allan Francovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2508",
      "databaseFilmTitle": "On Dangerous Ground",
      "FilmTitle": "On Dangerous Ground",
      "AlternateTitle": "",
      "TitleArray": [
        "On Dangerous Ground"
      ],
      "Year": "1951",
      "Director": "Nicholas Ray, Ida Lupino",
      "DirectorArray": [
        "Nicholas Ray",
        "Ida Lupino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2509",
      "databaseFilmTitle": "On Her Majesty's Secret Service",
      "FilmTitle": "On Her Majesty's Secret Service",
      "AlternateTitle": "",
      "TitleArray": [
        "On Her Majesty's Secret Service"
      ],
      "Year": "1969",
      "Director": "Peter R. Hunt",
      "DirectorArray": [
        "Peter R. Hunt"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2510",
      "databaseFilmTitle": "On the Beach",
      "FilmTitle": "On the Beach",
      "AlternateTitle": "",
      "TitleArray": [
        "On the Beach"
      ],
      "Year": "1959",
      "Director": "Stanley Kramer",
      "DirectorArray": [
        "Stanley Kramer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2511",
      "databaseFilmTitle": "On the Beach at Night Alone",
      "FilmTitle": "On the Beach at Night Alone",
      "AlternateTitle": "Bamui haebyun-eoseo honja",
      "TitleArray": [
        "On the Beach at Night Alone",
        "Bamui haebyun-eoseo honja"
      ],
      "Year": "2017",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2512",
      "databaseFilmTitle": "On the Road: The Document",
      "FilmTitle": "On the Road: The Document",
      "AlternateTitle": "Document Rojo",
      "TitleArray": [
        "On the Road: The Document",
        "Document Rojo"
      ],
      "Year": "1964",
      "Director": "Noriaki Tsuchimoto",
      "DirectorArray": [
        "Noriaki Tsuchimoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2513",
      "databaseFilmTitle": "On the Silver Globe",
      "FilmTitle": "On the Silver Globe",
      "AlternateTitle": "Na srebrnym globie",
      "TitleArray": [
        "On the Silver Globe",
        "Na srebrnym globie"
      ],
      "Year": "1988",
      "Director": "Andrzej Żuławski",
      "DirectorArray": [
        "Andrzej Żuławski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2514",
      "databaseFilmTitle": "On the Tiger's Back",
      "FilmTitle": "On the Tiger's Back",
      "AlternateTitle": "A cavallo della tigre",
      "TitleArray": [
        "On the Tiger's Back",
        "A cavallo della tigre"
      ],
      "Year": "1961",
      "Director": "Luigi Comencini",
      "DirectorArray": [
        "Luigi Comencini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2515",
      "databaseFilmTitle": "On the Town",
      "FilmTitle": "On the Town",
      "AlternateTitle": "",
      "TitleArray": [
        "On the Town"
      ],
      "Year": "1949",
      "Director": "Gene Kelly, Stanley Donen",
      "DirectorArray": [
        "Gene Kelly",
        "Stanley Donen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2516",
      "databaseFilmTitle": "On the Waterfront",
      "FilmTitle": "On the Waterfront",
      "AlternateTitle": "",
      "TitleArray": [
        "On the Waterfront"
      ],
      "Year": "1954",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2517",
      "databaseFilmTitle": "On the Way",
      "FilmTitle": "On the Way",
      "AlternateTitle": "Auf def Weg",
      "TitleArray": [
        "On the Way",
        "Auf def Weg"
      ],
      "Year": "1980",
      "Director": "Peter Schreiner",
      "DirectorArray": [
        "Peter Schreiner"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2518",
      "databaseFilmTitle": "On Top of the Whale",
      "FilmTitle": "On Top of the Whale",
      "AlternateTitle": "Het dak van de walvis",
      "TitleArray": [
        "On Top of the Whale",
        "Het dak van de walvis"
      ],
      "Year": "1982",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2519",
      "databaseFilmTitle": "On Tour with Pina Bausch",
      "FilmTitle": "On Tour with Pina Bausch",
      "AlternateTitle": "Un jour Pina m'a demandé",
      "TitleArray": [
        "On Tour with Pina Bausch",
        "Un jour Pina m'a demandé"
      ],
      "Year": "1983",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2520",
      "databaseFilmTitle": "Once More",
      "FilmTitle": "Once More",
      "AlternateTitle": "",
      "TitleArray": [
        "Once More"
      ],
      "Year": "1988",
      "Director": "Paul Vecchiali",
      "DirectorArray": [
        "Paul Vecchiali"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2521",
      "databaseFilmTitle": "Once upon a Time in America",
      "FilmTitle": "Once upon a Time in America",
      "AlternateTitle": "",
      "TitleArray": [
        "Once upon a Time in America"
      ],
      "Year": "1984",
      "Director": "Sergio Leone",
      "DirectorArray": [
        "Sergio Leone"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "2522",
      "databaseFilmTitle": "Once Upon a Time in Anatolia",
      "FilmTitle": "Once Upon a Time in Anatolia",
      "AlternateTitle": "",
      "TitleArray": [
        "Once Upon a Time in Anatolia"
      ],
      "Year": "2011",
      "Director": "Nuri Bilge Ceylan",
      "DirectorArray": [
        "Nuri Bilge Ceylan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2523",
      "databaseFilmTitle": "Once Upon a Time in China",
      "FilmTitle": "Once Upon a Time in China",
      "AlternateTitle": "Wong Fei Hung",
      "TitleArray": [
        "Once Upon a Time in China",
        "Wong Fei Hung"
      ],
      "Year": "1991",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2524",
      "databaseFilmTitle": "Once Upon a Time in China II",
      "FilmTitle": "Once Upon a Time in China II",
      "AlternateTitle": "Wong Fei-hung II: Naam yi dong ji keung",
      "TitleArray": [
        "Once Upon a Time in China II",
        "Wong Fei-hung II: Naam yi dong ji keung"
      ],
      "Year": "1992",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2525",
      "databaseFilmTitle": "Once upon a Time in the West",
      "FilmTitle": "Once upon a Time in the West",
      "AlternateTitle": "C'era una volta il West",
      "TitleArray": [
        "Once upon a Time in the West",
        "C'era una volta il West"
      ],
      "Year": "1968",
      "Director": "Sergio Leone",
      "DirectorArray": [
        "Sergio Leone"
      ],
      "Country": "Italy, United States",
      "CountryArray": [
        "Italy",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "78",
      "2012votes": "21",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "2526",
      "databaseFilmTitle": "Once Upon a Time… in Hollywood",
      "FilmTitle": "Once Upon a Time… in Hollywood",
      "AlternateTitle": "",
      "TitleArray": [
        "Once Upon a Time… in Hollywood"
      ],
      "Year": "2019",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "2527",
      "databaseFilmTitle": "One A.M.",
      "FilmTitle": "One A.M.",
      "AlternateTitle": "",
      "TitleArray": [
        "One A.M."
      ],
      "Year": "1916",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2528",
      "databaseFilmTitle": "One Day a Man Bought a House",
      "FilmTitle": "One Day a Man Bought a House",
      "AlternateTitle": "Huset på Kampen",
      "TitleArray": [
        "One Day a Man Bought a House",
        "Huset på Kampen"
      ],
      "Year": "1998",
      "Director": "Pjotr Sapegin",
      "DirectorArray": [
        "Pjotr Sapegin"
      ],
      "Country": "Norway",
      "CountryArray": [
        "Norway"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2529",
      "databaseFilmTitle": "One Day of Life",
      "FilmTitle": "One Day of Life",
      "AlternateTitle": "Un día de vida",
      "TitleArray": [
        "One Day of Life",
        "Un día de vida"
      ],
      "Year": "1950",
      "Director": "Emilio Fernández",
      "DirectorArray": [
        "Emilio Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2530",
      "databaseFilmTitle": "One Exciting Night",
      "FilmTitle": "One Exciting Night",
      "AlternateTitle": "",
      "TitleArray": [
        "One Exciting Night"
      ],
      "Year": "1922",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2531",
      "databaseFilmTitle": "One Flew over the Cuckoo's Nest",
      "FilmTitle": "One Flew over the Cuckoo's Nest",
      "AlternateTitle": "",
      "TitleArray": [
        "One Flew over the Cuckoo's Nest"
      ],
      "Year": "1975",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2532",
      "databaseFilmTitle": "One Hour with You",
      "FilmTitle": "One Hour with You",
      "AlternateTitle": "",
      "TitleArray": [
        "One Hour with You"
      ],
      "Year": "1932",
      "Director": "Ernst Lubitsch, George Cukor",
      "DirectorArray": [
        "Ernst Lubitsch",
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2533",
      "databaseFilmTitle": "One Hundred Children Waiting for a Train",
      "FilmTitle": "One Hundred Children Waiting for a Train",
      "AlternateTitle": "Cien niños esperando un tren",
      "TitleArray": [
        "One Hundred Children Waiting for a Train",
        "Cien niños esperando un tren"
      ],
      "Year": "1988",
      "Director": "Ignacio Agüero",
      "DirectorArray": [
        "Ignacio Agüero"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2534",
      "databaseFilmTitle": "One Night... A Train",
      "FilmTitle": "One Night... A Train",
      "AlternateTitle": "Un soir, un train",
      "TitleArray": [
        "One Night... A Train",
        "Un soir, un train"
      ],
      "Year": "1968",
      "Director": "André Delvaux",
      "DirectorArray": [
        "André Delvaux"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2535",
      "databaseFilmTitle": "One Sings, the Other Doesn't",
      "FilmTitle": "One Sings, the Other Doesn't",
      "AlternateTitle": "L'une chante, l'autre pas",
      "TitleArray": [
        "One Sings, the Other Doesn't",
        "L'une chante, l'autre pas"
      ],
      "Year": "1977",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2536",
      "databaseFilmTitle": "One Way Boogie Woogie / 27 Years Later",
      "FilmTitle": "One Way Boogie Woogie / 27 Years Later",
      "AlternateTitle": "",
      "TitleArray": [
        "One Way Boogie Woogie / 27 Years Later"
      ],
      "Year": "2005",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2537",
      "databaseFilmTitle": "One Way or Another",
      "FilmTitle": "One Way or Another",
      "AlternateTitle": "De cierta manera",
      "TitleArray": [
        "One Way or Another",
        "De cierta manera"
      ],
      "Year": "1977",
      "Director": "Sara Gómez",
      "DirectorArray": [
        "Sara Gómez"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "2538",
      "databaseFilmTitle": "One Way Passage",
      "FilmTitle": "One Way Passage",
      "AlternateTitle": "",
      "TitleArray": [
        "One Way Passage"
      ],
      "Year": "1932",
      "Director": "Tay Garnett",
      "DirectorArray": [
        "Tay Garnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2539",
      "databaseFilmTitle": "One Week",
      "FilmTitle": "One Week",
      "AlternateTitle": "",
      "TitleArray": [
        "One Week"
      ],
      "Year": "1920",
      "Director": "Buster Keaton, Edward F. Cline",
      "DirectorArray": [
        "Buster Keaton",
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2540",
      "databaseFilmTitle": "One, Two, Three",
      "FilmTitle": "One, Two, Three",
      "AlternateTitle": "",
      "TitleArray": [
        "One, Two, Three"
      ],
      "Year": "1961",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2541",
      "databaseFilmTitle": "Onegin",
      "FilmTitle": "Onegin",
      "AlternateTitle": "",
      "TitleArray": [
        "Onegin"
      ],
      "Year": "1999",
      "Director": "Martha Fiennes",
      "DirectorArray": [
        "Martha Fiennes"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2542",
      "databaseFilmTitle": "Onibaba",
      "FilmTitle": "Onibaba",
      "AlternateTitle": "",
      "TitleArray": [
        "Onibaba"
      ],
      "Year": "1964",
      "Director": "Kaneto Shindô",
      "DirectorArray": [
        "Kaneto Shindô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2543",
      "databaseFilmTitle": "Only Angels Have Wings",
      "FilmTitle": "Only Angels Have Wings",
      "AlternateTitle": "",
      "TitleArray": [
        "Only Angels Have Wings"
      ],
      "Year": "1939",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "123",
      "2022votes": "25"
    },
    {
      "key": "2544",
      "databaseFilmTitle": "Only Yesterday",
      "FilmTitle": "Only Yesterday",
      "AlternateTitle": "Omohide poro poro",
      "TitleArray": [
        "Only Yesterday",
        "Omohide poro poro"
      ],
      "Year": "1991",
      "Director": "Isao Takahata",
      "DirectorArray": [
        "Isao Takahata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2545",
      "databaseFilmTitle": "Open All Night",
      "FilmTitle": "Open All Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Open All Night"
      ],
      "Year": "1934",
      "Director": "George Pearson",
      "DirectorArray": [
        "George Pearson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2546",
      "databaseFilmTitle": "Open Your Eyes",
      "FilmTitle": "Open Your Eyes",
      "AlternateTitle": "Abre los ojos",
      "TitleArray": [
        "Open Your Eyes",
        "Abre los ojos"
      ],
      "Year": "1997",
      "Director": "Alejandro Amenábar",
      "DirectorArray": [
        "Alejandro Amenábar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2547",
      "databaseFilmTitle": "Opening Night",
      "FilmTitle": "Opening Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Opening Night"
      ],
      "Year": "1977",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2548",
      "databaseFilmTitle": "Orchestra Rehearsal",
      "FilmTitle": "Orchestra Rehearsal",
      "AlternateTitle": "Prova d'Orchestra",
      "TitleArray": [
        "Orchestra Rehearsal",
        "Prova d'Orchestra"
      ],
      "Year": "1978",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2549",
      "databaseFilmTitle": "Ordet",
      "FilmTitle": "Ordet",
      "AlternateTitle": "",
      "TitleArray": [
        "Ordet"
      ],
      "Year": "1955",
      "Director": "Carl Theodor Dreyer",
      "DirectorArray": [
        "Carl Theodor Dreyer"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "24",
      "2012votes": "42",
      "2022rank": "48",
      "2022votes": "48"
    },
    {
      "key": "2550",
      "databaseFilmTitle": "Ordinary Fascism",
      "FilmTitle": "Ordinary Fascism",
      "AlternateTitle": "",
      "TitleArray": [
        "Ordinary Fascism"
      ],
      "Year": "1965",
      "Director": "Mikhail Romm",
      "DirectorArray": [
        "Mikhail Romm"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2551",
      "databaseFilmTitle": "Ordinary People",
      "FilmTitle": "Ordinary People",
      "AlternateTitle": "",
      "TitleArray": [
        "Ordinary People"
      ],
      "Year": "1980",
      "Director": "Robert Redford",
      "DirectorArray": [
        "Robert Redford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2552",
      "databaseFilmTitle": "Origins of the 21st Century",
      "FilmTitle": "Origins of the 21st Century",
      "AlternateTitle": "De l'origine du XXIe siècle",
      "TitleArray": [
        "Origins of the 21st Century",
        "De l'origine du XXIe siècle"
      ],
      "Year": "2000",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2553",
      "databaseFilmTitle": "Orlando",
      "FilmTitle": "Orlando",
      "AlternateTitle": "",
      "TitleArray": [
        "Orlando"
      ],
      "Year": "1992",
      "Director": "Sally Potter",
      "DirectorArray": [
        "Sally Potter"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "2554",
      "databaseFilmTitle": "Ornamental Hairpin",
      "FilmTitle": "Ornamental Hairpin",
      "AlternateTitle": "Kanzashi",
      "TitleArray": [
        "Ornamental Hairpin",
        "Kanzashi"
      ],
      "Year": "1941",
      "Director": "Hiroshi Shimizu",
      "DirectorArray": [
        "Hiroshi Shimizu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2555",
      "databaseFilmTitle": "Orphans of the Storm",
      "FilmTitle": "Orphans of the Storm",
      "AlternateTitle": "",
      "TitleArray": [
        "Orphans of the Storm"
      ],
      "Year": "1921",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2556",
      "databaseFilmTitle": "Orpheus",
      "FilmTitle": "Orpheus",
      "AlternateTitle": "Orphée",
      "TitleArray": [
        "Orpheus",
        "Orphée"
      ],
      "Year": "1950",
      "Director": "Jean Cocteau",
      "DirectorArray": [
        "Jean Cocteau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2557",
      "databaseFilmTitle": "Osaka Elegy",
      "FilmTitle": "Osaka Elegy",
      "AlternateTitle": "Naniwa ereji",
      "TitleArray": [
        "Osaka Elegy",
        "Naniwa ereji"
      ],
      "Year": "1936",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2558",
      "databaseFilmTitle": "Oss Oss Wee Oss",
      "FilmTitle": "Oss Oss Wee Oss",
      "AlternateTitle": "",
      "TitleArray": [
        "Oss Oss Wee Oss"
      ],
      "Year": "1953",
      "Director": "Alan Lomax",
      "DirectorArray": [
        "Alan Lomax"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2559",
      "databaseFilmTitle": "Ossessione",
      "FilmTitle": "Ossessione",
      "AlternateTitle": "",
      "TitleArray": [
        "Ossessione"
      ],
      "Year": "1943",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2560",
      "databaseFilmTitle": "Ossos",
      "FilmTitle": "Ossos",
      "AlternateTitle": "",
      "TitleArray": [
        "Ossos"
      ],
      "Year": "1997",
      "Director": "Pedro Costa",
      "DirectorArray": [
        "Pedro Costa"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2561",
      "databaseFilmTitle": "Ostia",
      "FilmTitle": "Ostia",
      "AlternateTitle": "",
      "TitleArray": [
        "Ostia"
      ],
      "Year": "1988",
      "Director": "Julian Cole",
      "DirectorArray": [
        "Julian Cole"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2562",
      "databaseFilmTitle": "Othello",
      "FilmTitle": "Othello",
      "AlternateTitle": "The Tragedy of Othello: The Moor of Venice",
      "TitleArray": [
        "Othello",
        "The Tragedy of Othello: The Moor of Venice"
      ],
      "Year": "1951",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States, Italy",
      "CountryArray": [
        "United States",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2563",
      "databaseFilmTitle": "Other Men's Women",
      "FilmTitle": "Other Men's Women",
      "AlternateTitle": "",
      "TitleArray": [
        "Other Men's Women"
      ],
      "Year": "1931",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2564",
      "databaseFilmTitle": "Our Beloved Month of August",
      "FilmTitle": "Our Beloved Month of August",
      "AlternateTitle": "Aquele Querido Mês de Agosto",
      "TitleArray": [
        "Our Beloved Month of August",
        "Aquele Querido Mês de Agosto"
      ],
      "Year": "2008",
      "Director": "Miguel Gomes",
      "DirectorArray": [
        "Miguel Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2565",
      "databaseFilmTitle": "Our Century",
      "FilmTitle": "Our Century",
      "AlternateTitle": "Mer dare",
      "TitleArray": [
        "Our Century",
        "Mer dare"
      ],
      "Year": "1983",
      "Director": "Artavazd Peleshian",
      "DirectorArray": [
        "Artavazd Peleshian"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2566",
      "databaseFilmTitle": "Our Daily Bread (1934)",
      "FilmTitle": "Our Daily Bread",
      "AlternateTitle": "",
      "TitleArray": [
        "Our Daily Bread"
      ],
      "Year": "1934",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2567",
      "databaseFilmTitle": "Our Daily Bread (1970)",
      "FilmTitle": "Our Daily Bread",
      "AlternateTitle": "Uski Roti",
      "TitleArray": [
        "Our Daily Bread",
        "Uski Roti"
      ],
      "Year": "1970",
      "Director": "Mani Kaul",
      "DirectorArray": [
        "Mani Kaul"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2568",
      "databaseFilmTitle": "Our Hitler: A Film from Germany",
      "FilmTitle": "Our Hitler: A Film from Germany",
      "AlternateTitle": "Hitler, ein Film aus Deutschland",
      "TitleArray": [
        "Our Hitler: A Film from Germany",
        "Hitler, ein Film aus Deutschland"
      ],
      "Year": "1977",
      "Director": "Hans-Jürgen Syberberg",
      "DirectorArray": [
        "Hans-Jürgen Syberberg"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2569",
      "databaseFilmTitle": "Our Hospitality",
      "FilmTitle": "Our Hospitality",
      "AlternateTitle": "",
      "TitleArray": [
        "Our Hospitality"
      ],
      "Year": "1923",
      "Director": "John G. Blystone, Buster Keaton",
      "DirectorArray": [
        "John G. Blystone",
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2570",
      "databaseFilmTitle": "Our Lady of the Turks",
      "FilmTitle": "Our Lady of the Turks",
      "AlternateTitle": "Nostra signora dei turchi",
      "TitleArray": [
        "Our Lady of the Turks",
        "Nostra signora dei turchi"
      ],
      "Year": "1968",
      "Director": "Carmelo Bene",
      "DirectorArray": [
        "Carmelo Bene"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2571",
      "databaseFilmTitle": "Our Music",
      "FilmTitle": "Our Music",
      "AlternateTitle": "Notre musique",
      "TitleArray": [
        "Our Music",
        "Notre musique"
      ],
      "Year": "2004",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2572",
      "databaseFilmTitle": "Our Nazi",
      "FilmTitle": "Our Nazi",
      "AlternateTitle": "Notre Nazi",
      "TitleArray": [
        "Our Nazi",
        "Notre Nazi"
      ],
      "Year": "1985",
      "Director": "Robert Kramer",
      "DirectorArray": [
        "Robert Kramer"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2573",
      "databaseFilmTitle": "Our Town",
      "FilmTitle": "Our Town",
      "AlternateTitle": "",
      "TitleArray": [
        "Our Town"
      ],
      "Year": "1940",
      "Director": "Sam Wood",
      "DirectorArray": [
        "Sam Wood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2574",
      "databaseFilmTitle": "Our Voice of the Earth, Memory and the Future",
      "FilmTitle": "Our Voice of the Earth, Memory and the Future",
      "AlternateTitle": "Nuestra voz de tierra, memoria y futuro",
      "TitleArray": [
        "Our Voice of the Earth, Memory and the Future",
        "Nuestra voz de tierra, memoria y futuro"
      ],
      "Year": "1981",
      "Director": "Marta Rodríguez, Jorge Silva",
      "DirectorArray": [
        "Marta Rodríguez",
        "Jorge Silva"
      ],
      "Country": "Colombia",
      "CountryArray": [
        "Colombia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2575",
      "databaseFilmTitle": "Out",
      "FilmTitle": "Out",
      "AlternateTitle": "Tse",
      "TitleArray": [
        "Out",
        "Tse"
      ],
      "Year": "2010",
      "Director": "Roee Rosen",
      "DirectorArray": [
        "Roee Rosen"
      ],
      "Country": "Israel",
      "CountryArray": [
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2576",
      "databaseFilmTitle": "Out 1",
      "FilmTitle": "Out 1",
      "AlternateTitle": "Out 1, noli me tangere",
      "TitleArray": [
        "Out 1",
        "Out 1, noli me tangere"
      ],
      "Year": "1971",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "2577",
      "databaseFilmTitle": "Out of Africa",
      "FilmTitle": "Out of Africa",
      "AlternateTitle": "",
      "TitleArray": [
        "Out of Africa"
      ],
      "Year": "1985",
      "Director": "Sydney Pollack",
      "DirectorArray": [
        "Sydney Pollack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2578",
      "databaseFilmTitle": "Out of Phoenix Bridge",
      "FilmTitle": "Out of Phoenix Bridge",
      "AlternateTitle": "Hui dao feng huang qiao",
      "TitleArray": [
        "Out of Phoenix Bridge",
        "Hui dao feng huang qiao"
      ],
      "Year": "1997",
      "Director": "Hong Li",
      "DirectorArray": [
        "Hong Li"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2579",
      "databaseFilmTitle": "Out of Sight",
      "FilmTitle": "Out of Sight",
      "AlternateTitle": "",
      "TitleArray": [
        "Out of Sight"
      ],
      "Year": "1998",
      "Director": "Steven Soderbergh",
      "DirectorArray": [
        "Steven Soderbergh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2580",
      "databaseFilmTitle": "Out of the Blue",
      "FilmTitle": "Out of the Blue",
      "AlternateTitle": "",
      "TitleArray": [
        "Out of the Blue"
      ],
      "Year": "1980",
      "Director": "Dennis Hopper",
      "DirectorArray": [
        "Dennis Hopper"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2581",
      "databaseFilmTitle": "Out of the Past",
      "FilmTitle": "Out of the Past",
      "AlternateTitle": "",
      "TitleArray": [
        "Out of the Past"
      ],
      "Year": "1947",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "2582",
      "databaseFilmTitle": "Outcast of the Islands",
      "FilmTitle": "Outcast of the Islands",
      "AlternateTitle": "",
      "TitleArray": [
        "Outcast of the Islands"
      ],
      "Year": "1952",
      "Director": "Carol Reed",
      "DirectorArray": [
        "Carol Reed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2583",
      "databaseFilmTitle": "Outer and Inner Space",
      "FilmTitle": "Outer and Inner Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Outer and Inner Space"
      ],
      "Year": "1965",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2584",
      "databaseFilmTitle": "Outer Space",
      "FilmTitle": "Outer Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Outer Space"
      ],
      "Year": "1999",
      "Director": "Peter Tscherkassky",
      "DirectorArray": [
        "Peter Tscherkassky"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2585",
      "databaseFilmTitle": "Outrage",
      "FilmTitle": "Outrage",
      "AlternateTitle": "",
      "TitleArray": [
        "Outrage"
      ],
      "Year": "1950",
      "Director": "Ida Lupino",
      "DirectorArray": [
        "Ida Lupino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2586",
      "databaseFilmTitle": "Outskirts",
      "FilmTitle": "Outskirts",
      "AlternateTitle": "Okraina",
      "TitleArray": [
        "Outskirts",
        "Okraina"
      ],
      "Year": "1933",
      "Director": "Boris Barnet",
      "DirectorArray": [
        "Boris Barnet"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2587",
      "databaseFilmTitle": "Oxhide II",
      "FilmTitle": "Oxhide II",
      "AlternateTitle": "Niupi er",
      "TitleArray": [
        "Oxhide II",
        "Niupi er"
      ],
      "Year": "2009",
      "Director": "Liu Jiayin",
      "DirectorArray": [
        "Liu Jiayin"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2588",
      "databaseFilmTitle": "Paddington",
      "FilmTitle": "Paddington",
      "AlternateTitle": "",
      "TitleArray": [
        "Paddington"
      ],
      "Year": "2014",
      "Director": "Paul King",
      "DirectorArray": [
        "Paul King"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2589",
      "databaseFilmTitle": "Paddington 2",
      "FilmTitle": "Paddington 2",
      "AlternateTitle": "",
      "TitleArray": [
        "Paddington 2"
      ],
      "Year": "2017",
      "Director": "Paul King",
      "DirectorArray": [
        "Paul King"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2590",
      "databaseFilmTitle": "Padre Padrone",
      "FilmTitle": "Padre Padrone",
      "AlternateTitle": "",
      "TitleArray": [
        "Padre Padrone"
      ],
      "Year": "1977",
      "Director": "Paolo Taviani, Vittorio Taviani",
      "DirectorArray": [
        "Paolo Taviani",
        "Vittorio Taviani"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2591",
      "databaseFilmTitle": "Pain and Glory",
      "FilmTitle": "Pain and Glory",
      "AlternateTitle": "Dolor y gloria",
      "TitleArray": [
        "Pain and Glory",
        "Dolor y gloria"
      ],
      "Year": "2019",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2592",
      "databaseFilmTitle": "Painting Today",
      "FilmTitle": "Painting Today",
      "AlternateTitle": "Malerei heute",
      "TitleArray": [
        "Painting Today",
        "Malerei heute"
      ],
      "Year": "2005",
      "Director": "Stefan Hayn, Anja-Christin Remmert",
      "DirectorArray": [
        "Stefan Hayn",
        "Anja-Christin Remmert"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2593",
      "databaseFilmTitle": "Paisan",
      "FilmTitle": "Paisan",
      "AlternateTitle": "Paisà",
      "TitleArray": [
        "Paisan",
        "Paisà"
      ],
      "Year": "1946",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "26",
      "1992votes": "7",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "2594",
      "databaseFilmTitle": "Pakeezah",
      "FilmTitle": "Pakeezah",
      "AlternateTitle": "",
      "TitleArray": [
        "Pakeezah"
      ],
      "Year": "1972",
      "Director": "Kamal Amrohi",
      "DirectorArray": [
        "Kamal Amrohi"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2595",
      "databaseFilmTitle": "Pale Rider",
      "FilmTitle": "Pale Rider",
      "AlternateTitle": "",
      "TitleArray": [
        "Pale Rider"
      ],
      "Year": "1985",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2596",
      "databaseFilmTitle": "Palms",
      "FilmTitle": "Palms",
      "AlternateTitle": "Ladoni",
      "TitleArray": [
        "Palms",
        "Ladoni"
      ],
      "Year": "1993",
      "Director": "Artour Aristakisian",
      "DirectorArray": [
        "Artour Aristakisian"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2597",
      "databaseFilmTitle": "Pan's Labyrinth",
      "FilmTitle": "Pan's Labyrinth",
      "AlternateTitle": "El laberinto del fauno",
      "TitleArray": [
        "Pan's Labyrinth",
        "El laberinto del fauno"
      ],
      "Year": "2006",
      "Director": "Guillermo del Toro",
      "DirectorArray": [
        "Guillermo del Toro"
      ],
      "Country": "Spain, Mexico",
      "CountryArray": [
        "Spain",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "2598",
      "databaseFilmTitle": "Pandemonium",
      "FilmTitle": "Pandemonium",
      "AlternateTitle": "Shura",
      "TitleArray": [
        "Pandemonium",
        "Shura"
      ],
      "Year": "1971",
      "Director": "Toshio Matsumoto",
      "DirectorArray": [
        "Toshio Matsumoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2599",
      "databaseFilmTitle": "Pandora's Box",
      "FilmTitle": "Pandora's Box",
      "AlternateTitle": "Die Büchse der Pandora",
      "TitleArray": [
        "Pandora's Box",
        "Die Büchse der Pandora"
      ],
      "Year": "1929",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2600",
      "databaseFilmTitle": "Panorama du Grand Canal vu d'un bateau",
      "FilmTitle": "Panorama du Grand Canal vu d'un bateau",
      "AlternateTitle": "",
      "TitleArray": [
        "Panorama du Grand Canal vu d'un bateau"
      ],
      "Year": "1896",
      "Director": "Alexandre Promio",
      "DirectorArray": [
        "Alexandre Promio"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2601",
      "databaseFilmTitle": "Paperhouse",
      "FilmTitle": "Paperhouse",
      "AlternateTitle": "",
      "TitleArray": [
        "Paperhouse"
      ],
      "Year": "1988",
      "Director": "Bernard Rose",
      "DirectorArray": [
        "Bernard Rose"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2602",
      "databaseFilmTitle": "Paprika",
      "FilmTitle": "Paprika",
      "AlternateTitle": "",
      "TitleArray": [
        "Paprika"
      ],
      "Year": "2006",
      "Director": "Satoshi Kon",
      "DirectorArray": [
        "Satoshi Kon"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2603",
      "databaseFilmTitle": "Paradise Now",
      "FilmTitle": "Paradise Now",
      "AlternateTitle": "",
      "TitleArray": [
        "Paradise Now"
      ],
      "Year": "2005",
      "Director": "Hany Abu-Assad",
      "DirectorArray": [
        "Hany Abu-Assad"
      ],
      "Country": "Palestine, France",
      "CountryArray": [
        "Palestine",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2604",
      "databaseFilmTitle": "Paradise: Love",
      "FilmTitle": "Paradise: Love",
      "AlternateTitle": "",
      "TitleArray": [
        "Paradise: Love"
      ],
      "Year": "2012",
      "Director": "Ulrich Seidl",
      "DirectorArray": [
        "Ulrich Seidl"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2605",
      "databaseFilmTitle": "Paraguayan Hammock",
      "FilmTitle": "Paraguayan Hammock",
      "AlternateTitle": "Hamaca paraguaya",
      "TitleArray": [
        "Paraguayan Hammock",
        "Hamaca paraguaya"
      ],
      "Year": "2006",
      "Director": "Paz Encina",
      "DirectorArray": [
        "Paz Encina"
      ],
      "Country": "Paraguay",
      "CountryArray": [
        "Paraguay"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2606",
      "databaseFilmTitle": "Parasite",
      "FilmTitle": "Parasite",
      "AlternateTitle": "Gisaengchoong",
      "TitleArray": [
        "Parasite",
        "Gisaengchoong"
      ],
      "Year": "2019",
      "Director": "Bong Joon Ho",
      "DirectorArray": [
        "Bong Joon Ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "90",
      "2022votes": "32"
    },
    {
      "key": "2607",
      "databaseFilmTitle": "Parents' Hearts",
      "FilmTitle": "Parents' Hearts",
      "AlternateTitle": "Fu mu xin",
      "TitleArray": [
        "Parents' Hearts",
        "Fu mu xin"
      ],
      "Year": "1955",
      "Director": "Kim Chun",
      "DirectorArray": [
        "Kim Chun"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2608",
      "databaseFilmTitle": "Pariah",
      "FilmTitle": "Pariah",
      "AlternateTitle": "",
      "TitleArray": [
        "Pariah"
      ],
      "Year": "2011",
      "Director": "Dee Rees",
      "DirectorArray": [
        "Dee Rees"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2609",
      "databaseFilmTitle": "Paris 1900",
      "FilmTitle": "Paris 1900",
      "AlternateTitle": "",
      "TitleArray": [
        "Paris 1900"
      ],
      "Year": "1947",
      "Director": "Nicole Vedrès",
      "DirectorArray": [
        "Nicole Vedrès"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2610",
      "databaseFilmTitle": "Paris Frills",
      "FilmTitle": "Paris Frills",
      "AlternateTitle": "Falbalas",
      "TitleArray": [
        "Paris Frills",
        "Falbalas"
      ],
      "Year": "1945",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2611",
      "databaseFilmTitle": "Paris Is Burning",
      "FilmTitle": "Paris Is Burning",
      "AlternateTitle": "",
      "TitleArray": [
        "Paris Is Burning"
      ],
      "Year": "1990",
      "Director": "Jennie Livingston",
      "DirectorArray": [
        "Jennie Livingston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "2612",
      "databaseFilmTitle": "Paris, Texas",
      "FilmTitle": "Paris, Texas",
      "AlternateTitle": "",
      "TitleArray": [
        "Paris, Texas"
      ],
      "Year": "1984",
      "Director": "Wim Wenders",
      "DirectorArray": [
        "Wim Wenders"
      ],
      "Country": "United States, West Germany, France",
      "CountryArray": [
        "United States",
        "West Germany",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "2613",
      "databaseFilmTitle": "Park Lanes",
      "FilmTitle": "Park Lanes",
      "AlternateTitle": "",
      "TitleArray": [
        "Park Lanes"
      ],
      "Year": "2015",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2614",
      "databaseFilmTitle": "Parsifal",
      "FilmTitle": "Parsifal",
      "AlternateTitle": "",
      "TitleArray": [
        "Parsifal"
      ],
      "Year": "1982",
      "Director": "Hans-Jürgen Syberberg",
      "DirectorArray": [
        "Hans-Jürgen Syberberg"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2615",
      "databaseFilmTitle": "Partner",
      "FilmTitle": "Partner",
      "AlternateTitle": "",
      "TitleArray": [
        "Partner"
      ],
      "Year": "1968",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2616",
      "databaseFilmTitle": "Party Girl",
      "FilmTitle": "Party Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Party Girl"
      ],
      "Year": "1958",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2617",
      "databaseFilmTitle": "Party on the CAPS",
      "FilmTitle": "Party on the CAPS",
      "AlternateTitle": "",
      "TitleArray": [
        "Party on the CAPS"
      ],
      "Year": "2018",
      "Director": "Meriem Bennani",
      "DirectorArray": [
        "Meriem Bennani"
      ],
      "Country": "Morocco",
      "CountryArray": [
        "Morocco"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2618",
      "databaseFilmTitle": "Pass the Gravy",
      "FilmTitle": "Pass the Gravy",
      "AlternateTitle": "",
      "TitleArray": [
        "Pass the Gravy"
      ],
      "Year": "1928",
      "Director": "Leo McCarey, Fred Guiol",
      "DirectorArray": [
        "Leo McCarey",
        "Fred Guiol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2619",
      "databaseFilmTitle": "Passacaglia y Fuga",
      "FilmTitle": "Passacaglia y Fuga",
      "AlternateTitle": "",
      "TitleArray": [
        "Passacaglia y Fuga"
      ],
      "Year": "1975",
      "Director": "Jorge Honik",
      "DirectorArray": [
        "Jorge Honik"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2620",
      "databaseFilmTitle": "Passage Through a Ritual",
      "FilmTitle": "Passage Through a Ritual",
      "AlternateTitle": "",
      "TitleArray": [
        "Passage Through a Ritual"
      ],
      "Year": "1990",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2621",
      "databaseFilmTitle": "Passages",
      "FilmTitle": "Passages",
      "AlternateTitle": "Passagen",
      "TitleArray": [
        "Passages",
        "Passagen"
      ],
      "Year": "1996",
      "Director": "Lisl Ponger",
      "DirectorArray": [
        "Lisl Ponger"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2622",
      "databaseFilmTitle": "Passeio com Johnny Guitar",
      "FilmTitle": "Passeio com Johnny Guitar",
      "AlternateTitle": "",
      "TitleArray": [
        "Passeio com Johnny Guitar"
      ],
      "Year": "1995",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2623",
      "databaseFilmTitle": "Passenger",
      "FilmTitle": "Passenger",
      "AlternateTitle": "Pasazerka",
      "TitleArray": [
        "Passenger",
        "Pasazerka"
      ],
      "Year": "1963",
      "Director": "Andrzej Munk, Witold Lesiewicz",
      "DirectorArray": [
        "Andrzej Munk",
        "Witold Lesiewicz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2624",
      "databaseFilmTitle": "Passing Through",
      "FilmTitle": "Passing Through",
      "AlternateTitle": "",
      "TitleArray": [
        "Passing Through"
      ],
      "Year": "1977",
      "Director": "Larry Clark",
      "DirectorArray": [
        "Larry Clark"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2625",
      "databaseFilmTitle": "Passion",
      "FilmTitle": "Passion",
      "AlternateTitle": "",
      "TitleArray": [
        "Passion"
      ],
      "Year": "1982",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "Switzerland, France",
      "CountryArray": [
        "Switzerland",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2626",
      "databaseFilmTitle": "Passione d'amore",
      "FilmTitle": "Passione d'amore",
      "AlternateTitle": "",
      "TitleArray": [
        "Passione d'amore"
      ],
      "Year": "1981",
      "Director": "Ettore Scola",
      "DirectorArray": [
        "Ettore Scola"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2627",
      "databaseFilmTitle": "Passport to Pimlico",
      "FilmTitle": "Passport to Pimlico",
      "AlternateTitle": "",
      "TitleArray": [
        "Passport to Pimlico"
      ],
      "Year": "1949",
      "Director": "Henry Cornelius",
      "DirectorArray": [
        "Henry Cornelius"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2628",
      "databaseFilmTitle": "Past and Present",
      "FilmTitle": "Past and Present",
      "AlternateTitle": "O passado e o presente",
      "TitleArray": [
        "Past and Present",
        "O passado e o presente"
      ],
      "Year": "1972",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2629",
      "databaseFilmTitle": "Pastoral: To Die in the Country",
      "FilmTitle": "Pastoral: To Die in the Country",
      "AlternateTitle": "Den-en ni shisu",
      "TitleArray": [
        "Pastoral: To Die in the Country",
        "Den-en ni shisu"
      ],
      "Year": "1974",
      "Director": "Shûji Terayama",
      "DirectorArray": [
        "Shûji Terayama"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2630",
      "databaseFilmTitle": "Pat Garrett and Billy the Kid",
      "FilmTitle": "Pat Garrett and Billy the Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "Pat Garrett and Billy the Kid"
      ],
      "Year": "1973",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2631",
      "databaseFilmTitle": "Path",
      "FilmTitle": "Path",
      "AlternateTitle": "",
      "TitleArray": [
        "Path"
      ],
      "Year": "1987",
      "Director": "Martha Davis",
      "DirectorArray": [
        "Martha Davis"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2632",
      "databaseFilmTitle": "Pather Panchali",
      "FilmTitle": "Pather Panchali",
      "AlternateTitle": "",
      "TitleArray": [
        "Pather Panchali"
      ],
      "Year": "1955",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "11",
      "1962votes": "11",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "6",
      "1992votes": "15",
      "2002rank": "22",
      "2002votes": "9",
      "2012rank": "41",
      "2012votes": "32",
      "2022rank": "35",
      "2022votes": "57"
    },
    {
      "key": "2633",
      "databaseFilmTitle": "Paths of Glory",
      "FilmTitle": "Paths of Glory",
      "AlternateTitle": "",
      "TitleArray": [
        "Paths of Glory"
      ],
      "Year": "1957",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2634",
      "databaseFilmTitle": "Patrick",
      "FilmTitle": "Patrick",
      "AlternateTitle": "",
      "TitleArray": [
        "Patrick"
      ],
      "Year": "1978",
      "Director": "Richard Franklin",
      "DirectorArray": [
        "Richard Franklin"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2635",
      "databaseFilmTitle": "Patton",
      "FilmTitle": "Patton",
      "AlternateTitle": "",
      "TitleArray": [
        "Patton"
      ],
      "Year": "1970",
      "Director": "Franklin J. Schaffner",
      "DirectorArray": [
        "Franklin J. Schaffner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2636",
      "databaseFilmTitle": "Patu!",
      "FilmTitle": "Patu!",
      "AlternateTitle": "",
      "TitleArray": [
        "Patu!"
      ],
      "Year": "1983",
      "Director": "Merata Mita",
      "DirectorArray": [
        "Merata Mita"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2637",
      "databaseFilmTitle": "Pauline at the Beach",
      "FilmTitle": "Pauline at the Beach",
      "AlternateTitle": "Pauline à la plage",
      "TitleArray": [
        "Pauline at the Beach",
        "Pauline à la plage"
      ],
      "Year": "1983",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2638",
      "databaseFilmTitle": "Peeping Tom",
      "FilmTitle": "Peeping Tom",
      "AlternateTitle": "",
      "TitleArray": [
        "Peeping Tom"
      ],
      "Year": "1960",
      "Director": "Michael Powell",
      "DirectorArray": [
        "Michael Powell"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2639",
      "databaseFilmTitle": "Peggy and Fred in Hell",
      "FilmTitle": "Peggy and Fred in Hell",
      "AlternateTitle": "",
      "TitleArray": [
        "Peggy and Fred in Hell"
      ],
      "Year": "1985",
      "Director": "Leslie Thornton",
      "DirectorArray": [
        "Leslie Thornton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2640",
      "databaseFilmTitle": "Peking Opera Blues",
      "FilmTitle": "Peking Opera Blues",
      "AlternateTitle": "Do ma daan",
      "TitleArray": [
        "Peking Opera Blues",
        "Do ma daan"
      ],
      "Year": "1986",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2641",
      "databaseFilmTitle": "Penda's Fen",
      "FilmTitle": "Penda's Fen",
      "AlternateTitle": "Play for Today: Penda's Fen",
      "TitleArray": [
        "Penda's Fen",
        "Play for Today: Penda's Fen"
      ],
      "Year": "1974",
      "Director": "Alan Clarke",
      "DirectorArray": [
        "Alan Clarke"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2642",
      "databaseFilmTitle": "People on Sunday",
      "FilmTitle": "People on Sunday",
      "AlternateTitle": "Menschen am Sonntag",
      "TitleArray": [
        "People on Sunday",
        "Menschen am Sonntag"
      ],
      "Year": "1930",
      "Director": "Curt Siodmak, Robert Siodmak, Edgar G. Ulmer, Fred Zinnemann, Rochus Gliese",
      "DirectorArray": [
        "Curt Siodmak",
        "Robert Siodmak",
        "Edgar G. Ulmer",
        "Fred Zinnemann",
        "Rochus Gliese"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2643",
      "databaseFilmTitle": "Pépé le Moko",
      "FilmTitle": "Pépé le Moko",
      "AlternateTitle": "",
      "TitleArray": [
        "Pépé le Moko"
      ],
      "Year": "1937",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2644",
      "databaseFilmTitle": "Peppermint Candy",
      "FilmTitle": "Peppermint Candy",
      "AlternateTitle": "Bakha satang",
      "TitleArray": [
        "Peppermint Candy",
        "Bakha satang"
      ],
      "Year": "1999",
      "Director": "Lee Chang-dong",
      "DirectorArray": [
        "Lee Chang-dong"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2645",
      "databaseFilmTitle": "Peppermint Frappé",
      "FilmTitle": "Peppermint Frappé",
      "AlternateTitle": "",
      "TitleArray": [
        "Peppermint Frappé"
      ],
      "Year": "1967",
      "Director": "Carlos Saura",
      "DirectorArray": [
        "Carlos Saura"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2646",
      "databaseFilmTitle": "Perceval",
      "FilmTitle": "Perceval",
      "AlternateTitle": "Pecerval le Gallois",
      "TitleArray": [
        "Perceval",
        "Pecerval le Gallois"
      ],
      "Year": "1978",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2647",
      "databaseFilmTitle": "Perfect Blue",
      "FilmTitle": "Perfect Blue",
      "AlternateTitle": "Pafekuto buru",
      "TitleArray": [
        "Perfect Blue",
        "Pafekuto buru"
      ],
      "Year": "1997",
      "Director": "Satoshi Kon",
      "DirectorArray": [
        "Satoshi Kon"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2648",
      "databaseFilmTitle": "Perfect Day",
      "FilmTitle": "Perfect Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Perfect Day"
      ],
      "Year": "2008",
      "Director": "Ange Leccia",
      "DirectorArray": [
        "Ange Leccia"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2649",
      "databaseFilmTitle": "Perfect Film",
      "FilmTitle": "Perfect Film",
      "AlternateTitle": "",
      "TitleArray": [
        "Perfect Film"
      ],
      "Year": "1986",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2650",
      "databaseFilmTitle": "Performance",
      "FilmTitle": "Performance",
      "AlternateTitle": "",
      "TitleArray": [
        "Performance"
      ],
      "Year": "1970",
      "Director": "Donald Cammell, Nicholas Roeg",
      "DirectorArray": [
        "Donald Cammell",
        "Nicholas Roeg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2651",
      "databaseFilmTitle": "Perfumed Nightmare",
      "FilmTitle": "Perfumed Nightmare",
      "AlternateTitle": "Mababangong Bangungot",
      "TitleArray": [
        "Perfumed Nightmare",
        "Mababangong Bangungot"
      ],
      "Year": "1977",
      "Director": "Kidlat Tahimik",
      "DirectorArray": [
        "Kidlat Tahimik"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2652",
      "databaseFilmTitle": "Persepolis",
      "FilmTitle": "Persepolis",
      "AlternateTitle": "",
      "TitleArray": [
        "Persepolis"
      ],
      "Year": "2007",
      "Director": "Marjane Satrapi, Vincent Paronnaud",
      "DirectorArray": [
        "Marjane Satrapi",
        "Vincent Paronnaud"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2653",
      "databaseFilmTitle": "Persona",
      "FilmTitle": "Persona",
      "AlternateTitle": "",
      "TitleArray": [
        "Persona"
      ],
      "Year": "1966",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "5",
      "1972votes": "12",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "17",
      "2012votes": "48",
      "2022rank": "18",
      "2022votes": "76"
    },
    {
      "key": "2654",
      "databaseFilmTitle": "Personal Problems",
      "FilmTitle": "Personal Problems",
      "AlternateTitle": "",
      "TitleArray": [
        "Personal Problems"
      ],
      "Year": "1980",
      "Director": "Bill Gunn",
      "DirectorArray": [
        "Bill Gunn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2655",
      "databaseFilmTitle": "Personal Shopper",
      "FilmTitle": "Personal Shopper",
      "AlternateTitle": "",
      "TitleArray": [
        "Personal Shopper"
      ],
      "Year": "2016",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2656",
      "databaseFilmTitle": "Peter Ibbetson",
      "FilmTitle": "Peter Ibbetson",
      "AlternateTitle": "",
      "TitleArray": [
        "Peter Ibbetson"
      ],
      "Year": "1935",
      "Director": "Henry Hathaway",
      "DirectorArray": [
        "Henry Hathaway"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2657",
      "databaseFilmTitle": "Peter Pan",
      "FilmTitle": "Peter Pan",
      "AlternateTitle": "",
      "TitleArray": [
        "Peter Pan"
      ],
      "Year": "1924",
      "Director": "Herbert Brenon",
      "DirectorArray": [
        "Herbert Brenon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2658",
      "databaseFilmTitle": "Petite Maman",
      "FilmTitle": "Petite Maman",
      "AlternateTitle": "",
      "TitleArray": [
        "Petite Maman"
      ],
      "Year": "2021",
      "Director": "Céline Sciamma",
      "DirectorArray": [
        "Céline Sciamma"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "2659",
      "databaseFilmTitle": "Petition",
      "FilmTitle": "Petition",
      "AlternateTitle": "Shang fang",
      "TitleArray": [
        "Petition",
        "Shang fang"
      ],
      "Year": "2009",
      "Director": "Zhao Liang",
      "DirectorArray": [
        "Zhao Liang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2660",
      "databaseFilmTitle": "Petulia",
      "FilmTitle": "Petulia",
      "AlternateTitle": "",
      "TitleArray": [
        "Petulia"
      ],
      "Year": "1968",
      "Director": "Richard Lester",
      "DirectorArray": [
        "Richard Lester"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2661",
      "databaseFilmTitle": "Peyton Place (Season 1): Episode 32",
      "FilmTitle": "Peyton Place (Season 1): Episode 32",
      "AlternateTitle": "",
      "TitleArray": [
        "Peyton Place (Season 1): Episode 32"
      ],
      "Year": "1965",
      "Director": "Walter Doniger",
      "DirectorArray": [
        "Walter Doniger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2662",
      "databaseFilmTitle": "Phantom",
      "FilmTitle": "Phantom",
      "AlternateTitle": "",
      "TitleArray": [
        "Phantom"
      ],
      "Year": "1922",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2663",
      "databaseFilmTitle": "Phantom Lady",
      "FilmTitle": "Phantom Lady",
      "AlternateTitle": "",
      "TitleArray": [
        "Phantom Lady"
      ],
      "Year": "1944",
      "Director": "Robert Soidmak",
      "DirectorArray": [
        "Robert Soidmak"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2664",
      "databaseFilmTitle": "Phantom of the Paradise",
      "FilmTitle": "Phantom of the Paradise",
      "AlternateTitle": "",
      "TitleArray": [
        "Phantom of the Paradise"
      ],
      "Year": "1974",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2665",
      "databaseFilmTitle": "Phantom Ride",
      "FilmTitle": "Phantom Ride",
      "AlternateTitle": "",
      "TitleArray": [
        "Phantom Ride"
      ],
      "Year": "2019",
      "Director": "Stephen Broomer",
      "DirectorArray": [
        "Stephen Broomer"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2666",
      "databaseFilmTitle": "Phantom Thread",
      "FilmTitle": "Phantom Thread",
      "AlternateTitle": "",
      "TitleArray": [
        "Phantom Thread"
      ],
      "Year": "2017",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2667",
      "databaseFilmTitle": "Phase IV",
      "FilmTitle": "Phase IV",
      "AlternateTitle": "",
      "TitleArray": [
        "Phase IV"
      ],
      "Year": "1974",
      "Director": "Saul Bass",
      "DirectorArray": [
        "Saul Bass"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2668",
      "databaseFilmTitle": "Phoenix",
      "FilmTitle": "Phoenix",
      "AlternateTitle": "",
      "TitleArray": [
        "Phoenix"
      ],
      "Year": "2014",
      "Director": "Christian Petzold",
      "DirectorArray": [
        "Christian Petzold"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2669",
      "databaseFilmTitle": "Photographing a Female Crook",
      "FilmTitle": "Photographing a Female Crook",
      "AlternateTitle": "",
      "TitleArray": [
        "Photographing a Female Crook"
      ],
      "Year": "1904",
      "Director": "Wallace McCutcheon",
      "DirectorArray": [
        "Wallace McCutcheon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2670",
      "databaseFilmTitle": "Pickle Surprise",
      "FilmTitle": "Pickle Surprise",
      "AlternateTitle": "",
      "TitleArray": [
        "Pickle Surprise"
      ],
      "Year": "1989",
      "Director": "Tom Rubnitz",
      "DirectorArray": [
        "Tom Rubnitz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2671",
      "databaseFilmTitle": "Pickpocket",
      "FilmTitle": "Pickpocket",
      "AlternateTitle": "",
      "TitleArray": [
        "Pickpocket"
      ],
      "Year": "1959",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "2672",
      "databaseFilmTitle": "Pickup on the South Street",
      "FilmTitle": "Pickup on the South Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Pickup on the South Street"
      ],
      "Year": "1953",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2673",
      "databaseFilmTitle": "Picnic at Hanging Rock",
      "FilmTitle": "Picnic at Hanging Rock",
      "AlternateTitle": "",
      "TitleArray": [
        "Picnic at Hanging Rock"
      ],
      "Year": "1975",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2674",
      "databaseFilmTitle": "Picnic on the Grass",
      "FilmTitle": "Picnic on the Grass",
      "AlternateTitle": "Le Déjeuner sur l'herbe",
      "TitleArray": [
        "Picnic on the Grass",
        "Le Déjeuner sur l'herbe"
      ],
      "Year": "1959",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2675",
      "databaseFilmTitle": "Pictures of the Old World",
      "FilmTitle": "Pictures of the Old World",
      "AlternateTitle": "Obrazy starého sveta",
      "TitleArray": [
        "Pictures of the Old World",
        "Obrazy starého sveta"
      ],
      "Year": "1972",
      "Director": "Dušan Hanák",
      "DirectorArray": [
        "Dušan Hanák"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2676",
      "databaseFilmTitle": "Pierrot le Fou",
      "FilmTitle": "Pierrot le Fou",
      "AlternateTitle": "",
      "TitleArray": [
        "Pierrot le Fou"
      ],
      "Year": "1965",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "43",
      "2012votes": "31",
      "2022rank": "85",
      "2022votes": "34"
    },
    {
      "key": "2677",
      "databaseFilmTitle": "Pig",
      "FilmTitle": "Pig",
      "AlternateTitle": "",
      "TitleArray": [
        "Pig"
      ],
      "Year": "2021",
      "Director": "Michael Sarnoski",
      "DirectorArray": [
        "Michael Sarnoski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2678",
      "databaseFilmTitle": "Pigsty",
      "FilmTitle": "Pigsty",
      "AlternateTitle": "Porcile",
      "TitleArray": [
        "Pigsty",
        "Porcile"
      ],
      "Year": "1969",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2679",
      "databaseFilmTitle": "Pilgrimage",
      "FilmTitle": "Pilgrimage",
      "AlternateTitle": "",
      "TitleArray": [
        "Pilgrimage"
      ],
      "Year": "1933",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2680",
      "databaseFilmTitle": "Pina",
      "FilmTitle": "Pina",
      "AlternateTitle": "",
      "TitleArray": [
        "Pina"
      ],
      "Year": "2011",
      "Director": "Wim Wenders",
      "DirectorArray": [
        "Wim Wenders"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2681",
      "databaseFilmTitle": "Pink Flamingos",
      "FilmTitle": "Pink Flamingos",
      "AlternateTitle": "",
      "TitleArray": [
        "Pink Flamingos"
      ],
      "Year": "1972",
      "Director": "John Waters",
      "DirectorArray": [
        "John Waters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "2682",
      "databaseFilmTitle": "Pink Floyd London '66-'67",
      "FilmTitle": "Pink Floyd London '66-'67",
      "AlternateTitle": "",
      "TitleArray": [
        "Pink Floyd London '66-'67"
      ],
      "Year": "1967",
      "Director": "Peter Whitehead",
      "DirectorArray": [
        "Peter Whitehead"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2683",
      "databaseFilmTitle": "Pink Floyd: The Wall",
      "FilmTitle": "Pink Floyd: The Wall",
      "AlternateTitle": "",
      "TitleArray": [
        "Pink Floyd: The Wall"
      ],
      "Year": "1982",
      "Director": "Alan Parker",
      "DirectorArray": [
        "Alan Parker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2684",
      "databaseFilmTitle": "Pink Narcissus",
      "FilmTitle": "Pink Narcissus",
      "AlternateTitle": "",
      "TitleArray": [
        "Pink Narcissus"
      ],
      "Year": "1971",
      "Director": "James Bidgood",
      "DirectorArray": [
        "James Bidgood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2685",
      "databaseFilmTitle": "Pinocchio",
      "FilmTitle": "Pinocchio",
      "AlternateTitle": "",
      "TitleArray": [
        "Pinocchio"
      ],
      "Year": "1940",
      "Director": "Ben Sharpsteen, Norman Ferguson, T. Hee, Wildred Jackson, Jack Kinney, Hamilton Luske, Bill Roberts",
      "DirectorArray": [
        "Ben Sharpsteen",
        "Norman Ferguson",
        "T. Hee",
        "Wildred Jackson",
        "Jack Kinney",
        "Hamilton Luske",
        "Bill Roberts"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2686",
      "databaseFilmTitle": "Pirates of the Caribbean: At World's End",
      "FilmTitle": "Pirates of the Caribbean: At World's End",
      "AlternateTitle": "",
      "TitleArray": [
        "Pirates of the Caribbean: At World's End"
      ],
      "Year": "2007",
      "Director": "Gore Verbinski",
      "DirectorArray": [
        "Gore Verbinski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2687",
      "databaseFilmTitle": "Place of Work",
      "FilmTitle": "Place of Work",
      "AlternateTitle": "",
      "TitleArray": [
        "Place of Work"
      ],
      "Year": "1976",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2688",
      "databaseFilmTitle": "Plácido",
      "FilmTitle": "Plácido",
      "AlternateTitle": "",
      "TitleArray": [
        "Plácido"
      ],
      "Year": "1961",
      "Director": "Luis García Berlanga",
      "DirectorArray": [
        "Luis García Berlanga"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2689",
      "databaseFilmTitle": "Plan 9 From Outer Space",
      "FilmTitle": "Plan 9 From Outer Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Plan 9 From Outer Space"
      ],
      "Year": "1959",
      "Director": "Edward D. Wood Jr.",
      "DirectorArray": [
        "Edward D. Wood Jr."
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2690",
      "databaseFilmTitle": "Planet of the Apes",
      "FilmTitle": "Planet of the Apes",
      "AlternateTitle": "",
      "TitleArray": [
        "Planet of the Apes"
      ],
      "Year": "1968",
      "Director": "Franklin J. Schaffner",
      "DirectorArray": [
        "Franklin J. Schaffner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2691",
      "databaseFilmTitle": "Plastic Jesus",
      "FilmTitle": "Plastic Jesus",
      "AlternateTitle": "Plastični Isus",
      "TitleArray": [
        "Plastic Jesus",
        "Plastični Isus"
      ],
      "Year": "1971",
      "Director": "Lazar Stojanović",
      "DirectorArray": [
        "Lazar Stojanović"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2692",
      "databaseFilmTitle": "Platform",
      "FilmTitle": "Platform",
      "AlternateTitle": "Zhantai",
      "TitleArray": [
        "Platform",
        "Zhantai"
      ],
      "Year": "2000",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2693",
      "databaseFilmTitle": "Platoon",
      "FilmTitle": "Platoon",
      "AlternateTitle": "",
      "TitleArray": [
        "Platoon"
      ],
      "Year": "1986",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2694",
      "databaseFilmTitle": "Playground",
      "FilmTitle": "Playground",
      "AlternateTitle": "Un monde",
      "TitleArray": [
        "Playground",
        "Un monde"
      ],
      "Year": "2021",
      "Director": "Laura Wandel",
      "DirectorArray": [
        "Laura Wandel"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2695",
      "databaseFilmTitle": "Playtime",
      "FilmTitle": "Playtime",
      "AlternateTitle": "",
      "TitleArray": [
        "Playtime"
      ],
      "Year": "1967",
      "Director": "Jacques Tati",
      "DirectorArray": [
        "Jacques Tati"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "43",
      "2012votes": "31",
      "2022rank": "23",
      "2022votes": "68"
    },
    {
      "key": "2696",
      "databaseFilmTitle": "Please Say Something",
      "FilmTitle": "Please Say Something",
      "AlternateTitle": "",
      "TitleArray": [
        "Please Say Something"
      ],
      "Year": "2008",
      "Director": "David O'Reilly",
      "DirectorArray": [
        "David O'Reilly"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2697",
      "databaseFilmTitle": "Plumb Line",
      "FilmTitle": "Plumb Line",
      "AlternateTitle": "",
      "TitleArray": [
        "Plumb Line"
      ],
      "Year": "1971",
      "Director": "Carolee Schneemann",
      "DirectorArray": [
        "Carolee Schneemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2698",
      "databaseFilmTitle": "Pneuma",
      "FilmTitle": "Pneuma",
      "AlternateTitle": "",
      "TitleArray": [
        "Pneuma"
      ],
      "Year": "1983",
      "Director": "Nathaniel Dorsky",
      "DirectorArray": [
        "Nathaniel Dorsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2699",
      "databaseFilmTitle": "Poem of the Sea",
      "FilmTitle": "Poem of the Sea",
      "AlternateTitle": "",
      "TitleArray": [
        "Poem of the Sea"
      ],
      "Year": "1958",
      "Director": "Yuliya Solntseva",
      "DirectorArray": [
        "Yuliya Solntseva"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2700",
      "databaseFilmTitle": "Poetic Justice",
      "FilmTitle": "Poetic Justice",
      "AlternateTitle": "",
      "TitleArray": [
        "Poetic Justice"
      ],
      "Year": "1993",
      "Director": "John Singleton",
      "DirectorArray": [
        "John Singleton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2701",
      "databaseFilmTitle": "Poetry",
      "FilmTitle": "Poetry",
      "AlternateTitle": "Shi",
      "TitleArray": [
        "Poetry",
        "Shi"
      ],
      "Year": "2010",
      "Director": "Lee Chang-dong",
      "DirectorArray": [
        "Lee Chang-dong"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2702",
      "databaseFilmTitle": "Poil de carotte",
      "FilmTitle": "Poil de carotte",
      "AlternateTitle": "",
      "TitleArray": [
        "Poil de carotte"
      ],
      "Year": "1932",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2703",
      "databaseFilmTitle": "Point Blank",
      "FilmTitle": "Point Blank",
      "AlternateTitle": "",
      "TitleArray": [
        "Point Blank"
      ],
      "Year": "1967",
      "Director": "John Boorman",
      "DirectorArray": [
        "John Boorman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2704",
      "databaseFilmTitle": "Point Break",
      "FilmTitle": "Point Break",
      "AlternateTitle": "",
      "TitleArray": [
        "Point Break"
      ],
      "Year": "1991",
      "Director": "Kathryn Bigelow",
      "DirectorArray": [
        "Kathryn Bigelow"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2705",
      "databaseFilmTitle": "Poison",
      "FilmTitle": "Poison",
      "AlternateTitle": "",
      "TitleArray": [
        "Poison"
      ],
      "Year": "1991",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2706",
      "databaseFilmTitle": "Pola X",
      "FilmTitle": "Pola X",
      "AlternateTitle": "",
      "TitleArray": [
        "Pola X"
      ],
      "Year": "1999",
      "Director": "Leos Carax",
      "DirectorArray": [
        "Leos Carax"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2707",
      "databaseFilmTitle": "Police Story",
      "FilmTitle": "Police Story",
      "AlternateTitle": "Ging chat goo si",
      "TitleArray": [
        "Police Story",
        "Ging chat goo si"
      ],
      "Year": "1985",
      "Director": "Jackie Chan",
      "DirectorArray": [
        "Jackie Chan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2708",
      "databaseFilmTitle": "Police Story: Lockdown",
      "FilmTitle": "Police Story: Lockdown",
      "AlternateTitle": "Jing cha gu shi",
      "TitleArray": [
        "Police Story: Lockdown",
        "Jing cha gu shi"
      ],
      "Year": "2013",
      "Director": "Sheng Ding",
      "DirectorArray": [
        "Sheng Ding"
      ],
      "Country": "China, Hong Kong",
      "CountryArray": [
        "China",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2709",
      "databaseFilmTitle": "Police, Adjective",
      "FilmTitle": "Police, Adjective",
      "AlternateTitle": "Polițist, Adjectiv",
      "TitleArray": [
        "Police, Adjective",
        "Polițist, Adjectiv"
      ],
      "Year": "2009",
      "Director": "Corneliu Porumboiu",
      "DirectorArray": [
        "Corneliu Porumboiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2710",
      "databaseFilmTitle": "Policeman",
      "FilmTitle": "Policeman",
      "AlternateTitle": "Keisatsukan",
      "TitleArray": [
        "Policeman",
        "Keisatsukan"
      ],
      "Year": "1933",
      "Director": "Tomu Uchida",
      "DirectorArray": [
        "Tomu Uchida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2711",
      "databaseFilmTitle": "Pom Poko",
      "FilmTitle": "Pom Poko",
      "AlternateTitle": "Heisei tanuki gassen pompoko",
      "TitleArray": [
        "Pom Poko",
        "Heisei tanuki gassen pompoko"
      ],
      "Year": "1994",
      "Director": "Isao Takahata",
      "DirectorArray": [
        "Isao Takahata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2712",
      "databaseFilmTitle": "Pontypool",
      "FilmTitle": "Pontypool",
      "AlternateTitle": "",
      "TitleArray": [
        "Pontypool"
      ],
      "Year": "2008",
      "Director": "Bruce McDonald",
      "DirectorArray": [
        "Bruce McDonald"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2713",
      "databaseFilmTitle": "Poor Cow",
      "FilmTitle": "Poor Cow",
      "AlternateTitle": "",
      "TitleArray": [
        "Poor Cow"
      ],
      "Year": "1967",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2714",
      "databaseFilmTitle": "Poosteh",
      "FilmTitle": "Poosteh",
      "AlternateTitle": "",
      "TitleArray": [
        "Poosteh"
      ],
      "Year": "2009",
      "Director": "Mostafa Aleahmad",
      "DirectorArray": [
        "Mostafa Aleahmad"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2715",
      "databaseFilmTitle": "Popeye",
      "FilmTitle": "Popeye",
      "AlternateTitle": "",
      "TitleArray": [
        "Popeye"
      ],
      "Year": "1980",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2716",
      "databaseFilmTitle": "Poppies and Sailboats",
      "FilmTitle": "Poppies and Sailboats",
      "AlternateTitle": "Voiliers et coquelicots",
      "TitleArray": [
        "Poppies and Sailboats",
        "Voiliers et coquelicots"
      ],
      "Year": "2001",
      "Director": "Rose Lowder",
      "DirectorArray": [
        "Rose Lowder"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2717",
      "databaseFilmTitle": "Porco Rosso",
      "FilmTitle": "Porco Rosso",
      "AlternateTitle": "Kurenai no buta",
      "TitleArray": [
        "Porco Rosso",
        "Kurenai no buta"
      ],
      "Year": "1992",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2718",
      "databaseFilmTitle": "Port of Shadows",
      "FilmTitle": "Port of Shadows",
      "AlternateTitle": "Le quai des brumes",
      "TitleArray": [
        "Port of Shadows",
        "Le quai des brumes"
      ],
      "Year": "1938",
      "Director": "Marcel Carné",
      "DirectorArray": [
        "Marcel Carné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2719",
      "databaseFilmTitle": "Porto Of My Childhood",
      "FilmTitle": "Porto Of My Childhood",
      "AlternateTitle": "Porto da Minha Infância",
      "TitleArray": [
        "Porto Of My Childhood",
        "Porto da Minha Infância"
      ],
      "Year": "2001",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2720",
      "databaseFilmTitle": "Portrait of a Lady on Fire",
      "FilmTitle": "Portrait of a Lady on Fire",
      "AlternateTitle": "Portrait de la jeune fille en feu",
      "TitleArray": [
        "Portrait of a Lady on Fire",
        "Portrait de la jeune fille en feu"
      ],
      "Year": "2019",
      "Director": "Céline Sciamma",
      "DirectorArray": [
        "Céline Sciamma"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "30",
      "2022votes": "60"
    },
    {
      "key": "2721",
      "databaseFilmTitle": "Portrait of Ga",
      "FilmTitle": "Portrait of Ga",
      "AlternateTitle": "",
      "TitleArray": [
        "Portrait of Ga"
      ],
      "Year": "1952",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2722",
      "databaseFilmTitle": "Portrait of Jason",
      "FilmTitle": "Portrait of Jason",
      "AlternateTitle": "",
      "TitleArray": [
        "Portrait of Jason"
      ],
      "Year": "1967",
      "Director": "Shirley Clarke",
      "DirectorArray": [
        "Shirley Clarke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "2723",
      "databaseFilmTitle": "Portrait of Jennie",
      "FilmTitle": "Portrait of Jennie",
      "AlternateTitle": "",
      "TitleArray": [
        "Portrait of Jennie"
      ],
      "Year": "1948",
      "Director": "William Dieterle",
      "DirectorArray": [
        "William Dieterle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2724",
      "databaseFilmTitle": "Portrait of Madame Yuki",
      "FilmTitle": "Portrait of Madame Yuki",
      "AlternateTitle": "Yuki fujin ezu",
      "TitleArray": [
        "Portrait of Madame Yuki",
        "Yuki fujin ezu"
      ],
      "Year": "1950",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2725",
      "databaseFilmTitle": "Portrait of Maria",
      "FilmTitle": "Portrait of Maria",
      "AlternateTitle": "María Candelaria (Xochimilco)",
      "TitleArray": [
        "Portrait of Maria",
        "María Candelaria (Xochimilco)"
      ],
      "Year": "1944",
      "Director": "Emilio Fernández",
      "DirectorArray": [
        "Emilio Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2726",
      "databaseFilmTitle": "Portret",
      "FilmTitle": "Portret",
      "AlternateTitle": "",
      "TitleArray": [
        "Portret"
      ],
      "Year": "1977",
      "Director": "Stanisław Lenartowicz",
      "DirectorArray": [
        "Stanisław Lenartowicz"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2727",
      "databaseFilmTitle": "Possession",
      "FilmTitle": "Possession",
      "AlternateTitle": "",
      "TitleArray": [
        "Possession"
      ],
      "Year": "1981",
      "Director": "Andrzej Żuławski",
      "DirectorArray": [
        "Andrzej Żuławski"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "2728",
      "databaseFilmTitle": "Possibly in Michigan",
      "FilmTitle": "Possibly in Michigan",
      "AlternateTitle": "",
      "TitleArray": [
        "Possibly in Michigan"
      ],
      "Year": "1983",
      "Director": "Cecelia Condit",
      "DirectorArray": [
        "Cecelia Condit"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2729",
      "databaseFilmTitle": "Post",
      "FilmTitle": "Post",
      "AlternateTitle": "Pochta",
      "TitleArray": [
        "Post",
        "Pochta"
      ],
      "Year": "1929",
      "Director": "Mikhail Tsekhanovskiy",
      "DirectorArray": [
        "Mikhail Tsekhanovskiy"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2730",
      "databaseFilmTitle": "Powers of Ten",
      "FilmTitle": "Powers of Ten",
      "AlternateTitle": "",
      "TitleArray": [
        "Powers of Ten"
      ],
      "Year": "1977",
      "Director": "Charles Eames, Ray Eames",
      "DirectorArray": [
        "Charles Eames",
        "Ray Eames"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2731",
      "databaseFilmTitle": "Pravda",
      "FilmTitle": "Pravda",
      "AlternateTitle": "",
      "TitleArray": [
        "Pravda"
      ],
      "Year": "1970",
      "Director": "Groupe Dziga Vertov, Paul Burron, Jean-Luc Godard, Jean-Henri Roger",
      "DirectorArray": [
        "Groupe Dziga Vertov",
        "Paul Burron",
        "Jean-Luc Godard",
        "Jean-Henri Roger"
      ],
      "Country": "West Germany, France",
      "CountryArray": [
        "West Germany",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2732",
      "databaseFilmTitle": "Pray the Devil Back to Hell",
      "FilmTitle": "Pray the Devil Back to Hell",
      "AlternateTitle": "",
      "TitleArray": [
        "Pray the Devil Back to Hell"
      ],
      "Year": "2008",
      "Director": "Gini Reticker",
      "DirectorArray": [
        "Gini Reticker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2733",
      "databaseFilmTitle": "Precious",
      "FilmTitle": "Precious",
      "AlternateTitle": "",
      "TitleArray": [
        "Precious"
      ],
      "Year": "2009",
      "Director": "Lee Daniels",
      "DirectorArray": [
        "Lee Daniels"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2734",
      "databaseFilmTitle": "Predator",
      "FilmTitle": "Predator",
      "AlternateTitle": "",
      "TitleArray": [
        "Predator"
      ],
      "Year": "1987",
      "Director": "John McTiernan",
      "DirectorArray": [
        "John McTiernan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2735",
      "databaseFilmTitle": "Prehistory of the Partisans",
      "FilmTitle": "Prehistory of the Partisans",
      "AlternateTitle": "Paruchizan zenshi",
      "TitleArray": [
        "Prehistory of the Partisans",
        "Paruchizan zenshi"
      ],
      "Year": "1969",
      "Director": "Noriaki Tsuchimoto, Masao Tsusumi",
      "DirectorArray": [
        "Noriaki Tsuchimoto",
        "Masao Tsusumi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2736",
      "databaseFilmTitle": "Presents",
      "FilmTitle": "Presents",
      "AlternateTitle": "",
      "TitleArray": [
        "Presents"
      ],
      "Year": "1981",
      "Director": "Michael Snow",
      "DirectorArray": [
        "Michael Snow"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2737",
      "databaseFilmTitle": "Pressure",
      "FilmTitle": "Pressure",
      "AlternateTitle": "",
      "TitleArray": [
        "Pressure"
      ],
      "Year": "1976",
      "Director": "Horace Ové",
      "DirectorArray": [
        "Horace Ové"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2738",
      "databaseFilmTitle": "Pretty in Pink",
      "FilmTitle": "Pretty in Pink",
      "AlternateTitle": "",
      "TitleArray": [
        "Pretty in Pink"
      ],
      "Year": "1986",
      "Director": "Howard Deutch",
      "DirectorArray": [
        "Howard Deutch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2739",
      "databaseFilmTitle": "Pretty Village, Pretty Flame",
      "FilmTitle": "Pretty Village, Pretty Flame",
      "AlternateTitle": "Lepa sela lepo gore",
      "TitleArray": [
        "Pretty Village, Pretty Flame",
        "Lepa sela lepo gore"
      ],
      "Year": "1996",
      "Director": "Srdjan Dragojević",
      "DirectorArray": [
        "Srdjan Dragojević"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2740",
      "databaseFilmTitle": "Pretty Woman",
      "FilmTitle": "Pretty Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Pretty Woman"
      ],
      "Year": "1990",
      "Director": "Garry Marshall",
      "DirectorArray": [
        "Garry Marshall"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2741",
      "databaseFilmTitle": "Pride & Prejudice",
      "FilmTitle": "Pride & Prejudice",
      "AlternateTitle": "",
      "TitleArray": [
        "Pride & Prejudice"
      ],
      "Year": "2005",
      "Director": "Joe Wright",
      "DirectorArray": [
        "Joe Wright"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2742",
      "databaseFilmTitle": "Priest of Darkness",
      "FilmTitle": "Priest of Darkness",
      "AlternateTitle": "Kōchiyama Sōshun",
      "TitleArray": [
        "Priest of Darkness",
        "Kōchiyama Sōshun"
      ],
      "Year": "1936",
      "Director": "Sadao Yamanaka",
      "DirectorArray": [
        "Sadao Yamanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2743",
      "databaseFilmTitle": "Primary",
      "FilmTitle": "Primary",
      "AlternateTitle": "",
      "TitleArray": [
        "Primary"
      ],
      "Year": "1960",
      "Director": "Robert Drew",
      "DirectorArray": [
        "Robert Drew"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2744",
      "databaseFilmTitle": "Primate",
      "FilmTitle": "Primate",
      "AlternateTitle": "",
      "TitleArray": [
        "Primate"
      ],
      "Year": "1974",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2745",
      "databaseFilmTitle": "Princess Mononoke",
      "FilmTitle": "Princess Mononoke",
      "AlternateTitle": "Mononoke-hime",
      "TitleArray": [
        "Princess Mononoke",
        "Mononoke-hime"
      ],
      "Year": "1997",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2746",
      "databaseFilmTitle": "Princess Raccoon",
      "FilmTitle": "Princess Raccoon",
      "AlternateTitle": "Operetta tanuki goten",
      "TitleArray": [
        "Princess Raccoon",
        "Operetta tanuki goten"
      ],
      "Year": "2005",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2747",
      "databaseFilmTitle": "Princess Yang Kwei-fei",
      "FilmTitle": "Princess Yang Kwei-fei",
      "AlternateTitle": "Yōkihi",
      "TitleArray": [
        "Princess Yang Kwei-fei",
        "Yōkihi"
      ],
      "Year": "1955",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2748",
      "databaseFilmTitle": "Prison",
      "FilmTitle": "Prison",
      "AlternateTitle": "Fängelse",
      "TitleArray": [
        "Prison",
        "Fängelse"
      ],
      "Year": "1949",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2749",
      "databaseFilmTitle": "Profit & Nothing But! Or Impolite Thoughts on the Class Struggle",
      "FilmTitle": "Profit & Nothing But! Or Impolite Thoughts on the Class Struggle",
      "AlternateTitle": "Le Profit et rien d'autre ou: réflexions abusives sur la lutte des classes",
      "TitleArray": [
        "Profit & Nothing But! Or Impolite Thoughts on the Class Struggle",
        "Le Profit et rien d'autre ou: réflexions abusives sur la lutte des classes"
      ],
      "Year": "2001",
      "Director": "Raoul Peck",
      "DirectorArray": [
        "Raoul Peck"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2750",
      "databaseFilmTitle": "Profit Motive and The Whispering Wind",
      "FilmTitle": "Profit Motive and The Whispering Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "Profit Motive and The Whispering Wind"
      ],
      "Year": "2007",
      "Director": "John Gianvito",
      "DirectorArray": [
        "John Gianvito"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2751",
      "databaseFilmTitle": "Profound Desires of the Gods",
      "FilmTitle": "Profound Desires of the Gods",
      "AlternateTitle": "Kamigami no fukaki yokubo",
      "TitleArray": [
        "Profound Desires of the Gods",
        "Kamigami no fukaki yokubo"
      ],
      "Year": "1968",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2752",
      "databaseFilmTitle": "Promising Young Woman",
      "FilmTitle": "Promising Young Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Promising Young Woman"
      ],
      "Year": "2020",
      "Director": "Emerald Fennell",
      "DirectorArray": [
        "Emerald Fennell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2753",
      "databaseFilmTitle": "Prospero's Books",
      "FilmTitle": "Prospero's Books",
      "AlternateTitle": "",
      "TitleArray": [
        "Prospero's Books"
      ],
      "Year": "1991",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2754",
      "databaseFilmTitle": "Protéa",
      "FilmTitle": "Protéa",
      "AlternateTitle": "",
      "TitleArray": [
        "Protéa"
      ],
      "Year": "1913",
      "Director": "Victorin-Hippolyte Jasset",
      "DirectorArray": [
        "Victorin-Hippolyte Jasset"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2755",
      "databaseFilmTitle": "Providence",
      "FilmTitle": "Providence",
      "AlternateTitle": "",
      "TitleArray": [
        "Providence"
      ],
      "Year": "1977",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2756",
      "databaseFilmTitle": "Przypadek?",
      "FilmTitle": "Przypadek?",
      "AlternateTitle": "",
      "TitleArray": [
        "Przypadek?"
      ],
      "Year": "1977",
      "Director": "Krzysztof Kiwerski",
      "DirectorArray": [
        "Krzysztof Kiwerski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2757",
      "databaseFilmTitle": "Psycho",
      "FilmTitle": "Psycho",
      "AlternateTitle": "",
      "TitleArray": [
        "Psycho"
      ],
      "Year": "1960",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "34",
      "2012votes": "35",
      "2022rank": "31",
      "2022votes": "59"
    },
    {
      "key": "2758",
      "databaseFilmTitle": "Psychomania",
      "FilmTitle": "Psychomania",
      "AlternateTitle": "",
      "TitleArray": [
        "Psychomania"
      ],
      "Year": "1973",
      "Director": "Don Sharp",
      "DirectorArray": [
        "Don Sharp"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2759",
      "databaseFilmTitle": "Public Housing",
      "FilmTitle": "Public Housing",
      "AlternateTitle": "",
      "TitleArray": [
        "Public Housing"
      ],
      "Year": "1997",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2760",
      "databaseFilmTitle": "Pulp Fiction",
      "FilmTitle": "Pulp Fiction",
      "AlternateTitle": "",
      "TitleArray": [
        "Pulp Fiction"
      ],
      "Year": "1994",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "129",
      "2022votes": "23"
    },
    {
      "key": "2761",
      "databaseFilmTitle": "Pulse",
      "FilmTitle": "Pulse",
      "AlternateTitle": "Kairo",
      "TitleArray": [
        "Pulse",
        "Kairo"
      ],
      "Year": "2001",
      "Director": "Kiyoshi Kurosawa",
      "DirectorArray": [
        "Kiyoshi Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2762",
      "databaseFilmTitle": "Pumping Iron",
      "FilmTitle": "Pumping Iron",
      "AlternateTitle": "",
      "TitleArray": [
        "Pumping Iron"
      ],
      "Year": "1977",
      "Director": "George Butler, Robert Fiore",
      "DirectorArray": [
        "George Butler",
        "Robert Fiore"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2763",
      "databaseFilmTitle": "Punch-Drunk Love",
      "FilmTitle": "Punch-Drunk Love",
      "AlternateTitle": "",
      "TitleArray": [
        "Punch-Drunk Love"
      ],
      "Year": "2002",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2764",
      "databaseFilmTitle": "Punishment Park",
      "FilmTitle": "Punishment Park",
      "AlternateTitle": "",
      "TitleArray": [
        "Punishment Park"
      ],
      "Year": "1971",
      "Director": "Peter Watkins",
      "DirectorArray": [
        "Peter Watkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2765",
      "databaseFilmTitle": "Purple",
      "FilmTitle": "Purple",
      "AlternateTitle": "",
      "TitleArray": [
        "Purple"
      ],
      "Year": "2017",
      "Director": "John Akomfrah",
      "DirectorArray": [
        "John Akomfrah"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2766",
      "databaseFilmTitle": "Pursued",
      "FilmTitle": "Pursued",
      "AlternateTitle": "",
      "TitleArray": [
        "Pursued"
      ],
      "Year": "1947",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2767",
      "databaseFilmTitle": "Puzzle of a Downfall Child",
      "FilmTitle": "Puzzle of a Downfall Child",
      "AlternateTitle": "",
      "TitleArray": [
        "Puzzle of a Downfall Child"
      ],
      "Year": "1970",
      "Director": "Jerry Schatzberg",
      "DirectorArray": [
        "Jerry Schatzberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2768",
      "databaseFilmTitle": "Pyaasa",
      "FilmTitle": "Pyaasa",
      "AlternateTitle": "",
      "TitleArray": [
        "Pyaasa"
      ],
      "Year": "1957",
      "Director": "Guru Dutt",
      "DirectorArray": [
        "Guru Dutt"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "2769",
      "databaseFilmTitle": "Pygmalion",
      "FilmTitle": "Pygmalion",
      "AlternateTitle": "",
      "TitleArray": [
        "Pygmalion"
      ],
      "Year": "1938",
      "Director": "Anthony Asquith, Leslie Howard",
      "DirectorArray": [
        "Anthony Asquith",
        "Leslie Howard"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2770",
      "databaseFilmTitle": "Qabyo 2",
      "FilmTitle": "Qabyo 2",
      "AlternateTitle": "",
      "TitleArray": [
        "Qabyo 2"
      ],
      "Year": "2003",
      "Director": "Ibrahim Abdulkadir Ibrahim, Abdulrahman Issa Kahin",
      "DirectorArray": [
        "Ibrahim Abdulkadir Ibrahim",
        "Abdulrahman Issa Kahin"
      ],
      "Country": "Somalia",
      "CountryArray": [
        "Somalia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2771",
      "databaseFilmTitle": "Quality Control",
      "FilmTitle": "Quality Control",
      "AlternateTitle": "",
      "TitleArray": [
        "Quality Control"
      ],
      "Year": "2011",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2772",
      "databaseFilmTitle": "Quatermass 2: Enemy from Space",
      "FilmTitle": "Quatermass 2: Enemy from Space",
      "AlternateTitle": "",
      "TitleArray": [
        "Quatermass 2: Enemy from Space"
      ],
      "Year": "1957",
      "Director": "United Kingdom",
      "DirectorArray": [
        "United Kingdom"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2773",
      "databaseFilmTitle": "Queen Christina",
      "FilmTitle": "Queen Christina",
      "AlternateTitle": "",
      "TitleArray": [
        "Queen Christina"
      ],
      "Year": "1933",
      "Director": "Rouben Mamoulian",
      "DirectorArray": [
        "Rouben Mamoulian"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2774",
      "databaseFilmTitle": "Queen Kelly",
      "FilmTitle": "Queen Kelly",
      "AlternateTitle": "",
      "TitleArray": [
        "Queen Kelly"
      ],
      "Year": "1932",
      "Director": "Erich von Stroheim",
      "DirectorArray": [
        "Erich von Stroheim"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2775",
      "databaseFilmTitle": "Querelle",
      "FilmTitle": "Querelle",
      "AlternateTitle": "",
      "TitleArray": [
        "Querelle"
      ],
      "Year": "1982",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2776",
      "databaseFilmTitle": "Quick Billy",
      "FilmTitle": "Quick Billy",
      "AlternateTitle": "",
      "TitleArray": [
        "Quick Billy"
      ],
      "Year": "1971",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2777",
      "databaseFilmTitle": "Quintet",
      "FilmTitle": "Quintet",
      "AlternateTitle": "",
      "TitleArray": [
        "Quintet"
      ],
      "Year": "1979",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2778",
      "databaseFilmTitle": "Quixote",
      "FilmTitle": "Quixote",
      "AlternateTitle": "",
      "TitleArray": [
        "Quixote"
      ],
      "Year": "1965",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2779",
      "databaseFilmTitle": "Quo vadis, Aida?",
      "FilmTitle": "Quo vadis, Aida?",
      "AlternateTitle": "",
      "TitleArray": [
        "Quo vadis, Aida?"
      ],
      "Year": "2020",
      "Director": "Jasmila Žbanić",
      "DirectorArray": [
        "Jasmila Žbanić"
      ],
      "Country": "Bosnia and Herzegovina, Austria",
      "CountryArray": [
        "Bosnia and Herzegovina",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2780",
      "databaseFilmTitle": "R.I.P.",
      "FilmTitle": "R.I.P.",
      "AlternateTitle": "Ee. Ma. Yau.",
      "TitleArray": [
        "R.I.P.",
        "Ee. Ma. Yau."
      ],
      "Year": "2018",
      "Director": "Lijo Jose Pellissery",
      "DirectorArray": [
        "Lijo Jose Pellissery"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2781",
      "databaseFilmTitle": "Rabbit of Seville",
      "FilmTitle": "Rabbit of Seville",
      "AlternateTitle": "",
      "TitleArray": [
        "Rabbit of Seville"
      ],
      "Year": "1950",
      "Director": "Chuck Jones",
      "DirectorArray": [
        "Chuck Jones"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2782",
      "databaseFilmTitle": "Rabbit's Moon",
      "FilmTitle": "Rabbit's Moon",
      "AlternateTitle": "",
      "TitleArray": [
        "Rabbit's Moon"
      ],
      "Year": "1950",
      "Director": "Kenneth Anger",
      "DirectorArray": [
        "Kenneth Anger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2783",
      "databaseFilmTitle": "Radiograph of a Family",
      "FilmTitle": "Radiograph of a Family",
      "AlternateTitle": "",
      "TitleArray": [
        "Radiograph of a Family"
      ],
      "Year": "2020",
      "Director": "Firouzeh Khosrovani",
      "DirectorArray": [
        "Firouzeh Khosrovani"
      ],
      "Country": "Norway, Iran",
      "CountryArray": [
        "Norway",
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2784",
      "databaseFilmTitle": "Rafiki",
      "FilmTitle": "Rafiki",
      "AlternateTitle": "",
      "TitleArray": [
        "Rafiki"
      ],
      "Year": "2018",
      "Director": "Wanuri Kahiu",
      "DirectorArray": [
        "Wanuri Kahiu"
      ],
      "Country": "Kenya, South Africa",
      "CountryArray": [
        "Kenya",
        "South Africa"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2785",
      "databaseFilmTitle": "Raging Bull",
      "FilmTitle": "Raging Bull",
      "AlternateTitle": "",
      "TitleArray": [
        "Raging Bull"
      ],
      "Year": "1980",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "53",
      "2012votes": "28",
      "2022rank": "129",
      "2022votes": "23"
    },
    {
      "key": "2786",
      "databaseFilmTitle": "Raiders of the Lost Ark",
      "FilmTitle": "Raiders of the Lost Ark",
      "AlternateTitle": "",
      "TitleArray": [
        "Raiders of the Lost Ark"
      ],
      "Year": "1981",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "2787",
      "databaseFilmTitle": "Rain",
      "FilmTitle": "Rain",
      "AlternateTitle": "Regen",
      "TitleArray": [
        "Rain",
        "Regen"
      ],
      "Year": "1929",
      "Director": "Joris Ivens, Mannus Franken",
      "DirectorArray": [
        "Joris Ivens",
        "Mannus Franken"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2788",
      "databaseFilmTitle": "Rain Man",
      "FilmTitle": "Rain Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Rain Man"
      ],
      "Year": "1988",
      "Director": "Barry Levinson",
      "DirectorArray": [
        "Barry Levinson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2789",
      "databaseFilmTitle": "Rainbow Dance",
      "FilmTitle": "Rainbow Dance",
      "AlternateTitle": "",
      "TitleArray": [
        "Rainbow Dance"
      ],
      "Year": "1936",
      "Director": "Len Lye",
      "DirectorArray": [
        "Len Lye"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2790",
      "databaseFilmTitle": "Raining in the Mountain",
      "FilmTitle": "Raining in the Mountain",
      "AlternateTitle": "Kong shan ling yu",
      "TitleArray": [
        "Raining in the Mountain",
        "Kong shan ling yu"
      ],
      "Year": "1979",
      "Director": "King Hu",
      "DirectorArray": [
        "King Hu"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2791",
      "databaseFilmTitle": "Raise the Red Lantern",
      "FilmTitle": "Raise the Red Lantern",
      "AlternateTitle": "Da hong deng long gao gao gua",
      "TitleArray": [
        "Raise the Red Lantern",
        "Da hong deng long gao gao gua"
      ],
      "Year": "1991",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2792",
      "databaseFilmTitle": "Raising Arizona",
      "FilmTitle": "Raising Arizona",
      "AlternateTitle": "",
      "TitleArray": [
        "Raising Arizona"
      ],
      "Year": "1987",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2793",
      "databaseFilmTitle": "Raising Cain",
      "FilmTitle": "Raising Cain",
      "AlternateTitle": "",
      "TitleArray": [
        "Raising Cain"
      ],
      "Year": "1992",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2794",
      "databaseFilmTitle": "Rally 'Round the Flag, Boys!",
      "FilmTitle": "Rally 'Round the Flag, Boys!",
      "AlternateTitle": "",
      "TitleArray": [
        "Rally 'Round the Flag, Boys!"
      ],
      "Year": "1958",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2795",
      "databaseFilmTitle": "Rambo",
      "FilmTitle": "Rambo",
      "AlternateTitle": "",
      "TitleArray": [
        "Rambo"
      ],
      "Year": "2008",
      "Director": "Sylvester Stallone",
      "DirectorArray": [
        "Sylvester Stallone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2796",
      "databaseFilmTitle": "Ramchand Pakistani",
      "FilmTitle": "Ramchand Pakistani",
      "AlternateTitle": "",
      "TitleArray": [
        "Ramchand Pakistani"
      ],
      "Year": "2008",
      "Director": "Mehreen Jabbar",
      "DirectorArray": [
        "Mehreen Jabbar"
      ],
      "Country": "Pakistan",
      "CountryArray": [
        "Pakistan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2797",
      "databaseFilmTitle": "Rameau's Nephew' by Diderot (Thanx to Dennis Young) by Wilma Schoen",
      "FilmTitle": "Rameau's Nephew' by Diderot (Thanx to Dennis Young) by Wilma Schoen",
      "AlternateTitle": "",
      "TitleArray": [
        "Rameau's Nephew' by Diderot (Thanx to Dennis Young) by Wilma Schoen"
      ],
      "Year": "1974",
      "Director": "Michael Snow",
      "DirectorArray": [
        "Michael Snow"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2798",
      "databaseFilmTitle": "Ran",
      "FilmTitle": "Ran",
      "AlternateTitle": "",
      "TitleArray": [
        "Ran"
      ],
      "Year": "1985",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "2799",
      "databaseFilmTitle": "Random Harvest",
      "FilmTitle": "Random Harvest",
      "AlternateTitle": "",
      "TitleArray": [
        "Random Harvest"
      ],
      "Year": "1942",
      "Director": "Mervyn LeRoy",
      "DirectorArray": [
        "Mervyn LeRoy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2800",
      "databaseFilmTitle": "Rapture",
      "FilmTitle": "Rapture",
      "AlternateTitle": "Arrebato",
      "TitleArray": [
        "Rapture",
        "Arrebato"
      ],
      "Year": "1979",
      "Director": "Iván Zulueta",
      "DirectorArray": [
        "Iván Zulueta"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2801",
      "databaseFilmTitle": "Rashomon",
      "FilmTitle": "Rashomon",
      "AlternateTitle": "",
      "TitleArray": [
        "Rashomon"
      ],
      "Year": "1950",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "14",
      "2002votes": "14",
      "2012rank": "24",
      "2012votes": "42",
      "2022rank": "41",
      "2022votes": "52"
    },
    {
      "key": "2802",
      "databaseFilmTitle": "Rat-Trap",
      "FilmTitle": "Rat-Trap",
      "AlternateTitle": "Elippathayam",
      "TitleArray": [
        "Rat-Trap",
        "Elippathayam"
      ],
      "Year": "1981",
      "Director": "Adoor Gopalakrishnan",
      "DirectorArray": [
        "Adoor Gopalakrishnan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2803",
      "databaseFilmTitle": "Ratatouille",
      "FilmTitle": "Ratatouille",
      "AlternateTitle": "",
      "TitleArray": [
        "Ratatouille"
      ],
      "Year": "2007",
      "Director": "Brad Bird, Jan Pinkava",
      "DirectorArray": [
        "Brad Bird",
        "Jan Pinkava"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2804",
      "databaseFilmTitle": "Ratcatcher",
      "FilmTitle": "Ratcatcher",
      "AlternateTitle": "",
      "TitleArray": [
        "Ratcatcher"
      ],
      "Year": "1999",
      "Director": "Lynne Ramsay",
      "DirectorArray": [
        "Lynne Ramsay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2805",
      "databaseFilmTitle": "Rattlesnake",
      "FilmTitle": "Rattlesnake",
      "AlternateTitle": "Cascabel",
      "TitleArray": [
        "Rattlesnake",
        "Cascabel"
      ],
      "Year": "1977",
      "Director": "Raúl Araiza",
      "DirectorArray": [
        "Raúl Araiza"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2806",
      "databaseFilmTitle": "Raw",
      "FilmTitle": "Raw",
      "AlternateTitle": "Gravw",
      "TitleArray": [
        "Raw",
        "Gravw"
      ],
      "Year": "2016",
      "Director": "Julia Ducournau",
      "DirectorArray": [
        "Julia Ducournau"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2807",
      "databaseFilmTitle": "Ray & Liz",
      "FilmTitle": "Ray & Liz",
      "AlternateTitle": "",
      "TitleArray": [
        "Ray & Liz"
      ],
      "Year": "2018",
      "Director": "Richard Billingham",
      "DirectorArray": [
        "Richard Billingham"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2808",
      "databaseFilmTitle": "Raymond Tallis: On Tickling",
      "FilmTitle": "Raymond Tallis: On Tickling",
      "AlternateTitle": "",
      "TitleArray": [
        "Raymond Tallis: On Tickling"
      ],
      "Year": "2017",
      "Director": "Johan Grimonprez",
      "DirectorArray": [
        "Johan Grimonprez"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2809",
      "databaseFilmTitle": "Razor Blades",
      "FilmTitle": "Razor Blades",
      "AlternateTitle": "",
      "TitleArray": [
        "Razor Blades"
      ],
      "Year": "1965",
      "Director": "Paul Sharits",
      "DirectorArray": [
        "Paul Sharits"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2810",
      "databaseFilmTitle": "Re-Animator",
      "FilmTitle": "Re-Animator",
      "AlternateTitle": "",
      "TitleArray": [
        "Re-Animator"
      ],
      "Year": "1985",
      "Director": "Stuart Gordon",
      "DirectorArray": [
        "Stuart Gordon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2811",
      "databaseFilmTitle": "Reality's Invisible",
      "FilmTitle": "Reality's Invisible",
      "AlternateTitle": "",
      "TitleArray": [
        "Reality's Invisible"
      ],
      "Year": "1971",
      "Director": "Robert Fulton",
      "DirectorArray": [
        "Robert Fulton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2812",
      "databaseFilmTitle": "Rear Window",
      "FilmTitle": "Rear Window",
      "AlternateTitle": "",
      "TitleArray": [
        "Rear Window"
      ],
      "Year": "1954",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "26",
      "1992votes": "7",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "53",
      "2012votes": "28",
      "2022rank": "38",
      "2022votes": "53"
    },
    {
      "key": "2813",
      "databaseFilmTitle": "Reason, Debate and a Story",
      "FilmTitle": "Reason, Debate and a Story",
      "AlternateTitle": "Jukti, Takko Aar Gappo",
      "TitleArray": [
        "Reason, Debate and a Story",
        "Jukti, Takko Aar Gappo"
      ],
      "Year": "1974",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2814",
      "databaseFilmTitle": "Reassemblage",
      "FilmTitle": "Reassemblage",
      "AlternateTitle": "",
      "TitleArray": [
        "Reassemblage"
      ],
      "Year": "1982",
      "Director": "T. Minh-ha Trinh",
      "DirectorArray": [
        "T. Minh-ha Trinh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2815",
      "databaseFilmTitle": "Rebecca",
      "FilmTitle": "Rebecca",
      "AlternateTitle": "",
      "TitleArray": [
        "Rebecca"
      ],
      "Year": "1940",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2816",
      "databaseFilmTitle": "Rebel Without a Cause",
      "FilmTitle": "Rebel Without a Cause",
      "AlternateTitle": "",
      "TitleArray": [
        "Rebel Without a Cause"
      ],
      "Year": "1955",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2817",
      "databaseFilmTitle": "Rebellion from Below",
      "FilmTitle": "Rebellion from Below",
      "AlternateTitle": "Gyakusha gokumon toride",
      "TitleArray": [
        "Rebellion from Below",
        "Gyakusha gokumon toride"
      ],
      "Year": "1956",
      "Director": "Tomu Uchida",
      "DirectorArray": [
        "Tomu Uchida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2818",
      "databaseFilmTitle": "Rebels of the Neon God",
      "FilmTitle": "Rebels of the Neon God",
      "AlternateTitle": "",
      "TitleArray": [
        "Rebels of the Neon God"
      ],
      "Year": "1992",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2819",
      "databaseFilmTitle": "Rebirth Is Necessary",
      "FilmTitle": "Rebirth Is Necessary",
      "AlternateTitle": "",
      "TitleArray": [
        "Rebirth Is Necessary"
      ],
      "Year": "2017",
      "Director": "Jenn Nkiru",
      "DirectorArray": [
        "Jenn Nkiru"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2820",
      "databaseFilmTitle": "Recollections of the Yellow House",
      "FilmTitle": "Recollections of the Yellow House",
      "AlternateTitle": "Recordações da Casa Amarela: Uma Comédia Lusitana",
      "TitleArray": [
        "Recollections of the Yellow House",
        "Recordações da Casa Amarela: Uma Comédia Lusitana"
      ],
      "Year": "1989",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2821",
      "databaseFilmTitle": "Reconstruction",
      "FilmTitle": "Reconstruction",
      "AlternateTitle": "Reconstituiera",
      "TitleArray": [
        "Reconstruction",
        "Reconstituiera"
      ],
      "Year": "1968",
      "Director": "Lucian Pintilie",
      "DirectorArray": [
        "Lucian Pintilie"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2822",
      "databaseFilmTitle": "Record of a Tenement Gentleman",
      "FilmTitle": "Record of a Tenement Gentleman",
      "AlternateTitle": "Nagaya Shinshiroku",
      "TitleArray": [
        "Record of a Tenement Gentleman",
        "Nagaya Shinshiroku"
      ],
      "Year": "1947",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2823",
      "databaseFilmTitle": "Recreation",
      "FilmTitle": "Recreation",
      "AlternateTitle": "",
      "TitleArray": [
        "Recreation"
      ],
      "Year": "1956",
      "Director": "Robert Breer",
      "DirectorArray": [
        "Robert Breer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2824",
      "databaseFilmTitle": "Red Beard",
      "FilmTitle": "Red Beard",
      "AlternateTitle": "Akahige",
      "TitleArray": [
        "Red Beard",
        "Akahige"
      ],
      "Year": "1965",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2825",
      "databaseFilmTitle": "Red Desert",
      "FilmTitle": "Red Desert",
      "AlternateTitle": "Il deserto rosoo",
      "TitleArray": [
        "Red Desert",
        "Il deserto rosoo"
      ],
      "Year": "1964",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "2826",
      "databaseFilmTitle": "Red Hollywood",
      "FilmTitle": "Red Hollywood",
      "AlternateTitle": "",
      "TitleArray": [
        "Red Hollywood"
      ],
      "Year": "1996",
      "Director": "Thom Andersen, Noël Burch",
      "DirectorArray": [
        "Thom Andersen",
        "Noël Burch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2827",
      "databaseFilmTitle": "Red Hot Riding Hood",
      "FilmTitle": "Red Hot Riding Hood",
      "AlternateTitle": "",
      "TitleArray": [
        "Red Hot Riding Hood"
      ],
      "Year": "1943",
      "Director": "Tex Avery",
      "DirectorArray": [
        "Tex Avery"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2828",
      "databaseFilmTitle": "Red Line 7000",
      "FilmTitle": "Red Line 7000",
      "AlternateTitle": "",
      "TitleArray": [
        "Red Line 7000"
      ],
      "Year": "1965",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2829",
      "databaseFilmTitle": "Red Peony Gambler 6: Oryu's Visit",
      "FilmTitle": "Red Peony Gambler 6: Oryu's Visit",
      "AlternateTitle": "Hibotan bakuto: Oryû sanjô",
      "TitleArray": [
        "Red Peony Gambler 6: Oryu's Visit",
        "Hibotan bakuto: Oryû sanjô"
      ],
      "Year": "1970",
      "Director": "Tai Katô",
      "DirectorArray": [
        "Tai Katô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2830",
      "databaseFilmTitle": "Red Persimmon",
      "FilmTitle": "Red Persimmon",
      "AlternateTitle": "Hong shi zi",
      "TitleArray": [
        "Red Persimmon",
        "Hong shi zi"
      ],
      "Year": "1996",
      "Director": "Wang Toon",
      "DirectorArray": [
        "Wang Toon"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2831",
      "databaseFilmTitle": "Red Psalm",
      "FilmTitle": "Red Psalm",
      "AlternateTitle": "Még kér a nép",
      "TitleArray": [
        "Red Psalm",
        "Még kér a nép"
      ],
      "Year": "1972",
      "Director": "Miklós Jancsó",
      "DirectorArray": [
        "Miklós Jancsó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2832",
      "databaseFilmTitle": "Red River",
      "FilmTitle": "Red River",
      "AlternateTitle": "",
      "TitleArray": [
        "Red River"
      ],
      "Year": "1948",
      "Director": "Howard Hawks, Arthur Rosson",
      "DirectorArray": [
        "Howard Hawks",
        "Arthur Rosson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2833",
      "databaseFilmTitle": "Red Road",
      "FilmTitle": "Red Road",
      "AlternateTitle": "",
      "TitleArray": [
        "Red Road"
      ],
      "Year": "2006",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2834",
      "databaseFilmTitle": "Red Sorghum",
      "FilmTitle": "Red Sorghum",
      "AlternateTitle": "Hong gau liang",
      "TitleArray": [
        "Red Sorghum",
        "Hong gau liang"
      ],
      "Year": "1987",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2835",
      "databaseFilmTitle": "Red Wood Pigeon",
      "FilmTitle": "Red Wood Pigeon",
      "AlternateTitle": "Palombella rossa",
      "TitleArray": [
        "Red Wood Pigeon",
        "Palombella rossa"
      ],
      "Year": "1989",
      "Director": "Nanni Moretti",
      "DirectorArray": [
        "Nanni Moretti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "2836",
      "databaseFilmTitle": "Redline",
      "FilmTitle": "Redline",
      "AlternateTitle": "",
      "TitleArray": [
        "Redline"
      ],
      "Year": "2009",
      "Director": "Takeshi Koike",
      "DirectorArray": [
        "Takeshi Koike"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2837",
      "databaseFilmTitle": "Reds",
      "FilmTitle": "Reds",
      "AlternateTitle": "",
      "TitleArray": [
        "Reds"
      ],
      "Year": "1981",
      "Director": "Warren Beatty",
      "DirectorArray": [
        "Warren Beatty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2838",
      "databaseFilmTitle": "Reel Time",
      "FilmTitle": "Reel Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Reel Time"
      ],
      "Year": "2008",
      "Director": "Randall Cole",
      "DirectorArray": [
        "Randall Cole"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2839",
      "databaseFilmTitle": "Regular Lovers",
      "FilmTitle": "Regular Lovers",
      "AlternateTitle": "Les amants réguliers",
      "TitleArray": [
        "Regular Lovers",
        "Les amants réguliers"
      ],
      "Year": "2005",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2840",
      "databaseFilmTitle": "Rehearsals for Extinct Anatomies",
      "FilmTitle": "Rehearsals for Extinct Anatomies",
      "AlternateTitle": "",
      "TitleArray": [
        "Rehearsals for Extinct Anatomies"
      ],
      "Year": "1987",
      "Director": "Stephen Quay, Timothy Quay",
      "DirectorArray": [
        "Stephen Quay",
        "Timothy Quay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2841",
      "databaseFilmTitle": "Rembrandt",
      "FilmTitle": "Rembrandt",
      "AlternateTitle": "",
      "TitleArray": [
        "Rembrandt"
      ],
      "Year": "1942",
      "Director": "Hans Steinhoff",
      "DirectorArray": [
        "Hans Steinhoff"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2842",
      "databaseFilmTitle": "Remember the Night",
      "FilmTitle": "Remember the Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Remember the Night"
      ],
      "Year": "1940",
      "Director": "Mitchell Leisen",
      "DirectorArray": [
        "Mitchell Leisen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2843",
      "databaseFilmTitle": "Reminiscences of a Journey to Lithuania",
      "FilmTitle": "Reminiscences of a Journey to Lithuania",
      "AlternateTitle": "",
      "TitleArray": [
        "Reminiscences of a Journey to Lithuania"
      ],
      "Year": "1972",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States, West Germany",
      "CountryArray": [
        "United States",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2844",
      "databaseFilmTitle": "Renaissance",
      "FilmTitle": "Renaissance",
      "AlternateTitle": "",
      "TitleArray": [
        "Renaissance"
      ],
      "Year": "1964",
      "Director": "Walerian Borowczyk",
      "DirectorArray": [
        "Walerian Borowczyk"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2845",
      "databaseFilmTitle": "Renaldo and Clara",
      "FilmTitle": "Renaldo and Clara",
      "AlternateTitle": "",
      "TitleArray": [
        "Renaldo and Clara"
      ],
      "Year": "1978",
      "Director": "Bob Dylan",
      "DirectorArray": [
        "Bob Dylan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2846",
      "databaseFilmTitle": "Rendez-vous à Bray",
      "FilmTitle": "Rendez-vous à Bray",
      "AlternateTitle": "",
      "TitleArray": [
        "Rendez-vous à Bray"
      ],
      "Year": "1971",
      "Director": "André Delvaux",
      "DirectorArray": [
        "André Delvaux"
      ],
      "Country": "Belgium, West Germany",
      "CountryArray": [
        "Belgium",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2847",
      "databaseFilmTitle": "Rentrée des classes",
      "FilmTitle": "Rentrée des classes",
      "AlternateTitle": "",
      "TitleArray": [
        "Rentrée des classes"
      ],
      "Year": "1956",
      "Director": "Jacques Rozier",
      "DirectorArray": [
        "Jacques Rozier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2848",
      "databaseFilmTitle": "Repo Man",
      "FilmTitle": "Repo Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Repo Man"
      ],
      "Year": "1984",
      "Director": "Alex Cox",
      "DirectorArray": [
        "Alex Cox"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2849",
      "databaseFilmTitle": "Report",
      "FilmTitle": "Report",
      "AlternateTitle": "",
      "TitleArray": [
        "Report"
      ],
      "Year": "1967",
      "Director": "Bruce Conner",
      "DirectorArray": [
        "Bruce Conner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2850",
      "databaseFilmTitle": "Report to Mother",
      "FilmTitle": "Report to Mother",
      "AlternateTitle": "Amma Ariyan",
      "TitleArray": [
        "Report to Mother",
        "Amma Ariyan"
      ],
      "Year": "1986",
      "Director": "John Abraham",
      "DirectorArray": [
        "John Abraham"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2851",
      "databaseFilmTitle": "Republic",
      "FilmTitle": "Republic",
      "AlternateTitle": "República",
      "TitleArray": [
        "Republic",
        "República"
      ],
      "Year": "2020",
      "Director": "Grace Passô",
      "DirectorArray": [
        "Grace Passô"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2852",
      "databaseFilmTitle": "Republic Steel Strike Riots Newsreel Footage",
      "FilmTitle": "Republic Steel Strike Riots Newsreel Footage",
      "AlternateTitle": "",
      "TitleArray": [
        "Republic Steel Strike Riots Newsreel Footage"
      ],
      "Year": "1937",
      "Director": "N/A",
      "DirectorArray": [
        "N/A"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2853",
      "databaseFilmTitle": "Repulsion",
      "FilmTitle": "Repulsion",
      "AlternateTitle": "",
      "TitleArray": [
        "Repulsion"
      ],
      "Year": "1965",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2854",
      "databaseFilmTitle": "Requiem for a Dream",
      "FilmTitle": "Requiem for a Dream",
      "AlternateTitle": "",
      "TitleArray": [
        "Requiem for a Dream"
      ],
      "Year": "2000",
      "Director": "Darren Aronofsky",
      "DirectorArray": [
        "Darren Aronofsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2855",
      "databaseFilmTitle": "Requiem from Java",
      "FilmTitle": "Requiem from Java",
      "AlternateTitle": "Opera Jawa",
      "TitleArray": [
        "Requiem from Java",
        "Opera Jawa"
      ],
      "Year": "2006",
      "Director": "Garin Nugroho",
      "DirectorArray": [
        "Garin Nugroho"
      ],
      "Country": "Indonesia, Austria",
      "CountryArray": [
        "Indonesia",
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2856",
      "databaseFilmTitle": "Reservoir Dogs",
      "FilmTitle": "Reservoir Dogs",
      "AlternateTitle": "",
      "TitleArray": [
        "Reservoir Dogs"
      ],
      "Year": "1992",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2857",
      "databaseFilmTitle": "Return to Homs",
      "FilmTitle": "Return to Homs",
      "AlternateTitle": "",
      "TitleArray": [
        "Return to Homs"
      ],
      "Year": "2013",
      "Director": "Talal Derki",
      "DirectorArray": [
        "Talal Derki"
      ],
      "Country": "Syria, Germany",
      "CountryArray": [
        "Syria",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2858",
      "databaseFilmTitle": "Revolution der Augen",
      "FilmTitle": "Revolution der Augen",
      "AlternateTitle": "",
      "TitleArray": [
        "Revolution der Augen"
      ],
      "Year": "2022",
      "Director": "Friederike Pezold",
      "DirectorArray": [
        "Friederike Pezold"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2859",
      "databaseFilmTitle": "Revolver",
      "FilmTitle": "Revolver",
      "AlternateTitle": "",
      "TitleArray": [
        "Revolver"
      ],
      "Year": "1993",
      "Director": "Jonas Odell",
      "DirectorArray": [
        "Jonas Odell"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2860",
      "databaseFilmTitle": "Rich and Famous",
      "FilmTitle": "Rich and Famous",
      "AlternateTitle": "",
      "TitleArray": [
        "Rich and Famous"
      ],
      "Year": "1981",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2861",
      "databaseFilmTitle": "Rich and Strange",
      "FilmTitle": "Rich and Strange",
      "AlternateTitle": "",
      "TitleArray": [
        "Rich and Strange"
      ],
      "Year": "1931",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2862",
      "databaseFilmTitle": "Richard III",
      "FilmTitle": "Richard III",
      "AlternateTitle": "",
      "TitleArray": [
        "Richard III"
      ],
      "Year": "1955",
      "Director": "Laurence Olivier",
      "DirectorArray": [
        "Laurence Olivier"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2863",
      "databaseFilmTitle": "Riddles of the Sphinx",
      "FilmTitle": "Riddles of the Sphinx",
      "AlternateTitle": "",
      "TitleArray": [
        "Riddles of the Sphinx"
      ],
      "Year": "1977",
      "Director": "Laura Mulvey, Peter Wollen",
      "DirectorArray": [
        "Laura Mulvey",
        "Peter Wollen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2864",
      "databaseFilmTitle": "Ride Lonesome",
      "FilmTitle": "Ride Lonesome",
      "AlternateTitle": "",
      "TitleArray": [
        "Ride Lonesome"
      ],
      "Year": "1959",
      "Director": "Budd Boetticher",
      "DirectorArray": [
        "Budd Boetticher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2865",
      "databaseFilmTitle": "Ride the High Country",
      "FilmTitle": "Ride the High Country",
      "AlternateTitle": "Guns in the Afternoon",
      "TitleArray": [
        "Ride the High Country",
        "Guns in the Afternoon"
      ],
      "Year": "1962",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2866",
      "databaseFilmTitle": "Riff-Raff",
      "FilmTitle": "Riff-Raff",
      "AlternateTitle": "",
      "TitleArray": [
        "Riff-Raff"
      ],
      "Year": "1991",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2867",
      "databaseFilmTitle": "Right Now, Wrong Then",
      "FilmTitle": "Right Now, Wrong Then",
      "AlternateTitle": "Ji-geum-eun-mat-go-geu-ddae-neun-teul-li-da",
      "TitleArray": [
        "Right Now, Wrong Then",
        "Ji-geum-eun-mat-go-geu-ddae-neun-teul-li-da"
      ],
      "Year": "2015",
      "Director": "Hang Sang-soo",
      "DirectorArray": [
        "Hang Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2868",
      "databaseFilmTitle": "Ring",
      "FilmTitle": "Ring",
      "AlternateTitle": "Ringu",
      "TitleArray": [
        "Ring",
        "Ringu"
      ],
      "Year": "1998",
      "Director": "Hideo Nakata",
      "DirectorArray": [
        "Hideo Nakata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2869",
      "databaseFilmTitle": "Rio Bravo",
      "FilmTitle": "Rio Bravo",
      "AlternateTitle": "",
      "TitleArray": [
        "Rio Bravo"
      ],
      "Year": "1959",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "101",
      "2022votes": "30"
    },
    {
      "key": "2870",
      "databaseFilmTitle": "Rio Grande",
      "FilmTitle": "Rio Grande",
      "AlternateTitle": "",
      "TitleArray": [
        "Rio Grande"
      ],
      "Year": "1950",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2871",
      "databaseFilmTitle": "Rio, Northern Zone",
      "FilmTitle": "Rio, Northern Zone",
      "AlternateTitle": "Rio zona norte",
      "TitleArray": [
        "Rio, Northern Zone",
        "Rio zona norte"
      ],
      "Year": "1957",
      "Director": "Nelson Pereira dos Santos",
      "DirectorArray": [
        "Nelson Pereira dos Santos"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2872",
      "databaseFilmTitle": "Rise of the Planet of the Apes",
      "FilmTitle": "Rise of the Planet of the Apes",
      "AlternateTitle": "",
      "TitleArray": [
        "Rise of the Planet of the Apes"
      ],
      "Year": "2011",
      "Director": "Rupert Wyatt",
      "DirectorArray": [
        "Rupert Wyatt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2873",
      "databaseFilmTitle": "Risky Roadz Volume 1 Tha Roadz are Real",
      "FilmTitle": "Risky Roadz",
      "AlternateTitle": "[Vol. 1] [Tha Roadz are Real]",
      "TitleArray": [
        "Risky Roadz",
        "[Vol. 1] [Tha Roadz are Real]"
      ],
      "Year": "2004",
      "Director": "Roony Keefe",
      "DirectorArray": [
        "Roony Keefe"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2874",
      "databaseFilmTitle": "Ritual in Transfigured Time",
      "FilmTitle": "Ritual in Transfigured Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Ritual in Transfigured Time"
      ],
      "Year": "1949",
      "Director": "Maya Deren",
      "DirectorArray": [
        "Maya Deren"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2875",
      "databaseFilmTitle": "Ro.Go.Pa.G.",
      "FilmTitle": "Ro.Go.Pa.G.",
      "AlternateTitle": "",
      "TitleArray": [
        "Ro.Go.Pa.G."
      ],
      "Year": "1963",
      "Director": "Roberto Rossellini, Jean-Luc Godard, Pier Paolo Pasolini, Ugo Gregoretti",
      "DirectorArray": [
        "Roberto Rossellini",
        "Jean-Luc Godard",
        "Pier Paolo Pasolini",
        "Ugo Gregoretti"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2876",
      "databaseFilmTitle": "Road to Life",
      "FilmTitle": "Road to Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Road to Life"
      ],
      "Year": "1931",
      "Director": "Nikolai Ekk",
      "DirectorArray": [
        "Nikolai Ekk"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2877",
      "databaseFilmTitle": "Road to Nowhere",
      "FilmTitle": "Road to Nowhere",
      "AlternateTitle": "",
      "TitleArray": [
        "Road to Nowhere"
      ],
      "Year": "2010",
      "Director": "Monte Hellman",
      "DirectorArray": [
        "Monte Hellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2878",
      "databaseFilmTitle": "Roar",
      "FilmTitle": "Roar",
      "AlternateTitle": "",
      "TitleArray": [
        "Roar"
      ],
      "Year": "1981",
      "Director": "Noel Marshall",
      "DirectorArray": [
        "Noel Marshall"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2879",
      "databaseFilmTitle": "Robin and Marian",
      "FilmTitle": "Robin and Marian",
      "AlternateTitle": "",
      "TitleArray": [
        "Robin and Marian"
      ],
      "Year": "1976",
      "Director": "Richard Lester",
      "DirectorArray": [
        "Richard Lester"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2880",
      "databaseFilmTitle": "Robinson Crusoe",
      "FilmTitle": "Robinson Crusoe",
      "AlternateTitle": "",
      "TitleArray": [
        "Robinson Crusoe"
      ],
      "Year": "1954",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2881",
      "databaseFilmTitle": "RoboCop",
      "FilmTitle": "RoboCop",
      "AlternateTitle": "",
      "TitleArray": [
        "RoboCop"
      ],
      "Year": "1987",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2882",
      "databaseFilmTitle": "Rocco and His Brothers",
      "FilmTitle": "Rocco and His Brothers",
      "AlternateTitle": "Rocco e i suoi fratelli",
      "TitleArray": [
        "Rocco and His Brothers",
        "Rocco e i suoi fratelli"
      ],
      "Year": "1960",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "2883",
      "databaseFilmTitle": "Rocío y José",
      "FilmTitle": "Rocío y José",
      "AlternateTitle": "",
      "TitleArray": [
        "Rocío y José"
      ],
      "Year": "1983",
      "Director": "Gonzalo García Pelayo",
      "DirectorArray": [
        "Gonzalo García Pelayo"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2884",
      "databaseFilmTitle": "Rock My Religion",
      "FilmTitle": "Rock My Religion",
      "AlternateTitle": "",
      "TitleArray": [
        "Rock My Religion"
      ],
      "Year": "1984",
      "Director": "Dan Graham",
      "DirectorArray": [
        "Dan Graham"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2885",
      "databaseFilmTitle": "Rocks",
      "FilmTitle": "Rocks",
      "AlternateTitle": "",
      "TitleArray": [
        "Rocks"
      ],
      "Year": "2019",
      "Director": "Sarah Gavron",
      "DirectorArray": [
        "Sarah Gavron"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2886",
      "databaseFilmTitle": "Rocky",
      "FilmTitle": "Rocky",
      "AlternateTitle": "",
      "TitleArray": [
        "Rocky"
      ],
      "Year": "1976",
      "Director": "John G. Avildsen",
      "DirectorArray": [
        "John G. Avildsen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2887",
      "databaseFilmTitle": "Roma",
      "FilmTitle": "Roma",
      "AlternateTitle": "",
      "TitleArray": [
        "Roma"
      ],
      "Year": "2018",
      "Director": "Alfonso Cuarón",
      "DirectorArray": [
        "Alfonso Cuarón"
      ],
      "Country": "Mexico, United States",
      "CountryArray": [
        "Mexico",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "2888",
      "databaseFilmTitle": "Roman Holiday",
      "FilmTitle": "Roman Holiday",
      "AlternateTitle": "",
      "TitleArray": [
        "Roman Holiday"
      ],
      "Year": "1953",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2889",
      "databaseFilmTitle": "Romance X",
      "FilmTitle": "Romance X",
      "AlternateTitle": "",
      "TitleArray": [
        "Romance X"
      ],
      "Year": "1999",
      "Director": "Catherine Breillat",
      "DirectorArray": [
        "Catherine Breillat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2890",
      "databaseFilmTitle": "Romancing in Thin Air",
      "FilmTitle": "Romancing in Thin Air",
      "AlternateTitle": "Gao hai ba zhi lian il",
      "TitleArray": [
        "Romancing in Thin Air",
        "Gao hai ba zhi lian il"
      ],
      "Year": "2012",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "China, Hong Kong",
      "CountryArray": [
        "China",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2891",
      "databaseFilmTitle": "Rome Rather Than You",
      "FilmTitle": "Rome Rather Than You",
      "AlternateTitle": "Roma wa la n'touma",
      "TitleArray": [
        "Rome Rather Than You",
        "Roma wa la n'touma"
      ],
      "Year": "2006",
      "Director": "Tariq Teguia",
      "DirectorArray": [
        "Tariq Teguia"
      ],
      "Country": "Algeria",
      "CountryArray": [
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2892",
      "databaseFilmTitle": "Rome, Open City",
      "FilmTitle": "Rome, Open City",
      "AlternateTitle": "Roma città aperta",
      "TitleArray": [
        "Rome, Open City",
        "Roma città aperta"
      ],
      "Year": "1945",
      "Director": "Roberto Rossellini, Jean-Luc Godard, Pier Paolo Pasolini, Ugo Gregoretti",
      "DirectorArray": [
        "Roberto Rossellini",
        "Jean-Luc Godard",
        "Pier Paolo Pasolini",
        "Ugo Gregoretti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "2893",
      "databaseFilmTitle": "Romeo + Juliet",
      "FilmTitle": "Romeo + Juliet",
      "AlternateTitle": "",
      "TitleArray": [
        "Romeo + Juliet"
      ],
      "Year": "1996",
      "Director": "Baz Luhrmann",
      "DirectorArray": [
        "Baz Luhrmann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2894",
      "databaseFilmTitle": "Romeo and Juliet",
      "FilmTitle": "Romeo and Juliet",
      "AlternateTitle": "",
      "TitleArray": [
        "Romeo and Juliet"
      ],
      "Year": "1968",
      "Director": "Franco Zeffirelli",
      "DirectorArray": [
        "Franco Zeffirelli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2895",
      "databaseFilmTitle": "Romy and Michele's High School Reunion",
      "FilmTitle": "Romy and Michele's High School Reunion",
      "AlternateTitle": "",
      "TitleArray": [
        "Romy and Michele's High School Reunion"
      ],
      "Year": "1997",
      "Director": "David Mirkin",
      "DirectorArray": [
        "David Mirkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2896",
      "databaseFilmTitle": "Room At The Top",
      "FilmTitle": "Room At The Top",
      "AlternateTitle": "",
      "TitleArray": [
        "Room At The Top"
      ],
      "Year": "1959",
      "Director": "Jack Clayton",
      "DirectorArray": [
        "Jack Clayton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2897",
      "databaseFilmTitle": "Rope",
      "FilmTitle": "Rope",
      "AlternateTitle": "",
      "TitleArray": [
        "Rope"
      ],
      "Year": "1948",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2898",
      "databaseFilmTitle": "Rosa Luxemburg",
      "FilmTitle": "Rosa Luxemburg",
      "AlternateTitle": "Die Geduld der Rosa Luxemburg",
      "TitleArray": [
        "Rosa Luxemburg",
        "Die Geduld der Rosa Luxemburg"
      ],
      "Year": "1986",
      "Director": "Margarethe von Trotta",
      "DirectorArray": [
        "Margarethe von Trotta"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2899",
      "databaseFilmTitle": "Rose Hobart",
      "FilmTitle": "Rose Hobart",
      "AlternateTitle": "",
      "TitleArray": [
        "Rose Hobart"
      ],
      "Year": "1936",
      "Director": "Joseph Cornell",
      "DirectorArray": [
        "Joseph Cornell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2900",
      "databaseFilmTitle": "Rosemary's Baby",
      "FilmTitle": "Rosemary's Baby",
      "AlternateTitle": "",
      "TitleArray": [
        "Rosemary's Baby"
      ],
      "Year": "1968",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "2901",
      "databaseFilmTitle": "Rosetta",
      "FilmTitle": "Rosetta",
      "AlternateTitle": "",
      "TitleArray": [
        "Rosetta"
      ],
      "Year": "1999",
      "Director": "Jean-Pierre Dardenne, Luc Dardenne",
      "DirectorArray": [
        "Jean-Pierre Dardenne",
        "Luc Dardenne"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "2902",
      "databaseFilmTitle": "Rouge",
      "FilmTitle": "Rouge",
      "AlternateTitle": "Yin ji kau",
      "TitleArray": [
        "Rouge",
        "Yin ji kau"
      ],
      "Year": "1987",
      "Director": "Stanley Kwan",
      "DirectorArray": [
        "Stanley Kwan"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2903",
      "databaseFilmTitle": "Rough Diamond",
      "FilmTitle": "Rough Diamond",
      "AlternateTitle": "Diamante bruto",
      "TitleArray": [
        "Rough Diamond",
        "Diamante bruto"
      ],
      "Year": "1977",
      "Director": "Orlando Senna",
      "DirectorArray": [
        "Orlando Senna"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2904",
      "databaseFilmTitle": "Rough Treatment",
      "FilmTitle": "Rough Treatment",
      "AlternateTitle": "Ben Znieczulenia",
      "TitleArray": [
        "Rough Treatment",
        "Ben Znieczulenia"
      ],
      "Year": "1979",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2905",
      "databaseFilmTitle": "Roundhay Garden Scene",
      "FilmTitle": "Roundhay Garden Scene",
      "AlternateTitle": "",
      "TitleArray": [
        "Roundhay Garden Scene"
      ],
      "Year": "1888",
      "Director": "Louis Le Prince",
      "DirectorArray": [
        "Louis Le Prince"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2906",
      "databaseFilmTitle": "Route One/USA",
      "FilmTitle": "Route One/USA",
      "AlternateTitle": "",
      "TitleArray": [
        "Route One/USA"
      ],
      "Year": "1989",
      "Director": "Robert Kramer",
      "DirectorArray": [
        "Robert Kramer"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2907",
      "databaseFilmTitle": "RR",
      "FilmTitle": "RR",
      "AlternateTitle": "",
      "TitleArray": [
        "RR"
      ],
      "Year": "2007",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2908",
      "databaseFilmTitle": "RRR",
      "FilmTitle": "RRR",
      "AlternateTitle": "",
      "TitleArray": [
        "RRR"
      ],
      "Year": "2022",
      "Director": "S.S. Rajamouli",
      "DirectorArray": [
        "S.S. Rajamouli"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2909",
      "databaseFilmTitle": "Ruby Gentry",
      "FilmTitle": "Ruby Gentry",
      "AlternateTitle": "",
      "TitleArray": [
        "Ruby Gentry"
      ],
      "Year": "1952",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2910",
      "databaseFilmTitle": "Rudy Wurlitzer",
      "FilmTitle": "Rudy Wurlitzer",
      "AlternateTitle": "",
      "TitleArray": [
        "Rudy Wurlitzer"
      ],
      "Year": "1994",
      "Director": "Christopher Petit",
      "DirectorArray": [
        "Christopher Petit"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2911",
      "databaseFilmTitle": "Ruggles of Red Gap",
      "FilmTitle": "Ruggles of Red Gap",
      "AlternateTitle": "",
      "TitleArray": [
        "Ruggles of Red Gap"
      ],
      "Year": "1935",
      "Director": "Leo McCarey",
      "DirectorArray": [
        "Leo McCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2912",
      "databaseFilmTitle": "Rumble Fish",
      "FilmTitle": "Rumble Fish",
      "AlternateTitle": "",
      "TitleArray": [
        "Rumble Fish"
      ],
      "Year": "1983",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2913",
      "databaseFilmTitle": "Run Lola Run",
      "FilmTitle": "Run Lola Run",
      "AlternateTitle": "Lola Rennt",
      "TitleArray": [
        "Run Lola Run",
        "Lola Rennt"
      ],
      "Year": "1998",
      "Director": "Tom Tykwer",
      "DirectorArray": [
        "Tom Tykwer"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2914",
      "databaseFilmTitle": "Running on Empty",
      "FilmTitle": "Running on Empty",
      "AlternateTitle": "",
      "TitleArray": [
        "Running on Empty"
      ],
      "Year": "1988",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2915",
      "databaseFilmTitle": "Running on Karma",
      "FilmTitle": "Running on Karma",
      "AlternateTitle": "Daai chek liu",
      "TitleArray": [
        "Running on Karma",
        "Daai chek liu"
      ],
      "Year": "2003",
      "Director": "Johnnie To, Wai Ka-Fai",
      "DirectorArray": [
        "Johnnie To",
        "Wai Ka-Fai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2916",
      "databaseFilmTitle": "Rushmore",
      "FilmTitle": "Rushmore",
      "AlternateTitle": "",
      "TitleArray": [
        "Rushmore"
      ],
      "Year": "1998",
      "Director": "Wes Anderson",
      "DirectorArray": [
        "Wes Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2917",
      "databaseFilmTitle": "Ruskin",
      "FilmTitle": "Ruskin",
      "AlternateTitle": "",
      "TitleArray": [
        "Ruskin"
      ],
      "Year": "1997",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2918",
      "databaseFilmTitle": "Russian Ark",
      "FilmTitle": "Russian Ark",
      "AlternateTitle": "",
      "TitleArray": [
        "Russian Ark"
      ],
      "Year": "2002",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2919",
      "databaseFilmTitle": "Russian Pioneers",
      "FilmTitle": "Russian Pioneers",
      "AlternateTitle": "",
      "TitleArray": [
        "Russian Pioneers"
      ],
      "Year": "1967",
      "Director": "Aleksandr Ivanov, Yevgeni Shiffers",
      "DirectorArray": [
        "Aleksandr Ivanov",
        "Yevgeni Shiffers"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2920",
      "databaseFilmTitle": "Rust and Bone",
      "FilmTitle": "Rust and Bone",
      "AlternateTitle": "De rouille et d'os",
      "TitleArray": [
        "Rust and Bone",
        "De rouille et d'os"
      ],
      "Year": "2012",
      "Director": "Jacques Audiard",
      "DirectorArray": [
        "Jacques Audiard"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2921",
      "databaseFilmTitle": "Ryan's Daughter",
      "FilmTitle": "Ryan's Daughter",
      "AlternateTitle": "",
      "TitleArray": [
        "Ryan's Daughter"
      ],
      "Year": "1970",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2922",
      "databaseFilmTitle": "S21: The Khmer Rouge Death Machine",
      "FilmTitle": "S21: The Khmer Rouge Death Machine",
      "AlternateTitle": "S-21, la machine de mort Khmère rouge",
      "TitleArray": [
        "S21: The Khmer Rouge Death Machine",
        "S-21, la machine de mort Khmère rouge"
      ],
      "Year": "2003",
      "Director": "Rithy Panh",
      "DirectorArray": [
        "Rithy Panh"
      ],
      "Country": "France, Cambodia",
      "CountryArray": [
        "France",
        "Cambodia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2923",
      "databaseFilmTitle": "Sabotage",
      "FilmTitle": "Sabotage",
      "AlternateTitle": "",
      "TitleArray": [
        "Sabotage"
      ],
      "Year": "1936",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2924",
      "databaseFilmTitle": "Safe",
      "FilmTitle": "Safe",
      "AlternateTitle": "",
      "TitleArray": [
        "Safe"
      ],
      "Year": "1995",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "2925",
      "databaseFilmTitle": "Safe in Hell",
      "FilmTitle": "Safe in Hell",
      "AlternateTitle": "",
      "TitleArray": [
        "Safe in Hell"
      ],
      "Year": "1931",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2926",
      "databaseFilmTitle": "Saint Joan",
      "FilmTitle": "Saint Joan",
      "AlternateTitle": "",
      "TitleArray": [
        "Saint Joan"
      ],
      "Year": "1957",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2927",
      "databaseFilmTitle": "Saint Maud",
      "FilmTitle": "Saint Maud",
      "AlternateTitle": "",
      "TitleArray": [
        "Saint Maud"
      ],
      "Year": "2019",
      "Director": "Rose Glass",
      "DirectorArray": [
        "Rose Glass"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2928",
      "databaseFilmTitle": "Saint Omer",
      "FilmTitle": "Saint Omer",
      "AlternateTitle": "",
      "TitleArray": [
        "Saint Omer"
      ],
      "Year": "2022",
      "Director": "Alice Diop",
      "DirectorArray": [
        "Alice Diop"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2929",
      "databaseFilmTitle": "Saint Tukaram",
      "FilmTitle": "Saint Tukaram",
      "AlternateTitle": "Sant Tukaram",
      "TitleArray": [
        "Saint Tukaram",
        "Sant Tukaram"
      ],
      "Year": "1936",
      "Director": "Vishnupant Govind Damle, Sheikh Fattelal",
      "DirectorArray": [
        "Vishnupant Govind Damle",
        "Sheikh Fattelal"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2930",
      "databaseFilmTitle": "Salaam Cinema",
      "FilmTitle": "Salaam Cinema",
      "AlternateTitle": "",
      "TitleArray": [
        "Salaam Cinema"
      ],
      "Year": "1995",
      "Director": "Mohsen Makhmalbaf",
      "DirectorArray": [
        "Mohsen Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2931",
      "databaseFilmTitle": "Salesman",
      "FilmTitle": "Salesman",
      "AlternateTitle": "",
      "TitleArray": [
        "Salesman"
      ],
      "Year": "1969",
      "Director": "Albert Maysles, David Maysles, Charlotte Zwerin",
      "DirectorArray": [
        "Albert Maysles",
        "David Maysles",
        "Charlotte Zwerin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2932",
      "databaseFilmTitle": "Salò, or the 120 Days of Sodom",
      "FilmTitle": "Salò, or the 120 Days of Sodom",
      "AlternateTitle": "Salò o le 120 giornate di Sodoma",
      "TitleArray": [
        "Salò, or the 120 Days of Sodom",
        "Salò o le 120 giornate di Sodoma"
      ],
      "Year": "1975",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "2933",
      "databaseFilmTitle": "Salomé (1923)",
      "FilmTitle": "Salomé",
      "AlternateTitle": "",
      "TitleArray": [
        "Salomé"
      ],
      "Year": "1923",
      "Director": "Charles Bryant",
      "DirectorArray": [
        "Charles Bryant"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2934",
      "databaseFilmTitle": "Salomè (1972)",
      "FilmTitle": "Salomè",
      "AlternateTitle": "",
      "TitleArray": [
        "Salomè"
      ],
      "Year": "1972",
      "Director": "Carmelo Bene",
      "DirectorArray": [
        "Carmelo Bene"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2935",
      "databaseFilmTitle": "Salomé (1976)",
      "FilmTitle": "Salomé",
      "AlternateTitle": "",
      "TitleArray": [
        "Salomé"
      ],
      "Year": "1976",
      "Director": "Téo Hernandez",
      "DirectorArray": [
        "Téo Hernandez"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2936",
      "databaseFilmTitle": "Salt for Svanetia",
      "FilmTitle": "Salt for Svanetia",
      "AlternateTitle": "Jim Shvante (Marili Svanets)",
      "TitleArray": [
        "Salt for Svanetia",
        "Jim Shvante (Marili Svanets)"
      ],
      "Year": "1930",
      "Director": "Mikhail Kalatozov",
      "DirectorArray": [
        "Mikhail Kalatozov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2937",
      "databaseFilmTitle": "Salt of the Earth",
      "FilmTitle": "Salt of the Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "Salt of the Earth"
      ],
      "Year": "1954",
      "Director": "Herbert J. Biberman",
      "DirectorArray": [
        "Herbert J. Biberman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2938",
      "databaseFilmTitle": "Salvador",
      "FilmTitle": "Salvador",
      "AlternateTitle": "",
      "TitleArray": [
        "Salvador"
      ],
      "Year": "1986",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2939",
      "databaseFilmTitle": "Salvatore Giuliano",
      "FilmTitle": "Salvatore Giuliano",
      "AlternateTitle": "",
      "TitleArray": [
        "Salvatore Giuliano"
      ],
      "Year": "1962",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2940",
      "databaseFilmTitle": "Sambizanga",
      "FilmTitle": "Sambizanga",
      "AlternateTitle": "",
      "TitleArray": [
        "Sambizanga"
      ],
      "Year": "1972",
      "Director": "Sarah Maldoror",
      "DirectorArray": [
        "Sarah Maldoror"
      ],
      "Country": "Angola, France",
      "CountryArray": [
        "Angola",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "2941",
      "databaseFilmTitle": "Same Old Song",
      "FilmTitle": "Same Old Song",
      "AlternateTitle": "On connaît la chanson",
      "TitleArray": [
        "Same Old Song",
        "On connaît la chanson"
      ],
      "Year": "1997",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2942",
      "databaseFilmTitle": "Samson and Delilah (1949)",
      "FilmTitle": "Samson and Delilah",
      "AlternateTitle": "",
      "TitleArray": [
        "Samson and Delilah"
      ],
      "Year": "1949",
      "Director": "Cecil B. DeMille",
      "DirectorArray": [
        "Cecil B. DeMille"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2943",
      "databaseFilmTitle": "Samson and Delilah (2009)",
      "FilmTitle": "Samson and Delilah",
      "AlternateTitle": "",
      "TitleArray": [
        "Samson and Delilah"
      ],
      "Year": "2009",
      "Director": "Warwick Thornton",
      "DirectorArray": [
        "Warwick Thornton"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2944",
      "databaseFilmTitle": "Samurai Rebellion",
      "FilmTitle": "Samurai Rebellion",
      "AlternateTitle": "",
      "TitleArray": [
        "Samurai Rebellion"
      ],
      "Year": "1967",
      "Director": "Masaki Kobayashi",
      "DirectorArray": [
        "Masaki Kobayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2945",
      "databaseFilmTitle": "Sanctus",
      "FilmTitle": "Sanctus",
      "AlternateTitle": "",
      "TitleArray": [
        "Sanctus"
      ],
      "Year": "1990",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2946",
      "databaseFilmTitle": "Sandow",
      "FilmTitle": "Sandow",
      "AlternateTitle": "",
      "TitleArray": [
        "Sandow"
      ],
      "Year": "1896",
      "Director": "William K.L. Dickson",
      "DirectorArray": [
        "William K.L. Dickson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2947",
      "databaseFilmTitle": "Sandra",
      "FilmTitle": "Sandra",
      "AlternateTitle": "",
      "TitleArray": [
        "Sandra"
      ],
      "Year": "1965",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2948",
      "databaseFilmTitle": "Sanggye-Dong Olympic",
      "FilmTitle": "Sanggye-Dong Olympic",
      "AlternateTitle": "",
      "TitleArray": [
        "Sanggye-Dong Olympic"
      ],
      "Year": "1988",
      "Director": "Dong-won Kim",
      "DirectorArray": [
        "Dong-won Kim"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2949",
      "databaseFilmTitle": "Sankofa",
      "FilmTitle": "Sankofa",
      "AlternateTitle": "",
      "TitleArray": [
        "Sankofa"
      ],
      "Year": "1993",
      "Director": "Haile Gerima",
      "DirectorArray": [
        "Haile Gerima"
      ],
      "Country": "Ethiopia, United States",
      "CountryArray": [
        "Ethiopia",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2950",
      "databaseFilmTitle": "Sans soleil",
      "FilmTitle": "Sans soleil",
      "AlternateTitle": "",
      "TitleArray": [
        "Sans soleil"
      ],
      "Year": "1983",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "69",
      "2012votes": "23",
      "2022rank": "59",
      "2022votes": "43"
    },
    {
      "key": "2951",
      "databaseFilmTitle": "Sansho the Bailiff",
      "FilmTitle": "Sansho the Bailiff",
      "AlternateTitle": "Sanshō dayū",
      "TitleArray": [
        "Sansho the Bailiff",
        "Sanshō dayū"
      ],
      "Year": "1954",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "59",
      "2012votes": "25",
      "2022rank": "75",
      "2022votes": "36"
    },
    {
      "key": "2952",
      "databaseFilmTitle": "Santa Claus Has Blue Eyes",
      "FilmTitle": "Santa Claus Has Blue Eyes",
      "AlternateTitle": "Le père Noël a les yeux bleus",
      "TitleArray": [
        "Santa Claus Has Blue Eyes",
        "Le père Noël a les yeux bleus"
      ],
      "Year": "1966",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2953",
      "databaseFilmTitle": "Santa sangre",
      "FilmTitle": "Santa sangre",
      "AlternateTitle": "",
      "TitleArray": [
        "Santa sangre"
      ],
      "Year": "1989",
      "Director": "Alejandro Jodorowsky",
      "DirectorArray": [
        "Alejandro Jodorowsky"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2954",
      "databaseFilmTitle": "Saraband",
      "FilmTitle": "Saraband",
      "AlternateTitle": "",
      "TitleArray": [
        "Saraband"
      ],
      "Year": "2003",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2955",
      "databaseFilmTitle": "Satan's Brew",
      "FilmTitle": "Satan's Brew",
      "AlternateTitle": "Satansbraten",
      "TitleArray": [
        "Satan's Brew",
        "Satansbraten"
      ],
      "Year": "1976",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2956",
      "databaseFilmTitle": "Satan's Rhapsody",
      "FilmTitle": "Satan's Rhapsody",
      "AlternateTitle": "Rapsodia satanica",
      "TitleArray": [
        "Satan's Rhapsody",
        "Rapsodia satanica"
      ],
      "Year": "1915",
      "Director": "Nino Oxilia",
      "DirectorArray": [
        "Nino Oxilia"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2957",
      "databaseFilmTitle": "Satan's Sword",
      "FilmTitle": "Satan's Sword",
      "AlternateTitle": "Daibosatsu tôge",
      "TitleArray": [
        "Satan's Sword",
        "Daibosatsu tôge"
      ],
      "Year": "1960",
      "Director": "Kenji Misumi",
      "DirectorArray": [
        "Kenji Misumi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2958",
      "databaseFilmTitle": "Sátántangó",
      "FilmTitle": "Sátántangó",
      "AlternateTitle": "",
      "TitleArray": [
        "Sátántangó"
      ],
      "Year": "1994",
      "Director": "Béla Tarr",
      "DirectorArray": [
        "Béla Tarr"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "36",
      "2012votes": "34",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "2959",
      "databaseFilmTitle": "Saturday Fiction",
      "FilmTitle": "Saturday Fiction",
      "AlternateTitle": "Lan xin da ju yuan",
      "TitleArray": [
        "Saturday Fiction",
        "Lan xin da ju yuan"
      ],
      "Year": "2019",
      "Director": "Lou Ye",
      "DirectorArray": [
        "Lou Ye"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2960",
      "databaseFilmTitle": "Saturday Night and Sunday Morning",
      "FilmTitle": "Saturday Night and Sunday Morning",
      "AlternateTitle": "",
      "TitleArray": [
        "Saturday Night and Sunday Morning"
      ],
      "Year": "1960",
      "Director": "Karel Reisz",
      "DirectorArray": [
        "Karel Reisz"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2961",
      "databaseFilmTitle": "Saving Private Ryan",
      "FilmTitle": "Saving Private Ryan",
      "AlternateTitle": "",
      "TitleArray": [
        "Saving Private Ryan"
      ],
      "Year": "1998",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2962",
      "databaseFilmTitle": "Sawdust and Tinsel",
      "FilmTitle": "Sawdust and Tinsel",
      "AlternateTitle": "Gycklarnas afton",
      "TitleArray": [
        "Sawdust and Tinsel",
        "Gycklarnas afton"
      ],
      "Year": "1953",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2963",
      "databaseFilmTitle": "Scarface",
      "FilmTitle": "Scarface",
      "AlternateTitle": "",
      "TitleArray": [
        "Scarface"
      ],
      "Year": "1983",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2964",
      "databaseFilmTitle": "Scarlet Street",
      "FilmTitle": "Scarlet Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Scarlet Street"
      ],
      "Year": "1945",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2965",
      "databaseFilmTitle": "Scattered Clouds",
      "FilmTitle": "Scattered Clouds",
      "AlternateTitle": "Midaregumo",
      "TitleArray": [
        "Scattered Clouds",
        "Midaregumo"
      ],
      "Year": "1967",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2966",
      "databaseFilmTitle": "Scénario du film 'Passion'",
      "FilmTitle": "Scénario du film 'Passion'",
      "AlternateTitle": "",
      "TitleArray": [
        "Scénario du film 'Passion'"
      ],
      "Year": "1982",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2967",
      "databaseFilmTitle": "Scenes from a Marriage",
      "FilmTitle": "Scenes from a Marriage",
      "AlternateTitle": "Scener ur ett äktenskap",
      "TitleArray": [
        "Scenes from a Marriage",
        "Scener ur ett äktenskap"
      ],
      "Year": "1974",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2968",
      "databaseFilmTitle": "Scenes from Under Childhood",
      "FilmTitle": "Scenes from Under Childhood",
      "AlternateTitle": "",
      "TitleArray": [
        "Scenes from Under Childhood"
      ],
      "Year": "1970",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2969",
      "databaseFilmTitle": "Scenes of City Life",
      "FilmTitle": "Scenes of City Life",
      "AlternateTitle": "Dushi fengguang",
      "TitleArray": [
        "Scenes of City Life",
        "Dushi fengguang"
      ],
      "Year": "1935",
      "Director": "Yuan Muzhi",
      "DirectorArray": [
        "Yuan Muzhi"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2970",
      "databaseFilmTitle": "Schindler's List",
      "FilmTitle": "Schindler's List",
      "AlternateTitle": "",
      "TitleArray": [
        "Schindler's List"
      ],
      "Year": "1993",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2971",
      "databaseFilmTitle": "Schmeerguntz",
      "FilmTitle": "Schmeerguntz",
      "AlternateTitle": "",
      "TitleArray": [
        "Schmeerguntz"
      ],
      "Year": "1965",
      "Director": "Gunvor Nelson, Dorothy Wiley",
      "DirectorArray": [
        "Gunvor Nelson",
        "Dorothy Wiley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2972",
      "databaseFilmTitle": "School Daze",
      "FilmTitle": "School Daze",
      "AlternateTitle": "",
      "TitleArray": [
        "School Daze"
      ],
      "Year": "1988",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2973",
      "databaseFilmTitle": "School of Rock",
      "FilmTitle": "School of Rock",
      "AlternateTitle": "",
      "TitleArray": [
        "School of Rock"
      ],
      "Year": "2003",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2974",
      "databaseFilmTitle": "Schwechater",
      "FilmTitle": "Schwechater",
      "AlternateTitle": "",
      "TitleArray": [
        "Schwechater"
      ],
      "Year": "1958",
      "Director": "Peter Kubelka",
      "DirectorArray": [
        "Peter Kubelka"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2975",
      "databaseFilmTitle": "Scorching Winds",
      "FilmTitle": "Scorching Winds",
      "AlternateTitle": "Garam Hava",
      "TitleArray": [
        "Scorching Winds",
        "Garam Hava"
      ],
      "Year": "1973",
      "Director": "M.S. Sathyu",
      "DirectorArray": [
        "M.S. Sathyu"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2976",
      "databaseFilmTitle": "Scorpio Rising",
      "FilmTitle": "Scorpio Rising",
      "AlternateTitle": "",
      "TitleArray": [
        "Scorpio Rising"
      ],
      "Year": "1963",
      "Director": "Kenneth Anger",
      "DirectorArray": [
        "Kenneth Anger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2977",
      "databaseFilmTitle": "Scorpion Thunderbolt",
      "FilmTitle": "Scorpion Thunderbolt",
      "AlternateTitle": "",
      "TitleArray": [
        "Scorpion Thunderbolt"
      ],
      "Year": "1988",
      "Director": "Godfrey Ho",
      "DirectorArray": [
        "Godfrey Ho"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2978",
      "databaseFilmTitle": "Scream",
      "FilmTitle": "Scream",
      "AlternateTitle": "",
      "TitleArray": [
        "Scream"
      ],
      "Year": "1996",
      "Director": "Wes Craven",
      "DirectorArray": [
        "Wes Craven"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "2979",
      "databaseFilmTitle": "Screen Tests",
      "FilmTitle": "Screen Tests",
      "AlternateTitle": "",
      "TitleArray": [
        "Screen Tests"
      ],
      "Year": "1965",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2980",
      "databaseFilmTitle": "Scum",
      "FilmTitle": "Scum",
      "AlternateTitle": "",
      "TitleArray": [
        "Scum"
      ],
      "Year": "1979",
      "Director": "Alan Clarke",
      "DirectorArray": [
        "Alan Clarke"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2981",
      "databaseFilmTitle": "Sea in the Blood",
      "FilmTitle": "Sea in the Blood",
      "AlternateTitle": "",
      "TitleArray": [
        "Sea in the Blood"
      ],
      "Year": "2000",
      "Director": "Richard Fung",
      "DirectorArray": [
        "Richard Fung"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2982",
      "databaseFilmTitle": "Sea Point Days",
      "FilmTitle": "Sea Point Days",
      "AlternateTitle": "",
      "TitleArray": [
        "Sea Point Days"
      ],
      "Year": "2008",
      "Director": "François Verster",
      "DirectorArray": [
        "François Verster"
      ],
      "Country": "South Africa",
      "CountryArray": [
        "South Africa"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2983",
      "databaseFilmTitle": "Season of the Devil",
      "FilmTitle": "Season of the Devil",
      "AlternateTitle": "Ang Panahon ng Halimaw",
      "TitleArray": [
        "Season of the Devil",
        "Ang Panahon ng Halimaw"
      ],
      "Year": "2018",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2984",
      "databaseFilmTitle": "Seasons of the Year",
      "FilmTitle": "Seasons of the Year",
      "AlternateTitle": "Tarva yeghanakner",
      "TitleArray": [
        "Seasons of the Year",
        "Tarva yeghanakner"
      ],
      "Year": "1975",
      "Director": "Artavazd Peleshian",
      "DirectorArray": [
        "Artavazd Peleshian"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2985",
      "databaseFilmTitle": "Second Wind",
      "FilmTitle": "Second Wind",
      "AlternateTitle": "Le deuxième souffle",
      "TitleArray": [
        "Second Wind",
        "Le deuxième souffle"
      ],
      "Year": "1966",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2986",
      "databaseFilmTitle": "Seconds",
      "FilmTitle": "Seconds",
      "AlternateTitle": "",
      "TitleArray": [
        "Seconds"
      ],
      "Year": "1966",
      "Director": "John Frakenheimer",
      "DirectorArray": [
        "John Frakenheimer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2987",
      "databaseFilmTitle": "Secret Sunshine",
      "FilmTitle": "Secret Sunshine",
      "AlternateTitle": "Milyang",
      "TitleArray": [
        "Secret Sunshine",
        "Milyang"
      ],
      "Year": "2007",
      "Director": "Lee Chang-dong",
      "DirectorArray": [
        "Lee Chang-dong"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2988",
      "databaseFilmTitle": "Secrets & Lies",
      "FilmTitle": "Secrets & Lies",
      "AlternateTitle": "",
      "TitleArray": [
        "Secrets & Lies"
      ],
      "Year": "1996",
      "Director": "Mike Leigh",
      "DirectorArray": [
        "Mike Leigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "2989",
      "databaseFilmTitle": "Seduced and Abandoned",
      "FilmTitle": "Seduced and Abandoned",
      "AlternateTitle": "Sedotta e abbandonata",
      "TitleArray": [
        "Seduced and Abandoned",
        "Sedotta e abbandonata"
      ],
      "Year": "1964",
      "Director": "Pietro Germi",
      "DirectorArray": [
        "Pietro Germi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2990",
      "databaseFilmTitle": "Seduction",
      "FilmTitle": "Seduction",
      "AlternateTitle": "Erotikon",
      "TitleArray": [
        "Seduction",
        "Erotikon"
      ],
      "Year": "1929",
      "Director": "Gustav Machatý",
      "DirectorArray": [
        "Gustav Machatý"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2991",
      "databaseFilmTitle": "Seeking Asylum",
      "FilmTitle": "Seeking Asylum",
      "AlternateTitle": "Chiedo asilo",
      "TitleArray": [
        "Seeking Asylum",
        "Chiedo asilo"
      ],
      "Year": "1979",
      "Director": "Marco Ferreri",
      "DirectorArray": [
        "Marco Ferreri"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "2992",
      "databaseFilmTitle": "Selena",
      "FilmTitle": "Selena",
      "AlternateTitle": "",
      "TitleArray": [
        "Selena"
      ],
      "Year": "1997",
      "Director": "Gregory Nava",
      "DirectorArray": [
        "Gregory Nava"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2993",
      "databaseFilmTitle": "Sense and Sensibility",
      "FilmTitle": "Sense and Sensibility",
      "AlternateTitle": "",
      "TitleArray": [
        "Sense and Sensibility"
      ],
      "Year": "1995",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2994",
      "databaseFilmTitle": "Senso",
      "FilmTitle": "Senso",
      "AlternateTitle": "",
      "TitleArray": [
        "Senso"
      ],
      "Year": "1954",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2995",
      "databaseFilmTitle": "Sentinel Under the Neon Lights",
      "FilmTitle": "Sentinel Under the Neon Lights",
      "AlternateTitle": "Ni Hong Deng Xia De Shao Bing",
      "TitleArray": [
        "Sentinel Under the Neon Lights",
        "Ni Hong Deng Xia De Shao Bing"
      ],
      "Year": "1964",
      "Director": "Xin Ge, Ping Wang",
      "DirectorArray": [
        "Xin Ge",
        "Ping Wang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2996",
      "databaseFilmTitle": "Separation",
      "FilmTitle": "Separation",
      "AlternateTitle": "",
      "TitleArray": [
        "Separation"
      ],
      "Year": "1968",
      "Director": "Jack Bond",
      "DirectorArray": [
        "Jack Bond"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "2997",
      "databaseFilmTitle": "Ser de luz",
      "FilmTitle": "Ser de luz",
      "AlternateTitle": "",
      "TitleArray": [
        "Ser de luz"
      ],
      "Year": "2009",
      "Director": "Diana Toucedo",
      "DirectorArray": [
        "Diana Toucedo"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2998",
      "databaseFilmTitle": "Serene Velocity",
      "FilmTitle": "Serene Velocity",
      "AlternateTitle": "",
      "TitleArray": [
        "Serene Velocity"
      ],
      "Year": "1970",
      "Director": "Ernie Gehr",
      "DirectorArray": [
        "Ernie Gehr"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "2999",
      "databaseFilmTitle": "Série noire",
      "FilmTitle": "Série noire",
      "AlternateTitle": "",
      "TitleArray": [
        "Série noire"
      ],
      "Year": "1979",
      "Director": "Alain Corneau",
      "DirectorArray": [
        "Alain Corneau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3000",
      "databaseFilmTitle": "Serious Undertakings",
      "FilmTitle": "Serious Undertakings",
      "AlternateTitle": "",
      "TitleArray": [
        "Serious Undertakings"
      ],
      "Year": "1983",
      "Director": "Helen Grace",
      "DirectorArray": [
        "Helen Grace"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3001",
      "databaseFilmTitle": "Set It Off",
      "FilmTitle": "Set It Off",
      "AlternateTitle": "",
      "TitleArray": [
        "Set It Off"
      ],
      "Year": "1996",
      "Director": "F. Gary Gray",
      "DirectorArray": [
        "F. Gary Gray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3002",
      "databaseFilmTitle": "Seven",
      "FilmTitle": "Seven",
      "AlternateTitle": "Se7en",
      "TitleArray": [
        "Seven",
        "Se7en"
      ],
      "Year": "1995",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3003",
      "databaseFilmTitle": "Seven Beauties",
      "FilmTitle": "Seven Beauties",
      "AlternateTitle": "Pasqualino settebellezze",
      "TitleArray": [
        "Seven Beauties",
        "Pasqualino settebellezze"
      ],
      "Year": "1975",
      "Director": "Lina Wertmüller",
      "DirectorArray": [
        "Lina Wertmüller"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3004",
      "databaseFilmTitle": "Seven Chances",
      "FilmTitle": "Seven Chances",
      "AlternateTitle": "",
      "TitleArray": [
        "Seven Chances"
      ],
      "Year": "1925",
      "Director": "Buster Keaton",
      "DirectorArray": [
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3005",
      "databaseFilmTitle": "Seven Samurai",
      "FilmTitle": "Seven Samurai",
      "AlternateTitle": "Shichinin no Samurai",
      "TitleArray": [
        "Seven Samurai",
        "Shichinin no Samurai"
      ],
      "Year": "1954",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "3",
      "1982votes": "15",
      "1992rank": "15",
      "1992votes": "9",
      "2002rank": "11",
      "2002votes": "15",
      "2012rank": "17",
      "2012votes": "48",
      "2022rank": "20",
      "2022votes": "71"
    },
    {
      "key": "3006",
      "databaseFilmTitle": "Seven Times a Day We Complain About Our Fate and at Night We Get up to Avoid Our Dreams",
      "FilmTitle": "Seven Times a Day We Complain About Our Fate and at Night We Get up to Avoid Our Dreams",
      "AlternateTitle": "Sieben Mal am Tag beklagen wir unser Los und nachts stehen wir auf, um nicht zu träumen",
      "TitleArray": [
        "Seven Times a Day We Complain About Our Fate and at Night We Get up to Avoid Our Dreams",
        "Sieben Mal am Tag beklagen wir unser Los und nachts stehen wir auf, um nicht zu träumen"
      ],
      "Year": "2014",
      "Director": "Susann Maria Hempel",
      "DirectorArray": [
        "Susann Maria Hempel"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3007",
      "databaseFilmTitle": "Seven Up!",
      "FilmTitle": "Seven Up!",
      "AlternateTitle": "",
      "TitleArray": [
        "Seven Up!"
      ],
      "Year": "1964",
      "Director": "Paul Almond",
      "DirectorArray": [
        "Paul Almond"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3008",
      "databaseFilmTitle": "Seventeen",
      "FilmTitle": "Seventeen",
      "AlternateTitle": "",
      "TitleArray": [
        "Seventeen"
      ],
      "Year": "1983",
      "Director": "Joel DeMott, Jeff Kreines",
      "DirectorArray": [
        "Joel DeMott",
        "Jeff Kreines"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3009",
      "databaseFilmTitle": "Sex and the Single Girl",
      "FilmTitle": "Sex and the Single Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Sex and the Single Girl"
      ],
      "Year": "1964",
      "Director": "Richard Quine",
      "DirectorArray": [
        "Richard Quine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3010",
      "databaseFilmTitle": "Sexy Beast",
      "FilmTitle": "Sexy Beast",
      "AlternateTitle": "",
      "TitleArray": [
        "Sexy Beast"
      ],
      "Year": "2000",
      "Director": "Jonathan Glazer",
      "DirectorArray": [
        "Jonathan Glazer"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3011",
      "databaseFilmTitle": "Shadow of a Doubt",
      "FilmTitle": "Shadow of a Doubt",
      "AlternateTitle": "",
      "TitleArray": [
        "Shadow of a Doubt"
      ],
      "Year": "1943",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3012",
      "databaseFilmTitle": "Shadowlands",
      "FilmTitle": "Shadowlands",
      "AlternateTitle": "",
      "TitleArray": [
        "Shadowlands"
      ],
      "Year": "1993",
      "Director": "Richard Attenborough",
      "DirectorArray": [
        "Richard Attenborough"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3013",
      "databaseFilmTitle": "Shadows",
      "FilmTitle": "Shadows",
      "AlternateTitle": "",
      "TitleArray": [
        "Shadows"
      ],
      "Year": "1959",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3014",
      "databaseFilmTitle": "Shadows of Forgotten Ancestors",
      "FilmTitle": "Shadows of Forgotten Ancestors",
      "AlternateTitle": "Tini zabutykh predkiv",
      "TitleArray": [
        "Shadows of Forgotten Ancestors",
        "Tini zabutykh predkiv"
      ],
      "Year": "1965",
      "Director": "Sergei Parajanov",
      "DirectorArray": [
        "Sergei Parajanov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3015",
      "databaseFilmTitle": "Shaihu Umar",
      "FilmTitle": "Shaihu Umar",
      "AlternateTitle": "",
      "TitleArray": [
        "Shaihu Umar"
      ],
      "Year": "1976",
      "Director": "Adamu Halilu",
      "DirectorArray": [
        "Adamu Halilu"
      ],
      "Country": "Nigeria",
      "CountryArray": [
        "Nigeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3016",
      "databaseFilmTitle": "Shakedown",
      "FilmTitle": "Shakedown",
      "AlternateTitle": "",
      "TitleArray": [
        "Shakedown"
      ],
      "Year": "2018",
      "Director": "Leilah Weinraub",
      "DirectorArray": [
        "Leilah Weinraub"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3017",
      "databaseFilmTitle": "Shame (1968)",
      "FilmTitle": "Shame",
      "AlternateTitle": "Skammen",
      "TitleArray": [
        "Shame",
        "Skammen"
      ],
      "Year": "1968",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3018",
      "databaseFilmTitle": "Shame (2011)",
      "FilmTitle": "Shame",
      "AlternateTitle": "",
      "TitleArray": [
        "Shame"
      ],
      "Year": "2011",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3019",
      "databaseFilmTitle": "Shane",
      "FilmTitle": "Shane",
      "AlternateTitle": "",
      "TitleArray": [
        "Shane"
      ],
      "Year": "1953",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3020",
      "databaseFilmTitle": "Shanghai Express",
      "FilmTitle": "Shanghai Express",
      "AlternateTitle": "",
      "TitleArray": [
        "Shanghai Express"
      ],
      "Year": "1932",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3021",
      "databaseFilmTitle": "Shanghai Women",
      "FilmTitle": "Shanghai Women",
      "AlternateTitle": "",
      "TitleArray": [
        "Shanghai Women"
      ],
      "Year": "2002",
      "Director": "Peng Xiaolian",
      "DirectorArray": [
        "Peng Xiaolian"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3022",
      "databaseFilmTitle": "Shara",
      "FilmTitle": "Shara",
      "AlternateTitle": "Shara",
      "TitleArray": [
        "Shara",
        "Shara"
      ],
      "Year": "2003",
      "Director": "Naomi Kawase",
      "DirectorArray": [
        "Naomi Kawase"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3023",
      "databaseFilmTitle": "Shaun of the Dead",
      "FilmTitle": "Shaun of the Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "Shaun of the Dead"
      ],
      "Year": "2004",
      "Director": "Edgar Wright",
      "DirectorArray": [
        "Edgar Wright"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3024",
      "databaseFilmTitle": "She Puppet",
      "FilmTitle": "She Puppet",
      "AlternateTitle": "",
      "TitleArray": [
        "She Puppet"
      ],
      "Year": "2001",
      "Director": "Peggy Ahwesh",
      "DirectorArray": [
        "Peggy Ahwesh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3025",
      "databaseFilmTitle": "She Was Like a Wild Chrysanthemum",
      "FilmTitle": "She Was Like a Wild Chrysanthemum",
      "AlternateTitle": "Nogiku no gotoki kimi nariki",
      "TitleArray": [
        "She Was Like a Wild Chrysanthemum",
        "Nogiku no gotoki kimi nariki"
      ],
      "Year": "1955",
      "Director": "Keisuke Kinoshita",
      "DirectorArray": [
        "Keisuke Kinoshita"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3026",
      "databaseFilmTitle": "She Wore a Yellow Ribbon",
      "FilmTitle": "She Wore a Yellow Ribbon",
      "AlternateTitle": "",
      "TitleArray": [
        "She Wore a Yellow Ribbon"
      ],
      "Year": "1949",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3027",
      "databaseFilmTitle": "She, a Chinese",
      "FilmTitle": "She, a Chinese",
      "AlternateTitle": "",
      "TitleArray": [
        "She, a Chinese"
      ],
      "Year": "2009",
      "Director": "Guo Xiaolu",
      "DirectorArray": [
        "Guo Xiaolu"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3028",
      "databaseFilmTitle": "Sheep",
      "FilmTitle": "Sheep",
      "AlternateTitle": "Mouton",
      "TitleArray": [
        "Sheep",
        "Mouton"
      ],
      "Year": "2013",
      "Director": "Gilles Deroo, Marianne Pistone",
      "DirectorArray": [
        "Gilles Deroo",
        "Marianne Pistone"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3029",
      "databaseFilmTitle": "Sherlock Jr.",
      "FilmTitle": "Sherlock Jr.",
      "AlternateTitle": "",
      "TitleArray": [
        "Sherlock Jr."
      ],
      "Year": "1924",
      "Director": "Buster Keaton",
      "DirectorArray": [
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "59",
      "2012votes": "25",
      "2022rank": "54",
      "2022votes": "44"
    },
    {
      "key": "3030",
      "databaseFilmTitle": "Sherman's March",
      "FilmTitle": "Sherman's March",
      "AlternateTitle": "Sherman's March: A Meditation to the Possibility of Romantic Love in the South During an Era of Nuclear Weapons Proliferation",
      "TitleArray": [
        "Sherman's March",
        "Sherman's March: A Meditation to the Possibility of Romantic Love in the South During an Era of Nuclear Weapons Proliferation"
      ],
      "Year": "1985",
      "Director": "Ross McElwee",
      "DirectorArray": [
        "Ross McElwee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3031",
      "databaseFilmTitle": "Sherpa",
      "FilmTitle": "Sherpa",
      "AlternateTitle": "",
      "TitleArray": [
        "Sherpa"
      ],
      "Year": "2015",
      "Director": "Jennifer Peedom",
      "DirectorArray": [
        "Jennifer Peedom"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3032",
      "databaseFilmTitle": "Shin Heike Monogatari",
      "FilmTitle": "Shin Heike Monogatari",
      "AlternateTitle": "",
      "TitleArray": [
        "Shin Heike Monogatari"
      ],
      "Year": "1972",
      "Director": "Shimizu Mitsuru, Higuchi Masahiro",
      "DirectorArray": [
        "Shimizu Mitsuru",
        "Higuchi Masahiro"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3033",
      "databaseFilmTitle": "Ship of Theseus",
      "FilmTitle": "Ship of Theseus",
      "AlternateTitle": "",
      "TitleArray": [
        "Ship of Theseus"
      ],
      "Year": "2012",
      "Director": "Anand Gandhi",
      "DirectorArray": [
        "Anand Gandhi"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3034",
      "databaseFilmTitle": "Shirin",
      "FilmTitle": "Shirin",
      "AlternateTitle": "",
      "TitleArray": [
        "Shirin"
      ],
      "Year": "2008",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3035",
      "databaseFilmTitle": "Shirkers",
      "FilmTitle": "Shirkers",
      "AlternateTitle": "",
      "TitleArray": [
        "Shirkers"
      ],
      "Year": "2018",
      "Director": "Sandi Tan",
      "DirectorArray": [
        "Sandi Tan"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3036",
      "databaseFilmTitle": "Shirley",
      "FilmTitle": "Shirley",
      "AlternateTitle": "",
      "TitleArray": [
        "Shirley"
      ],
      "Year": "2020",
      "Director": "Josephine Decker",
      "DirectorArray": [
        "Josephine Decker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3037",
      "databaseFilmTitle": "Shirley Thompson Versus The Aliens",
      "FilmTitle": "Shirley Thompson Versus The Aliens",
      "AlternateTitle": "",
      "TitleArray": [
        "Shirley Thompson Versus The Aliens"
      ],
      "Year": "1972",
      "Director": "Jim Sharman",
      "DirectorArray": [
        "Jim Sharman"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3038",
      "databaseFilmTitle": "Shirley: Visions of Reality",
      "FilmTitle": "Shirley: Visions of Reality",
      "AlternateTitle": "",
      "TitleArray": [
        "Shirley: Visions of Reality"
      ],
      "Year": "2013",
      "Director": "Gustav Deutsch",
      "DirectorArray": [
        "Gustav Deutsch"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3039",
      "databaseFilmTitle": "Shoah",
      "FilmTitle": "Shoah",
      "AlternateTitle": "",
      "TitleArray": [
        "Shoah"
      ],
      "Year": "1985",
      "Director": "Claude Lanzmann",
      "DirectorArray": [
        "Claude Lanzmann"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "29",
      "2012votes": "39",
      "2022rank": "27",
      "2022votes": "64"
    },
    {
      "key": "3040",
      "databaseFilmTitle": "Shoah: Four Sisters",
      "FilmTitle": "Shoah: Four Sisters",
      "AlternateTitle": "Les quatre soeurs",
      "TitleArray": [
        "Shoah: Four Sisters",
        "Les quatre soeurs"
      ],
      "Year": "2017",
      "Director": "Claude Lanzmann",
      "DirectorArray": [
        "Claude Lanzmann"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3041",
      "databaseFilmTitle": "Shock Corridor",
      "FilmTitle": "Shock Corridor",
      "AlternateTitle": "",
      "TitleArray": [
        "Shock Corridor"
      ],
      "Year": "1963",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3042",
      "databaseFilmTitle": "Shoes",
      "FilmTitle": "Shoes",
      "AlternateTitle": "",
      "TitleArray": [
        "Shoes"
      ],
      "Year": "1916",
      "Director": "Lois Weber",
      "DirectorArray": [
        "Lois Weber"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3043",
      "databaseFilmTitle": "Shoeshine",
      "FilmTitle": "Shoeshine",
      "AlternateTitle": "Sciuscià",
      "TitleArray": [
        "Shoeshine",
        "Sciuscià"
      ],
      "Year": "1946",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3044",
      "databaseFilmTitle": "Sholay",
      "FilmTitle": "Sholay",
      "AlternateTitle": "",
      "TitleArray": [
        "Sholay"
      ],
      "Year": "1975",
      "Director": "Ramesh Sippy",
      "DirectorArray": [
        "Ramesh Sippy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3045",
      "databaseFilmTitle": "Shoot for the Contents",
      "FilmTitle": "Shoot for the Contents",
      "AlternateTitle": "",
      "TitleArray": [
        "Shoot for the Contents"
      ],
      "Year": "1991",
      "Director": "T. Minh-ha Trinh",
      "DirectorArray": [
        "T. Minh-ha Trinh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3046",
      "databaseFilmTitle": "Shoot the Piano Player",
      "FilmTitle": "Shoot the Piano Player",
      "AlternateTitle": "Tirez sur le pianiste",
      "TitleArray": [
        "Shoot the Piano Player",
        "Tirez sur le pianiste"
      ],
      "Year": "1960",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3047",
      "databaseFilmTitle": "Shooting Stars",
      "FilmTitle": "Shooting Stars",
      "AlternateTitle": "",
      "TitleArray": [
        "Shooting Stars"
      ],
      "Year": "1928",
      "Director": "Anthony Asquith, A.V. Bramble",
      "DirectorArray": [
        "Anthony Asquith",
        "A.V. Bramble"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3048",
      "databaseFilmTitle": "Shoplifters",
      "FilmTitle": "Shoplifters",
      "AlternateTitle": "Manbiki kazoku",
      "TitleArray": [
        "Shoplifters",
        "Manbiki kazoku"
      ],
      "Year": "2018",
      "Director": "Hirokazu Koreeda",
      "DirectorArray": [
        "Hirokazu Koreeda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3049",
      "databaseFilmTitle": "Short Cuts",
      "FilmTitle": "Short Cuts",
      "AlternateTitle": "",
      "TitleArray": [
        "Short Cuts"
      ],
      "Year": "1993",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3050",
      "databaseFilmTitle": "Short Film Series",
      "FilmTitle": "Short Film Series",
      "AlternateTitle": "",
      "TitleArray": [
        "Short Film Series"
      ],
      "Year": "1975",
      "Director": "Guy Sherwin",
      "DirectorArray": [
        "Guy Sherwin"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3051",
      "databaseFilmTitle": "Shortbus",
      "FilmTitle": "Shortbus",
      "AlternateTitle": "",
      "TitleArray": [
        "Shortbus"
      ],
      "Year": "2006",
      "Director": "John Cameron Mitchell",
      "DirectorArray": [
        "John Cameron Mitchell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3052",
      "databaseFilmTitle": "Shoulder Arms",
      "FilmTitle": "Shoulder Arms",
      "AlternateTitle": "",
      "TitleArray": [
        "Shoulder Arms"
      ],
      "Year": "1918",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3053",
      "databaseFilmTitle": "Show People",
      "FilmTitle": "Show People",
      "AlternateTitle": "",
      "TitleArray": [
        "Show People"
      ],
      "Year": "1928",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3054",
      "databaseFilmTitle": "Shower",
      "FilmTitle": "Shower",
      "AlternateTitle": "Xizao",
      "TitleArray": [
        "Shower",
        "Xizao"
      ],
      "Year": "1999",
      "Director": "Zhang Yang",
      "DirectorArray": [
        "Zhang Yang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3055",
      "databaseFilmTitle": "Showgirls",
      "FilmTitle": "Showgirls",
      "AlternateTitle": "",
      "TitleArray": [
        "Showgirls"
      ],
      "Year": "1995",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3056",
      "databaseFilmTitle": "Shrek",
      "FilmTitle": "Shrek",
      "AlternateTitle": "",
      "TitleArray": [
        "Shrek"
      ],
      "Year": "2001",
      "Director": "Andrew Adamson, Vicky Jenson",
      "DirectorArray": [
        "Andrew Adamson",
        "Vicky Jenson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3057",
      "databaseFilmTitle": "Shulie",
      "FilmTitle": "Shulie",
      "AlternateTitle": "",
      "TitleArray": [
        "Shulie"
      ],
      "Year": "1997",
      "Director": "Elisabeth Subrin",
      "DirectorArray": [
        "Elisabeth Subrin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3058",
      "databaseFilmTitle": "Siberiade",
      "FilmTitle": "Siberiade",
      "AlternateTitle": "",
      "TitleArray": [
        "Siberiade"
      ],
      "Year": "1979",
      "Director": "Andrey Konchalovskiy",
      "DirectorArray": [
        "Andrey Konchalovskiy"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3059",
      "databaseFilmTitle": "Sicilia!",
      "FilmTitle": "Sicilia!",
      "AlternateTitle": "",
      "TitleArray": [
        "Sicilia!"
      ],
      "Year": "1999",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3060",
      "databaseFilmTitle": "Siddeshwari",
      "FilmTitle": "Siddeshwari",
      "AlternateTitle": "",
      "TitleArray": [
        "Siddeshwari"
      ],
      "Year": "1989",
      "Director": "Mani Kaul",
      "DirectorArray": [
        "Mani Kaul"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3061",
      "databaseFilmTitle": "Side/Walk/Shuttle",
      "FilmTitle": "Side/Walk/Shuttle",
      "AlternateTitle": "",
      "TitleArray": [
        "Side/Walk/Shuttle"
      ],
      "Year": "1991",
      "Director": "Ernie Gehr",
      "DirectorArray": [
        "Ernie Gehr"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3062",
      "databaseFilmTitle": "Sidewalk Stories",
      "FilmTitle": "Sidewalk Stories",
      "AlternateTitle": "",
      "TitleArray": [
        "Sidewalk Stories"
      ],
      "Year": "1989",
      "Director": "Charles Lane",
      "DirectorArray": [
        "Charles Lane"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3063",
      "databaseFilmTitle": "Sideways",
      "FilmTitle": "Sideways",
      "AlternateTitle": "",
      "TitleArray": [
        "Sideways"
      ],
      "Year": "2004",
      "Director": "Alexander Payne",
      "DirectorArray": [
        "Alexander Payne"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3064",
      "databaseFilmTitle": "Siegfried",
      "FilmTitle": "Siegfried",
      "AlternateTitle": "",
      "TitleArray": [
        "Siegfried"
      ],
      "Year": "2005",
      "Director": "Sven Unterwaldt Jr.",
      "DirectorArray": [
        "Sven Unterwaldt Jr."
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3065",
      "databaseFilmTitle": "Sieranevada",
      "FilmTitle": "Sieranevada",
      "AlternateTitle": "",
      "TitleArray": [
        "Sieranevada"
      ],
      "Year": "2016",
      "Director": "Cristi Puiu",
      "DirectorArray": [
        "Cristi Puiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3066",
      "databaseFilmTitle": "Signs of Life",
      "FilmTitle": "Signs of Life",
      "AlternateTitle": "Lebenszeichen",
      "TitleArray": [
        "Signs of Life",
        "Lebenszeichen"
      ],
      "Year": "1968",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3067",
      "databaseFilmTitle": "Silence",
      "FilmTitle": "Silence",
      "AlternateTitle": "",
      "TitleArray": [
        "Silence"
      ],
      "Year": "2016",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3068",
      "databaseFilmTitle": "Silence and Cry",
      "FilmTitle": "Silence and Cry",
      "AlternateTitle": "Csend és kiáltás",
      "TitleArray": [
        "Silence and Cry",
        "Csend és kiáltás"
      ],
      "Year": "1967",
      "Director": "Miklós Jancsó",
      "DirectorArray": [
        "Miklós Jancsó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3069",
      "databaseFilmTitle": "Silence Has No Wings",
      "FilmTitle": "Silence Has No Wings",
      "AlternateTitle": "Tobenai chinmoku",
      "TitleArray": [
        "Silence Has No Wings",
        "Tobenai chinmoku"
      ],
      "Year": "1966",
      "Director": "Kazuo Kuroki",
      "DirectorArray": [
        "Kazuo Kuroki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3070",
      "databaseFilmTitle": "Silent Light",
      "FilmTitle": "Silent Light",
      "AlternateTitle": "Stellet licht",
      "TitleArray": [
        "Silent Light",
        "Stellet licht"
      ],
      "Year": "2007",
      "Director": "Carlos Reygadas",
      "DirectorArray": [
        "Carlos Reygadas"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3071",
      "databaseFilmTitle": "Silent Running",
      "FilmTitle": "Silent Running",
      "AlternateTitle": "",
      "TitleArray": [
        "Silent Running"
      ],
      "Year": "1972",
      "Director": "Douglas Trumbull",
      "DirectorArray": [
        "Douglas Trumbull"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3072",
      "databaseFilmTitle": "Silverlake Life: The View from Here",
      "FilmTitle": "Silverlake Life: The View from Here",
      "AlternateTitle": "",
      "TitleArray": [
        "Silverlake Life: The View from Here"
      ],
      "Year": "1993",
      "Director": "Peter Friedman, Tom Joslin",
      "DirectorArray": [
        "Peter Friedman",
        "Tom Joslin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3073",
      "databaseFilmTitle": "Siméon",
      "FilmTitle": "Siméon",
      "AlternateTitle": "",
      "TitleArray": [
        "Siméon"
      ],
      "Year": "1992",
      "Director": "Euzhan Palcy",
      "DirectorArray": [
        "Euzhan Palcy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3074",
      "databaseFilmTitle": "Simon of the Desert",
      "FilmTitle": "Simon of the Desert",
      "AlternateTitle": "Simón del desierto",
      "TitleArray": [
        "Simon of the Desert",
        "Simón del desierto"
      ],
      "Year": "1965",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3075",
      "databaseFilmTitle": "Simone Barbes or Virtue",
      "FilmTitle": "Simone Barbes or Virtue",
      "AlternateTitle": "Simone Barbès ou la vertu",
      "TitleArray": [
        "Simone Barbes or Virtue",
        "Simone Barbès ou la vertu"
      ],
      "Year": "1980",
      "Director": "Marie-Claude Treilhou",
      "DirectorArray": [
        "Marie-Claude Treilhou"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3076",
      "databaseFilmTitle": "Simple Men",
      "FilmTitle": "Simple Men",
      "AlternateTitle": "",
      "TitleArray": [
        "Simple Men"
      ],
      "Year": "1992",
      "Director": "Hal Hartley",
      "DirectorArray": [
        "Hal Hartley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3077",
      "databaseFilmTitle": "Sinbad",
      "FilmTitle": "Sinbad",
      "AlternateTitle": "Szindbád",
      "TitleArray": [
        "Sinbad",
        "Szindbád"
      ],
      "Year": "1971",
      "Director": "Zoltán Huszárik",
      "DirectorArray": [
        "Zoltán Huszárik"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3078",
      "databaseFilmTitle": "Singin' in the Rain",
      "FilmTitle": "Singin' in the Rain",
      "AlternateTitle": "",
      "TitleArray": [
        "Singin' in the Rain"
      ],
      "Year": "1952",
      "Director": "Stanley Donen, Gene Kelly",
      "DirectorArray": [
        "Stanley Donen",
        "Gene Kelly"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "3",
      "1982votes": "15",
      "1992rank": "11",
      "1992votes": "10",
      "2002rank": "9",
      "2002votes": "17",
      "2012rank": "20",
      "2012votes": "46",
      "2022rank": "10",
      "2022votes": "99"
    },
    {
      "key": "3079",
      "databaseFilmTitle": "Sinister",
      "FilmTitle": "Sinister",
      "AlternateTitle": "",
      "TitleArray": [
        "Sinister"
      ],
      "Year": "2012",
      "Director": "Scott Derrickson",
      "DirectorArray": [
        "Scott Derrickson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3080",
      "databaseFilmTitle": "Sink or Swim",
      "FilmTitle": "Sink or Swim",
      "AlternateTitle": "",
      "TitleArray": [
        "Sink or Swim"
      ],
      "Year": "1990",
      "Director": "Su Friedrich",
      "DirectorArray": [
        "Su Friedrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3081",
      "databaseFilmTitle": "Sir Arne's Treasure",
      "FilmTitle": "Sir Arne's Treasure",
      "AlternateTitle": "Herr Arnes Pengar",
      "TitleArray": [
        "Sir Arne's Treasure",
        "Herr Arnes Pengar"
      ],
      "Year": "1919",
      "Director": "Mauritz Stiller",
      "DirectorArray": [
        "Mauritz Stiller"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3082",
      "databaseFilmTitle": "Sir Henry at Rawlinson End",
      "FilmTitle": "Sir Henry at Rawlinson End",
      "AlternateTitle": "",
      "TitleArray": [
        "Sir Henry at Rawlinson End"
      ],
      "Year": "1980",
      "Director": "Steve Roberts",
      "DirectorArray": [
        "Steve Roberts"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3083",
      "databaseFilmTitle": "Sirley",
      "FilmTitle": "Sirley",
      "AlternateTitle": "Maledetta primavera",
      "TitleArray": [
        "Sirley",
        "Maledetta primavera"
      ],
      "Year": "2020",
      "Director": "Elisa Amoruso",
      "DirectorArray": [
        "Elisa Amoruso"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3084",
      "databaseFilmTitle": "Sister Act",
      "FilmTitle": "Sister Act",
      "AlternateTitle": "",
      "TitleArray": [
        "Sister Act"
      ],
      "Year": "1992",
      "Director": "Emile Ardolino",
      "DirectorArray": [
        "Emile Ardolino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3085",
      "databaseFilmTitle": "Sister Galvan",
      "FilmTitle": "Sister Galvan",
      "AlternateTitle": "",
      "TitleArray": [
        "Sister Galvan"
      ],
      "Year": "2003",
      "Director": "Marian Evans",
      "DirectorArray": [
        "Marian Evans"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3086",
      "databaseFilmTitle": "Sister Stella L.",
      "FilmTitle": "Sister Stella L.",
      "AlternateTitle": "",
      "TitleArray": [
        "Sister Stella L."
      ],
      "Year": "1984",
      "Director": "Mike De Leon",
      "DirectorArray": [
        "Mike De Leon"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3087",
      "databaseFilmTitle": "Sisters",
      "FilmTitle": "Sisters",
      "AlternateTitle": "",
      "TitleArray": [
        "Sisters"
      ],
      "Year": "1972",
      "Director": "Brian De Palma",
      "DirectorArray": [
        "Brian De Palma"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3088",
      "databaseFilmTitle": "Sisters of the Gion",
      "FilmTitle": "Sisters of the Gion",
      "AlternateTitle": "Gion no shimai",
      "TitleArray": [
        "Sisters of the Gion",
        "Gion no shimai"
      ],
      "Year": "1936",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3089",
      "databaseFilmTitle": "Six Degrees of Separation",
      "FilmTitle": "Six Degrees of Separation",
      "AlternateTitle": "",
      "TitleArray": [
        "Six Degrees of Separation"
      ],
      "Year": "1993",
      "Director": "Fred Schepisi",
      "DirectorArray": [
        "Fred Schepisi"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3090",
      "databaseFilmTitle": "Six fois deux/Sur et sous la communication",
      "FilmTitle": "Six fois deux/Sur et sous la communication",
      "AlternateTitle": "",
      "TitleArray": [
        "Six fois deux/Sur et sous la communication"
      ],
      "Year": "1976",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3091",
      "databaseFilmTitle": "Sixth Happiness",
      "FilmTitle": "Sixth Happiness",
      "AlternateTitle": "",
      "TitleArray": [
        "Sixth Happiness"
      ],
      "Year": "1997",
      "Director": "Waris Hussein",
      "DirectorArray": [
        "Waris Hussein"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3092",
      "databaseFilmTitle": "Skazka",
      "FilmTitle": "Skazka",
      "AlternateTitle": "",
      "TitleArray": [
        "Skazka"
      ],
      "Year": "2021",
      "Director": "Maksim Kulkov",
      "DirectorArray": [
        "Maksim Kulkov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3093",
      "databaseFilmTitle": "Slacker",
      "FilmTitle": "Slacker",
      "AlternateTitle": "",
      "TitleArray": [
        "Slacker"
      ],
      "Year": "1990",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3094",
      "databaseFilmTitle": "Sleep Has Her House",
      "FilmTitle": "Sleep Has Her House",
      "AlternateTitle": "",
      "TitleArray": [
        "Sleep Has Her House"
      ],
      "Year": "2017",
      "Director": "Scott Barley",
      "DirectorArray": [
        "Scott Barley"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3095",
      "databaseFilmTitle": "Sleepcinemahotel",
      "FilmTitle": "Sleepcinemahotel",
      "AlternateTitle": "",
      "TitleArray": [
        "Sleepcinemahotel"
      ],
      "Year": "2018",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3096",
      "databaseFilmTitle": "Sleeping Beauty",
      "FilmTitle": "Sleeping Beauty",
      "AlternateTitle": "",
      "TitleArray": [
        "Sleeping Beauty"
      ],
      "Year": "1959",
      "Director": "Clyde Geronimi, Les Clark, Eric Larson, Wolfgang Reitherman",
      "DirectorArray": [
        "Clyde Geronimi",
        "Les Clark",
        "Eric Larson",
        "Wolfgang Reitherman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3097",
      "databaseFilmTitle": "Sleepless in Seattle",
      "FilmTitle": "Sleepless in Seattle",
      "AlternateTitle": "",
      "TitleArray": [
        "Sleepless in Seattle"
      ],
      "Year": "1993",
      "Director": "Nora Ephron",
      "DirectorArray": [
        "Nora Ephron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3098",
      "databaseFilmTitle": "Sleepy Hallow",
      "FilmTitle": "Sleepy Hallow",
      "AlternateTitle": "",
      "TitleArray": [
        "Sleepy Hallow"
      ],
      "Year": "1999",
      "Director": "Tim Burton",
      "DirectorArray": [
        "Tim Burton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3099",
      "databaseFilmTitle": "Slow Summer",
      "FilmTitle": "Slow Summer",
      "AlternateTitle": "Langsamer Sommer",
      "TitleArray": [
        "Slow Summer",
        "Langsamer Sommer"
      ],
      "Year": "1976",
      "Director": "Michael Pilz",
      "DirectorArray": [
        "Michael Pilz"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3100",
      "databaseFilmTitle": "Small Axe: Lovers Rock",
      "FilmTitle": "Small Axe: Lovers Rock",
      "AlternateTitle": "",
      "TitleArray": [
        "Small Axe: Lovers Rock"
      ],
      "Year": "2020",
      "Director": "Steven McQueen",
      "DirectorArray": [
        "Steven McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3101",
      "databaseFilmTitle": "Small Axe: Mangrove",
      "FilmTitle": "Small Axe: Mangrove",
      "AlternateTitle": "",
      "TitleArray": [
        "Small Axe: Mangrove"
      ],
      "Year": "2020",
      "Director": "Steve McQueen",
      "DirectorArray": [
        "Steve McQueen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3102",
      "databaseFilmTitle": "Small Time Crooks",
      "FilmTitle": "Small Time Crooks",
      "AlternateTitle": "",
      "TitleArray": [
        "Small Time Crooks"
      ],
      "Year": "2000",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3103",
      "databaseFilmTitle": "Small-Town Woman",
      "FilmTitle": "Small-Town Woman",
      "AlternateTitle": "Pueblerina",
      "TitleArray": [
        "Small-Town Woman",
        "Pueblerina"
      ],
      "Year": "1949",
      "Director": "Emilio Fernández",
      "DirectorArray": [
        "Emilio Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3104",
      "databaseFilmTitle": "Smell of Camphor, Fragrance of Jasmine",
      "FilmTitle": "Smell of Camphor, Fragrance of Jasmine",
      "AlternateTitle": "Booye kafoor, atre yas",
      "TitleArray": [
        "Smell of Camphor, Fragrance of Jasmine",
        "Booye kafoor, atre yas"
      ],
      "Year": "2000",
      "Director": "Bahman Farmanara",
      "DirectorArray": [
        "Bahman Farmanara"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3105",
      "databaseFilmTitle": "Smiles of a Summer Night",
      "FilmTitle": "Smiles of a Summer Night",
      "AlternateTitle": "Sommarnattens leende",
      "TitleArray": [
        "Smiles of a Summer Night",
        "Sommarnattens leende"
      ],
      "Year": "1955",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3106",
      "databaseFilmTitle": "Smiley Face",
      "FilmTitle": "Smiley Face",
      "AlternateTitle": "",
      "TitleArray": [
        "Smiley Face"
      ],
      "Year": "2007",
      "Director": "Gregg Araki",
      "DirectorArray": [
        "Gregg Araki"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3107",
      "databaseFilmTitle": "Smithereens",
      "FilmTitle": "Smithereens",
      "AlternateTitle": "",
      "TitleArray": [
        "Smithereens"
      ],
      "Year": "1982",
      "Director": "Susan Seidelman",
      "DirectorArray": [
        "Susan Seidelman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3108",
      "databaseFilmTitle": "Smog",
      "FilmTitle": "Smog",
      "AlternateTitle": "",
      "TitleArray": [
        "Smog"
      ],
      "Year": "1962",
      "Director": "Franco Rossi",
      "DirectorArray": [
        "Franco Rossi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3109",
      "databaseFilmTitle": "Smoking/No Smoking",
      "FilmTitle": "Smoking/No Smoking",
      "AlternateTitle": "",
      "TitleArray": [
        "Smoking/No Smoking"
      ],
      "Year": "1993",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3110",
      "databaseFilmTitle": "Smooth Talk",
      "FilmTitle": "Smooth Talk",
      "AlternateTitle": "",
      "TitleArray": [
        "Smooth Talk"
      ],
      "Year": "1985",
      "Director": "Joyce Chopra",
      "DirectorArray": [
        "Joyce Chopra"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3111",
      "databaseFilmTitle": "Snatch",
      "FilmTitle": "Snatch",
      "AlternateTitle": "",
      "TitleArray": [
        "Snatch"
      ],
      "Year": "2000",
      "Director": "Guy Ritchie",
      "DirectorArray": [
        "Guy Ritchie"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3112",
      "databaseFilmTitle": "Snow",
      "FilmTitle": "Snow",
      "AlternateTitle": "",
      "TitleArray": [
        "Snow"
      ],
      "Year": "1963",
      "Director": "Geoffrey Jones",
      "DirectorArray": [
        "Geoffrey Jones"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3113",
      "databaseFilmTitle": "Snow White",
      "FilmTitle": "Snow White",
      "AlternateTitle": "Branca de neve",
      "TitleArray": [
        "Snow White",
        "Branca de neve"
      ],
      "Year": "2000",
      "Director": "João César Monteiro",
      "DirectorArray": [
        "João César Monteiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3114",
      "databaseFilmTitle": "Snow White and the Seven Dwarfs",
      "FilmTitle": "Snow White and the Seven Dwarfs",
      "AlternateTitle": "",
      "TitleArray": [
        "Snow White and the Seven Dwarfs"
      ],
      "Year": "1937",
      "Director": "William Cottrell, David Hand, Wilfred Jackson, Larry Morey, Perce Pearce, Ben Sharpsteen",
      "DirectorArray": [
        "William Cottrell",
        "David Hand",
        "Wilfred Jackson",
        "Larry Morey",
        "Perce Pearce",
        "Ben Sharpsteen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3115",
      "databaseFilmTitle": "So Long, My Son",
      "FilmTitle": "So Long, My Son",
      "AlternateTitle": "Di jiu tian chang",
      "TitleArray": [
        "So Long, My Son",
        "Di jiu tian chang"
      ],
      "Year": "2019",
      "Director": "Wang Xiaoshuai",
      "DirectorArray": [
        "Wang Xiaoshuai"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3116",
      "databaseFilmTitle": "So That You Can Live",
      "FilmTitle": "So That You Can Live",
      "AlternateTitle": "",
      "TitleArray": [
        "So That You Can Live"
      ],
      "Year": "1981",
      "Director": "Cinema Action, Eduardo Guedes, Ann Guedes",
      "DirectorArray": [
        "Cinema Action",
        "Eduardo Guedes",
        "Ann Guedes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3117",
      "databaseFilmTitle": "So This Is Paris",
      "FilmTitle": "So This Is Paris",
      "AlternateTitle": "",
      "TitleArray": [
        "So This Is Paris"
      ],
      "Year": "1926",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3118",
      "databaseFilmTitle": "Socialism",
      "FilmTitle": "Socialism",
      "AlternateTitle": "Sosialismi",
      "TitleArray": [
        "Socialism",
        "Sosialismi"
      ],
      "Year": "2014",
      "Director": "Peter von Bagh",
      "DirectorArray": [
        "Peter von Bagh"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3119",
      "databaseFilmTitle": "Society",
      "FilmTitle": "Society",
      "AlternateTitle": "",
      "TitleArray": [
        "Society"
      ],
      "Year": "1989",
      "Director": "Brian Yuzna",
      "DirectorArray": [
        "Brian Yuzna"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3120",
      "databaseFilmTitle": "Society of the Spectacle",
      "FilmTitle": "Society of the Spectacle",
      "AlternateTitle": "La société du spectacle",
      "TitleArray": [
        "Society of the Spectacle",
        "La société du spectacle"
      ],
      "Year": "1974",
      "Director": "Guy Debord",
      "DirectorArray": [
        "Guy Debord"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3121",
      "databaseFilmTitle": "Sock Ads: Judith Williamson Consumes Passionately in Southern California",
      "FilmTitle": "Sock Ads: Judith Williamson Consumes Passionately in Southern California",
      "AlternateTitle": "",
      "TitleArray": [
        "Sock Ads: Judith Williamson Consumes Passionately in Southern California"
      ],
      "Year": "1987",
      "Director": "Judith Williamson",
      "DirectorArray": [
        "Judith Williamson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3122",
      "databaseFilmTitle": "Sodom",
      "FilmTitle": "Sodom",
      "AlternateTitle": "",
      "TitleArray": [
        "Sodom"
      ],
      "Year": "1989",
      "Director": "Luther Price",
      "DirectorArray": [
        "Luther Price"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3123",
      "databaseFilmTitle": "Soft Fiction",
      "FilmTitle": "Soft Fiction",
      "AlternateTitle": "",
      "TitleArray": [
        "Soft Fiction"
      ],
      "Year": "1979",
      "Director": "Chick Strand",
      "DirectorArray": [
        "Chick Strand"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3124",
      "databaseFilmTitle": "Solar Flare Arkestral Marching Band",
      "FilmTitle": "Solar Flare Arkestral Marching Band",
      "AlternateTitle": "",
      "TitleArray": [
        "Solar Flare Arkestral Marching Band"
      ],
      "Year": "2011",
      "Director": "Cauleen Smith",
      "DirectorArray": [
        "Cauleen Smith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3125",
      "databaseFilmTitle": "Solaris",
      "FilmTitle": "Solaris",
      "AlternateTitle": "",
      "TitleArray": [
        "Solaris"
      ],
      "Year": "1972",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "3126",
      "databaseFilmTitle": "Solidarity",
      "FilmTitle": "Solidarity",
      "AlternateTitle": "",
      "TitleArray": [
        "Solidarity"
      ],
      "Year": "1973",
      "Director": "Joyce Wieland",
      "DirectorArray": [
        "Joyce Wieland"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3127",
      "databaseFilmTitle": "Solo",
      "FilmTitle": "Solo",
      "AlternateTitle": "",
      "TitleArray": [
        "Solo"
      ],
      "Year": "1970",
      "Director": "Jean-Pierre Mocky",
      "DirectorArray": [
        "Jean-Pierre Mocky"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3128",
      "databaseFilmTitle": "Some Came Running",
      "FilmTitle": "Some Came Running",
      "AlternateTitle": "",
      "TitleArray": [
        "Some Came Running"
      ],
      "Year": "1958",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3129",
      "databaseFilmTitle": "Some Interviews on Personal Matters",
      "FilmTitle": "Some Interviews on Personal Matters",
      "AlternateTitle": "Ramdenime interviu pirad sakitkhebze",
      "TitleArray": [
        "Some Interviews on Personal Matters",
        "Ramdenime interviu pirad sakitkhebze"
      ],
      "Year": "1978",
      "Director": "Lana Ghoghoberidze",
      "DirectorArray": [
        "Lana Ghoghoberidze"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3130",
      "databaseFilmTitle": "Some Like It Hot",
      "FilmTitle": "Some Like It Hot",
      "AlternateTitle": "",
      "TitleArray": [
        "Some Like It Hot"
      ],
      "Year": "1959",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "26",
      "1992votes": "7",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "43",
      "2012votes": "31",
      "2022rank": "38",
      "2022votes": "53"
    },
    {
      "key": "3131",
      "databaseFilmTitle": "Something Better to Come",
      "FilmTitle": "Something Better to Come",
      "AlternateTitle": "",
      "TitleArray": [
        "Something Better to Come"
      ],
      "Year": "2014",
      "Director": "Hanna Polak",
      "DirectorArray": [
        "Hanna Polak"
      ],
      "Country": "Poland, Denmark",
      "CountryArray": [
        "Poland",
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3132",
      "databaseFilmTitle": "Something Different",
      "FilmTitle": "Something Different",
      "AlternateTitle": "O něčem jiném",
      "TitleArray": [
        "Something Different",
        "O něčem jiném"
      ],
      "Year": "1963",
      "Director": "Věra Chytilová",
      "DirectorArray": [
        "Věra Chytilová"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3133",
      "databaseFilmTitle": "Something Like a War",
      "FilmTitle": "Something Like a War",
      "AlternateTitle": "",
      "TitleArray": [
        "Something Like a War"
      ],
      "Year": "1991",
      "Director": "Deepa Dhanraj",
      "DirectorArray": [
        "Deepa Dhanraj"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3134",
      "databaseFilmTitle": "Something Nice to Eat",
      "FilmTitle": "Something Nice to Eat",
      "AlternateTitle": "",
      "TitleArray": [
        "Something Nice to Eat"
      ],
      "Year": "1967",
      "Director": "Sarah Erulkar",
      "DirectorArray": [
        "Sarah Erulkar"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3135",
      "databaseFilmTitle": "Something Wild",
      "FilmTitle": "Something Wild",
      "AlternateTitle": "",
      "TitleArray": [
        "Something Wild"
      ],
      "Year": "1986",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3136",
      "databaseFilmTitle": "Sometimes a Great Notion",
      "FilmTitle": "Sometimes a Great Notion",
      "AlternateTitle": "",
      "TitleArray": [
        "Sometimes a Great Notion"
      ],
      "Year": "1970",
      "Director": "Paul Newman",
      "DirectorArray": [
        "Paul Newman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3137",
      "databaseFilmTitle": "Somewhere",
      "FilmTitle": "Somewhere",
      "AlternateTitle": "",
      "TitleArray": [
        "Somewhere"
      ],
      "Year": "2010",
      "Director": "Sofia Coppola",
      "DirectorArray": [
        "Sofia Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3138",
      "databaseFilmTitle": "Somewhere, Someone",
      "FilmTitle": "Somewhere, Someone",
      "AlternateTitle": "Quelque part quelqu'un",
      "TitleArray": [
        "Somewhere, Someone",
        "Quelque part quelqu'un"
      ],
      "Year": "1972",
      "Director": "Yannick Bellon",
      "DirectorArray": [
        "Yannick Bellon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3139",
      "databaseFilmTitle": "Son nom de Venise dans Calcutta désert",
      "FilmTitle": "Son nom de Venise dans Calcutta désert",
      "AlternateTitle": "",
      "TitleArray": [
        "Son nom de Venise dans Calcutta désert"
      ],
      "Year": "1976",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3140",
      "databaseFilmTitle": "Son of Saul",
      "FilmTitle": "Son of Saul",
      "AlternateTitle": "Saul fia",
      "TitleArray": [
        "Son of Saul",
        "Saul fia"
      ],
      "Year": "2015",
      "Director": "László Nemes",
      "DirectorArray": [
        "László Nemes"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3141",
      "databaseFilmTitle": "Sonatine",
      "FilmTitle": "Sonatine",
      "AlternateTitle": "",
      "TitleArray": [
        "Sonatine"
      ],
      "Year": "1993",
      "Director": "Takeshi Kitano",
      "DirectorArray": [
        "Takeshi Kitano"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3142",
      "databaseFilmTitle": "Song and Solitude",
      "FilmTitle": "Song and Solitude",
      "AlternateTitle": "",
      "TitleArray": [
        "Song and Solitude"
      ],
      "Year": "2006",
      "Director": "Nathaniel Dorsky",
      "DirectorArray": [
        "Nathaniel Dorsky"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3143",
      "databaseFilmTitle": "Song of the Exile",
      "FilmTitle": "Song of the Exile",
      "AlternateTitle": "Ke tu qiu hen",
      "TitleArray": [
        "Song of the Exile",
        "Ke tu qiu hen"
      ],
      "Year": "1990",
      "Director": "Ann Hui",
      "DirectorArray": [
        "Ann Hui"
      ],
      "Country": "Taiwan, Hong Kong",
      "CountryArray": [
        "Taiwan",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3144",
      "databaseFilmTitle": "Song of the Sea",
      "FilmTitle": "Song of the Sea",
      "AlternateTitle": "",
      "TitleArray": [
        "Song of the Sea"
      ],
      "Year": "2014",
      "Director": "Tomm Moore",
      "DirectorArray": [
        "Tomm Moore"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3145",
      "databaseFilmTitle": "Songs from the Second Floor",
      "FilmTitle": "Songs from the Second Floor",
      "AlternateTitle": "Sånger från andra våningen",
      "TitleArray": [
        "Songs from the Second Floor",
        "Sånger från andra våningen"
      ],
      "Year": "2000",
      "Director": "Roy Andersson",
      "DirectorArray": [
        "Roy Andersson"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3146",
      "databaseFilmTitle": "Sons of the Desert",
      "FilmTitle": "Sons of the Desert",
      "AlternateTitle": "",
      "TitleArray": [
        "Sons of the Desert"
      ],
      "Year": "1933",
      "Director": "William A. Seiter",
      "DirectorArray": [
        "William A. Seiter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3147",
      "databaseFilmTitle": "Sophie's Choice",
      "FilmTitle": "Sophie's Choice",
      "AlternateTitle": "",
      "TitleArray": [
        "Sophie's Choice"
      ],
      "Year": "1982",
      "Director": "Alan J. Pakula",
      "DirectorArray": [
        "Alan J. Pakula"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3148",
      "databaseFilmTitle": "Sopyonje",
      "FilmTitle": "Sopyonje",
      "AlternateTitle": "",
      "TitleArray": [
        "Sopyonje"
      ],
      "Year": "1993",
      "Director": "Im Kwon-taek",
      "DirectorArray": [
        "Im Kwon-taek"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3149",
      "databaseFilmTitle": "Sorcerer",
      "FilmTitle": "Sorcerer",
      "AlternateTitle": "",
      "TitleArray": [
        "Sorcerer"
      ],
      "Year": "1977",
      "Director": "William Friedkin",
      "DirectorArray": [
        "William Friedkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3150",
      "databaseFilmTitle": "Sorry to Bother You",
      "FilmTitle": "Sorry to Bother You",
      "AlternateTitle": "",
      "TitleArray": [
        "Sorry to Bother You"
      ],
      "Year": "2018",
      "Director": "Boots Riley",
      "DirectorArray": [
        "Boots Riley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3151",
      "databaseFilmTitle": "Soul in the Eye",
      "FilmTitle": "Soul in the Eye",
      "AlternateTitle": "Alma no olho",
      "TitleArray": [
        "Soul in the Eye",
        "Alma no olho"
      ],
      "Year": "1973",
      "Director": "Zózimo Bulbul",
      "DirectorArray": [
        "Zózimo Bulbul"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3152",
      "databaseFilmTitle": "Sound and Fury",
      "FilmTitle": "Sound and Fury",
      "AlternateTitle": "De bruit et de fureur",
      "TitleArray": [
        "Sound and Fury",
        "De bruit et de fureur"
      ],
      "Year": "1988",
      "Director": "Jean-Claude Brisseau",
      "DirectorArray": [
        "Jean-Claude Brisseau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3153",
      "databaseFilmTitle": "Sound in the Mist",
      "FilmTitle": "Sound in the Mist",
      "AlternateTitle": "Kiri no oto",
      "TitleArray": [
        "Sound in the Mist",
        "Kiri no oto"
      ],
      "Year": "1957",
      "Director": "Hiroshi Shimizu",
      "DirectorArray": [
        "Hiroshi Shimizu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3154",
      "databaseFilmTitle": "Sound of the Mountain",
      "FilmTitle": "Sound of the Mountain",
      "AlternateTitle": "Yama no oto",
      "TitleArray": [
        "Sound of the Mountain",
        "Yama no oto"
      ],
      "Year": "1954",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3155",
      "databaseFilmTitle": "Soundtrack",
      "FilmTitle": "Soundtrack",
      "AlternateTitle": "",
      "TitleArray": [
        "Soundtrack"
      ],
      "Year": "1969",
      "Director": "Barry J. Spinello",
      "DirectorArray": [
        "Barry J. Spinello"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3156",
      "databaseFilmTitle": "South",
      "FilmTitle": "South",
      "AlternateTitle": "Sud",
      "TitleArray": [
        "South",
        "Sud"
      ],
      "Year": "1993",
      "Director": "Gabriele Salvatores",
      "DirectorArray": [
        "Gabriele Salvatores"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3157",
      "databaseFilmTitle": "Southland Tales",
      "FilmTitle": "Southland Tales",
      "AlternateTitle": "",
      "TitleArray": [
        "Southland Tales"
      ],
      "Year": "2006",
      "Director": "Richard Kelly",
      "DirectorArray": [
        "Richard Kelly"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3158",
      "databaseFilmTitle": "Spacy",
      "FilmTitle": "Spacy",
      "AlternateTitle": "",
      "TitleArray": [
        "Spacy"
      ],
      "Year": "1981",
      "Director": "Takashi Itô",
      "DirectorArray": [
        "Takashi Itô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3159",
      "databaseFilmTitle": "Spare Time",
      "FilmTitle": "Spare Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Spare Time"
      ],
      "Year": "1939",
      "Director": "Humphrey Jennings",
      "DirectorArray": [
        "Humphrey Jennings"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3160",
      "databaseFilmTitle": "Spartacus (1960)",
      "FilmTitle": "Spartacus",
      "AlternateTitle": "",
      "TitleArray": [
        "Spartacus"
      ],
      "Year": "1960",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3161",
      "databaseFilmTitle": "Spartacus (2010)",
      "FilmTitle": "Spartacus",
      "AlternateTitle": "",
      "TitleArray": [
        "Spartacus"
      ],
      "Year": "2010-2013",
      "Director": "Steven S. DeKnight",
      "DirectorArray": [
        "Steven S. DeKnight"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3162",
      "databaseFilmTitle": "Speak Up",
      "FilmTitle": "Speak Up",
      "AlternateTitle": "Ouvrir la voix",
      "TitleArray": [
        "Speak Up",
        "Ouvrir la voix"
      ],
      "Year": "2017",
      "Director": "Amandine Gay",
      "DirectorArray": [
        "Amandine Gay"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3163",
      "databaseFilmTitle": "Spectrum Reverse Spectrum",
      "FilmTitle": "Spectrum Reverse Spectrum",
      "AlternateTitle": "",
      "TitleArray": [
        "Spectrum Reverse Spectrum"
      ],
      "Year": "2014",
      "Director": "Margaret Honda",
      "DirectorArray": [
        "Margaret Honda"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3164",
      "databaseFilmTitle": "Speed Racer",
      "FilmTitle": "Speed Racer",
      "AlternateTitle": "",
      "TitleArray": [
        "Speed Racer"
      ],
      "Year": "2008",
      "Director": "Lilly Wachowski, Lana Wachowski",
      "DirectorArray": [
        "Lilly Wachowski",
        "Lana Wachowski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3165",
      "databaseFilmTitle": "Spellbound",
      "FilmTitle": "Spellbound",
      "AlternateTitle": "",
      "TitleArray": [
        "Spellbound"
      ],
      "Year": "1945",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3166",
      "databaseFilmTitle": "Spend It All",
      "FilmTitle": "Spend It All",
      "AlternateTitle": "",
      "TitleArray": [
        "Spend It All"
      ],
      "Year": "1971",
      "Director": "Les Blank",
      "DirectorArray": [
        "Les Blank"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3167",
      "databaseFilmTitle": "Spicebush",
      "FilmTitle": "Spicebush",
      "AlternateTitle": "",
      "TitleArray": [
        "Spicebush"
      ],
      "Year": "2005",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3168",
      "databaseFilmTitle": "Spider",
      "FilmTitle": "Spider",
      "AlternateTitle": "",
      "TitleArray": [
        "Spider"
      ],
      "Year": "2002",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3169",
      "databaseFilmTitle": "Spider Forest",
      "FilmTitle": "Spider Forest",
      "AlternateTitle": "",
      "TitleArray": [
        "Spider Forest"
      ],
      "Year": "2004",
      "Director": "Song Il-gon",
      "DirectorArray": [
        "Song Il-gon"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3170",
      "databaseFilmTitle": "Spider-Man: Into the Spider-Verse",
      "FilmTitle": "Spider-Man: Into the Spider-Verse",
      "AlternateTitle": "",
      "TitleArray": [
        "Spider-Man: Into the Spider-Verse"
      ],
      "Year": "2018",
      "Director": "Bob Persichetti, Peter Ramsey, Rodney Rothman",
      "DirectorArray": [
        "Bob Persichetti",
        "Peter Ramsey",
        "Rodney Rothman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3171",
      "databaseFilmTitle": "Spies",
      "FilmTitle": "Spies",
      "AlternateTitle": "Spione",
      "TitleArray": [
        "Spies",
        "Spione"
      ],
      "Year": "1928",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3172",
      "databaseFilmTitle": "Spirited Away",
      "FilmTitle": "Spirited Away",
      "AlternateTitle": "Sen to chihiro no kamikakushi",
      "TitleArray": [
        "Spirited Away",
        "Sen to chihiro no kamikakushi"
      ],
      "Year": "2001",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "75",
      "2022votes": "36"
    },
    {
      "key": "3173",
      "databaseFilmTitle": "Spiritual Voices",
      "FilmTitle": "Spiritual Voices",
      "AlternateTitle": "",
      "TitleArray": [
        "Spiritual Voices"
      ],
      "Year": "1995",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3174",
      "databaseFilmTitle": "Splendor in the Grass",
      "FilmTitle": "Splendor in the Grass",
      "AlternateTitle": "",
      "TitleArray": [
        "Splendor in the Grass"
      ],
      "Year": "1961",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3175",
      "databaseFilmTitle": "Spoor",
      "FilmTitle": "Spoor",
      "AlternateTitle": "Pokot",
      "TitleArray": [
        "Spoor",
        "Pokot"
      ],
      "Year": "2017",
      "Director": "Agnieszka Holland",
      "DirectorArray": [
        "Agnieszka Holland"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3176",
      "databaseFilmTitle": "Spring in a Small Town",
      "FilmTitle": "Spring in a Small Town",
      "AlternateTitle": "Xiao cheng zhi chun",
      "TitleArray": [
        "Spring in a Small Town",
        "Xiao cheng zhi chun"
      ],
      "Year": "1948",
      "Director": "Mu Fei",
      "DirectorArray": [
        "Mu Fei"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "3177",
      "databaseFilmTitle": "Spring in the Forest",
      "FilmTitle": "Spring in the Forest",
      "AlternateTitle": "Ukuaru",
      "TitleArray": [
        "Spring in the Forest",
        "Ukuaru"
      ],
      "Year": "1973",
      "Director": "Leida Laius",
      "DirectorArray": [
        "Leida Laius"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3178",
      "databaseFilmTitle": "Spring Night, Summer Night",
      "FilmTitle": "Spring Night, Summer Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Spring Night, Summer Night"
      ],
      "Year": "1967",
      "Director": "Joseph L. Anderson",
      "DirectorArray": [
        "Joseph L. Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3179",
      "databaseFilmTitle": "Spring Shower",
      "FilmTitle": "Spring Shower",
      "AlternateTitle": "Tavaszi zápor",
      "TitleArray": [
        "Spring Shower",
        "Tavaszi zápor"
      ],
      "Year": "1932",
      "Director": "Pál Fejös",
      "DirectorArray": [
        "Pál Fejös"
      ],
      "Country": "France, Hungary",
      "CountryArray": [
        "France",
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3180",
      "databaseFilmTitle": "Spring, Summer, Fall, Winter... and Spring",
      "FilmTitle": "Spring, Summer, Fall, Winter... and Spring",
      "AlternateTitle": "",
      "TitleArray": [
        "Spring, Summer, Fall, Winter... and Spring"
      ],
      "Year": "2003",
      "Director": "Kim Ki-duk",
      "DirectorArray": [
        "Kim Ki-duk"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3181",
      "databaseFilmTitle": "Stagecoach",
      "FilmTitle": "Stagecoach",
      "AlternateTitle": "",
      "TitleArray": [
        "Stagecoach"
      ],
      "Year": "1939",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3182",
      "databaseFilmTitle": "Stalker",
      "FilmTitle": "Stalker",
      "AlternateTitle": "",
      "TitleArray": [
        "Stalker"
      ],
      "Year": "1979",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "29",
      "2012votes": "39",
      "2022rank": "43",
      "2022votes": "51"
    },
    {
      "key": "3183",
      "databaseFilmTitle": "Stand by Me",
      "FilmTitle": "Stand by Me",
      "AlternateTitle": "",
      "TitleArray": [
        "Stand by Me"
      ],
      "Year": "1986",
      "Director": "Rob Reiner",
      "DirectorArray": [
        "Rob Reiner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3184",
      "databaseFilmTitle": "Standard Gauge",
      "FilmTitle": "Standard Gauge",
      "AlternateTitle": "",
      "TitleArray": [
        "Standard Gauge"
      ],
      "Year": "1984",
      "Director": "Morgan Fisher",
      "DirectorArray": [
        "Morgan Fisher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3185",
      "databaseFilmTitle": "Star Spangled to Death",
      "FilmTitle": "Star Spangled to Death",
      "AlternateTitle": "",
      "TitleArray": [
        "Star Spangled to Death"
      ],
      "Year": "2003",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3186",
      "databaseFilmTitle": "Star Trek II: The Wrath of Khan",
      "FilmTitle": "Star Trek II: The Wrath of Khan",
      "AlternateTitle": "",
      "TitleArray": [
        "Star Trek II: The Wrath of Khan"
      ],
      "Year": "1982",
      "Director": "Nicholas Meyer",
      "DirectorArray": [
        "Nicholas Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3187",
      "databaseFilmTitle": "Star Wars: Episode IV - A New Hope",
      "FilmTitle": "Star Wars: Episode IV - A New Hope",
      "AlternateTitle": "Star Wars",
      "TitleArray": [
        "Star Wars: Episode IV - A New Hope",
        "Star Wars"
      ],
      "Year": "1977",
      "Director": "George Lucas",
      "DirectorArray": [
        "George Lucas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "3188",
      "databaseFilmTitle": "Star Wars: Episode V - The Empire Strikes Back",
      "FilmTitle": "Star Wars: Episode V - The Empire Strikes Back",
      "AlternateTitle": "",
      "TitleArray": [
        "Star Wars: Episode V - The Empire Strikes Back"
      ],
      "Year": "1980",
      "Director": "Irvin Kershner",
      "DirectorArray": [
        "Irvin Kershner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3189",
      "databaseFilmTitle": "Stardust Memories",
      "FilmTitle": "Stardust Memories",
      "AlternateTitle": "",
      "TitleArray": [
        "Stardust Memories"
      ],
      "Year": "1980",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3190",
      "databaseFilmTitle": "Stars in Broad Daylight",
      "FilmTitle": "Stars in Broad Daylight",
      "AlternateTitle": "Nujum al-Nahar",
      "TitleArray": [
        "Stars in Broad Daylight",
        "Nujum al-Nahar"
      ],
      "Year": "1988",
      "Director": "Ossama Mohammed",
      "DirectorArray": [
        "Ossama Mohammed"
      ],
      "Country": "Syria",
      "CountryArray": [
        "Syria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3191",
      "databaseFilmTitle": "Stars in My Crown",
      "FilmTitle": "Stars in My Crown",
      "AlternateTitle": "",
      "TitleArray": [
        "Stars in My Crown"
      ],
      "Year": "1950",
      "Director": "Jacques Tourneur",
      "DirectorArray": [
        "Jacques Tourneur"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3192",
      "databaseFilmTitle": "Starship Troopers",
      "FilmTitle": "Starship Troopers",
      "AlternateTitle": "",
      "TitleArray": [
        "Starship Troopers"
      ],
      "Year": "1997",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3193",
      "databaseFilmTitle": "Stations of the Elevated",
      "FilmTitle": "Stations of the Elevated",
      "AlternateTitle": "",
      "TitleArray": [
        "Stations of the Elevated"
      ],
      "Year": "1981",
      "Director": "Manfred Kirchheimer",
      "DirectorArray": [
        "Manfred Kirchheimer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3194",
      "databaseFilmTitle": "Statues Also Die",
      "FilmTitle": "Statues Also Die",
      "AlternateTitle": "Les statues meurent aussi",
      "TitleArray": [
        "Statues Also Die",
        "Les statues meurent aussi"
      ],
      "Year": "1953",
      "Director": "Chris Marker, Alain Resnais",
      "DirectorArray": [
        "Chris Marker",
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3195",
      "databaseFilmTitle": "Steak",
      "FilmTitle": "Steak",
      "AlternateTitle": "",
      "TitleArray": [
        "Steak"
      ],
      "Year": "2007",
      "Director": "Quentin Dupieux",
      "DirectorArray": [
        "Quentin Dupieux"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3196",
      "databaseFilmTitle": "Steamboat Bill Jr.",
      "FilmTitle": "Steamboat Bill Jr.",
      "AlternateTitle": "",
      "TitleArray": [
        "Steamboat Bill Jr."
      ],
      "Year": "1928",
      "Director": "Buster Keaton, Charles Reisner",
      "DirectorArray": [
        "Buster Keaton",
        "Charles Reisner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3197",
      "databaseFilmTitle": "Steamboat Willie",
      "FilmTitle": "Steamboat Willie",
      "AlternateTitle": "",
      "TitleArray": [
        "Steamboat Willie"
      ],
      "Year": "1928",
      "Director": "Ub Iwerks",
      "DirectorArray": [
        "Ub Iwerks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3198",
      "databaseFilmTitle": "Stella",
      "FilmTitle": "Stella",
      "AlternateTitle": "",
      "TitleArray": [
        "Stella"
      ],
      "Year": "2008",
      "Director": "Sylvie Verheyde",
      "DirectorArray": [
        "Sylvie Verheyde"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3199",
      "databaseFilmTitle": "Stella Dallas",
      "FilmTitle": "Stella Dallas",
      "AlternateTitle": "",
      "TitleArray": [
        "Stella Dallas"
      ],
      "Year": "1937",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3200",
      "databaseFilmTitle": "Stephen",
      "FilmTitle": "Stephen",
      "AlternateTitle": "Esthappan",
      "TitleArray": [
        "Stephen",
        "Esthappan"
      ],
      "Year": "1980",
      "Director": "Govindan Aravindan",
      "DirectorArray": [
        "Govindan Aravindan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3201",
      "databaseFilmTitle": "Still",
      "FilmTitle": "Still",
      "AlternateTitle": "",
      "TitleArray": [
        "Still"
      ],
      "Year": "1969",
      "Director": "Ernie Gehr",
      "DirectorArray": [
        "Ernie Gehr"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3202",
      "databaseFilmTitle": "Still Life (1974)",
      "FilmTitle": "Still Life",
      "AlternateTitle": "Tabiate bijan",
      "TitleArray": [
        "Still Life",
        "Tabiate bijan"
      ],
      "Year": "1974",
      "Director": "Sohrab Shahid Saless",
      "DirectorArray": [
        "Sohrab Shahid Saless"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3203",
      "databaseFilmTitle": "Still Life (2006)",
      "FilmTitle": "Still Life",
      "AlternateTitle": "San xia hao ren",
      "TitleArray": [
        "Still Life",
        "San xia hao ren"
      ],
      "Year": "2006",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3204",
      "databaseFilmTitle": "Still Sound",
      "FilmTitle": "Still Sound",
      "AlternateTitle": "Stendalì - Suonano ancora",
      "TitleArray": [
        "Still Sound",
        "Stendalì - Suonano ancora"
      ],
      "Year": "1960",
      "Director": "Cecilia Mangini",
      "DirectorArray": [
        "Cecilia Mangini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3205",
      "databaseFilmTitle": "Still the Water",
      "FilmTitle": "Still the Water",
      "AlternateTitle": "Futatsume no mado",
      "TitleArray": [
        "Still the Water",
        "Futatsume no mado"
      ],
      "Year": "2014",
      "Director": "Naomi Kawase",
      "DirectorArray": [
        "Naomi Kawase"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3206",
      "databaseFilmTitle": "Still Walking",
      "FilmTitle": "Still Walking",
      "AlternateTitle": "Aruitemo aruitemo",
      "TitleArray": [
        "Still Walking",
        "Aruitemo aruitemo"
      ],
      "Year": "2008",
      "Director": "Hirokazu Koreeda",
      "DirectorArray": [
        "Hirokazu Koreeda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3207",
      "databaseFilmTitle": "Still/here",
      "FilmTitle": "Still/here",
      "AlternateTitle": "",
      "TitleArray": [
        "Still/here"
      ],
      "Year": "2001",
      "Director": "Christopher Harris",
      "DirectorArray": [
        "Christopher Harris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3208",
      "databaseFilmTitle": "Stop Genocide",
      "FilmTitle": "Stop Genocide",
      "AlternateTitle": "",
      "TitleArray": [
        "Stop Genocide"
      ],
      "Year": "1971",
      "Director": "Zahir Raihan",
      "DirectorArray": [
        "Zahir Raihan"
      ],
      "Country": "Bangladesh",
      "CountryArray": [
        "Bangladesh"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3209",
      "databaseFilmTitle": "Stop Making Sense",
      "FilmTitle": "Stop Making Sense",
      "AlternateTitle": "",
      "TitleArray": [
        "Stop Making Sense"
      ],
      "Year": "1984",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3210",
      "databaseFilmTitle": "Stories We Tell",
      "FilmTitle": "Stories We Tell",
      "AlternateTitle": "",
      "TitleArray": [
        "Stories We Tell"
      ],
      "Year": "2012",
      "Director": "Sarah Polley",
      "DirectorArray": [
        "Sarah Polley"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3211",
      "databaseFilmTitle": "Storm",
      "FilmTitle": "Storm",
      "AlternateTitle": "Orage",
      "TitleArray": [
        "Storm",
        "Orage"
      ],
      "Year": "1938",
      "Director": "Marc Allégret",
      "DirectorArray": [
        "Marc Allégret"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3212",
      "databaseFilmTitle": "Storm Over Asia",
      "FilmTitle": "Storm Over Asia",
      "AlternateTitle": "",
      "TitleArray": [
        "Storm Over Asia"
      ],
      "Year": "1928",
      "Director": "Vsevolod Pudovkin",
      "DirectorArray": [
        "Vsevolod Pudovkin"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3213",
      "databaseFilmTitle": "Stormy Waters",
      "FilmTitle": "Stormy Waters",
      "AlternateTitle": "Remorques",
      "TitleArray": [
        "Stormy Waters",
        "Remorques"
      ],
      "Year": "1941",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3214",
      "databaseFilmTitle": "Stormy Weather",
      "FilmTitle": "Stormy Weather",
      "AlternateTitle": "",
      "TitleArray": [
        "Stormy Weather"
      ],
      "Year": "1943",
      "Director": "Andrew L. Stone",
      "DirectorArray": [
        "Andrew L. Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3215",
      "databaseFilmTitle": "Story of a Love Affair",
      "FilmTitle": "Story of a Love Affair",
      "AlternateTitle": "Cronana di un amore",
      "TitleArray": [
        "Story of a Love Affair",
        "Cronana di un amore"
      ],
      "Year": "1950",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3216",
      "databaseFilmTitle": "Strange Days",
      "FilmTitle": "Strange Days",
      "AlternateTitle": "",
      "TitleArray": [
        "Strange Days"
      ],
      "Year": "1995",
      "Director": "Kathryn Bigelow",
      "DirectorArray": [
        "Kathryn Bigelow"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3217",
      "databaseFilmTitle": "Stranger by the Lake",
      "FilmTitle": "Stranger by the Lake",
      "AlternateTitle": "L'inconnu du lac",
      "TitleArray": [
        "Stranger by the Lake",
        "L'inconnu du lac"
      ],
      "Year": "2013",
      "Director": "Alain Guiraudie",
      "DirectorArray": [
        "Alain Guiraudie"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3218",
      "databaseFilmTitle": "Stranger than Paradise",
      "FilmTitle": "Stranger than Paradise",
      "AlternateTitle": "",
      "TitleArray": [
        "Stranger than Paradise"
      ],
      "Year": "1984",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3219",
      "databaseFilmTitle": "Strangers in Good Company",
      "FilmTitle": "Strangers in Good Company",
      "AlternateTitle": "",
      "TitleArray": [
        "Strangers in Good Company"
      ],
      "Year": "1990",
      "Director": "Cynthia Scott",
      "DirectorArray": [
        "Cynthia Scott"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3220",
      "databaseFilmTitle": "Strangers on a Train",
      "FilmTitle": "Strangers on a Train",
      "AlternateTitle": "",
      "TitleArray": [
        "Strangers on a Train"
      ],
      "Year": "1951",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3221",
      "databaseFilmTitle": "Strangers When We Meet",
      "FilmTitle": "Strangers When We Meet",
      "AlternateTitle": "",
      "TitleArray": [
        "Strangers When We Meet"
      ],
      "Year": "1960",
      "Director": "Richard Quine",
      "DirectorArray": [
        "Richard Quine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3222",
      "databaseFilmTitle": "Straw Dogs",
      "FilmTitle": "Straw Dogs",
      "AlternateTitle": "",
      "TitleArray": [
        "Straw Dogs"
      ],
      "Year": "1971",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3223",
      "databaseFilmTitle": "Strawberry and Chocolate",
      "FilmTitle": "Strawberry and Chocolate",
      "AlternateTitle": "Fresa y chocholate",
      "TitleArray": [
        "Strawberry and Chocolate",
        "Fresa y chocholate"
      ],
      "Year": "1992",
      "Director": "Tomás Gutiérrez Alea, Juan Carlos Tabío",
      "DirectorArray": [
        "Tomás Gutiérrez Alea",
        "Juan Carlos Tabío"
      ],
      "Country": "Cuba, Mexico",
      "CountryArray": [
        "Cuba",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3224",
      "databaseFilmTitle": "Stray Dogs",
      "FilmTitle": "Stray Dogs",
      "AlternateTitle": "",
      "TitleArray": [
        "Stray Dogs"
      ],
      "Year": "2013",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan, France",
      "CountryArray": [
        "Taiwan",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3225",
      "databaseFilmTitle": "Street Angel",
      "FilmTitle": "Street Angel",
      "AlternateTitle": "",
      "TitleArray": [
        "Street Angel"
      ],
      "Year": "1928",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3226",
      "databaseFilmTitle": "Street of Crocodiles",
      "FilmTitle": "Street of Crocodiles",
      "AlternateTitle": "",
      "TitleArray": [
        "Street of Crocodiles"
      ],
      "Year": "1986",
      "Director": "Stephen Quay, Timothy Quay",
      "DirectorArray": [
        "Stephen Quay",
        "Timothy Quay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3227",
      "databaseFilmTitle": "Street of Shame",
      "FilmTitle": "Street of Shame",
      "AlternateTitle": "Akasen chitai",
      "TitleArray": [
        "Street of Shame",
        "Akasen chitai"
      ],
      "Year": "1956",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3228",
      "databaseFilmTitle": "Strictly Ballroom",
      "FilmTitle": "Strictly Ballroom",
      "AlternateTitle": "",
      "TitleArray": [
        "Strictly Ballroom"
      ],
      "Year": "1992",
      "Director": "Baz Luhrmann",
      "DirectorArray": [
        "Baz Luhrmann"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3229",
      "databaseFilmTitle": "Strike",
      "FilmTitle": "Strike",
      "AlternateTitle": "Stachka",
      "TitleArray": [
        "Strike",
        "Stachka"
      ],
      "Year": "1925",
      "Director": "Sergei Eisenstein",
      "DirectorArray": [
        "Sergei Eisenstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3230",
      "databaseFilmTitle": "Stromboli",
      "FilmTitle": "Stromboli",
      "AlternateTitle": "Stromboli, Terra di Dio",
      "TitleArray": [
        "Stromboli",
        "Stromboli, Terra di Dio"
      ],
      "Year": "1950",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3231",
      "databaseFilmTitle": "Strong Island",
      "FilmTitle": "Strong Island",
      "AlternateTitle": "",
      "TitleArray": [
        "Strong Island"
      ],
      "Year": "2017",
      "Director": "Yance Ford",
      "DirectorArray": [
        "Yance Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3232",
      "databaseFilmTitle": "Stroszek",
      "FilmTitle": "Stroszek",
      "AlternateTitle": "",
      "TitleArray": [
        "Stroszek"
      ],
      "Year": "1977",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3233",
      "databaseFilmTitle": "Struggle in Italy",
      "FilmTitle": "Struggle in Italy",
      "AlternateTitle": "Lotte in Italia",
      "TitleArray": [
        "Struggle in Italy",
        "Lotte in Italia"
      ],
      "Year": "1970",
      "Director": "Groupe Dziga Vertov, Jean-Luc Godard, Jean-Pierre Gorin",
      "DirectorArray": [
        "Groupe Dziga Vertov",
        "Jean-Luc Godard",
        "Jean-Pierre Gorin"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3234",
      "databaseFilmTitle": "Stud Life",
      "FilmTitle": "Stud Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Stud Life"
      ],
      "Year": "2012",
      "Director": "Campbell X",
      "DirectorArray": [
        "Campbell X"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3235",
      "databaseFilmTitle": "Study of a River",
      "FilmTitle": "Study of a River",
      "AlternateTitle": "",
      "TitleArray": [
        "Study of a River"
      ],
      "Year": "1997",
      "Director": "Peter Hutton",
      "DirectorArray": [
        "Peter Hutton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3236",
      "databaseFilmTitle": "Successive Slidings of Pleasure",
      "FilmTitle": "Successive Slidings of Pleasure",
      "AlternateTitle": "Glissements progressifs du plaisir",
      "TitleArray": [
        "Successive Slidings of Pleasure",
        "Glissements progressifs du plaisir"
      ],
      "Year": "1974",
      "Director": "Alain Robbe-Grillet",
      "DirectorArray": [
        "Alain Robbe-Grillet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3237",
      "databaseFilmTitle": "Succubus",
      "FilmTitle": "Succubus",
      "AlternateTitle": "Necronomicon - Geträumte Sünden",
      "TitleArray": [
        "Succubus",
        "Necronomicon - Geträumte Sünden"
      ],
      "Year": "1968",
      "Director": "Jesús Franco",
      "DirectorArray": [
        "Jesús Franco"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3238",
      "databaseFilmTitle": "Sugar Cane Alley",
      "FilmTitle": "Sugar Cane Alley",
      "AlternateTitle": "Rue Cases Nègres",
      "TitleArray": [
        "Sugar Cane Alley",
        "Rue Cases Nègres"
      ],
      "Year": "1983",
      "Director": "Euzhan Palcy",
      "DirectorArray": [
        "Euzhan Palcy"
      ],
      "Country": "Martinique, France",
      "CountryArray": [
        "Martinique",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3239",
      "databaseFilmTitle": "Sullivan's Travels",
      "FilmTitle": "Sullivan's Travels",
      "AlternateTitle": "",
      "TitleArray": [
        "Sullivan's Travels"
      ],
      "Year": "1941",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "3240",
      "databaseFilmTitle": "Summer Holiday",
      "FilmTitle": "Summer Holiday",
      "AlternateTitle": "",
      "TitleArray": [
        "Summer Holiday"
      ],
      "Year": "1963",
      "Director": "Peter Yates",
      "DirectorArray": [
        "Peter Yates"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3241",
      "databaseFilmTitle": "Summer Hours",
      "FilmTitle": "Summer Hours",
      "AlternateTitle": "L'heure d'été",
      "TitleArray": [
        "Summer Hours",
        "L'heure d'été"
      ],
      "Year": "2008",
      "Director": "Olivier Assayas",
      "DirectorArray": [
        "Olivier Assayas"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3242",
      "databaseFilmTitle": "Summer in Narita",
      "FilmTitle": "Summer in Narita",
      "AlternateTitle": "Nihon Kaiho sensen: Sanrizuka no natsu",
      "TitleArray": [
        "Summer in Narita",
        "Nihon Kaiho sensen: Sanrizuka no natsu"
      ],
      "Year": "1968",
      "Director": "Shinsuke Ogawa",
      "DirectorArray": [
        "Shinsuke Ogawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3243",
      "databaseFilmTitle": "Summer with Monika",
      "FilmTitle": "Summer with Monika",
      "AlternateTitle": "Sommaren med Monika",
      "TitleArray": [
        "Summer with Monika",
        "Sommaren med Monika"
      ],
      "Year": "1953",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3244",
      "databaseFilmTitle": "Sun in the Last Days of the Shogunate",
      "FilmTitle": "Sun in the Last Days of the Shogunate",
      "AlternateTitle": "Bakumatsu taiyôden",
      "TitleArray": [
        "Sun in the Last Days of the Shogunate",
        "Bakumatsu taiyôden"
      ],
      "Year": "1957",
      "Director": "Yûzô Kawashima",
      "DirectorArray": [
        "Yûzô Kawashima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3245",
      "databaseFilmTitle": "Sun Stop!",
      "FilmTitle": "Sun Stop!",
      "AlternateTitle": "Sonne halt!",
      "TitleArray": [
        "Sun Stop!",
        "Sonne halt!"
      ],
      "Year": "1962",
      "Director": "Ferry Radax",
      "DirectorArray": [
        "Ferry Radax"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3246",
      "databaseFilmTitle": "Sundays and Cybele",
      "FilmTitle": "Sundays and Cybele",
      "AlternateTitle": "Les dimanches de Ville d'Avray",
      "TitleArray": [
        "Sundays and Cybele",
        "Les dimanches de Ville d'Avray"
      ],
      "Year": "1962",
      "Director": "Serge Bourguignon",
      "DirectorArray": [
        "Serge Bourguignon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3247",
      "databaseFilmTitle": "Sunrise: A Song of Two Humans",
      "FilmTitle": "Sunrise: A Song of Two Humans",
      "AlternateTitle": "",
      "TitleArray": [
        "Sunrise: A Song of Two Humans"
      ],
      "Year": "1927",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "17",
      "1962votes": "9",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "17",
      "1982votes": "8",
      "1992rank": "11",
      "1992votes": "10",
      "2002rank": "6",
      "2002votes": "19",
      "2012rank": "5",
      "2012votes": "93",
      "2022rank": "11",
      "2022votes": "98"
    },
    {
      "key": "3248",
      "databaseFilmTitle": "Sunset",
      "FilmTitle": "Sunset",
      "AlternateTitle": "Napszállta",
      "TitleArray": [
        "Sunset",
        "Napszállta"
      ],
      "Year": "2018",
      "Director": "László Nemes",
      "DirectorArray": [
        "László Nemes"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3249",
      "databaseFilmTitle": "Sunset Blvd.",
      "FilmTitle": "Sunset Blvd.",
      "AlternateTitle": "",
      "TitleArray": [
        "Sunset Blvd."
      ],
      "Year": "1950",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "78",
      "2022votes": "35"
    },
    {
      "key": "3250",
      "databaseFilmTitle": "Super Fly",
      "FilmTitle": "Super Fly",
      "AlternateTitle": "",
      "TitleArray": [
        "Super Fly"
      ],
      "Year": "1972",
      "Director": "Gordon Parks Jr.",
      "DirectorArray": [
        "Gordon Parks Jr."
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3251",
      "databaseFilmTitle": "Superdyke Meets Madame X",
      "FilmTitle": "Superdyke Meets Madame X",
      "AlternateTitle": "",
      "TitleArray": [
        "Superdyke Meets Madame X"
      ],
      "Year": "1975",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3252",
      "databaseFilmTitle": "Superman",
      "FilmTitle": "Superman",
      "AlternateTitle": "",
      "TitleArray": [
        "Superman"
      ],
      "Year": "1978",
      "Director": "Richard Donner",
      "DirectorArray": [
        "Richard Donner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3253",
      "databaseFilmTitle": "Supermen of Malegaon",
      "FilmTitle": "Supermen of Malegaon",
      "AlternateTitle": "",
      "TitleArray": [
        "Supermen of Malegaon"
      ],
      "Year": "2008",
      "Director": "Faiza Ahmad Khan",
      "DirectorArray": [
        "Faiza Ahmad Khan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3254",
      "databaseFilmTitle": "Superstar: The Karen Carpenter Story",
      "FilmTitle": "Superstar: The Karen Carpenter Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Superstar: The Karen Carpenter Story"
      ],
      "Year": "1988",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3255",
      "databaseFilmTitle": "Supervixens",
      "FilmTitle": "Supervixens",
      "AlternateTitle": "",
      "TitleArray": [
        "Supervixens"
      ],
      "Year": "1975",
      "Director": "Russ Meyer",
      "DirectorArray": [
        "Russ Meyer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3256",
      "databaseFilmTitle": "Survival in New York",
      "FilmTitle": "Survival in New York",
      "AlternateTitle": "Überleben in New York",
      "TitleArray": [
        "Survival in New York",
        "Überleben in New York"
      ],
      "Year": "1989",
      "Director": "Rosa von Praunheim",
      "DirectorArray": [
        "Rosa von Praunheim"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3257",
      "databaseFilmTitle": "Surviving Life (Theory and Practice)",
      "FilmTitle": "Surviving Life (Theory and Practice)",
      "AlternateTitle": "Přežít svůj život",
      "TitleArray": [
        "Surviving Life (Theory and Practice)",
        "Přežít svůj život"
      ],
      "Year": "2010",
      "Director": "Jan Švankmajer",
      "DirectorArray": [
        "Jan Švankmajer"
      ],
      "Country": "Czech Republic, Slovakia",
      "CountryArray": [
        "Czech Republic",
        "Slovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3258",
      "databaseFilmTitle": "Susana",
      "FilmTitle": "Susana",
      "AlternateTitle": "",
      "TitleArray": [
        "Susana"
      ],
      "Year": "1951",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3259",
      "databaseFilmTitle": "Suspense",
      "FilmTitle": "Suspense",
      "AlternateTitle": "",
      "TitleArray": [
        "Suspense"
      ],
      "Year": "1913",
      "Director": "Phillips Smalley, Lois Weber",
      "DirectorArray": [
        "Phillips Smalley",
        "Lois Weber"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3260",
      "databaseFilmTitle": "Suspiria",
      "FilmTitle": "Suspiria",
      "AlternateTitle": "",
      "TitleArray": [
        "Suspiria"
      ],
      "Year": "1977",
      "Director": "Dario Argento",
      "DirectorArray": [
        "Dario Argento"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "3261",
      "databaseFilmTitle": "Suture",
      "FilmTitle": "Suture",
      "AlternateTitle": "",
      "TitleArray": [
        "Suture"
      ],
      "Year": "1993",
      "Director": "Scott McGehee, David Siegel",
      "DirectorArray": [
        "Scott McGehee",
        "David Siegel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3262",
      "databaseFilmTitle": "Suzanne, Suzanne",
      "FilmTitle": "Suzanne, Suzanne",
      "AlternateTitle": "",
      "TitleArray": [
        "Suzanne, Suzanne"
      ],
      "Year": "1982",
      "Director": "Camille Billops, James Hatch",
      "DirectorArray": [
        "Camille Billops",
        "James Hatch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3263",
      "databaseFilmTitle": "Sweeney Todd: The Demon Barber of Fleet Street",
      "FilmTitle": "Sweeney Todd: The Demon Barber of Fleet Street",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweeney Todd: The Demon Barber of Fleet Street"
      ],
      "Year": "2007",
      "Director": "Tim Burton",
      "DirectorArray": [
        "Tim Burton"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3264",
      "databaseFilmTitle": "Sweet Country",
      "FilmTitle": "Sweet Country",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweet Country"
      ],
      "Year": "2017",
      "Director": "Warwick Thornton",
      "DirectorArray": [
        "Warwick Thornton"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3265",
      "databaseFilmTitle": "Sweet Deceptions",
      "FilmTitle": "Sweet Deceptions",
      "AlternateTitle": "I dolci inganni",
      "TitleArray": [
        "Sweet Deceptions",
        "I dolci inganni"
      ],
      "Year": "1960",
      "Director": "Alberto Lattuada",
      "DirectorArray": [
        "Alberto Lattuada"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3266",
      "databaseFilmTitle": "Sweet Movie",
      "FilmTitle": "Sweet Movie",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweet Movie"
      ],
      "Year": "1974",
      "Director": "Dušan Makavejev",
      "DirectorArray": [
        "Dušan Makavejev"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3267",
      "databaseFilmTitle": "Sweet Smell of Success",
      "FilmTitle": "Sweet Smell of Success",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweet Smell of Success"
      ],
      "Year": "1957",
      "Director": "Aledander Mackendrick",
      "DirectorArray": [
        "Aledander Mackendrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3268",
      "databaseFilmTitle": "Sweet Sweetback's Baadasssss Song",
      "FilmTitle": "Sweet Sweetback's Baadasssss Song",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweet Sweetback's Baadasssss Song"
      ],
      "Year": "1971",
      "Director": "Melvin Van Peebles",
      "DirectorArray": [
        "Melvin Van Peebles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3269",
      "databaseFilmTitle": "Sweetie",
      "FilmTitle": "Sweetie",
      "AlternateTitle": "",
      "TitleArray": [
        "Sweetie"
      ],
      "Year": "1989",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3270",
      "databaseFilmTitle": "Swept Away",
      "FilmTitle": "Swept Away",
      "AlternateTitle": "Travolti da un insolito destino nell'azzurro mare d'agosto",
      "TitleArray": [
        "Swept Away",
        "Travolti da un insolito destino nell'azzurro mare d'agosto"
      ],
      "Year": "1974",
      "Director": "Lina Wertmüller",
      "DirectorArray": [
        "Lina Wertmüller"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3271",
      "databaseFilmTitle": "Swimming to Cambodia",
      "FilmTitle": "Swimming to Cambodia",
      "AlternateTitle": "",
      "TitleArray": [
        "Swimming to Cambodia"
      ],
      "Year": "1987",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3272",
      "databaseFilmTitle": "Swing Shift",
      "FilmTitle": "Swing Shift",
      "AlternateTitle": "",
      "TitleArray": [
        "Swing Shift"
      ],
      "Year": "1984",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3273",
      "databaseFilmTitle": "Swing Time",
      "FilmTitle": "Swing Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Swing Time"
      ],
      "Year": "1936",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3274",
      "databaseFilmTitle": "Switchmen",
      "FilmTitle": "Switchmen",
      "AlternateTitle": "Rangierer",
      "TitleArray": [
        "Switchmen",
        "Rangierer"
      ],
      "Year": "1984",
      "Director": "Jürgen Böttcher",
      "DirectorArray": [
        "Jürgen Böttcher"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3275",
      "databaseFilmTitle": "Sylvester",
      "FilmTitle": "Sylvester",
      "AlternateTitle": "",
      "TitleArray": [
        "Sylvester"
      ],
      "Year": "1985",
      "Director": "Tim Hunter",
      "DirectorArray": [
        "Tim Hunter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3276",
      "databaseFilmTitle": "Sylvia Scarlett",
      "FilmTitle": "Sylvia Scarlett",
      "AlternateTitle": "",
      "TitleArray": [
        "Sylvia Scarlett"
      ],
      "Year": "1935",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3277",
      "databaseFilmTitle": "Sylvie",
      "FilmTitle": "Sylvie",
      "AlternateTitle": "",
      "TitleArray": [
        "Sylvie"
      ],
      "Year": "1973",
      "Director": "Klaus Lemke",
      "DirectorArray": [
        "Klaus Lemke"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3278",
      "databaseFilmTitle": "Symbiopsychotaxiplasm: Take One",
      "FilmTitle": "Symbiopsychotaxiplasm: Take One",
      "AlternateTitle": "",
      "TitleArray": [
        "Symbiopsychotaxiplasm: Take One"
      ],
      "Year": "1968",
      "Director": "William Greaves",
      "DirectorArray": [
        "William Greaves"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "3279",
      "databaseFilmTitle": "Sympathy for Mr. Vengeance",
      "FilmTitle": "Sympathy for Mr. Vengeance",
      "AlternateTitle": "Boksuneun naui geot",
      "TitleArray": [
        "Sympathy for Mr. Vengeance",
        "Boksuneun naui geot"
      ],
      "Year": "2002",
      "Director": "Park Chan-wook",
      "DirectorArray": [
        "Park Chan-wook"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3280",
      "databaseFilmTitle": "Sync Touch",
      "FilmTitle": "Sync Touch",
      "AlternateTitle": "",
      "TitleArray": [
        "Sync Touch"
      ],
      "Year": "1981",
      "Director": "Barbara Hammer",
      "DirectorArray": [
        "Barbara Hammer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3281",
      "databaseFilmTitle": "Syndromes and a Century",
      "FilmTitle": "Syndromes and a Century",
      "AlternateTitle": "Sang sattawat",
      "TitleArray": [
        "Syndromes and a Century",
        "Sang sattawat"
      ],
      "Year": "2006",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "3282",
      "databaseFilmTitle": "Synecdoche, New York",
      "FilmTitle": "Synecdoche, New York",
      "AlternateTitle": "",
      "TitleArray": [
        "Synecdoche, New York"
      ],
      "Year": "2008",
      "Director": "Charlie Kaufman",
      "DirectorArray": [
        "Charlie Kaufman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3283",
      "databaseFilmTitle": "T.G.: Psychic Rally in Heaven",
      "FilmTitle": "T.G.: Psychic Rally in Heaven",
      "AlternateTitle": "",
      "TitleArray": [
        "T.G.: Psychic Rally in Heaven"
      ],
      "Year": "1981",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3284",
      "databaseFilmTitle": "Tabu (2012)",
      "FilmTitle": "Tabu",
      "AlternateTitle": "",
      "TitleArray": [
        "Tabu"
      ],
      "Year": "2012",
      "Director": "Miguel Gomes",
      "DirectorArray": [
        "Miguel Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3285",
      "databaseFilmTitle": "Tabu: A Story of the South Seas",
      "FilmTitle": "Tabu: A Story of the South Seas",
      "AlternateTitle": "",
      "TitleArray": [
        "Tabu: A Story of the South Seas"
      ],
      "Year": "1931",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3286",
      "databaseFilmTitle": "Taiga",
      "FilmTitle": "Taiga",
      "AlternateTitle": "",
      "TitleArray": [
        "Taiga"
      ],
      "Year": "1992",
      "Director": "Ulrike Ottinger",
      "DirectorArray": [
        "Ulrike Ottinger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3287",
      "databaseFilmTitle": "Tailpiece",
      "FilmTitle": "Tailpiece",
      "AlternateTitle": "",
      "TitleArray": [
        "Tailpiece"
      ],
      "Year": "1976",
      "Director": "Margaret Tait",
      "DirectorArray": [
        "Margaret Tait"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3288",
      "databaseFilmTitle": "Taipei Story",
      "FilmTitle": "Taipei Story",
      "AlternateTitle": "Qing mei zhu ma",
      "TitleArray": [
        "Taipei Story",
        "Qing mei zhu ma"
      ],
      "Year": "1985",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3289",
      "databaseFilmTitle": "Taira Clan Saga",
      "FilmTitle": "Taira Clan Saga",
      "AlternateTitle": "Shin heike monogatari",
      "TitleArray": [
        "Taira Clan Saga",
        "Shin heike monogatari"
      ],
      "Year": "1955",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3290",
      "databaseFilmTitle": "Take it All",
      "FilmTitle": "Take it All",
      "AlternateTitle": "À tout prendre",
      "TitleArray": [
        "Take it All",
        "À tout prendre"
      ],
      "Year": "1963",
      "Director": "Claude Jutra",
      "DirectorArray": [
        "Claude Jutra"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3291",
      "databaseFilmTitle": "Take This Waltz",
      "FilmTitle": "Take This Waltz",
      "AlternateTitle": "",
      "TitleArray": [
        "Take This Waltz"
      ],
      "Year": "2011",
      "Director": "Sarah Polley",
      "DirectorArray": [
        "Sarah Polley"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3292",
      "databaseFilmTitle": "Taking Off",
      "FilmTitle": "Taking Off",
      "AlternateTitle": "",
      "TitleArray": [
        "Taking Off"
      ],
      "Year": "1971",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3293",
      "databaseFilmTitle": "Taking the horse to eat jalebis",
      "FilmTitle": "Taking the horse to eat jalebis",
      "AlternateTitle": "",
      "TitleArray": [
        "Taking the horse to eat jalebis"
      ],
      "Year": "2018",
      "Director": "Anamika Haksar",
      "DirectorArray": [
        "Anamika Haksar"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3294",
      "databaseFilmTitle": "Tale of Cinema",
      "FilmTitle": "Tale of Cinema",
      "AlternateTitle": "Geuk jang jeon",
      "TitleArray": [
        "Tale of Cinema",
        "Geuk jang jeon"
      ],
      "Year": "2005",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3295",
      "databaseFilmTitle": "Tale of Tales",
      "FilmTitle": "Tale of Tales",
      "AlternateTitle": "Skazka Skazok",
      "TitleArray": [
        "Tale of Tales",
        "Skazka Skazok"
      ],
      "Year": "1979",
      "Director": "Yuri Norstein",
      "DirectorArray": [
        "Yuri Norstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3296",
      "databaseFilmTitle": "Talk to Her",
      "FilmTitle": "Talk to Her",
      "AlternateTitle": "Hable con ella",
      "TitleArray": [
        "Talk to Her",
        "Hable con ella"
      ],
      "Year": "2002",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3297",
      "databaseFilmTitle": "Talking about Trees",
      "FilmTitle": "Talking about Trees",
      "AlternateTitle": "",
      "TitleArray": [
        "Talking about Trees"
      ],
      "Year": "2019",
      "Director": "Suhaib Gasmelbari",
      "DirectorArray": [
        "Suhaib Gasmelbari"
      ],
      "Country": "Sudan",
      "CountryArray": [
        "Sudan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3298",
      "databaseFilmTitle": "Taller",
      "FilmTitle": "Taller",
      "AlternateTitle": "",
      "TitleArray": [
        "Taller"
      ],
      "Year": "1975",
      "Director": "Narcisa Hirsch",
      "DirectorArray": [
        "Narcisa Hirsch"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3299",
      "databaseFilmTitle": "Tampopo",
      "FilmTitle": "Tampopo",
      "AlternateTitle": "",
      "TitleArray": [
        "Tampopo"
      ],
      "Year": "1985",
      "Director": "Jûzô Itami",
      "DirectorArray": [
        "Jûzô Itami"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3300",
      "databaseFilmTitle": "Tango",
      "FilmTitle": "Tango",
      "AlternateTitle": "",
      "TitleArray": [
        "Tango"
      ],
      "Year": "1998",
      "Director": "Carlos Saura",
      "DirectorArray": [
        "Carlos Saura"
      ],
      "Country": "Argentina, Spain",
      "CountryArray": [
        "Argentina",
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3301",
      "databaseFilmTitle": "Tangos, the Exile of Gardel",
      "FilmTitle": "Tangos, the Exile of Gardel",
      "AlternateTitle": "Tangos, L'exil de Gardel",
      "TitleArray": [
        "Tangos, the Exile of Gardel",
        "Tangos, L'exil de Gardel"
      ],
      "Year": "1985",
      "Director": "Fernando E. Solanas",
      "DirectorArray": [
        "Fernando E. Solanas"
      ],
      "Country": "France, Argentina",
      "CountryArray": [
        "France",
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3302",
      "databaseFilmTitle": "Tanner '88",
      "FilmTitle": "Tanner '88",
      "AlternateTitle": "",
      "TitleArray": [
        "Tanner '88"
      ],
      "Year": "1988",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3303",
      "databaseFilmTitle": "Targets",
      "FilmTitle": "Targets",
      "AlternateTitle": "",
      "TitleArray": [
        "Targets"
      ],
      "Year": "1968",
      "Director": "Peter Bogdanovich",
      "DirectorArray": [
        "Peter Bogdanovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3304",
      "databaseFilmTitle": "Tarnation",
      "FilmTitle": "Tarnation",
      "AlternateTitle": "",
      "TitleArray": [
        "Tarnation"
      ],
      "Year": "2003",
      "Director": "Jonathan Caouette",
      "DirectorArray": [
        "Jonathan Caouette"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3305",
      "databaseFilmTitle": "Tarzan and His Mate",
      "FilmTitle": "Tarzan and His Mate",
      "AlternateTitle": "",
      "TitleArray": [
        "Tarzan and His Mate"
      ],
      "Year": "1934",
      "Director": "Cedric Gibbons, Jack Conway, James C. McKay",
      "DirectorArray": [
        "Cedric Gibbons",
        "Jack Conway",
        "James C. McKay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3306",
      "databaseFilmTitle": "Taste of Cherry",
      "FilmTitle": "Taste of Cherry",
      "AlternateTitle": "Ta'm e Guilass",
      "TitleArray": [
        "Taste of Cherry",
        "Ta'm e Guilass"
      ],
      "Year": "1997",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "3307",
      "databaseFilmTitle": "Tattooed Life",
      "FilmTitle": "Tattooed Life",
      "AlternateTitle": "Irezumi ichidai",
      "TitleArray": [
        "Tattooed Life",
        "Irezumi ichidai"
      ],
      "Year": "1965",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3308",
      "databaseFilmTitle": "Tawny Pipit",
      "FilmTitle": "Tawny Pipit",
      "AlternateTitle": "",
      "TitleArray": [
        "Tawny Pipit"
      ],
      "Year": "1944",
      "Director": "Bernard Miles, Charles Saunders",
      "DirectorArray": [
        "Bernard Miles",
        "Charles Saunders"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3309",
      "databaseFilmTitle": "Taxi Driver",
      "FilmTitle": "Taxi Driver",
      "AlternateTitle": "",
      "TitleArray": [
        "Taxi Driver"
      ],
      "Year": "1976",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "31",
      "2012votes": "38",
      "2022rank": "29",
      "2022votes": "62"
    },
    {
      "key": "3310",
      "databaseFilmTitle": "Taxi Tehran",
      "FilmTitle": "Taxi Tehran",
      "AlternateTitle": "",
      "TitleArray": [
        "Taxi Tehran"
      ],
      "Year": "2015",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3311",
      "databaseFilmTitle": "Te Rua",
      "FilmTitle": "Te Rua",
      "AlternateTitle": "",
      "TitleArray": [
        "Te Rua"
      ],
      "Year": "1991",
      "Director": "Barry Barclay",
      "DirectorArray": [
        "Barry Barclay"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3312",
      "databaseFilmTitle": "Tea and Sympathy",
      "FilmTitle": "Tea and Sympathy",
      "AlternateTitle": "",
      "TitleArray": [
        "Tea and Sympathy"
      ],
      "Year": "1956",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3313",
      "databaseFilmTitle": "Tears of the Sun",
      "FilmTitle": "Tears of the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Tears of the Sun"
      ],
      "Year": "2003",
      "Director": "Antoine Fuqua",
      "DirectorArray": [
        "Antoine Fuqua"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3314",
      "databaseFilmTitle": "Tell Me Who You Are",
      "FilmTitle": "Tell Me Who You Are",
      "AlternateTitle": "Min Ye",
      "TitleArray": [
        "Tell Me Who You Are",
        "Min Ye"
      ],
      "Year": "2009",
      "Director": "Souleymane Cissé",
      "DirectorArray": [
        "Souleymane Cissé"
      ],
      "Country": "Mali",
      "CountryArray": [
        "Mali"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3315",
      "databaseFilmTitle": "Ten",
      "FilmTitle": "Ten",
      "AlternateTitle": "Dan",
      "TitleArray": [
        "Ten",
        "Dan"
      ],
      "Year": "2002",
      "Director": "Abbas Kiarostami, Mania Akbari",
      "DirectorArray": [
        "Abbas Kiarostami",
        "Mania Akbari"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3316",
      "databaseFilmTitle": "Ten Canoes",
      "FilmTitle": "Ten Canoes",
      "AlternateTitle": "",
      "TitleArray": [
        "Ten Canoes"
      ],
      "Year": "2006",
      "Director": "Rolf de Heer, Peter Djigrir",
      "DirectorArray": [
        "Rolf de Heer",
        "Peter Djigrir"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3317",
      "databaseFilmTitle": "Ten Days Wonder",
      "FilmTitle": "Ten Days Wonder",
      "AlternateTitle": "La décade prodigieuse",
      "TitleArray": [
        "Ten Days Wonder",
        "La décade prodigieuse"
      ],
      "Year": "1971",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3318",
      "databaseFilmTitle": "Ten Minutes to Live",
      "FilmTitle": "Ten Minutes to Live",
      "AlternateTitle": "",
      "TitleArray": [
        "Ten Minutes to Live"
      ],
      "Year": "1932",
      "Director": "Oscar Micheaux",
      "DirectorArray": [
        "Oscar Micheaux"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3319",
      "databaseFilmTitle": "Ten Skies",
      "FilmTitle": "Ten Skies",
      "AlternateTitle": "",
      "TitleArray": [
        "Ten Skies"
      ],
      "Year": "2004",
      "Director": "James Benning",
      "DirectorArray": [
        "James Benning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3320",
      "databaseFilmTitle": "Tender Age",
      "FilmTitle": "Tender Age",
      "AlternateTitle": "",
      "TitleArray": [
        "Tender Age"
      ],
      "Year": "2000",
      "Director": "Sergei Solovyov",
      "DirectorArray": [
        "Sergei Solovyov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3321",
      "databaseFilmTitle": "Tender's Heat: Wild Wild Beach",
      "FilmTitle": "Tender's Heat: Wild Wild Beach",
      "AlternateTitle": "",
      "TitleArray": [
        "Tender's Heat: Wild Wild Beach"
      ],
      "Year": "2006",
      "Director": "Aleksandr Rastorguev",
      "DirectorArray": [
        "Aleksandr Rastorguev"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3322",
      "databaseFilmTitle": "Teorema",
      "FilmTitle": "Teorema",
      "AlternateTitle": "",
      "TitleArray": [
        "Teorema"
      ],
      "Year": "1968",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3323",
      "databaseFilmTitle": "Terminator 2: Judgment Day",
      "FilmTitle": "Terminator 2: Judgment Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Terminator 2: Judgment Day"
      ],
      "Year": "1991",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3324",
      "databaseFilmTitle": "Terminus",
      "FilmTitle": "Terminus",
      "AlternateTitle": "",
      "TitleArray": [
        "Terminus"
      ],
      "Year": "1961",
      "Director": "John Schlesigner",
      "DirectorArray": [
        "John Schlesigner"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3325",
      "databaseFilmTitle": "Testament (1983)",
      "FilmTitle": "Testament",
      "AlternateTitle": "",
      "TitleArray": [
        "Testament"
      ],
      "Year": "1983",
      "Director": "Lynne Littman",
      "DirectorArray": [
        "Lynne Littman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3326",
      "databaseFilmTitle": "Testament (1988)",
      "FilmTitle": "Testament",
      "AlternateTitle": "",
      "TitleArray": [
        "Testament"
      ],
      "Year": "1988",
      "Director": "John Akomfrah",
      "DirectorArray": [
        "John Akomfrah"
      ],
      "Country": "Ghana, United Kingdom",
      "CountryArray": [
        "Ghana",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3327",
      "databaseFilmTitle": "Testament of Orpheus",
      "FilmTitle": "Testament of Orpheus",
      "AlternateTitle": "Le testament d'Orphée ou ne me demandez pas pourquoi",
      "TitleArray": [
        "Testament of Orpheus",
        "Le testament d'Orphée ou ne me demandez pas pourquoi"
      ],
      "Year": "1960",
      "Director": "Jean Cocteau",
      "DirectorArray": [
        "Jean Cocteau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3328",
      "databaseFilmTitle": "Tetsuo: The Iron Man",
      "FilmTitle": "Tetsuo: The Iron Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Tetsuo: The Iron Man"
      ],
      "Year": "1989",
      "Director": "Shin'ya Tsukamoto",
      "DirectorArray": [
        "Shin'ya Tsukamoto"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3329",
      "databaseFilmTitle": "Texasville",
      "FilmTitle": "Texasville",
      "AlternateTitle": "",
      "TitleArray": [
        "Texasville"
      ],
      "Year": "1990",
      "Director": "Peter Bodganovich",
      "DirectorArray": [
        "Peter Bodganovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3330",
      "databaseFilmTitle": "Textism",
      "FilmTitle": "Textism",
      "AlternateTitle": "",
      "TitleArray": [
        "Textism"
      ],
      "Year": "2003",
      "Director": "Isamu Hirabayashi",
      "DirectorArray": [
        "Isamu Hirabayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3331",
      "databaseFilmTitle": "Teza",
      "FilmTitle": "Teza",
      "AlternateTitle": "",
      "TitleArray": [
        "Teza"
      ],
      "Year": "2008",
      "Director": "Haile Gerima",
      "DirectorArray": [
        "Haile Gerima"
      ],
      "Country": "Ethiopia",
      "CountryArray": [
        "Ethiopia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3332",
      "databaseFilmTitle": "That Is the Dawn",
      "FilmTitle": "That Is the Dawn",
      "AlternateTitle": "Cela s'appelle l'aurore",
      "TitleArray": [
        "That Is the Dawn",
        "Cela s'appelle l'aurore"
      ],
      "Year": "1956",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3333",
      "databaseFilmTitle": "That Obscure Object of Desire",
      "FilmTitle": "That Obscure Object of Desire",
      "AlternateTitle": "Cet obscur objet du désir",
      "TitleArray": [
        "That Obscure Object of Desire",
        "Cet obscur objet du désir"
      ],
      "Year": "1977",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France, Spain",
      "CountryArray": [
        "France",
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3334",
      "databaseFilmTitle": "The '?' Motorist",
      "FilmTitle": "The '?' Motorist",
      "AlternateTitle": "",
      "TitleArray": [
        "The '?' Motorist"
      ],
      "Year": "1906",
      "Director": "Walter R. Booth",
      "DirectorArray": [
        "Walter R. Booth"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3335",
      "databaseFilmTitle": "The 1000 Eyes of Dr. Mabuse",
      "FilmTitle": "The 1000 Eyes of Dr. Mabuse",
      "AlternateTitle": "Die 1000 Augen des Dr. Mabuse",
      "TitleArray": [
        "The 1000 Eyes of Dr. Mabuse",
        "Die 1000 Augen des Dr. Mabuse"
      ],
      "Year": "1960",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "West Germany, France",
      "CountryArray": [
        "West Germany",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3336",
      "databaseFilmTitle": "The 3 Rooms of Melancholia",
      "FilmTitle": "The 3 Rooms of Melancholia",
      "AlternateTitle": "Melancholian 3 huonetta",
      "TitleArray": [
        "The 3 Rooms of Melancholia",
        "Melancholian 3 huonetta"
      ],
      "Year": "2004",
      "Director": "Pirjo Honkasalo",
      "DirectorArray": [
        "Pirjo Honkasalo"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3337",
      "databaseFilmTitle": "The 36th Chamber of Shaolin",
      "FilmTitle": "The 36th Chamber of Shaolin",
      "AlternateTitle": "Shao Lin san shi liu fang",
      "TitleArray": [
        "The 36th Chamber of Shaolin",
        "Shao Lin san shi liu fang"
      ],
      "Year": "1978",
      "Director": "Lau Kar-leung",
      "DirectorArray": [
        "Lau Kar-leung"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3338",
      "databaseFilmTitle": "The 39 Steps",
      "FilmTitle": "The 39 Steps",
      "AlternateTitle": "",
      "TitleArray": [
        "The 39 Steps"
      ],
      "Year": "1935",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3339",
      "databaseFilmTitle": "The 400 Blows",
      "FilmTitle": "The 400 Blows",
      "AlternateTitle": "Les quatre cents coups",
      "TitleArray": [
        "The 400 Blows",
        "Les quatre cents coups"
      ],
      "Year": "1959",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "39",
      "2012votes": "33",
      "2022rank": "50",
      "2022votes": "46"
    },
    {
      "key": "3340",
      "databaseFilmTitle": "The 47 Loyal Ronin",
      "FilmTitle": "The 47 Loyal Ronin",
      "AlternateTitle": "Chūshingura",
      "TitleArray": [
        "The 47 Loyal Ronin",
        "Chūshingura"
      ],
      "Year": "1958",
      "Director": "Kunio Watanabe",
      "DirectorArray": [
        "Kunio Watanabe"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3341",
      "databaseFilmTitle": "The 47 Ronin",
      "FilmTitle": "The 47 Ronin",
      "AlternateTitle": "Genroku Chūshingura",
      "TitleArray": [
        "The 47 Ronin",
        "Genroku Chūshingura"
      ],
      "Year": "1941",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3342",
      "databaseFilmTitle": "The 5000 Fingers of Dr. T",
      "FilmTitle": "The 5000 Fingers of Dr. T",
      "AlternateTitle": "",
      "TitleArray": [
        "The 5000 Fingers of Dr. T"
      ],
      "Year": "1953",
      "Director": "Roy Rowland",
      "DirectorArray": [
        "Roy Rowland"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3343",
      "databaseFilmTitle": "The 8 Diagram Pole Fighter",
      "FilmTitle": "The 8 Diagram Pole Fighter",
      "AlternateTitle": "Wu Lang ba gua gun",
      "TitleArray": [
        "The 8 Diagram Pole Fighter",
        "Wu Lang ba gua gun"
      ],
      "Year": "1984",
      "Director": "Lau Kar-leung",
      "DirectorArray": [
        "Lau Kar-leung"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3344",
      "databaseFilmTitle": "The Abeer Color",
      "FilmTitle": "The Abeer Color",
      "AlternateTitle": "Gulaal",
      "TitleArray": [
        "The Abeer Color",
        "Gulaal"
      ],
      "Year": "2009",
      "Director": "Anurag Kashyap",
      "DirectorArray": [
        "Anurag Kashyap"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3345",
      "databaseFilmTitle": "The Abyss",
      "FilmTitle": "The Abyss",
      "AlternateTitle": "",
      "TitleArray": [
        "The Abyss"
      ],
      "Year": "1989",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3346",
      "databaseFilmTitle": "The Accidental Tourist",
      "FilmTitle": "The Accidental Tourist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Accidental Tourist"
      ],
      "Year": "1988",
      "Director": "Lawrence Kasdan",
      "DirectorArray": [
        "Lawrence Kasdan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3347",
      "databaseFilmTitle": "The Act of Killing",
      "FilmTitle": "The Act of Killing",
      "AlternateTitle": "",
      "TitleArray": [
        "The Act of Killing"
      ],
      "Year": "2012",
      "Director": "Joshua Oppenheimer, Christine Cynn",
      "DirectorArray": [
        "Joshua Oppenheimer",
        "Christine Cynn"
      ],
      "Country": "Denmark, Indonesia",
      "CountryArray": [
        "Denmark",
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3348",
      "databaseFilmTitle": "The Act of Seeing with One's Own Eyes",
      "FilmTitle": "The Act of Seeing with One's Own Eyes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Act of Seeing with One's Own Eyes"
      ],
      "Year": "1971",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3349",
      "databaseFilmTitle": "The Addiction",
      "FilmTitle": "The Addiction",
      "AlternateTitle": "",
      "TitleArray": [
        "The Addiction"
      ],
      "Year": "1995",
      "Director": "Abel Ferrara",
      "DirectorArray": [
        "Abel Ferrara"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3350",
      "databaseFilmTitle": "The Adventures of Prince Achmed",
      "FilmTitle": "The Adventures of Prince Achmed",
      "AlternateTitle": "Die Abenteuer des Prinzen Achmed",
      "TitleArray": [
        "The Adventures of Prince Achmed",
        "Die Abenteuer des Prinzen Achmed"
      ],
      "Year": "1926",
      "Director": "Lotte Reiniger",
      "DirectorArray": [
        "Lotte Reiniger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3351",
      "databaseFilmTitle": "The Adventures of Priscilla, Queen of the Desert",
      "FilmTitle": "The Adventures of Priscilla, Queen of the Desert",
      "AlternateTitle": "",
      "TitleArray": [
        "The Adventures of Priscilla, Queen of the Desert"
      ],
      "Year": "1994",
      "Director": "Stephan Elliot",
      "DirectorArray": [
        "Stephan Elliot"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3352",
      "databaseFilmTitle": "The Adventures of Robin Hood",
      "FilmTitle": "The Adventures of Robin Hood",
      "AlternateTitle": "",
      "TitleArray": [
        "The Adventures of Robin Hood"
      ],
      "Year": "1938",
      "Director": "Michael Curtiz, William Keighley",
      "DirectorArray": [
        "Michael Curtiz",
        "William Keighley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3353",
      "databaseFilmTitle": "The African Queen",
      "FilmTitle": "The African Queen",
      "AlternateTitle": "",
      "TitleArray": [
        "The African Queen"
      ],
      "Year": "1951",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3354",
      "databaseFilmTitle": "The Age of Innocence",
      "FilmTitle": "The Age of Innocence",
      "AlternateTitle": "",
      "TitleArray": [
        "The Age of Innocence"
      ],
      "Year": "1993",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3355",
      "databaseFilmTitle": "The Age of the Earth",
      "FilmTitle": "The Age of the Earth",
      "AlternateTitle": "A Idade da Terra",
      "TitleArray": [
        "The Age of the Earth",
        "A Idade da Terra"
      ],
      "Year": "1980",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3356",
      "databaseFilmTitle": "The Age of the Medici",
      "FilmTitle": "The Age of the Medici",
      "AlternateTitle": "L'età di Cosimo de Medici",
      "TitleArray": [
        "The Age of the Medici",
        "L'età di Cosimo de Medici"
      ],
      "Year": "1973",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3357",
      "databaseFilmTitle": "The Aimless Bullet",
      "FilmTitle": "The Aimless Bullet",
      "AlternateTitle": "Obaltan",
      "TitleArray": [
        "The Aimless Bullet",
        "Obaltan"
      ],
      "Year": "1961",
      "Director": "Yu Hyun-mok",
      "DirectorArray": [
        "Yu Hyun-mok"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3358",
      "databaseFilmTitle": "The All-Round Reduced Personality - Redupers",
      "FilmTitle": "The All-Round Reduced Personality - Redupers",
      "AlternateTitle": "Die Allseitig reduzierte Persönlichkeit - Redupers",
      "TitleArray": [
        "The All-Round Reduced Personality - Redupers",
        "Die Allseitig reduzierte Persönlichkeit - Redupers"
      ],
      "Year": "1978",
      "Director": "Helke Sander",
      "DirectorArray": [
        "Helke Sander"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3359",
      "databaseFilmTitle": "The American Friend",
      "FilmTitle": "The American Friend",
      "AlternateTitle": "Der Amerikanische Freund",
      "TitleArray": [
        "The American Friend",
        "Der Amerikanische Freund"
      ],
      "Year": "1977",
      "Director": "Wim Wenders",
      "DirectorArray": [
        "Wim Wenders"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3360",
      "databaseFilmTitle": "The American Soldier",
      "FilmTitle": "The American Soldier",
      "AlternateTitle": "Der Amerikanische Soldat",
      "TitleArray": [
        "The American Soldier",
        "Der Amerikanische Soldat"
      ],
      "Year": "1970",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3361",
      "databaseFilmTitle": "The Ancient Law",
      "FilmTitle": "The Ancient Law",
      "AlternateTitle": "Das alte Gesetz",
      "TitleArray": [
        "The Ancient Law",
        "Das alte Gesetz"
      ],
      "Year": "1923",
      "Director": "Ewald André Dupont",
      "DirectorArray": [
        "Ewald André Dupont"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3362",
      "databaseFilmTitle": "The Angelic Conversation",
      "FilmTitle": "The Angelic Conversation",
      "AlternateTitle": "",
      "TitleArray": [
        "The Angelic Conversation"
      ],
      "Year": "1985",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3363",
      "databaseFilmTitle": "The Angkar",
      "FilmTitle": "The Angkar",
      "AlternateTitle": "Die Angkar",
      "TitleArray": [
        "The Angkar",
        "Die Angkar"
      ],
      "Year": "1981",
      "Director": "Walter Heynowski, Gerhard Scheumann",
      "DirectorArray": [
        "Walter Heynowski",
        "Gerhard Scheumann"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3364",
      "databaseFilmTitle": "The Anthem",
      "FilmTitle": "The Anthem",
      "AlternateTitle": "",
      "TitleArray": [
        "The Anthem"
      ],
      "Year": "2006",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3365",
      "databaseFilmTitle": "The Apartment",
      "FilmTitle": "The Apartment",
      "AlternateTitle": "",
      "TitleArray": [
        "The Apartment"
      ],
      "Year": "1960",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "54",
      "2022votes": "44"
    },
    {
      "key": "3366",
      "databaseFilmTitle": "The Apple",
      "FilmTitle": "The Apple",
      "AlternateTitle": "Sib",
      "TitleArray": [
        "The Apple",
        "Sib"
      ],
      "Year": "1998",
      "Director": "Samira Makhmalbaf",
      "DirectorArray": [
        "Samira Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3367",
      "databaseFilmTitle": "The Arbor",
      "FilmTitle": "The Arbor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Arbor"
      ],
      "Year": "2010",
      "Director": "Clio Barnard",
      "DirectorArray": [
        "Clio Barnard"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3368",
      "databaseFilmTitle": "The Arrival of a Train at La Ciotat",
      "FilmTitle": "The Arrival of a Train at La Ciotat",
      "AlternateTitle": "L'Arrivée d'un train en gare de La Ciotat",
      "TitleArray": [
        "The Arrival of a Train at La Ciotat",
        "L'Arrivée d'un train en gare de La Ciotat"
      ],
      "Year": "1896",
      "Director": "Auguste Lumière, Louis Lumière",
      "DirectorArray": [
        "Auguste Lumière",
        "Louis Lumière"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3369",
      "databaseFilmTitle": "The Art of Vision",
      "FilmTitle": "The Art of Vision",
      "AlternateTitle": "",
      "TitleArray": [
        "The Art of Vision"
      ],
      "Year": "1965",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3370",
      "databaseFilmTitle": "The Artist",
      "FilmTitle": "The Artist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Artist"
      ],
      "Year": "2011",
      "Director": "Michel Hazanavicius",
      "DirectorArray": [
        "Michel Hazanavicius"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3371",
      "databaseFilmTitle": "The Ascent",
      "FilmTitle": "The Ascent",
      "AlternateTitle": "Voskhozhdenie",
      "TitleArray": [
        "The Ascent",
        "Voskhozhdenie"
      ],
      "Year": "1977",
      "Director": "Larisa Shepitko",
      "DirectorArray": [
        "Larisa Shepitko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "128",
      "2022votes": "24"
    },
    {
      "key": "3372",
      "databaseFilmTitle": "The Asphalt Jungle",
      "FilmTitle": "The Asphalt Jungle",
      "AlternateTitle": "",
      "TitleArray": [
        "The Asphalt Jungle"
      ],
      "Year": "1950",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3373",
      "databaseFilmTitle": "The Assassin",
      "FilmTitle": "The Assassin",
      "AlternateTitle": "Nie yin niang",
      "TitleArray": [
        "The Assassin",
        "Nie yin niang"
      ],
      "Year": "2015",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan, China",
      "CountryArray": [
        "Taiwan",
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3374",
      "databaseFilmTitle": "The Assassination of Jesse James by the Coward Robert Ford",
      "FilmTitle": "The Assassination of Jesse James by the Coward Robert Ford",
      "AlternateTitle": "",
      "TitleArray": [
        "The Assassination of Jesse James by the Coward Robert Ford"
      ],
      "Year": "2007",
      "Director": "Andrew Dominik",
      "DirectorArray": [
        "Andrew Dominik"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3375",
      "databaseFilmTitle": "The Assassination of the Duke de Guise",
      "FilmTitle": "The Assassination of the Duke de Guise",
      "AlternateTitle": "L'assassinat du Duc de Guise",
      "TitleArray": [
        "The Assassination of the Duke de Guise",
        "L'assassinat du Duc de Guise"
      ],
      "Year": "1908",
      "Director": "André Calmettes, Charles Le Bargy",
      "DirectorArray": [
        "André Calmettes",
        "Charles Le Bargy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3376",
      "databaseFilmTitle": "The Asthenic Syndrome",
      "FilmTitle": "The Asthenic Syndrome",
      "AlternateTitle": "",
      "TitleArray": [
        "The Asthenic Syndrome"
      ],
      "Year": "1989",
      "Director": "Kira Muratova",
      "DirectorArray": [
        "Kira Muratova"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3377",
      "databaseFilmTitle": "The Astrologer",
      "FilmTitle": "The Astrologer",
      "AlternateTitle": "",
      "TitleArray": [
        "The Astrologer"
      ],
      "Year": "1975",
      "Director": "Craig Denney",
      "DirectorArray": [
        "Craig Denney"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3378",
      "databaseFilmTitle": "The Astronauts",
      "FilmTitle": "The Astronauts",
      "AlternateTitle": "Les astronautes",
      "TitleArray": [
        "The Astronauts",
        "Les astronautes"
      ],
      "Year": "1959",
      "Director": "Walerian Borowczyk, Chris Marker",
      "DirectorArray": [
        "Walerian Borowczyk",
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3379",
      "databaseFilmTitle": "The Atomic Cafe",
      "FilmTitle": "The Atomic Cafe",
      "AlternateTitle": "",
      "TitleArray": [
        "The Atomic Cafe"
      ],
      "Year": "1982",
      "Director": "Jayne Loader, Kevin Rafferty, Pierce Rafferty",
      "DirectorArray": [
        "Jayne Loader",
        "Kevin Rafferty",
        "Pierce Rafferty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3380",
      "databaseFilmTitle": "The Aura",
      "FilmTitle": "The Aura",
      "AlternateTitle": "El aura",
      "TitleArray": [
        "The Aura",
        "El aura"
      ],
      "Year": "2005",
      "Director": "Fabián Bielinsky",
      "DirectorArray": [
        "Fabián Bielinsky"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3381",
      "databaseFilmTitle": "The Autobiography of Nicolae Ceauşescu",
      "FilmTitle": "The Autobiography of Nicolae Ceauşescu",
      "AlternateTitle": "Autobiografia lui Nicolae Ceaușescu",
      "TitleArray": [
        "The Autobiography of Nicolae Ceauşescu",
        "Autobiografia lui Nicolae Ceaușescu"
      ],
      "Year": "2010",
      "Director": "Andrei Ujică",
      "DirectorArray": [
        "Andrei Ujică"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3382",
      "databaseFilmTitle": "The Automat",
      "FilmTitle": "The Automat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Automat"
      ],
      "Year": "2021",
      "Director": "Lisa Hurwitz",
      "DirectorArray": [
        "Lisa Hurwitz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3383",
      "databaseFilmTitle": "The Aviator",
      "FilmTitle": "The Aviator",
      "AlternateTitle": "",
      "TitleArray": [
        "The Aviator"
      ],
      "Year": "2004",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3384",
      "databaseFilmTitle": "The Awful Truth",
      "FilmTitle": "The Awful Truth",
      "AlternateTitle": "",
      "TitleArray": [
        "The Awful Truth"
      ],
      "Year": "1937",
      "Director": "Leo LcCarey",
      "DirectorArray": [
        "Leo LcCarey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3385",
      "databaseFilmTitle": "The Babadook",
      "FilmTitle": "The Babadook",
      "AlternateTitle": "",
      "TitleArray": [
        "The Babadook"
      ],
      "Year": "2014",
      "Director": "Jennifer Kent",
      "DirectorArray": [
        "Jennifer Kent"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3386",
      "databaseFilmTitle": "The Baby Carriage",
      "FilmTitle": "The Baby Carriage",
      "AlternateTitle": "Barnvagnen",
      "TitleArray": [
        "The Baby Carriage",
        "Barnvagnen"
      ],
      "Year": "1963",
      "Director": "Bo Widerberg",
      "DirectorArray": [
        "Bo Widerberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3387",
      "databaseFilmTitle": "The Baby of Mâcon",
      "FilmTitle": "The Baby of Mâcon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Baby of Mâcon"
      ],
      "Year": "1993",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3388",
      "databaseFilmTitle": "The Back of Beyond",
      "FilmTitle": "The Back of Beyond",
      "AlternateTitle": "",
      "TitleArray": [
        "The Back of Beyond"
      ],
      "Year": "1954",
      "Director": "John Heyer",
      "DirectorArray": [
        "John Heyer"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3389",
      "databaseFilmTitle": "The Bad and the Beautiful",
      "FilmTitle": "The Bad and the Beautiful",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bad and the Beautiful"
      ],
      "Year": "1952",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3390",
      "databaseFilmTitle": "The Bad Seed",
      "FilmTitle": "The Bad Seed",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bad Seed"
      ],
      "Year": "1956",
      "Director": "Mervyn LeRoy",
      "DirectorArray": [
        "Mervyn LeRoy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3391",
      "databaseFilmTitle": "The Bad Sleep Well",
      "FilmTitle": "The Bad Sleep Well",
      "AlternateTitle": "Warui yatsu hodo yoku nemuru",
      "TitleArray": [
        "The Bad Sleep Well",
        "Warui yatsu hodo yoku nemuru"
      ],
      "Year": "1960",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3392",
      "databaseFilmTitle": "The Ballad of Cable Hogue",
      "FilmTitle": "The Ballad of Cable Hogue",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ballad of Cable Hogue"
      ],
      "Year": "1970",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3393",
      "databaseFilmTitle": "The Ballad of Little Jo",
      "FilmTitle": "The Ballad of Little Jo",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ballad of Little Jo"
      ],
      "Year": "1993",
      "Director": "Maggie Greenwald",
      "DirectorArray": [
        "Maggie Greenwald"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3394",
      "databaseFilmTitle": "The Ballad of Narayama",
      "FilmTitle": "The Ballad of Narayama",
      "AlternateTitle": "Narayama bushikô",
      "TitleArray": [
        "The Ballad of Narayama",
        "Narayama bushikô"
      ],
      "Year": "1983",
      "Director": "Shōhei Imamura",
      "DirectorArray": [
        "Shōhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3395",
      "databaseFilmTitle": "The Ballad of Sexual Dependency",
      "FilmTitle": "The Ballad of Sexual Dependency",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ballad of Sexual Dependency"
      ],
      "Year": "1986",
      "Director": "Nan Goldin",
      "DirectorArray": [
        "Nan Goldin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3396",
      "databaseFilmTitle": "The Band Wagon",
      "FilmTitle": "The Band Wagon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Band Wagon"
      ],
      "Year": "1953",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3397",
      "databaseFilmTitle": "The Banishment",
      "FilmTitle": "The Banishment",
      "AlternateTitle": "Izgnanie",
      "TitleArray": [
        "The Banishment",
        "Izgnanie"
      ],
      "Year": "2007",
      "Director": "Andrey Zvyagintsev",
      "DirectorArray": [
        "Andrey Zvyagintsev"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3398",
      "databaseFilmTitle": "The Bank Dick",
      "FilmTitle": "The Bank Dick",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bank Dick"
      ],
      "Year": "1940",
      "Director": "Edward F. Cline",
      "DirectorArray": [
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3399",
      "databaseFilmTitle": "The Barefoot Contessa",
      "FilmTitle": "The Barefoot Contessa",
      "AlternateTitle": "",
      "TitleArray": [
        "The Barefoot Contessa"
      ],
      "Year": "1954",
      "Director": "Joseph L. Mankiewicz",
      "DirectorArray": [
        "Joseph L. Mankiewicz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3400",
      "databaseFilmTitle": "The Barkleys of Broadway",
      "FilmTitle": "The Barkleys of Broadway",
      "AlternateTitle": "",
      "TitleArray": [
        "The Barkleys of Broadway"
      ],
      "Year": "1949",
      "Director": "Charles Walters",
      "DirectorArray": [
        "Charles Walters"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3401",
      "databaseFilmTitle": "The Bartered Bride",
      "FilmTitle": "The Bartered Bride",
      "AlternateTitle": "Die verkaufte Braut",
      "TitleArray": [
        "The Bartered Bride",
        "Die verkaufte Braut"
      ],
      "Year": "1932",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3402",
      "databaseFilmTitle": "The Basilisks",
      "FilmTitle": "The Basilisks",
      "AlternateTitle": "I basilischi",
      "TitleArray": [
        "The Basilisks",
        "I basilischi"
      ],
      "Year": "1963",
      "Director": "Lina Wertmüller",
      "DirectorArray": [
        "Lina Wertmüller"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3403",
      "databaseFilmTitle": "The Bat Whispers",
      "FilmTitle": "The Bat Whispers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bat Whispers"
      ],
      "Year": "1930",
      "Director": "Roland West",
      "DirectorArray": [
        "Roland West"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3404",
      "databaseFilmTitle": "The Battle of Algiers",
      "FilmTitle": "The Battle of Algiers",
      "AlternateTitle": "La battaglia di Algeri",
      "TitleArray": [
        "The Battle of Algiers",
        "La battaglia di Algeri"
      ],
      "Year": "1966",
      "Director": "Gillo Pontecorvo",
      "DirectorArray": [
        "Gillo Pontecorvo"
      ],
      "Country": "Italy, Algeria",
      "CountryArray": [
        "Italy",
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "48",
      "2012votes": "30",
      "2022rank": "45",
      "2022votes": "49"
    },
    {
      "key": "3405",
      "databaseFilmTitle": "The Battle of Chile",
      "FilmTitle": "The Battle of Chile",
      "AlternateTitle": "La batalla de Chile",
      "TitleArray": [
        "The Battle of Chile",
        "La batalla de Chile"
      ],
      "Year": "1979",
      "Director": "Patricio Guzmán",
      "DirectorArray": [
        "Patricio Guzmán"
      ],
      "Country": "Chile, Cuba",
      "CountryArray": [
        "Chile",
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3406",
      "databaseFilmTitle": "The Battle of the Somme",
      "FilmTitle": "The Battle of the Somme",
      "AlternateTitle": "",
      "TitleArray": [
        "The Battle of the Somme"
      ],
      "Year": "1916",
      "Director": "J.B. McDowell, Geoffrey H. Malins",
      "DirectorArray": [
        "J.B. McDowell",
        "Geoffrey H. Malins"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3407",
      "databaseFilmTitle": "The Beaches of Agnès",
      "FilmTitle": "The Beaches of Agnès",
      "AlternateTitle": "Les plages d'Agnès",
      "TitleArray": [
        "The Beaches of Agnès",
        "Les plages d'Agnès"
      ],
      "Year": "2008",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3408",
      "databaseFilmTitle": "The Beat That My Heart Skipped",
      "FilmTitle": "The Beat That My Heart Skipped",
      "AlternateTitle": "De battre mon coeur s'est arrêté",
      "TitleArray": [
        "The Beat That My Heart Skipped",
        "De battre mon coeur s'est arrêté"
      ],
      "Year": "2005",
      "Director": "Jacques Audiard",
      "DirectorArray": [
        "Jacques Audiard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3409",
      "databaseFilmTitle": "The Bed You Sleep In",
      "FilmTitle": "The Bed You Sleep In",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bed You Sleep In"
      ],
      "Year": "1993",
      "Director": "Jon Jost",
      "DirectorArray": [
        "Jon Jost"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3410",
      "databaseFilmTitle": "The Beginning and the End",
      "FilmTitle": "The Beginning and the End",
      "AlternateTitle": "Principio y fin",
      "TitleArray": [
        "The Beginning and the End",
        "Principio y fin"
      ],
      "Year": "1993",
      "Director": "Arturo Ripstein",
      "DirectorArray": [
        "Arturo Ripstein"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3411",
      "databaseFilmTitle": "The Beguiled",
      "FilmTitle": "The Beguiled",
      "AlternateTitle": "",
      "TitleArray": [
        "The Beguiled"
      ],
      "Year": "1971",
      "Director": "Don Siegel",
      "DirectorArray": [
        "Don Siegel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3412",
      "databaseFilmTitle": "The Bells of St. Mary's",
      "FilmTitle": "The Bells of St. Mary's",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bells of St. Mary's"
      ],
      "Year": "1945",
      "Director": "Leo Mc",
      "DirectorArray": [
        "Leo Mc"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3413",
      "databaseFilmTitle": "The Belovs",
      "FilmTitle": "The Belovs",
      "AlternateTitle": "",
      "TitleArray": [
        "The Belovs"
      ],
      "Year": "1993",
      "Director": "Victor Kossakovsky",
      "DirectorArray": [
        "Victor Kossakovsky"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3414",
      "databaseFilmTitle": "The Best of Youth",
      "FilmTitle": "The Best of Youth",
      "AlternateTitle": "La meglio gioventù",
      "TitleArray": [
        "The Best of Youth",
        "La meglio gioventù"
      ],
      "Year": "2003",
      "Director": "Marco Tullio Giordana",
      "DirectorArray": [
        "Marco Tullio Giordana"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3415",
      "databaseFilmTitle": "The Best Years of Our Lives",
      "FilmTitle": "The Best Years of Our Lives",
      "AlternateTitle": "",
      "TitleArray": [
        "The Best Years of Our Lives"
      ],
      "Year": "1946",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3416",
      "databaseFilmTitle": "The Beyond",
      "FilmTitle": "The Beyond",
      "AlternateTitle": "E tu vivrai nel terrore! L'aldilà",
      "TitleArray": [
        "The Beyond",
        "E tu vivrai nel terrore! L'aldilà"
      ],
      "Year": "1981",
      "Director": "Lucio Fulci",
      "DirectorArray": [
        "Lucio Fulci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3417",
      "databaseFilmTitle": "The Big City",
      "FilmTitle": "The Big City",
      "AlternateTitle": "Mahanagar",
      "TitleArray": [
        "The Big City",
        "Mahanagar"
      ],
      "Year": "1963",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3418",
      "databaseFilmTitle": "The Big Country",
      "FilmTitle": "The Big Country",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Country"
      ],
      "Year": "1958",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3419",
      "databaseFilmTitle": "The Big Feast",
      "FilmTitle": "The Big Feast",
      "AlternateTitle": "La grande bouffe",
      "TitleArray": [
        "The Big Feast",
        "La grande bouffe"
      ],
      "Year": "1973",
      "Director": "Marco Ferreri",
      "DirectorArray": [
        "Marco Ferreri"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3420",
      "databaseFilmTitle": "The Big Heat",
      "FilmTitle": "The Big Heat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Heat"
      ],
      "Year": "1953",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3421",
      "databaseFilmTitle": "The Big Lebowski",
      "FilmTitle": "The Big Lebowski",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Lebowski"
      ],
      "Year": "1998",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "3422",
      "databaseFilmTitle": "The Big Mouth",
      "FilmTitle": "The Big Mouth",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Mouth"
      ],
      "Year": "1967",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3423",
      "databaseFilmTitle": "The Big Night",
      "FilmTitle": "The Big Night",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Night"
      ],
      "Year": "1951",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3424",
      "databaseFilmTitle": "The Big Parade",
      "FilmTitle": "The Big Parade",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Parade"
      ],
      "Year": "1925",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3425",
      "databaseFilmTitle": "The Big Red One",
      "FilmTitle": "The Big Red One",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Red One"
      ],
      "Year": "1980",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3426",
      "databaseFilmTitle": "The Big Road",
      "FilmTitle": "The Big Road",
      "AlternateTitle": "Dalu",
      "TitleArray": [
        "The Big Road",
        "Dalu"
      ],
      "Year": "1935",
      "Director": "Sun Yu",
      "DirectorArray": [
        "Sun Yu"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3427",
      "databaseFilmTitle": "The Big Sky",
      "FilmTitle": "The Big Sky",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Sky"
      ],
      "Year": "1952",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3428",
      "databaseFilmTitle": "The Big Sleep",
      "FilmTitle": "The Big Sleep",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Sleep"
      ],
      "Year": "1946",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3429",
      "databaseFilmTitle": "The Big Trail",
      "FilmTitle": "The Big Trail",
      "AlternateTitle": "",
      "TitleArray": [
        "The Big Trail"
      ],
      "Year": "1930",
      "Director": "Raoul Walsh, Louis R. Loeffler",
      "DirectorArray": [
        "Raoul Walsh",
        "Louis R. Loeffler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3430",
      "databaseFilmTitle": "The Bigamist",
      "FilmTitle": "The Bigamist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bigamist"
      ],
      "Year": "1953",
      "Director": "Ida Lupino",
      "DirectorArray": [
        "Ida Lupino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3431",
      "databaseFilmTitle": "The Birds",
      "FilmTitle": "The Birds",
      "AlternateTitle": "",
      "TitleArray": [
        "The Birds"
      ],
      "Year": "1963",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "3432",
      "databaseFilmTitle": "The Birth of a Nation (1915)",
      "FilmTitle": "The Birth of a Nation",
      "AlternateTitle": "",
      "TitleArray": [
        "The Birth of a Nation"
      ],
      "Year": "1915",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3433",
      "databaseFilmTitle": "The Birth of a Nation (1973)",
      "FilmTitle": "The Birth of a Nation",
      "AlternateTitle": "Die Geburt der Nation",
      "TitleArray": [
        "The Birth of a Nation",
        "Die Geburt der Nation"
      ],
      "Year": "1973",
      "Director": "Klaus Wyborny",
      "DirectorArray": [
        "Klaus Wyborny"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "583",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3434",
      "databaseFilmTitle": "The Birth of Love",
      "FilmTitle": "The Birth of Love",
      "AlternateTitle": "La naissance de l'amour",
      "TitleArray": [
        "The Birth of Love",
        "La naissance de l'amour"
      ],
      "Year": "1993",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3435",
      "databaseFilmTitle": "The Bitter Tears of Petra von Kant",
      "FilmTitle": "The Bitter Tears of Petra von Kant",
      "AlternateTitle": "Die bitteren Tränen der Petra von Kant",
      "TitleArray": [
        "The Bitter Tears of Petra von Kant",
        "Die bitteren Tränen der Petra von Kant"
      ],
      "Year": "1972",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3436",
      "databaseFilmTitle": "The Black Cat",
      "FilmTitle": "The Black Cat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Black Cat"
      ],
      "Year": "1934",
      "Director": "Edgar G. Ulmer",
      "DirectorArray": [
        "Edgar G. Ulmer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3437",
      "databaseFilmTitle": "The Black Tower",
      "FilmTitle": "The Black Tower",
      "AlternateTitle": "",
      "TitleArray": [
        "The Black Tower"
      ],
      "Year": "1987",
      "Director": "John Smith",
      "DirectorArray": [
        "John Smith"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3438",
      "databaseFilmTitle": "The Blade",
      "FilmTitle": "The Blade",
      "AlternateTitle": "Dao",
      "TitleArray": [
        "The Blade",
        "Dao"
      ],
      "Year": "1995",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3439",
      "databaseFilmTitle": "The Blair Witch Project",
      "FilmTitle": "The Blair Witch Project",
      "AlternateTitle": "",
      "TitleArray": [
        "The Blair Witch Project"
      ],
      "Year": "1999",
      "Director": "Daniel Myrick, Eduardo Sánchez",
      "DirectorArray": [
        "Daniel Myrick",
        "Eduardo Sánchez"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3440",
      "databaseFilmTitle": "The Blind Child",
      "FilmTitle": "The Blind Child",
      "AlternateTitle": "Blind kind",
      "TitleArray": [
        "The Blind Child",
        "Blind kind"
      ],
      "Year": "1964",
      "Director": "Johan van der Keuken",
      "DirectorArray": [
        "Johan van der Keuken"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3441",
      "databaseFilmTitle": "The Blind Man of Jerusalem",
      "FilmTitle": "The Blind Man of Jerusalem",
      "AlternateTitle": "L'aveugle de Jérusalem",
      "TitleArray": [
        "The Blind Man of Jerusalem",
        "L'aveugle de Jérusalem"
      ],
      "Year": "1909",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3442",
      "databaseFilmTitle": "The Blind Owl",
      "FilmTitle": "The Blind Owl",
      "AlternateTitle": "La chouette aveugle",
      "TitleArray": [
        "The Blind Owl",
        "La chouette aveugle"
      ],
      "Year": "1987",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "France, Switzerland",
      "CountryArray": [
        "France",
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3443",
      "databaseFilmTitle": "The Blonds",
      "FilmTitle": "The Blonds",
      "AlternateTitle": "Los rubios",
      "TitleArray": [
        "The Blonds",
        "Los rubios"
      ],
      "Year": "2003",
      "Director": "Albertina Carri",
      "DirectorArray": [
        "Albertina Carri"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3444",
      "databaseFilmTitle": "The Blood of a Poet",
      "FilmTitle": "The Blood of a Poet",
      "AlternateTitle": "Le sang d'un poète",
      "TitleArray": [
        "The Blood of a Poet",
        "Le sang d'un poète"
      ],
      "Year": "1932",
      "Director": "Jean Cocteau",
      "DirectorArray": [
        "Jean Cocteau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3445",
      "databaseFilmTitle": "The Blood of Hussain",
      "FilmTitle": "The Blood of Hussain",
      "AlternateTitle": "",
      "TitleArray": [
        "The Blood of Hussain"
      ],
      "Year": "1980",
      "Director": "Jamil Dehlavi",
      "DirectorArray": [
        "Jamil Dehlavi"
      ],
      "Country": "Pakistan",
      "CountryArray": [
        "Pakistan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3446",
      "databaseFilmTitle": "The Blood of Jesus",
      "FilmTitle": "The Blood of Jesus",
      "AlternateTitle": "",
      "TitleArray": [
        "The Blood of Jesus"
      ],
      "Year": "1941",
      "Director": "Spencher Williams",
      "DirectorArray": [
        "Spencher Williams"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3447",
      "databaseFilmTitle": "The Blue Angel",
      "FilmTitle": "The Blue Angel",
      "AlternateTitle": "Der blaue Engel",
      "TitleArray": [
        "The Blue Angel",
        "Der blaue Engel"
      ],
      "Year": "1930",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3448",
      "databaseFilmTitle": "The Blue Express",
      "FilmTitle": "The Blue Express",
      "AlternateTitle": "",
      "TitleArray": [
        "The Blue Express"
      ],
      "Year": "1929",
      "Director": "Ilya Trauberg",
      "DirectorArray": [
        "Ilya Trauberg"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3449",
      "databaseFilmTitle": "The Blue Planet",
      "FilmTitle": "The Blue Planet",
      "AlternateTitle": "Il pianeta azzurro",
      "TitleArray": [
        "The Blue Planet",
        "Il pianeta azzurro"
      ],
      "Year": "1980",
      "Director": "Franco Piavoli",
      "DirectorArray": [
        "Franco Piavoli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3450",
      "databaseFilmTitle": "The Boat",
      "FilmTitle": "The Boat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Boat"
      ],
      "Year": "1921",
      "Director": "Buster Keaton, Edward F. Cline",
      "DirectorArray": [
        "Buster Keaton",
        "Edward F. Cline"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3451",
      "databaseFilmTitle": "The Body Beautiful",
      "FilmTitle": "The Body Beautiful",
      "AlternateTitle": "",
      "TitleArray": [
        "The Body Beautiful"
      ],
      "Year": "1991",
      "Director": "Ngozi Onwurah",
      "DirectorArray": [
        "Ngozi Onwurah"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3452",
      "databaseFilmTitle": "The Body Confession",
      "FilmTitle": "The Body Confession",
      "AlternateTitle": "Yukche-ui gobak",
      "TitleArray": [
        "The Body Confession",
        "Yukche-ui gobak"
      ],
      "Year": "1964",
      "Director": "Yukche-ui gobak",
      "DirectorArray": [
        "Yukche-ui gobak"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3453",
      "databaseFilmTitle": "The Body Remembers When the World Broke Open",
      "FilmTitle": "The Body Remembers When the World Broke Open",
      "AlternateTitle": "",
      "TitleArray": [
        "The Body Remembers When the World Broke Open"
      ],
      "Year": "2019",
      "Director": "Elle-Máijá Tailfeathers, Kathleen Hepburn",
      "DirectorArray": [
        "Elle-Máijá Tailfeathers",
        "Kathleen Hepburn"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3454",
      "databaseFilmTitle": "The Bohemian Life",
      "FilmTitle": "The Bohemian Life",
      "AlternateTitle": "La vie de bohème",
      "TitleArray": [
        "The Bohemian Life",
        "La vie de bohème"
      ],
      "Year": "1992",
      "Director": "Aki Kaurismäki",
      "DirectorArray": [
        "Aki Kaurismäki"
      ],
      "Country": "Finland, France",
      "CountryArray": [
        "Finland",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3455",
      "databaseFilmTitle": "The Bourne Supremacy",
      "FilmTitle": "The Bourne Supremacy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bourne Supremacy"
      ],
      "Year": "2004",
      "Director": "Paul Greengrass",
      "DirectorArray": [
        "Paul Greengrass"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3456",
      "databaseFilmTitle": "The Bowery",
      "FilmTitle": "The Bowery",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bowery"
      ],
      "Year": "1933",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3457",
      "databaseFilmTitle": "The Box Theory",
      "FilmTitle": "The Box Theory",
      "AlternateTitle": "",
      "TitleArray": [
        "The Box Theory"
      ],
      "Year": "1984",
      "Director": "Owen Land",
      "DirectorArray": [
        "Owen Land"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3458",
      "databaseFilmTitle": "The Boys from Fengkuei",
      "FilmTitle": "The Boys from Fengkuei",
      "AlternateTitle": "Feng gui lai de ren",
      "TitleArray": [
        "The Boys from Fengkuei",
        "Feng gui lai de ren"
      ],
      "Year": "1983",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3459",
      "databaseFilmTitle": "The Bread and Alley",
      "FilmTitle": "The Bread and Alley",
      "AlternateTitle": "Nan va Koutcheh",
      "TitleArray": [
        "The Bread and Alley",
        "Nan va Koutcheh"
      ],
      "Year": "1970",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3460",
      "databaseFilmTitle": "The Breakfast Club",
      "FilmTitle": "The Breakfast Club",
      "AlternateTitle": "",
      "TitleArray": [
        "The Breakfast Club"
      ],
      "Year": "1985",
      "Director": "John Hughes",
      "DirectorArray": [
        "John Hughes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3461",
      "databaseFilmTitle": "The Brickmakers",
      "FilmTitle": "The Brickmakers",
      "AlternateTitle": "Chircales",
      "TitleArray": [
        "The Brickmakers",
        "Chircales"
      ],
      "Year": "1972",
      "Director": "Marta Rodríguez, Jorge Silva",
      "DirectorArray": [
        "Marta Rodríguez",
        "Jorge Silva"
      ],
      "Country": "Colombia",
      "CountryArray": [
        "Colombia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3462",
      "databaseFilmTitle": "The Bride Wore Black",
      "FilmTitle": "The Bride Wore Black",
      "AlternateTitle": "La mariée était en noir",
      "TitleArray": [
        "The Bride Wore Black",
        "La mariée était en noir"
      ],
      "Year": "1968",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3463",
      "databaseFilmTitle": "The Bridegroom, the Comedienne and the Pimp",
      "FilmTitle": "The Bridegroom, the Comedienne and the Pimp",
      "AlternateTitle": "Der Bräutigam, die Komödiantin und der Zuhälter",
      "TitleArray": [
        "The Bridegroom, the Comedienne and the Pimp",
        "Der Bräutigam, die Komödiantin und der Zuhälter"
      ],
      "Year": "1968",
      "Director": "Jean-Marie Straub",
      "DirectorArray": [
        "Jean-Marie Straub"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3464",
      "databaseFilmTitle": "The Brides of Dracula",
      "FilmTitle": "The Brides of Dracula",
      "AlternateTitle": "",
      "TitleArray": [
        "The Brides of Dracula"
      ],
      "Year": "1960",
      "Director": "Terence Fisher",
      "DirectorArray": [
        "Terence Fisher"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3465",
      "databaseFilmTitle": "The Bridge of Arts",
      "FilmTitle": "The Bridge of Arts",
      "AlternateTitle": "Le pont des arts",
      "TitleArray": [
        "The Bridge of Arts",
        "Le pont des arts"
      ],
      "Year": "2004",
      "Director": "Eugène Green",
      "DirectorArray": [
        "Eugène Green"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3466",
      "databaseFilmTitle": "The Bridge on the River Kwai",
      "FilmTitle": "The Bridge on the River Kwai",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bridge on the River Kwai"
      ],
      "Year": "1957",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3467",
      "databaseFilmTitle": "The Bridges of Madison County",
      "FilmTitle": "The Bridges of Madison County",
      "AlternateTitle": "",
      "TitleArray": [
        "The Bridges of Madison County"
      ],
      "Year": "1995",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3468",
      "databaseFilmTitle": "The Brood",
      "FilmTitle": "The Brood",
      "AlternateTitle": "",
      "TitleArray": [
        "The Brood"
      ],
      "Year": "1979",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3469",
      "databaseFilmTitle": "The Brothers Karamazov",
      "FilmTitle": "The Brothers Karamazov",
      "AlternateTitle": "Der Mörder Dimitri Karamasoff",
      "TitleArray": [
        "The Brothers Karamazov",
        "Der Mörder Dimitri Karamasoff"
      ],
      "Year": "1931",
      "Director": "Fyodor Otsep",
      "DirectorArray": [
        "Fyodor Otsep"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3470",
      "databaseFilmTitle": "The Burmese Harp",
      "FilmTitle": "The Burmese Harp",
      "AlternateTitle": "Biruma no tategoto",
      "TitleArray": [
        "The Burmese Harp",
        "Biruma no tategoto"
      ],
      "Year": "1956",
      "Director": "Kon Ichikawa",
      "DirectorArray": [
        "Kon Ichikawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3471",
      "databaseFilmTitle": "The Bus Driver",
      "FilmTitle": "The Bus Driver",
      "AlternateTitle": "Sawak al-Utubis",
      "TitleArray": [
        "The Bus Driver",
        "Sawak al-Utubis"
      ],
      "Year": "1982",
      "Director": "Atef El-Taieb",
      "DirectorArray": [
        "Atef El-Taieb"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3472",
      "databaseFilmTitle": "The Butcher",
      "FilmTitle": "The Butcher",
      "AlternateTitle": "Le boucher",
      "TitleArray": [
        "The Butcher",
        "Le boucher"
      ],
      "Year": "1970",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3473",
      "databaseFilmTitle": "The Cabbage Fairy",
      "FilmTitle": "The Cabbage Fairy",
      "AlternateTitle": "La fée aux choux",
      "TitleArray": [
        "The Cabbage Fairy",
        "La fée aux choux"
      ],
      "Year": "1900",
      "Director": "Alice Guy-Blaché",
      "DirectorArray": [
        "Alice Guy-Blaché"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3474",
      "databaseFilmTitle": "The Cabinet of Dr. Caligari",
      "FilmTitle": "The Cabinet of Dr. Caligari",
      "AlternateTitle": "Das cabinet des Dr. Caligari",
      "TitleArray": [
        "The Cabinet of Dr. Caligari",
        "Das cabinet des Dr. Caligari"
      ],
      "Year": "1920",
      "Director": "Rovert Wiene",
      "DirectorArray": [
        "Rovert Wiene"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3475",
      "databaseFilmTitle": "The Camera: Je or La Camera: I",
      "FilmTitle": "The Camera: Je or La Camera: I",
      "AlternateTitle": "",
      "TitleArray": [
        "The Camera: Je or La Camera: I"
      ],
      "Year": "1977",
      "Director": "Babette Mangolte",
      "DirectorArray": [
        "Babette Mangolte"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3476",
      "databaseFilmTitle": "The Cameraman",
      "FilmTitle": "The Cameraman",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cameraman"
      ],
      "Year": "1928",
      "Director": "Edward Sedgwick, Buster Keaton",
      "DirectorArray": [
        "Edward Sedgwick",
        "Buster Keaton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3477",
      "databaseFilmTitle": "The Cameraman's Revenge",
      "FilmTitle": "The Cameraman's Revenge",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cameraman's Revenge"
      ],
      "Year": "1912",
      "Director": "Wladyslaw Starewicz",
      "DirectorArray": [
        "Wladyslaw Starewicz"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3478",
      "databaseFilmTitle": "The Captive",
      "FilmTitle": "The Captive",
      "AlternateTitle": "La captive",
      "TitleArray": [
        "The Captive",
        "La captive"
      ],
      "Year": "2000",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3479",
      "databaseFilmTitle": "The Carabineers",
      "FilmTitle": "The Carabineers",
      "AlternateTitle": "Les carabiniers",
      "TitleArray": [
        "The Carabineers",
        "Les carabiniers"
      ],
      "Year": "1963",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3480",
      "databaseFilmTitle": "The Castle of Purity",
      "FilmTitle": "The Castle of Purity",
      "AlternateTitle": "El castillo de la pureza",
      "TitleArray": [
        "The Castle of Purity",
        "El castillo de la pureza"
      ],
      "Year": "1973",
      "Director": "Arturo Ripstein",
      "DirectorArray": [
        "Arturo Ripstein"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3481",
      "databaseFilmTitle": "The Cat",
      "FilmTitle": "The Cat",
      "AlternateTitle": "Mačka",
      "TitleArray": [
        "The Cat",
        "Mačka"
      ],
      "Year": "1971",
      "Director": "Zlatko Bourek",
      "DirectorArray": [
        "Zlatko Bourek"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3482",
      "databaseFilmTitle": "The Cat Concerto",
      "FilmTitle": "The Cat Concerto",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cat Concerto"
      ],
      "Year": "1947",
      "Director": "Joseph Barbera, William Hanna",
      "DirectorArray": [
        "Joseph Barbera",
        "William Hanna"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3483",
      "databaseFilmTitle": "The Cell",
      "FilmTitle": "The Cell",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cell"
      ],
      "Year": "2000",
      "Director": "Tarsem Singh",
      "DirectorArray": [
        "Tarsem Singh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3484",
      "databaseFilmTitle": "The Celluloid Closet",
      "FilmTitle": "The Celluloid Closet",
      "AlternateTitle": "",
      "TitleArray": [
        "The Celluloid Closet"
      ],
      "Year": "1995",
      "Director": "Rob Epstein, Jeffrey Friedman",
      "DirectorArray": [
        "Rob Epstein",
        "Jeffrey Friedman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3485",
      "databaseFilmTitle": "The Ceremony",
      "FilmTitle": "The Ceremony",
      "AlternateTitle": "Gishiki",
      "TitleArray": [
        "The Ceremony",
        "Gishiki"
      ],
      "Year": "1971",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3486",
      "databaseFilmTitle": "The Chamber",
      "FilmTitle": "The Chamber",
      "AlternateTitle": "La chambre",
      "TitleArray": [
        "The Chamber",
        "La chambre"
      ],
      "Year": "1972",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3487",
      "databaseFilmTitle": "The Chambermaid",
      "FilmTitle": "The Chambermaid",
      "AlternateTitle": "La camarista",
      "TitleArray": [
        "The Chambermaid",
        "La camarista"
      ],
      "Year": "2018",
      "Director": "Lila Avilés",
      "DirectorArray": [
        "Lila Avilés"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3488",
      "databaseFilmTitle": "The Changeling",
      "FilmTitle": "The Changeling",
      "AlternateTitle": "",
      "TitleArray": [
        "The Changeling"
      ],
      "Year": "1980",
      "Director": "Peter Medak",
      "DirectorArray": [
        "Peter Medak"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3489",
      "databaseFilmTitle": "The Chapman Report",
      "FilmTitle": "The Chapman Report",
      "AlternateTitle": "",
      "TitleArray": [
        "The Chapman Report"
      ],
      "Year": "1962",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3490",
      "databaseFilmTitle": "The Charge of the Light Brigade",
      "FilmTitle": "The Charge of the Light Brigade",
      "AlternateTitle": "",
      "TitleArray": [
        "The Charge of the Light Brigade"
      ],
      "Year": "1936",
      "Director": "Michael Curtiz, William Keighley",
      "DirectorArray": [
        "Michael Curtiz",
        "William Keighley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3491",
      "databaseFilmTitle": "The Cheat",
      "FilmTitle": "The Cheat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cheat"
      ],
      "Year": "1915",
      "Director": "Cecil B. DeMille",
      "DirectorArray": [
        "Cecil B. DeMille"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3492",
      "databaseFilmTitle": "The Chekist",
      "FilmTitle": "The Chekist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Chekist"
      ],
      "Year": "1992",
      "Director": "Aleksandr Rogozhkin",
      "DirectorArray": [
        "Aleksandr Rogozhkin"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3493",
      "databaseFilmTitle": "The Chelsea Girls",
      "FilmTitle": "The Chelsea Girls",
      "AlternateTitle": "",
      "TitleArray": [
        "The Chelsea Girls"
      ],
      "Year": "1966",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3494",
      "databaseFilmTitle": "The Child of Another",
      "FilmTitle": "The Child of Another",
      "AlternateTitle": "Muna moto",
      "TitleArray": [
        "The Child of Another",
        "Muna moto"
      ],
      "Year": "1975",
      "Director": "Jean-Pierre Dikongue-Pipa",
      "DirectorArray": [
        "Jean-Pierre Dikongue-Pipa"
      ],
      "Country": "Cameroon",
      "CountryArray": [
        "Cameroon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3495",
      "databaseFilmTitle": "The Childhood of Maxim Gorky",
      "FilmTitle": "The Childhood of Maxim Gorky",
      "AlternateTitle": "",
      "TitleArray": [
        "The Childhood of Maxim Gorky"
      ],
      "Year": "1938",
      "Director": "Mark Donskoy",
      "DirectorArray": [
        "Mark Donskoy"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "16",
      "1952votes": "8",
      "1962rank": "14",
      "1962votes": "10",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3496",
      "databaseFilmTitle": "The Children",
      "FilmTitle": "The Children",
      "AlternateTitle": "Les enfants",
      "TitleArray": [
        "The Children",
        "Les enfants"
      ],
      "Year": "1984",
      "Director": "Marguerite Duras, Jean Mascolo, Jean-Marc Turine",
      "DirectorArray": [
        "Marguerite Duras",
        "Jean Mascolo",
        "Jean-Marc Turine"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3497",
      "databaseFilmTitle": "The Church",
      "FilmTitle": "The Church",
      "AlternateTitle": "La chiesa",
      "TitleArray": [
        "The Church",
        "La chiesa"
      ],
      "Year": "1989",
      "Director": "Michele Soavi",
      "DirectorArray": [
        "Michele Soavi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3498",
      "databaseFilmTitle": "The Circle",
      "FilmTitle": "The Circle",
      "AlternateTitle": "Dayereh",
      "TitleArray": [
        "The Circle",
        "Dayereh"
      ],
      "Year": "2000",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3499",
      "databaseFilmTitle": "The Circular Scene",
      "FilmTitle": "The Circular Scene",
      "AlternateTitle": "La escena circular",
      "TitleArray": [
        "The Circular Scene",
        "La escena circular"
      ],
      "Year": "1982",
      "Director": "Claudio Caldini",
      "DirectorArray": [
        "Claudio Caldini"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3500",
      "databaseFilmTitle": "The Circus",
      "FilmTitle": "The Circus",
      "AlternateTitle": "",
      "TitleArray": [
        "The Circus"
      ],
      "Year": "1928",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3501",
      "databaseFilmTitle": "The Clay Bird",
      "FilmTitle": "The Clay Bird",
      "AlternateTitle": "Matir Moina",
      "TitleArray": [
        "The Clay Bird",
        "Matir Moina"
      ],
      "Year": "2002",
      "Director": "Tareque Masud",
      "DirectorArray": [
        "Tareque Masud"
      ],
      "Country": "Pakistan",
      "CountryArray": [
        "Pakistan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3502",
      "databaseFilmTitle": "The Clock (1945)",
      "FilmTitle": "The Clock",
      "AlternateTitle": "Under the Clock",
      "TitleArray": [
        "The Clock",
        "Under the Clock"
      ],
      "Year": "1945",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3503",
      "databaseFilmTitle": "The Clock (2010)",
      "FilmTitle": "The Clock",
      "AlternateTitle": "",
      "TitleArray": [
        "The Clock"
      ],
      "Year": "2010",
      "Director": "Christian Marclay",
      "DirectorArray": [
        "Christian Marclay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3504",
      "databaseFilmTitle": "The Cloud-Capped Star",
      "FilmTitle": "The Cloud-Capped Star",
      "AlternateTitle": "Meghe Dhaka Tara",
      "TitleArray": [
        "The Cloud-Capped Star",
        "Meghe Dhaka Tara"
      ],
      "Year": "1960",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "153",
      "2022votes": "19"
    },
    {
      "key": "3505",
      "databaseFilmTitle": "The Clowns",
      "FilmTitle": "The Clowns",
      "AlternateTitle": "I clowns",
      "TitleArray": [
        "The Clowns",
        "I clowns"
      ],
      "Year": "1970",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3506",
      "databaseFilmTitle": "The Club of the Great Cause",
      "FilmTitle": "The Club of the Great Cause",
      "AlternateTitle": "S.V.D. - Soyuz velikogo dela",
      "TitleArray": [
        "The Club of the Great Cause",
        "S.V.D. - Soyuz velikogo dela"
      ],
      "Year": "1927",
      "Director": "Grigori Kozintsev, Leonid Trauberg",
      "DirectorArray": [
        "Grigori Kozintsev",
        "Leonid Trauberg"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3507",
      "databaseFilmTitle": "The Cobweb",
      "FilmTitle": "The Cobweb",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cobweb"
      ],
      "Year": "1955",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3508",
      "databaseFilmTitle": "The Color of Love",
      "FilmTitle": "The Color of Love",
      "AlternateTitle": "",
      "TitleArray": [
        "The Color of Love"
      ],
      "Year": "1994",
      "Director": "Peggy Ahwesh",
      "DirectorArray": [
        "Peggy Ahwesh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3509",
      "databaseFilmTitle": "The Color of Paradise",
      "FilmTitle": "The Color of Paradise",
      "AlternateTitle": "Rang-e Khoda",
      "TitleArray": [
        "The Color of Paradise",
        "Rang-e Khoda"
      ],
      "Year": "1999",
      "Director": "Majid Majidi",
      "DirectorArray": [
        "Majid Majidi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3510",
      "databaseFilmTitle": "The Color of Pomegranates",
      "FilmTitle": "The Color of Pomegranates",
      "AlternateTitle": "Sayat Nova",
      "TitleArray": [
        "The Color of Pomegranates",
        "Sayat Nova"
      ],
      "Year": "1969",
      "Director": "Sergei Parajanov",
      "DirectorArray": [
        "Sergei Parajanov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "123",
      "2022votes": "25"
    },
    {
      "key": "3511",
      "databaseFilmTitle": "The Color Purple",
      "FilmTitle": "The Color Purple",
      "AlternateTitle": "",
      "TitleArray": [
        "The Color Purple"
      ],
      "Year": "1985",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3512",
      "databaseFilmTitle": "The Conformist",
      "FilmTitle": "The Conformist",
      "AlternateTitle": "Il conformista",
      "TitleArray": [
        "The Conformist",
        "Il conformista"
      ],
      "Year": "1970",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "118",
      "2022votes": "26"
    },
    {
      "key": "3513",
      "databaseFilmTitle": "The Connection",
      "FilmTitle": "The Connection",
      "AlternateTitle": "",
      "TitleArray": [
        "The Connection"
      ],
      "Year": "1961",
      "Director": "Shirley Clarke",
      "DirectorArray": [
        "Shirley Clarke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3514",
      "databaseFilmTitle": "The Consequences of Feminism",
      "FilmTitle": "The Consequences of Feminism",
      "AlternateTitle": "Les Résultats du féminisme",
      "TitleArray": [
        "The Consequences of Feminism",
        "Les Résultats du féminisme"
      ],
      "Year": "1906",
      "Director": "Alice Guy-Blaché",
      "DirectorArray": [
        "Alice Guy-Blaché"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3515",
      "databaseFilmTitle": "The Conversation",
      "FilmTitle": "The Conversation",
      "AlternateTitle": "",
      "TitleArray": [
        "The Conversation"
      ],
      "Year": "1974",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3516",
      "databaseFilmTitle": "The Cook, the Thief, His Wife & Her Lover",
      "FilmTitle": "The Cook, the Thief, His Wife & Her Lover",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cook, the Thief, His Wife & Her Lover"
      ],
      "Year": "1989",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3517",
      "databaseFilmTitle": "The Cool World",
      "FilmTitle": "The Cool World",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cool World"
      ],
      "Year": "1963",
      "Director": "Shirely Clarke",
      "DirectorArray": [
        "Shirely Clarke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3518",
      "databaseFilmTitle": "The Cordillera of Dreams",
      "FilmTitle": "The Cordillera of Dreams",
      "AlternateTitle": "La cordillère des songes",
      "TitleArray": [
        "The Cordillera of Dreams",
        "La cordillère des songes"
      ],
      "Year": "2019",
      "Director": "Patricio Guzmán",
      "DirectorArray": [
        "Patricio Guzmán"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3519",
      "databaseFilmTitle": "The Counselor",
      "FilmTitle": "The Counselor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Counselor"
      ],
      "Year": "2013",
      "Director": "Ridley Scott",
      "DirectorArray": [
        "Ridley Scott"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3520",
      "databaseFilmTitle": "The Count",
      "FilmTitle": "The Count",
      "AlternateTitle": "Kreivi",
      "TitleArray": [
        "The Count",
        "Kreivi"
      ],
      "Year": "1971",
      "Director": "Peter von Bagh",
      "DirectorArray": [
        "Peter von Bagh"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3521",
      "databaseFilmTitle": "The Country Doctor",
      "FilmTitle": "The Country Doctor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Country Doctor"
      ],
      "Year": "1909",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3522",
      "databaseFilmTitle": "The Courage of the People",
      "FilmTitle": "The Courage of the People",
      "AlternateTitle": "El coraje del pueblo",
      "TitleArray": [
        "The Courage of the People",
        "El coraje del pueblo"
      ],
      "Year": "1971",
      "Director": "Jorge Sanjinés",
      "DirectorArray": [
        "Jorge Sanjinés"
      ],
      "Country": "Bolivia, Italy",
      "CountryArray": [
        "Bolivia",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3523",
      "databaseFilmTitle": "The Court Jester",
      "FilmTitle": "The Court Jester",
      "AlternateTitle": "",
      "TitleArray": [
        "The Court Jester"
      ],
      "Year": "1955",
      "Director": "Melvin Frank, Norman Panama",
      "DirectorArray": [
        "Melvin Frank",
        "Norman Panama"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3524",
      "databaseFilmTitle": "The Covered Wagon",
      "FilmTitle": "The Covered Wagon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Covered Wagon"
      ],
      "Year": "1923",
      "Director": "James Cruze",
      "DirectorArray": [
        "James Cruze"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3525",
      "databaseFilmTitle": "The Cow",
      "FilmTitle": "The Cow",
      "AlternateTitle": "Gav",
      "TitleArray": [
        "The Cow",
        "Gav"
      ],
      "Year": "1969",
      "Director": "Dariush Mehrjui",
      "DirectorArray": [
        "Dariush Mehrjui"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3526",
      "databaseFilmTitle": "The Cranes Are Flying",
      "FilmTitle": "The Cranes Are Flying",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cranes Are Flying"
      ],
      "Year": "1957",
      "Director": "Mikhail Kalatozov",
      "DirectorArray": [
        "Mikhail Kalatozov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3527",
      "databaseFilmTitle": "The Crazy Ray",
      "FilmTitle": "The Crazy Ray",
      "AlternateTitle": "Paris qui dort",
      "TitleArray": [
        "The Crazy Ray",
        "Paris qui dort"
      ],
      "Year": "1925",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3528",
      "databaseFilmTitle": "The Cremator",
      "FilmTitle": "The Cremator",
      "AlternateTitle": "Spalovač mrtvol",
      "TitleArray": [
        "The Cremator",
        "Spalovač mrtvol"
      ],
      "Year": "1969",
      "Director": "Juraj Herz",
      "DirectorArray": [
        "Juraj Herz"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3529",
      "databaseFilmTitle": "The Crime of Monsieur Lange",
      "FilmTitle": "The Crime of Monsieur Lange",
      "AlternateTitle": "Le crime de Monsieur Lange",
      "TitleArray": [
        "The Crime of Monsieur Lange",
        "Le crime de Monsieur Lange"
      ],
      "Year": "1936",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3530",
      "databaseFilmTitle": "The Criminal",
      "FilmTitle": "The Criminal",
      "AlternateTitle": "",
      "TitleArray": [
        "The Criminal"
      ],
      "Year": "1960",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3531",
      "databaseFilmTitle": "The Criminal Life of Archibaldo de la Cruz",
      "FilmTitle": "The Criminal Life of Archibaldo de la Cruz",
      "AlternateTitle": "Ensayo de un crimen",
      "TitleArray": [
        "The Criminal Life of Archibaldo de la Cruz",
        "Ensayo de un crimen"
      ],
      "Year": "1955",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3532",
      "databaseFilmTitle": "The Crimson Kimono",
      "FilmTitle": "The Crimson Kimono",
      "AlternateTitle": "",
      "TitleArray": [
        "The Crimson Kimono"
      ],
      "Year": "1959",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3533",
      "databaseFilmTitle": "The Crowd",
      "FilmTitle": "The Crowd",
      "AlternateTitle": "",
      "TitleArray": [
        "The Crowd"
      ],
      "Year": "1928",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "3534",
      "databaseFilmTitle": "The Crucified Lovers",
      "FilmTitle": "The Crucified Lovers",
      "AlternateTitle": "Chikamatsu Monogataru",
      "TitleArray": [
        "The Crucified Lovers",
        "Chikamatsu Monogataru"
      ],
      "Year": "1954",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3535",
      "databaseFilmTitle": "The Cure",
      "FilmTitle": "The Cure",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cure"
      ],
      "Year": "1917",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3536",
      "databaseFilmTitle": "The Curious Case of Benjamin Button",
      "FilmTitle": "The Curious Case of Benjamin Button",
      "AlternateTitle": "",
      "TitleArray": [
        "The Curious Case of Benjamin Button"
      ],
      "Year": "2008",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3537",
      "databaseFilmTitle": "The Cut Ups",
      "FilmTitle": "The Cut Ups",
      "AlternateTitle": "",
      "TitleArray": [
        "The Cut Ups"
      ],
      "Year": "1966",
      "Director": "Antony Balch, William S. Burroughs",
      "DirectorArray": [
        "Antony Balch",
        "William S. Burroughs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3538",
      "databaseFilmTitle": "The Cyclist",
      "FilmTitle": "The Cyclist",
      "AlternateTitle": "Bicycleran",
      "TitleArray": [
        "The Cyclist",
        "Bicycleran"
      ],
      "Year": "1989",
      "Director": "Mohsen Makhmalbaf",
      "DirectorArray": [
        "Mohsen Makhmalbaf"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3539",
      "databaseFilmTitle": "The Czech Year",
      "FilmTitle": "The Czech Year",
      "AlternateTitle": "Špalíček",
      "TitleArray": [
        "The Czech Year",
        "Špalíček"
      ],
      "Year": "1947",
      "Director": "Jiří Trnka",
      "DirectorArray": [
        "Jiří Trnka"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3540",
      "databaseFilmTitle": "The Damned",
      "FilmTitle": "The Damned",
      "AlternateTitle": "La caduta degli dei - Götterdämmerung",
      "TitleArray": [
        "The Damned",
        "La caduta degli dei - Götterdämmerung"
      ],
      "Year": "1969",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy, West Germany",
      "CountryArray": [
        "Italy",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3541",
      "databaseFilmTitle": "The Dance of Life",
      "FilmTitle": "The Dance of Life",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dance of Life"
      ],
      "Year": "1929",
      "Director": "John Cromwell, A. Edward Sutherland",
      "DirectorArray": [
        "John Cromwell",
        "A. Edward Sutherland"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3542",
      "databaseFilmTitle": "The Dante Quartet",
      "FilmTitle": "The Dante Quartet",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dante Quartet"
      ],
      "Year": "1987",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3543",
      "databaseFilmTitle": "The Dark Knight",
      "FilmTitle": "The Dark Knight",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dark Knight"
      ],
      "Year": "2008",
      "Director": "Christopher Nolan",
      "DirectorArray": [
        "Christopher Nolan"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3544",
      "databaseFilmTitle": "The Day After",
      "FilmTitle": "The Day After",
      "AlternateTitle": "Geu-hu",
      "TitleArray": [
        "The Day After",
        "Geu-hu"
      ],
      "Year": "2017",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3545",
      "databaseFilmTitle": "The Day He Arrives",
      "FilmTitle": "The Day He Arrives",
      "AlternateTitle": "Book chon bang hyang",
      "TitleArray": [
        "The Day He Arrives",
        "Book chon bang hyang"
      ],
      "Year": "2011",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3546",
      "databaseFilmTitle": "The Day of the Beast",
      "FilmTitle": "The Day of the Beast",
      "AlternateTitle": "El día de la bestia",
      "TitleArray": [
        "The Day of the Beast",
        "El día de la bestia"
      ],
      "Year": "1995",
      "Director": "Álex de la Iglesia",
      "DirectorArray": [
        "Álex de la Iglesia"
      ],
      "Country": "Spain, Italy",
      "CountryArray": [
        "Spain",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3547",
      "databaseFilmTitle": "The Day the Earth Caught Fire",
      "FilmTitle": "The Day the Earth Caught Fire",
      "AlternateTitle": "",
      "TitleArray": [
        "The Day the Earth Caught Fire"
      ],
      "Year": "1961",
      "Director": "Val Guest",
      "DirectorArray": [
        "Val Guest"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3548",
      "databaseFilmTitle": "The Days of Eclipse",
      "FilmTitle": "The Days of Eclipse",
      "AlternateTitle": "",
      "TitleArray": [
        "The Days of Eclipse"
      ],
      "Year": "1988",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3549",
      "databaseFilmTitle": "The Dead",
      "FilmTitle": "The Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dead"
      ],
      "Year": "1987",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3550",
      "databaseFilmTitle": "The Dead Nation",
      "FilmTitle": "The Dead Nation",
      "AlternateTitle": "Țara moartă",
      "TitleArray": [
        "The Dead Nation",
        "Țara moartă"
      ],
      "Year": "2017",
      "Director": "Radu Jude",
      "DirectorArray": [
        "Radu Jude"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3551",
      "databaseFilmTitle": "The Dead Zone",
      "FilmTitle": "The Dead Zone",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dead Zone"
      ],
      "Year": "1983",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3552",
      "databaseFilmTitle": "The Death of Empedocles",
      "FilmTitle": "The Death of Empedocles",
      "AlternateTitle": "Der Tod des Empedokles; oder: wenn dann der Erde Grün von neuem euch erglänzt",
      "TitleArray": [
        "The Death of Empedocles",
        "Der Tod des Empedokles",
        "oder: wenn dann der Erde Grün von neuem euch erglänzt"
      ],
      "Year": "1987",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3553",
      "databaseFilmTitle": "The Death of Louis XIV",
      "FilmTitle": "The Death of Louis XIV",
      "AlternateTitle": "La mort de Louis XIV",
      "TitleArray": [
        "The Death of Louis XIV",
        "La mort de Louis XIV"
      ],
      "Year": "2016",
      "Director": "Albert Serra",
      "DirectorArray": [
        "Albert Serra"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3554",
      "databaseFilmTitle": "The Death of Maria Malibran",
      "FilmTitle": "The Death of Maria Malibran",
      "AlternateTitle": "Der tod der Maria Malibran",
      "TitleArray": [
        "The Death of Maria Malibran",
        "Der tod der Maria Malibran"
      ],
      "Year": "1972",
      "Director": "Werner Schroeter",
      "DirectorArray": [
        "Werner Schroeter"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3555",
      "databaseFilmTitle": "The Death of Mr. Lăzărescu",
      "FilmTitle": "The Death of Mr. Lăzărescu",
      "AlternateTitle": "Moartea domnului Lăzărescu",
      "TitleArray": [
        "The Death of Mr. Lăzărescu",
        "Moartea domnului Lăzărescu"
      ],
      "Year": "2005",
      "Director": "Christi Puiu",
      "DirectorArray": [
        "Christi Puiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3556",
      "databaseFilmTitle": "The Decalogue",
      "FilmTitle": "The Decalogue",
      "AlternateTitle": "Dekalog",
      "TitleArray": [
        "The Decalogue",
        "Dekalog"
      ],
      "Year": "1989",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "3557",
      "databaseFilmTitle": "The Decameron",
      "FilmTitle": "The Decameron",
      "AlternateTitle": "Il decameron",
      "TitleArray": [
        "The Decameron",
        "Il decameron"
      ],
      "Year": "1971",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3558",
      "databaseFilmTitle": "The Deer Hunter",
      "FilmTitle": "The Deer Hunter",
      "AlternateTitle": "",
      "TitleArray": [
        "The Deer Hunter"
      ],
      "Year": "1978",
      "Director": "Michael Cimino",
      "DirectorArray": [
        "Michael Cimino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "3559",
      "databaseFilmTitle": "The Departed",
      "FilmTitle": "The Departed",
      "AlternateTitle": "",
      "TitleArray": [
        "The Departed"
      ],
      "Year": "2006",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3560",
      "databaseFilmTitle": "The Departure",
      "FilmTitle": "The Departure",
      "AlternateTitle": "Le Départ",
      "TitleArray": [
        "The Departure",
        "Le Départ"
      ],
      "Year": "1967",
      "Director": "Jerzy Skolimowski",
      "DirectorArray": [
        "Jerzy Skolimowski"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3561",
      "databaseFilmTitle": "The Deserter and the Nomads",
      "FilmTitle": "The Deserter and the Nomads",
      "AlternateTitle": "Zbehovia a pútnici",
      "TitleArray": [
        "The Deserter and the Nomads",
        "Zbehovia a pútnici"
      ],
      "Year": "1968",
      "Director": "Juraj Jakubisko",
      "DirectorArray": [
        "Juraj Jakubisko"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3562",
      "databaseFilmTitle": "The Devil and Daniel Webster",
      "FilmTitle": "The Devil and Daniel Webster",
      "AlternateTitle": "The Devil and Daniel Webster",
      "TitleArray": [
        "The Devil and Daniel Webster",
        "The Devil and Daniel Webster"
      ],
      "Year": "1941",
      "Director": "William Dieterle",
      "DirectorArray": [
        "William Dieterle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3563",
      "databaseFilmTitle": "The Devil is a Woman",
      "FilmTitle": "The Devil is a Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "The Devil is a Woman"
      ],
      "Year": "1935",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3564",
      "databaseFilmTitle": "The Devil Never Sleeps",
      "FilmTitle": "The Devil Never Sleeps",
      "AlternateTitle": "El diablo nunca duerme",
      "TitleArray": [
        "The Devil Never Sleeps",
        "El diablo nunca duerme"
      ],
      "Year": "1994",
      "Director": "Lourdes Portillo",
      "DirectorArray": [
        "Lourdes Portillo"
      ],
      "Country": "Mexico, United States",
      "CountryArray": [
        "Mexico",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3565",
      "databaseFilmTitle": "The Devil Rides Out",
      "FilmTitle": "The Devil Rides Out",
      "AlternateTitle": "The Devil's Bride",
      "TitleArray": [
        "The Devil Rides Out",
        "The Devil's Bride"
      ],
      "Year": "1968",
      "Director": "Terence Fisher",
      "DirectorArray": [
        "Terence Fisher"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3566",
      "databaseFilmTitle": "The Devil Strikes at Night",
      "FilmTitle": "The Devil Strikes at Night",
      "AlternateTitle": "Nachts, wenn der Teufel kam",
      "TitleArray": [
        "The Devil Strikes at Night",
        "Nachts, wenn der Teufel kam"
      ],
      "Year": "1957",
      "Director": "Robert Siodmak",
      "DirectorArray": [
        "Robert Siodmak"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3567",
      "databaseFilmTitle": "The Devil Wears Prada",
      "FilmTitle": "The Devil Wears Prada",
      "AlternateTitle": "",
      "TitleArray": [
        "The Devil Wears Prada"
      ],
      "Year": "2006",
      "Director": "David Frankel",
      "DirectorArray": [
        "David Frankel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3568",
      "databaseFilmTitle": "The Devil, Probably",
      "FilmTitle": "The Devil, Probably",
      "AlternateTitle": "Le diable, probablement...",
      "TitleArray": [
        "The Devil, Probably",
        "Le diable, probablement..."
      ],
      "Year": "1977",
      "Director": "Robert Bresson",
      "DirectorArray": [
        "Robert Bresson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3569",
      "databaseFilmTitle": "The Devil's Backbone",
      "FilmTitle": "The Devil's Backbone",
      "AlternateTitle": "El espinazo del diablo",
      "TitleArray": [
        "The Devil's Backbone",
        "El espinazo del diablo"
      ],
      "Year": "2001",
      "Director": "Guillermo del Toro",
      "DirectorArray": [
        "Guillermo del Toro"
      ],
      "Country": "Spain, Mexico",
      "CountryArray": [
        "Spain",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3570",
      "databaseFilmTitle": "The Devils",
      "FilmTitle": "The Devils",
      "AlternateTitle": "",
      "TitleArray": [
        "The Devils"
      ],
      "Year": "1971",
      "Director": "Ken Russell",
      "DirectorArray": [
        "Ken Russell"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3571",
      "databaseFilmTitle": "The Diary of a Teenage Girl",
      "FilmTitle": "The Diary of a Teenage Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "The Diary of a Teenage Girl"
      ],
      "Year": "2015",
      "Director": "Marielle Heller",
      "DirectorArray": [
        "Marielle Heller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3572",
      "databaseFilmTitle": "The Dinner Game",
      "FilmTitle": "The Dinner Game",
      "AlternateTitle": "Le Dîner de Cons",
      "TitleArray": [
        "The Dinner Game",
        "Le Dîner de Cons"
      ],
      "Year": "1998",
      "Director": "Francis Verber",
      "DirectorArray": [
        "Francis Verber"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3573",
      "databaseFilmTitle": "The Discreet Charm of the Bourgeoisie",
      "FilmTitle": "The Discreet Charm of the Bourgeoisie",
      "AlternateTitle": "Le charme discret de la bourgeoisie",
      "TitleArray": [
        "The Discreet Charm of the Bourgeoisie",
        "Le charme discret de la bourgeoisie"
      ],
      "Year": "1972",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "3574",
      "databaseFilmTitle": "The Disenchantment",
      "FilmTitle": "The Disenchantment",
      "AlternateTitle": "El desencanto",
      "TitleArray": [
        "The Disenchantment",
        "El desencanto"
      ],
      "Year": "1976",
      "Director": "Jaime Chávarri",
      "DirectorArray": [
        "Jaime Chávarri"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3575",
      "databaseFilmTitle": "The Disorderly Orderly",
      "FilmTitle": "The Disorderly Orderly",
      "AlternateTitle": "",
      "TitleArray": [
        "The Disorderly Orderly"
      ],
      "Year": "1964",
      "Director": "Frank Tashlin",
      "DirectorArray": [
        "Frank Tashlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3576",
      "databaseFilmTitle": "The Ditch",
      "FilmTitle": "The Ditch",
      "AlternateTitle": "Jiabiangou",
      "TitleArray": [
        "The Ditch",
        "Jiabiangou"
      ],
      "Year": "2010",
      "Director": "Wang Bing",
      "DirectorArray": [
        "Wang Bing"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3577",
      "databaseFilmTitle": "The Diving Bell and the Butterfly",
      "FilmTitle": "The Diving Bell and the Butterfly",
      "AlternateTitle": "Le scaphandre et le papillon",
      "TitleArray": [
        "The Diving Bell and the Butterfly",
        "Le scaphandre et le papillon"
      ],
      "Year": "2007",
      "Director": "Julian Schnabel",
      "DirectorArray": [
        "Julian Schnabel"
      ],
      "Country": "France, United States",
      "CountryArray": [
        "France",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3578",
      "databaseFilmTitle": "The Docks of New York",
      "FilmTitle": "The Docks of New York",
      "AlternateTitle": "",
      "TitleArray": [
        "The Docks of New York"
      ],
      "Year": "1928",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3579",
      "databaseFilmTitle": "The Doom Generation",
      "FilmTitle": "The Doom Generation",
      "AlternateTitle": "",
      "TitleArray": [
        "The Doom Generation"
      ],
      "Year": "1995",
      "Director": "Gregg Araki",
      "DirectorArray": [
        "Gregg Araki"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3580",
      "databaseFilmTitle": "The Doors",
      "FilmTitle": "The Doors",
      "AlternateTitle": "",
      "TitleArray": [
        "The Doors"
      ],
      "Year": "1991",
      "Director": "Oliver Stone",
      "DirectorArray": [
        "Oliver Stone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3581",
      "databaseFilmTitle": "The Double Life of Véronique",
      "FilmTitle": "The Double Life of Véronique",
      "AlternateTitle": "La double vie de Véronique",
      "TitleArray": [
        "The Double Life of Véronique",
        "La double vie de Véronique"
      ],
      "Year": "1991",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3582",
      "databaseFilmTitle": "The Downfall of Osen",
      "FilmTitle": "The Downfall of Osen",
      "AlternateTitle": "Orizuru Osen",
      "TitleArray": [
        "The Downfall of Osen",
        "Orizuru Osen"
      ],
      "Year": "1935",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3583",
      "databaseFilmTitle": "The Dragon is the Frame",
      "FilmTitle": "The Dragon is the Frame",
      "AlternateTitle": "",
      "TitleArray": [
        "The Dragon is the Frame"
      ],
      "Year": "2014",
      "Director": "Mary Helena Clark",
      "DirectorArray": [
        "Mary Helena Clark"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3584",
      "databaseFilmTitle": "The Draughtsman's Contract",
      "FilmTitle": "The Draughtsman's Contract",
      "AlternateTitle": "",
      "TitleArray": [
        "The Draughtsman's Contract"
      ],
      "Year": "1982",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3585",
      "databaseFilmTitle": "The Dreamed Ones",
      "FilmTitle": "The Dreamed Ones",
      "AlternateTitle": "Die Geträumten",
      "TitleArray": [
        "The Dreamed Ones",
        "Die Geträumten"
      ],
      "Year": "2016",
      "Director": "Ruth Beckermann",
      "DirectorArray": [
        "Ruth Beckermann"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3586",
      "databaseFilmTitle": "The Dreamed Path",
      "FilmTitle": "The Dreamed Path",
      "AlternateTitle": "Der traumhafte Weg",
      "TitleArray": [
        "The Dreamed Path",
        "Der traumhafte Weg"
      ],
      "Year": "2016",
      "Director": "Angela Schanelec",
      "DirectorArray": [
        "Angela Schanelec"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3587",
      "databaseFilmTitle": "The Dreams of the Centenarians",
      "FilmTitle": "The Dreams of the Centenarians",
      "AlternateTitle": "imtamečių godos",
      "TitleArray": [
        "The Dreams of the Centenarians",
        "imtamečių godos"
      ],
      "Year": "1969",
      "Director": "Robertas Verba",
      "DirectorArray": [
        "Robertas Verba"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3588",
      "databaseFilmTitle": "The Driver",
      "FilmTitle": "The Driver",
      "AlternateTitle": "",
      "TitleArray": [
        "The Driver"
      ],
      "Year": "1978",
      "Director": "Walter Hill",
      "DirectorArray": [
        "Walter Hill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3589",
      "databaseFilmTitle": "The Duchess of Langeais",
      "FilmTitle": "The Duchess of Langeais",
      "AlternateTitle": "Ne touchez pas la hache",
      "TitleArray": [
        "The Duchess of Langeais",
        "Ne touchez pas la hache"
      ],
      "Year": "2007",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3590",
      "databaseFilmTitle": "The Ducksters",
      "FilmTitle": "The Ducksters",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ducksters"
      ],
      "Year": "1950",
      "Director": "Chuck Jones",
      "DirectorArray": [
        "Chuck Jones"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3591",
      "databaseFilmTitle": "The Duellists",
      "FilmTitle": "The Duellists",
      "AlternateTitle": "",
      "TitleArray": [
        "The Duellists"
      ],
      "Year": "1977",
      "Director": "Ridley Scott",
      "DirectorArray": [
        "Ridley Scott"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3592",
      "databaseFilmTitle": "The Duke of Burgundy",
      "FilmTitle": "The Duke of Burgundy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Duke of Burgundy"
      ],
      "Year": "2014",
      "Director": "Peter Strickland",
      "DirectorArray": [
        "Peter Strickland"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3593",
      "databaseFilmTitle": "The Dupes",
      "FilmTitle": "The Dupes",
      "AlternateTitle": "Al-makhdu'un",
      "TitleArray": [
        "The Dupes",
        "Al-makhdu'un"
      ],
      "Year": "1972",
      "Director": "Tewfik Saleh",
      "DirectorArray": [
        "Tewfik Saleh"
      ],
      "Country": "Syria",
      "CountryArray": [
        "Syria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3594",
      "databaseFilmTitle": "The Dying Swan",
      "FilmTitle": "The Dying Swan",
      "AlternateTitle": "Umirayushchiy lebed",
      "TitleArray": [
        "The Dying Swan",
        "Umirayushchiy lebed"
      ],
      "Year": "1917",
      "Director": "Yevgeni Bauer",
      "DirectorArray": [
        "Yevgeni Bauer"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3595",
      "databaseFilmTitle": "The Eagle Path",
      "FilmTitle": "The Eagle Path",
      "AlternateTitle": "[Cannes 2010 Market Version]",
      "TitleArray": [
        "The Eagle Path",
        "[Cannes 2010 Market Version]"
      ],
      "Year": "2010",
      "Director": "Jean-Claude van Damme",
      "DirectorArray": [
        "Jean-Claude van Damme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3596",
      "databaseFilmTitle": "The Ear",
      "FilmTitle": "The Ear",
      "AlternateTitle": "Ucho",
      "TitleArray": [
        "The Ear",
        "Ucho"
      ],
      "Year": "1970",
      "Director": "Karel Kachyna",
      "DirectorArray": [
        "Karel Kachyna"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3597",
      "databaseFilmTitle": "The Earrings of Madame de...",
      "FilmTitle": "The Earrings of Madame de . . .",
      "AlternateTitle": "",
      "TitleArray": [
        "The Earrings of Madame de . . ."
      ],
      "Year": "1953",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "90",
      "2022votes": "32"
    },
    {
      "key": "3598",
      "databaseFilmTitle": "The East is Red",
      "FilmTitle": "The East is Red",
      "AlternateTitle": "Dongfang hong",
      "TitleArray": [
        "The East is Red",
        "Dongfang hong"
      ],
      "Year": "1965",
      "Director": "Ping Wang",
      "DirectorArray": [
        "Ping Wang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3599",
      "databaseFilmTitle": "The Easy Life",
      "FilmTitle": "The Easy Life",
      "AlternateTitle": "Il sorpasso",
      "TitleArray": [
        "The Easy Life",
        "Il sorpasso"
      ],
      "Year": "1962",
      "Director": "Dino Risi",
      "DirectorArray": [
        "Dino Risi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3600",
      "databaseFilmTitle": "The Eclipse",
      "FilmTitle": "The Eclipse",
      "AlternateTitle": "L'eclisse",
      "TitleArray": [
        "The Eclipse",
        "L'eclisse"
      ],
      "Year": "1962",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "73",
      "2012votes": "22",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "3601",
      "databaseFilmTitle": "the effects of the atomic bomb on hiroshima and nagasaki",
      "FilmTitle": "the effects of the atomic bomb on hiroshima and nagasaki",
      "AlternateTitle": "",
      "TitleArray": [
        "the effects of the atomic bomb on hiroshima and nagasaki"
      ],
      "Year": "1946",
      "Director": "Ito Sueo",
      "DirectorArray": [
        "Ito Sueo"
      ],
      "Country": "Japan, United States",
      "CountryArray": [
        "Japan",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3602",
      "databaseFilmTitle": "The Elephant Keeper",
      "FilmTitle": "The Elephant Keeper",
      "AlternateTitle": "Khon liang change",
      "TitleArray": [
        "The Elephant Keeper",
        "Khon liang change"
      ],
      "Year": "1987",
      "Director": "Chatrichalerm Yukol",
      "DirectorArray": [
        "Chatrichalerm Yukol"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3603",
      "databaseFilmTitle": "The Elephant Man",
      "FilmTitle": "The Elephant Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Elephant Man"
      ],
      "Year": "1980",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3604",
      "databaseFilmTitle": "The Eleventh Year",
      "FilmTitle": "The Eleventh Year",
      "AlternateTitle": "Odinnadtsatyy",
      "TitleArray": [
        "The Eleventh Year",
        "Odinnadtsatyy"
      ],
      "Year": "1928",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3605",
      "databaseFilmTitle": "The Elusive Corporal",
      "FilmTitle": "The Elusive Corporal",
      "AlternateTitle": "Le caporal épinglé",
      "TitleArray": [
        "The Elusive Corporal",
        "Le caporal épinglé"
      ],
      "Year": "1962",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3606",
      "databaseFilmTitle": "The Emigrants",
      "FilmTitle": "The Emigrants",
      "AlternateTitle": "Utvandrarna",
      "TitleArray": [
        "The Emigrants",
        "Utvandrarna"
      ],
      "Year": "1971",
      "Director": "Jan Troell",
      "DirectorArray": [
        "Jan Troell"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3607",
      "databaseFilmTitle": "The Emperor of the Mughals",
      "FilmTitle": "The Emperor of the Mughals",
      "AlternateTitle": "Mughal-e-Azam",
      "TitleArray": [
        "The Emperor of the Mughals",
        "Mughal-e-Azam"
      ],
      "Year": "1960",
      "Director": "K. Asif",
      "DirectorArray": [
        "K. Asif"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3608",
      "databaseFilmTitle": "The Emperor's Naked Army Marches On",
      "FilmTitle": "The Emperor's Naked Army Marches On",
      "AlternateTitle": "Yuki yukite shingun",
      "TitleArray": [
        "The Emperor's Naked Army Marches On",
        "Yuki yukite shingun"
      ],
      "Year": "1987",
      "Director": "Kazuo Hara",
      "DirectorArray": [
        "Kazuo Hara"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3609",
      "databaseFilmTitle": "The Enchanted Desna",
      "FilmTitle": "The Enchanted Desna",
      "AlternateTitle": "",
      "TitleArray": [
        "The Enchanted Desna"
      ],
      "Year": "1964",
      "Director": "Yuliya Solntseva",
      "DirectorArray": [
        "Yuliya Solntseva"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3610",
      "databaseFilmTitle": "The Enclosed Valley",
      "FilmTitle": "The Enclosed Valley",
      "AlternateTitle": "La vallee close",
      "TitleArray": [
        "The Enclosed Valley",
        "La vallee close"
      ],
      "Year": "1955",
      "Director": "Jean-Claude Rousseau",
      "DirectorArray": [
        "Jean-Claude Rousseau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3611",
      "databaseFilmTitle": "The End",
      "FilmTitle": "The End",
      "AlternateTitle": "",
      "TitleArray": [
        "The End"
      ],
      "Year": "1953",
      "Director": "Christopher Maclaine",
      "DirectorArray": [
        "Christopher Maclaine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3612",
      "databaseFilmTitle": "The End of Evangelion",
      "FilmTitle": "The End of Evangelion",
      "AlternateTitle": "Shin seiki Evangelion Gekijô-ban: Air/Magokoro wo, kimi ni",
      "TitleArray": [
        "The End of Evangelion",
        "Shin seiki Evangelion Gekijô-ban: Air/Magokoro wo, kimi ni"
      ],
      "Year": "1997",
      "Director": "Kazuya Tsurumaki, Hideaki Anno",
      "DirectorArray": [
        "Kazuya Tsurumaki",
        "Hideaki Anno"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3613",
      "databaseFilmTitle": "The End of St. Petersburg",
      "FilmTitle": "The End of St. Petersburg",
      "AlternateTitle": "Konets Sankt-Peterburga",
      "TitleArray": [
        "The End of St. Petersburg",
        "Konets Sankt-Peterburga"
      ],
      "Year": "1927",
      "Director": "Vsevolod Pudovkin, Mikhail Doller",
      "DirectorArray": [
        "Vsevolod Pudovkin",
        "Mikhail Doller"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3614",
      "databaseFilmTitle": "The End of Summer",
      "FilmTitle": "The End of Summer",
      "AlternateTitle": "Kohayawaga-ke no aki",
      "TitleArray": [
        "The End of Summer",
        "Kohayawaga-ke no aki"
      ],
      "Year": "1961",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3615",
      "databaseFilmTitle": "The End of the Day",
      "FilmTitle": "The End of the Day",
      "AlternateTitle": "La fin du jour",
      "TitleArray": [
        "The End of the Day",
        "La fin du jour"
      ],
      "Year": "1939",
      "Director": "Julien Divivier",
      "DirectorArray": [
        "Julien Divivier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3616",
      "databaseFilmTitle": "The English Patient",
      "FilmTitle": "The English Patient",
      "AlternateTitle": "",
      "TitleArray": [
        "The English Patient"
      ],
      "Year": "1996",
      "Director": "Anthony Minghella",
      "DirectorArray": [
        "Anthony Minghella"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3617",
      "databaseFilmTitle": "The Enigma of Kaspar Hauser",
      "FilmTitle": "The Enigma of Kaspar Hauser",
      "AlternateTitle": "Jeder für sich und Gott gegen alle",
      "TitleArray": [
        "The Enigma of Kaspar Hauser",
        "Jeder für sich und Gott gegen alle"
      ],
      "Year": "1974",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3618",
      "databaseFilmTitle": "The Equalizer",
      "FilmTitle": "The Equalizer",
      "AlternateTitle": "",
      "TitleArray": [
        "The Equalizer"
      ],
      "Year": "2014",
      "Director": "Antoine Fuqua",
      "DirectorArray": [
        "Antoine Fuqua"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3619",
      "databaseFilmTitle": "The Errand Boy",
      "FilmTitle": "The Errand Boy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Errand Boy"
      ],
      "Year": "1961",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3620",
      "databaseFilmTitle": "The Eternal Breasts (Forever a Woman)",
      "FilmTitle": "The Eternal Breasts (Forever a Woman)",
      "AlternateTitle": "Chibusa yo eien nare",
      "TitleArray": [
        "The Eternal Breasts (Forever a Woman)",
        "Chibusa yo eien nare"
      ],
      "Year": "1955",
      "Director": "Kinuyo Tanaka",
      "DirectorArray": [
        "Kinuyo Tanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3621",
      "databaseFilmTitle": "The Executioner",
      "FilmTitle": "The Executioner",
      "AlternateTitle": "El verdugo",
      "TitleArray": [
        "The Executioner",
        "El verdugo"
      ],
      "Year": "1963",
      "Director": "Luis García Berlanga",
      "DirectorArray": [
        "Luis García Berlanga"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3622",
      "databaseFilmTitle": "The Exiles",
      "FilmTitle": "The Exiles",
      "AlternateTitle": "",
      "TitleArray": [
        "The Exiles"
      ],
      "Year": "1961",
      "Director": "Kent MacKenzie",
      "DirectorArray": [
        "Kent MacKenzie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3623",
      "databaseFilmTitle": "The Exorcist",
      "FilmTitle": "The Exorcist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Exorcist"
      ],
      "Year": "1973",
      "Director": "William Friedkin",
      "DirectorArray": [
        "William Friedkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3624",
      "databaseFilmTitle": "The Experiment",
      "FilmTitle": "The Experiment",
      "AlternateTitle": "Das Experiment",
      "TitleArray": [
        "The Experiment",
        "Das Experiment"
      ],
      "Year": "2001",
      "Director": "Oliver Hirschbiegel",
      "DirectorArray": [
        "Oliver Hirschbiegel"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3625",
      "databaseFilmTitle": "The Exterminating Angel",
      "FilmTitle": "The Exterminating Angel",
      "AlternateTitle": "El ángel exterminador",
      "TitleArray": [
        "The Exterminating Angel",
        "El ángel exterminador"
      ],
      "Year": "1962",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "3626",
      "databaseFilmTitle": "The External World",
      "FilmTitle": "The External World",
      "AlternateTitle": "",
      "TitleArray": [
        "The External World"
      ],
      "Year": "2010",
      "Director": "David O'Reilly",
      "DirectorArray": [
        "David O'Reilly"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3627",
      "databaseFilmTitle": "The Face with Two Left Feet",
      "FilmTitle": "The Face with Two Left Feet",
      "AlternateTitle": "John Travolto... Da un insolito destino",
      "TitleArray": [
        "The Face with Two Left Feet",
        "John Travolto... Da un insolito destino"
      ],
      "Year": "1979",
      "Director": "Neri Parenti",
      "DirectorArray": [
        "Neri Parenti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3628",
      "databaseFilmTitle": "The Falconet",
      "FilmTitle": "The Falconet",
      "AlternateTitle": "Zanburak",
      "TitleArray": [
        "The Falconet",
        "Zanburak"
      ],
      "Year": "1975",
      "Director": "Farokh Ghafari",
      "DirectorArray": [
        "Farokh Ghafari"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3629",
      "databaseFilmTitle": "The Fall",
      "FilmTitle": "The Fall",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fall"
      ],
      "Year": "1969",
      "Director": "Peter Whitehead",
      "DirectorArray": [
        "Peter Whitehead"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3630",
      "databaseFilmTitle": "The Fall of the House of Usher",
      "FilmTitle": "The Fall of the House of Usher",
      "AlternateTitle": "La chute de la maison Usher",
      "TitleArray": [
        "The Fall of the House of Usher",
        "La chute de la maison Usher"
      ],
      "Year": "1928",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3631",
      "databaseFilmTitle": "The Fall of the Romanov Dynasty",
      "FilmTitle": "The Fall of the Romanov Dynasty",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fall of the Romanov Dynasty"
      ],
      "Year": "1927",
      "Director": "Esfir Shub",
      "DirectorArray": [
        "Esfir Shub"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3632",
      "databaseFilmTitle": "The Fallen Idol",
      "FilmTitle": "The Fallen Idol",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fallen Idol"
      ],
      "Year": "1948",
      "Director": "Carol Reed",
      "DirectorArray": [
        "Carol Reed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3633",
      "databaseFilmTitle": "The Falls",
      "FilmTitle": "The Falls",
      "AlternateTitle": "",
      "TitleArray": [
        "The Falls"
      ],
      "Year": "1980",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3634",
      "databaseFilmTitle": "The Family",
      "FilmTitle": "The Family",
      "AlternateTitle": "La famiglia",
      "TitleArray": [
        "The Family",
        "La famiglia"
      ],
      "Year": "1987",
      "Director": "Ettore Scola",
      "DirectorArray": [
        "Ettore Scola"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3635",
      "databaseFilmTitle": "The Fan",
      "FilmTitle": "The Fan",
      "AlternateTitle": "Der Fan",
      "TitleArray": [
        "The Fan",
        "Der Fan"
      ],
      "Year": "1982",
      "Director": "Eckhart Schmidt",
      "DirectorArray": [
        "Eckhart Schmidt"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3636",
      "databaseFilmTitle": "The Far Country",
      "FilmTitle": "The Far Country",
      "AlternateTitle": "",
      "TitleArray": [
        "The Far Country"
      ],
      "Year": "1954",
      "Director": "Anthony Mann",
      "DirectorArray": [
        "Anthony Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3637",
      "databaseFilmTitle": "The Far Shore",
      "FilmTitle": "The Far Shore",
      "AlternateTitle": "",
      "TitleArray": [
        "The Far Shore"
      ],
      "Year": "1976",
      "Director": "Joyce Wieland",
      "DirectorArray": [
        "Joyce Wieland"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3638",
      "databaseFilmTitle": "The Fatal Glass of Beer",
      "FilmTitle": "The Fatal Glass of Beer",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fatal Glass of Beer"
      ],
      "Year": "1933",
      "Director": "Clyde Bruckman",
      "DirectorArray": [
        "Clyde Bruckman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3639",
      "databaseFilmTitle": "The Fate of Lee Khan",
      "FilmTitle": "The Fate of Lee Khan",
      "AlternateTitle": "Ying chun ge zhi fengbo",
      "TitleArray": [
        "The Fate of Lee Khan",
        "Ying chun ge zhi fengbo"
      ],
      "Year": "1973",
      "Director": "King Hu",
      "DirectorArray": [
        "King Hu"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3640",
      "databaseFilmTitle": "The Favourite",
      "FilmTitle": "The Favourite",
      "AlternateTitle": "",
      "TitleArray": [
        "The Favourite"
      ],
      "Year": "2018",
      "Director": "Yorgos Lanthimos",
      "DirectorArray": [
        "Yorgos Lanthimos"
      ],
      "Country": "United Kingdom, Ireland",
      "CountryArray": [
        "United Kingdom",
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3641",
      "databaseFilmTitle": "The Fiances",
      "FilmTitle": "The Fiances",
      "AlternateTitle": "I fidanzati",
      "TitleArray": [
        "The Fiances",
        "I fidanzati"
      ],
      "Year": "1963",
      "Director": "Ermanno Olmi",
      "DirectorArray": [
        "Ermanno Olmi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3642",
      "databaseFilmTitle": "The Filibuster",
      "FilmTitle": "The Filibuster",
      "AlternateTitle": "El filibusterismo",
      "TitleArray": [
        "The Filibuster",
        "El filibusterismo"
      ],
      "Year": "1962",
      "Director": "Gerardo de León",
      "DirectorArray": [
        "Gerardo de León"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3643",
      "databaseFilmTitle": "The Fire Within",
      "FilmTitle": "The Fire Within",
      "AlternateTitle": "Le feu follet",
      "TitleArray": [
        "The Fire Within",
        "Le feu follet"
      ],
      "Year": "1963",
      "Director": "Louis Malle",
      "DirectorArray": [
        "Louis Malle"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3644",
      "databaseFilmTitle": "The Firemen's Ball",
      "FilmTitle": "The Firemen's Ball",
      "AlternateTitle": "Horí, má panenko",
      "TitleArray": [
        "The Firemen's Ball",
        "Horí, má panenko"
      ],
      "Year": "1967",
      "Director": "Miloš Forman",
      "DirectorArray": [
        "Miloš Forman"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3645",
      "databaseFilmTitle": "The Firm",
      "FilmTitle": "The Firm",
      "AlternateTitle": "",
      "TitleArray": [
        "The Firm"
      ],
      "Year": "1989",
      "Director": "Alan Clarke",
      "DirectorArray": [
        "Alan Clarke"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3646",
      "databaseFilmTitle": "The Five",
      "FilmTitle": "The Five",
      "AlternateTitle": "Gonin",
      "TitleArray": [
        "The Five",
        "Gonin"
      ],
      "Year": "1995",
      "Director": "Takashi Ishii",
      "DirectorArray": [
        "Takashi Ishii"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3647",
      "databaseFilmTitle": "The Five Obstructions",
      "FilmTitle": "The Five Obstructions",
      "AlternateTitle": "",
      "TitleArray": [
        "The Five Obstructions"
      ],
      "Year": "2003",
      "Director": "Lars von Trier, Jørgen Leth",
      "DirectorArray": [
        "Lars von Trier",
        "Jørgen Leth"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3648",
      "databaseFilmTitle": "The Flame That Will Not Die",
      "FilmTitle": "The Flame That Will Not Die",
      "AlternateTitle": "Fiamma che non si spenge",
      "TitleArray": [
        "The Flame That Will Not Die",
        "Fiamma che non si spenge"
      ],
      "Year": "1949",
      "Director": "Vittorio Cottafavi",
      "DirectorArray": [
        "Vittorio Cottafavi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3649",
      "databaseFilmTitle": "The Flicker",
      "FilmTitle": "The Flicker",
      "AlternateTitle": "",
      "TitleArray": [
        "The Flicker"
      ],
      "Year": "1965",
      "Director": "Tony Conrad",
      "DirectorArray": [
        "Tony Conrad"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3650",
      "databaseFilmTitle": "The Flirtation of Girls",
      "FilmTitle": "The Flirtation of Girls",
      "AlternateTitle": "Ghazal al-Banat",
      "TitleArray": [
        "The Flirtation of Girls",
        "Ghazal al-Banat"
      ],
      "Year": "1949",
      "Director": "Anwar Wagdi",
      "DirectorArray": [
        "Anwar Wagdi"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3651",
      "databaseFilmTitle": "The Flower of My Secret",
      "FilmTitle": "The Flower of My Secret",
      "AlternateTitle": "La flor de mi secreto",
      "TitleArray": [
        "The Flower of My Secret",
        "La flor de mi secreto"
      ],
      "Year": "1995",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3652",
      "databaseFilmTitle": "The Flowers of St. Francis",
      "FilmTitle": "The Flowers of St. Francis",
      "AlternateTitle": "Francesco, giullare di Dio",
      "TitleArray": [
        "The Flowers of St. Francis",
        "Francesco, giullare di Dio"
      ],
      "Year": "1950",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3653",
      "databaseFilmTitle": "The Fly",
      "FilmTitle": "The Fly",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fly"
      ],
      "Year": "1986",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3654",
      "databaseFilmTitle": "The Flying Train",
      "FilmTitle": "The Flying Train",
      "AlternateTitle": "",
      "TitleArray": [
        "The Flying Train"
      ],
      "Year": "1902",
      "Director": "Deutsche Mutoskop und Biograph G.m.b.H.",
      "DirectorArray": [
        "Deutsche Mutoskop und Biograph G.m.b.H."
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3655",
      "databaseFilmTitle": "The Fog",
      "FilmTitle": "The Fog",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fog"
      ],
      "Year": "1980",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3656",
      "databaseFilmTitle": "The Forest for the Trees",
      "FilmTitle": "The Forest for the Trees",
      "AlternateTitle": "Der Wald vor lauter Bäumen",
      "TitleArray": [
        "The Forest for the Trees",
        "Der Wald vor lauter Bäumen"
      ],
      "Year": "2003",
      "Director": "Maren Ade",
      "DirectorArray": [
        "Maren Ade"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3657",
      "databaseFilmTitle": "The Fountainhead",
      "FilmTitle": "The Fountainhead",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fountainhead"
      ],
      "Year": "1949",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3658",
      "databaseFilmTitle": "The Four Horsemen of the Apocalypse (1921)",
      "FilmTitle": "The Four Horsemen of the Apocalypse",
      "AlternateTitle": "",
      "TitleArray": [
        "The Four Horsemen of the Apocalypse"
      ],
      "Year": "1921",
      "Director": "Rex Ingram",
      "DirectorArray": [
        "Rex Ingram"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3659",
      "databaseFilmTitle": "The Four Horsemen of the Apocalypse (1962)",
      "FilmTitle": "The Four Horsemen of the Apocalypse",
      "AlternateTitle": "",
      "TitleArray": [
        "The Four Horsemen of the Apocalypse"
      ],
      "Year": "1962",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3660",
      "databaseFilmTitle": "The French Connection",
      "FilmTitle": "The French Connection",
      "AlternateTitle": "",
      "TitleArray": [
        "The French Connection"
      ],
      "Year": "1971",
      "Director": "William Friedkin",
      "DirectorArray": [
        "William Friedkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3661",
      "databaseFilmTitle": "The Friends of Eddie Coyle",
      "FilmTitle": "The Friends of Eddie Coyle",
      "AlternateTitle": "",
      "TitleArray": [
        "The Friends of Eddie Coyle"
      ],
      "Year": "1973",
      "Director": "Peter Yates",
      "DirectorArray": [
        "Peter Yates"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3662",
      "databaseFilmTitle": "The Fright",
      "FilmTitle": "The Fright",
      "AlternateTitle": "L'épouvante",
      "TitleArray": [
        "The Fright",
        "L'épouvante"
      ],
      "Year": "1911",
      "Director": "Albert Capellani",
      "DirectorArray": [
        "Albert Capellani"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3663",
      "databaseFilmTitle": "The Front Page",
      "FilmTitle": "The Front Page",
      "AlternateTitle": "",
      "TitleArray": [
        "The Front Page"
      ],
      "Year": "1974",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3664",
      "databaseFilmTitle": "The Fugitive",
      "FilmTitle": "The Fugitive",
      "AlternateTitle": "",
      "TitleArray": [
        "The Fugitive"
      ],
      "Year": "1993",
      "Director": "Andrew Davis",
      "DirectorArray": [
        "Andrew Davis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3665",
      "databaseFilmTitle": "The Full Stack",
      "FilmTitle": "The Full Stack",
      "AlternateTitle": "Le grand jeu",
      "TitleArray": [
        "The Full Stack",
        "Le grand jeu"
      ],
      "Year": "1934",
      "Director": "Jacques Feyder",
      "DirectorArray": [
        "Jacques Feyder"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3666",
      "databaseFilmTitle": "The Funeral",
      "FilmTitle": "The Funeral",
      "AlternateTitle": "",
      "TitleArray": [
        "The Funeral"
      ],
      "Year": "1996",
      "Director": "Abel Ferrara",
      "DirectorArray": [
        "Abel Ferrara"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3667",
      "databaseFilmTitle": "The Game",
      "FilmTitle": "The Game",
      "AlternateTitle": "",
      "TitleArray": [
        "The Game"
      ],
      "Year": "1997",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3668",
      "databaseFilmTitle": "The Games of Countess Dolingen",
      "FilmTitle": "The Games of Countess Dolingen",
      "AlternateTitle": "Les Jeux de la comtesse Dolingen de Gratz",
      "TitleArray": [
        "The Games of Countess Dolingen",
        "Les Jeux de la comtesse Dolingen de Gratz"
      ],
      "Year": "1981",
      "Director": "Catherine Binet",
      "DirectorArray": [
        "Catherine Binet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3669",
      "databaseFilmTitle": "The Garden of the Finzi-Continis",
      "FilmTitle": "The Garden of the Finzi-Continis",
      "AlternateTitle": "Il giardino dei Finzi Contini",
      "TitleArray": [
        "The Garden of the Finzi-Continis",
        "Il giardino dei Finzi Contini"
      ],
      "Year": "1970",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3670",
      "databaseFilmTitle": "The General",
      "FilmTitle": "The General",
      "AlternateTitle": "",
      "TitleArray": [
        "The General"
      ],
      "Year": "1926",
      "Director": "Buster Keaton, Clyde Bruckman",
      "DirectorArray": [
        "Buster Keaton",
        "Clyde Bruckman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "8",
      "1972votes": "10",
      "1982rank": "10",
      "1982votes": "11",
      "1992rank": "15",
      "1992votes": "9",
      "2002rank": "16",
      "2002votes": "11",
      "2012rank": "34",
      "2012votes": "35",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "3671",
      "databaseFilmTitle": "The German Sisters",
      "FilmTitle": "The German Sisters",
      "AlternateTitle": "Die bleierne Zeit",
      "TitleArray": [
        "The German Sisters",
        "Die bleierne Zeit"
      ],
      "Year": "1981",
      "Director": "Margarethe von Trotta",
      "DirectorArray": [
        "Margarethe von Trotta"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3672",
      "databaseFilmTitle": "The Ghost and Mrs. Muir",
      "FilmTitle": "The Ghost and Mrs. Muir",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ghost and Mrs. Muir"
      ],
      "Year": "1947",
      "Director": "Joseph L. Mankiewicz",
      "DirectorArray": [
        "Joseph L. Mankiewicz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3673",
      "databaseFilmTitle": "The Ghost Cat and the Mysterious Shamisen",
      "FilmTitle": "The Ghost Cat and the Mysterious Shamisen",
      "AlternateTitle": "Kaibyo nazo no shamisen",
      "TitleArray": [
        "The Ghost Cat and the Mysterious Shamisen",
        "Kaibyo nazo no shamisen"
      ],
      "Year": "1938",
      "Director": "Kiyohiko Ushihara",
      "DirectorArray": [
        "Kiyohiko Ushihara"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3674",
      "databaseFilmTitle": "The Ghost That Never Returns",
      "FilmTitle": "The Ghost That Never Returns",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ghost That Never Returns"
      ],
      "Year": "1930",
      "Director": "Abram Room",
      "DirectorArray": [
        "Abram Room"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3675",
      "databaseFilmTitle": "The Ghost Writer",
      "FilmTitle": "The Ghost Writer",
      "AlternateTitle": "The Ghost",
      "TitleArray": [
        "The Ghost Writer",
        "The Ghost"
      ],
      "Year": "2010",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3676",
      "databaseFilmTitle": "The Girl",
      "FilmTitle": "The Girl",
      "AlternateTitle": "Eltávozott nap",
      "TitleArray": [
        "The Girl",
        "Eltávozott nap"
      ],
      "Year": "1968",
      "Director": "Márta Mészáros",
      "DirectorArray": [
        "Márta Mészáros"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3677",
      "databaseFilmTitle": "The Girl Can't Help It",
      "FilmTitle": "The Girl Can't Help It",
      "AlternateTitle": "",
      "TitleArray": [
        "The Girl Can't Help It"
      ],
      "Year": "1956",
      "Director": "Frank Tashlin",
      "DirectorArray": [
        "Frank Tashlin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3678",
      "databaseFilmTitle": "The Girl Chewing Gum",
      "FilmTitle": "The Girl Chewing Gum",
      "AlternateTitle": "",
      "TitleArray": [
        "The Girl Chewing Gum"
      ],
      "Year": "1976",
      "Director": "John Smith",
      "DirectorArray": [
        "John Smith"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3679",
      "databaseFilmTitle": "The Girl from Chicago",
      "FilmTitle": "The Girl from Chicago",
      "AlternateTitle": "",
      "TitleArray": [
        "The Girl from Chicago"
      ],
      "Year": "1932",
      "Director": "Oscar Micheaux",
      "DirectorArray": [
        "Oscar Micheaux"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3680",
      "databaseFilmTitle": "The Girl with the Dragon Tattoo",
      "FilmTitle": "The Girl with the Dragon Tattoo",
      "AlternateTitle": "",
      "TitleArray": [
        "The Girl with the Dragon Tattoo"
      ],
      "Year": "2011",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3681",
      "databaseFilmTitle": "The Glass Tower",
      "FilmTitle": "The Glass Tower",
      "AlternateTitle": "Der gläserne Turm",
      "TitleArray": [
        "The Glass Tower",
        "Der gläserne Turm"
      ],
      "Year": "1957",
      "Director": "Harald Braun",
      "DirectorArray": [
        "Harald Braun"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3682",
      "databaseFilmTitle": "The Gleaners and I",
      "FilmTitle": "The Gleaners and I",
      "AlternateTitle": "Les glaneurs et la glaneuse",
      "TitleArray": [
        "The Gleaners and I",
        "Les glaneurs et la glaneuse"
      ],
      "Year": "2000",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "67",
      "2022votes": "38"
    },
    {
      "key": "3683",
      "databaseFilmTitle": "The Go-Between",
      "FilmTitle": "The Go-Between",
      "AlternateTitle": "",
      "TitleArray": [
        "The Go-Between"
      ],
      "Year": "1971",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3684",
      "databaseFilmTitle": "The Goalie's Anxiety at the Penalty Kick",
      "FilmTitle": "The Goalie's Anxiety at the Penalty Kick",
      "AlternateTitle": "Die Angst des Tormanns beim Elfmeter",
      "TitleArray": [
        "The Goalie's Anxiety at the Penalty Kick",
        "Die Angst des Tormanns beim Elfmeter"
      ],
      "Year": "1972",
      "Director": "Wim Wenders",
      "DirectorArray": [
        "Wim Wenders"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3685",
      "databaseFilmTitle": "The Goddess",
      "FilmTitle": "The Goddess",
      "AlternateTitle": "Shen nu",
      "TitleArray": [
        "The Goddess",
        "Shen nu"
      ],
      "Year": "1934",
      "Director": "Wu Yonggang",
      "DirectorArray": [
        "Wu Yonggang"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3686",
      "databaseFilmTitle": "The Godfather",
      "FilmTitle": "The Godfather",
      "AlternateTitle": "",
      "TitleArray": [
        "The Godfather"
      ],
      "Year": "1972",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "17",
      "1982votes": "8",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "9",
      "2002votes": "17",
      "2012rank": "21",
      "2012votes": "43",
      "2022rank": "12",
      "2022votes": "93"
    },
    {
      "key": "3687",
      "databaseFilmTitle": "The Godfather: Part II",
      "FilmTitle": "The Godfather: Part II",
      "AlternateTitle": "",
      "TitleArray": [
        "The Godfather: Part II"
      ],
      "Year": "1974",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "11",
      "2002votes": "15",
      "2012rank": "31",
      "2012votes": "38",
      "2022rank": "104",
      "2022votes": "29"
    },
    {
      "key": "3688",
      "databaseFilmTitle": "The Godfather: Part III",
      "FilmTitle": "The Godfather: Part III",
      "AlternateTitle": "",
      "TitleArray": [
        "The Godfather: Part III"
      ],
      "Year": "1990",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3689",
      "databaseFilmTitle": "The Gold Diggers",
      "FilmTitle": "The Gold Diggers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Gold Diggers"
      ],
      "Year": "1983",
      "Director": "Sally Potter",
      "DirectorArray": [
        "Sally Potter"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3690",
      "databaseFilmTitle": "The Gold Rush",
      "FilmTitle": "The Gold Rush",
      "AlternateTitle": "",
      "TitleArray": [
        "The Gold Rush"
      ],
      "Year": "1925",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "2",
      "1952votes": "19",
      "1962rank": "14",
      "1962votes": "10",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3691",
      "databaseFilmTitle": "The Golden Age of Fish",
      "FilmTitle": "The Golden Age of Fish",
      "AlternateTitle": "",
      "TitleArray": [
        "The Golden Age of Fish"
      ],
      "Year": "2008",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3692",
      "databaseFilmTitle": "The Golden Coach",
      "FilmTitle": "The Golden Coach",
      "AlternateTitle": "Le Carrosse d'or",
      "TitleArray": [
        "The Golden Coach",
        "Le Carrosse d'or"
      ],
      "Year": "1952",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3693",
      "databaseFilmTitle": "The Golden Era",
      "FilmTitle": "The Golden Era",
      "AlternateTitle": "Huang jin shi dai",
      "TitleArray": [
        "The Golden Era",
        "Huang jin shi dai"
      ],
      "Year": "2014",
      "Director": "Ann Hui",
      "DirectorArray": [
        "Ann Hui"
      ],
      "Country": "China, Hong Kong",
      "CountryArray": [
        "China",
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3694",
      "databaseFilmTitle": "The Golden Thread",
      "FilmTitle": "The Golden Thread",
      "AlternateTitle": "Subarnarekha",
      "TitleArray": [
        "The Golden Thread",
        "Subarnarekha"
      ],
      "Year": "1965",
      "Director": "Ritwik Ghatak",
      "DirectorArray": [
        "Ritwik Ghatak"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3695",
      "databaseFilmTitle": "The Good, the Bad and the Ugly",
      "FilmTitle": "The Good, the Bad and the Ugly",
      "AlternateTitle": "Il buono, il brutto, il cattivo",
      "TitleArray": [
        "The Good, the Bad and the Ugly",
        "Il buono, il brutto, il cattivo"
      ],
      "Year": "1966",
      "Director": "Sergio Leone",
      "DirectorArray": [
        "Sergio Leone"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "3696",
      "databaseFilmTitle": "The Gospel According to St. Matthew",
      "FilmTitle": "The Gospel According to St. Matthew",
      "AlternateTitle": "Il vangelo secondo Matteo",
      "TitleArray": [
        "The Gospel According to St. Matthew",
        "Il vangelo secondo Matteo"
      ],
      "Year": "1964",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "3697",
      "databaseFilmTitle": "The Graduate",
      "FilmTitle": "The Graduate",
      "AlternateTitle": "",
      "TitleArray": [
        "The Graduate"
      ],
      "Year": "1967",
      "Director": "Mike Nichols",
      "DirectorArray": [
        "Mike Nichols"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3698",
      "databaseFilmTitle": "The Grand Budapest Hotel",
      "FilmTitle": "The Grand Budapest Hotel",
      "AlternateTitle": "",
      "TitleArray": [
        "The Grand Budapest Hotel"
      ],
      "Year": "2014",
      "Director": "Wes Anderson",
      "DirectorArray": [
        "Wes Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3699",
      "databaseFilmTitle": "The Grand Duke's Finances",
      "FilmTitle": "The Grand Duke's Finances",
      "AlternateTitle": "Die Finanzen des Grossherzogs",
      "TitleArray": [
        "The Grand Duke's Finances",
        "Die Finanzen des Grossherzogs"
      ],
      "Year": "1924",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3700",
      "databaseFilmTitle": "The Grandmaster",
      "FilmTitle": "The Grandmaster",
      "AlternateTitle": "Yi dai zong shi",
      "TitleArray": [
        "The Grandmaster",
        "Yi dai zong shi"
      ],
      "Year": "2013",
      "Director": "Wong Kar Wai",
      "DirectorArray": [
        "Wong Kar Wai"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3701",
      "databaseFilmTitle": "The Grapes of Wrath",
      "FilmTitle": "The Grapes of Wrath",
      "AlternateTitle": "",
      "TitleArray": [
        "The Grapes of Wrath"
      ],
      "Year": "1940",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "13",
      "1952votes": "9",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3702",
      "databaseFilmTitle": "The Gratinated Brains of Pupilija Ferkeverk",
      "FilmTitle": "The Gratinated Brains of Pupilija Ferkeverk",
      "AlternateTitle": "Pupilias Ferkeverk Brain Au Gratain",
      "TitleArray": [
        "The Gratinated Brains of Pupilija Ferkeverk",
        "Pupilias Ferkeverk Brain Au Gratain"
      ],
      "Year": "1970",
      "Director": "Karpo Ačimović-Godina",
      "DirectorArray": [
        "Karpo Ačimović-Godina"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3703",
      "databaseFilmTitle": "The Great Adventure",
      "FilmTitle": "The Great Adventure",
      "AlternateTitle": "Det stora äventyret",
      "TitleArray": [
        "The Great Adventure",
        "Det stora äventyret"
      ],
      "Year": "1953",
      "Director": "Arne Sucksdorff",
      "DirectorArray": [
        "Arne Sucksdorff"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3704",
      "databaseFilmTitle": "The Great Art of Knowing",
      "FilmTitle": "The Great Art of Knowing",
      "AlternateTitle": "",
      "TitleArray": [
        "The Great Art of Knowing"
      ],
      "Year": "2004",
      "Director": "David Gatten",
      "DirectorArray": [
        "David Gatten"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3705",
      "databaseFilmTitle": "The Great Beauty",
      "FilmTitle": "The Great Beauty",
      "AlternateTitle": "La grande bellezza",
      "TitleArray": [
        "The Great Beauty",
        "La grande bellezza"
      ],
      "Year": "2013",
      "Director": "Paolo Sorrentino",
      "DirectorArray": [
        "Paolo Sorrentino"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3706",
      "databaseFilmTitle": "The Great Buddha +",
      "FilmTitle": "The Great Buddha +",
      "AlternateTitle": "Da fu pu la si",
      "TitleArray": [
        "The Great Buddha +",
        "Da fu pu la si"
      ],
      "Year": "2017",
      "Director": "Huang Hsin-yao",
      "DirectorArray": [
        "Huang Hsin-yao"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3707",
      "databaseFilmTitle": "The Great Dictator",
      "FilmTitle": "The Great Dictator",
      "AlternateTitle": "",
      "TitleArray": [
        "The Great Dictator"
      ],
      "Year": "1940",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3708",
      "databaseFilmTitle": "The Great Ecstasy of Woodcarver Steiner",
      "FilmTitle": "The Great Ecstasy of Woodcarver Steiner",
      "AlternateTitle": "Die grosse Ekstase des Bildschnitzers Steiner",
      "TitleArray": [
        "The Great Ecstasy of Woodcarver Steiner",
        "Die grosse Ekstase des Bildschnitzers Steiner"
      ],
      "Year": "1974",
      "Director": "Werner Herzog",
      "DirectorArray": [
        "Werner Herzog"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3709",
      "databaseFilmTitle": "The Great Escape",
      "FilmTitle": "The Great Escape",
      "AlternateTitle": "",
      "TitleArray": [
        "The Great Escape"
      ],
      "Year": "1963",
      "Director": "John Sturges",
      "DirectorArray": [
        "John Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3710",
      "databaseFilmTitle": "The Great Madcap",
      "FilmTitle": "The Great Madcap",
      "AlternateTitle": "El gran calavera",
      "TitleArray": [
        "The Great Madcap",
        "El gran calavera"
      ],
      "Year": "1949",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3711",
      "databaseFilmTitle": "The Great Rock 'n' Roll Swindle",
      "FilmTitle": "The Great Rock 'n' Roll Swindle",
      "AlternateTitle": "",
      "TitleArray": [
        "The Great Rock 'n' Roll Swindle"
      ],
      "Year": "1980",
      "Director": "Julien Temple",
      "DirectorArray": [
        "Julien Temple"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3712",
      "databaseFilmTitle": "The Great Sacrifice",
      "FilmTitle": "The Great Sacrifice",
      "AlternateTitle": "Opfergang",
      "TitleArray": [
        "The Great Sacrifice",
        "Opfergang"
      ],
      "Year": "1944",
      "Director": "Veit Harlan",
      "DirectorArray": [
        "Veit Harlan"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3713",
      "databaseFilmTitle": "The Great Silence",
      "FilmTitle": "The Great Silence",
      "AlternateTitle": "Il grande silenzio",
      "TitleArray": [
        "The Great Silence",
        "Il grande silenzio"
      ],
      "Year": "1968",
      "Director": "Sergio Corbucci",
      "DirectorArray": [
        "Sergio Corbucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3714",
      "databaseFilmTitle": "The Great Waltz",
      "FilmTitle": "The Great Waltz",
      "AlternateTitle": "",
      "TitleArray": [
        "The Great Waltz"
      ],
      "Year": "1938",
      "Director": "Julien Duvivier",
      "DirectorArray": [
        "Julien Duvivier"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3715",
      "databaseFilmTitle": "The Green Pastures",
      "FilmTitle": "The Green Pastures",
      "AlternateTitle": "",
      "TitleArray": [
        "The Green Pastures"
      ],
      "Year": "1936",
      "Director": "Marc Connelly, William Keighley",
      "DirectorArray": [
        "Marc Connelly",
        "William Keighley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3716",
      "databaseFilmTitle": "The Green Ray",
      "FilmTitle": "The Green Ray",
      "AlternateTitle": "Le rayon vert",
      "TitleArray": [
        "The Green Ray",
        "Le rayon vert"
      ],
      "Year": "1986",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "226",
      "2022votes": "13"
    },
    {
      "key": "3717",
      "databaseFilmTitle": "The Green Years",
      "FilmTitle": "The Green Years",
      "AlternateTitle": "Os verdes anos",
      "TitleArray": [
        "The Green Years",
        "Os verdes anos"
      ],
      "Year": "1963",
      "Director": "Paulo Rocha",
      "DirectorArray": [
        "Paulo Rocha"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3718",
      "databaseFilmTitle": "The Grissom Gang",
      "FilmTitle": "The Grissom Gang",
      "AlternateTitle": "",
      "TitleArray": [
        "The Grissom Gang"
      ],
      "Year": "1971",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3719",
      "databaseFilmTitle": "The Ground",
      "FilmTitle": "The Ground",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ground"
      ],
      "Year": "2001",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3720",
      "databaseFilmTitle": "The Gunfighter",
      "FilmTitle": "The Gunfighter",
      "AlternateTitle": "",
      "TitleArray": [
        "The Gunfighter"
      ],
      "Year": "1950",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3721",
      "databaseFilmTitle": "The Guns",
      "FilmTitle": "The Guns",
      "AlternateTitle": "Os fuzis",
      "TitleArray": [
        "The Guns",
        "Os fuzis"
      ],
      "Year": "1964",
      "Director": "Ruy Guerra",
      "DirectorArray": [
        "Ruy Guerra"
      ],
      "Country": "Brazil, Argentina",
      "CountryArray": [
        "Brazil",
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3722",
      "databaseFilmTitle": "The Halfway House",
      "FilmTitle": "The Halfway House",
      "AlternateTitle": "",
      "TitleArray": [
        "The Halfway House"
      ],
      "Year": "1944",
      "Director": "Basil Dearden, Alberto Cavalcanti",
      "DirectorArray": [
        "Basil Dearden",
        "Alberto Cavalcanti"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3723",
      "databaseFilmTitle": "The Handmaiden",
      "FilmTitle": "The Handmaiden",
      "AlternateTitle": "Agassi",
      "TitleArray": [
        "The Handmaiden",
        "Agassi"
      ],
      "Year": "2016",
      "Director": "Park Chan-wook",
      "DirectorArray": [
        "Park Chan-wook"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3724",
      "databaseFilmTitle": "The Hands of Orlac",
      "FilmTitle": "The Hands of Orlac",
      "AlternateTitle": "Orlacs Hände",
      "TitleArray": [
        "The Hands of Orlac",
        "Orlacs Hände"
      ],
      "Year": "1924",
      "Director": "Robert Wiene",
      "DirectorArray": [
        "Robert Wiene"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3725",
      "databaseFilmTitle": "The Happiest Days of Your Life",
      "FilmTitle": "The Happiest Days of Your Life",
      "AlternateTitle": "",
      "TitleArray": [
        "The Happiest Days of Your Life"
      ],
      "Year": "1950",
      "Director": "Frank Launder",
      "DirectorArray": [
        "Frank Launder"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3726",
      "databaseFilmTitle": "The Harder They Fall",
      "FilmTitle": "The Harder They Fall",
      "AlternateTitle": "",
      "TitleArray": [
        "The Harder They Fall"
      ],
      "Year": "2021",
      "Director": "Jeymes Samuel",
      "DirectorArray": [
        "Jeymes Samuel"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3727",
      "databaseFilmTitle": "The Hart of London",
      "FilmTitle": "The Hart of London",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hart of London"
      ],
      "Year": "1970",
      "Director": "Jack Chambers",
      "DirectorArray": [
        "Jack Chambers"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3728",
      "databaseFilmTitle": "The Hateful Eight",
      "FilmTitle": "The Hateful Eight",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hateful Eight"
      ],
      "Year": "2015",
      "Director": "Quentin Tarantino",
      "DirectorArray": [
        "Quentin Tarantino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3729",
      "databaseFilmTitle": "The Haunting",
      "FilmTitle": "The Haunting",
      "AlternateTitle": "",
      "TitleArray": [
        "The Haunting"
      ],
      "Year": "1963",
      "Director": "Robert Wise",
      "DirectorArray": [
        "Robert Wise"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3730",
      "databaseFilmTitle": "The Hawks and the Sparrows",
      "FilmTitle": "The Hawks and the Sparrows",
      "AlternateTitle": "Uccellacci e uccellini",
      "TitleArray": [
        "The Hawks and the Sparrows",
        "Uccellacci e uccellini"
      ],
      "Year": "1966",
      "Director": "Pier Paolo Pasolini",
      "DirectorArray": [
        "Pier Paolo Pasolini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3731",
      "databaseFilmTitle": "The Head",
      "FilmTitle": "The Head",
      "AlternateTitle": "Golova",
      "TitleArray": [
        "The Head",
        "Golova"
      ],
      "Year": "2004",
      "Director": "Svetlana Baskova",
      "DirectorArray": [
        "Svetlana Baskova"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3732",
      "databaseFilmTitle": "The Headless Woman",
      "FilmTitle": "The Headless Woman",
      "AlternateTitle": "La mujer sin cabeza",
      "TitleArray": [
        "The Headless Woman",
        "La mujer sin cabeza"
      ],
      "Year": "2008",
      "Director": "Lucrecia Martel",
      "DirectorArray": [
        "Lucrecia Martel"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "3733",
      "databaseFilmTitle": "The Heartbreak Kid",
      "FilmTitle": "The Heartbreak Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "The Heartbreak Kid"
      ],
      "Year": "1972",
      "Director": "Elaine May",
      "DirectorArray": [
        "Elaine May"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3734",
      "databaseFilmTitle": "The Hedonists",
      "FilmTitle": "The Hedonists",
      "AlternateTitle": "Ying sheng",
      "TitleArray": [
        "The Hedonists",
        "Ying sheng"
      ],
      "Year": "2016",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3735",
      "databaseFilmTitle": "The Heiress",
      "FilmTitle": "The Heiress",
      "AlternateTitle": "",
      "TitleArray": [
        "The Heiress"
      ],
      "Year": "1949",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3736",
      "databaseFilmTitle": "The Hidden Fortress",
      "FilmTitle": "The Hidden Fortress",
      "AlternateTitle": "Kakushi-toride no san-akunin",
      "TitleArray": [
        "The Hidden Fortress",
        "Kakushi-toride no san-akunin"
      ],
      "Year": "1958",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3737",
      "databaseFilmTitle": "The Hills of Disorder",
      "FilmTitle": "The Hills of Disorder",
      "AlternateTitle": "serras da desordem",
      "TitleArray": [
        "The Hills of Disorder",
        "serras da desordem"
      ],
      "Year": "2006",
      "Director": "Andrea Tonacci",
      "DirectorArray": [
        "Andrea Tonacci"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3738",
      "databaseFilmTitle": "The Himmler Project",
      "FilmTitle": "The Himmler Project",
      "AlternateTitle": "Das Himmler Projekt",
      "TitleArray": [
        "The Himmler Project",
        "Das Himmler Projekt"
      ],
      "Year": "2000",
      "Director": "Romuald Karmakar",
      "DirectorArray": [
        "Romuald Karmakar"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3739",
      "databaseFilmTitle": "The Hired Hand",
      "FilmTitle": "The Hired Hand",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hired Hand"
      ],
      "Year": "1971",
      "Director": "Peter Fonda",
      "DirectorArray": [
        "Peter Fonda"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3740",
      "databaseFilmTitle": "The History of the Seattle Mariners",
      "FilmTitle": "The History of the Seattle Mariners",
      "AlternateTitle": "",
      "TitleArray": [
        "The History of the Seattle Mariners"
      ],
      "Year": "2020",
      "Director": "Jon Bois",
      "DirectorArray": [
        "Jon Bois"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3741",
      "databaseFilmTitle": "The Hitch-Hiker",
      "FilmTitle": "The Hitch-Hiker",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hitch-Hiker"
      ],
      "Year": "1953",
      "Director": "Ida Lupino",
      "DirectorArray": [
        "Ida Lupino"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3742",
      "databaseFilmTitle": "The Hitchhiker's Guide to the Galaxy",
      "FilmTitle": "The Hitchhiker's Guide to the Galaxy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hitchhiker's Guide to the Galaxy"
      ],
      "Year": "2005",
      "Director": "Garth Jennings",
      "DirectorArray": [
        "Garth Jennings"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3743",
      "databaseFilmTitle": "The Hole",
      "FilmTitle": "The Hole",
      "AlternateTitle": "Dong",
      "TitleArray": [
        "The Hole",
        "Dong"
      ],
      "Year": "1998",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3744",
      "databaseFilmTitle": "The Holiday",
      "FilmTitle": "The Holiday",
      "AlternateTitle": "",
      "TitleArray": [
        "The Holiday"
      ],
      "Year": "2006",
      "Director": "Nancy Meyers",
      "DirectorArray": [
        "Nancy Meyers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3745",
      "databaseFilmTitle": "The Holy Girl",
      "FilmTitle": "The Holy Girl",
      "AlternateTitle": "La niña santa",
      "TitleArray": [
        "The Holy Girl",
        "La niña santa"
      ],
      "Year": "2004",
      "Director": "Lucrecia Martel",
      "DirectorArray": [
        "Lucrecia Martel"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3746",
      "databaseFilmTitle": "The Holy Mountain",
      "FilmTitle": "The Holy Mountain",
      "AlternateTitle": "",
      "TitleArray": [
        "The Holy Mountain"
      ],
      "Year": "1973",
      "Director": "Alejandro Jodorowsky",
      "DirectorArray": [
        "Alejandro Jodorowsky"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3747",
      "databaseFilmTitle": "The Home & The World Today",
      "FilmTitle": "The Home & The World Today",
      "AlternateTitle": "Ghawre Bairey Aaj",
      "TitleArray": [
        "The Home & The World Today",
        "Ghawre Bairey Aaj"
      ],
      "Year": "2019",
      "Director": "Sparna Sen",
      "DirectorArray": [
        "Sparna Sen"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3748",
      "databaseFilmTitle": "The Honeymoon Killers",
      "FilmTitle": "The Honeymoon Killers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Honeymoon Killers"
      ],
      "Year": "1970",
      "Director": "Leonard Kastle",
      "DirectorArray": [
        "Leonard Kastle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3749",
      "databaseFilmTitle": "The Horse Thief",
      "FilmTitle": "The Horse Thief",
      "AlternateTitle": "Dao me zei",
      "TitleArray": [
        "The Horse Thief",
        "Dao me zei"
      ],
      "Year": "1986",
      "Director": "Tian Zhuangzhuang, Peicheng Pan",
      "DirectorArray": [
        "Tian Zhuangzhuang",
        "Peicheng Pan"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3750",
      "databaseFilmTitle": "The Host",
      "FilmTitle": "The Host",
      "AlternateTitle": "Gwoemul",
      "TitleArray": [
        "The Host",
        "Gwoemul"
      ],
      "Year": "2006",
      "Director": "Bong Joon Ho",
      "DirectorArray": [
        "Bong Joon Ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3751",
      "databaseFilmTitle": "The Hottest August",
      "FilmTitle": "The Hottest August",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hottest August"
      ],
      "Year": "2019",
      "Director": "Brett Story",
      "DirectorArray": [
        "Brett Story"
      ],
      "Country": "United States, Canada",
      "CountryArray": [
        "United States",
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3752",
      "databaseFilmTitle": "The Hound of the Baskervilles",
      "FilmTitle": "The Hound of the Baskervilles",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hound of the Baskervilles"
      ],
      "Year": "1939",
      "Director": "Sidney Lanfield",
      "DirectorArray": [
        "Sidney Lanfield"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3753",
      "databaseFilmTitle": "The Hour of the Furnaces",
      "FilmTitle": "The Hour of the Furnaces",
      "AlternateTitle": "La hora de los hornos: Notas y testimonios sobre el neocolonialismo, la violencia y la liberación",
      "TitleArray": [
        "The Hour of the Furnaces",
        "La hora de los hornos: Notas y testimonios sobre el neocolonialismo, la violencia y la liberación"
      ],
      "Year": "1968",
      "Director": "Octavio Getino, Fernando E. Solanas",
      "DirectorArray": [
        "Octavio Getino",
        "Fernando E. Solanas"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "3754",
      "databaseFilmTitle": "The Hourglass Sanatorium",
      "FilmTitle": "The Hourglass Sanatorium",
      "AlternateTitle": "Sanatorium pod Klepsydra",
      "TitleArray": [
        "The Hourglass Sanatorium",
        "Sanatorium pod Klepsydra"
      ],
      "Year": "1973",
      "Director": "Wojciech Has",
      "DirectorArray": [
        "Wojciech Has"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3755",
      "databaseFilmTitle": "The House in the Woods",
      "FilmTitle": "The House in the Woods",
      "AlternateTitle": "La maison des bois",
      "TitleArray": [
        "The House in the Woods",
        "La maison des bois"
      ],
      "Year": "1971",
      "Director": "Maurice Pailat",
      "DirectorArray": [
        "Maurice Pailat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3756",
      "databaseFilmTitle": "The House is Black",
      "FilmTitle": "The House is Black",
      "AlternateTitle": "Khaneh siah ast",
      "TitleArray": [
        "The House is Black",
        "Khaneh siah ast"
      ],
      "Year": "1963",
      "Director": "Forugh Farrokhzad",
      "DirectorArray": [
        "Forugh Farrokhzad"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "101",
      "2022votes": "30"
    },
    {
      "key": "3757",
      "databaseFilmTitle": "The House on Trubnaya Square",
      "FilmTitle": "The House on Trubnaya Square",
      "AlternateTitle": "Dom na Trubnoi",
      "TitleArray": [
        "The House on Trubnaya Square",
        "Dom na Trubnoi"
      ],
      "Year": "1928",
      "Director": "Boris Barnet",
      "DirectorArray": [
        "Boris Barnet"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3758",
      "databaseFilmTitle": "The Housemaid",
      "FilmTitle": "The Housemaid",
      "AlternateTitle": "Hanyo",
      "TitleArray": [
        "The Housemaid",
        "Hanyo"
      ],
      "Year": "1960",
      "Director": "Kim Ki-young",
      "DirectorArray": [
        "Kim Ki-young"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3759",
      "databaseFilmTitle": "The Hudsucker Proxy",
      "FilmTitle": "The Hudsucker Proxy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hudsucker Proxy"
      ],
      "Year": "1994",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3760",
      "databaseFilmTitle": "The Human Condition",
      "FilmTitle": "The Human Condition",
      "AlternateTitle": "Ningen no jōken",
      "TitleArray": [
        "The Human Condition",
        "Ningen no jōken"
      ],
      "Year": "1959",
      "Director": "Masaki Kobayashi",
      "DirectorArray": [
        "Masaki Kobayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3761",
      "databaseFilmTitle": "The Human Condition III: A Soldier's Prayer",
      "FilmTitle": "The Human Condition III: A Soldier's Prayer",
      "AlternateTitle": "Ningen no jōken",
      "TitleArray": [
        "The Human Condition III: A Soldier's Prayer",
        "Ningen no jōken"
      ],
      "Year": "1961",
      "Director": "Masaki Kobayashi",
      "DirectorArray": [
        "Masaki Kobayashi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3762",
      "databaseFilmTitle": "The Human Pyramid",
      "FilmTitle": "The Human Pyramid",
      "AlternateTitle": "La pyramide humaine",
      "TitleArray": [
        "The Human Pyramid",
        "La pyramide humaine"
      ],
      "Year": "1961",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "Ivory Coast",
      "CountryArray": [
        "Ivory Coast"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3763",
      "databaseFilmTitle": "The Human Surge",
      "FilmTitle": "The Human Surge",
      "AlternateTitle": "El auge del humano",
      "TitleArray": [
        "The Human Surge",
        "El auge del humano"
      ],
      "Year": "2016",
      "Director": "Eduardo Williams",
      "DirectorArray": [
        "Eduardo Williams"
      ],
      "Country": "Argentina, Brazil",
      "CountryArray": [
        "Argentina",
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3764",
      "databaseFilmTitle": "The Hunger Years: In a Land of Plenty",
      "FilmTitle": "The Hunger Years: In a Land of Plenty",
      "AlternateTitle": "Hungerjahre - in einem reichen Land",
      "TitleArray": [
        "The Hunger Years: In a Land of Plenty",
        "Hungerjahre - in einem reichen Land"
      ],
      "Year": "1980",
      "Director": "Jutta Brückner",
      "DirectorArray": [
        "Jutta Brückner"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3765",
      "databaseFilmTitle": "The Hunt",
      "FilmTitle": "The Hunt",
      "AlternateTitle": "A Caça",
      "TitleArray": [
        "The Hunt",
        "A Caça"
      ],
      "Year": "1964",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3766",
      "databaseFilmTitle": "The Hunters (1957)",
      "FilmTitle": "The Hunters",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hunters"
      ],
      "Year": "1957",
      "Director": "Robert Gardner, John Marshall",
      "DirectorArray": [
        "Robert Gardner",
        "John Marshall"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3767",
      "databaseFilmTitle": "The Hunters (1977)",
      "FilmTitle": "The Hunters",
      "AlternateTitle": "Oi kynigoi",
      "TitleArray": [
        "The Hunters",
        "Oi kynigoi"
      ],
      "Year": "1977",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3768",
      "databaseFilmTitle": "The Hurt Locker",
      "FilmTitle": "The Hurt Locker",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hurt Locker"
      ],
      "Year": "2008",
      "Director": "Kathryn Bigelow",
      "DirectorArray": [
        "Kathryn Bigelow"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3769",
      "databaseFilmTitle": "The Hussy",
      "FilmTitle": "The Hussy",
      "AlternateTitle": "La Drôlesse",
      "TitleArray": [
        "The Hussy",
        "La Drôlesse"
      ],
      "Year": "1979",
      "Director": "Jacques Doillon",
      "DirectorArray": [
        "Jacques Doillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3770",
      "databaseFilmTitle": "The Hustler",
      "FilmTitle": "The Hustler",
      "AlternateTitle": "",
      "TitleArray": [
        "The Hustler"
      ],
      "Year": "1961",
      "Director": "Robert Rossen",
      "DirectorArray": [
        "Robert Rossen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3771",
      "databaseFilmTitle": "The Hypothesis of the Stolen Painting",
      "FilmTitle": "The Hypothesis of the Stolen Painting",
      "AlternateTitle": "L'hypothèse du tableau volé",
      "TitleArray": [
        "The Hypothesis of the Stolen Painting",
        "L'hypothèse du tableau volé"
      ],
      "Year": "1978",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3772",
      "databaseFilmTitle": "The Ice Storm",
      "FilmTitle": "The Ice Storm",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ice Storm"
      ],
      "Year": "1997",
      "Director": "Ang Lee",
      "DirectorArray": [
        "Ang Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3773",
      "databaseFilmTitle": "The Idiot",
      "FilmTitle": "The Idiot",
      "AlternateTitle": "Hakuchi",
      "TitleArray": [
        "The Idiot",
        "Hakuchi"
      ],
      "Year": "1951",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3774",
      "databaseFilmTitle": "The Idiots",
      "FilmTitle": "The Idiots",
      "AlternateTitle": "Idioterne",
      "TitleArray": [
        "The Idiots",
        "Idioterne"
      ],
      "Year": "1998",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3775",
      "databaseFilmTitle": "The Image Book",
      "FilmTitle": "The Image Book",
      "AlternateTitle": "Le livre d'image",
      "TitleArray": [
        "The Image Book",
        "Le livre d'image"
      ],
      "Year": "2018",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3776",
      "databaseFilmTitle": "The Immigrant",
      "FilmTitle": "The Immigrant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Immigrant"
      ],
      "Year": "1917",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3777",
      "databaseFilmTitle": "The Impossible Voyage",
      "FilmTitle": "The Impossible Voyage",
      "AlternateTitle": "Le Voyage à travers l'impossible",
      "TitleArray": [
        "The Impossible Voyage",
        "Le Voyage à travers l'impossible"
      ],
      "Year": "1904",
      "Director": "Georges Méliès",
      "DirectorArray": [
        "Georges Méliès"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3778",
      "databaseFilmTitle": "The In-Laws",
      "FilmTitle": "The In-Laws",
      "AlternateTitle": "",
      "TitleArray": [
        "The In-Laws"
      ],
      "Year": "1979",
      "Director": "Arthur Hiller",
      "DirectorArray": [
        "Arthur Hiller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3779",
      "databaseFilmTitle": "The Incredible Shrinking Man",
      "FilmTitle": "The Incredible Shrinking Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Incredible Shrinking Man"
      ],
      "Year": "1957",
      "Director": "Jack Arnold",
      "DirectorArray": [
        "Jack Arnold"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3780",
      "databaseFilmTitle": "The Indian Tomb",
      "FilmTitle": "The Indian Tomb",
      "AlternateTitle": "Das Indische Grabmal",
      "TitleArray": [
        "The Indian Tomb",
        "Das Indische Grabmal"
      ],
      "Year": "1959",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3781",
      "databaseFilmTitle": "The Inextinguishable Fire",
      "FilmTitle": "The Inextinguishable Fire",
      "AlternateTitle": "Nicht löschbares Feuer",
      "TitleArray": [
        "The Inextinguishable Fire",
        "Nicht löschbares Feuer"
      ],
      "Year": "1969",
      "Director": "Harun Farocki",
      "DirectorArray": [
        "Harun Farocki"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3782",
      "databaseFilmTitle": "The Informer",
      "FilmTitle": "The Informer",
      "AlternateTitle": "",
      "TitleArray": [
        "The Informer"
      ],
      "Year": "1935",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3783",
      "databaseFilmTitle": "The Inheritance",
      "FilmTitle": "The Inheritance",
      "AlternateTitle": "",
      "TitleArray": [
        "The Inheritance"
      ],
      "Year": "2020",
      "Director": "Ephraim Asili",
      "DirectorArray": [
        "Ephraim Asili"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3784",
      "databaseFilmTitle": "The Inner Scar",
      "FilmTitle": "The Inner Scar",
      "AlternateTitle": "La cicatrice intérieure",
      "TitleArray": [
        "The Inner Scar",
        "La cicatrice intérieure"
      ],
      "Year": "1972",
      "Director": "Philippe Garrel",
      "DirectorArray": [
        "Philippe Garrel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3785",
      "databaseFilmTitle": "The Innocents",
      "FilmTitle": "The Innocents",
      "AlternateTitle": "",
      "TitleArray": [
        "The Innocents"
      ],
      "Year": "1961",
      "Director": "Jack Clayton",
      "DirectorArray": [
        "Jack Clayton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "3786",
      "databaseFilmTitle": "The Insect Woman",
      "FilmTitle": "The Insect Woman",
      "AlternateTitle": "Nippon konchuki",
      "TitleArray": [
        "The Insect Woman",
        "Nippon konchuki"
      ],
      "Year": "1963",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3787",
      "databaseFilmTitle": "The Insider",
      "FilmTitle": "The Insider",
      "AlternateTitle": "",
      "TitleArray": [
        "The Insider"
      ],
      "Year": "1999",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3788",
      "databaseFilmTitle": "The Intruder",
      "FilmTitle": "The Intruder",
      "AlternateTitle": "L'instrus",
      "TitleArray": [
        "The Intruder",
        "L'instrus"
      ],
      "Year": "2004",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "3789",
      "databaseFilmTitle": "The Irishman",
      "FilmTitle": "The Irishman",
      "AlternateTitle": "",
      "TitleArray": [
        "The Irishman"
      ],
      "Year": "2019",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3790",
      "databaseFilmTitle": "The Iron Giant",
      "FilmTitle": "The Iron Giant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Iron Giant"
      ],
      "Year": "1999",
      "Director": "Brad Bird",
      "DirectorArray": [
        "Brad Bird"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3791",
      "databaseFilmTitle": "The Iron Horse",
      "FilmTitle": "The Iron Horse",
      "AlternateTitle": "",
      "TitleArray": [
        "The Iron Horse"
      ],
      "Year": "1924",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3792",
      "databaseFilmTitle": "The Iron Mask",
      "FilmTitle": "The Iron Mask",
      "AlternateTitle": "",
      "TitleArray": [
        "The Iron Mask"
      ],
      "Year": "1929",
      "Director": "Allan Dwan",
      "DirectorArray": [
        "Allan Dwan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3793",
      "databaseFilmTitle": "The Island of St. Matthews",
      "FilmTitle": "The Island of St. Matthews",
      "AlternateTitle": "",
      "TitleArray": [
        "The Island of St. Matthews"
      ],
      "Year": "2013",
      "Director": "Kevin Jerome Everson",
      "DirectorArray": [
        "Kevin Jerome Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3794",
      "databaseFilmTitle": "The Italian Straw Hat",
      "FilmTitle": "The Italian Straw Hat",
      "AlternateTitle": "Un chapeau de paille d'Italie",
      "TitleArray": [
        "The Italian Straw Hat",
        "Un chapeau de paille d'Italie"
      ],
      "Year": "1928",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3795",
      "databaseFilmTitle": "The Joyless Street",
      "FilmTitle": "The Joyless Street",
      "AlternateTitle": "Die freudlose Gasse",
      "TitleArray": [
        "The Joyless Street",
        "Die freudlose Gasse"
      ],
      "Year": "1925",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3796",
      "databaseFilmTitle": "The Jungle Book",
      "FilmTitle": "The Jungle Book",
      "AlternateTitle": "",
      "TitleArray": [
        "The Jungle Book"
      ],
      "Year": "1967",
      "Director": "Wolfgang Reitherman",
      "DirectorArray": [
        "Wolfgang Reitherman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3797",
      "databaseFilmTitle": "The Kaiser's Lackey",
      "FilmTitle": "The Kaiser's Lackey",
      "AlternateTitle": "Der Untertan (Man of Straw)",
      "TitleArray": [
        "The Kaiser's Lackey",
        "Der Untertan (Man of Straw)"
      ],
      "Year": "1951",
      "Director": "Wolfgang Staudte",
      "DirectorArray": [
        "Wolfgang Staudte"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3798",
      "databaseFilmTitle": "The Karate Kid",
      "FilmTitle": "The Karate Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "The Karate Kid"
      ],
      "Year": "1984",
      "Director": "John G. Avildsen",
      "DirectorArray": [
        "John G. Avildsen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3799",
      "databaseFilmTitle": "The Karnival Kid",
      "FilmTitle": "The Karnival Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "The Karnival Kid"
      ],
      "Year": "1929",
      "Director": "Walt Disney, Ub Iwerks",
      "DirectorArray": [
        "Walt Disney",
        "Ub Iwerks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3800",
      "databaseFilmTitle": "The Kid",
      "FilmTitle": "The Kid",
      "AlternateTitle": "",
      "TitleArray": [
        "The Kid"
      ],
      "Year": "1921",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3801",
      "databaseFilmTitle": "The Kids Are All Right",
      "FilmTitle": "The Kids Are All Right",
      "AlternateTitle": "",
      "TitleArray": [
        "The Kids Are All Right"
      ],
      "Year": "2010",
      "Director": "Lisa Cholodenko",
      "DirectorArray": [
        "Lisa Cholodenko"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3802",
      "databaseFilmTitle": "The Killer",
      "FilmTitle": "The Killer",
      "AlternateTitle": "Dip huet seung hung",
      "TitleArray": [
        "The Killer",
        "Dip huet seung hung"
      ],
      "Year": "1989",
      "Director": "John Woo",
      "DirectorArray": [
        "John Woo"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3803",
      "databaseFilmTitle": "The Killing",
      "FilmTitle": "The Killing",
      "AlternateTitle": "",
      "TitleArray": [
        "The Killing"
      ],
      "Year": "1956",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3804",
      "databaseFilmTitle": "The Killing Fields",
      "FilmTitle": "The Killing Fields",
      "AlternateTitle": "",
      "TitleArray": [
        "The Killing Fields"
      ],
      "Year": "1984",
      "Director": "Roland Joffé",
      "DirectorArray": [
        "Roland Joffé"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3805",
      "databaseFilmTitle": "The Killing of a Chinese Bookie",
      "FilmTitle": "The Killing of a Chinese Bookie",
      "AlternateTitle": "",
      "TitleArray": [
        "The Killing of a Chinese Bookie"
      ],
      "Year": "1976",
      "Director": "John Cassavetes",
      "DirectorArray": [
        "John Cassavetes"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3806",
      "databaseFilmTitle": "The Killing of America",
      "FilmTitle": "The Killing of America",
      "AlternateTitle": "Violence U.S.A.",
      "TitleArray": [
        "The Killing of America",
        "Violence U.S.A."
      ],
      "Year": "1981",
      "Director": "Sheldon Renan, Leonard Schrader",
      "DirectorArray": [
        "Sheldon Renan",
        "Leonard Schrader"
      ],
      "Country": "Japan, United States",
      "CountryArray": [
        "Japan",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3807",
      "databaseFilmTitle": "The King and the Mockingbird",
      "FilmTitle": "The King and the Mockingbird",
      "AlternateTitle": "Le roi et l'oiseau",
      "TitleArray": [
        "The King and the Mockingbird",
        "Le roi et l'oiseau"
      ],
      "Year": "1980",
      "Director": "Paul Grimault",
      "DirectorArray": [
        "Paul Grimault"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3808",
      "databaseFilmTitle": "The King of Comedy",
      "FilmTitle": "The King of Comedy",
      "AlternateTitle": "",
      "TitleArray": [
        "The King of Comedy"
      ],
      "Year": "1982",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "3809",
      "databaseFilmTitle": "The King's Speech",
      "FilmTitle": "The King's Speech",
      "AlternateTitle": "",
      "TitleArray": [
        "The King's Speech"
      ],
      "Year": "2010",
      "Director": "Tom Hooper",
      "DirectorArray": [
        "Tom Hooper"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3810",
      "databaseFilmTitle": "The King's Wake",
      "FilmTitle": "The King's Wake",
      "AlternateTitle": "",
      "TitleArray": [
        "The King's Wake"
      ],
      "Year": "2000",
      "Director": "John McCloskey",
      "DirectorArray": [
        "John McCloskey"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3811",
      "databaseFilmTitle": "The Kingdom",
      "FilmTitle": "The Kingdom",
      "AlternateTitle": "Riget",
      "TitleArray": [
        "The Kingdom",
        "Riget"
      ],
      "Year": "1994",
      "Director": "Lars von Trier",
      "DirectorArray": [
        "Lars von Trier"
      ],
      "Country": "Denmark",
      "CountryArray": [
        "Denmark"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3812",
      "databaseFilmTitle": "The Kingdom of Naples",
      "FilmTitle": "The Kingdom of Naples",
      "AlternateTitle": "Nel regno di Napoli",
      "TitleArray": [
        "The Kingdom of Naples",
        "Nel regno di Napoli"
      ],
      "Year": "1978",
      "Director": "Werner Schroeter",
      "DirectorArray": [
        "Werner Schroeter"
      ],
      "Country": "Italy, West Germany",
      "CountryArray": [
        "Italy",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3813",
      "databaseFilmTitle": "The Knack ...And How to Get It",
      "FilmTitle": "The Knack ...And How to Get It",
      "AlternateTitle": "",
      "TitleArray": [
        "The Knack ...And How to Get It"
      ],
      "Year": "1965",
      "Director": "Richard Lester",
      "DirectorArray": [
        "Richard Lester"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3814",
      "databaseFilmTitle": "The Knell",
      "FilmTitle": "The Knell",
      "AlternateTitle": "Le glas",
      "TitleArray": [
        "The Knell",
        "Le glas"
      ],
      "Year": "1964",
      "Director": "René Vautier",
      "DirectorArray": [
        "René Vautier"
      ],
      "Country": "Algeria, Zimbabwe",
      "CountryArray": [
        "Algeria",
        "Zimbabwe"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3815",
      "databaseFilmTitle": "The Koumiko Mystery",
      "FilmTitle": "The Koumiko Mystery",
      "AlternateTitle": "Le mystère Koumiko",
      "TitleArray": [
        "The Koumiko Mystery",
        "Le mystère Koumiko"
      ],
      "Year": "1965",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3816",
      "databaseFilmTitle": "The L-shaped Room",
      "FilmTitle": "The L-shaped Room",
      "AlternateTitle": "",
      "TitleArray": [
        "The L-shaped Room"
      ],
      "Year": "1962",
      "Director": "Bryan Forbes",
      "DirectorArray": [
        "Bryan Forbes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3817",
      "databaseFilmTitle": "The Ladies Man",
      "FilmTitle": "The Ladies Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ladies Man"
      ],
      "Year": "1961",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3818",
      "databaseFilmTitle": "The Lady Eve",
      "FilmTitle": "The Lady Eve",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lady Eve"
      ],
      "Year": "1941",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "3819",
      "databaseFilmTitle": "The Lady from Shanghai",
      "FilmTitle": "The Lady from Shanghai",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lady from Shanghai"
      ],
      "Year": "1947",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3820",
      "databaseFilmTitle": "The Lady of the Dugout",
      "FilmTitle": "The Lady of the Dugout",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lady of the Dugout"
      ],
      "Year": "1918",
      "Director": "W.S. Van Dyke",
      "DirectorArray": [
        "W.S. Van Dyke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3821",
      "databaseFilmTitle": "The Lady Vanishes",
      "FilmTitle": "The Lady Vanishes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lady Vanishes"
      ],
      "Year": "1938",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3822",
      "databaseFilmTitle": "The Lady With the Little Dog",
      "FilmTitle": "The Lady With the Little Dog",
      "AlternateTitle": "Dama s sobachkoj",
      "TitleArray": [
        "The Lady With the Little Dog",
        "Dama s sobachkoj"
      ],
      "Year": "1960",
      "Director": "Iosif Kheifits",
      "DirectorArray": [
        "Iosif Kheifits"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3823",
      "databaseFilmTitle": "The Lady Without Camelias",
      "FilmTitle": "The Lady Without Camelias",
      "AlternateTitle": "La signora senza camelie",
      "TitleArray": [
        "The Lady Without Camelias",
        "La signora senza camelie"
      ],
      "Year": "1953",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3824",
      "databaseFilmTitle": "The Ladykillers",
      "FilmTitle": "The Ladykillers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ladykillers"
      ],
      "Year": "1955",
      "Director": "Alexander Mackendrick",
      "DirectorArray": [
        "Alexander Mackendrick"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3825",
      "databaseFilmTitle": "The Lamentations Series: The Ninth Night and Day",
      "FilmTitle": "The Lamentations Series: The Ninth Night and Day",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lamentations Series: The Ninth Night and Day"
      ],
      "Year": "2005",
      "Director": "Jalal Toufic",
      "DirectorArray": [
        "Jalal Toufic"
      ],
      "Country": "Lebanon",
      "CountryArray": [
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3826",
      "databaseFilmTitle": "The Land Beyond the Sunset",
      "FilmTitle": "The Land Beyond the Sunset",
      "AlternateTitle": "",
      "TitleArray": [
        "The Land Beyond the Sunset"
      ],
      "Year": "1912",
      "Director": "Harold M. Shaw",
      "DirectorArray": [
        "Harold M. Shaw"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3827",
      "databaseFilmTitle": "The Land of the Fathers",
      "FilmTitle": "The Land of the Fathers",
      "AlternateTitle": "Zemlya ottsov",
      "TitleArray": [
        "The Land of the Fathers",
        "Zemlya ottsov"
      ],
      "Year": "1966",
      "Director": "Shaken Aimanov",
      "DirectorArray": [
        "Shaken Aimanov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3828",
      "databaseFilmTitle": "The Landlord",
      "FilmTitle": "The Landlord",
      "AlternateTitle": "",
      "TitleArray": [
        "The Landlord"
      ],
      "Year": "1970",
      "Director": "Hal Ashby",
      "DirectorArray": [
        "Hal Ashby"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3829",
      "databaseFilmTitle": "The Last Angel of History",
      "FilmTitle": "The Last Angel of History",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Angel of History"
      ],
      "Year": "1996",
      "Director": "John Akomfrah",
      "DirectorArray": [
        "John Akomfrah"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3830",
      "databaseFilmTitle": "The Last Black Man in San Francisco",
      "FilmTitle": "The Last Black Man in San Francisco",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Black Man in San Francisco"
      ],
      "Year": "2019",
      "Director": "Joe Talbot",
      "DirectorArray": [
        "Joe Talbot"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3831",
      "databaseFilmTitle": "The Last Bolshevik",
      "FilmTitle": "The Last Bolshevik",
      "AlternateTitle": "Le tombeau d'Alexandre",
      "TitleArray": [
        "The Last Bolshevik",
        "Le tombeau d'Alexandre"
      ],
      "Year": "1993",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3832",
      "databaseFilmTitle": "The Last Command",
      "FilmTitle": "The Last Command",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Command"
      ],
      "Year": "1928",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3833",
      "databaseFilmTitle": "The Last Day of Summer",
      "FilmTitle": "The Last Day of Summer",
      "AlternateTitle": "Ostatni dzień lata",
      "TitleArray": [
        "The Last Day of Summer",
        "Ostatni dzień lata"
      ],
      "Year": "1958",
      "Director": "Tadeusz Konwicki",
      "DirectorArray": [
        "Tadeusz Konwicki"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3834",
      "databaseFilmTitle": "The Last Days of Disco",
      "FilmTitle": "The Last Days of Disco",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Days of Disco"
      ],
      "Year": "1998",
      "Director": "Whit Stillman",
      "DirectorArray": [
        "Whit Stillman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3835",
      "databaseFilmTitle": "The Last Emperor",
      "FilmTitle": "The Last Emperor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Emperor"
      ],
      "Year": "1987",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "China, Italy",
      "CountryArray": [
        "China",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3836",
      "databaseFilmTitle": "The Last Flight",
      "FilmTitle": "The Last Flight",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Flight"
      ],
      "Year": "1931",
      "Director": "William Dieterle",
      "DirectorArray": [
        "William Dieterle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3837",
      "databaseFilmTitle": "The Last Hunt",
      "FilmTitle": "The Last Hunt",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Hunt"
      ],
      "Year": "1956",
      "Director": "Richard Brooks",
      "DirectorArray": [
        "Richard Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3838",
      "databaseFilmTitle": "The Last Laugh",
      "FilmTitle": "The Last Laugh",
      "AlternateTitle": "Der letzte Mann",
      "TitleArray": [
        "The Last Laugh",
        "Der letzte Mann"
      ],
      "Year": "1924",
      "Director": "F.W. Murnau",
      "DirectorArray": [
        "F.W. Murnau"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "3839",
      "databaseFilmTitle": "The Last Metro",
      "FilmTitle": "The Last Metro",
      "AlternateTitle": "Le dernier métro",
      "TitleArray": [
        "The Last Metro",
        "Le dernier métro"
      ],
      "Year": "1980",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3840",
      "databaseFilmTitle": "The Last of England",
      "FilmTitle": "The Last of England",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last of England"
      ],
      "Year": "1987",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3841",
      "databaseFilmTitle": "The Last of Sheila",
      "FilmTitle": "The Last of Sheila",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last of Sheila"
      ],
      "Year": "1973",
      "Director": "Herbert Ross",
      "DirectorArray": [
        "Herbert Ross"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3842",
      "databaseFilmTitle": "The Last of the Mohicans",
      "FilmTitle": "The Last of the Mohicans",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last of the Mohicans"
      ],
      "Year": "1992",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3843",
      "databaseFilmTitle": "The Last Picture Show",
      "FilmTitle": "The Last Picture Show",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Picture Show"
      ],
      "Year": "1971",
      "Director": "Peter Bogdanovich",
      "DirectorArray": [
        "Peter Bogdanovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3844",
      "databaseFilmTitle": "The Last Seduction",
      "FilmTitle": "The Last Seduction",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Seduction"
      ],
      "Year": "1994",
      "Director": "John Dahl",
      "DirectorArray": [
        "John Dahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3845",
      "databaseFilmTitle": "The Last Stage",
      "FilmTitle": "The Last Stage",
      "AlternateTitle": "Ostatni etap",
      "TitleArray": [
        "The Last Stage",
        "Ostatni etap"
      ],
      "Year": "1948",
      "Director": "Wanda Jakubowska",
      "DirectorArray": [
        "Wanda Jakubowska"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3846",
      "databaseFilmTitle": "The Last Supper",
      "FilmTitle": "The Last Supper",
      "AlternateTitle": "La última cena",
      "TitleArray": [
        "The Last Supper",
        "La última cena"
      ],
      "Year": "1976",
      "Director": "Tomás Gutiérrez Alea",
      "DirectorArray": [
        "Tomás Gutiérrez Alea"
      ],
      "Country": "Cuba",
      "CountryArray": [
        "Cuba"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3847",
      "databaseFilmTitle": "The Last Temptation of Christ",
      "FilmTitle": "The Last Temptation of Christ",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Temptation of Christ"
      ],
      "Year": "1988",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3848",
      "databaseFilmTitle": "The Last Ten Days",
      "FilmTitle": "The Last Ten Days",
      "AlternateTitle": "Der letzte Akt",
      "TitleArray": [
        "The Last Ten Days",
        "Der letzte Akt"
      ],
      "Year": "1955",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3849",
      "databaseFilmTitle": "The Last Train",
      "FilmTitle": "The Last Train",
      "AlternateTitle": "Le train",
      "TitleArray": [
        "The Last Train",
        "Le train"
      ],
      "Year": "1973",
      "Director": "Pierre Grainer-Deferre",
      "DirectorArray": [
        "Pierre Grainer-Deferre"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3850",
      "databaseFilmTitle": "The Last Vacation",
      "FilmTitle": "The Last Vacation",
      "AlternateTitle": "Les dernières vacances",
      "TitleArray": [
        "The Last Vacation",
        "Les dernières vacances"
      ],
      "Year": "1947",
      "Director": "Roger Leenhardt",
      "DirectorArray": [
        "Roger Leenhardt"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3851",
      "databaseFilmTitle": "The Last Wave",
      "FilmTitle": "The Last Wave",
      "AlternateTitle": "",
      "TitleArray": [
        "The Last Wave"
      ],
      "Year": "1977",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3852",
      "databaseFilmTitle": "The Last Woman",
      "FilmTitle": "The Last Woman",
      "AlternateTitle": "La dernière femme",
      "TitleArray": [
        "The Last Woman",
        "La dernière femme"
      ],
      "Year": "1976",
      "Director": "Marco Ferreri",
      "DirectorArray": [
        "Marco Ferreri"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3853",
      "databaseFilmTitle": "The Last Word",
      "FilmTitle": "The Last Word",
      "AlternateTitle": "Poslednata duma",
      "TitleArray": [
        "The Last Word",
        "Poslednata duma"
      ],
      "Year": "1973",
      "Director": "Binka Zhelyazkova",
      "DirectorArray": [
        "Binka Zhelyazkova"
      ],
      "Country": "Bulgaria",
      "CountryArray": [
        "Bulgaria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3854",
      "databaseFilmTitle": "The Late Mathias Pascal",
      "FilmTitle": "The Late Mathias Pascal",
      "AlternateTitle": "Feu Mathias Pascal",
      "TitleArray": [
        "The Late Mathias Pascal",
        "Feu Mathias Pascal"
      ],
      "Year": "1925",
      "Director": "Marcel L'Herbier",
      "DirectorArray": [
        "Marcel L'Herbier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3855",
      "databaseFilmTitle": "The Laughing Man",
      "FilmTitle": "The Laughing Man",
      "AlternateTitle": "Der lachende Mann – Bekenntnisse eines Mörders",
      "TitleArray": [
        "The Laughing Man",
        "Der lachende Mann – Bekenntnisse eines Mörders"
      ],
      "Year": "1966",
      "Director": "Walter Heynowski, Gerhard Scheumann",
      "DirectorArray": [
        "Walter Heynowski",
        "Gerhard Scheumann"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3856",
      "databaseFilmTitle": "The Laughing Woman",
      "FilmTitle": "The Laughing Woman",
      "AlternateTitle": "Femina ridens",
      "TitleArray": [
        "The Laughing Woman",
        "Femina ridens"
      ],
      "Year": "1969",
      "Director": "Piero Schivazappa",
      "DirectorArray": [
        "Piero Schivazappa"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3857",
      "databaseFilmTitle": "The Lavender Hill Mob",
      "FilmTitle": "The Lavender Hill Mob",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lavender Hill Mob"
      ],
      "Year": "1951",
      "Director": "Charles Crichton",
      "DirectorArray": [
        "Charles Crichton"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3858",
      "databaseFilmTitle": "The Law",
      "FilmTitle": "The Law",
      "AlternateTitle": "Tilaï",
      "TitleArray": [
        "The Law",
        "Tilaï"
      ],
      "Year": "1990",
      "Director": "Idrissa Ouedraogo",
      "DirectorArray": [
        "Idrissa Ouedraogo"
      ],
      "Country": "Burkina Faso",
      "CountryArray": [
        "Burkina Faso"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3859",
      "databaseFilmTitle": "The Left-Handed Woman",
      "FilmTitle": "The Left-Handed Woman",
      "AlternateTitle": "Die linkshändige Frau",
      "TitleArray": [
        "The Left-Handed Woman",
        "Die linkshändige Frau"
      ],
      "Year": "1978",
      "Director": "Peter Handke",
      "DirectorArray": [
        "Peter Handke"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3860",
      "databaseFilmTitle": "The Leopard",
      "FilmTitle": "The Leopard",
      "AlternateTitle": "Il gattopardo",
      "TitleArray": [
        "The Leopard",
        "Il gattopardo"
      ],
      "Year": "1963",
      "Director": "Luchino Visconti",
      "DirectorArray": [
        "Luchino Visconti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "57",
      "2012votes": "26",
      "2022rank": "90",
      "2022votes": "32"
    },
    {
      "key": "3861",
      "databaseFilmTitle": "The Letter",
      "FilmTitle": "The Letter",
      "AlternateTitle": "",
      "TitleArray": [
        "The Letter"
      ],
      "Year": "1940",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3862",
      "databaseFilmTitle": "The Life and Death of Colonel Blimp",
      "FilmTitle": "The Life and Death of Colonel Blimp",
      "AlternateTitle": "",
      "TitleArray": [
        "The Life and Death of Colonel Blimp"
      ],
      "Year": "1943",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "3863",
      "databaseFilmTitle": "The Life and Times of Judge Roy Bean",
      "FilmTitle": "The Life and Times of Judge Roy Bean",
      "AlternateTitle": "",
      "TitleArray": [
        "The Life and Times of Judge Roy Bean"
      ],
      "Year": "1972",
      "Director": "Jonhn Huston",
      "DirectorArray": [
        "Jonhn Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3864",
      "databaseFilmTitle": "The Life of Jésus",
      "FilmTitle": "The Life of Jésus",
      "AlternateTitle": "La Vie de Jésus",
      "TitleArray": [
        "The Life of Jésus",
        "La Vie de Jésus"
      ],
      "Year": "1997",
      "Director": "Bruno Dumont",
      "DirectorArray": [
        "Bruno Dumont"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3865",
      "databaseFilmTitle": "The Life of Oharu",
      "FilmTitle": "The Life of Oharu",
      "AlternateTitle": "Saikaku ichidai onna",
      "TitleArray": [
        "The Life of Oharu",
        "Saikaku ichidai onna"
      ],
      "Year": "1952",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3866",
      "databaseFilmTitle": "The Lighthouse",
      "FilmTitle": "The Lighthouse",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lighthouse"
      ],
      "Year": "2019",
      "Director": "Robert Eggers",
      "DirectorArray": [
        "Robert Eggers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3867",
      "databaseFilmTitle": "The Lightship",
      "FilmTitle": "The Lightship",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lightship"
      ],
      "Year": "1985",
      "Director": "Jerzy Sklimowski",
      "DirectorArray": [
        "Jerzy Sklimowski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3868",
      "databaseFilmTitle": "The Lin Family Shop",
      "FilmTitle": "The Lin Family Shop",
      "AlternateTitle": "Lin jia pu zi",
      "TitleArray": [
        "The Lin Family Shop",
        "Lin jia pu zi"
      ],
      "Year": "1959",
      "Director": "Shui Hua",
      "DirectorArray": [
        "Shui Hua"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3869",
      "databaseFilmTitle": "The Line",
      "FilmTitle": "The Line",
      "AlternateTitle": "",
      "TitleArray": [
        "The Line"
      ],
      "Year": "2019",
      "Director": "Ricardo Laganaro",
      "DirectorArray": [
        "Ricardo Laganaro"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3870",
      "databaseFilmTitle": "The Lion Has Seven Heads",
      "FilmTitle": "The Lion Has Seven Heads",
      "AlternateTitle": "Der Leone Have Sept Cabeças",
      "TitleArray": [
        "The Lion Has Seven Heads",
        "Der Leone Have Sept Cabeças"
      ],
      "Year": "1970",
      "Director": "Glauber Rocha",
      "DirectorArray": [
        "Glauber Rocha"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3871",
      "databaseFilmTitle": "The Lion King",
      "FilmTitle": "The Lion King",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lion King"
      ],
      "Year": "1994",
      "Director": "Roger Allers, Rob Minkoff",
      "DirectorArray": [
        "Roger Allers",
        "Rob Minkoff"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3872",
      "databaseFilmTitle": "The Little Foxes",
      "FilmTitle": "The Little Foxes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Little Foxes"
      ],
      "Year": "1941",
      "Director": "William Wyler",
      "DirectorArray": [
        "William Wyler"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3873",
      "databaseFilmTitle": "The Little Girl and Her Cat",
      "FilmTitle": "The Little Girl and Her Cat",
      "AlternateTitle": "La petite fille et son chat",
      "TitleArray": [
        "The Little Girl and Her Cat",
        "La petite fille et son chat"
      ],
      "Year": "1899",
      "Director": "Louis Lumière",
      "DirectorArray": [
        "Louis Lumière"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3874",
      "databaseFilmTitle": "The Little Girl Who Sold the Sun",
      "FilmTitle": "The Little Girl Who Sold the Sun",
      "AlternateTitle": "La petite vendeuse de soleil",
      "TitleArray": [
        "The Little Girl Who Sold the Sun",
        "La petite vendeuse de soleil"
      ],
      "Year": "1999",
      "Director": "Djibril Diop Mambéty",
      "DirectorArray": [
        "Djibril Diop Mambéty"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3875",
      "databaseFilmTitle": "The Little Snow Animal",
      "FilmTitle": "The Little Snow Animal",
      "AlternateTitle": "Lumikko",
      "TitleArray": [
        "The Little Snow Animal",
        "Lumikko"
      ],
      "Year": "2009",
      "Director": "Miia Tervo",
      "DirectorArray": [
        "Miia Tervo"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3876",
      "databaseFilmTitle": "The Lives of Others",
      "FilmTitle": "The Lives of Others",
      "AlternateTitle": "Das leben der Anderen",
      "TitleArray": [
        "The Lives of Others",
        "Das leben der Anderen"
      ],
      "Year": "2006",
      "Director": "Florian Henckel von Donnersmarck",
      "DirectorArray": [
        "Florian Henckel von Donnersmarck"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3877",
      "databaseFilmTitle": "The Living Daylights",
      "FilmTitle": "The Living Daylights",
      "AlternateTitle": "",
      "TitleArray": [
        "The Living Daylights"
      ],
      "Year": "1987",
      "Director": "John Glen",
      "DirectorArray": [
        "John Glen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3878",
      "databaseFilmTitle": "The Lobster",
      "FilmTitle": "The Lobster",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lobster"
      ],
      "Year": "2015",
      "Director": "Yorgos Lanthimos",
      "DirectorArray": [
        "Yorgos Lanthimos"
      ],
      "Country": "Ireland, Greece",
      "CountryArray": [
        "Ireland",
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3879",
      "databaseFilmTitle": "The Lock-In",
      "FilmTitle": "The Lock-In",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lock-In"
      ],
      "Year": "2022",
      "Director": "Stanley Schtinter",
      "DirectorArray": [
        "Stanley Schtinter"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3880",
      "databaseFilmTitle": "The Lodger: A Story of the London Fog",
      "FilmTitle": "The Lodger: A Story of the London Fog",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lodger: A Story of the London Fog"
      ],
      "Year": "1927",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3881",
      "databaseFilmTitle": "The Lonedale Operator",
      "FilmTitle": "The Lonedale Operator",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lonedale Operator"
      ],
      "Year": "1911",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3882",
      "databaseFilmTitle": "The Loneliest Planet",
      "FilmTitle": "The Loneliest Planet",
      "AlternateTitle": "",
      "TitleArray": [
        "The Loneliest Planet"
      ],
      "Year": "2011",
      "Director": "Julia Loktev",
      "DirectorArray": [
        "Julia Loktev"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3883",
      "databaseFilmTitle": "The Loneliness of the Long Distance Runner",
      "FilmTitle": "The Loneliness of the Long Distance Runner",
      "AlternateTitle": "",
      "TitleArray": [
        "The Loneliness of the Long Distance Runner"
      ],
      "Year": "1962",
      "Director": "Tony Richardson",
      "DirectorArray": [
        "Tony Richardson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3884",
      "databaseFilmTitle": "The Long Absence",
      "FilmTitle": "The Long Absence",
      "AlternateTitle": "Une aussi longue absence",
      "TitleArray": [
        "The Long Absence",
        "Une aussi longue absence"
      ],
      "Year": "1961",
      "Director": "Henry Colpi",
      "DirectorArray": [
        "Henry Colpi"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3885",
      "databaseFilmTitle": "The Long Day Closes",
      "FilmTitle": "The Long Day Closes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Day Closes"
      ],
      "Year": "1992",
      "Director": "Terence Davies",
      "DirectorArray": [
        "Terence Davies"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "3886",
      "databaseFilmTitle": "The Long Day's Dying",
      "FilmTitle": "The Long Day's Dying",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Day's Dying"
      ],
      "Year": "1968",
      "Director": "Peter Collinson",
      "DirectorArray": [
        "Peter Collinson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3887",
      "databaseFilmTitle": "The Long Farewell",
      "FilmTitle": "The Long Farewell",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Farewell"
      ],
      "Year": "1971",
      "Director": "Kira Muratova",
      "DirectorArray": [
        "Kira Muratova"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3888",
      "databaseFilmTitle": "The Long Goodbye",
      "FilmTitle": "The Long Goodbye",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Goodbye"
      ],
      "Year": "1973",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3889",
      "databaseFilmTitle": "The Long Gray Line",
      "FilmTitle": "The Long Gray Line",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Gray Line"
      ],
      "Year": "1955",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3890",
      "databaseFilmTitle": "The Long Voyage Home",
      "FilmTitle": "The Long Voyage Home",
      "AlternateTitle": "",
      "TitleArray": [
        "The Long Voyage Home"
      ],
      "Year": "1940",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3891",
      "databaseFilmTitle": "The Longest Night",
      "FilmTitle": "The Longest Night",
      "AlternateTitle": "Nay-dalgata nosht",
      "TitleArray": [
        "The Longest Night",
        "Nay-dalgata nosht"
      ],
      "Year": "1967",
      "Director": "Vulo Radev",
      "DirectorArray": [
        "Vulo Radev"
      ],
      "Country": "Bulgaria",
      "CountryArray": [
        "Bulgaria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3892",
      "databaseFilmTitle": "The Look of Silence",
      "FilmTitle": "The Look of Silence",
      "AlternateTitle": "Senyap",
      "TitleArray": [
        "The Look of Silence",
        "Senyap"
      ],
      "Year": "2014",
      "Director": "Joshua Oppenheimer",
      "DirectorArray": [
        "Joshua Oppenheimer"
      ],
      "Country": "Denmark, Indonesia",
      "CountryArray": [
        "Denmark",
        "Indonesia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3893",
      "databaseFilmTitle": "The Lord of the Rings: The Fellowship of the Ring",
      "FilmTitle": "The Lord of the Rings: The Fellowship of the Ring",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lord of the Rings: The Fellowship of the Ring"
      ],
      "Year": "2001",
      "Director": "Peter Jackson",
      "DirectorArray": [
        "Peter Jackson"
      ],
      "Country": "United States, New Zealand",
      "CountryArray": [
        "United States",
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "3894",
      "databaseFilmTitle": "The Lord of the Rings: The Return of the King",
      "FilmTitle": "The Lord of the Rings: The Return of the King",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lord of the Rings: The Return of the King"
      ],
      "Year": "2003",
      "Director": "Peter Jackson",
      "DirectorArray": [
        "Peter Jackson"
      ],
      "Country": "United States, New Zealand",
      "CountryArray": [
        "United States",
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3895",
      "databaseFilmTitle": "The Lord of the Rings: The Two Towers",
      "FilmTitle": "The Lord of the Rings: The Two Towers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lord of the Rings: The Two Towers"
      ],
      "Year": "2002",
      "Director": "Peter Jackson",
      "DirectorArray": [
        "Peter Jackson"
      ],
      "Country": "United States, New Zealand",
      "CountryArray": [
        "United States",
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3896",
      "databaseFilmTitle": "The Loss of Sexual Innocence",
      "FilmTitle": "The Loss of Sexual Innocence",
      "AlternateTitle": "",
      "TitleArray": [
        "The Loss of Sexual Innocence"
      ],
      "Year": "1999",
      "Director": "Mike Figgis",
      "DirectorArray": [
        "Mike Figgis"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3897",
      "databaseFilmTitle": "The Lost Boys",
      "FilmTitle": "The Lost Boys",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lost Boys"
      ],
      "Year": "1987",
      "Director": "Joel Schumacher",
      "DirectorArray": [
        "Joel Schumacher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3898",
      "databaseFilmTitle": "The Lost Honor of Katharina Blum",
      "FilmTitle": "The Lost Honor of Katharina Blum",
      "AlternateTitle": "Die verlorene Ehre der Katharina Blum oder: Wie Gewalt entstehen und wohin sie führen kann",
      "TitleArray": [
        "The Lost Honor of Katharina Blum",
        "Die verlorene Ehre der Katharina Blum oder: Wie Gewalt entstehen und wohin sie führen kann"
      ],
      "Year": "1975",
      "Director": "Volker Schlöndorff, Margarethe von Trotta",
      "DirectorArray": [
        "Volker Schlöndorff",
        "Margarethe von Trotta"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3899",
      "databaseFilmTitle": "The Lost One",
      "FilmTitle": "The Lost One",
      "AlternateTitle": "Der Verlorene",
      "TitleArray": [
        "The Lost One",
        "Der Verlorene"
      ],
      "Year": "1951",
      "Director": "Peter Lorre",
      "DirectorArray": [
        "Peter Lorre"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3900",
      "databaseFilmTitle": "The Lost Patrol",
      "FilmTitle": "The Lost Patrol",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lost Patrol"
      ],
      "Year": "1934",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3901",
      "databaseFilmTitle": "The Lost Weekend",
      "FilmTitle": "The Lost Weekend",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lost Weekend"
      ],
      "Year": "1945",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3902",
      "databaseFilmTitle": "The Love of a Woman",
      "FilmTitle": "The Love of a Woman",
      "AlternateTitle": "L'amour d'une femme",
      "TitleArray": [
        "The Love of a Woman",
        "L'amour d'une femme"
      ],
      "Year": "1953",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3903",
      "databaseFilmTitle": "The Love of Jeanne Ney",
      "FilmTitle": "The Love of Jeanne Ney",
      "AlternateTitle": "Die liebe der Jeanne Ney",
      "TitleArray": [
        "The Love of Jeanne Ney",
        "Die liebe der Jeanne Ney"
      ],
      "Year": "1927",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3904",
      "databaseFilmTitle": "The Love Witch",
      "FilmTitle": "The Love Witch",
      "AlternateTitle": "",
      "TitleArray": [
        "The Love Witch"
      ],
      "Year": "2016",
      "Director": "Anna Biller",
      "DirectorArray": [
        "Anna Biller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3905",
      "databaseFilmTitle": "The Lovers on the Bridge",
      "FilmTitle": "The Lovers on the Bridge",
      "AlternateTitle": "Les amants du pont-neuf",
      "TitleArray": [
        "The Lovers on the Bridge",
        "Les amants du pont-neuf"
      ],
      "Year": "1991",
      "Director": "Leos Carax",
      "DirectorArray": [
        "Leos Carax"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3906",
      "databaseFilmTitle": "The Lower Depths",
      "FilmTitle": "The Lower Depths",
      "AlternateTitle": "Donzoko",
      "TitleArray": [
        "The Lower Depths",
        "Donzoko"
      ],
      "Year": "1957",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3907",
      "databaseFilmTitle": "The Lusty Men",
      "FilmTitle": "The Lusty Men",
      "AlternateTitle": "",
      "TitleArray": [
        "The Lusty Men"
      ],
      "Year": "1952",
      "Director": "Nicholas Ray, Robert Parrish",
      "DirectorArray": [
        "Nicholas Ray",
        "Robert Parrish"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3908",
      "databaseFilmTitle": "The Lyre of Delight",
      "FilmTitle": "The Lyre of Delight",
      "AlternateTitle": "A Lira do Delírio",
      "TitleArray": [
        "The Lyre of Delight",
        "A Lira do Delírio"
      ],
      "Year": "1978",
      "Director": "Walter Lima Jr.",
      "DirectorArray": [
        "Walter Lima Jr."
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3909",
      "databaseFilmTitle": "The Mad Fox",
      "FilmTitle": "The Mad Fox",
      "AlternateTitle": "Koiya koi nasuna koi",
      "TitleArray": [
        "The Mad Fox",
        "Koiya koi nasuna koi"
      ],
      "Year": "1962",
      "Director": "Tomu Uchida",
      "DirectorArray": [
        "Tomu Uchida"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3910",
      "databaseFilmTitle": "The Mad Masters",
      "FilmTitle": "The Mad Masters",
      "AlternateTitle": "Les maîtres fous",
      "TitleArray": [
        "The Mad Masters",
        "Les maîtres fous"
      ],
      "Year": "1957",
      "Director": "Jean Rouch",
      "DirectorArray": [
        "Jean Rouch"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3911",
      "databaseFilmTitle": "The Mad Songs of Fernanda Hussein",
      "FilmTitle": "The Mad Songs of Fernanda Hussein",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mad Songs of Fernanda Hussein"
      ],
      "Year": "2001",
      "Director": "John Gianvito",
      "DirectorArray": [
        "John Gianvito"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3912",
      "databaseFilmTitle": "The Magnificent Ambersons",
      "FilmTitle": "The Magnificent Ambersons",
      "AlternateTitle": "",
      "TitleArray": [
        "The Magnificent Ambersons"
      ],
      "Year": "1942",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "8",
      "1972votes": "10",
      "1982rank": "7",
      "1982votes": "12",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "81",
      "2012votes": "20",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "3913",
      "databaseFilmTitle": "The Magnificent Seven",
      "FilmTitle": "The Magnificent Seven",
      "AlternateTitle": "",
      "TitleArray": [
        "The Magnificent Seven"
      ],
      "Year": "1960",
      "Director": "John Sturges",
      "DirectorArray": [
        "John Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3914",
      "databaseFilmTitle": "The Making of Monsters",
      "FilmTitle": "The Making of Monsters",
      "AlternateTitle": "",
      "TitleArray": [
        "The Making of Monsters"
      ],
      "Year": "1990",
      "Director": "John Greyson",
      "DirectorArray": [
        "John Greyson"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3915",
      "databaseFilmTitle": "The Maltese Falcon",
      "FilmTitle": "The Maltese Falcon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Maltese Falcon"
      ],
      "Year": "1941",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3916",
      "databaseFilmTitle": "The Man by the Shore",
      "FilmTitle": "The Man by the Shore",
      "AlternateTitle": "L'homme sur les quais",
      "TitleArray": [
        "The Man by the Shore",
        "L'homme sur les quais"
      ],
      "Year": "1993",
      "Director": "Raoul Peck",
      "DirectorArray": [
        "Raoul Peck"
      ],
      "Country": "Haiti, France",
      "CountryArray": [
        "Haiti",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3917",
      "databaseFilmTitle": "The Man in the White Suit",
      "FilmTitle": "The Man in the White Suit",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man in the White Suit"
      ],
      "Year": "1951",
      "Director": "Alexander Mackendrick",
      "DirectorArray": [
        "Alexander Mackendrick"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3918",
      "databaseFilmTitle": "The Man of the Story",
      "FilmTitle": "The Man of the Story",
      "AlternateTitle": "Kathapurushan",
      "TitleArray": [
        "The Man of the Story",
        "Kathapurushan"
      ],
      "Year": "1997",
      "Director": "Adoor Gopalakrishnan",
      "DirectorArray": [
        "Adoor Gopalakrishnan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3919",
      "databaseFilmTitle": "The Man on the Roof",
      "FilmTitle": "The Man on the Roof",
      "AlternateTitle": "Mannen på taket",
      "TitleArray": [
        "The Man on the Roof",
        "Mannen på taket"
      ],
      "Year": "1976",
      "Director": "Bo Widerberg",
      "DirectorArray": [
        "Bo Widerberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3920",
      "databaseFilmTitle": "The Man Who Disappeared Yesterday",
      "FilmTitle": "The Man Who Disappeared Yesterday",
      "AlternateTitle": "Kinô kieta otoko",
      "TitleArray": [
        "The Man Who Disappeared Yesterday",
        "Kinô kieta otoko"
      ],
      "Year": "1941",
      "Director": "Masahiro Makino",
      "DirectorArray": [
        "Masahiro Makino"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3921",
      "databaseFilmTitle": "The Man Who Fell to Earth",
      "FilmTitle": "The Man Who Fell to Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man Who Fell to Earth"
      ],
      "Year": "1976",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3922",
      "databaseFilmTitle": "The Man Who Knew Too Much",
      "FilmTitle": "The Man Who Knew Too Much",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man Who Knew Too Much"
      ],
      "Year": "1956",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3923",
      "databaseFilmTitle": "The Man Who Laughs",
      "FilmTitle": "The Man Who Laughs",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man Who Laughs"
      ],
      "Year": "1928",
      "Director": "Paul Leni",
      "DirectorArray": [
        "Paul Leni"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3924",
      "databaseFilmTitle": "The Man Who Left His Will on Film",
      "FilmTitle": "The Man Who Left His Will on Film",
      "AlternateTitle": "Tôkyô senso sengo hiwa",
      "TitleArray": [
        "The Man Who Left His Will on Film",
        "Tôkyô senso sengo hiwa"
      ],
      "Year": "1970",
      "Director": "Nagisa Ôshima",
      "DirectorArray": [
        "Nagisa Ôshima"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3925",
      "databaseFilmTitle": "The Man Who Lies",
      "FilmTitle": "The Man Who Lies",
      "AlternateTitle": "L'homme qui ment",
      "TitleArray": [
        "The Man Who Lies",
        "L'homme qui ment"
      ],
      "Year": "1968",
      "Director": "Alain Robbe-Grillet",
      "DirectorArray": [
        "Alain Robbe-Grillet"
      ],
      "Country": "France, Czechoslovakia",
      "CountryArray": [
        "France",
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3926",
      "databaseFilmTitle": "The Man Who Loved Women",
      "FilmTitle": "The Man Who Loved Women",
      "AlternateTitle": "L'homme qui aimait les femmes",
      "TitleArray": [
        "The Man Who Loved Women",
        "L'homme qui aimait les femmes"
      ],
      "Year": "1977",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3927",
      "databaseFilmTitle": "The Man Who Planted Trees",
      "FilmTitle": "The Man Who Planted Trees",
      "AlternateTitle": "L'homme qui plantait des arbres",
      "TitleArray": [
        "The Man Who Planted Trees",
        "L'homme qui plantait des arbres"
      ],
      "Year": "1987",
      "Director": "Frédéric Back",
      "DirectorArray": [
        "Frédéric Back"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3928",
      "databaseFilmTitle": "The Man Who Shot Liberty Valance",
      "FilmTitle": "The Man Who Shot Liberty Valance",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man Who Shot Liberty Valance"
      ],
      "Year": "1962",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "3929",
      "databaseFilmTitle": "The Man Who Stole the Sun",
      "FilmTitle": "The Man Who Stole the Sun",
      "AlternateTitle": "Taiyô wo nusunda otoko",
      "TitleArray": [
        "The Man Who Stole the Sun",
        "Taiyô wo nusunda otoko"
      ],
      "Year": "1979",
      "Director": "Kazuhiko Hasegawa",
      "DirectorArray": [
        "Kazuhiko Hasegawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3930",
      "databaseFilmTitle": "The Man Who Would Be King",
      "FilmTitle": "The Man Who Would Be King",
      "AlternateTitle": "",
      "TitleArray": [
        "The Man Who Would Be King"
      ],
      "Year": "1975",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3931",
      "databaseFilmTitle": "The Man with the Rubber Head",
      "FilmTitle": "The Man with the Rubber Head",
      "AlternateTitle": "L'Homme à la tête en caoutchouc",
      "TitleArray": [
        "The Man with the Rubber Head",
        "L'Homme à la tête en caoutchouc"
      ],
      "Year": "1901",
      "Director": "Georges Méliès",
      "DirectorArray": [
        "Georges Méliès"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3932",
      "databaseFilmTitle": "The Manchurian Candidate",
      "FilmTitle": "The Manchurian Candidate",
      "AlternateTitle": "",
      "TitleArray": [
        "The Manchurian Candidate"
      ],
      "Year": "1962",
      "Director": "John Frankenheimer",
      "DirectorArray": [
        "John Frankenheimer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3933",
      "databaseFilmTitle": "The Margin",
      "FilmTitle": "The Margin",
      "AlternateTitle": "A margem",
      "TitleArray": [
        "The Margin",
        "A margem"
      ],
      "Year": "1967",
      "Director": "Ozualdo Ribeiro Candeias",
      "DirectorArray": [
        "Ozualdo Ribeiro Candeias"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3934",
      "databaseFilmTitle": "The Marginal Ones",
      "FilmTitle": "The Marginal Ones",
      "AlternateTitle": "Oka Oori Katha",
      "TitleArray": [
        "The Marginal Ones",
        "Oka Oori Katha"
      ],
      "Year": "1977",
      "Director": "Mrinal Sen",
      "DirectorArray": [
        "Mrinal Sen"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3935",
      "databaseFilmTitle": "The Mark of Zorro",
      "FilmTitle": "The Mark of Zorro",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mark of Zorro"
      ],
      "Year": "1940",
      "Director": "Rouben Mamoulian",
      "DirectorArray": [
        "Rouben Mamoulian"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3936",
      "databaseFilmTitle": "The Marquise of O",
      "FilmTitle": "The Marquise of O",
      "AlternateTitle": "Die Marquise von O...",
      "TitleArray": [
        "The Marquise of O",
        "Die Marquise von O..."
      ],
      "Year": "1976",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3937",
      "databaseFilmTitle": "The Marriage Circle",
      "FilmTitle": "The Marriage Circle",
      "AlternateTitle": "",
      "TitleArray": [
        "The Marriage Circle"
      ],
      "Year": "1924",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3938",
      "databaseFilmTitle": "The Marriage of Maria Braun",
      "FilmTitle": "The Marriage of Maria Braun",
      "AlternateTitle": "Die Ehe der Maria Braun",
      "TitleArray": [
        "The Marriage of Maria Braun",
        "Die Ehe der Maria Braun"
      ],
      "Year": "1979",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "3939",
      "databaseFilmTitle": "The Marshes' Chant",
      "FilmTitle": "The Marshes' Chant",
      "AlternateTitle": "La canta delle marane",
      "TitleArray": [
        "The Marshes' Chant",
        "La canta delle marane"
      ],
      "Year": "1961",
      "Director": "Cecilia Mangini",
      "DirectorArray": [
        "Cecilia Mangini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3940",
      "databaseFilmTitle": "The Mascot",
      "FilmTitle": "The Mascot",
      "AlternateTitle": "Fétiche Mascotte",
      "TitleArray": [
        "The Mascot",
        "Fétiche Mascotte"
      ],
      "Year": "1933",
      "Director": "Wladyslaw Starewicz",
      "DirectorArray": [
        "Wladyslaw Starewicz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3941",
      "databaseFilmTitle": "The Masque of Red Death",
      "FilmTitle": "The Masque of Red Death",
      "AlternateTitle": "",
      "TitleArray": [
        "The Masque of Red Death"
      ],
      "Year": "1964",
      "Director": "Roger Corman",
      "DirectorArray": [
        "Roger Corman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3942",
      "databaseFilmTitle": "The Master",
      "FilmTitle": "The Master",
      "AlternateTitle": "",
      "TitleArray": [
        "The Master"
      ],
      "Year": "2012",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3943",
      "databaseFilmTitle": "The Match Factory Girl",
      "FilmTitle": "The Match Factory Girl",
      "AlternateTitle": "Tulitikkutehtaan tyttö",
      "TitleArray": [
        "The Match Factory Girl",
        "Tulitikkutehtaan tyttö"
      ],
      "Year": "1990",
      "Director": "Aki Kaurismäki",
      "DirectorArray": [
        "Aki Kaurismäki"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3944",
      "databaseFilmTitle": "The Matrix",
      "FilmTitle": "The Matrix",
      "AlternateTitle": "",
      "TitleArray": [
        "The Matrix"
      ],
      "Year": "1999",
      "Director": "Lilly Wachowski, Lana Wachowski",
      "DirectorArray": [
        "Lilly Wachowski",
        "Lana Wachowski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "118",
      "2022votes": "26"
    },
    {
      "key": "3945",
      "databaseFilmTitle": "The Mattei Affair",
      "FilmTitle": "The Mattei Affair",
      "AlternateTitle": "Il caso mattei",
      "TitleArray": [
        "The Mattei Affair",
        "Il caso mattei"
      ],
      "Year": "1972",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3946",
      "databaseFilmTitle": "The Meeting Point",
      "FilmTitle": "The Meeting Point",
      "AlternateTitle": "Sabirni centar",
      "TitleArray": [
        "The Meeting Point",
        "Sabirni centar"
      ],
      "Year": "1989",
      "Director": "Goran Marković",
      "DirectorArray": [
        "Goran Marković"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3947",
      "databaseFilmTitle": "The Meetings of Anna",
      "FilmTitle": "The Meetings of Anna",
      "AlternateTitle": "Les rendez-vous d'Anna",
      "TitleArray": [
        "The Meetings of Anna",
        "Les rendez-vous d'Anna"
      ],
      "Year": "1978",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3948",
      "databaseFilmTitle": "The Melomaniac",
      "FilmTitle": "The Melomaniac",
      "AlternateTitle": "Le mélomane",
      "TitleArray": [
        "The Melomaniac",
        "Le mélomane"
      ],
      "Year": "1903",
      "Director": "Georges Méliès",
      "DirectorArray": [
        "Georges Méliès"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3949",
      "databaseFilmTitle": "The Member of the Wedding",
      "FilmTitle": "The Member of the Wedding",
      "AlternateTitle": "",
      "TitleArray": [
        "The Member of the Wedding"
      ],
      "Year": "1952",
      "Director": "Fred Zinnemann",
      "DirectorArray": [
        "Fred Zinnemann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3950",
      "databaseFilmTitle": "The Memory of Justice",
      "FilmTitle": "The Memory of Justice",
      "AlternateTitle": "",
      "TitleArray": [
        "The Memory of Justice"
      ],
      "Year": "1976",
      "Director": "Marcel Ophüls",
      "DirectorArray": [
        "Marcel Ophüls"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3951",
      "databaseFilmTitle": "The Mermaids, or Aiden in Wonderland",
      "FilmTitle": "The Mermaids, or Aiden in Wonderland",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mermaids, or Aiden in Wonderland"
      ],
      "Year": "2018",
      "Director": "Karrabing Film Collective",
      "DirectorArray": [
        "Karrabing Film Collective"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3952",
      "databaseFilmTitle": "The Merry Widow",
      "FilmTitle": "The Merry Widow",
      "AlternateTitle": "",
      "TitleArray": [
        "The Merry Widow"
      ],
      "Year": "1934",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3953",
      "databaseFilmTitle": "The Messenger: The Story of Joan of Arc",
      "FilmTitle": "The Messenger: The Story of Joan of Arc",
      "AlternateTitle": "Jeanne d'Arc",
      "TitleArray": [
        "The Messenger: The Story of Joan of Arc",
        "Jeanne d'Arc"
      ],
      "Year": "1999",
      "Director": "Luc Besson",
      "DirectorArray": [
        "Luc Besson"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3954",
      "databaseFilmTitle": "The Messiah",
      "FilmTitle": "The Messiah",
      "AlternateTitle": "Il messia",
      "TitleArray": [
        "The Messiah",
        "Il messia"
      ],
      "Year": "1975",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3955",
      "databaseFilmTitle": "The Messina Disaster",
      "FilmTitle": "The Messina Disaster",
      "AlternateTitle": "Il terremoto di Messina e Calabria",
      "TitleArray": [
        "The Messina Disaster",
        "Il terremoto di Messina e Calabria"
      ],
      "Year": "1909",
      "Director": "Luca Comerio",
      "DirectorArray": [
        "Luca Comerio"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3956",
      "databaseFilmTitle": "The Metamorphosis of Birds",
      "FilmTitle": "The Metamorphosis of Birds",
      "AlternateTitle": "A Metamorfose dos Pássaros",
      "TitleArray": [
        "The Metamorphosis of Birds",
        "A Metamorfose dos Pássaros"
      ],
      "Year": "2020",
      "Director": "Catarina Vasconcelos",
      "DirectorArray": [
        "Catarina Vasconcelos"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3957",
      "databaseFilmTitle": "The Milk of Human Kindness",
      "FilmTitle": "The Milk of Human Kindness",
      "AlternateTitle": "Le lait de la tendresse humaine",
      "TitleArray": [
        "The Milk of Human Kindness",
        "Le lait de la tendresse humaine"
      ],
      "Year": "2001",
      "Director": "Doninique Cabrera",
      "DirectorArray": [
        "Doninique Cabrera"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3958",
      "databaseFilmTitle": "The Milk of Sorrow",
      "FilmTitle": "The Milk of Sorrow",
      "AlternateTitle": "La teta asustada",
      "TitleArray": [
        "The Milk of Sorrow",
        "La teta asustada"
      ],
      "Year": "2009",
      "Director": "Claudia Llosa",
      "DirectorArray": [
        "Claudia Llosa"
      ],
      "Country": "Peru",
      "CountryArray": [
        "Peru"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3959",
      "databaseFilmTitle": "The Milky Way",
      "FilmTitle": "The Milky Way",
      "AlternateTitle": "La voie lactée",
      "TitleArray": [
        "The Milky Way",
        "La voie lactée"
      ],
      "Year": "1969",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3960",
      "databaseFilmTitle": "The Mill on the Po",
      "FilmTitle": "The Mill on the Po",
      "AlternateTitle": "Il mulino del Po",
      "TitleArray": [
        "The Mill on the Po",
        "Il mulino del Po"
      ],
      "Year": "1949",
      "Director": "Alberto Lattuada",
      "DirectorArray": [
        "Alberto Lattuada"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3961",
      "databaseFilmTitle": "The Miracle of Morgan's Creek",
      "FilmTitle": "The Miracle of Morgan's Creek",
      "AlternateTitle": "",
      "TitleArray": [
        "The Miracle of Morgan's Creek"
      ],
      "Year": "1943",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3962",
      "databaseFilmTitle": "The Miracle of P. Tinto",
      "FilmTitle": "The Miracle of P. Tinto",
      "AlternateTitle": "El milagro de P. Tinto",
      "TitleArray": [
        "The Miracle of P. Tinto",
        "El milagro de P. Tinto"
      ],
      "Year": "1998",
      "Director": "Javier Fesser",
      "DirectorArray": [
        "Javier Fesser"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3963",
      "databaseFilmTitle": "The Miracle Worker",
      "FilmTitle": "The Miracle Worker",
      "AlternateTitle": "",
      "TitleArray": [
        "The Miracle Worker"
      ],
      "Year": "1962",
      "Director": "Arthur Penn",
      "DirectorArray": [
        "Arthur Penn"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3964",
      "databaseFilmTitle": "The Mirage",
      "FilmTitle": "The Mirage",
      "AlternateTitle": "Assarab",
      "TitleArray": [
        "The Mirage",
        "Assarab"
      ],
      "Year": "1979",
      "Director": "Ahmed Bouanani",
      "DirectorArray": [
        "Ahmed Bouanani"
      ],
      "Country": "Morocco",
      "CountryArray": [
        "Morocco"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3965",
      "databaseFilmTitle": "The Mirror",
      "FilmTitle": "The Mirror",
      "AlternateTitle": "Ayneh",
      "TitleArray": [
        "The Mirror",
        "Ayneh"
      ],
      "Year": "1997",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3966",
      "databaseFilmTitle": "The Misfits",
      "FilmTitle": "The Misfits",
      "AlternateTitle": "",
      "TitleArray": [
        "The Misfits"
      ],
      "Year": "1961",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3967",
      "databaseFilmTitle": "The Missing Picture",
      "FilmTitle": "The Missing Picture",
      "AlternateTitle": "L'image manquante",
      "TitleArray": [
        "The Missing Picture",
        "L'image manquante"
      ],
      "Year": "2013",
      "Director": "Rithy Panh",
      "DirectorArray": [
        "Rithy Panh"
      ],
      "Country": "Cambodia",
      "CountryArray": [
        "Cambodia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3968",
      "databaseFilmTitle": "The Mission (1986)",
      "FilmTitle": "The Mission",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mission"
      ],
      "Year": "1986",
      "Director": "Roland Joffé",
      "DirectorArray": [
        "Roland Joffé"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3969",
      "databaseFilmTitle": "The Mission (1999)",
      "FilmTitle": "The Mission",
      "AlternateTitle": "Cheung fo",
      "TitleArray": [
        "The Mission",
        "Cheung fo"
      ],
      "Year": "1999",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3970",
      "databaseFilmTitle": "The Mist",
      "FilmTitle": "The Mist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mist"
      ],
      "Year": "2007",
      "Director": "Frank Darabont",
      "DirectorArray": [
        "Frank Darabont"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3971",
      "databaseFilmTitle": "The Moon Has Risen",
      "FilmTitle": "The Moon Has Risen",
      "AlternateTitle": "Tsuki wa noborinu",
      "TitleArray": [
        "The Moon Has Risen",
        "Tsuki wa noborinu"
      ],
      "Year": "1955",
      "Director": "Kinuyo Tanaka",
      "DirectorArray": [
        "Kinuyo Tanaka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3972",
      "databaseFilmTitle": "The More the Merrier",
      "FilmTitle": "The More the Merrier",
      "AlternateTitle": "",
      "TitleArray": [
        "The More the Merrier"
      ],
      "Year": "1943",
      "Director": "George Stevens",
      "DirectorArray": [
        "George Stevens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3973",
      "databaseFilmTitle": "The Mortal Storm",
      "FilmTitle": "The Mortal Storm",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mortal Storm"
      ],
      "Year": "1940",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3974",
      "databaseFilmTitle": "The Most Dangerous Man in the World",
      "FilmTitle": "The Most Dangerous Man in the World",
      "AlternateTitle": "Akhtar ragol fil alam",
      "TitleArray": [
        "The Most Dangerous Man in the World",
        "Akhtar ragol fil alam"
      ],
      "Year": "1967",
      "Director": "Niazi Mostafa",
      "DirectorArray": [
        "Niazi Mostafa"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3975",
      "databaseFilmTitle": "The Most Important Thing: Love",
      "FilmTitle": "The Most Important Thing: Love",
      "AlternateTitle": "L'important c'est d'aimer",
      "TitleArray": [
        "The Most Important Thing: Love",
        "L'important c'est d'aimer"
      ],
      "Year": "1965",
      "Director": "Andrzej Żuławski",
      "DirectorArray": [
        "Andrzej Żuławski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3976",
      "databaseFilmTitle": "The Mother and the Law",
      "FilmTitle": "The Mother and the Law",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mother and the Law"
      ],
      "Year": "1919",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3977",
      "databaseFilmTitle": "The Mother and the Whore",
      "FilmTitle": "The Mother and the Whore",
      "AlternateTitle": "La mamn et la putain",
      "TitleArray": [
        "The Mother and the Whore",
        "La mamn et la putain"
      ],
      "Year": "1973",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "59",
      "2012votes": "25",
      "2022rank": "104",
      "2022votes": "29"
    },
    {
      "key": "3978",
      "databaseFilmTitle": "The Mothering Heart",
      "FilmTitle": "The Mothering Heart",
      "AlternateTitle": "",
      "TitleArray": [
        "The Mothering Heart"
      ],
      "Year": "1913",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3979",
      "databaseFilmTitle": "The Mourning Forest",
      "FilmTitle": "The Mourning Forest",
      "AlternateTitle": "Mogari no mori",
      "TitleArray": [
        "The Mourning Forest",
        "Mogari no mori"
      ],
      "Year": "2007",
      "Director": "Naomi Kawase",
      "DirectorArray": [
        "Naomi Kawase"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3980",
      "databaseFilmTitle": "The Mouth Agape",
      "FilmTitle": "The Mouth Agape",
      "AlternateTitle": "La gueule ouverte",
      "TitleArray": [
        "The Mouth Agape",
        "La gueule ouverte"
      ],
      "Year": "1974",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3981",
      "databaseFilmTitle": "The Music Box",
      "FilmTitle": "The Music Box",
      "AlternateTitle": "",
      "TitleArray": [
        "The Music Box"
      ],
      "Year": "1932",
      "Director": "James Parrott",
      "DirectorArray": [
        "James Parrott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3982",
      "databaseFilmTitle": "The Music Lovers",
      "FilmTitle": "The Music Lovers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Music Lovers"
      ],
      "Year": "1971",
      "Director": "Ken Russell",
      "DirectorArray": [
        "Ken Russell"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3983",
      "databaseFilmTitle": "The Music Room",
      "FilmTitle": "The Music Room",
      "AlternateTitle": "Jalsaghar",
      "TitleArray": [
        "The Music Room",
        "Jalsaghar"
      ],
      "Year": "1958",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "26",
      "1992votes": "7",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "3984",
      "databaseFilmTitle": "The Musketeers of Pig Alley",
      "FilmTitle": "The Musketeers of Pig Alley",
      "AlternateTitle": "",
      "TitleArray": [
        "The Musketeers of Pig Alley"
      ],
      "Year": "1912",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3985",
      "databaseFilmTitle": "The Mutants",
      "FilmTitle": "The Mutants",
      "AlternateTitle": "Os mutantes",
      "TitleArray": [
        "The Mutants",
        "Os mutantes"
      ],
      "Year": "1998",
      "Director": "Teresa Villaverde",
      "DirectorArray": [
        "Teresa Villaverde"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3986",
      "databaseFilmTitle": "The Mystery of Picasso",
      "FilmTitle": "The Mystery of Picasso",
      "AlternateTitle": "Le mystère Picasso",
      "TitleArray": [
        "The Mystery of Picasso",
        "Le mystère Picasso"
      ],
      "Year": "1956",
      "Director": "Henri-Georges Clouzot",
      "DirectorArray": [
        "Henri-Georges Clouzot"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3987",
      "databaseFilmTitle": "The Naked and the Dead",
      "FilmTitle": "The Naked and the Dead",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked and the Dead"
      ],
      "Year": "1958",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3988",
      "databaseFilmTitle": "The Naked City",
      "FilmTitle": "The Naked City",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked City"
      ],
      "Year": "1948",
      "Director": "Jules Dassin",
      "DirectorArray": [
        "Jules Dassin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3989",
      "databaseFilmTitle": "The Naked Dawn",
      "FilmTitle": "The Naked Dawn",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked Dawn"
      ],
      "Year": "1955",
      "Director": "Edgar G. Ulmer",
      "DirectorArray": [
        "Edgar G. Ulmer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3990",
      "databaseFilmTitle": "The Naked Gun: From the Files of Police Squad!",
      "FilmTitle": "The Naked Gun: From the Files of Police Squad!",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked Gun: From the Files of Police Squad!"
      ],
      "Year": "1988",
      "Director": "David Zucker",
      "DirectorArray": [
        "David Zucker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "3991",
      "databaseFilmTitle": "The Naked Island",
      "FilmTitle": "The Naked Island",
      "AlternateTitle": "Hadaka no shima",
      "TitleArray": [
        "The Naked Island",
        "Hadaka no shima"
      ],
      "Year": "1960",
      "Director": "Kaneto Shindô",
      "DirectorArray": [
        "Kaneto Shindô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3992",
      "databaseFilmTitle": "The Naked Kiss",
      "FilmTitle": "The Naked Kiss",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked Kiss"
      ],
      "Year": "1964",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "3993",
      "databaseFilmTitle": "The Naked Prey",
      "FilmTitle": "The Naked Prey",
      "AlternateTitle": "",
      "TitleArray": [
        "The Naked Prey"
      ],
      "Year": "1965",
      "Director": "Cornel Wilde",
      "DirectorArray": [
        "Cornel Wilde"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3994",
      "databaseFilmTitle": "The Name of the Game (Season 2): The Perfect Image",
      "FilmTitle": "The Name of the Game (Season 2): The Perfect Image",
      "AlternateTitle": "",
      "TitleArray": [
        "The Name of the Game (Season 2): The Perfect Image"
      ],
      "Year": "1969",
      "Director": "Sutton Roley",
      "DirectorArray": [
        "Sutton Roley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3995",
      "databaseFilmTitle": "The Namesake",
      "FilmTitle": "The Namesake",
      "AlternateTitle": "",
      "TitleArray": [
        "The Namesake"
      ],
      "Year": "2006",
      "Director": "Mira Nail",
      "DirectorArray": [
        "Mira Nail"
      ],
      "Country": "India, United States",
      "CountryArray": [
        "India",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3996",
      "databaseFilmTitle": "The Naughty Ones",
      "FilmTitle": "The Naughty Ones",
      "AlternateTitle": "Nemirni",
      "TitleArray": [
        "The Naughty Ones",
        "Nemirni"
      ],
      "Year": "1967",
      "Director": "Vojislav 'Kokan' Rakonjac",
      "DirectorArray": [
        "Vojislav 'Kokan' Rakonjac"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3997",
      "databaseFilmTitle": "The Navigator",
      "FilmTitle": "The Navigator",
      "AlternateTitle": "",
      "TitleArray": [
        "The Navigator"
      ],
      "Year": "1924",
      "Director": "Buston Keaton, Donald Crisp",
      "DirectorArray": [
        "Buston Keaton",
        "Donald Crisp"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "3998",
      "databaseFilmTitle": "The New Babylon",
      "FilmTitle": "The New Babylon",
      "AlternateTitle": "",
      "TitleArray": [
        "The New Babylon"
      ],
      "Year": "1929",
      "Director": "Grigori Kozintsev, Leonid Trauberg",
      "DirectorArray": [
        "Grigori Kozintsev",
        "Leonid Trauberg"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "3999",
      "databaseFilmTitle": "The New Morning of Billy The Kid",
      "FilmTitle": "The New Morning of Billy The Kid",
      "AlternateTitle": "Birî za kiddo no atarashii yoake",
      "TitleArray": [
        "The New Morning of Billy The Kid",
        "Birî za kiddo no atarashii yoake"
      ],
      "Year": "1986",
      "Director": "Naoto Yamakawa",
      "DirectorArray": [
        "Naoto Yamakawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4000",
      "databaseFilmTitle": "The New World",
      "FilmTitle": "The New World",
      "AlternateTitle": "",
      "TitleArray": [
        "The New World"
      ],
      "Year": "2005",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4001",
      "databaseFilmTitle": "The New York Ripper",
      "FilmTitle": "The New York Ripper",
      "AlternateTitle": "Lo squartatore di New York",
      "TitleArray": [
        "The New York Ripper",
        "Lo squartatore di New York"
      ],
      "Year": "1982",
      "Director": "Lucio Fulci",
      "DirectorArray": [
        "Lucio Fulci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4002",
      "databaseFilmTitle": "The Night",
      "FilmTitle": "The Night",
      "AlternateTitle": "La notte",
      "TitleArray": [
        "The Night",
        "La notte"
      ],
      "Year": "1961",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "4003",
      "databaseFilmTitle": "The Night is Young",
      "FilmTitle": "The Night is Young",
      "AlternateTitle": "",
      "TitleArray": [
        "The Night is Young"
      ],
      "Year": "1935",
      "Director": "Dudley Murphy",
      "DirectorArray": [
        "Dudley Murphy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4004",
      "databaseFilmTitle": "The Night of Counting the Years",
      "FilmTitle": "The Night of Counting the Years",
      "AlternateTitle": "",
      "TitleArray": [
        "The Night of Counting the Years"
      ],
      "Year": "1969",
      "Director": "Shadi Abdel Salam",
      "DirectorArray": [
        "Shadi Abdel Salam"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "4005",
      "databaseFilmTitle": "The Night of the Hunter",
      "FilmTitle": "The Night of the Hunter",
      "AlternateTitle": "",
      "TitleArray": [
        "The Night of the Hunter"
      ],
      "Year": "1955",
      "Director": "Charles Laughton",
      "DirectorArray": [
        "Charles Laughton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "25",
      "2022votes": "66"
    },
    {
      "key": "4006",
      "databaseFilmTitle": "The Night of the Iguana",
      "FilmTitle": "The Night of the Iguana",
      "AlternateTitle": "",
      "TitleArray": [
        "The Night of the Iguana"
      ],
      "Year": "1964",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4007",
      "databaseFilmTitle": "The Night of the Shooting Stars",
      "FilmTitle": "The Night of the Shooting Stars",
      "AlternateTitle": "La notte di San Lorenzo",
      "TitleArray": [
        "The Night of the Shooting Stars",
        "La notte di San Lorenzo"
      ],
      "Year": "1982",
      "Director": "Paoul Taviani, Vittorio Taviani",
      "DirectorArray": [
        "Paoul Taviani",
        "Vittorio Taviani"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4008",
      "databaseFilmTitle": "The Night Porter",
      "FilmTitle": "The Night Porter",
      "AlternateTitle": "Il portiere di notte",
      "TitleArray": [
        "The Night Porter",
        "Il portiere di notte"
      ],
      "Year": "1974",
      "Director": "Liliana Cavani",
      "DirectorArray": [
        "Liliana Cavani"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4009",
      "databaseFilmTitle": "The Nightcleaners",
      "FilmTitle": "The Nightcleaners",
      "AlternateTitle": "",
      "TitleArray": [
        "The Nightcleaners"
      ],
      "Year": "1975",
      "Director": "Berwick Street Film Collective, Marc Karlin",
      "DirectorArray": [
        "Berwick Street Film Collective",
        "Marc Karlin"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4010",
      "databaseFilmTitle": "The Nightmare before Christmas",
      "FilmTitle": "The Nightmare before Christmas",
      "AlternateTitle": "",
      "TitleArray": [
        "The Nightmare before Christmas"
      ],
      "Year": "1993",
      "Director": "Henry Selick",
      "DirectorArray": [
        "Henry Selick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4011",
      "databaseFilmTitle": "The Nine Muses",
      "FilmTitle": "The Nine Muses",
      "AlternateTitle": "",
      "TitleArray": [
        "The Nine Muses"
      ],
      "Year": "2010",
      "Director": "John Akomfrah",
      "DirectorArray": [
        "John Akomfrah"
      ],
      "Country": "United Kingdom, Ghana",
      "CountryArray": [
        "United Kingdom",
        "Ghana"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4012",
      "databaseFilmTitle": "The Ninth Configuration",
      "FilmTitle": "The Ninth Configuration",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ninth Configuration"
      ],
      "Year": "1980",
      "Director": "William Peter Blatty",
      "DirectorArray": [
        "William Peter Blatty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4013",
      "databaseFilmTitle": "The Northern Calot",
      "FilmTitle": "The Northern Calot",
      "AlternateTitle": "Die Nordkalotte",
      "TitleArray": [
        "The Northern Calot",
        "Die Nordkalotte"
      ],
      "Year": "1990",
      "Director": "Peter Nestler",
      "DirectorArray": [
        "Peter Nestler"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4014",
      "databaseFilmTitle": "The Nun's Night",
      "FilmTitle": "The Nun's Night",
      "AlternateTitle": "Noc nevěsty",
      "TitleArray": [
        "The Nun's Night",
        "Noc nevěsty"
      ],
      "Year": "1967",
      "Director": "Karel Kachyna",
      "DirectorArray": [
        "Karel Kachyna"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4015",
      "databaseFilmTitle": "The Nutty Professor",
      "FilmTitle": "The Nutty Professor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Nutty Professor"
      ],
      "Year": "1963",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4016",
      "databaseFilmTitle": "The Oak",
      "FilmTitle": "The Oak",
      "AlternateTitle": "Balanța",
      "TitleArray": [
        "The Oak",
        "Balanța"
      ],
      "Year": "1992",
      "Director": "Lucian Pintilie",
      "DirectorArray": [
        "Lucian Pintilie"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4017",
      "databaseFilmTitle": "The Odd Couple",
      "FilmTitle": "The Odd Couple",
      "AlternateTitle": "",
      "TitleArray": [
        "The Odd Couple"
      ],
      "Year": "1968",
      "Director": "Gene Saks",
      "DirectorArray": [
        "Gene Saks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4018",
      "databaseFilmTitle": "The Official Story",
      "FilmTitle": "The Official Story",
      "AlternateTitle": "La historia oficial",
      "TitleArray": [
        "The Official Story",
        "La historia oficial"
      ],
      "Year": "1985",
      "Director": "Luis Puenzo",
      "DirectorArray": [
        "Luis Puenzo"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4019",
      "databaseFilmTitle": "The Old Actor",
      "FilmTitle": "The Old Actor",
      "AlternateTitle": "",
      "TitleArray": [
        "The Old Actor"
      ],
      "Year": "1912",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4020",
      "databaseFilmTitle": "The Old Country Where Rimbaud Died",
      "FilmTitle": "The Old Country Where Rimbaud Died",
      "AlternateTitle": "Le vieux pays où Rimbaud est mort",
      "TitleArray": [
        "The Old Country Where Rimbaud Died",
        "Le vieux pays où Rimbaud est mort"
      ],
      "Year": "1977",
      "Director": "Jean Pierre Lefebvre",
      "DirectorArray": [
        "Jean Pierre Lefebvre"
      ],
      "Country": "Canada, France",
      "CountryArray": [
        "Canada",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4021",
      "databaseFilmTitle": "The Old Dark House",
      "FilmTitle": "The Old Dark House",
      "AlternateTitle": "",
      "TitleArray": [
        "The Old Dark House"
      ],
      "Year": "1932",
      "Director": "James Whale",
      "DirectorArray": [
        "James Whale"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4022",
      "databaseFilmTitle": "The Only Son",
      "FilmTitle": "The Only Son",
      "AlternateTitle": "Hitori musuko",
      "TitleArray": [
        "The Only Son",
        "Hitori musuko"
      ],
      "Year": "1936",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4023",
      "databaseFilmTitle": "The Opening of Misty Beethoven",
      "FilmTitle": "The Opening of Misty Beethoven",
      "AlternateTitle": "",
      "TitleArray": [
        "The Opening of Misty Beethoven"
      ],
      "Year": "1976",
      "Director": "Radley Metzger",
      "DirectorArray": [
        "Radley Metzger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4024",
      "databaseFilmTitle": "The Opposite of Sex",
      "FilmTitle": "The Opposite of Sex",
      "AlternateTitle": "",
      "TitleArray": [
        "The Opposite of Sex"
      ],
      "Year": "1998",
      "Director": "Don Roos",
      "DirectorArray": [
        "Don Roos"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4025",
      "databaseFilmTitle": "The Option",
      "FilmTitle": "The Option",
      "AlternateTitle": "Aopção ou As Rosas da Estrada",
      "TitleArray": [
        "The Option",
        "Aopção ou As Rosas da Estrada"
      ],
      "Year": "1981",
      "Director": "Ozualdo Ribeiro Candeias",
      "DirectorArray": [
        "Ozualdo Ribeiro Candeias"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4026",
      "databaseFilmTitle": "The Organizer",
      "FilmTitle": "The Organizer",
      "AlternateTitle": "I compagni",
      "TitleArray": [
        "The Organizer",
        "I compagni"
      ],
      "Year": "1963",
      "Director": "Mario Monicelli",
      "DirectorArray": [
        "Mario Monicelli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4027",
      "databaseFilmTitle": "The Original Kings of Comedy",
      "FilmTitle": "The Original Kings of Comedy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Original Kings of Comedy"
      ],
      "Year": "2000",
      "Director": "Spike Lee",
      "DirectorArray": [
        "Spike Lee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4028",
      "databaseFilmTitle": "The Ornithologist",
      "FilmTitle": "The Ornithologist",
      "AlternateTitle": "O Ornitólogo",
      "TitleArray": [
        "The Ornithologist",
        "O Ornitólogo"
      ],
      "Year": "2016",
      "Director": "João Pedro Rodrigues",
      "DirectorArray": [
        "João Pedro Rodrigues"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4029",
      "databaseFilmTitle": "The Other Side of the Underneath",
      "FilmTitle": "The Other Side of the Underneath",
      "AlternateTitle": "",
      "TitleArray": [
        "The Other Side of the Underneath"
      ],
      "Year": "1972",
      "Director": "Jane Arden",
      "DirectorArray": [
        "Jane Arden"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4030",
      "databaseFilmTitle": "The Other Side of the Wind",
      "FilmTitle": "The Other Side of the Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "The Other Side of the Wind"
      ],
      "Year": "2018",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4031",
      "databaseFilmTitle": "The Outlaw and His Wife",
      "FilmTitle": "The Outlaw and His Wife",
      "AlternateTitle": "Berg-Ejvind och hans hustru",
      "TitleArray": [
        "The Outlaw and His Wife",
        "Berg-Ejvind och hans hustru"
      ],
      "Year": "1918",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4032",
      "databaseFilmTitle": "The Outlaw Josey Wales",
      "FilmTitle": "The Outlaw Josey Wales",
      "AlternateTitle": "",
      "TitleArray": [
        "The Outlaw Josey Wales"
      ],
      "Year": "1976",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4033",
      "databaseFilmTitle": "The Outsiders",
      "FilmTitle": "The Outsiders",
      "AlternateTitle": "",
      "TitleArray": [
        "The Outsiders"
      ],
      "Year": "1983",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4034",
      "databaseFilmTitle": "The Outskirts",
      "FilmTitle": "The Outskirts",
      "AlternateTitle": "",
      "TitleArray": [
        "The Outskirts"
      ],
      "Year": "1998",
      "Director": "Pyotr Lutsik",
      "DirectorArray": [
        "Pyotr Lutsik"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4035",
      "databaseFilmTitle": "The Ox-Bow Incident",
      "FilmTitle": "The Ox-Bow Incident",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ox-Bow Incident"
      ],
      "Year": "1942",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4036",
      "databaseFilmTitle": "The Oyster Princess",
      "FilmTitle": "The Oyster Princess",
      "AlternateTitle": "Die Austernprinzessin",
      "TitleArray": [
        "The Oyster Princess",
        "Die Austernprinzessin"
      ],
      "Year": "1919",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4037",
      "databaseFilmTitle": "The Painted Bird",
      "FilmTitle": "The Painted Bird",
      "AlternateTitle": "",
      "TitleArray": [
        "The Painted Bird"
      ],
      "Year": "2019",
      "Director": "Václav Marhoul",
      "DirectorArray": [
        "Václav Marhoul"
      ],
      "Country": "Czech Republic",
      "CountryArray": [
        "Czech Republic"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4038",
      "databaseFilmTitle": "The Painted Lady",
      "FilmTitle": "The Painted Lady",
      "AlternateTitle": "",
      "TitleArray": [
        "The Painted Lady"
      ],
      "Year": "1912",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4039",
      "databaseFilmTitle": "The Pajama Game",
      "FilmTitle": "The Pajama Game",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pajama Game"
      ],
      "Year": "1957",
      "Director": "George Abbott, Stanley Donen",
      "DirectorArray": [
        "George Abbott",
        "Stanley Donen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4040",
      "databaseFilmTitle": "The Palm Beach Story",
      "FilmTitle": "The Palm Beach Story",
      "AlternateTitle": "",
      "TitleArray": [
        "The Palm Beach Story"
      ],
      "Year": "1942",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4041",
      "databaseFilmTitle": "The Paper Bridge",
      "FilmTitle": "The Paper Bridge",
      "AlternateTitle": "Die papierene Brücke",
      "TitleArray": [
        "The Paper Bridge",
        "Die papierene Brücke"
      ],
      "Year": "1987",
      "Director": "Ruth Beckermann",
      "DirectorArray": [
        "Ruth Beckermann"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4042",
      "databaseFilmTitle": "The Parallax View",
      "FilmTitle": "The Parallax View",
      "AlternateTitle": "",
      "TitleArray": [
        "The Parallax View"
      ],
      "Year": "1974",
      "Director": "Alan J. Pakula",
      "DirectorArray": [
        "Alan J. Pakula"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4043",
      "databaseFilmTitle": "The Parallel Street",
      "FilmTitle": "The Parallel Street",
      "AlternateTitle": "Die Parallelstrasse",
      "TitleArray": [
        "The Parallel Street",
        "Die Parallelstrasse"
      ],
      "Year": "1962",
      "Director": "Ferdinand Khittl",
      "DirectorArray": [
        "Ferdinand Khittl"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4044",
      "databaseFilmTitle": "The Parson's Widow",
      "FilmTitle": "The Parson's Widow",
      "AlternateTitle": "Prästänkan",
      "TitleArray": [
        "The Parson's Widow",
        "Prästänkan"
      ],
      "Year": "1920",
      "Director": "Carl Th. Dreyer",
      "DirectorArray": [
        "Carl Th. Dreyer"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4045",
      "databaseFilmTitle": "The Party",
      "FilmTitle": "The Party",
      "AlternateTitle": "",
      "TitleArray": [
        "The Party"
      ],
      "Year": "1968",
      "Director": "Blake Edwards",
      "DirectorArray": [
        "Blake Edwards"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4046",
      "databaseFilmTitle": "The Passenger",
      "FilmTitle": "The Passenger",
      "AlternateTitle": "Professione: Reporter",
      "TitleArray": [
        "The Passenger",
        "Professione: Reporter"
      ],
      "Year": "1975",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "4047",
      "databaseFilmTitle": "The Passion of Anna",
      "FilmTitle": "The Passion of Anna",
      "AlternateTitle": "En passion",
      "TitleArray": [
        "The Passion of Anna",
        "En passion"
      ],
      "Year": "1969",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4048",
      "databaseFilmTitle": "The Passion of Joan of Arc",
      "FilmTitle": "The Passion of Joan of Arc",
      "AlternateTitle": "La passion de Jeanne d'Arc",
      "TitleArray": [
        "The Passion of Joan of Arc",
        "La passion de Jeanne d'Arc"
      ],
      "Year": "1928",
      "Director": "Carl Th. Dreyer",
      "DirectorArray": [
        "Carl Th. Dreyer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "7",
      "1952votes": "11",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "7",
      "1972votes": "11",
      "1982rank": "17",
      "1982votes": "8",
      "1992rank": "6",
      "1992votes": "15",
      "2002rank": "15",
      "2002votes": "12",
      "2012rank": "9",
      "2012votes": "65",
      "2022rank": "20",
      "2022votes": "71"
    },
    {
      "key": "4049",
      "databaseFilmTitle": "The Passionate Friends",
      "FilmTitle": "The Passionate Friends",
      "AlternateTitle": "",
      "TitleArray": [
        "The Passionate Friends"
      ],
      "Year": "1949",
      "Director": "David Lean",
      "DirectorArray": [
        "David Lean"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4050",
      "databaseFilmTitle": "The Passionate Stranger",
      "FilmTitle": "The Passionate Stranger",
      "AlternateTitle": "",
      "TitleArray": [
        "The Passionate Stranger"
      ],
      "Year": "1957",
      "Director": "Muriel Box",
      "DirectorArray": [
        "Muriel Box"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4051",
      "databaseFilmTitle": "The Patsy",
      "FilmTitle": "The Patsy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Patsy"
      ],
      "Year": "1964",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4052",
      "databaseFilmTitle": "The Pawnshop",
      "FilmTitle": "The Pawnshop",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pawnshop"
      ],
      "Year": "1916",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4053",
      "databaseFilmTitle": "The Peanut Butter Falcon",
      "FilmTitle": "The Peanut Butter Falcon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Peanut Butter Falcon"
      ],
      "Year": "2019",
      "Director": "Tyler Nilson, Mike Schwartz",
      "DirectorArray": [
        "Tyler Nilson",
        "Mike Schwartz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4054",
      "databaseFilmTitle": "The Pearl Button",
      "FilmTitle": "The Pearl Button",
      "AlternateTitle": "El botón de nácar",
      "TitleArray": [
        "The Pearl Button",
        "El botón de nácar"
      ],
      "Year": "2015",
      "Director": "Patricio Guzmán",
      "DirectorArray": [
        "Patricio Guzmán"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4055",
      "databaseFilmTitle": "The People's Account",
      "FilmTitle": "The People's Account",
      "AlternateTitle": "",
      "TitleArray": [
        "The People's Account"
      ],
      "Year": "1986",
      "Director": "Menelik Shabazz",
      "DirectorArray": [
        "Menelik Shabazz"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4056",
      "databaseFilmTitle": "The Petrified Forest",
      "FilmTitle": "The Petrified Forest",
      "AlternateTitle": "",
      "TitleArray": [
        "The Petrified Forest"
      ],
      "Year": "1936",
      "Director": "Archie Mayo",
      "DirectorArray": [
        "Archie Mayo"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4057",
      "databaseFilmTitle": "The Phantom Carriage",
      "FilmTitle": "The Phantom Carriage",
      "AlternateTitle": "Körkarlen",
      "TitleArray": [
        "The Phantom Carriage",
        "Körkarlen"
      ],
      "Year": "1921",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4058",
      "databaseFilmTitle": "The Phantom of Liberty",
      "FilmTitle": "The Phantom of Liberty",
      "AlternateTitle": "Le fantôme de la liberté",
      "TitleArray": [
        "The Phantom of Liberty",
        "Le fantôme de la liberté"
      ],
      "Year": "1974",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4059",
      "databaseFilmTitle": "The Philadelphia Story",
      "FilmTitle": "The Philadelphia Story",
      "AlternateTitle": "",
      "TitleArray": [
        "The Philadelphia Story"
      ],
      "Year": "1940",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4060",
      "databaseFilmTitle": "The Pianist",
      "FilmTitle": "The Pianist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pianist"
      ],
      "Year": "2002",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "France, Germany",
      "CountryArray": [
        "France",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4061",
      "databaseFilmTitle": "The Piano",
      "FilmTitle": "The Piano",
      "AlternateTitle": "",
      "TitleArray": [
        "The Piano"
      ],
      "Year": "1993",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "New Zealand, Australia",
      "CountryArray": [
        "New Zealand",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "50",
      "2022votes": "46"
    },
    {
      "key": "4062",
      "databaseFilmTitle": "The Piano Teacher",
      "FilmTitle": "The Piano Teacher",
      "AlternateTitle": "La pianiste",
      "TitleArray": [
        "The Piano Teacher",
        "La pianiste"
      ],
      "Year": "2001",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "Austria, France",
      "CountryArray": [
        "Austria",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4063",
      "databaseFilmTitle": "The Pilgrim",
      "FilmTitle": "The Pilgrim",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pilgrim"
      ],
      "Year": "1923",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4064",
      "databaseFilmTitle": "The Pillow Book",
      "FilmTitle": "The Pillow Book",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pillow Book"
      ],
      "Year": "1996",
      "Director": "Peter Greenaway",
      "DirectorArray": [
        "Peter Greenaway"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4065",
      "databaseFilmTitle": "The Pirate",
      "FilmTitle": "The Pirate",
      "AlternateTitle": "",
      "TitleArray": [
        "The Pirate"
      ],
      "Year": "1948",
      "Director": "Vincente Minnelli",
      "DirectorArray": [
        "Vincente Minnelli"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4066",
      "databaseFilmTitle": "The Place Beyond the Pines",
      "FilmTitle": "The Place Beyond the Pines",
      "AlternateTitle": "",
      "TitleArray": [
        "The Place Beyond the Pines"
      ],
      "Year": "2012",
      "Director": "Derek Cianfrance",
      "DirectorArray": [
        "Derek Cianfrance"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4067",
      "databaseFilmTitle": "The Place Without Limits",
      "FilmTitle": "The Place Without Limits",
      "AlternateTitle": "El lugar sin límites",
      "TitleArray": [
        "The Place Without Limits",
        "El lugar sin límites"
      ],
      "Year": "1978",
      "Director": "Arturo Ripstein",
      "DirectorArray": [
        "Arturo Ripstein"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4068",
      "databaseFilmTitle": "The Plague of the Zombies",
      "FilmTitle": "The Plague of the Zombies",
      "AlternateTitle": "",
      "TitleArray": [
        "The Plague of the Zombies"
      ],
      "Year": "1966",
      "Director": "John Gilling",
      "DirectorArray": [
        "John Gilling"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4069",
      "databaseFilmTitle": "The Player",
      "FilmTitle": "The Player",
      "AlternateTitle": "",
      "TitleArray": [
        "The Player"
      ],
      "Year": "1992",
      "Director": "Robert Altman",
      "DirectorArray": [
        "Robert Altman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4070",
      "databaseFilmTitle": "The Poem of Hayachine Valley",
      "FilmTitle": "The Poem of Hayachine Valley",
      "AlternateTitle": "Hayachine no fu",
      "TitleArray": [
        "The Poem of Hayachine Valley",
        "Hayachine no fu"
      ],
      "Year": "1982",
      "Director": "Sumiko Haneda",
      "DirectorArray": [
        "Sumiko Haneda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4071",
      "databaseFilmTitle": "The Pornographers",
      "FilmTitle": "The Pornographers",
      "AlternateTitle": "Erogotoshi-tachi yori: Jinruigaku nyûmon",
      "TitleArray": [
        "The Pornographers",
        "Erogotoshi-tachi yori: Jinruigaku nyûmon"
      ],
      "Year": "1966",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4072",
      "databaseFilmTitle": "The Portrait of a Lady",
      "FilmTitle": "The Portrait of a Lady",
      "AlternateTitle": "",
      "TitleArray": [
        "The Portrait of a Lady"
      ],
      "Year": "1996",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4073",
      "databaseFilmTitle": "The Portuguese Woman",
      "FilmTitle": "The Portuguese Woman",
      "AlternateTitle": "A Portuguesa",
      "TitleArray": [
        "The Portuguese Woman",
        "A Portuguesa"
      ],
      "Year": "2018",
      "Director": "Rita Azevedo Gomes",
      "DirectorArray": [
        "Rita Azevedo Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4074",
      "databaseFilmTitle": "The Postman Always Rings Twice",
      "FilmTitle": "The Postman Always Rings Twice",
      "AlternateTitle": "",
      "TitleArray": [
        "The Postman Always Rings Twice"
      ],
      "Year": "1946",
      "Director": "Tay Garnett",
      "DirectorArray": [
        "Tay Garnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4075",
      "databaseFilmTitle": "The Power of Speech",
      "FilmTitle": "The Power of Speech",
      "AlternateTitle": "Puissance de la parole",
      "TitleArray": [
        "The Power of Speech",
        "Puissance de la parole"
      ],
      "Year": "1988",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4076",
      "databaseFilmTitle": "The Power of the Dog",
      "FilmTitle": "The Power of the Dog",
      "AlternateTitle": "",
      "TitleArray": [
        "The Power of the Dog"
      ],
      "Year": "2021",
      "Director": "Jane Campion",
      "DirectorArray": [
        "Jane Campion"
      ],
      "Country": "Australia, New Zealand",
      "CountryArray": [
        "Australia",
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "4077",
      "databaseFilmTitle": "The Prestige",
      "FilmTitle": "The Prestige",
      "AlternateTitle": "",
      "TitleArray": [
        "The Prestige"
      ],
      "Year": "2006",
      "Director": "Christopher Nolan",
      "DirectorArray": [
        "Christopher Nolan"
      ],
      "Country": "United Kingdom, United States",
      "CountryArray": [
        "United Kingdom",
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4078",
      "databaseFilmTitle": "The Prince and the Showgirl",
      "FilmTitle": "The Prince and the Showgirl",
      "AlternateTitle": "",
      "TitleArray": [
        "The Prince and the Showgirl"
      ],
      "Year": "1957",
      "Director": "Laurence Olivier",
      "DirectorArray": [
        "Laurence Olivier"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4079",
      "databaseFilmTitle": "The Prison in Twelve Landscapes",
      "FilmTitle": "The Prison in Twelve Landscapes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Prison in Twelve Landscapes"
      ],
      "Year": "2016",
      "Director": "Brett Story",
      "DirectorArray": [
        "Brett Story"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4080",
      "databaseFilmTitle": "The Private Life of a Cat",
      "FilmTitle": "The Private Life of a Cat",
      "AlternateTitle": "",
      "TitleArray": [
        "The Private Life of a Cat"
      ],
      "Year": "1947",
      "Director": "Alexander Hammid",
      "DirectorArray": [
        "Alexander Hammid"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4081",
      "databaseFilmTitle": "The Private Life of Sherlock Holmes",
      "FilmTitle": "The Private Life of Sherlock Holmes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Private Life of Sherlock Holmes"
      ],
      "Year": "1970",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4082",
      "databaseFilmTitle": "The Producers",
      "FilmTitle": "The Producers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Producers"
      ],
      "Year": "1967",
      "Director": "Mel Brooks",
      "DirectorArray": [
        "Mel Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4083",
      "databaseFilmTitle": "The Promised Land",
      "FilmTitle": "The Promised Land",
      "AlternateTitle": "Ziemia Obiecana",
      "TitleArray": [
        "The Promised Land",
        "Ziemia Obiecana"
      ],
      "Year": "1975",
      "Director": "Andrzej Wajda",
      "DirectorArray": [
        "Andrzej Wajda"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4084",
      "databaseFilmTitle": "The Public Enemy",
      "FilmTitle": "The Public Enemy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Public Enemy"
      ],
      "Year": "1931",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4085",
      "databaseFilmTitle": "The Puppetmaster",
      "FilmTitle": "The Puppetmaster",
      "AlternateTitle": "Xi meng ren sheng",
      "TitleArray": [
        "The Puppetmaster",
        "Xi meng ren sheng"
      ],
      "Year": "1993",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4086",
      "databaseFilmTitle": "The Purple Rose of Cairo",
      "FilmTitle": "The Purple Rose of Cairo",
      "AlternateTitle": "",
      "TitleArray": [
        "The Purple Rose of Cairo"
      ],
      "Year": "1985",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4087",
      "databaseFilmTitle": "The Python",
      "FilmTitle": "The Python",
      "AlternateTitle": "Ngworougu",
      "TitleArray": [
        "The Python",
        "Ngworougu"
      ],
      "Year": "2003",
      "Director": "Amayo Uzo Philips",
      "DirectorArray": [
        "Amayo Uzo Philips"
      ],
      "Country": "Nigeria",
      "CountryArray": [
        "Nigeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4088",
      "databaseFilmTitle": "The Queen Is Dead: A Film by Derek Jarman",
      "FilmTitle": "The Queen Is Dead: A Film by Derek Jarman",
      "AlternateTitle": "",
      "TitleArray": [
        "The Queen Is Dead: A Film by Derek Jarman"
      ],
      "Year": "1986",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4089",
      "databaseFilmTitle": "The Quiet Girl",
      "FilmTitle": "The Quiet Girl",
      "AlternateTitle": "An Cailín Ciúin",
      "TitleArray": [
        "The Quiet Girl",
        "An Cailín Ciúin"
      ],
      "Year": "2022",
      "Director": "Colm Bairéad",
      "DirectorArray": [
        "Colm Bairéad"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4090",
      "databaseFilmTitle": "The Quiet Man",
      "FilmTitle": "The Quiet Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Quiet Man"
      ],
      "Year": "1952",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "4091",
      "databaseFilmTitle": "The Quince Tree Sun",
      "FilmTitle": "The Quince Tree Sun",
      "AlternateTitle": "El sol del membrillo",
      "TitleArray": [
        "The Quince Tree Sun",
        "El sol del membrillo"
      ],
      "Year": "1992",
      "Director": "Víctor Erice",
      "DirectorArray": [
        "Víctor Erice"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "4092",
      "databaseFilmTitle": "The Raid",
      "FilmTitle": "The Raid",
      "AlternateTitle": "",
      "TitleArray": [
        "The Raid"
      ],
      "Year": "1954",
      "Director": "Hugo Fregonese",
      "DirectorArray": [
        "Hugo Fregonese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4093",
      "databaseFilmTitle": "The Railway Children",
      "FilmTitle": "The Railway Children",
      "AlternateTitle": "",
      "TitleArray": [
        "The Railway Children"
      ],
      "Year": "1970",
      "Director": "Lionel Jeffries",
      "DirectorArray": [
        "Lionel Jeffries"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4094",
      "databaseFilmTitle": "The Rainmaker",
      "FilmTitle": "The Rainmaker",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rainmaker"
      ],
      "Year": "1997",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4095",
      "databaseFilmTitle": "The Rake's Progress",
      "FilmTitle": "The Rake's Progress",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rake's Progress"
      ],
      "Year": "1945",
      "Director": "Sidney Gilliant",
      "DirectorArray": [
        "Sidney Gilliant"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4096",
      "databaseFilmTitle": "The Rapture",
      "FilmTitle": "The Rapture",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rapture"
      ],
      "Year": "1991",
      "Director": "Michael Tolkin",
      "DirectorArray": [
        "Michael Tolkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4097",
      "databaseFilmTitle": "The Reckless Moment",
      "FilmTitle": "The Reckless Moment",
      "AlternateTitle": "",
      "TitleArray": [
        "The Reckless Moment"
      ],
      "Year": "1949",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4098",
      "databaseFilmTitle": "The Red and the White",
      "FilmTitle": "The Red and the White",
      "AlternateTitle": "Csillagosok, katonák",
      "TitleArray": [
        "The Red and the White",
        "Csillagosok, katonák"
      ],
      "Year": "1967",
      "Director": "Miklós Jancsó",
      "DirectorArray": [
        "Miklós Jancsó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4099",
      "databaseFilmTitle": "The Red Army/PFLP: Declaration of World War",
      "FilmTitle": "The Red Army/PFLP: Declaration of World War",
      "AlternateTitle": "Sekigun-PFLP: Sekai senso sengen",
      "TitleArray": [
        "The Red Army/PFLP: Declaration of World War",
        "Sekigun-PFLP: Sekai senso sengen"
      ],
      "Year": "1971",
      "Director": "Masao Adachi, Kôji Wakamatsu",
      "DirectorArray": [
        "Masao Adachi",
        "Kôji Wakamatsu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4100",
      "databaseFilmTitle": "The Red Balloon",
      "FilmTitle": "The Red Balloon",
      "AlternateTitle": "Le ballon rouge",
      "TitleArray": [
        "The Red Balloon",
        "Le ballon rouge"
      ],
      "Year": "1956",
      "Director": "Albert Lamorisse",
      "DirectorArray": [
        "Albert Lamorisse"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4101",
      "databaseFilmTitle": "The Red Circle",
      "FilmTitle": "The Red Circle",
      "AlternateTitle": "Le cercle rouge",
      "TitleArray": [
        "The Red Circle",
        "Le cercle rouge"
      ],
      "Year": "1970",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4102",
      "databaseFilmTitle": "The Red Detachment of Women",
      "FilmTitle": "The Red Detachment of Women",
      "AlternateTitle": "Hong se niang zi jun",
      "TitleArray": [
        "The Red Detachment of Women",
        "Hong se niang zi jun"
      ],
      "Year": "1961",
      "Director": "Jin Xie",
      "DirectorArray": [
        "Jin Xie"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4103",
      "databaseFilmTitle": "The Red Shoes",
      "FilmTitle": "The Red Shoes",
      "AlternateTitle": "",
      "TitleArray": [
        "The Red Shoes"
      ],
      "Year": "1948",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "67",
      "2022votes": "38"
    },
    {
      "key": "4104",
      "databaseFilmTitle": "The Red Snowball Tree",
      "FilmTitle": "The Red Snowball Tree",
      "AlternateTitle": "",
      "TitleArray": [
        "The Red Snowball Tree"
      ],
      "Year": "1973",
      "Director": "Vasili Shuskin",
      "DirectorArray": [
        "Vasili Shuskin"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4105",
      "databaseFilmTitle": "The Remains of the Day",
      "FilmTitle": "The Remains of the Day",
      "AlternateTitle": "",
      "TitleArray": [
        "The Remains of the Day"
      ],
      "Year": "1993",
      "Director": "James Ivory",
      "DirectorArray": [
        "James Ivory"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4106",
      "databaseFilmTitle": "The Rest is Personal",
      "FilmTitle": "The Rest is Personal",
      "AlternateTitle": "Bakita Byaktigato",
      "TitleArray": [
        "The Rest is Personal",
        "Bakita Byaktigato"
      ],
      "Year": "2013",
      "Director": "Pradipta Bhattacharyya",
      "DirectorArray": [
        "Pradipta Bhattacharyya"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4107",
      "databaseFilmTitle": "The Rest Is Silence",
      "FilmTitle": "The Rest Is Silence",
      "AlternateTitle": "Der Rest ist Schweigen",
      "TitleArray": [
        "The Rest Is Silence",
        "Der Rest ist Schweigen"
      ],
      "Year": "1959",
      "Director": "Helmut Käutner",
      "DirectorArray": [
        "Helmut Käutner"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4108",
      "databaseFilmTitle": "The Return",
      "FilmTitle": "The Return",
      "AlternateTitle": "Vozvrashcheniye",
      "TitleArray": [
        "The Return",
        "Vozvrashcheniye"
      ],
      "Year": "2003",
      "Director": "Andrey Zvyagintsev",
      "DirectorArray": [
        "Andrey Zvyagintsev"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4109",
      "databaseFilmTitle": "The Revenant",
      "FilmTitle": "The Revenant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Revenant"
      ],
      "Year": "2015",
      "Director": "Alejandro González Iñárritu",
      "DirectorArray": [
        "Alejandro González Iñárritu"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4110",
      "databaseFilmTitle": "The Revenge of Pancho Villa",
      "FilmTitle": "The Revenge of Pancho Villa",
      "AlternateTitle": "",
      "TitleArray": [
        "The Revenge of Pancho Villa"
      ],
      "Year": "1936",
      "Director": "Félix Padilla, Edmundo Padilla",
      "DirectorArray": [
        "Félix Padilla",
        "Edmundo Padilla"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4111",
      "databaseFilmTitle": "The Rhythm of Crime",
      "FilmTitle": "The Rhythm of Crime",
      "AlternateTitle": "Ritam zločina",
      "TitleArray": [
        "The Rhythm of Crime",
        "Ritam zločina"
      ],
      "Year": "1981",
      "Director": "Zoran Tadić",
      "DirectorArray": [
        "Zoran Tadić"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4112",
      "databaseFilmTitle": "The Rider",
      "FilmTitle": "The Rider",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rider"
      ],
      "Year": "2017",
      "Director": "Chloé Zhao",
      "DirectorArray": [
        "Chloé Zhao"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4113",
      "databaseFilmTitle": "The Right Stuff",
      "FilmTitle": "The Right Stuff",
      "AlternateTitle": "",
      "TitleArray": [
        "The Right Stuff"
      ],
      "Year": "1983",
      "Director": "Philip Kaufman",
      "DirectorArray": [
        "Philip Kaufman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4114",
      "databaseFilmTitle": "The Ring",
      "FilmTitle": "The Ring",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ring"
      ],
      "Year": "2002",
      "Director": "Gore Verbinski",
      "DirectorArray": [
        "Gore Verbinski"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4115",
      "databaseFilmTitle": "The Rink",
      "FilmTitle": "The Rink",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rink"
      ],
      "Year": "1916",
      "Director": "Charlie Chaplin",
      "DirectorArray": [
        "Charlie Chaplin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4116",
      "databaseFilmTitle": "The Ritual",
      "FilmTitle": "The Ritual",
      "AlternateTitle": "Ghatashraddha",
      "TitleArray": [
        "The Ritual",
        "Ghatashraddha"
      ],
      "Year": "1977",
      "Director": "Girish Kasaravalli",
      "DirectorArray": [
        "Girish Kasaravalli"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4117",
      "databaseFilmTitle": "The River (1928)",
      "FilmTitle": "The River",
      "AlternateTitle": "",
      "TitleArray": [
        "The River"
      ],
      "Year": "1928",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4118",
      "databaseFilmTitle": "The River (1951)",
      "FilmTitle": "The River",
      "AlternateTitle": "",
      "TitleArray": [
        "The River"
      ],
      "Year": "1951",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "4119",
      "databaseFilmTitle": "The River (1997)",
      "FilmTitle": "The River",
      "AlternateTitle": "He liu",
      "TitleArray": [
        "The River",
        "He liu"
      ],
      "Year": "1997",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4120",
      "databaseFilmTitle": "The River Schooners",
      "FilmTitle": "The River Schooners",
      "AlternateTitle": "Les voitures d'eau",
      "TitleArray": [
        "The River Schooners",
        "Les voitures d'eau"
      ],
      "Year": "1968",
      "Director": "Pierre Perrault",
      "DirectorArray": [
        "Pierre Perrault"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4121",
      "databaseFilmTitle": "The Road (1982)",
      "FilmTitle": "The Road",
      "AlternateTitle": "Yol",
      "TitleArray": [
        "The Road",
        "Yol"
      ],
      "Year": "1982",
      "Director": "Şerif Gören, Yılmaz Güney",
      "DirectorArray": [
        "Şerif Gören",
        "Yılmaz Güney"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4122",
      "databaseFilmTitle": "The Road (2006)",
      "FilmTitle": "The Road",
      "AlternateTitle": "Fang xiang zhi lu",
      "TitleArray": [
        "The Road",
        "Fang xiang zhi lu"
      ],
      "Year": "2006",
      "Director": "Zhang Jiarui",
      "DirectorArray": [
        "Zhang Jiarui"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4123",
      "databaseFilmTitle": "The Roaring Twenties",
      "FilmTitle": "The Roaring Twenties",
      "AlternateTitle": "",
      "TitleArray": [
        "The Roaring Twenties"
      ],
      "Year": "1939",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4124",
      "databaseFilmTitle": "The Robber Symphony",
      "FilmTitle": "The Robber Symphony",
      "AlternateTitle": "",
      "TitleArray": [
        "The Robber Symphony"
      ],
      "Year": "1936",
      "Director": "Friedrich Feher",
      "DirectorArray": [
        "Friedrich Feher"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4125",
      "databaseFilmTitle": "The Rocky Horror Picture Show",
      "FilmTitle": "The Rocky Horror Picture Show",
      "AlternateTitle": "",
      "TitleArray": [
        "The Rocky Horror Picture Show"
      ],
      "Year": "1975",
      "Director": "Jim Sharman",
      "DirectorArray": [
        "Jim Sharman"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4126",
      "databaseFilmTitle": "The Romance of Aniceto and Francesca",
      "FilmTitle": "The Romance of Aniceto and Francesca",
      "AlternateTitle": "El romace del Aniceto y la Francisca",
      "TitleArray": [
        "The Romance of Aniceto and Francesca",
        "El romace del Aniceto y la Francisca"
      ],
      "Year": "1967",
      "Director": "Leonardo Favio",
      "DirectorArray": [
        "Leonardo Favio"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4127",
      "databaseFilmTitle": "The Rose King",
      "FilmTitle": "The Rose King",
      "AlternateTitle": "Der Rosenkönig",
      "TitleArray": [
        "The Rose King",
        "Der Rosenkönig"
      ],
      "Year": "1986",
      "Director": "Werner Schroeter",
      "DirectorArray": [
        "Werner Schroeter"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4128",
      "databaseFilmTitle": "The Round-Up",
      "FilmTitle": "The Round-Up",
      "AlternateTitle": "Szegénylegények",
      "TitleArray": [
        "The Round-Up",
        "Szegénylegények"
      ],
      "Year": "1966",
      "Director": "Miklós Jancsó",
      "DirectorArray": [
        "Miklós Jancsó"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4129",
      "databaseFilmTitle": "The Royal Road",
      "FilmTitle": "The Royal Road",
      "AlternateTitle": "",
      "TitleArray": [
        "The Royal Road"
      ],
      "Year": "2015",
      "Director": "Jenni Olson",
      "DirectorArray": [
        "Jenni Olson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4130",
      "databaseFilmTitle": "The Royal Tenenbaums",
      "FilmTitle": "The Royal Tenenbaums",
      "AlternateTitle": "",
      "TitleArray": [
        "The Royal Tenenbaums"
      ],
      "Year": "2001",
      "Director": "Wes Anderson",
      "DirectorArray": [
        "Wes Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4131",
      "databaseFilmTitle": "The Rules of the Game",
      "FilmTitle": "The Rules of the Game",
      "AlternateTitle": "La règle du jeu",
      "TitleArray": [
        "The Rules of the Game",
        "La règle du jeu"
      ],
      "Year": "1939",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "10",
      "1952votes": "10",
      "1962rank": "3",
      "1962votes": "19",
      "1972rank": "2",
      "1972votes": "28",
      "1982rank": "2",
      "1982votes": "31",
      "1992rank": "2",
      "1992votes": "32",
      "2002rank": "3",
      "2002votes": "30",
      "2012rank": "4",
      "2012votes": "100",
      "2022rank": "13",
      "2022votes": "87"
    },
    {
      "key": "4132",
      "databaseFilmTitle": "The Runner",
      "FilmTitle": "The Runner",
      "AlternateTitle": "Davandeh",
      "TitleArray": [
        "The Runner",
        "Davandeh"
      ],
      "Year": "1985",
      "Director": "Amir Naderi",
      "DirectorArray": [
        "Amir Naderi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4133",
      "databaseFilmTitle": "The Sacrifice",
      "FilmTitle": "The Sacrifice",
      "AlternateTitle": "Offret",
      "TitleArray": [
        "The Sacrifice",
        "Offret"
      ],
      "Year": "1986",
      "Director": "Andrei Tarkovsky",
      "DirectorArray": [
        "Andrei Tarkovsky"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4134",
      "databaseFilmTitle": "The Saga of Gösta Berling",
      "FilmTitle": "The Saga of Gösta Berling",
      "AlternateTitle": "Gösta Berlings Saga",
      "TitleArray": [
        "The Saga of Gösta Berling",
        "Gösta Berlings Saga"
      ],
      "Year": "1924",
      "Director": "Mauritz Stiller",
      "DirectorArray": [
        "Mauritz Stiller"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4135",
      "databaseFilmTitle": "The Salvation Hunters",
      "FilmTitle": "The Salvation Hunters",
      "AlternateTitle": "",
      "TitleArray": [
        "The Salvation Hunters"
      ],
      "Year": "1925",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4136",
      "databaseFilmTitle": "The Sapphires",
      "FilmTitle": "The Sapphires",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sapphires"
      ],
      "Year": "2012",
      "Director": "Wayne Blair",
      "DirectorArray": [
        "Wayne Blair"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4137",
      "databaseFilmTitle": "The Saragossa Manuscript",
      "FilmTitle": "The Saragossa Manuscript",
      "AlternateTitle": "Rękopis znaleziony w Saragossie",
      "TitleArray": [
        "The Saragossa Manuscript",
        "Rękopis znaleziony w Saragossie"
      ],
      "Year": "1965",
      "Director": "Wojchiech Has",
      "DirectorArray": [
        "Wojchiech Has"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4138",
      "databaseFilmTitle": "The Satin Slipper",
      "FilmTitle": "The Satin Slipper",
      "AlternateTitle": "Le soulier de satin",
      "TitleArray": [
        "The Satin Slipper",
        "Le soulier de satin"
      ],
      "Year": "1985",
      "Director": "Manoel de oliveira",
      "DirectorArray": [
        "Manoel de oliveira"
      ],
      "Country": "France, Portugal",
      "CountryArray": [
        "France",
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4139",
      "databaseFilmTitle": "The Scarlet Empress",
      "FilmTitle": "The Scarlet Empress",
      "AlternateTitle": "",
      "TitleArray": [
        "The Scarlet Empress"
      ],
      "Year": "1934",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4140",
      "databaseFilmTitle": "The Scent of Green Papaya",
      "FilmTitle": "The Scent of Green Papaya",
      "AlternateTitle": "Mùi đu đủ xanh - L'Odeur de la papaye verte",
      "TitleArray": [
        "The Scent of Green Papaya",
        "Mùi đu đủ xanh - L'Odeur de la papaye verte"
      ],
      "Year": "1993",
      "Director": "Trần Anh Hùng",
      "DirectorArray": [
        "Trần Anh Hùng"
      ],
      "Country": "Vietnam, France",
      "CountryArray": [
        "Vietnam",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4141",
      "databaseFilmTitle": "The Sea and Poison",
      "FilmTitle": "The Sea and Poison",
      "AlternateTitle": "Umi to dokuyaku",
      "TitleArray": [
        "The Sea and Poison",
        "Umi to dokuyaku"
      ],
      "Year": "1986",
      "Director": "Kei Kumai",
      "DirectorArray": [
        "Kei Kumai"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4142",
      "databaseFilmTitle": "The Sea Horse",
      "FilmTitle": "The Sea Horse",
      "AlternateTitle": "L'hippocampe (Cheval marin)",
      "TitleArray": [
        "The Sea Horse",
        "L'hippocampe (Cheval marin)"
      ],
      "Year": "1934",
      "Director": "Jean Painlevé",
      "DirectorArray": [
        "Jean Painlevé"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4143",
      "databaseFilmTitle": "The Sea Inside",
      "FilmTitle": "The Sea Inside",
      "AlternateTitle": "Mar adentro",
      "TitleArray": [
        "The Sea Inside",
        "Mar adentro"
      ],
      "Year": "2004",
      "Director": "Alejandro González Iñárritu",
      "DirectorArray": [
        "Alejandro González Iñárritu"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4144",
      "databaseFilmTitle": "The Searchers",
      "FilmTitle": "The Searchers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Searchers"
      ],
      "Year": "1956",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "10",
      "1982votes": "11",
      "1992rank": "5",
      "1992votes": "17",
      "2002rank": "11",
      "2002votes": "15",
      "2012rank": "7",
      "2012votes": "78",
      "2022rank": "15",
      "2022votes": "80"
    },
    {
      "key": "4145",
      "databaseFilmTitle": "The Seashell and the Clergyman",
      "FilmTitle": "The Seashell and the Clergyman",
      "AlternateTitle": "La coquille et le clergyman",
      "TitleArray": [
        "The Seashell and the Clergyman",
        "La coquille et le clergyman"
      ],
      "Year": "1927",
      "Director": "Germaine Dulac",
      "DirectorArray": [
        "Germaine Dulac"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4146",
      "databaseFilmTitle": "The Seasons",
      "FilmTitle": "The Seasons",
      "AlternateTitle": "Vremena goda",
      "TitleArray": [
        "The Seasons",
        "Vremena goda"
      ],
      "Year": "1969",
      "Director": "Ivan Ivanov-Vano, Yuri Norstein",
      "DirectorArray": [
        "Ivan Ivanov-Vano",
        "Yuri Norstein"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4147",
      "databaseFilmTitle": "The Second Circle",
      "FilmTitle": "The Second Circle",
      "AlternateTitle": "Krug vtoroy",
      "TitleArray": [
        "The Second Circle",
        "Krug vtoroy"
      ],
      "Year": "1990",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4148",
      "databaseFilmTitle": "The Second Game",
      "FilmTitle": "The Second Game",
      "AlternateTitle": "Al doilea joc",
      "TitleArray": [
        "The Second Game",
        "Al doilea joc"
      ],
      "Year": "2014",
      "Director": "Corneliu Porumboiu",
      "DirectorArray": [
        "Corneliu Porumboiu"
      ],
      "Country": "Romania",
      "CountryArray": [
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4149",
      "databaseFilmTitle": "The Second Journey (To Uluru)",
      "FilmTitle": "The Second Journey (To Uluru)",
      "AlternateTitle": "",
      "TitleArray": [
        "The Second Journey (To Uluru)"
      ],
      "Year": "1981",
      "Director": "Arthur Cantrill, Corinne Cantrill",
      "DirectorArray": [
        "Arthur Cantrill",
        "Corinne Cantrill"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4150",
      "databaseFilmTitle": "The Secret Formula",
      "FilmTitle": "The Secret Formula",
      "AlternateTitle": "La fórmula secreta",
      "TitleArray": [
        "The Secret Formula",
        "La fórmula secreta"
      ],
      "Year": "1965",
      "Director": "Rubén Gámez",
      "DirectorArray": [
        "Rubén Gámez"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4151",
      "databaseFilmTitle": "The Secret Nation",
      "FilmTitle": "The Secret Nation",
      "AlternateTitle": "La nación clandestina",
      "TitleArray": [
        "The Secret Nation",
        "La nación clandestina"
      ],
      "Year": "1989",
      "Director": "Jorge Sanjinés",
      "DirectorArray": [
        "Jorge Sanjinés"
      ],
      "Country": "Bolivia",
      "CountryArray": [
        "Bolivia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4152",
      "databaseFilmTitle": "The Secret of the Grain",
      "FilmTitle": "The Secret of the Grain",
      "AlternateTitle": "La graine et le mulet",
      "TitleArray": [
        "The Secret of the Grain",
        "La graine et le mulet"
      ],
      "Year": "2007",
      "Director": "Abdellatif Kechiche",
      "DirectorArray": [
        "Abdellatif Kechiche"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4153",
      "databaseFilmTitle": "The Selfish Giant",
      "FilmTitle": "The Selfish Giant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Selfish Giant"
      ],
      "Year": "2013",
      "Director": "Clio Barnard",
      "DirectorArray": [
        "Clio Barnard"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4154",
      "databaseFilmTitle": "The Servant",
      "FilmTitle": "The Servant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Servant"
      ],
      "Year": "1963",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4155",
      "databaseFilmTitle": "The Servile",
      "FilmTitle": "The Servile",
      "AlternateTitle": "Vidheyan",
      "TitleArray": [
        "The Servile",
        "Vidheyan"
      ],
      "Year": "1994",
      "Director": "Adoor Gopalakrishnan",
      "DirectorArray": [
        "Adoor Gopalakrishnan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4156",
      "databaseFilmTitle": "The Set-Up",
      "FilmTitle": "The Set-Up",
      "AlternateTitle": "",
      "TitleArray": [
        "The Set-Up"
      ],
      "Year": "1949",
      "Director": "Robert Wise",
      "DirectorArray": [
        "Robert Wise"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4157",
      "databaseFilmTitle": "The Seventh Continent",
      "FilmTitle": "The Seventh Continent",
      "AlternateTitle": "Der siebente Kontinent",
      "TitleArray": [
        "The Seventh Continent",
        "Der siebente Kontinent"
      ],
      "Year": "1989",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4158",
      "databaseFilmTitle": "The Seventh Seal",
      "FilmTitle": "The Seventh Seal",
      "AlternateTitle": "Det sjunde inseglet",
      "TitleArray": [
        "The Seventh Seal",
        "Det sjunde inseglet"
      ],
      "Year": "1957",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "4159",
      "databaseFilmTitle": "The Seventh Victim",
      "FilmTitle": "The Seventh Victim",
      "AlternateTitle": "",
      "TitleArray": [
        "The Seventh Victim"
      ],
      "Year": "1943",
      "Director": "Mark Robson",
      "DirectorArray": [
        "Mark Robson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4160",
      "databaseFilmTitle": "The Shadow",
      "FilmTitle": "The Shadow",
      "AlternateTitle": "L'ombra",
      "TitleArray": [
        "The Shadow",
        "L'ombra"
      ],
      "Year": "1954",
      "Director": "Giorgio Bianchi",
      "DirectorArray": [
        "Giorgio Bianchi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4161",
      "databaseFilmTitle": "The Shanghai Gesture",
      "FilmTitle": "The Shanghai Gesture",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shanghai Gesture"
      ],
      "Year": "1941",
      "Director": "Josef von Sternberg",
      "DirectorArray": [
        "Josef von Sternberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4162",
      "databaseFilmTitle": "The Shape of Water",
      "FilmTitle": "The Shape of Water",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shape of Water"
      ],
      "Year": "2017",
      "Director": "Guillermo del Toro",
      "DirectorArray": [
        "Guillermo del Toro"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4163",
      "databaseFilmTitle": "The Shawshank Redemption",
      "FilmTitle": "The Shawshank Redemption",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shawshank Redemption"
      ],
      "Year": "1994",
      "Director": "Frank Darabont",
      "DirectorArray": [
        "Frank Darabont"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4164",
      "databaseFilmTitle": "The Shetland Experience",
      "FilmTitle": "The Shetland Experience",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shetland Experience"
      ],
      "Year": "1977",
      "Director": "Derek Williams",
      "DirectorArray": [
        "Derek Williams"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4165",
      "databaseFilmTitle": "The Shimmering Beast",
      "FilmTitle": "The Shimmering Beast",
      "AlternateTitle": "La bête lumineuse",
      "TitleArray": [
        "The Shimmering Beast",
        "La bête lumineuse"
      ],
      "Year": "1982",
      "Director": "Pierre Perrault",
      "DirectorArray": [
        "Pierre Perrault"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4166",
      "databaseFilmTitle": "The Shining",
      "FilmTitle": "The Shining",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shining"
      ],
      "Year": "1980",
      "Director": "Stanley Kubrick",
      "DirectorArray": [
        "Stanley Kubrick"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "88",
      "2022votes": "33"
    },
    {
      "key": "4167",
      "databaseFilmTitle": "The Shop around the Corner",
      "FilmTitle": "The Shop around the Corner",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shop around the Corner"
      ],
      "Year": "1940",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4168",
      "databaseFilmTitle": "The Shout",
      "FilmTitle": "The Shout",
      "AlternateTitle": "",
      "TitleArray": [
        "The Shout"
      ],
      "Year": "1978",
      "Director": "Jerzy Skolimowski",
      "DirectorArray": [
        "Jerzy Skolimowski"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4169",
      "databaseFilmTitle": "The Sieges of Alcazar",
      "FilmTitle": "The Sieges of Alcazar",
      "AlternateTitle": "Les sièges de l'Alcazar",
      "TitleArray": [
        "The Sieges of Alcazar",
        "Les sièges de l'Alcazar"
      ],
      "Year": "1989",
      "Director": "Luc Moullet",
      "DirectorArray": [
        "Luc Moullet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4170",
      "databaseFilmTitle": "The Sign of Leo",
      "FilmTitle": "The Sign of Leo",
      "AlternateTitle": "Le signe du lion",
      "TitleArray": [
        "The Sign of Leo",
        "Le signe du lion"
      ],
      "Year": "1959",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4171",
      "databaseFilmTitle": "The Sign of Venus",
      "FilmTitle": "The Sign of Venus",
      "AlternateTitle": "Il segno di venere",
      "TitleArray": [
        "The Sign of Venus",
        "Il segno di venere"
      ],
      "Year": "1955",
      "Director": "Dino Risi",
      "DirectorArray": [
        "Dino Risi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4172",
      "databaseFilmTitle": "The Silence",
      "FilmTitle": "The Silence",
      "AlternateTitle": "Tystnaden",
      "TitleArray": [
        "The Silence",
        "Tystnaden"
      ],
      "Year": "1963",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4173",
      "databaseFilmTitle": "The Silence of the Lambs",
      "FilmTitle": "The Silence of the Lambs",
      "AlternateTitle": "",
      "TitleArray": [
        "The Silence of the Lambs"
      ],
      "Year": "1991",
      "Director": "Jonathan Demme",
      "DirectorArray": [
        "Jonathan Demme"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4174",
      "databaseFilmTitle": "The Silence of the Sea",
      "FilmTitle": "The Silence of the Sea",
      "AlternateTitle": "Le silence de lar mer",
      "TitleArray": [
        "The Silence of the Sea",
        "Le silence de lar mer"
      ],
      "Year": "1949",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4175",
      "databaseFilmTitle": "The Silences of the Palace",
      "FilmTitle": "The Silences of the Palace",
      "AlternateTitle": "Samt el Qusur",
      "TitleArray": [
        "The Silences of the Palace",
        "Samt el Qusur"
      ],
      "Year": "1994",
      "Director": "Moufida Tiatli",
      "DirectorArray": [
        "Moufida Tiatli"
      ],
      "Country": "Tunisia",
      "CountryArray": [
        "Tunisia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4176",
      "databaseFilmTitle": "The Sin of Nora Moran",
      "FilmTitle": "The Sin of Nora Moran",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sin of Nora Moran"
      ],
      "Year": "1933",
      "Director": "Phil Goldstone",
      "DirectorArray": [
        "Phil Goldstone"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4177",
      "databaseFilmTitle": "The Sinking of the Lusitania",
      "FilmTitle": "The Sinking of the Lusitania",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sinking of the Lusitania"
      ],
      "Year": "1918",
      "Director": "Winsor McCay",
      "DirectorArray": [
        "Winsor McCay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4178",
      "databaseFilmTitle": "The Sinner",
      "FilmTitle": "The Sinner",
      "AlternateTitle": "Die Sünderin",
      "TitleArray": [
        "The Sinner",
        "Die Sünderin"
      ],
      "Year": "1951",
      "Director": "Willi Forst",
      "DirectorArray": [
        "Willi Forst"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4179",
      "databaseFilmTitle": "The Sixth Part of the World",
      "FilmTitle": "The Sixth Part of the World",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sixth Part of the World"
      ],
      "Year": "1926",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4180",
      "databaseFilmTitle": "The Sky of Our Childhood",
      "FilmTitle": "The Sky of Our Childhood",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sky of Our Childhood"
      ],
      "Year": "1966",
      "Director": "Tolomush Okeyev",
      "DirectorArray": [
        "Tolomush Okeyev"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4181",
      "databaseFilmTitle": "The Sky Socialist",
      "FilmTitle": "The Sky Socialist",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sky Socialist"
      ],
      "Year": "1968",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4182",
      "databaseFilmTitle": "The Slightest Gesture",
      "FilmTitle": "The Slightest Gesture",
      "AlternateTitle": "Le moindre geste",
      "TitleArray": [
        "The Slightest Gesture",
        "Le moindre geste"
      ],
      "Year": "1971",
      "Director": "Jean-Pierre Daniel, Fernand Deligny, Josée Manenti",
      "DirectorArray": [
        "Jean-Pierre Daniel",
        "Fernand Deligny",
        "Josée Manenti"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4183",
      "databaseFilmTitle": "The Small World of Sammy Lee",
      "FilmTitle": "The Small World of Sammy Lee",
      "AlternateTitle": "",
      "TitleArray": [
        "The Small World of Sammy Lee"
      ],
      "Year": "1963",
      "Director": "Ken Hughes",
      "DirectorArray": [
        "Ken Hughes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4184",
      "databaseFilmTitle": "The Smallest Show on Earth",
      "FilmTitle": "The Smallest Show on Earth",
      "AlternateTitle": "",
      "TitleArray": [
        "The Smallest Show on Earth"
      ],
      "Year": "1957",
      "Director": "Basil Dearden",
      "DirectorArray": [
        "Basil Dearden"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4185",
      "databaseFilmTitle": "The Smiling Lieutenant",
      "FilmTitle": "The Smiling Lieutenant",
      "AlternateTitle": "",
      "TitleArray": [
        "The Smiling Lieutenant"
      ],
      "Year": "1931",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4186",
      "databaseFilmTitle": "The Smiling Madame Beudet",
      "FilmTitle": "The Smiling Madame Beudet",
      "AlternateTitle": "La souriante Madame Beudet",
      "TitleArray": [
        "The Smiling Madame Beudet",
        "La souriante Madame Beudet"
      ],
      "Year": "1923",
      "Director": "Germaine Dulac",
      "DirectorArray": [
        "Germaine Dulac"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4187",
      "databaseFilmTitle": "The Social Life of Small Urban Spaces",
      "FilmTitle": "The Social Life of Small Urban Spaces",
      "AlternateTitle": "",
      "TitleArray": [
        "The Social Life of Small Urban Spaces"
      ],
      "Year": "1988",
      "Director": "William H. Whyte",
      "DirectorArray": [
        "William H. Whyte"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4188",
      "databaseFilmTitle": "The Social Network",
      "FilmTitle": "The Social Network",
      "AlternateTitle": "",
      "TitleArray": [
        "The Social Network"
      ],
      "Year": "2010",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4189",
      "databaseFilmTitle": "The Soft Skin",
      "FilmTitle": "The Soft Skin",
      "AlternateTitle": "Le peau douce",
      "TitleArray": [
        "The Soft Skin",
        "Le peau douce"
      ],
      "Year": "1964",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4190",
      "databaseFilmTitle": "The Son",
      "FilmTitle": "The Son",
      "AlternateTitle": "Le fils",
      "TitleArray": [
        "The Son",
        "Le fils"
      ],
      "Year": "2002",
      "Director": "Jean-Pierre Dardenne, Luc Dardenne",
      "DirectorArray": [
        "Jean-Pierre Dardenne",
        "Luc Dardenne"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4191",
      "databaseFilmTitle": "The Son of the White Mare",
      "FilmTitle": "The Son of the White Mare",
      "AlternateTitle": "Fehérlófia",
      "TitleArray": [
        "The Son of the White Mare",
        "Fehérlófia"
      ],
      "Year": "1981",
      "Director": "Marcell Jankovic",
      "DirectorArray": [
        "Marcell Jankovic"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4192",
      "databaseFilmTitle": "The Song Lantern",
      "FilmTitle": "The Song Lantern",
      "AlternateTitle": "Uta-andon",
      "TitleArray": [
        "The Song Lantern",
        "Uta-andon"
      ],
      "Year": "1943",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4193",
      "databaseFilmTitle": "The Song of Ceylon",
      "FilmTitle": "The Song of Ceylon",
      "AlternateTitle": "",
      "TitleArray": [
        "The Song of Ceylon"
      ],
      "Year": "1934",
      "Director": "Basil Wright",
      "DirectorArray": [
        "Basil Wright"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4194",
      "databaseFilmTitle": "The Song of Rio Jim",
      "FilmTitle": "The Song of Rio Jim",
      "AlternateTitle": "",
      "TitleArray": [
        "The Song of Rio Jim"
      ],
      "Year": "1978",
      "Director": "Maurice Lemaître",
      "DirectorArray": [
        "Maurice Lemaître"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4195",
      "databaseFilmTitle": "The Sorrow and the Pity",
      "FilmTitle": "The Sorrow and the Pity",
      "AlternateTitle": "Le chagrin et la pitié",
      "TitleArray": [
        "The Sorrow and the Pity",
        "Le chagrin et la pitié"
      ],
      "Year": "1969",
      "Director": "Marcel Ophüls",
      "DirectorArray": [
        "Marcel Ophüls"
      ],
      "Country": "France, West Germany",
      "CountryArray": [
        "France",
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4196",
      "databaseFilmTitle": "The Sound of Insects: Record of a Mummy",
      "FilmTitle": "The Sound of Insects: Record of a Mummy",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sound of Insects: Record of a Mummy"
      ],
      "Year": "2009",
      "Director": "Peter Liechti",
      "DirectorArray": [
        "Peter Liechti"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4197",
      "databaseFilmTitle": "The Sound of Music",
      "FilmTitle": "The Sound of Music",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sound of Music"
      ],
      "Year": "1965",
      "Director": "Robert Wise",
      "DirectorArray": [
        "Robert Wise"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4198",
      "databaseFilmTitle": "The Sound of the Shaking Earth",
      "FilmTitle": "The Sound of the Shaking Earth",
      "AlternateTitle": "O som da terra a tremer",
      "TitleArray": [
        "The Sound of the Shaking Earth",
        "O som da terra a tremer"
      ],
      "Year": "1990",
      "Director": "Rita Azevedo Gomes",
      "DirectorArray": [
        "Rita Azevedo Gomes"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4199",
      "databaseFilmTitle": "The South",
      "FilmTitle": "The South",
      "AlternateTitle": "Sur",
      "TitleArray": [
        "The South",
        "Sur"
      ],
      "Year": "1988",
      "Director": "Fernando E. Solanas",
      "DirectorArray": [
        "Fernando E. Solanas"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4200",
      "databaseFilmTitle": "The Souvenir",
      "FilmTitle": "The Souvenir",
      "AlternateTitle": "",
      "TitleArray": [
        "The Souvenir"
      ],
      "Year": "2019",
      "Director": "Joanna Hogg",
      "DirectorArray": [
        "Joanna Hogg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4201",
      "databaseFilmTitle": "The Souvenir: Part II",
      "FilmTitle": "The Souvenir: Part II",
      "AlternateTitle": "",
      "TitleArray": [
        "The Souvenir: Part II"
      ],
      "Year": "2022",
      "Director": "Joanna Hogg",
      "DirectorArray": [
        "Joanna Hogg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4202",
      "databaseFilmTitle": "The Spider's Stratagem",
      "FilmTitle": "The Spider's Stratagem",
      "AlternateTitle": "Strategia del ragno",
      "TitleArray": [
        "The Spider's Stratagem",
        "Strategia del ragno"
      ],
      "Year": "1970",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4203",
      "databaseFilmTitle": "The Spiral Staircase",
      "FilmTitle": "The Spiral Staircase",
      "AlternateTitle": "",
      "TitleArray": [
        "The Spiral Staircase"
      ],
      "Year": "1946",
      "Director": "Robert Siodmak",
      "DirectorArray": [
        "Robert Siodmak"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4204",
      "databaseFilmTitle": "The Spirit of the Beehive",
      "FilmTitle": "The Spirit of the Beehive",
      "AlternateTitle": "El espíritu de la colmena",
      "TitleArray": [
        "The Spirit of the Beehive",
        "El espíritu de la colmena"
      ],
      "Year": "1973",
      "Director": "Víctor Erice",
      "DirectorArray": [
        "Víctor Erice"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "81",
      "2012votes": "20",
      "2022rank": "85",
      "2022votes": "34"
    },
    {
      "key": "4205",
      "databaseFilmTitle": "The Spook Who Sat by the Door",
      "FilmTitle": "The Spook Who Sat by the Door",
      "AlternateTitle": "",
      "TitleArray": [
        "The Spook Who Sat by the Door"
      ],
      "Year": "1973",
      "Director": "Ivan Dixon",
      "DirectorArray": [
        "Ivan Dixon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4206",
      "databaseFilmTitle": "The Spring River Flows East",
      "FilmTitle": "The Spring River Flows East",
      "AlternateTitle": "Yi jiang chun shui xiang dong liu",
      "TitleArray": [
        "The Spring River Flows East",
        "Yi jiang chun shui xiang dong liu"
      ],
      "Year": "1947",
      "Director": "Cai Chusheng, Zheng Junli",
      "DirectorArray": [
        "Cai Chusheng",
        "Zheng Junli"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4207",
      "databaseFilmTitle": "The Square",
      "FilmTitle": "The Square",
      "AlternateTitle": "",
      "TitleArray": [
        "The Square"
      ],
      "Year": "2017",
      "Director": "Ruben Östlund",
      "DirectorArray": [
        "Ruben Östlund"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4208",
      "databaseFilmTitle": "The Squid and the Whale",
      "FilmTitle": "The Squid and the Whale",
      "AlternateTitle": "",
      "TitleArray": [
        "The Squid and the Whale"
      ],
      "Year": "2005",
      "Director": "Noah Baumbach",
      "DirectorArray": [
        "Noah Baumbach"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4209",
      "databaseFilmTitle": "The Stars Look Down",
      "FilmTitle": "The Stars Look Down",
      "AlternateTitle": "",
      "TitleArray": [
        "The Stars Look Down"
      ],
      "Year": "1940",
      "Director": "Carol Reed",
      "DirectorArray": [
        "Carol Reed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4210",
      "databaseFilmTitle": "The Station Agent",
      "FilmTitle": "The Station Agent",
      "AlternateTitle": "",
      "TitleArray": [
        "The Station Agent"
      ],
      "Year": "2003",
      "Director": "Tom McCarthy",
      "DirectorArray": [
        "Tom McCarthy"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4211",
      "databaseFilmTitle": "The Steel Animal",
      "FilmTitle": "The Steel Animal",
      "AlternateTitle": "Das Stahltier",
      "TitleArray": [
        "The Steel Animal",
        "Das Stahltier"
      ],
      "Year": "1935",
      "Director": "Willy Zielke",
      "DirectorArray": [
        "Willy Zielke"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4212",
      "databaseFilmTitle": "The Steel Helmet",
      "FilmTitle": "The Steel Helmet",
      "AlternateTitle": "",
      "TitleArray": [
        "The Steel Helmet"
      ],
      "Year": "1951",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4213",
      "databaseFilmTitle": "The Stolen Children",
      "FilmTitle": "The Stolen Children",
      "AlternateTitle": "Il ladro di bambini",
      "TitleArray": [
        "The Stolen Children",
        "Il ladro di bambini"
      ],
      "Year": "1992",
      "Director": "Gianni Amelio",
      "DirectorArray": [
        "Gianni Amelio"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4214",
      "databaseFilmTitle": "The Stone",
      "FilmTitle": "The Stone",
      "AlternateTitle": "Kamen",
      "TitleArray": [
        "The Stone",
        "Kamen"
      ],
      "Year": "1992",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4215",
      "databaseFilmTitle": "The Story of a Cheat",
      "FilmTitle": "The Story of a Cheat",
      "AlternateTitle": "Le roman d'un tricheur",
      "TitleArray": [
        "The Story of a Cheat",
        "Le roman d'un tricheur"
      ],
      "Year": "1936",
      "Director": "Sacha Guitry",
      "DirectorArray": [
        "Sacha Guitry"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4216",
      "databaseFilmTitle": "The Story of a Three-Day Pass",
      "FilmTitle": "The Story of a Three-Day Pass",
      "AlternateTitle": "La permission",
      "TitleArray": [
        "The Story of a Three-Day Pass",
        "La permission"
      ],
      "Year": "1968",
      "Director": "Melvin Van Peebles",
      "DirectorArray": [
        "Melvin Van Peebles"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4217",
      "databaseFilmTitle": "The Story of Marie and Julien",
      "FilmTitle": "The Story of Marie and Julien",
      "AlternateTitle": "Histoire de Marie et Julien",
      "TitleArray": [
        "The Story of Marie and Julien",
        "Histoire de Marie et Julien"
      ],
      "Year": "2003",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4218",
      "databaseFilmTitle": "The Story of Qiu Ju",
      "FilmTitle": "The Story of Qiu Ju",
      "AlternateTitle": "Giu Ju da guan si",
      "TitleArray": [
        "The Story of Qiu Ju",
        "Giu Ju da guan si"
      ],
      "Year": "1992",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4219",
      "databaseFilmTitle": "The Story of the Kelly Gang",
      "FilmTitle": "The Story of the Kelly Gang",
      "AlternateTitle": "",
      "TitleArray": [
        "The Story of the Kelly Gang"
      ],
      "Year": "1906",
      "Director": "Charles Tait",
      "DirectorArray": [
        "Charles Tait"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4220",
      "databaseFilmTitle": "The Story of the Last Chrysanthemums",
      "FilmTitle": "The Story of the Last Chrysanthemums",
      "AlternateTitle": "Zangiku monogatari",
      "TitleArray": [
        "The Story of the Last Chrysanthemums",
        "Zangiku monogatari"
      ],
      "Year": "1939",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "25",
      "2002votes": "8",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "4221",
      "databaseFilmTitle": "The Straight Story",
      "FilmTitle": "The Straight Story",
      "AlternateTitle": "",
      "TitleArray": [
        "The Straight Story"
      ],
      "Year": "1999",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4222",
      "databaseFilmTitle": "The Straits of Love and Hate",
      "FilmTitle": "The Straits of Love and Hate",
      "AlternateTitle": "Aien kyo",
      "TitleArray": [
        "The Straits of Love and Hate",
        "Aien kyo"
      ],
      "Year": "1937",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4223",
      "databaseFilmTitle": "The Strange Colour of Your Body's Tears",
      "FilmTitle": "The Strange Colour of Your Body's Tears",
      "AlternateTitle": "L'étrange couleur des larmes de ton corps",
      "TitleArray": [
        "The Strange Colour of Your Body's Tears",
        "L'étrange couleur des larmes de ton corps"
      ],
      "Year": "2013",
      "Director": "Hélène Cattet, Bruno Forzani",
      "DirectorArray": [
        "Hélène Cattet",
        "Bruno Forzani"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4224",
      "databaseFilmTitle": "The Stranger's Return",
      "FilmTitle": "The Stranger's Return",
      "AlternateTitle": "",
      "TitleArray": [
        "The Stranger's Return"
      ],
      "Year": "1933",
      "Director": "King Vidor",
      "DirectorArray": [
        "King Vidor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4225",
      "databaseFilmTitle": "The Strategy of the Snail",
      "FilmTitle": "The Strategy of the Snail",
      "AlternateTitle": "La estrategia del caracol",
      "TitleArray": [
        "The Strategy of the Snail",
        "La estrategia del caracol"
      ],
      "Year": "1993",
      "Director": "Sérgio Cabrera",
      "DirectorArray": [
        "Sérgio Cabrera"
      ],
      "Country": "Colombia",
      "CountryArray": [
        "Colombia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4226",
      "databaseFilmTitle": "The Streetwalker",
      "FilmTitle": "The Streetwalker",
      "AlternateTitle": "La marge (The Margin / Emanuela 77)",
      "TitleArray": [
        "The Streetwalker",
        "La marge (The Margin / Emanuela 77)"
      ],
      "Year": "1976",
      "Director": "Walerian Borowczyk",
      "DirectorArray": [
        "Walerian Borowczyk"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4227",
      "databaseFilmTitle": "The Stuart Hall Project",
      "FilmTitle": "The Stuart Hall Project",
      "AlternateTitle": "",
      "TitleArray": [
        "The Stuart Hall Project"
      ],
      "Year": "2013",
      "Director": "John Akomfrah",
      "DirectorArray": [
        "John Akomfrah"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4228",
      "databaseFilmTitle": "The Student of Prague",
      "FilmTitle": "The Student of Prague",
      "AlternateTitle": "Der Student von Prag",
      "TitleArray": [
        "The Student of Prague",
        "Der Student von Prag"
      ],
      "Year": "1926",
      "Director": "Henrik Galeen",
      "DirectorArray": [
        "Henrik Galeen"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4229",
      "databaseFilmTitle": "The Student Prince in Old Heidelberg",
      "FilmTitle": "The Student Prince in Old Heidelberg",
      "AlternateTitle": "",
      "TitleArray": [
        "The Student Prince in Old Heidelberg"
      ],
      "Year": "1927",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4230",
      "databaseFilmTitle": "The Stuff",
      "FilmTitle": "The Stuff",
      "AlternateTitle": "",
      "TitleArray": [
        "The Stuff"
      ],
      "Year": "1985",
      "Director": "Larry Cohen",
      "DirectorArray": [
        "Larry Cohen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4231",
      "databaseFilmTitle": "The Stunt Man",
      "FilmTitle": "The Stunt Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Stunt Man"
      ],
      "Year": "1980",
      "Director": "Richard Rush",
      "DirectorArray": [
        "Richard Rush"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4232",
      "databaseFilmTitle": "The Sun",
      "FilmTitle": "The Sun",
      "AlternateTitle": "Solntse",
      "TitleArray": [
        "The Sun",
        "Solntse"
      ],
      "Year": "2005",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4233",
      "databaseFilmTitle": "The Sun Shines Bright",
      "FilmTitle": "The Sun Shines Bright",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sun Shines Bright"
      ],
      "Year": "1953",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4234",
      "databaseFilmTitle": "The Suspended Step of the Stork",
      "FilmTitle": "The Suspended Step of the Stork",
      "AlternateTitle": "To meteoro vima tou pelargou",
      "TitleArray": [
        "The Suspended Step of the Stork",
        "To meteoro vima tou pelargou"
      ],
      "Year": "1991",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4235",
      "databaseFilmTitle": "The Sweet Hereafter",
      "FilmTitle": "The Sweet Hereafter",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sweet Hereafter"
      ],
      "Year": "1997",
      "Director": "Atom Egoyan",
      "DirectorArray": [
        "Atom Egoyan"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4236",
      "databaseFilmTitle": "The Sweet Smell of Success",
      "FilmTitle": "The Sweet Smell of Success",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sweet Smell of Success"
      ],
      "Year": "1957",
      "Director": "Alexaner Mackendrick",
      "DirectorArray": [
        "Alexaner Mackendrick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4237",
      "databaseFilmTitle": "The Swimmer",
      "FilmTitle": "The Swimmer",
      "AlternateTitle": "",
      "TitleArray": [
        "The Swimmer"
      ],
      "Year": "1986",
      "Director": "Frank Perry",
      "DirectorArray": [
        "Frank Perry"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4238",
      "databaseFilmTitle": "The Sword in the Stone",
      "FilmTitle": "The Sword in the Stone",
      "AlternateTitle": "",
      "TitleArray": [
        "The Sword in the Stone"
      ],
      "Year": "1963",
      "Director": "Wolfgang Reitherman",
      "DirectorArray": [
        "Wolfgang Reitherman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4239",
      "databaseFilmTitle": "The Taking of Pelham One Two Three",
      "FilmTitle": "The Taking of Pelham One Two Three",
      "AlternateTitle": "",
      "TitleArray": [
        "The Taking of Pelham One Two Three"
      ],
      "Year": "1974",
      "Director": "Joseph Sargent",
      "DirectorArray": [
        "Joseph Sargent"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4240",
      "databaseFilmTitle": "The Taking of Power by Louis XIV",
      "FilmTitle": "The Taking of Power by Louis XIV",
      "AlternateTitle": "La prise de pouvoir par Louis XIV",
      "TitleArray": [
        "The Taking of Power by Louis XIV",
        "La prise de pouvoir par Louis XIV"
      ],
      "Year": "1966",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4241",
      "databaseFilmTitle": "The Tale of the Princess Kaguya",
      "FilmTitle": "The Tale of the Princess Kaguya",
      "AlternateTitle": "Kaguya-hime no monogatari",
      "TitleArray": [
        "The Tale of the Princess Kaguya",
        "Kaguya-hime no monogatari"
      ],
      "Year": "2013",
      "Director": "Isao Takahata",
      "DirectorArray": [
        "Isao Takahata"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4242",
      "databaseFilmTitle": "The Talented Mr. Ripley",
      "FilmTitle": "The Talented Mr. Ripley",
      "AlternateTitle": "",
      "TitleArray": [
        "The Talented Mr. Ripley"
      ],
      "Year": "1999",
      "Director": "Anthony Minghella",
      "DirectorArray": [
        "Anthony Minghella"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4243",
      "databaseFilmTitle": "The Tales of Hoffmann",
      "FilmTitle": "The Tales of Hoffmann",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tales of Hoffmann"
      ],
      "Year": "1951",
      "Director": "Michael Powell, Emeric Pressburger",
      "DirectorArray": [
        "Michael Powell",
        "Emeric Pressburger"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4244",
      "databaseFilmTitle": "The Tall Men",
      "FilmTitle": "The Tall Men",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tall Men"
      ],
      "Year": "1955",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4245",
      "databaseFilmTitle": "The Tall T",
      "FilmTitle": "The Tall T",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tall T"
      ],
      "Year": "1957",
      "Director": "Budd Boetticher",
      "DirectorArray": [
        "Budd Boetticher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4246",
      "databaseFilmTitle": "The Tarnished Angels",
      "FilmTitle": "The Tarnished Angels",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tarnished Angels"
      ],
      "Year": "1957",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4247",
      "databaseFilmTitle": "The Taste of Others",
      "FilmTitle": "The Taste of Others",
      "AlternateTitle": "Le goût des autres",
      "TitleArray": [
        "The Taste of Others",
        "Le goût des autres"
      ],
      "Year": "2000",
      "Director": "Agnès Jaoui",
      "DirectorArray": [
        "Agnès Jaoui"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4248",
      "databaseFilmTitle": "The Taste of Tea",
      "FilmTitle": "The Taste of Tea",
      "AlternateTitle": "Cha no aji",
      "TitleArray": [
        "The Taste of Tea",
        "Cha no aji"
      ],
      "Year": "2004",
      "Director": "Katsuhito Ishii",
      "DirectorArray": [
        "Katsuhito Ishii"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4249",
      "databaseFilmTitle": "The Tempest",
      "FilmTitle": "The Tempest",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tempest"
      ],
      "Year": "1979",
      "Director": "Derek Jarman",
      "DirectorArray": [
        "Derek Jarman"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4250",
      "databaseFilmTitle": "The Tempest: Poem on the Sea",
      "FilmTitle": "The Tempest: Poem on the Sea",
      "AlternateTitle": "Le tempestaire",
      "TitleArray": [
        "The Tempest: Poem on the Sea",
        "Le tempestaire"
      ],
      "Year": "1947",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4251",
      "databaseFilmTitle": "The Ten Commandments",
      "FilmTitle": "The Ten Commandments",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ten Commandments"
      ],
      "Year": "1956",
      "Director": "Cecil B. DeMille",
      "DirectorArray": [
        "Cecil B. DeMille"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4252",
      "databaseFilmTitle": "The Tenant",
      "FilmTitle": "The Tenant",
      "AlternateTitle": "Le locataire",
      "TitleArray": [
        "The Tenant",
        "Le locataire"
      ],
      "Year": "1976",
      "Director": "Roman Polanski",
      "DirectorArray": [
        "Roman Polanski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4253",
      "databaseFilmTitle": "The Terminator",
      "FilmTitle": "The Terminator",
      "AlternateTitle": "",
      "TitleArray": [
        "The Terminator"
      ],
      "Year": "1984",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4254",
      "databaseFilmTitle": "The Terror and the Time",
      "FilmTitle": "The Terror and the Time",
      "AlternateTitle": "",
      "TitleArray": [
        "The Terror and the Time"
      ],
      "Year": "1976",
      "Director": "Rupert Roopnaraine",
      "DirectorArray": [
        "Rupert Roopnaraine"
      ],
      "Country": "Guyana",
      "CountryArray": [
        "Guyana"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4255",
      "databaseFilmTitle": "The Terrorizers",
      "FilmTitle": "The Terrorizers",
      "AlternateTitle": "Kong bu fen zi",
      "TitleArray": [
        "The Terrorizers",
        "Kong bu fen zi"
      ],
      "Year": "1986",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4256",
      "databaseFilmTitle": "The Testament of Dr. Cordelier",
      "FilmTitle": "The Testament of Dr. Cordelier",
      "AlternateTitle": "Le testament du docteur Cordelier",
      "TitleArray": [
        "The Testament of Dr. Cordelier",
        "Le testament du docteur Cordelier"
      ],
      "Year": "1959",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4257",
      "databaseFilmTitle": "The Testament of Dr. Mabuse",
      "FilmTitle": "The Testament of Dr. Mabuse",
      "AlternateTitle": "Das Testament des Dr. Mabuse",
      "TitleArray": [
        "The Testament of Dr. Mabuse",
        "Das Testament des Dr. Mabuse"
      ],
      "Year": "1933",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4258",
      "databaseFilmTitle": "The Texas Chain Saw Massacre",
      "FilmTitle": "The Texas Chain Saw Massacre",
      "AlternateTitle": "",
      "TitleArray": [
        "The Texas Chain Saw Massacre"
      ],
      "Year": "1974",
      "Director": "Tobe Hooper",
      "DirectorArray": [
        "Tobe Hooper"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "118",
      "2022votes": "26"
    },
    {
      "key": "4259",
      "databaseFilmTitle": "The Text of Light",
      "FilmTitle": "The Text of Light",
      "AlternateTitle": "",
      "TitleArray": [
        "The Text of Light"
      ],
      "Year": "1974",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4260",
      "databaseFilmTitle": "The Thief of Bagdad",
      "FilmTitle": "The Thief of Bagdad",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thief of Bagdad"
      ],
      "Year": "1940",
      "Director": "Ludwig Berger, Michael Powell, Tim Whelan",
      "DirectorArray": [
        "Ludwig Berger",
        "Michael Powell",
        "Tim Whelan"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4261",
      "databaseFilmTitle": "The Thin Blue Line",
      "FilmTitle": "The Thin Blue Line",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thin Blue Line"
      ],
      "Year": "1988",
      "Director": "Errol Morris",
      "DirectorArray": [
        "Errol Morris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4262",
      "databaseFilmTitle": "The Thin Man",
      "FilmTitle": "The Thin Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thin Man"
      ],
      "Year": "1934",
      "Director": "W.S. Van Dyke",
      "DirectorArray": [
        "W.S. Van Dyke"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4263",
      "databaseFilmTitle": "The Thin Red Line",
      "FilmTitle": "The Thin Red Line",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thin Red Line"
      ],
      "Year": "1998",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "182",
      "2012votes": "9",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "4264",
      "databaseFilmTitle": "The Thing",
      "FilmTitle": "The Thing",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thing"
      ],
      "Year": "1982",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "118",
      "2022votes": "26"
    },
    {
      "key": "4265",
      "databaseFilmTitle": "The Thing from Another World",
      "FilmTitle": "The Thing from Another World",
      "AlternateTitle": "",
      "TitleArray": [
        "The Thing from Another World"
      ],
      "Year": "1951",
      "Director": "Christian Nyby",
      "DirectorArray": [
        "Christian Nyby"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4266",
      "databaseFilmTitle": "The Things of Life",
      "FilmTitle": "The Things of Life",
      "AlternateTitle": "Les choses de la vie",
      "TitleArray": [
        "The Things of Life",
        "Les choses de la vie"
      ],
      "Year": "1970",
      "Director": "Claude Sautet",
      "DirectorArray": [
        "Claude Sautet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4267",
      "databaseFilmTitle": "The Third Generation",
      "FilmTitle": "The Third Generation",
      "AlternateTitle": "Die dritte Generation",
      "TitleArray": [
        "The Third Generation",
        "Die dritte Generation"
      ],
      "Year": "1979",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4268",
      "databaseFilmTitle": "The Third Man",
      "FilmTitle": "The Third Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Third Man"
      ],
      "Year": "1949",
      "Director": "Carol Reed",
      "DirectorArray": [
        "Carol Reed"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "14",
      "1982votes": "9",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "36",
      "2002votes": "6",
      "2012rank": "73",
      "2012votes": "22",
      "2022rank": "63",
      "2022votes": "40"
    },
    {
      "key": "4269",
      "databaseFilmTitle": "The Three-Sided Mirror",
      "FilmTitle": "The Three-Sided Mirror",
      "AlternateTitle": "La glace à trois faces",
      "TitleArray": [
        "The Three-Sided Mirror",
        "La glace à trois faces"
      ],
      "Year": "1927",
      "Director": "Jean Epstein",
      "DirectorArray": [
        "Jean Epstein"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4270",
      "databaseFilmTitle": "The Threepenny Opera",
      "FilmTitle": "The Threepenny Opera",
      "AlternateTitle": "Die 3 Groschen-Oper",
      "TitleArray": [
        "The Threepenny Opera",
        "Die 3 Groschen-Oper"
      ],
      "Year": "1931",
      "Director": "G.W. Pabst",
      "DirectorArray": [
        "G.W. Pabst"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "24",
      "1952votes": "5",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4271",
      "databaseFilmTitle": "The Tied-Up Balloon",
      "FilmTitle": "The Tied-Up Balloon",
      "AlternateTitle": "Privarzaniyat balon",
      "TitleArray": [
        "The Tied-Up Balloon",
        "Privarzaniyat balon"
      ],
      "Year": "1967",
      "Director": "Binka Zhelyazkova",
      "DirectorArray": [
        "Binka Zhelyazkova"
      ],
      "Country": "Bulgaria",
      "CountryArray": [
        "Bulgaria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4272",
      "databaseFilmTitle": "The Ties That Bind",
      "FilmTitle": "The Ties That Bind",
      "AlternateTitle": "",
      "TitleArray": [
        "The Ties That Bind"
      ],
      "Year": "1985",
      "Director": "Su Friedrich",
      "DirectorArray": [
        "Su Friedrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4273",
      "databaseFilmTitle": "The Tiger of Eschnapur",
      "FilmTitle": "The Tiger of Eschnapur",
      "AlternateTitle": "Der tiger von Eschnapur",
      "TitleArray": [
        "The Tiger of Eschnapur",
        "Der tiger von Eschnapur"
      ],
      "Year": "1959",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4274",
      "databaseFilmTitle": "The Tiger Who Came to Tea",
      "FilmTitle": "The Tiger Who Came to Tea",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tiger Who Came to Tea"
      ],
      "Year": "2019",
      "Director": "Robin Shaw",
      "DirectorArray": [
        "Robin Shaw"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4275",
      "databaseFilmTitle": "The Time Machine",
      "FilmTitle": "The Time Machine",
      "AlternateTitle": "",
      "TitleArray": [
        "The Time Machine"
      ],
      "Year": "1960",
      "Director": "George Pál",
      "DirectorArray": [
        "George Pál"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4276",
      "databaseFilmTitle": "The Time That Remains",
      "FilmTitle": "The Time That Remains",
      "AlternateTitle": "Le temps qu'il reste",
      "TitleArray": [
        "The Time That Remains",
        "Le temps qu'il reste"
      ],
      "Year": "2009",
      "Director": "Elia Seleiman",
      "DirectorArray": [
        "Elia Seleiman"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4277",
      "databaseFilmTitle": "The Times of Harvey Milk",
      "FilmTitle": "The Times of Harvey Milk",
      "AlternateTitle": "",
      "TitleArray": [
        "The Times of Harvey Milk"
      ],
      "Year": "1984",
      "Director": "Rob Epstein",
      "DirectorArray": [
        "Rob Epstein"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4278",
      "databaseFilmTitle": "The Tin Drum",
      "FilmTitle": "The Tin Drum",
      "AlternateTitle": "Die Blechtrommel",
      "TitleArray": [
        "The Tin Drum",
        "Die Blechtrommel"
      ],
      "Year": "1979",
      "Director": "Volker Schlöndorff",
      "DirectorArray": [
        "Volker Schlöndorff"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4279",
      "databaseFilmTitle": "The Towering Inferno",
      "FilmTitle": "The Towering Inferno",
      "AlternateTitle": "",
      "TitleArray": [
        "The Towering Inferno"
      ],
      "Year": "1974",
      "Director": "John Guillermin",
      "DirectorArray": [
        "John Guillermin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4280",
      "databaseFilmTitle": "The Town is Quiet",
      "FilmTitle": "The Town is Quiet",
      "AlternateTitle": "La ville est tranquille",
      "TitleArray": [
        "The Town is Quiet",
        "La ville est tranquille"
      ],
      "Year": "2000",
      "Director": "Robert Guédiguian",
      "DirectorArray": [
        "Robert Guédiguian"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4281",
      "databaseFilmTitle": "The Tragedy of Macbeth",
      "FilmTitle": "The Tragedy of Macbeth",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tragedy of Macbeth"
      ],
      "Year": "2021",
      "Director": "Joel Coen",
      "DirectorArray": [
        "Joel Coen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4282",
      "databaseFilmTitle": "The Traitors",
      "FilmTitle": "The Traitors",
      "AlternateTitle": "Los traidores",
      "TitleArray": [
        "The Traitors",
        "Los traidores"
      ],
      "Year": "1973",
      "Director": "Raymundo Gleyzer",
      "DirectorArray": [
        "Raymundo Gleyzer"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4283",
      "databaseFilmTitle": "The Travelling Players",
      "FilmTitle": "The Travelling Players",
      "AlternateTitle": "",
      "TitleArray": [
        "The Travelling Players"
      ],
      "Year": "1975",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "46",
      "2002votes": "5",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4284",
      "databaseFilmTitle": "The Treasure of the Sierra Madre",
      "FilmTitle": "The Treasure of the Sierra Madre",
      "AlternateTitle": "",
      "TitleArray": [
        "The Treasure of the Sierra Madre"
      ],
      "Year": "1948",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4285",
      "databaseFilmTitle": "The Tree of Life",
      "FilmTitle": "The Tree of Life",
      "AlternateTitle": "",
      "TitleArray": [
        "The Tree of Life"
      ],
      "Year": "2011",
      "Director": "Terrence Malick",
      "DirectorArray": [
        "Terrence Malick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "4286",
      "databaseFilmTitle": "The Tree of Wooden Clogs",
      "FilmTitle": "The Tree of Wooden Clogs",
      "AlternateTitle": "L'albero degli zoccoli",
      "TitleArray": [
        "The Tree of Wooden Clogs",
        "L'albero degli zoccoli"
      ],
      "Year": "1978",
      "Director": "Ermanno Olmi",
      "DirectorArray": [
        "Ermanno Olmi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4287",
      "databaseFilmTitle": "The Trial (1962)",
      "FilmTitle": "The Trial",
      "AlternateTitle": "Le Procès",
      "TitleArray": [
        "The Trial",
        "Le Procès"
      ],
      "Year": "1962",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "France, Italy",
      "CountryArray": [
        "France",
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4288",
      "databaseFilmTitle": "The Trial (1984)",
      "FilmTitle": "The Trial",
      "AlternateTitle": "Der Prozess",
      "TitleArray": [
        "The Trial",
        "Der Prozess"
      ],
      "Year": "1984",
      "Director": "Eberhard Fechner",
      "DirectorArray": [
        "Eberhard Fechner"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4289",
      "databaseFilmTitle": "The Trial of Martinovics and the Hungarian Jacobins",
      "FilmTitle": "The Trial of Martinovics and the Hungarian Jacobins",
      "AlternateTitle": "Vizsgálat Martinovits Ignác szászvári apát és társai ügyében",
      "TitleArray": [
        "The Trial of Martinovics and the Hungarian Jacobins",
        "Vizsgálat Martinovits Ignác szászvári apát és társai ügyében"
      ],
      "Year": "1980",
      "Director": "Judit Elek",
      "DirectorArray": [
        "Judit Elek"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4290",
      "databaseFilmTitle": "The Trial of the Chicago 7",
      "FilmTitle": "The Trial of the Chicago 7",
      "AlternateTitle": "",
      "TitleArray": [
        "The Trial of the Chicago 7"
      ],
      "Year": "2020",
      "Director": "Aaron Sorkin",
      "DirectorArray": [
        "Aaron Sorkin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4291",
      "databaseFilmTitle": "The Triplets of Belleville",
      "FilmTitle": "The Triplets of Belleville",
      "AlternateTitle": "Les triplettes de Belleville",
      "TitleArray": [
        "The Triplets of Belleville",
        "Les triplettes de Belleville"
      ],
      "Year": "2003",
      "Director": "Sylvain Chomet",
      "DirectorArray": [
        "Sylvain Chomet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4292",
      "databaseFilmTitle": "The Trouble with Harry",
      "FilmTitle": "The Trouble with Harry",
      "AlternateTitle": "",
      "TitleArray": [
        "The Trouble with Harry"
      ],
      "Year": "1955",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4293",
      "databaseFilmTitle": "The Truck",
      "FilmTitle": "The Truck",
      "AlternateTitle": "Le camion",
      "TitleArray": [
        "The Truck",
        "Le camion"
      ],
      "Year": "1977",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4294",
      "databaseFilmTitle": "The Truman Show",
      "FilmTitle": "The Truman Show",
      "AlternateTitle": "",
      "TitleArray": [
        "The Truman Show"
      ],
      "Year": "1998",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4295",
      "databaseFilmTitle": "The Truth About Bebe Donge",
      "FilmTitle": "The Truth About Bebe Donge",
      "AlternateTitle": "La vérité sur Bébé Donge",
      "TitleArray": [
        "The Truth About Bebe Donge",
        "La vérité sur Bébé Donge"
      ],
      "Year": "1952",
      "Director": "Henri Decoin",
      "DirectorArray": [
        "Henri Decoin"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4296",
      "databaseFilmTitle": "The Turin Horse",
      "FilmTitle": "The Turin Horse",
      "AlternateTitle": "A torinói ló",
      "TitleArray": [
        "The Turin Horse",
        "A torinói ló"
      ],
      "Year": "2011",
      "Director": "Béla Tarr, Ágnes Hranitzky",
      "DirectorArray": [
        "Béla Tarr",
        "Ágnes Hranitzky"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4297",
      "databaseFilmTitle": "The Umbrellas of Cherbourg",
      "FilmTitle": "The Umbrellas of Cherbourg",
      "AlternateTitle": "Les parapluies de Cherbourg",
      "TitleArray": [
        "The Umbrellas of Cherbourg",
        "Les parapluies de Cherbourg"
      ],
      "Year": "1964",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "123",
      "2022votes": "25"
    },
    {
      "key": "4298",
      "databaseFilmTitle": "The Unbearable Lightness of Being",
      "FilmTitle": "The Unbearable Lightness of Being",
      "AlternateTitle": "",
      "TitleArray": [
        "The Unbearable Lightness of Being"
      ],
      "Year": "1988",
      "Director": "Philip Kaufman",
      "DirectorArray": [
        "Philip Kaufman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4299",
      "databaseFilmTitle": "The Uncertainty Principle",
      "FilmTitle": "The Uncertainty Principle",
      "AlternateTitle": "O Princípio da Incerteza",
      "TitleArray": [
        "The Uncertainty Principle",
        "O Princípio da Incerteza"
      ],
      "Year": "2002",
      "Director": "Manoel de oliveira",
      "DirectorArray": [
        "Manoel de oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4300",
      "databaseFilmTitle": "The Underground Railroad",
      "FilmTitle": "The Underground Railroad",
      "AlternateTitle": "",
      "TitleArray": [
        "The Underground Railroad"
      ],
      "Year": "2021",
      "Director": "Barry Jenkins",
      "DirectorArray": [
        "Barry Jenkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4301",
      "databaseFilmTitle": "The Unfaithful Wife",
      "FilmTitle": "The Unfaithful Wife",
      "AlternateTitle": "La femme infidèle",
      "TitleArray": [
        "The Unfaithful Wife",
        "La femme infidèle"
      ],
      "Year": "1969",
      "Director": "Claude Chabrol",
      "DirectorArray": [
        "Claude Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4302",
      "databaseFilmTitle": "The Unholy Three",
      "FilmTitle": "The Unholy Three",
      "AlternateTitle": "",
      "TitleArray": [
        "The Unholy Three"
      ],
      "Year": "1925",
      "Director": "Tod Browning",
      "DirectorArray": [
        "Tod Browning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4303",
      "databaseFilmTitle": "The United States of America",
      "FilmTitle": "The United States of America",
      "AlternateTitle": "",
      "TitleArray": [
        "The United States of America"
      ],
      "Year": "1975",
      "Director": "James Benning, Better Gordon",
      "DirectorArray": [
        "James Benning",
        "Better Gordon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4304",
      "databaseFilmTitle": "The Unknown",
      "FilmTitle": "The Unknown",
      "AlternateTitle": "",
      "TitleArray": [
        "The Unknown"
      ],
      "Year": "1927",
      "Director": "Tod Browning",
      "DirectorArray": [
        "Tod Browning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4305",
      "databaseFilmTitle": "The Usual Suspects",
      "FilmTitle": "The Usual Suspects",
      "AlternateTitle": "",
      "TitleArray": [
        "The Usual Suspects"
      ],
      "Year": "1995",
      "Director": "Bryan Singer",
      "DirectorArray": [
        "Bryan Singer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4306",
      "databaseFilmTitle": "The V.I.P.s",
      "FilmTitle": "The V.I.P.s",
      "AlternateTitle": "",
      "TitleArray": [
        "The V.I.P.s"
      ],
      "Year": "1963",
      "Director": "Anthony Asquith",
      "DirectorArray": [
        "Anthony Asquith"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4307",
      "databaseFilmTitle": "The Vagabond",
      "FilmTitle": "The Vagabond",
      "AlternateTitle": "Awaara",
      "TitleArray": [
        "The Vagabond",
        "Awaara"
      ],
      "Year": "1951",
      "Director": "Raj Kapoor",
      "DirectorArray": [
        "Raj Kapoor"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4308",
      "databaseFilmTitle": "The Vampire Lovers",
      "FilmTitle": "The Vampire Lovers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Vampire Lovers"
      ],
      "Year": "1970",
      "Director": "Roy Ward Baker",
      "DirectorArray": [
        "Roy Ward Baker"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4309",
      "databaseFilmTitle": "The Vampires of Poverty",
      "FilmTitle": "The Vampires of Poverty",
      "AlternateTitle": "Agarrando pueblo",
      "TitleArray": [
        "The Vampires of Poverty",
        "Agarrando pueblo"
      ],
      "Year": "1978",
      "Director": "Luis Ospina, Carlos Mayolo",
      "DirectorArray": [
        "Luis Ospina",
        "Carlos Mayolo"
      ],
      "Country": "Colombia",
      "CountryArray": [
        "Colombia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4310",
      "databaseFilmTitle": "The Vanishing",
      "FilmTitle": "The Vanishing",
      "AlternateTitle": "Spoorloos",
      "TitleArray": [
        "The Vanishing",
        "Spoorloos"
      ],
      "Year": "1988",
      "Director": "George Sluizer",
      "DirectorArray": [
        "George Sluizer"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4311",
      "databaseFilmTitle": "The Vietnam War",
      "FilmTitle": "The Vietnam War",
      "AlternateTitle": "",
      "TitleArray": [
        "The Vietnam War"
      ],
      "Year": "2017",
      "Director": "Ken Burns, Lynn Novick",
      "DirectorArray": [
        "Ken Burns",
        "Lynn Novick"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4312",
      "databaseFilmTitle": "The Vikings",
      "FilmTitle": "The Vikings",
      "AlternateTitle": "",
      "TitleArray": [
        "The Vikings"
      ],
      "Year": "1958",
      "Director": "Richard Fleischer",
      "DirectorArray": [
        "Richard Fleischer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4313",
      "databaseFilmTitle": "The Village",
      "FilmTitle": "The Village",
      "AlternateTitle": "",
      "TitleArray": [
        "The Village"
      ],
      "Year": "2004",
      "Director": "M. Night Shyamalan",
      "DirectorArray": [
        "M. Night Shyamalan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4314",
      "databaseFilmTitle": "The Virgin of Nuremberg",
      "FilmTitle": "The Virgin of Nuremberg",
      "AlternateTitle": "La vergine di Norimberga (Horror Castle)",
      "TitleArray": [
        "The Virgin of Nuremberg",
        "La vergine di Norimberga (Horror Castle)"
      ],
      "Year": "1963",
      "Director": "Antonio Margheriti",
      "DirectorArray": [
        "Antonio Margheriti"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4315",
      "databaseFilmTitle": "The Virgin of Pessac",
      "FilmTitle": "The Virgin of Pessac",
      "AlternateTitle": "La rosière de Pessac",
      "TitleArray": [
        "The Virgin of Pessac",
        "La rosière de Pessac"
      ],
      "Year": "1968",
      "Director": "Jean Eustache",
      "DirectorArray": [
        "Jean Eustache"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4316",
      "databaseFilmTitle": "The Virgin Spring",
      "FilmTitle": "The Virgin Spring",
      "AlternateTitle": "Jungfrukällan",
      "TitleArray": [
        "The Virgin Spring",
        "Jungfrukällan"
      ],
      "Year": "1960",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4317",
      "databaseFilmTitle": "The Virgin Suicides",
      "FilmTitle": "The Virgin Suicides",
      "AlternateTitle": "",
      "TitleArray": [
        "The Virgin Suicides"
      ],
      "Year": "1999",
      "Director": "Sofia Coppola",
      "DirectorArray": [
        "Sofia Coppola"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4318",
      "databaseFilmTitle": "The Wages of Fear",
      "FilmTitle": "The Wages of Fear",
      "AlternateTitle": "Le salaire de la peur",
      "TitleArray": [
        "The Wages of Fear",
        "Le salaire de la peur"
      ],
      "Year": "1953",
      "Director": "Henri-Georges Clouzot",
      "DirectorArray": [
        "Henri-Georges Clouzot"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4319",
      "databaseFilmTitle": "The Wagoner",
      "FilmTitle": "The Wagoner",
      "AlternateTitle": "Borom Sarret",
      "TitleArray": [
        "The Wagoner",
        "Borom Sarret"
      ],
      "Year": "1963",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4320",
      "databaseFilmTitle": "The Wanderers",
      "FilmTitle": "The Wanderers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wanderers"
      ],
      "Year": "1979",
      "Director": "Philip Kaufman",
      "DirectorArray": [
        "Philip Kaufman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4321",
      "databaseFilmTitle": "The War Game",
      "FilmTitle": "The War Game",
      "AlternateTitle": "",
      "TitleArray": [
        "The War Game"
      ],
      "Year": "1966",
      "Director": "Peter Watkins",
      "DirectorArray": [
        "Peter Watkins"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4322",
      "databaseFilmTitle": "The War Is Over",
      "FilmTitle": "The War Is Over",
      "AlternateTitle": "La guerre est finie",
      "TitleArray": [
        "The War Is Over",
        "La guerre est finie"
      ],
      "Year": "1966",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4323",
      "databaseFilmTitle": "The War of the Worlds",
      "FilmTitle": "The War of the Worlds",
      "AlternateTitle": "",
      "TitleArray": [
        "The War of the Worlds"
      ],
      "Year": "1953",
      "Director": "Byron Haskin",
      "DirectorArray": [
        "Byron Haskin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4324",
      "databaseFilmTitle": "The Warriors",
      "FilmTitle": "The Warriors",
      "AlternateTitle": "",
      "TitleArray": [
        "The Warriors"
      ],
      "Year": "1979",
      "Director": "Walter Hill",
      "DirectorArray": [
        "Walter Hill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4325",
      "databaseFilmTitle": "The Water Carrier Is Dead",
      "FilmTitle": "The Water Carrier Is Dead",
      "AlternateTitle": "Al-Saqqa Mat",
      "TitleArray": [
        "The Water Carrier Is Dead",
        "Al-Saqqa Mat"
      ],
      "Year": "1979",
      "Director": "Salah Abouseif",
      "DirectorArray": [
        "Salah Abouseif"
      ],
      "Country": "Egypt",
      "CountryArray": [
        "Egypt"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4326",
      "databaseFilmTitle": "The Water of Seine",
      "FilmTitle": "The Water of Seine",
      "AlternateTitle": "L'eau de la Seine",
      "TitleArray": [
        "The Water of Seine",
        "L'eau de la Seine"
      ],
      "Year": "1983",
      "Director": "Téo Hernandez",
      "DirectorArray": [
        "Téo Hernandez"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4327",
      "databaseFilmTitle": "The Watermelon Woman",
      "FilmTitle": "The Watermelon Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "The Watermelon Woman"
      ],
      "Year": "1996",
      "Director": "Cheryl Dunye",
      "DirectorArray": [
        "Cheryl Dunye"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "4328",
      "databaseFilmTitle": "The Way Things Go",
      "FilmTitle": "The Way Things Go",
      "AlternateTitle": "Der Lauf der Dinge",
      "TitleArray": [
        "The Way Things Go",
        "Der Lauf der Dinge"
      ],
      "Year": "1987",
      "Director": "Peter Fischli, David Weiss",
      "DirectorArray": [
        "Peter Fischli",
        "David Weiss"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4329",
      "databaseFilmTitle": "The Wayward Cloud",
      "FilmTitle": "The Wayward Cloud",
      "AlternateTitle": "Tian bian yi duo yun",
      "TitleArray": [
        "The Wayward Cloud",
        "Tian bian yi duo yun"
      ],
      "Year": "2005",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4330",
      "databaseFilmTitle": "The Wedding March",
      "FilmTitle": "The Wedding March",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wedding March"
      ],
      "Year": "1928",
      "Director": "Erich von Strohein",
      "DirectorArray": [
        "Erich von Strohein"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4331",
      "databaseFilmTitle": "The Whip and the Body",
      "FilmTitle": "The Whip and the Body",
      "AlternateTitle": "La frusta e il corpo",
      "TitleArray": [
        "The Whip and the Body",
        "La frusta e il corpo"
      ],
      "Year": "1963",
      "Director": "Mario Bava",
      "DirectorArray": [
        "Mario Bava"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4332",
      "databaseFilmTitle": "The White Balloon",
      "FilmTitle": "The White Balloon",
      "AlternateTitle": "Badkonake Sefid",
      "TitleArray": [
        "The White Balloon",
        "Badkonake Sefid"
      ],
      "Year": "1995",
      "Director": "Jafar Panahi",
      "DirectorArray": [
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4333",
      "databaseFilmTitle": "The White Reindeer",
      "FilmTitle": "The White Reindeer",
      "AlternateTitle": "Valkoinen Peura",
      "TitleArray": [
        "The White Reindeer",
        "Valkoinen Peura"
      ],
      "Year": "1952",
      "Director": "Erik Blomberg",
      "DirectorArray": [
        "Erik Blomberg"
      ],
      "Country": "Finland",
      "CountryArray": [
        "Finland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4334",
      "databaseFilmTitle": "The White Ribbon",
      "FilmTitle": "The White Ribbon",
      "AlternateTitle": "Das weisse Band – Eine deutsche Kindergeschichte",
      "TitleArray": [
        "The White Ribbon",
        "Das weisse Band – Eine deutsche Kindergeschichte"
      ],
      "Year": "2009",
      "Director": "Michael Haneke",
      "DirectorArray": [
        "Michael Haneke"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "4335",
      "databaseFilmTitle": "The Wicker Man",
      "FilmTitle": "The Wicker Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wicker Man"
      ],
      "Year": "1973",
      "Director": "Robin Hardy",
      "DirectorArray": [
        "Robin Hardy"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4336",
      "databaseFilmTitle": "The Wife",
      "FilmTitle": "The Wife",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wife"
      ],
      "Year": "1995",
      "Director": "Tom Noonan",
      "DirectorArray": [
        "Tom Noonan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4337",
      "databaseFilmTitle": "The Wild Bunch",
      "FilmTitle": "The Wild Bunch",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wild Bunch"
      ],
      "Year": "1969",
      "Director": "Sam Peckinpah",
      "DirectorArray": [
        "Sam Peckinpah"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "84",
      "2012votes": "19",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "4338",
      "databaseFilmTitle": "The Wild Child",
      "FilmTitle": "The Wild Child",
      "AlternateTitle": "L'enfant sauvage",
      "TitleArray": [
        "The Wild Child",
        "L'enfant sauvage"
      ],
      "Year": "1970",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4339",
      "databaseFilmTitle": "The Wild Party",
      "FilmTitle": "The Wild Party",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wild Party"
      ],
      "Year": "1929",
      "Director": "Dorothy Arzner",
      "DirectorArray": [
        "Dorothy Arzner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4340",
      "databaseFilmTitle": "The Wind",
      "FilmTitle": "The Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wind"
      ],
      "Year": "1928",
      "Director": "Victor Sjöström",
      "DirectorArray": [
        "Victor Sjöström"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4341",
      "databaseFilmTitle": "The Wind and the Lion",
      "FilmTitle": "The Wind and the Lion",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wind and the Lion"
      ],
      "Year": "1975",
      "Director": "John Milius",
      "DirectorArray": [
        "John Milius"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4342",
      "databaseFilmTitle": "The Wind is Driving Him Toward the Open Sea",
      "FilmTitle": "The Wind is Driving Him Toward the Open Sea",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wind is Driving Him Toward the Open Sea"
      ],
      "Year": "1968",
      "Director": "David Brooks",
      "DirectorArray": [
        "David Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4343",
      "databaseFilmTitle": "The Wind Rises",
      "FilmTitle": "The Wind Rises",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wind Rises"
      ],
      "Year": "2013",
      "Director": "Hayao Miyazaki",
      "DirectorArray": [
        "Hayao Miyazaki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4344",
      "databaseFilmTitle": "The Wind Will Carry Us",
      "FilmTitle": "The Wind Will Carry Us",
      "AlternateTitle": "Bad ma ra khahad bord",
      "TitleArray": [
        "The Wind Will Carry Us",
        "Bad ma ra khahad bord"
      ],
      "Year": "1999",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4345",
      "databaseFilmTitle": "The Wings of Eagles",
      "FilmTitle": "The Wings of Eagles",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wings of Eagles"
      ],
      "Year": "1957",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4346",
      "databaseFilmTitle": "The Wire",
      "FilmTitle": "The Wire",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wire"
      ],
      "Year": "2002-2008",
      "Director": "David Simon",
      "DirectorArray": [
        "David Simon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United Staes"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4347",
      "databaseFilmTitle": "The Witches",
      "FilmTitle": "The Witches",
      "AlternateTitle": "",
      "TitleArray": [
        "The Witches"
      ],
      "Year": "1990",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4348",
      "databaseFilmTitle": "The Wiz",
      "FilmTitle": "The Wiz",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wiz"
      ],
      "Year": "1978",
      "Director": "Sidney Lumet",
      "DirectorArray": [
        "Sidney Lumet"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4349",
      "databaseFilmTitle": "The Wizard of Oz",
      "FilmTitle": "The Wizard of Oz",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wizard of Oz"
      ],
      "Year": "1939",
      "Director": "Victor Fleming",
      "DirectorArray": [
        "Victor Fleming"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "4350",
      "databaseFilmTitle": "The Wolf of Wall Street",
      "FilmTitle": "The Wolf of Wall Street",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wolf of Wall Street"
      ],
      "Year": "2013",
      "Director": "Martin Scorsese",
      "DirectorArray": [
        "Martin Scorsese"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4351",
      "databaseFilmTitle": "The Woman Next Door",
      "FilmTitle": "The Woman Next Door",
      "AlternateTitle": "La femme d'à côté",
      "TitleArray": [
        "The Woman Next Door",
        "La femme d'à côté"
      ],
      "Year": "1981",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4352",
      "databaseFilmTitle": "The Woman Who Dared",
      "FilmTitle": "The Woman Who Dared",
      "AlternateTitle": "Le ciel est à vous",
      "TitleArray": [
        "The Woman Who Dared",
        "Le ciel est à vous"
      ],
      "Year": "1944",
      "Director": "Jean Grémillon",
      "DirectorArray": [
        "Jean Grémillon"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4353",
      "databaseFilmTitle": "The Woman Who Left",
      "FilmTitle": "The Woman Who Left",
      "AlternateTitle": "Ang Babaeng Humayo",
      "TitleArray": [
        "The Woman Who Left",
        "Ang Babaeng Humayo"
      ],
      "Year": "2016",
      "Director": "Lav Diaz",
      "DirectorArray": [
        "Lav Diaz"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4354",
      "databaseFilmTitle": "The Woman's Greatest Value Is Her Silence",
      "FilmTitle": "The Woman's Greatest Value Is Her Silence",
      "AlternateTitle": "Das höchste Gut einer Frau ist ihr Schweigen (Il valore della donna è il suo silenzio)",
      "TitleArray": [
        "The Woman's Greatest Value Is Her Silence",
        "Das höchste Gut einer Frau ist ihr Schweigen (Il valore della donna è il suo silenzio)"
      ],
      "Year": "1980",
      "Director": "Gertrud Pinkus",
      "DirectorArray": [
        "Gertrud Pinkus"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4355",
      "databaseFilmTitle": "The Women",
      "FilmTitle": "The Women",
      "AlternateTitle": "",
      "TitleArray": [
        "The Women"
      ],
      "Year": "1939",
      "Director": "George Cukor",
      "DirectorArray": [
        "George Cukor"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4356",
      "databaseFilmTitle": "The Wonderful Lies of Nina Petrovna",
      "FilmTitle": "The Wonderful Lies of Nina Petrovna",
      "AlternateTitle": "Die wunderbare Lüge der Nina Petrowna",
      "TitleArray": [
        "The Wonderful Lies of Nina Petrovna",
        "Die wunderbare Lüge der Nina Petrowna"
      ],
      "Year": "1929",
      "Director": "Hanns Schwarz",
      "DirectorArray": [
        "Hanns Schwarz"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4357",
      "databaseFilmTitle": "The Wonders",
      "FilmTitle": "The Wonders",
      "AlternateTitle": "Le meraviglie",
      "TitleArray": [
        "The Wonders",
        "Le meraviglie"
      ],
      "Year": "2014",
      "Director": "Alice Rohrwacher",
      "DirectorArray": [
        "Alice Rohrwacher"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4358",
      "databaseFilmTitle": "The Woolworths Choir of 1979",
      "FilmTitle": "The Woolworths Choir of 1979",
      "AlternateTitle": "",
      "TitleArray": [
        "The Woolworths Choir of 1979"
      ],
      "Year": "2012",
      "Director": "Elizabeth Price",
      "DirectorArray": [
        "Elizabeth Price"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4359",
      "databaseFilmTitle": "The Workers Settlement",
      "FilmTitle": "The Workers Settlement",
      "AlternateTitle": "",
      "TitleArray": [
        "The Workers Settlement"
      ],
      "Year": "1965",
      "Director": "Vladimir Vengerov",
      "DirectorArray": [
        "Vladimir Vengerov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4360",
      "databaseFilmTitle": "The Working Class Goes to Heaven",
      "FilmTitle": "The Working Class Goes to Heaven",
      "AlternateTitle": "La classe operaia va in paradiso",
      "TitleArray": [
        "The Working Class Goes to Heaven",
        "La classe operaia va in paradiso"
      ],
      "Year": "1971",
      "Director": "Elio Petri",
      "DirectorArray": [
        "Elio Petri"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4361",
      "databaseFilmTitle": "The World",
      "FilmTitle": "The World",
      "AlternateTitle": "Shijie",
      "TitleArray": [
        "The World",
        "Shijie"
      ],
      "Year": "2004",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4362",
      "databaseFilmTitle": "The World According to Garp",
      "FilmTitle": "The World According to Garp",
      "AlternateTitle": "",
      "TitleArray": [
        "The World According to Garp"
      ],
      "Year": "1982",
      "Director": "George Roy Hill",
      "DirectorArray": [
        "George Roy Hill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4363",
      "databaseFilmTitle": "The World of Apu",
      "FilmTitle": "The World of Apu",
      "AlternateTitle": "Apur Sansar",
      "TitleArray": [
        "The World of Apu",
        "Apur Sansar"
      ],
      "Year": "1959",
      "Director": "Satyajit Ray",
      "DirectorArray": [
        "Satyajit Ray"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "33",
      "1982votes": "6",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4364",
      "databaseFilmTitle": "The World's Greatest Sinner",
      "FilmTitle": "The World's Greatest Sinner",
      "AlternateTitle": "",
      "TitleArray": [
        "The World's Greatest Sinner"
      ],
      "Year": "1962",
      "Director": "Timothy Carey",
      "DirectorArray": [
        "Timothy Carey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4365",
      "databaseFilmTitle": "The Wrong Man",
      "FilmTitle": "The Wrong Man",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wrong Man"
      ],
      "Year": "1956",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4366",
      "databaseFilmTitle": "The Wrong Trousers",
      "FilmTitle": "The Wrong Trousers",
      "AlternateTitle": "",
      "TitleArray": [
        "The Wrong Trousers"
      ],
      "Year": "1993",
      "Director": "Nick Park",
      "DirectorArray": [
        "Nick Park"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4367",
      "databaseFilmTitle": "The Year Long Road",
      "FilmTitle": "The Year Long Road",
      "AlternateTitle": "Cesta dugo godinu dana",
      "TitleArray": [
        "The Year Long Road",
        "Cesta dugo godinu dana"
      ],
      "Year": "1958",
      "Director": "Giuseppe de Santis",
      "DirectorArray": [
        "Giuseppe de Santis"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4368",
      "databaseFilmTitle": "The Young Girls of Rochefort",
      "FilmTitle": "The Young Girls of Rochefort",
      "AlternateTitle": "Les demoiselles de Rochefort",
      "TitleArray": [
        "The Young Girls of Rochefort",
        "Les demoiselles de Rochefort"
      ],
      "Year": "1967",
      "Director": "Jacques Demy",
      "DirectorArray": [
        "Jacques Demy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "4369",
      "databaseFilmTitle": "The Young One",
      "FilmTitle": "The Young One",
      "AlternateTitle": "La joven",
      "TitleArray": [
        "The Young One",
        "La joven"
      ],
      "Year": "1960",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4370",
      "databaseFilmTitle": "Thelma & Louise",
      "FilmTitle": "Thelma & Louise",
      "AlternateTitle": "",
      "TitleArray": [
        "Thelma & Louise"
      ],
      "Year": "1991",
      "Director": "Ridley Scott",
      "DirectorArray": [
        "Ridley Scott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4371",
      "databaseFilmTitle": "Them Thar Hills",
      "FilmTitle": "Them Thar Hills",
      "AlternateTitle": "",
      "TitleArray": [
        "Them Thar Hills"
      ],
      "Year": "1934",
      "Director": "Charley Rogers",
      "DirectorArray": [
        "Charley Rogers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4372",
      "databaseFilmTitle": "Themes and Variations",
      "FilmTitle": "Themes and Variations",
      "AlternateTitle": "Thème et variations",
      "TitleArray": [
        "Themes and Variations",
        "Thème et variations"
      ],
      "Year": "1928",
      "Director": "Germaine Dulac",
      "DirectorArray": [
        "Germaine Dulac"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4373",
      "databaseFilmTitle": "There Is No Evil",
      "FilmTitle": "There Is No Evil",
      "AlternateTitle": "Sheytan Vojud Nadarad",
      "TitleArray": [
        "There Is No Evil",
        "Sheytan Vojud Nadarad"
      ],
      "Year": "2020",
      "Director": "Mohammad Rassoulof",
      "DirectorArray": [
        "Mohammad Rassoulof"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4374",
      "databaseFilmTitle": "There Was a Father",
      "FilmTitle": "There Was a Father",
      "AlternateTitle": "Chichi ariki",
      "TitleArray": [
        "There Was a Father",
        "Chichi ariki"
      ],
      "Year": "1942",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4375",
      "databaseFilmTitle": "There Will Be Blood",
      "FilmTitle": "There Will Be Blood",
      "AlternateTitle": "",
      "TitleArray": [
        "There Will Be Blood"
      ],
      "Year": "2007",
      "Director": "Paul Thomas Anderson",
      "DirectorArray": [
        "Paul Thomas Anderson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "123",
      "2022votes": "25"
    },
    {
      "key": "4376",
      "databaseFilmTitle": "There's Always Tomorrow",
      "FilmTitle": "There's Always Tomorrow",
      "AlternateTitle": "",
      "TitleArray": [
        "There's Always Tomorrow"
      ],
      "Year": "1955",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4377",
      "databaseFilmTitle": "There's No Tomorrow",
      "FilmTitle": "There's No Tomorrow",
      "AlternateTitle": "Sans lendemain",
      "TitleArray": [
        "There's No Tomorrow",
        "Sans lendemain"
      ],
      "Year": "1939",
      "Director": "Max Ophüls",
      "DirectorArray": [
        "Max Ophüls"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4378",
      "databaseFilmTitle": "There's Something about Mary",
      "FilmTitle": "There's Something about Mary",
      "AlternateTitle": "",
      "TitleArray": [
        "There's Something about Mary"
      ],
      "Year": "1998",
      "Director": "Bobby Farrelly, Peter Farrelly",
      "DirectorArray": [
        "Bobby Farrelly",
        "Peter Farrelly"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4379",
      "databaseFilmTitle": "Thérèse",
      "FilmTitle": "Thérèse",
      "AlternateTitle": "",
      "TitleArray": [
        "Thérèse"
      ],
      "Year": "1986",
      "Director": "Alain Cavalier",
      "DirectorArray": [
        "Alain Cavalier"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4380",
      "databaseFilmTitle": "They all Laughed",
      "FilmTitle": "They all Laughed",
      "AlternateTitle": "",
      "TitleArray": [
        "They all Laughed"
      ],
      "Year": "1981",
      "Director": "Peter Bogdanovich",
      "DirectorArray": [
        "Peter Bogdanovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4381",
      "databaseFilmTitle": "They Died with Their Boots On",
      "FilmTitle": "They Died with Their Boots On",
      "AlternateTitle": "",
      "TitleArray": [
        "They Died with Their Boots On"
      ],
      "Year": "1941",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4382",
      "databaseFilmTitle": "They Have Changed Their Face",
      "FilmTitle": "They Have Changed Their Face",
      "AlternateTitle": "...Hanno cambiato faccia",
      "TitleArray": [
        "They Have Changed Their Face",
        "...Hanno cambiato faccia"
      ],
      "Year": "1971",
      "Director": "Corrado Farina",
      "DirectorArray": [
        "Corrado Farina"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4383",
      "databaseFilmTitle": "They Live",
      "FilmTitle": "They Live",
      "AlternateTitle": "",
      "TitleArray": [
        "They Live"
      ],
      "Year": "1988",
      "Director": "John Carpenter",
      "DirectorArray": [
        "John Carpenter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4384",
      "databaseFilmTitle": "They Live by Night",
      "FilmTitle": "They Live by Night",
      "AlternateTitle": "",
      "TitleArray": [
        "They Live by Night"
      ],
      "Year": "1948",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4385",
      "databaseFilmTitle": "They Shoot Horses, Don't They?",
      "FilmTitle": "They Shoot Horses, Don't They?",
      "AlternateTitle": "",
      "TitleArray": [
        "They Shoot Horses, Don't They?"
      ],
      "Year": "1969",
      "Director": "Sydney Pollack",
      "DirectorArray": [
        "Sydney Pollack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4386",
      "databaseFilmTitle": "They Were Expendable",
      "FilmTitle": "They Were Expendable",
      "AlternateTitle": "",
      "TitleArray": [
        "They Were Expendable"
      ],
      "Year": "1945",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4387",
      "databaseFilmTitle": "Thief",
      "FilmTitle": "Thief",
      "AlternateTitle": "",
      "TitleArray": [
        "Thief"
      ],
      "Year": "1981",
      "Director": "Michael Mann",
      "DirectorArray": [
        "Michael Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4388",
      "databaseFilmTitle": "Thief or Reality",
      "FilmTitle": "Thief or Reality",
      "AlternateTitle": "Kleftis i I pragmatikotita",
      "TitleArray": [
        "Thief or Reality",
        "Kleftis i I pragmatikotita"
      ],
      "Year": "2001",
      "Director": "Antouanetta Angelidi",
      "DirectorArray": [
        "Antouanetta Angelidi"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4389",
      "databaseFilmTitle": "Things behind the Sun",
      "FilmTitle": "Things behind the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Things behind the Sun"
      ],
      "Year": "2001",
      "Director": "Allison Anders",
      "DirectorArray": [
        "Allison Anders"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4390",
      "databaseFilmTitle": "Think of Me First As a Person",
      "FilmTitle": "Think of Me First As a Person",
      "AlternateTitle": "",
      "TitleArray": [
        "Think of Me First As a Person"
      ],
      "Year": "1975",
      "Director": "George Ingmire",
      "DirectorArray": [
        "George Ingmire"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4391",
      "databaseFilmTitle": "Thirty Two Short Films about Glenn Gould",
      "FilmTitle": "Thirty Two Short Films about Glenn Gould",
      "AlternateTitle": "",
      "TitleArray": [
        "Thirty Two Short Films about Glenn Gould"
      ],
      "Year": "1993",
      "Director": "François Girard",
      "DirectorArray": [
        "François Girard"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4392",
      "databaseFilmTitle": "This Gun for Hire",
      "FilmTitle": "This Gun for Hire",
      "AlternateTitle": "",
      "TitleArray": [
        "This Gun for Hire"
      ],
      "Year": "1942",
      "Director": "Frank Tuttle",
      "DirectorArray": [
        "Frank Tuttle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4393",
      "databaseFilmTitle": "This is England",
      "FilmTitle": "This is England",
      "AlternateTitle": "",
      "TitleArray": [
        "This is England"
      ],
      "Year": "2006",
      "Director": "Shane Meadows",
      "DirectorArray": [
        "Shane Meadows"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4394",
      "databaseFilmTitle": "This Is Not a Burial, It's a Resurrection",
      "FilmTitle": "This Is Not a Burial, It's a Resurrection",
      "AlternateTitle": "",
      "TitleArray": [
        "This Is Not a Burial, It's a Resurrection"
      ],
      "Year": "2019",
      "Director": "Lemohang Jeremiah Mossese",
      "DirectorArray": [
        "Lemohang Jeremiah Mossese"
      ],
      "Country": "Lesotho, South Africa",
      "CountryArray": [
        "Lesotho",
        "South Africa"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4395",
      "databaseFilmTitle": "This Is Not a Film",
      "FilmTitle": "This Is Not a Film",
      "AlternateTitle": "In film nist",
      "TitleArray": [
        "This Is Not a Film",
        "In film nist"
      ],
      "Year": "2011",
      "Director": "Mojtaba Mirtahasebi, Jafar Panahi",
      "DirectorArray": [
        "Mojtaba Mirtahasebi",
        "Jafar Panahi"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4396",
      "databaseFilmTitle": "This Is Spinal Tap",
      "FilmTitle": "This Is Spinal Tap",
      "AlternateTitle": "",
      "TitleArray": [
        "This Is Spinal Tap"
      ],
      "Year": "1984",
      "Director": "Rob Reiner",
      "DirectorArray": [
        "Rob Reiner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4397",
      "databaseFilmTitle": "This Life of Mine",
      "FilmTitle": "This Life of Mine",
      "AlternateTitle": "Wo zhe yi bei zi",
      "TitleArray": [
        "This Life of Mine",
        "Wo zhe yi bei zi"
      ],
      "Year": "1950",
      "Director": "Shi Hui",
      "DirectorArray": [
        "Shi Hui"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4398",
      "databaseFilmTitle": "This Man Must Die",
      "FilmTitle": "This Man Must Die",
      "AlternateTitle": "Que la bête meure",
      "TitleArray": [
        "This Man Must Die",
        "Que la bête meure"
      ],
      "Year": "1969",
      "Director": "Cluade Chabrol",
      "DirectorArray": [
        "Cluade Chabrol"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4399",
      "databaseFilmTitle": "This Sporting Life",
      "FilmTitle": "This Sporting Life",
      "AlternateTitle": "",
      "TitleArray": [
        "This Sporting Life"
      ],
      "Year": "1963",
      "Director": "Linday Anderson",
      "DirectorArray": [
        "Linday Anderson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4400",
      "databaseFilmTitle": "Those of Our Land",
      "FilmTitle": "Those of Our Land",
      "AlternateTitle": "Ceux de chez nous",
      "TitleArray": [
        "Those of Our Land",
        "Ceux de chez nous"
      ],
      "Year": "1915",
      "Director": "Sacha Guitry",
      "DirectorArray": [
        "Sacha Guitry"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4401",
      "databaseFilmTitle": "Those That, at a Distance, Resemble Another",
      "FilmTitle": "Those That, at a Distance, Resemble Another",
      "AlternateTitle": "",
      "TitleArray": [
        "Those That, at a Distance, Resemble Another"
      ],
      "Year": "2019",
      "Director": "Jessica Sarah Rinland",
      "DirectorArray": [
        "Jessica Sarah Rinland"
      ],
      "Country": "United Kingdom, Argentina",
      "CountryArray": [
        "United Kingdom",
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4402",
      "databaseFilmTitle": "Threads",
      "FilmTitle": "Threads",
      "AlternateTitle": "",
      "TitleArray": [
        "Threads"
      ],
      "Year": "1984",
      "Director": "Mick Jackson",
      "DirectorArray": [
        "Mick Jackson"
      ],
      "Country": "United Kingdom, Australia",
      "CountryArray": [
        "United Kingdom",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4403",
      "databaseFilmTitle": "Three Brothers",
      "FilmTitle": "Three Brothers",
      "AlternateTitle": "Tre fratelli",
      "TitleArray": [
        "Three Brothers",
        "Tre fratelli"
      ],
      "Year": "1981",
      "Director": "Francesco Rosi",
      "DirectorArray": [
        "Francesco Rosi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4404",
      "databaseFilmTitle": "Three Colors: Blue",
      "FilmTitle": "Three Colors: Blue",
      "AlternateTitle": "Trois couleurs: bleu",
      "TitleArray": [
        "Three Colors: Blue",
        "Trois couleurs: bleu"
      ],
      "Year": "1993",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4405",
      "databaseFilmTitle": "Three Colors: Red",
      "FilmTitle": "Three Colors: Red",
      "AlternateTitle": "Trois couleurs: rouge",
      "TitleArray": [
        "Three Colors: Red",
        "Trois couleurs: rouge"
      ],
      "Year": "1994",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "France, Switzerland",
      "CountryArray": [
        "France",
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4406",
      "databaseFilmTitle": "Three Colors: White",
      "FilmTitle": "Three Colors: White",
      "AlternateTitle": "Trois couleurs: blanc",
      "TitleArray": [
        "Three Colors: White",
        "Trois couleurs: blanc"
      ],
      "Year": "1994",
      "Director": "Krzysztof Kieślowski",
      "DirectorArray": [
        "Krzysztof Kieślowski"
      ],
      "Country": "France, Poland",
      "CountryArray": [
        "France",
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4407",
      "databaseFilmTitle": "Three Comrades",
      "FilmTitle": "Three Comrades",
      "AlternateTitle": "",
      "TitleArray": [
        "Three Comrades"
      ],
      "Year": "1938",
      "Director": "Frank Borzage",
      "DirectorArray": [
        "Frank Borzage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4408",
      "databaseFilmTitle": "Three Crowns of the Sailor",
      "FilmTitle": "Three Crowns of the Sailor",
      "AlternateTitle": "Les trois couronnes du matelot",
      "TitleArray": [
        "Three Crowns of the Sailor",
        "Les trois couronnes du matelot"
      ],
      "Year": "1983",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4409",
      "databaseFilmTitle": "Three Days of the Condor",
      "FilmTitle": "Three Days of the Condor",
      "AlternateTitle": "",
      "TitleArray": [
        "Three Days of the Condor"
      ],
      "Year": "1975",
      "Director": "Sydney Pollack",
      "DirectorArray": [
        "Sydney Pollack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4410",
      "databaseFilmTitle": "Three Girls Named Anna",
      "FilmTitle": "Three Girls Named Anna",
      "AlternateTitle": "Tri Ane",
      "TitleArray": [
        "Three Girls Named Anna",
        "Tri Ane"
      ],
      "Year": "1959",
      "Director": "Branko Bauer",
      "DirectorArray": [
        "Branko Bauer"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4411",
      "databaseFilmTitle": "Three Kings",
      "FilmTitle": "Three Kings",
      "AlternateTitle": "",
      "TitleArray": [
        "Three Kings"
      ],
      "Year": "1999",
      "Director": "David O. Russell",
      "DirectorArray": [
        "David O. Russell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4412",
      "databaseFilmTitle": "Three Monkeys",
      "FilmTitle": "Three Monkeys",
      "AlternateTitle": "Üç Maymun",
      "TitleArray": [
        "Three Monkeys",
        "Üç Maymun"
      ],
      "Year": "2008",
      "Director": "Nuri Bilge Ceyland",
      "DirectorArray": [
        "Nuri Bilge Ceyland"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4413",
      "databaseFilmTitle": "Three Rooms in Manhattan",
      "FilmTitle": "Three Rooms in Manhattan",
      "AlternateTitle": "Trois chambres à Manhattan",
      "TitleArray": [
        "Three Rooms in Manhattan",
        "Trois chambres à Manhattan"
      ],
      "Year": "1965",
      "Director": "Marcel Carné",
      "DirectorArray": [
        "Marcel Carné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4414",
      "databaseFilmTitle": "Three Sad Tigers",
      "FilmTitle": "Three Sad Tigers",
      "AlternateTitle": "Tres tristes tigres",
      "TitleArray": [
        "Three Sad Tigers",
        "Tres tristes tigres"
      ],
      "Year": "1968",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "Chile",
      "CountryArray": [
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4415",
      "databaseFilmTitle": "Three Songs About Lenin",
      "FilmTitle": "Three Songs About Lenin",
      "AlternateTitle": "",
      "TitleArray": [
        "Three Songs About Lenin"
      ],
      "Year": "1934",
      "Director": "Dziga Vertov",
      "DirectorArray": [
        "Dziga Vertov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4416",
      "databaseFilmTitle": "Three Times",
      "FilmTitle": "Three Times",
      "AlternateTitle": "Zui hao de shi guang",
      "TitleArray": [
        "Three Times",
        "Zui hao de shi guang"
      ],
      "Year": "2005",
      "Director": "Hou Hsiao-hsien",
      "DirectorArray": [
        "Hou Hsiao-hsien"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4417",
      "databaseFilmTitle": "Three Years Without God",
      "FilmTitle": "Three Years Without God",
      "AlternateTitle": "Três Dias Sem Deus",
      "TitleArray": [
        "Three Years Without God",
        "Três Dias Sem Deus"
      ],
      "Year": "1945",
      "Director": "Bárbara Virgínia",
      "DirectorArray": [
        "Bárbara Virgínia"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4418",
      "databaseFilmTitle": "Three, Two, One",
      "FilmTitle": "Three, Two, One",
      "AlternateTitle": "Tatlo, dalawa, isa",
      "TitleArray": [
        "Three, Two, One",
        "Tatlo, dalawa, isa"
      ],
      "Year": "1974",
      "Director": "Lino Brocka",
      "DirectorArray": [
        "Lino Brocka"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4419",
      "databaseFilmTitle": "Throne of Blood",
      "FilmTitle": "Throne of Blood",
      "AlternateTitle": "Kumonosu-jō",
      "TitleArray": [
        "Throne of Blood",
        "Kumonosu-jō"
      ],
      "Year": "1957",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4420",
      "databaseFilmTitle": "Through the Olive Trees",
      "FilmTitle": "Through the Olive Trees",
      "AlternateTitle": "Zīr-e Derakhtān-e Zeytūn",
      "TitleArray": [
        "Through the Olive Trees",
        "Zīr-e Derakhtān-e Zeytūn"
      ],
      "Year": "1994",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4421",
      "databaseFilmTitle": "Throw Away Your Books, Rally in the Streets",
      "FilmTitle": "Throw Away Your Books, Rally in the Streets",
      "AlternateTitle": "Sho o suteyo machi e deyou",
      "TitleArray": [
        "Throw Away Your Books, Rally in the Streets",
        "Sho o suteyo machi e deyou"
      ],
      "Year": "1971",
      "Director": "Shûji Terayama",
      "DirectorArray": [
        "Shûji Terayama"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4422",
      "databaseFilmTitle": "Throw Down",
      "FilmTitle": "Throw Down",
      "AlternateTitle": "Yau doh lung fu bong",
      "TitleArray": [
        "Throw Down",
        "Yau doh lung fu bong"
      ],
      "Year": "2004",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4423",
      "databaseFilmTitle": "Thundercrack!",
      "FilmTitle": "Thundercrack!",
      "AlternateTitle": "",
      "TitleArray": [
        "Thundercrack!"
      ],
      "Year": "1975",
      "Director": "Curt McDowell",
      "DirectorArray": [
        "Curt McDowell"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4424",
      "databaseFilmTitle": "Ticket of No Return",
      "FilmTitle": "Ticket of No Return",
      "AlternateTitle": "Bildnis einer Trinkerin",
      "TitleArray": [
        "Ticket of No Return",
        "Bildnis einer Trinkerin"
      ],
      "Year": "1979",
      "Director": "Ulrike Ottinger",
      "DirectorArray": [
        "Ulrike Ottinger"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4425",
      "databaseFilmTitle": "Tie Xi Qu: West of the Tracks",
      "FilmTitle": "Tie Xi Qu: West of the Tracks",
      "AlternateTitle": "",
      "TitleArray": [
        "Tie Xi Qu: West of the Tracks"
      ],
      "Year": "2002",
      "Director": "Wang Bing",
      "DirectorArray": [
        "Wang Bing"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "4426",
      "databaseFilmTitle": "Tie Xi Qu: West of the Tracks - Part 2: Remnants",
      "FilmTitle": "Tie Xi Qu: West of the Tracks - Part 2: Remnants",
      "AlternateTitle": "Tiexi qu",
      "TitleArray": [
        "Tie Xi Qu: West of the Tracks - Part 2: Remnants",
        "Tiexi qu"
      ],
      "Year": "2002",
      "Director": "Wang Bing",
      "DirectorArray": [
        "Wang Bing"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4427",
      "databaseFilmTitle": "Tigers Are Not Afraid",
      "FilmTitle": "Tigers Are Not Afraid",
      "AlternateTitle": "Vuelven",
      "TitleArray": [
        "Tigers Are Not Afraid",
        "Vuelven"
      ],
      "Year": "2017",
      "Director": "Issa López",
      "DirectorArray": [
        "Issa López"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4428",
      "databaseFilmTitle": "Tih Minh",
      "FilmTitle": "Tih Minh",
      "AlternateTitle": "",
      "TitleArray": [
        "Tih Minh"
      ],
      "Year": "1918",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4429",
      "databaseFilmTitle": "Timbuktu",
      "FilmTitle": "Timbuktu",
      "AlternateTitle": "",
      "TitleArray": [
        "Timbuktu"
      ],
      "Year": "2014",
      "Director": "Abderrahmane Sissako",
      "DirectorArray": [
        "Abderrahmane Sissako"
      ],
      "Country": "Mauritania",
      "CountryArray": [
        "Mauritania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4430",
      "databaseFilmTitle": "Time",
      "FilmTitle": "Time",
      "AlternateTitle": "",
      "TitleArray": [
        "Time"
      ],
      "Year": "2020",
      "Director": "Garrett Bradley",
      "DirectorArray": [
        "Garrett Bradley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4431",
      "databaseFilmTitle": "Time Addiction",
      "FilmTitle": "Time Addiction",
      "AlternateTitle": "Kaal Abhirati",
      "TitleArray": [
        "Time Addiction",
        "Kaal Abhirati"
      ],
      "Year": "1989",
      "Director": "Amitabh Chakraborty",
      "DirectorArray": [
        "Amitabh Chakraborty"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4432",
      "databaseFilmTitle": "Time and Tide",
      "FilmTitle": "Time and Tide",
      "AlternateTitle": "Shun liu ni liu",
      "TitleArray": [
        "Time and Tide",
        "Shun liu ni liu"
      ],
      "Year": "2000",
      "Director": "Tsui Hark",
      "DirectorArray": [
        "Tsui Hark"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4433",
      "databaseFilmTitle": "Time Bandits",
      "FilmTitle": "Time Bandits",
      "AlternateTitle": "",
      "TitleArray": [
        "Time Bandits"
      ],
      "Year": "1981",
      "Director": "Terry Gilliam",
      "DirectorArray": [
        "Terry Gilliam"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4434",
      "databaseFilmTitle": "Time for Revenge",
      "FilmTitle": "Time for Revenge",
      "AlternateTitle": "Tiempo de revancha",
      "TitleArray": [
        "Time for Revenge",
        "Tiempo de revancha"
      ],
      "Year": "1981",
      "Director": "Adolfo Aristarain",
      "DirectorArray": [
        "Adolfo Aristarain"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4435",
      "databaseFilmTitle": "Time Indefinite",
      "FilmTitle": "Time Indefinite",
      "AlternateTitle": "",
      "TitleArray": [
        "Time Indefinite"
      ],
      "Year": "1993",
      "Director": "Ross McElwee",
      "DirectorArray": [
        "Ross McElwee"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4436",
      "databaseFilmTitle": "Time of the Gypsies",
      "FilmTitle": "Time of the Gypsies",
      "AlternateTitle": "Dom za vešanje",
      "TitleArray": [
        "Time of the Gypsies",
        "Dom za vešanje"
      ],
      "Year": "1988",
      "Director": "Emir Kusturica",
      "DirectorArray": [
        "Emir Kusturica"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4437",
      "databaseFilmTitle": "Time of the Leopards",
      "FilmTitle": "Time of the Leopards",
      "AlternateTitle": "Vreme leoparda",
      "TitleArray": [
        "Time of the Leopards",
        "Vreme leoparda"
      ],
      "Year": "1985",
      "Director": "Zdravko Velimirovic",
      "DirectorArray": [
        "Zdravko Velimirovic"
      ],
      "Country": "Mozambique",
      "CountryArray": [
        "Mozambique"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4438",
      "databaseFilmTitle": "Time Regained",
      "FilmTitle": "Time Regained",
      "AlternateTitle": "Le temps retrouvé, d'après l'oeuvre de Marcel Proust",
      "TitleArray": [
        "Time Regained",
        "Le temps retrouvé, d'après l'oeuvre de Marcel Proust"
      ],
      "Year": "1999",
      "Director": "Raúl Ruiz",
      "DirectorArray": [
        "Raúl Ruiz"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4439",
      "databaseFilmTitle": "Time Without Pity",
      "FilmTitle": "Time Without Pity",
      "AlternateTitle": "",
      "TitleArray": [
        "Time Without Pity"
      ],
      "Year": "1957",
      "Director": "Joseph Losey",
      "DirectorArray": [
        "Joseph Losey"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4440",
      "databaseFilmTitle": "Timeless Bottomless Bad Movie",
      "FilmTitle": "Timeless Bottomless Bad Movie",
      "AlternateTitle": "Nappun yeonghwa",
      "TitleArray": [
        "Timeless Bottomless Bad Movie",
        "Nappun yeonghwa"
      ],
      "Year": "1997",
      "Director": "Jang Sun-woo",
      "DirectorArray": [
        "Jang Sun-woo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4441",
      "databaseFilmTitle": "Times and Winds",
      "FilmTitle": "Times and Winds",
      "AlternateTitle": "Beş Vakit",
      "TitleArray": [
        "Times and Winds",
        "Beş Vakit"
      ],
      "Year": "2006",
      "Director": "Reha Erdem",
      "DirectorArray": [
        "Reha Erdem"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4442",
      "databaseFilmTitle": "Tins for India",
      "FilmTitle": "Tins for India",
      "AlternateTitle": "",
      "TitleArray": [
        "Tins for India"
      ],
      "Year": "1941",
      "Director": "Bimal Roy",
      "DirectorArray": [
        "Bimal Roy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4443",
      "databaseFilmTitle": "Tiovivo c. 1950",
      "FilmTitle": "Tiovivo c. 1950",
      "AlternateTitle": "",
      "TitleArray": [
        "Tiovivo c. 1950"
      ],
      "Year": "2004",
      "Director": "José Luis Garci",
      "DirectorArray": [
        "José Luis Garci"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4444",
      "databaseFilmTitle": "Titane",
      "FilmTitle": "Titane",
      "AlternateTitle": "",
      "TitleArray": [
        "Titane"
      ],
      "Year": "2021",
      "Director": "Julia Ducournau",
      "DirectorArray": [
        "Julia Ducournau"
      ],
      "Country": "France, Belgium",
      "CountryArray": [
        "France",
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4445",
      "databaseFilmTitle": "Titanic",
      "FilmTitle": "Titanic",
      "AlternateTitle": "",
      "TitleArray": [
        "Titanic"
      ],
      "Year": "1997",
      "Director": "James Cameron",
      "DirectorArray": [
        "James Cameron"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4446",
      "databaseFilmTitle": "Titicut Follies",
      "FilmTitle": "Titicut Follies",
      "AlternateTitle": "",
      "TitleArray": [
        "Titicut Follies"
      ],
      "Year": "1967",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4447",
      "databaseFilmTitle": "Tlamess",
      "FilmTitle": "Tlamess",
      "AlternateTitle": "",
      "TitleArray": [
        "Tlamess"
      ],
      "Year": "2019",
      "Director": "Ala Eddine Slim",
      "DirectorArray": [
        "Ala Eddine Slim"
      ],
      "Country": "Tunisia",
      "CountryArray": [
        "Tunisia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4448",
      "databaseFilmTitle": "To Be or Not to Be",
      "FilmTitle": "To Be or Not to Be",
      "AlternateTitle": "",
      "TitleArray": [
        "To Be or Not to Be"
      ],
      "Year": "1942",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "114",
      "2022votes": "27"
    },
    {
      "key": "4449",
      "databaseFilmTitle": "To Dream, To Dream",
      "FilmTitle": "To Dream, To Dream",
      "AlternateTitle": "Soñar, soñar",
      "TitleArray": [
        "To Dream, To Dream",
        "Soñar, soñar"
      ],
      "Year": "1976",
      "Director": "Leonardo Favio",
      "DirectorArray": [
        "Leonardo Favio"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4450",
      "databaseFilmTitle": "To Have and Have Not",
      "FilmTitle": "To Have and Have Not",
      "AlternateTitle": "",
      "TitleArray": [
        "To Have and Have Not"
      ],
      "Year": "1944",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4451",
      "databaseFilmTitle": "To Kill a Mockingbird",
      "FilmTitle": "To Kill a Mockingbird",
      "AlternateTitle": "",
      "TitleArray": [
        "To Kill a Mockingbird"
      ],
      "Year": "1962",
      "Director": "Robert Mulligan",
      "DirectorArray": [
        "Robert Mulligan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4452",
      "databaseFilmTitle": "To Live",
      "FilmTitle": "To Live",
      "AlternateTitle": "Huozhe",
      "TitleArray": [
        "To Live",
        "Huozhe"
      ],
      "Year": "1994",
      "Director": "Zhang Yimou",
      "DirectorArray": [
        "Zhang Yimou"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4453",
      "databaseFilmTitle": "To Parsifal",
      "FilmTitle": "To Parsifal",
      "AlternateTitle": "",
      "TitleArray": [
        "To Parsifal"
      ],
      "Year": "1963",
      "Director": "Bruce Baillie",
      "DirectorArray": [
        "Bruce Baillie"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4454",
      "databaseFilmTitle": "To Sleep with Anger",
      "FilmTitle": "To Sleep with Anger",
      "AlternateTitle": "",
      "TitleArray": [
        "To Sleep with Anger"
      ],
      "Year": "1990",
      "Director": "Charles Burnett",
      "DirectorArray": [
        "Charles Burnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4455",
      "databaseFilmTitle": "To the Left of the Father",
      "FilmTitle": "To the Left of the Father",
      "AlternateTitle": "Lavoura arcaica",
      "TitleArray": [
        "To the Left of the Father",
        "Lavoura arcaica"
      ],
      "Year": "2001",
      "Director": "Luiz Fernando Carvalho",
      "DirectorArray": [
        "Luiz Fernando Carvalho"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4456",
      "databaseFilmTitle": "To the Sea",
      "FilmTitle": "To the Sea",
      "AlternateTitle": "Vers la mer",
      "TitleArray": [
        "To the Sea",
        "Vers la mer"
      ],
      "Year": "1999",
      "Director": "Annik Leroy",
      "DirectorArray": [
        "Annik Leroy"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4457",
      "databaseFilmTitle": "Tobacco Embers",
      "FilmTitle": "Tobacco Embers",
      "AlternateTitle": "Tambaku Chaakila Oob Ali",
      "TitleArray": [
        "Tobacco Embers",
        "Tambaku Chaakila Oob Ali"
      ],
      "Year": "1982",
      "Director": "Yugantar",
      "DirectorArray": [
        "Yugantar"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4458",
      "databaseFilmTitle": "Toby Dammit",
      "FilmTitle": "Toby Dammit",
      "AlternateTitle": "",
      "TitleArray": [
        "Toby Dammit"
      ],
      "Year": "1968",
      "Director": "Federico Fellini",
      "DirectorArray": [
        "Federico Fellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4459",
      "databaseFilmTitle": "Tokyo Chorus",
      "FilmTitle": "Tokyo Chorus",
      "AlternateTitle": "Tōkyō no kōrasu",
      "TitleArray": [
        "Tokyo Chorus",
        "Tōkyō no kōrasu"
      ],
      "Year": "1931",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4460",
      "databaseFilmTitle": "Tokyo Olympiad",
      "FilmTitle": "Tokyo Olympiad",
      "AlternateTitle": "Tôkyô orinpikku",
      "TitleArray": [
        "Tokyo Olympiad",
        "Tôkyô orinpikku"
      ],
      "Year": "1965",
      "Director": "Kon Ichikawa",
      "DirectorArray": [
        "Kon Ichikawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4461",
      "databaseFilmTitle": "Tokyo Story",
      "FilmTitle": "Tokyo Story",
      "AlternateTitle": "Tôkyô monogatari",
      "TitleArray": [
        "Tokyo Story",
        "Tôkyô monogatari"
      ],
      "Year": "1953",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "25",
      "1972votes": "5",
      "1982rank": "17",
      "1982votes": "8",
      "1992rank": "3",
      "1992votes": "22",
      "2002rank": "4",
      "2002votes": "22",
      "2012rank": "3",
      "2012votes": "107",
      "2022rank": "4",
      "2022votes": "145"
    },
    {
      "key": "4462",
      "databaseFilmTitle": "Tokyo Twilight",
      "FilmTitle": "Tokyo Twilight",
      "AlternateTitle": "Tōkyō boshoku",
      "TitleArray": [
        "Tokyo Twilight",
        "Tōkyō boshoku"
      ],
      "Year": "1957",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4463",
      "databaseFilmTitle": "Tol'able David",
      "FilmTitle": "Tol'able David",
      "AlternateTitle": "",
      "TitleArray": [
        "Tol'able David"
      ],
      "Year": "1921",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4464",
      "databaseFilmTitle": "Tom Jones",
      "FilmTitle": "Tom Jones",
      "AlternateTitle": "",
      "TitleArray": [
        "Tom Jones"
      ],
      "Year": "1963",
      "Director": "Tony Richardson",
      "DirectorArray": [
        "Tony Richardson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4465",
      "databaseFilmTitle": "Tom, Tom, the Piper's Son",
      "FilmTitle": "Tom, Tom, the Piper's Son",
      "AlternateTitle": "",
      "TitleArray": [
        "Tom, Tom, the Piper's Son"
      ],
      "Year": "1969",
      "Director": "Ken Jacobs",
      "DirectorArray": [
        "Ken Jacobs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4466",
      "databaseFilmTitle": "Tomboy",
      "FilmTitle": "Tomboy",
      "AlternateTitle": "",
      "TitleArray": [
        "Tomboy"
      ],
      "Year": "2011",
      "Director": "Céline Sciamma",
      "DirectorArray": [
        "Céline Sciamma"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4467",
      "databaseFilmTitle": "Tomorrow Tripoli",
      "FilmTitle": "Tomorrow Tripoli",
      "AlternateTitle": "",
      "TitleArray": [
        "Tomorrow Tripoli"
      ],
      "Year": "2014",
      "Director": "Florent Marcie",
      "DirectorArray": [
        "Florent Marcie"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4468",
      "databaseFilmTitle": "Tomorrow's Promise",
      "FilmTitle": "Tomorrow's Promise",
      "AlternateTitle": "",
      "TitleArray": [
        "Tomorrow's Promise"
      ],
      "Year": "1967",
      "Director": "Edward Owens",
      "DirectorArray": [
        "Edward Owens"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4469",
      "databaseFilmTitle": "Tongpan",
      "FilmTitle": "Tongpan",
      "AlternateTitle": "",
      "TitleArray": [
        "Tongpan"
      ],
      "Year": "1977",
      "Director": "Euthana Mukdasanit, Surachai Chantimatorn",
      "DirectorArray": [
        "Euthana Mukdasanit",
        "Surachai Chantimatorn"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4470",
      "databaseFilmTitle": "Tongues Untied",
      "FilmTitle": "Tongues Untied",
      "AlternateTitle": "",
      "TitleArray": [
        "Tongues Untied"
      ],
      "Year": "1989",
      "Director": "Marlon Riggs",
      "DirectorArray": [
        "Marlon Riggs"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "4471",
      "databaseFilmTitle": "Toni",
      "FilmTitle": "Toni",
      "AlternateTitle": "",
      "TitleArray": [
        "Toni"
      ],
      "Year": "1935",
      "Director": "Jean Renoir",
      "DirectorArray": [
        "Jean Renoir"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4472",
      "databaseFilmTitle": "Toni Erdmann",
      "FilmTitle": "Toni Erdmann",
      "AlternateTitle": "",
      "TitleArray": [
        "Toni Erdmann"
      ],
      "Year": "2016",
      "Director": "Maren Ade",
      "DirectorArray": [
        "Maren Ade"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "4473",
      "databaseFilmTitle": "Tonsler Park",
      "FilmTitle": "Tonsler Park",
      "AlternateTitle": "",
      "TitleArray": [
        "Tonsler Park"
      ],
      "Year": "2017",
      "Director": "Kevin Jermone Everson",
      "DirectorArray": [
        "Kevin Jermone Everson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4474",
      "databaseFilmTitle": "Too Early, Too Late",
      "FilmTitle": "Too Early, Too Late",
      "AlternateTitle": "Trop tôt, trop tard",
      "TitleArray": [
        "Too Early, Too Late",
        "Trop tôt, trop tard"
      ],
      "Year": "1982",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Egypt, France",
      "CountryArray": [
        "Egypt",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4475",
      "databaseFilmTitle": "Toomelah",
      "FilmTitle": "Toomelah",
      "AlternateTitle": "",
      "TitleArray": [
        "Toomelah"
      ],
      "Year": "2011",
      "Director": "Ivan Sen",
      "DirectorArray": [
        "Ivan Sen"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4476",
      "databaseFilmTitle": "Tootsie",
      "FilmTitle": "Tootsie",
      "AlternateTitle": "",
      "TitleArray": [
        "Tootsie"
      ],
      "Year": "1982",
      "Director": "Sydney Pollack",
      "DirectorArray": [
        "Sydney Pollack"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4477",
      "databaseFilmTitle": "Top Hat",
      "FilmTitle": "Top Hat",
      "AlternateTitle": "",
      "TitleArray": [
        "Top Hat"
      ],
      "Year": "1935",
      "Director": "Mark Sandrich",
      "DirectorArray": [
        "Mark Sandrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4478",
      "databaseFilmTitle": "Top of the Lake",
      "FilmTitle": "Top of the Lake",
      "AlternateTitle": "",
      "TitleArray": [
        "Top of the Lake"
      ],
      "Year": "2013",
      "Director": "Jane Campion, Garth Davis",
      "DirectorArray": [
        "Jane Campion",
        "Garth Davis"
      ],
      "Country": "New Zealand, Australia",
      "CountryArray": [
        "New Zealand",
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4479",
      "databaseFilmTitle": "Top Secret!",
      "FilmTitle": "Top Secret!",
      "AlternateTitle": "",
      "TitleArray": [
        "Top Secret!"
      ],
      "Year": "1984",
      "Director": "Jim Abrahams, David Zucker, Jerry Zucker",
      "DirectorArray": [
        "Jim Abrahams",
        "David Zucker",
        "Jerry Zucker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4480",
      "databaseFilmTitle": "Topaz",
      "FilmTitle": "Topaz",
      "AlternateTitle": "",
      "TitleArray": [
        "Topaz"
      ],
      "Year": "1969",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4481",
      "databaseFilmTitle": "Topos",
      "FilmTitle": "Topos",
      "AlternateTitle": "",
      "TitleArray": [
        "Topos"
      ],
      "Year": "1985",
      "Director": "Antouanetta Angelidi",
      "DirectorArray": [
        "Antouanetta Angelidi"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4482",
      "databaseFilmTitle": "Topsy-Turvy",
      "FilmTitle": "Topsy-Turvy",
      "AlternateTitle": "",
      "TitleArray": [
        "Topsy-Turvy"
      ],
      "Year": "1999",
      "Director": "Mike Leigh",
      "DirectorArray": [
        "Mike Leigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4483",
      "databaseFilmTitle": "Torment",
      "FilmTitle": "Torment",
      "AlternateTitle": "Hets",
      "TitleArray": [
        "Torment",
        "Hets"
      ],
      "Year": "1944",
      "Director": "Alf Sjöberg",
      "DirectorArray": [
        "Alf Sjöberg"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4484",
      "databaseFilmTitle": "Torneranno i prati",
      "FilmTitle": "Torneranno i prati",
      "AlternateTitle": "",
      "TitleArray": [
        "Torneranno i prati"
      ],
      "Year": "2014",
      "Director": "Ermanno Olmi",
      "DirectorArray": [
        "Ermanno Olmi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4485",
      "databaseFilmTitle": "Torre Bela",
      "FilmTitle": "Torre Bela",
      "AlternateTitle": "",
      "TitleArray": [
        "Torre Bela"
      ],
      "Year": "1975",
      "Director": "Thomas Harlan, Jacques d'Arthuys, Anna Devoto, Luisa Orioli",
      "DirectorArray": [
        "Thomas Harlan",
        "Jacques d'Arthuys",
        "Anna Devoto",
        "Luisa Orioli"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4486",
      "databaseFilmTitle": "Torture Dungeon",
      "FilmTitle": "Torture Dungeon",
      "AlternateTitle": "",
      "TitleArray": [
        "Torture Dungeon"
      ],
      "Year": "1970",
      "Director": "Andy Milligan",
      "DirectorArray": [
        "Andy Milligan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4487",
      "databaseFilmTitle": "Toss Me a Dime",
      "FilmTitle": "Toss Me a Dime",
      "AlternateTitle": "Tire dié",
      "TitleArray": [
        "Toss Me a Dime",
        "Tire dié"
      ],
      "Year": "1960",
      "Director": "Fernando Birri",
      "DirectorArray": [
        "Fernando Birri"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4488",
      "databaseFilmTitle": "Toto in Color",
      "FilmTitle": "Toto in Color",
      "AlternateTitle": "Totò a colori",
      "TitleArray": [
        "Toto in Color",
        "Totò a colori"
      ],
      "Year": "1953",
      "Director": "Steno",
      "DirectorArray": [
        "Steno"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4489",
      "databaseFilmTitle": "Toto Who Lived Twice",
      "FilmTitle": "Toto Who Lived Twice",
      "AlternateTitle": "Totò che visse due volte",
      "TitleArray": [
        "Toto Who Lived Twice",
        "Totò che visse due volte"
      ],
      "Year": "1998",
      "Director": "Daniele Ciprì, Franco Maresco",
      "DirectorArray": [
        "Daniele Ciprì",
        "Franco Maresco"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4490",
      "databaseFilmTitle": "Touch of Evil",
      "FilmTitle": "Touch of Evil",
      "AlternateTitle": "",
      "TitleArray": [
        "Touch of Evil"
      ],
      "Year": "1958",
      "Director": "Orson Welles",
      "DirectorArray": [
        "Orson Welles"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "17",
      "1982votes": "8",
      "1992rank": "31",
      "1992votes": "6",
      "2002rank": "16",
      "2002votes": "11",
      "2012rank": "57",
      "2012votes": "26",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "4491",
      "databaseFilmTitle": "Touchez pas au grisbi",
      "FilmTitle": "Touchez pas au grisbi",
      "AlternateTitle": "",
      "TitleArray": [
        "Touchez pas au grisbi"
      ],
      "Year": "1954",
      "Director": "Jacques Becker",
      "DirectorArray": [
        "Jacques Becker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4492",
      "databaseFilmTitle": "Touching the Void",
      "FilmTitle": "Touching the Void",
      "AlternateTitle": "",
      "TitleArray": [
        "Touching the Void"
      ],
      "Year": "2003",
      "Director": "Kevin Macdonald",
      "DirectorArray": [
        "Kevin Macdonald"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4493",
      "databaseFilmTitle": "Touki Bouki",
      "FilmTitle": "Touki Bouki",
      "AlternateTitle": "",
      "TitleArray": [
        "Touki Bouki"
      ],
      "Year": "1973",
      "Director": "Djibril Diop Mambéty",
      "DirectorArray": [
        "Djibril Diop Mambéty"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "66",
      "2022votes": "39"
    },
    {
      "key": "4494",
      "databaseFilmTitle": "Tout va bien",
      "FilmTitle": "Tout va bien",
      "AlternateTitle": "",
      "TitleArray": [
        "Tout va bien"
      ],
      "Year": "1972",
      "Director": "Jean-Luc Godard, Jean-Pierre Gorin, Groupe Dziga Vertov",
      "DirectorArray": [
        "Jean-Luc Godard",
        "Jean-Pierre Gorin",
        "Groupe Dziga Vertov"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4495",
      "databaseFilmTitle": "Toute une nuit",
      "FilmTitle": "Toute une nuit",
      "AlternateTitle": "",
      "TitleArray": [
        "Toute une nuit"
      ],
      "Year": "1982",
      "Director": "Chantal Akerman",
      "DirectorArray": [
        "Chantal Akerman"
      ],
      "Country": "Belgium, France",
      "CountryArray": [
        "Belgium",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4496",
      "databaseFilmTitle": "Towards the Sun",
      "FilmTitle": "Towards the Sun",
      "AlternateTitle": "",
      "TitleArray": [
        "Towards the Sun"
      ],
      "Year": "2018",
      "Director": "Nour Ouayda",
      "DirectorArray": [
        "Nour Ouayda"
      ],
      "Country": "Lebanon",
      "CountryArray": [
        "Lebanon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4497",
      "databaseFilmTitle": "Toy Story",
      "FilmTitle": "Toy Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Toy Story"
      ],
      "Year": "1995",
      "Director": "John Lasseter",
      "DirectorArray": [
        "John Lasseter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4498",
      "databaseFilmTitle": "Toy Story 2",
      "FilmTitle": "Toy Story 2",
      "AlternateTitle": "",
      "TitleArray": [
        "Toy Story 2"
      ],
      "Year": "1999",
      "Director": "John Lasseter",
      "DirectorArray": [
        "John Lasseter"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4499",
      "databaseFilmTitle": "Toy Story 3",
      "FilmTitle": "Toy Story 3",
      "AlternateTitle": "",
      "TitleArray": [
        "Toy Story 3"
      ],
      "Year": "2010",
      "Director": "Lee Unkrich",
      "DirectorArray": [
        "Lee Unkrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4500",
      "databaseFilmTitle": "Traces",
      "FilmTitle": "Traces",
      "AlternateTitle": "Wechma",
      "TitleArray": [
        "Traces",
        "Wechma"
      ],
      "Year": "1971",
      "Director": "Hamid Benani",
      "DirectorArray": [
        "Hamid Benani"
      ],
      "Country": "Morocco",
      "CountryArray": [
        "Morocco"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4501",
      "databaseFilmTitle": "Trade Tattoo",
      "FilmTitle": "Trade Tattoo",
      "AlternateTitle": "",
      "TitleArray": [
        "Trade Tattoo"
      ],
      "Year": "1937",
      "Director": "Len Lye",
      "DirectorArray": [
        "Len Lye"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4502",
      "databaseFilmTitle": "Traffic",
      "FilmTitle": "Traffic",
      "AlternateTitle": "",
      "TitleArray": [
        "Traffic"
      ],
      "Year": "2000",
      "Director": "Steven Soderbergh",
      "DirectorArray": [
        "Steven Soderbergh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4503",
      "databaseFilmTitle": "Traffic in Souls",
      "FilmTitle": "Traffic in Souls",
      "AlternateTitle": "",
      "TitleArray": [
        "Traffic in Souls"
      ],
      "Year": "1913",
      "Director": "George Loane Tucker",
      "DirectorArray": [
        "George Loane Tucker"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4504",
      "databaseFilmTitle": "Tragedy of a Ridiculous Man",
      "FilmTitle": "Tragedy of a Ridiculous Man",
      "AlternateTitle": "La tragedia di un uoma ridicolo",
      "TitleArray": [
        "Tragedy of a Ridiculous Man",
        "La tragedia di un uoma ridicolo"
      ],
      "Year": "1981",
      "Director": "Bernardo Bertolucci",
      "DirectorArray": [
        "Bernardo Bertolucci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4505",
      "databaseFilmTitle": "Train of Shadows",
      "FilmTitle": "Train of Shadows",
      "AlternateTitle": "Tren de sombras",
      "TitleArray": [
        "Train of Shadows",
        "Tren de sombras"
      ],
      "Year": "1997",
      "Director": "José Luis Guerín",
      "DirectorArray": [
        "José Luis Guerín"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4506",
      "databaseFilmTitle": "Train to Busan",
      "FilmTitle": "Train to Busan",
      "AlternateTitle": "Busanhaeng",
      "TitleArray": [
        "Train to Busan",
        "Busanhaeng"
      ],
      "Year": "2016",
      "Director": "Yeon Sang-ho",
      "DirectorArray": [
        "Yeon Sang-ho"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4507",
      "databaseFilmTitle": "Training Day",
      "FilmTitle": "Training Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Training Day"
      ],
      "Year": "2001",
      "Director": "Antoine Fuqua",
      "DirectorArray": [
        "Antoine Fuqua"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4508",
      "databaseFilmTitle": "Trainspotting",
      "FilmTitle": "Trainspotting",
      "AlternateTitle": "",
      "TitleArray": [
        "Trainspotting"
      ],
      "Year": "1996",
      "Director": "Danny Boyle",
      "DirectorArray": [
        "Danny Boyle"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4509",
      "databaseFilmTitle": "Trans-Europ-Express",
      "FilmTitle": "Trans-Europ-Express",
      "AlternateTitle": "",
      "TitleArray": [
        "Trans-Europ-Express"
      ],
      "Year": "1966",
      "Director": "Alain Robbe-Grillet",
      "DirectorArray": [
        "Alain Robbe-Grillet"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4510",
      "databaseFilmTitle": "Trás-os-Montes",
      "FilmTitle": "Trás-os-Montes",
      "AlternateTitle": "",
      "TitleArray": [
        "Trás-os-Montes"
      ],
      "Year": "1976",
      "Director": "António Reis, Margarida Cordeiro",
      "DirectorArray": [
        "António Reis",
        "Margarida Cordeiro"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "292",
      "2022votes": "10"
    },
    {
      "key": "4511",
      "databaseFilmTitle": "Trasferimento di modulazione",
      "FilmTitle": "Trasferimento di modulazione",
      "AlternateTitle": "",
      "TitleArray": [
        "Trasferimento di modulazione"
      ],
      "Year": "1969",
      "Director": "Piero Bargellini",
      "DirectorArray": [
        "Piero Bargellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4512",
      "databaseFilmTitle": "Trash",
      "FilmTitle": "Trash",
      "AlternateTitle": "",
      "TitleArray": [
        "Trash"
      ],
      "Year": "1970",
      "Director": "Paul Morrissey",
      "DirectorArray": [
        "Paul Morrissey"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4513",
      "databaseFilmTitle": "Trash Humpers",
      "FilmTitle": "Trash Humpers",
      "AlternateTitle": "",
      "TitleArray": [
        "Trash Humpers"
      ],
      "Year": "2009",
      "Director": "Harmony Korine",
      "DirectorArray": [
        "Harmony Korine"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4514",
      "databaseFilmTitle": "Traveling While Black",
      "FilmTitle": "Traveling While Black",
      "AlternateTitle": "",
      "TitleArray": [
        "Traveling While Black"
      ],
      "Year": "2019",
      "Director": "Roger Ross Williams, Félix Lajeunesse, Paul Raphaël, Ayesha Nadarajah",
      "DirectorArray": [
        "Roger Ross Williams",
        "Félix Lajeunesse",
        "Paul Raphaël",
        "Ayesha Nadarajah"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4515",
      "databaseFilmTitle": "Traveling While Black",
      "FilmTitle": "Travelling While Black",
      "AlternateTitle": "",
      "TitleArray": [
        "Travelling While Black"
      ],
      "Year": "2019",
      "Director": "Roger Ross Williams",
      "DirectorArray": [
        "Roger Ross Williams"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4516",
      "databaseFilmTitle": "Travelling Warrior",
      "FilmTitle": "Travelling Warrior",
      "AlternateTitle": "Reisender Krieger",
      "TitleArray": [
        "Travelling Warrior",
        "Reisender Krieger"
      ],
      "Year": "1981",
      "Director": "Christian Schocher",
      "DirectorArray": [
        "Christian Schocher"
      ],
      "Country": "Switzerland",
      "CountryArray": [
        "Switzerland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4517",
      "databaseFilmTitle": "Traviata '53",
      "FilmTitle": "Traviata '53",
      "AlternateTitle": "",
      "TitleArray": [
        "Traviata '53"
      ],
      "Year": "1953",
      "Director": "Vittorio Cottafavi",
      "DirectorArray": [
        "Vittorio Cottafavi"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4518",
      "databaseFilmTitle": "Travolta et Moi",
      "FilmTitle": "Travolta et Moi",
      "AlternateTitle": "Travolta and Me",
      "TitleArray": [
        "Travolta et Moi",
        "Travolta and Me"
      ],
      "Year": "1993",
      "Director": "Patricia Mazuy",
      "DirectorArray": [
        "Patricia Mazuy"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4519",
      "databaseFilmTitle": "Trees Lounge",
      "FilmTitle": "Trees Lounge",
      "AlternateTitle": "",
      "TitleArray": [
        "Trees Lounge"
      ],
      "Year": "1996",
      "Director": "Steven Buscemi",
      "DirectorArray": [
        "Steven Buscemi"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4520",
      "databaseFilmTitle": "Triangle of Sadness",
      "FilmTitle": "Triangle of Sadness",
      "AlternateTitle": "",
      "TitleArray": [
        "Triangle of Sadness"
      ],
      "Year": "2022",
      "Director": "Ruben Östlund",
      "DirectorArray": [
        "Ruben Östlund"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4521",
      "databaseFilmTitle": "Trikal",
      "FilmTitle": "Trikal",
      "AlternateTitle": "Past, Present, Future",
      "TitleArray": [
        "Trikal",
        "Past, Present, Future"
      ],
      "Year": "1985",
      "Director": "Shyam Benegal",
      "DirectorArray": [
        "Shyam Benegal"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4522",
      "databaseFilmTitle": "Triple agent",
      "FilmTitle": "Triple agent",
      "AlternateTitle": "",
      "TitleArray": [
        "Triple agent"
      ],
      "Year": "2004",
      "Director": "Éric Rohmer",
      "DirectorArray": [
        "Éric Rohmer"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4523",
      "databaseFilmTitle": "Tristana",
      "FilmTitle": "Tristana",
      "AlternateTitle": "",
      "TitleArray": [
        "Tristana"
      ],
      "Year": "1970",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "32",
      "1972votes": "4",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "4524",
      "databaseFilmTitle": "Tristram Shandy: A Cock and Bull Story",
      "FilmTitle": "Tristram Shandy: A Cock and Bull Story",
      "AlternateTitle": "",
      "TitleArray": [
        "Tristram Shandy: A Cock and Bull Story"
      ],
      "Year": "2005",
      "Director": "Michael Winterbottom",
      "DirectorArray": [
        "Michael Winterbottom"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4525",
      "databaseFilmTitle": "Triumph of the Will",
      "FilmTitle": "Triumph of the Will",
      "AlternateTitle": "Triumph des Willens",
      "TitleArray": [
        "Triumph of the Will",
        "Triumph des Willens"
      ],
      "Year": "1935",
      "Director": "Leni Riefenstahl",
      "DirectorArray": [
        "Leni Riefenstahl"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4526",
      "databaseFilmTitle": "Trobriand Cricket",
      "FilmTitle": "Trobriand Cricket",
      "AlternateTitle": "",
      "TitleArray": [
        "Trobriand Cricket"
      ],
      "Year": "1975",
      "Director": "Gary Kildea, Jerry Leach",
      "DirectorArray": [
        "Gary Kildea",
        "Jerry Leach"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4527",
      "databaseFilmTitle": "Tron",
      "FilmTitle": "Tron",
      "AlternateTitle": "",
      "TitleArray": [
        "Tron"
      ],
      "Year": "1982",
      "Director": "Steven Lisberger",
      "DirectorArray": [
        "Steven Lisberger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4528",
      "databaseFilmTitle": "Tropical Malady",
      "FilmTitle": "Tropical Malady",
      "AlternateTitle": "Sud Pralad",
      "TitleArray": [
        "Tropical Malady",
        "Sud Pralad"
      ],
      "Year": "2004",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "128",
      "2012votes": "13",
      "2022rank": "95",
      "2022votes": "31"
    },
    {
      "key": "4529",
      "databaseFilmTitle": "Trouble Every Day",
      "FilmTitle": "Trouble Every Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Trouble Every Day"
      ],
      "Year": "2001",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "320",
      "2022votes": "9"
    },
    {
      "key": "4530",
      "databaseFilmTitle": "Trouble in Mind",
      "FilmTitle": "Trouble in Mind",
      "AlternateTitle": "",
      "TitleArray": [
        "Trouble in Mind"
      ],
      "Year": "1985",
      "Director": "Alan Rudolph",
      "DirectorArray": [
        "Alan Rudolph"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4531",
      "databaseFilmTitle": "Trouble in Paradise",
      "FilmTitle": "Trouble in Paradise",
      "AlternateTitle": "",
      "TitleArray": [
        "Trouble in Paradise"
      ],
      "Year": "1932",
      "Director": "Ernst Lubitsch",
      "DirectorArray": [
        "Ernst Lubitsch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "41",
      "1992votes": "5",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "117",
      "2012votes": "14",
      "2022rank": "136",
      "2022votes": "21"
    },
    {
      "key": "4532",
      "databaseFilmTitle": "True Confessions",
      "FilmTitle": "True Confessions",
      "AlternateTitle": "",
      "TitleArray": [
        "True Confessions"
      ],
      "Year": "1981",
      "Director": "Ulu Grosbard",
      "DirectorArray": [
        "Ulu Grosbard"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4533",
      "databaseFilmTitle": "True Heart Susie",
      "FilmTitle": "True Heart Susie",
      "AlternateTitle": "",
      "TitleArray": [
        "True Heart Susie"
      ],
      "Year": "1919",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "47",
      "1962votes": "2",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4534",
      "databaseFilmTitle": "True Stories",
      "FilmTitle": "True Stories",
      "AlternateTitle": "",
      "TitleArray": [
        "True Stories"
      ],
      "Year": "1986",
      "Director": "David Byrne",
      "DirectorArray": [
        "David Byrne"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4535",
      "databaseFilmTitle": "Truth",
      "FilmTitle": "Truth",
      "AlternateTitle": "Satya",
      "TitleArray": [
        "Truth",
        "Satya"
      ],
      "Year": "1998",
      "Director": "Ram Gopal Varma",
      "DirectorArray": [
        "Ram Gopal Varma"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4536",
      "databaseFilmTitle": "Trying to Kiss the Moon",
      "FilmTitle": "Trying to Kiss the Moon",
      "AlternateTitle": "",
      "TitleArray": [
        "Trying to Kiss the Moon"
      ],
      "Year": "1994",
      "Director": "Stephen Dwoskin",
      "DirectorArray": [
        "Stephen Dwoskin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4537",
      "databaseFilmTitle": "Tumbbad",
      "FilmTitle": "Tumbbad",
      "AlternateTitle": "",
      "TitleArray": [
        "Tumbbad"
      ],
      "Year": "2018",
      "Director": "Rahi Anil Barve",
      "DirectorArray": [
        "Rahi Anil Barve"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4538",
      "databaseFilmTitle": "Tunde's Film",
      "FilmTitle": "Tunde's Film",
      "AlternateTitle": "",
      "TitleArray": [
        "Tunde's Film"
      ],
      "Year": "1973",
      "Director": "Maggie Pinhorn, Tunde Ikoli",
      "DirectorArray": [
        "Maggie Pinhorn",
        "Tunde Ikoli"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4539",
      "databaseFilmTitle": "Tuning the Instruments",
      "FilmTitle": "Tuning the Instruments",
      "AlternateTitle": "Strojenie instrumentów",
      "TitleArray": [
        "Tuning the Instruments",
        "Strojenie instrumentów"
      ],
      "Year": "2000",
      "Director": "Jerzy Kucia",
      "DirectorArray": [
        "Jerzy Kucia"
      ],
      "Country": "Poland",
      "CountryArray": [
        "Poland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4540",
      "databaseFilmTitle": "Turkish Delight",
      "FilmTitle": "Turkish Delight",
      "AlternateTitle": "Turks fruit",
      "TitleArray": [
        "Turkish Delight",
        "Turks fruit"
      ],
      "Year": "1973",
      "Director": "Paul Verhoeven",
      "DirectorArray": [
        "Paul Verhoeven"
      ],
      "Country": "Netherlands",
      "CountryArray": [
        "Netherlands"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4541",
      "databaseFilmTitle": "Turksib",
      "FilmTitle": "Turksib",
      "AlternateTitle": "",
      "TitleArray": [
        "Turksib"
      ],
      "Year": "1929",
      "Director": "Victor Turin",
      "DirectorArray": [
        "Victor Turin"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4542",
      "databaseFilmTitle": "Turtles Can Fly",
      "FilmTitle": "Turtles Can Fly",
      "AlternateTitle": "Lakposhtha parvaz mikonand",
      "TitleArray": [
        "Turtles Can Fly",
        "Lakposhtha parvaz mikonand"
      ],
      "Year": "2004",
      "Director": "Bahman Ghobadi",
      "DirectorArray": [
        "Bahman Ghobadi"
      ],
      "Country": "Iraq",
      "CountryArray": [
        "Iraq"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4543",
      "databaseFilmTitle": "Turumba",
      "FilmTitle": "Turumba",
      "AlternateTitle": "",
      "TitleArray": [
        "Turumba"
      ],
      "Year": "1981",
      "Director": "Kidlat Tahimik",
      "DirectorArray": [
        "Kidlat Tahimik"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4544",
      "databaseFilmTitle": "Twelve O'Clock High",
      "FilmTitle": "Twelve O'Clock High",
      "AlternateTitle": "",
      "TitleArray": [
        "Twelve O'Clock High"
      ],
      "Year": "1949",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4545",
      "databaseFilmTitle": "Twentieth Century",
      "FilmTitle": "Twentieth Century",
      "AlternateTitle": "",
      "TitleArray": [
        "Twentieth Century"
      ],
      "Year": "1934",
      "Director": "Howard Hawks",
      "DirectorArray": [
        "Howard Hawks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4546",
      "databaseFilmTitle": "Twenty Days Without War",
      "FilmTitle": "Twenty Days Without War",
      "AlternateTitle": "",
      "TitleArray": [
        "Twenty Days Without War"
      ],
      "Year": "1977",
      "Director": "Aleksei German",
      "DirectorArray": [
        "Aleksei German"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4547",
      "databaseFilmTitle": "Twenty Years Later",
      "FilmTitle": "Twenty Years Later",
      "AlternateTitle": "Cabra marcado para morrer",
      "TitleArray": [
        "Twenty Years Later",
        "Cabra marcado para morrer"
      ],
      "Year": "1984",
      "Director": "Eduardo Coutinho",
      "DirectorArray": [
        "Eduardo Coutinho"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "4548",
      "databaseFilmTitle": "Twice a Man",
      "FilmTitle": "Twice a Man",
      "AlternateTitle": "",
      "TitleArray": [
        "Twice a Man"
      ],
      "Year": "1963",
      "Director": "Gregory J. Markopoulos",
      "DirectorArray": [
        "Gregory J. Markopoulos"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4549",
      "databaseFilmTitle": "Twilight",
      "FilmTitle": "Twilight",
      "AlternateTitle": "Szürkület",
      "TitleArray": [
        "Twilight",
        "Szürkület"
      ],
      "Year": "1990",
      "Director": "György Fehér",
      "DirectorArray": [
        "György Fehér"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4550",
      "databaseFilmTitle": "Twilight City",
      "FilmTitle": "Twilight City",
      "AlternateTitle": "",
      "TitleArray": [
        "Twilight City"
      ],
      "Year": "1989",
      "Director": "Reece Auguistine",
      "DirectorArray": [
        "Reece Auguistine"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4551",
      "databaseFilmTitle": "Twin Peaks",
      "FilmTitle": "Twin Peaks",
      "AlternateTitle": "",
      "TitleArray": [
        "Twin Peaks"
      ],
      "Year": "1990-1991",
      "Director": "David Lynch, Mark Frost",
      "DirectorArray": [
        "David Lynch",
        "Mark Frost"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4552",
      "databaseFilmTitle": "Twin Peaks: Fire Walk With Me",
      "FilmTitle": "Twin Peaks: Fire Walk With Me",
      "AlternateTitle": "",
      "TitleArray": [
        "Twin Peaks: Fire Walk With Me"
      ],
      "Year": "1992",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "211",
      "2022votes": "14"
    },
    {
      "key": "4553",
      "databaseFilmTitle": "Twin Peaks: The Return",
      "FilmTitle": "Twin Peaks: The Return",
      "AlternateTitle": "",
      "TitleArray": [
        "Twin Peaks: The Return"
      ],
      "Year": "2017",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "4554",
      "databaseFilmTitle": "Two Acres of Land",
      "FilmTitle": "Two Acres of Land",
      "AlternateTitle": "Do Bigha Zamin",
      "TitleArray": [
        "Two Acres of Land",
        "Do Bigha Zamin"
      ],
      "Year": "1953",
      "Director": "Bimal Roy",
      "DirectorArray": [
        "Bimal Roy"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4555",
      "databaseFilmTitle": "Two Cars, One Night",
      "FilmTitle": "Two Cars, One Night",
      "AlternateTitle": "",
      "TitleArray": [
        "Two Cars, One Night"
      ],
      "Year": "2004",
      "Director": "Taika Waitit",
      "DirectorArray": [
        "Taika Waitit"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4556",
      "databaseFilmTitle": "Two Cents Worth of Hope",
      "FilmTitle": "Two Cents Worth of Hope",
      "AlternateTitle": "Due soldi di speranza",
      "TitleArray": [
        "Two Cents Worth of Hope",
        "Due soldi di speranza"
      ],
      "Year": "1952",
      "Director": "Renato Castellani",
      "DirectorArray": [
        "Renato Castellani"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4557",
      "databaseFilmTitle": "Two English Girls",
      "FilmTitle": "Two English Girls",
      "AlternateTitle": "Les deux anglaises et le continent",
      "TitleArray": [
        "Two English Girls",
        "Les deux anglaises et le continent"
      ],
      "Year": "1971",
      "Director": "François Truffaut",
      "DirectorArray": [
        "François Truffaut"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4558",
      "databaseFilmTitle": "Two for the Road",
      "FilmTitle": "Two for the Road",
      "AlternateTitle": "",
      "TitleArray": [
        "Two for the Road"
      ],
      "Year": "1967",
      "Director": "Stanley Donen",
      "DirectorArray": [
        "Stanley Donen"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4559",
      "databaseFilmTitle": "Two Lovers",
      "FilmTitle": "Two Lovers",
      "AlternateTitle": "",
      "TitleArray": [
        "Two Lovers"
      ],
      "Year": "2008",
      "Director": "James Gray",
      "DirectorArray": [
        "James Gray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4560",
      "databaseFilmTitle": "Two Meetings and a Funeral",
      "FilmTitle": "Two Meetings and a Funeral",
      "AlternateTitle": "",
      "TitleArray": [
        "Two Meetings and a Funeral"
      ],
      "Year": "2017",
      "Director": "Naeem Mohaiemen",
      "DirectorArray": [
        "Naeem Mohaiemen"
      ],
      "Country": "Bangladesh",
      "CountryArray": [
        "Bangladesh"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4561",
      "databaseFilmTitle": "Two People",
      "FilmTitle": "Two People",
      "AlternateTitle": "Två människor",
      "TitleArray": [
        "Two People",
        "Två människor"
      ],
      "Year": "1945",
      "Director": "Carl Th. Dreyer",
      "DirectorArray": [
        "Carl Th. Dreyer"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4562",
      "databaseFilmTitle": "Two Stage Sisters",
      "FilmTitle": "Two Stage Sisters",
      "AlternateTitle": "Witai Jiemei",
      "TitleArray": [
        "Two Stage Sisters",
        "Witai Jiemei"
      ],
      "Year": "1965",
      "Director": "Jin Xie",
      "DirectorArray": [
        "Jin Xie"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4563",
      "databaseFilmTitle": "Two Towns of Jasper",
      "FilmTitle": "Two Towns of Jasper",
      "AlternateTitle": "",
      "TitleArray": [
        "Two Towns of Jasper"
      ],
      "Year": "2002",
      "Director": "Whitney Dow, Marco Williams",
      "DirectorArray": [
        "Whitney Dow",
        "Marco Williams"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4564",
      "databaseFilmTitle": "Two Women",
      "FilmTitle": "Two Women",
      "AlternateTitle": "La ciociara",
      "TitleArray": [
        "Two Women",
        "La ciociara"
      ],
      "Year": "1960",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4565",
      "databaseFilmTitle": "Two-Lane Blacktop",
      "FilmTitle": "Two-Lane Blacktop",
      "AlternateTitle": "",
      "TitleArray": [
        "Two-Lane Blacktop"
      ],
      "Year": "1971",
      "Director": "Monte Hellman",
      "DirectorArray": [
        "Monte Hellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "265",
      "2022votes": "11"
    },
    {
      "key": "4566",
      "databaseFilmTitle": "U.S. Go Home",
      "FilmTitle": "U.S. Go Home",
      "AlternateTitle": "",
      "TitleArray": [
        "U.S. Go Home"
      ],
      "Year": "1994",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4567",
      "databaseFilmTitle": "Über uns der Dom",
      "FilmTitle": "Über uns der Dom",
      "AlternateTitle": "",
      "TitleArray": [
        "Über uns der Dom"
      ],
      "Year": "1934",
      "Director": "Rudolf Bamberger",
      "DirectorArray": [
        "Rudolf Bamberger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4568",
      "databaseFilmTitle": "Ugetsu",
      "FilmTitle": "Ugetsu",
      "AlternateTitle": "Ugetsu monogatari",
      "TitleArray": [
        "Ugetsu",
        "Ugetsu monogatari"
      ],
      "Year": "1953",
      "Director": "Kenji Mizoguchi",
      "DirectorArray": [
        "Kenji Mizoguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "4",
      "1962votes": "17",
      "1972rank": "10",
      "1972votes": "9",
      "1982rank": "22",
      "1982votes": "7",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "50",
      "2012votes": "29",
      "2022rank": "90",
      "2022votes": "32"
    },
    {
      "key": "4569",
      "databaseFilmTitle": "Ulysse",
      "FilmTitle": "Ulysse",
      "AlternateTitle": "",
      "TitleArray": [
        "Ulysse"
      ],
      "Year": "1983",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4570",
      "databaseFilmTitle": "Ulysses' Gaze",
      "FilmTitle": "Ulysses' Gaze",
      "AlternateTitle": "",
      "TitleArray": [
        "Ulysses' Gaze"
      ],
      "Year": "1995",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4571",
      "databaseFilmTitle": "Ulzana's Raid",
      "FilmTitle": "Ulzana's Raid",
      "AlternateTitle": "",
      "TitleArray": [
        "Ulzana's Raid"
      ],
      "Year": "1972",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4572",
      "databaseFilmTitle": "Umberto D.",
      "FilmTitle": "Umberto D.",
      "AlternateTitle": "",
      "TitleArray": [
        "Umberto D."
      ],
      "Year": "1952",
      "Director": "Vittorio De Sica",
      "DirectorArray": [
        "Vittorio De Sica"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "20",
      "1962votes": "7",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "80",
      "1982votes": "3",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4573",
      "databaseFilmTitle": "Umut",
      "FilmTitle": "Umut",
      "AlternateTitle": "",
      "TitleArray": [
        "Umut"
      ],
      "Year": "2009",
      "Director": "Murat Aslan",
      "DirectorArray": [
        "Murat Aslan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4574",
      "databaseFilmTitle": "Un Balcon en Afrique",
      "FilmTitle": "Un Balcon en Afrique",
      "AlternateTitle": "",
      "TitleArray": [
        "Un Balcon en Afrique"
      ],
      "Year": "1980",
      "Director": "Anita Fernández",
      "DirectorArray": [
        "Anita Fernández"
      ],
      "Country": "Guinea-Bissau",
      "CountryArray": [
        "Guinea-Bissau"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4575",
      "databaseFilmTitle": "Un chien andalou",
      "FilmTitle": "Un chien andalou",
      "AlternateTitle": "",
      "TitleArray": [
        "Un chien andalou"
      ],
      "Year": "1929",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "4576",
      "databaseFilmTitle": "Un flic",
      "FilmTitle": "Un flic",
      "AlternateTitle": "",
      "TitleArray": [
        "Un flic"
      ],
      "Year": "1972",
      "Director": "Jean-Pierre Melville",
      "DirectorArray": [
        "Jean-Pierre Melville"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4577",
      "databaseFilmTitle": "Unbreakable",
      "FilmTitle": "Unbreakable",
      "AlternateTitle": "",
      "TitleArray": [
        "Unbreakable"
      ],
      "Year": "2000",
      "Director": "M. Night Shyamalan",
      "DirectorArray": [
        "M. Night Shyamalan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4578",
      "databaseFilmTitle": "Uncle Boonmee Who Can Recall His Past Lives",
      "FilmTitle": "Uncle Boonmee Who Can Recall His Past Lives",
      "AlternateTitle": "Loong Boonmee raleuk chat",
      "TitleArray": [
        "Uncle Boonmee Who Can Recall His Past Lives",
        "Loong Boonmee raleuk chat"
      ],
      "Year": "2010",
      "Director": "Apichatpong Weerasethakul",
      "DirectorArray": [
        "Apichatpong Weerasethakul"
      ],
      "Country": "Thailand",
      "CountryArray": [
        "Thailand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "4579",
      "databaseFilmTitle": "Uncle Yanco",
      "FilmTitle": "Uncle Yanco",
      "AlternateTitle": "Oncle Yanco",
      "TitleArray": [
        "Uncle Yanco",
        "Oncle Yanco"
      ],
      "Year": "1967",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4580",
      "databaseFilmTitle": "Under Capricorn",
      "FilmTitle": "Under Capricorn",
      "AlternateTitle": "",
      "TitleArray": [
        "Under Capricorn"
      ],
      "Year": "1949",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4581",
      "databaseFilmTitle": "Under Snow",
      "FilmTitle": "Under Snow",
      "AlternateTitle": "Unter Schnee",
      "TitleArray": [
        "Under Snow",
        "Unter Schnee"
      ],
      "Year": "2011",
      "Director": "Ulrike Ottinger",
      "DirectorArray": [
        "Ulrike Ottinger"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4582",
      "databaseFilmTitle": "Under the Bridges",
      "FilmTitle": "Under the Bridges",
      "AlternateTitle": "Unter den Brücken",
      "TitleArray": [
        "Under the Bridges",
        "Unter den Brücken"
      ],
      "Year": "1946",
      "Director": "Helmut Käutner",
      "DirectorArray": [
        "Helmut Käutner"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4583",
      "databaseFilmTitle": "Under the Roofs of Paris",
      "FilmTitle": "Under the Roofs of Paris",
      "AlternateTitle": "Sous lse toits de Paris",
      "TitleArray": [
        "Under the Roofs of Paris",
        "Sous lse toits de Paris"
      ],
      "Year": "1930",
      "Director": "René Clair",
      "DirectorArray": [
        "René Clair"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "35",
      "1952votes": "4",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4584",
      "databaseFilmTitle": "Under the Skin (1997)",
      "FilmTitle": "Under the Skin",
      "AlternateTitle": "",
      "TitleArray": [
        "Under the Skin"
      ],
      "Year": "1997",
      "Director": "Carine Adler",
      "DirectorArray": [
        "Carine Adler"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4585",
      "databaseFilmTitle": "Under the Skin (2013)",
      "FilmTitle": "Under the Skin",
      "AlternateTitle": "",
      "TitleArray": [
        "Under the Skin"
      ],
      "Year": "2013",
      "Director": "Jonathan Glazer",
      "DirectorArray": [
        "Jonathan Glazer"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "169",
      "2022votes": "17"
    },
    {
      "key": "4586",
      "databaseFilmTitle": "Under the Skin of the Sky",
      "FilmTitle": "Under the Skin of the Sky",
      "AlternateTitle": "Zir-e poost-e shahr",
      "TitleArray": [
        "Under the Skin of the Sky",
        "Zir-e poost-e shahr"
      ],
      "Year": "2001",
      "Director": "Rakhshan Bani-Etemad",
      "DirectorArray": [
        "Rakhshan Bani-Etemad"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4587",
      "databaseFilmTitle": "Under the Volcano",
      "FilmTitle": "Under the Volcano",
      "AlternateTitle": "",
      "TitleArray": [
        "Under the Volcano"
      ],
      "Year": "1984",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4588",
      "databaseFilmTitle": "Under the Wire",
      "FilmTitle": "Under the Wire",
      "AlternateTitle": "",
      "TitleArray": [
        "Under the Wire"
      ],
      "Year": "2018",
      "Director": "Chris Martin",
      "DirectorArray": [
        "Chris Martin"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4589",
      "databaseFilmTitle": "Underground",
      "FilmTitle": "Underground",
      "AlternateTitle": "",
      "TitleArray": [
        "Underground"
      ],
      "Year": "1995",
      "Director": "Emir Kusturica",
      "DirectorArray": [
        "Emir Kusturica"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4590",
      "databaseFilmTitle": "Unfaithfully Yours",
      "FilmTitle": "Unfaithfully Yours",
      "AlternateTitle": "",
      "TitleArray": [
        "Unfaithfully Yours"
      ],
      "Year": "1948",
      "Director": "Preston Sturges",
      "DirectorArray": [
        "Preston Sturges"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4591",
      "databaseFilmTitle": "Unfinished Diary",
      "FilmTitle": "Unfinished Diary",
      "AlternateTitle": "Journal inachevé",
      "TitleArray": [
        "Unfinished Diary",
        "Journal inachevé"
      ],
      "Year": "1982",
      "Director": "Marilú Mallet",
      "DirectorArray": [
        "Marilú Mallet"
      ],
      "Country": "Canada, Chile",
      "CountryArray": [
        "Canada",
        "Chile"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4592",
      "databaseFilmTitle": "Unforgiven",
      "FilmTitle": "Unforgiven",
      "AlternateTitle": "",
      "TitleArray": [
        "Unforgiven"
      ],
      "Year": "1992",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4593",
      "databaseFilmTitle": "United Kingdom",
      "FilmTitle": "United Kingdom",
      "AlternateTitle": "Play for Today: United Kingdom",
      "TitleArray": [
        "United Kingdom",
        "Play for Today: United Kingdom"
      ],
      "Year": "1981",
      "Director": "Roland Joffé",
      "DirectorArray": [
        "Roland Joffé"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4594",
      "databaseFilmTitle": "Unknown Pleasures",
      "FilmTitle": "Unknown Pleasures",
      "AlternateTitle": "Ren xiao yao",
      "TitleArray": [
        "Unknown Pleasures",
        "Ren xiao yao"
      ],
      "Year": "2002",
      "Director": "Jia Zhangke",
      "DirectorArray": [
        "Jia Zhangke"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4595",
      "databaseFilmTitle": "Unknown to the City",
      "FilmTitle": "Unknown to the City",
      "AlternateTitle": "Ignoti alla città",
      "TitleArray": [
        "Unknown to the City",
        "Ignoti alla città"
      ],
      "Year": "1958",
      "Director": "Cecilia Mangini",
      "DirectorArray": [
        "Cecilia Mangini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4596",
      "databaseFilmTitle": "Unrelated",
      "FilmTitle": "Unrelated",
      "AlternateTitle": "",
      "TitleArray": [
        "Unrelated"
      ],
      "Year": "2007",
      "Director": "Joanna Hogg",
      "DirectorArray": [
        "Joanna Hogg"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4597",
      "databaseFilmTitle": "Unrest",
      "FilmTitle": "Unrest",
      "AlternateTitle": "",
      "TitleArray": [
        "Unrest"
      ],
      "Year": "2017",
      "Director": "Jennifer Brea",
      "DirectorArray": [
        "Jennifer Brea"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4598",
      "databaseFilmTitle": "Unsere Afrikareise",
      "FilmTitle": "Unsere Afrikareise",
      "AlternateTitle": "",
      "TitleArray": [
        "Unsere Afrikareise"
      ],
      "Year": "1966",
      "Director": "Peter Kubelka",
      "DirectorArray": [
        "Peter Kubelka"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4599",
      "databaseFilmTitle": "Unstoppable",
      "FilmTitle": "Unstoppable",
      "AlternateTitle": "",
      "TitleArray": [
        "Unstoppable"
      ],
      "Year": "2010",
      "Director": "Tony Scott",
      "DirectorArray": [
        "Tony Scott"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4600",
      "databaseFilmTitle": "Untitled",
      "FilmTitle": "Untitled",
      "AlternateTitle": "",
      "TitleArray": [
        "Untitled"
      ],
      "Year": "2017",
      "Director": "Michael Glawogger, Monika Willi",
      "DirectorArray": [
        "Michael Glawogger",
        "Monika Willi"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4601",
      "databaseFilmTitle": "Untitled #1: Dance of Leitfossil",
      "FilmTitle": "Untitled #1: Dance of Leitfossil",
      "AlternateTitle": "Sem Título # 1: Dance of Leitfossil",
      "TitleArray": [
        "Untitled #1: Dance of Leitfossil",
        "Sem Título # 1: Dance of Leitfossil"
      ],
      "Year": "2014",
      "Director": "Carlos Adriano",
      "DirectorArray": [
        "Carlos Adriano"
      ],
      "Country": "Brazil",
      "CountryArray": [
        "Brazil"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4602",
      "databaseFilmTitle": "Up",
      "FilmTitle": "Up",
      "AlternateTitle": "",
      "TitleArray": [
        "Up"
      ],
      "Year": "2009",
      "Director": "Pete Docter, Bob Peterson",
      "DirectorArray": [
        "Pete Docter",
        "Bob Peterson"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4603",
      "databaseFilmTitle": "Up the Junction",
      "FilmTitle": "Up the Junction",
      "AlternateTitle": "The Wednesday Play [S01, E37]: Up the Junction",
      "TitleArray": [
        "Up the Junction",
        "The Wednesday Play [S01, E37]: Up the Junction"
      ],
      "Year": "1965",
      "Director": "Ken Loach",
      "DirectorArray": [
        "Ken Loach"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4604",
      "databaseFilmTitle": "Us",
      "FilmTitle": "Us",
      "AlternateTitle": "",
      "TitleArray": [
        "Us"
      ],
      "Year": "2019",
      "Director": "Jordan Peele",
      "DirectorArray": [
        "Jordan Peele"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4605",
      "databaseFilmTitle": "Utopia",
      "FilmTitle": "Utopia",
      "AlternateTitle": "",
      "TitleArray": [
        "Utopia"
      ],
      "Year": "1983",
      "Director": "Sohrab Shahid Saless",
      "DirectorArray": [
        "Sohrab Shahid Saless"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4606",
      "databaseFilmTitle": "Utøya - July 22",
      "FilmTitle": "Utøya - July 22",
      "AlternateTitle": "Utøya 22. Juli",
      "TitleArray": [
        "Utøya - July 22",
        "Utøya 22. Juli"
      ],
      "Year": "2018",
      "Director": "Erik Poppe",
      "DirectorArray": [
        "Erik Poppe"
      ],
      "Country": "Norway",
      "CountryArray": [
        "Norway"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4607",
      "databaseFilmTitle": "Utu",
      "FilmTitle": "Utu",
      "AlternateTitle": "",
      "TitleArray": [
        "Utu"
      ],
      "Year": "1983",
      "Director": "Geoff Murphy",
      "DirectorArray": [
        "Geoff Murphy"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4608",
      "databaseFilmTitle": "Va savoir",
      "FilmTitle": "Va savoir",
      "AlternateTitle": "",
      "TitleArray": [
        "Va savoir"
      ],
      "Year": "2001",
      "Director": "Jacques Rivette",
      "DirectorArray": [
        "Jacques Rivette"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4609",
      "databaseFilmTitle": "Vagabond",
      "FilmTitle": "Vagabond",
      "AlternateTitle": "Sans toit ni loi",
      "TitleArray": [
        "Vagabond",
        "Sans toit ni loi"
      ],
      "Year": "1985",
      "Director": "Agnès Varda",
      "DirectorArray": [
        "Agnès Varda"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "101",
      "2022votes": "30"
    },
    {
      "key": "4610",
      "databaseFilmTitle": "Valerie and Her Week of Wonders",
      "FilmTitle": "Valerie and Her Week of Wonders",
      "AlternateTitle": "Valerie a týden divů",
      "TitleArray": [
        "Valerie and Her Week of Wonders",
        "Valerie a týden divů"
      ],
      "Year": "1970",
      "Director": "Jaromil Jireš",
      "DirectorArray": [
        "Jaromil Jireš"
      ],
      "Country": "Czechoslovakia",
      "CountryArray": [
        "Czechoslovakia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4611",
      "databaseFilmTitle": "Valley Girl",
      "FilmTitle": "Valley Girl",
      "AlternateTitle": "",
      "TitleArray": [
        "Valley Girl"
      ],
      "Year": "1983",
      "Director": "Martha Coolidge",
      "DirectorArray": [
        "Martha Coolidge"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4612",
      "databaseFilmTitle": "Vampir",
      "FilmTitle": "Vampir",
      "AlternateTitle": "Cuadecuc, vampir",
      "TitleArray": [
        "Vampir",
        "Cuadecuc, vampir"
      ],
      "Year": "1971",
      "Director": "Pere Portabella",
      "DirectorArray": [
        "Pere Portabella"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4613",
      "databaseFilmTitle": "Vampyr",
      "FilmTitle": "Vampyr",
      "AlternateTitle": "",
      "TitleArray": [
        "Vampyr"
      ],
      "Year": "1932",
      "Director": "Carl Th. Dreyer",
      "DirectorArray": [
        "Carl Th. Dreyer"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "43",
      "1952votes": "3",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "154",
      "2012votes": "11",
      "2022rank": "146",
      "2022votes": "20"
    },
    {
      "key": "4614",
      "databaseFilmTitle": "Van Gogh",
      "FilmTitle": "Van Gogh",
      "AlternateTitle": "",
      "TitleArray": [
        "Van Gogh"
      ],
      "Year": "1991",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4615",
      "databaseFilmTitle": "Vanessa",
      "FilmTitle": "Vanessa",
      "AlternateTitle": "",
      "TitleArray": [
        "Vanessa"
      ],
      "Year": "1977",
      "Director": "Hubert Frank",
      "DirectorArray": [
        "Hubert Frank"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4616",
      "databaseFilmTitle": "Variety (1925)",
      "FilmTitle": "Variety",
      "AlternateTitle": "Varieté",
      "TitleArray": [
        "Variety",
        "Varieté"
      ],
      "Year": "1925",
      "Director": "Ewald André Dupont",
      "DirectorArray": [
        "Ewald André Dupont"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4617",
      "databaseFilmTitle": "Variety (1983)",
      "FilmTitle": "Variety",
      "AlternateTitle": "",
      "TitleArray": [
        "Variety"
      ],
      "Year": "1983",
      "Director": "Bette Gordon",
      "DirectorArray": [
        "Bette Gordon"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4618",
      "databaseFilmTitle": "Velvet Goldmine",
      "FilmTitle": "Velvet Goldmine",
      "AlternateTitle": "",
      "TitleArray": [
        "Velvet Goldmine"
      ],
      "Year": "1998",
      "Director": "Todd Haynes",
      "DirectorArray": [
        "Todd Haynes"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4619",
      "databaseFilmTitle": "Vendémiaire",
      "FilmTitle": "Vendémiaire",
      "AlternateTitle": "",
      "TitleArray": [
        "Vendémiaire"
      ],
      "Year": "1918",
      "Director": "Louis Feuillade",
      "DirectorArray": [
        "Louis Feuillade"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4620",
      "databaseFilmTitle": "Vengeance (1970)",
      "FilmTitle": "Vengeance",
      "AlternateTitle": "Bao chou",
      "TitleArray": [
        "Vengeance",
        "Bao chou"
      ],
      "Year": "1970",
      "Director": "Chang Cheh",
      "DirectorArray": [
        "Chang Cheh"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4621",
      "databaseFilmTitle": "Vengeance (2009)",
      "FilmTitle": "Vengeance",
      "AlternateTitle": "Fuk sau",
      "TitleArray": [
        "Vengeance",
        "Fuk sau"
      ],
      "Year": "2009",
      "Director": "Johnnie To",
      "DirectorArray": [
        "Johnnie To"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4622",
      "databaseFilmTitle": "Vengeance is Mine",
      "FilmTitle": "Vengeance is Mine",
      "AlternateTitle": "Fukushû suru wa ware ni ari",
      "TitleArray": [
        "Vengeance is Mine",
        "Fukushû suru wa ware ni ari"
      ],
      "Year": "1979",
      "Director": "Shôhei Imamura",
      "DirectorArray": [
        "Shôhei Imamura"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4623",
      "databaseFilmTitle": "Venom and Eternity",
      "FilmTitle": "Venom and Eternity",
      "AlternateTitle": "Traité de bave et d'éternité",
      "TitleArray": [
        "Venom and Eternity",
        "Traité de bave et d'éternité"
      ],
      "Year": "1951",
      "Director": "Isidore Isou",
      "DirectorArray": [
        "Isidore Isou"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4624",
      "databaseFilmTitle": "Venus in Furs",
      "FilmTitle": "Venus in Furs",
      "AlternateTitle": "Paroxismus",
      "TitleArray": [
        "Venus in Furs",
        "Paroxismus"
      ],
      "Year": "1969",
      "Director": "Jesús Franco",
      "DirectorArray": [
        "Jesús Franco"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4625",
      "databaseFilmTitle": "Vera Cruz",
      "FilmTitle": "Vera Cruz",
      "AlternateTitle": "",
      "TitleArray": [
        "Vera Cruz"
      ],
      "Year": "1954",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4626",
      "databaseFilmTitle": "Veronika Voss",
      "FilmTitle": "Veronika Voss",
      "AlternateTitle": "Die Sehnsucht der Veronika Voss",
      "TitleArray": [
        "Veronika Voss",
        "Die Sehnsucht der Veronika Voss"
      ],
      "Year": "1982",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4627",
      "databaseFilmTitle": "Vertigo",
      "FilmTitle": "Vertigo",
      "AlternateTitle": "",
      "TitleArray": [
        "Vertigo"
      ],
      "Year": "1958",
      "Director": "Alfred Hitchcock",
      "DirectorArray": [
        "Alfred Hitchcock"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "12",
      "1972votes": "8",
      "1982rank": "7",
      "1982votes": "12",
      "1992rank": "4",
      "1992votes": "18",
      "2002rank": "2",
      "2002votes": "41",
      "2012rank": "1",
      "2012votes": "191",
      "2022rank": "2",
      "2022votes": "208"
    },
    {
      "key": "4628",
      "databaseFilmTitle": "Viaggio nel crepuscolo",
      "FilmTitle": "Viaggio nel crepuscolo",
      "AlternateTitle": "",
      "TitleArray": [
        "Viaggio nel crepuscolo"
      ],
      "Year": "2021",
      "Director": "Augusto Contento",
      "DirectorArray": [
        "Augusto Contento"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4629",
      "databaseFilmTitle": "Vice",
      "FilmTitle": "Vice",
      "AlternateTitle": "",
      "TitleArray": [
        "Vice"
      ],
      "Year": "2018",
      "Director": "Adam McKay",
      "DirectorArray": [
        "Adam McKay"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4630",
      "databaseFilmTitle": "Victims of Sin",
      "FilmTitle": "Victims of Sin",
      "AlternateTitle": "Víctimas del pecado",
      "TitleArray": [
        "Victims of Sin",
        "Víctimas del pecado"
      ],
      "Year": "1951",
      "Director": "Emilio Fernández",
      "DirectorArray": [
        "Emilio Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4631",
      "databaseFilmTitle": "Videodrome",
      "FilmTitle": "Videodrome",
      "AlternateTitle": "",
      "TitleArray": [
        "Videodrome"
      ],
      "Year": "1983",
      "Director": "David Cronenberg",
      "DirectorArray": [
        "David Cronenberg"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "4632",
      "databaseFilmTitle": "Videograms of a Revolution",
      "FilmTitle": "Videograms of a Revolution",
      "AlternateTitle": "Videogramme einer Revolution",
      "TitleArray": [
        "Videograms of a Revolution",
        "Videogramme einer Revolution"
      ],
      "Year": "1992",
      "Director": "Harun Farocki, Andrei Ujică",
      "DirectorArray": [
        "Harun Farocki",
        "Andrei Ujică"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4633",
      "databaseFilmTitle": "Vikings",
      "FilmTitle": "Vikings",
      "AlternateTitle": "",
      "TitleArray": [
        "Vikings"
      ],
      "Year": "2010-2020",
      "Director": "Michael Hirst",
      "DirectorArray": [
        "Michael Hirst"
      ],
      "Country": "Canada, Ireland",
      "CountryArray": [
        "Canada, Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4634",
      "databaseFilmTitle": "Vinyl",
      "FilmTitle": "Vinyl",
      "AlternateTitle": "",
      "TitleArray": [
        "Vinyl"
      ],
      "Year": "1965",
      "Director": "Andy Warhol",
      "DirectorArray": [
        "Andy Warhol"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4635",
      "databaseFilmTitle": "Virgin Machine",
      "FilmTitle": "Virgin Machine",
      "AlternateTitle": "Die Jungfrauenmaschine",
      "TitleArray": [
        "Virgin Machine",
        "Die Jungfrauenmaschine"
      ],
      "Year": "1988",
      "Director": "Monika Treut",
      "DirectorArray": [
        "Monika Treut"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4636",
      "databaseFilmTitle": "Viridiana",
      "FilmTitle": "Viridiana",
      "AlternateTitle": "",
      "TitleArray": [
        "Viridiana"
      ],
      "Year": "1961",
      "Director": "Luis Buñuel",
      "DirectorArray": [
        "Luis Buñuel"
      ],
      "Country": "Spain, Mexico",
      "CountryArray": [
        "Spain",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "18",
      "1972votes": "7",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "89",
      "2002votes": "3",
      "2012rank": "110",
      "2012votes": "15",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4637",
      "databaseFilmTitle": "Visions in Meditation #1",
      "FilmTitle": "Visions in Meditation #1",
      "AlternateTitle": "",
      "TitleArray": [
        "Visions in Meditation #1"
      ],
      "Year": "1989",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4638",
      "databaseFilmTitle": "Visit, or Memories and Confessions",
      "FilmTitle": "Visit, or Memories and Confessions",
      "AlternateTitle": "Visita ou Memórias e Confissões",
      "TitleArray": [
        "Visit, or Memories and Confessions",
        "Visita ou Memórias e Confissões"
      ],
      "Year": "1993",
      "Director": "Manoel de Oliveira",
      "DirectorArray": [
        "Manoel de Oliveira"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4639",
      "databaseFilmTitle": "Visitor Q",
      "FilmTitle": "Visitor Q",
      "AlternateTitle": "Bijitâ Q",
      "TitleArray": [
        "Visitor Q",
        "Bijitâ Q"
      ],
      "Year": "2001",
      "Director": "Takashi Miike",
      "DirectorArray": [
        "Takashi Miike"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4640",
      "databaseFilmTitle": "Vitalina Varela",
      "FilmTitle": "Vitalina Varela",
      "AlternateTitle": "",
      "TitleArray": [
        "Vitalina Varela"
      ],
      "Year": "2019",
      "Director": "Pedro Costa",
      "DirectorArray": [
        "Pedro Costa"
      ],
      "Country": "Portugal",
      "CountryArray": [
        "Portugal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4641",
      "databaseFilmTitle": "Viva Didou!",
      "FilmTitle": "Viva Didou!",
      "AlternateTitle": "Tahia ya Didou!",
      "TitleArray": [
        "Viva Didou!",
        "Tahia ya Didou!"
      ],
      "Year": "1971",
      "Director": "Mohamed Zinet",
      "DirectorArray": [
        "Mohamed Zinet"
      ],
      "Country": "Algeria",
      "CountryArray": [
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4642",
      "databaseFilmTitle": "Viva l'Italia!",
      "FilmTitle": "Viva l'Italia!",
      "AlternateTitle": "",
      "TitleArray": [
        "Viva l'Italia!"
      ],
      "Year": "1961",
      "Director": "Roberto Rossellini",
      "DirectorArray": [
        "Roberto Rossellini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4643",
      "databaseFilmTitle": "Viva Riva!",
      "FilmTitle": "Viva Riva!",
      "AlternateTitle": "",
      "TitleArray": [
        "Viva Riva!"
      ],
      "Year": "2010",
      "Director": "Djo Tunda Wa Munga",
      "DirectorArray": [
        "Djo Tunda Wa Munga"
      ],
      "Country": "Democratic Republic of the Congo",
      "CountryArray": [
        "Democratic Republic of the Congo"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4644",
      "databaseFilmTitle": "Vive l'amour",
      "FilmTitle": "Vive l'amour",
      "AlternateTitle": "Ai qing wan sui",
      "TitleArray": [
        "Vive l'amour",
        "Ai qing wan sui"
      ],
      "Year": "1994",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4645",
      "databaseFilmTitle": "Vivre sa vie",
      "FilmTitle": "Vivre sa vie",
      "AlternateTitle": "Vivre sa vie: Film en douze tableaux",
      "TitleArray": [
        "Vivre sa vie",
        "Vivre sa vie: Film en douze tableaux"
      ],
      "Year": "1962",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "144",
      "2012votes": "12",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "4646",
      "databaseFilmTitle": "Voices Through Time",
      "FilmTitle": "Voices Through Time",
      "AlternateTitle": "Voci nel tempo",
      "TitleArray": [
        "Voices Through Time",
        "Voci nel tempo"
      ],
      "Year": "1996",
      "Director": "Franco Piavoli",
      "DirectorArray": [
        "Franco Piavoli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4647",
      "databaseFilmTitle": "Voluptuous Sleep",
      "FilmTitle": "Voluptuous Sleep",
      "AlternateTitle": "",
      "TitleArray": [
        "Voluptuous Sleep"
      ],
      "Year": "2011",
      "Director": "Betzy Bromberg",
      "DirectorArray": [
        "Betzy Bromberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4648",
      "databaseFilmTitle": "Volver",
      "FilmTitle": "Volver",
      "AlternateTitle": "",
      "TitleArray": [
        "Volver"
      ],
      "Year": "2006",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4649",
      "databaseFilmTitle": "Vortex",
      "FilmTitle": "Vortex",
      "AlternateTitle": "",
      "TitleArray": [
        "Vortex"
      ],
      "Year": "2021",
      "Director": "Gaspar Noé",
      "DirectorArray": [
        "Gaspar Noé"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4650",
      "databaseFilmTitle": "Voyage to Cythera",
      "FilmTitle": "Voyage to Cythera",
      "AlternateTitle": "",
      "TitleArray": [
        "Voyage to Cythera"
      ],
      "Year": "1984",
      "Director": "Theodoros Angelopoulos",
      "DirectorArray": [
        "Theodoros Angelopoulos"
      ],
      "Country": "Greece",
      "CountryArray": [
        "Greece"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4651",
      "databaseFilmTitle": "Wadi Grand Canyon 2001",
      "FilmTitle": "Wadi Grand Canyon 2001",
      "AlternateTitle": "",
      "TitleArray": [
        "Wadi Grand Canyon 2001"
      ],
      "Year": "2001",
      "Director": "Amos Gitaï",
      "DirectorArray": [
        "Amos Gitaï"
      ],
      "Country": "Israel",
      "CountryArray": [
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4652",
      "databaseFilmTitle": "Wadjda",
      "FilmTitle": "Wadjda",
      "AlternateTitle": "",
      "TitleArray": [
        "Wadjda"
      ],
      "Year": "2012",
      "Director": "Haifaa Al-Mansour",
      "DirectorArray": [
        "Haifaa Al-Mansour"
      ],
      "Country": "Saudi Arabia",
      "CountryArray": [
        "Saudi Arabia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4653",
      "databaseFilmTitle": "Wages and Profits",
      "FilmTitle": "Wages and Profits",
      "AlternateTitle": "Tarang",
      "TitleArray": [
        "Wages and Profits",
        "Tarang"
      ],
      "Year": "1984",
      "Director": "Kumar Shahani",
      "DirectorArray": [
        "Kumar Shahani"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4654",
      "databaseFilmTitle": "Wagon Master",
      "FilmTitle": "Wagon Master",
      "AlternateTitle": "",
      "TitleArray": [
        "Wagon Master"
      ],
      "Year": "1950",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "35",
      "1962votes": "3",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4655",
      "databaseFilmTitle": "Wait till the Sun Shines, Nellie",
      "FilmTitle": "Wait till the Sun Shines, Nellie",
      "AlternateTitle": "",
      "TitleArray": [
        "Wait till the Sun Shines, Nellie"
      ],
      "Year": "1952",
      "Director": "Henry King",
      "DirectorArray": [
        "Henry King"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4656",
      "databaseFilmTitle": "Waiting For Guffman",
      "FilmTitle": "Waiting For Guffman",
      "AlternateTitle": "",
      "TitleArray": [
        "Waiting For Guffman"
      ],
      "Year": "1996",
      "Director": "Christopher Guest",
      "DirectorArray": [
        "Christopher Guest"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4657",
      "databaseFilmTitle": "Waiting for Happiness",
      "FilmTitle": "Waiting for Happiness",
      "AlternateTitle": "Heremakono",
      "TitleArray": [
        "Waiting for Happiness",
        "Heremakono"
      ],
      "Year": "2002",
      "Director": "Abderrahmane Sissako",
      "DirectorArray": [
        "Abderrahmane Sissako"
      ],
      "Country": "Mauritania",
      "CountryArray": [
        "Mauritania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4658",
      "databaseFilmTitle": "Wajib",
      "FilmTitle": "Wajib",
      "AlternateTitle": "",
      "TitleArray": [
        "Wajib"
      ],
      "Year": "2017",
      "Director": "Annemarie Jacir",
      "DirectorArray": [
        "Annemarie Jacir"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4659",
      "databaseFilmTitle": "Wake in Fright",
      "FilmTitle": "Wake in Fright",
      "AlternateTitle": "",
      "TitleArray": [
        "Wake in Fright"
      ],
      "Year": "1971",
      "Director": "Ted Kotcheff",
      "DirectorArray": [
        "Ted Kotcheff"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4660",
      "databaseFilmTitle": "Waking Life",
      "FilmTitle": "Waking Life",
      "AlternateTitle": "",
      "TitleArray": [
        "Waking Life"
      ],
      "Year": "2001",
      "Director": "Richard Linklater",
      "DirectorArray": [
        "Richard Linklater"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4661",
      "databaseFilmTitle": "Walden",
      "FilmTitle": "Walden",
      "AlternateTitle": "Diaries notes and sketches",
      "TitleArray": [
        "Walden",
        "Diaries notes and sketches"
      ],
      "Year": "1969",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4662",
      "databaseFilmTitle": "Walkabout",
      "FilmTitle": "Walkabout",
      "AlternateTitle": "",
      "TitleArray": [
        "Walkabout"
      ],
      "Year": "1971",
      "Director": "Nicolas Roeg",
      "DirectorArray": [
        "Nicolas Roeg"
      ],
      "Country": "Australia",
      "CountryArray": [
        "Australia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4663",
      "databaseFilmTitle": "Walking and Talking",
      "FilmTitle": "Walking and Talking",
      "AlternateTitle": "",
      "TitleArray": [
        "Walking and Talking"
      ],
      "Year": "1996",
      "Director": "Nicole Holofcener",
      "DirectorArray": [
        "Nicole Holofcener"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4664",
      "databaseFilmTitle": "WALL•E",
      "FilmTitle": "WALL•E",
      "AlternateTitle": "",
      "TitleArray": [
        "WALL•E"
      ],
      "Year": "2008",
      "Director": "Andrew Stanton",
      "DirectorArray": [
        "Andrew Stanton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4665",
      "databaseFilmTitle": "Wallay",
      "FilmTitle": "Wallay",
      "AlternateTitle": "",
      "TitleArray": [
        "Wallay"
      ],
      "Year": "2017",
      "Director": "Berni Goldblat",
      "DirectorArray": [
        "Berni Goldblat"
      ],
      "Country": "Burkina Faso",
      "CountryArray": [
        "Burkina Faso"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4666",
      "databaseFilmTitle": "Walls",
      "FilmTitle": "Walls",
      "AlternateTitle": "Mathilukal",
      "TitleArray": [
        "Walls",
        "Mathilukal"
      ],
      "Year": "1990",
      "Director": "Adoor Gopalakrishnan",
      "DirectorArray": [
        "Adoor Gopalakrishnan"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4667",
      "databaseFilmTitle": "Walter Defends Sarajevo",
      "FilmTitle": "Walter Defends Sarajevo",
      "AlternateTitle": "Valter Brani Sarajevo",
      "TitleArray": [
        "Walter Defends Sarajevo",
        "Valter Brani Sarajevo"
      ],
      "Year": "1972",
      "Director": "Hajrudin Kravac",
      "DirectorArray": [
        "Hajrudin Kravac"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4668",
      "databaseFilmTitle": "Waltz with Bashir",
      "FilmTitle": "Waltz with Bashir",
      "AlternateTitle": "Vals im Bashir",
      "TitleArray": [
        "Waltz with Bashir",
        "Vals im Bashir"
      ],
      "Year": "2008",
      "Director": "Ari Folman",
      "DirectorArray": [
        "Ari Folman"
      ],
      "Country": "Israel",
      "CountryArray": [
        "Israel"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4669",
      "databaseFilmTitle": "Wanda",
      "FilmTitle": "Wanda",
      "AlternateTitle": "",
      "TitleArray": [
        "Wanda"
      ],
      "Year": "1970",
      "Director": "Barbara Loden",
      "DirectorArray": [
        "Barbara Loden"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "201",
      "2012votes": "8",
      "2022rank": "48",
      "2022votes": "48"
    },
    {
      "key": "4670",
      "databaseFilmTitle": "War and Peace",
      "FilmTitle": "War and Peace",
      "AlternateTitle": "",
      "TitleArray": [
        "War and Peace"
      ],
      "Year": "1967",
      "Director": "Sergei Bondarchuk",
      "DirectorArray": [
        "Sergei Bondarchuk"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4671",
      "databaseFilmTitle": "War is Hell",
      "FilmTitle": "War is Hell",
      "AlternateTitle": "Maudite soit la guerre",
      "TitleArray": [
        "War is Hell",
        "Maudite soit la guerre"
      ],
      "Year": "1914",
      "Director": "Alfred Machin",
      "DirectorArray": [
        "Alfred Machin"
      ],
      "Country": "Belgium",
      "CountryArray": [
        "Belgium"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4672",
      "databaseFilmTitle": "War of the Worlds",
      "FilmTitle": "War of the Worlds",
      "AlternateTitle": "",
      "TitleArray": [
        "War of the Worlds"
      ],
      "Year": "2005",
      "Director": "Steven Spielberg",
      "DirectorArray": [
        "Steven Spielberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4673",
      "databaseFilmTitle": "Warm Broth",
      "FilmTitle": "Warm Broth",
      "AlternateTitle": "",
      "TitleArray": [
        "Warm Broth"
      ],
      "Year": "1988",
      "Director": "Luther Price",
      "DirectorArray": [
        "Luther Price"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4674",
      "databaseFilmTitle": "Warning Shadows: A Nocturnal Hallucination",
      "FilmTitle": "Warning Shadows: A Nocturnal Hallucination",
      "AlternateTitle": "Schatten – Eine nächtliche Halluzination",
      "TitleArray": [
        "Warning Shadows: A Nocturnal Hallucination",
        "Schatten – Eine nächtliche Halluzination"
      ],
      "Year": "1923",
      "Director": "Arthur Robison",
      "DirectorArray": [
        "Arthur Robison"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4675",
      "databaseFilmTitle": "Waru",
      "FilmTitle": "Waru",
      "AlternateTitle": "",
      "TitleArray": [
        "Waru"
      ],
      "Year": "2017",
      "Director": "Ainsley Gardiner, Casey Kaa, Renae Maihi, Awanui Simich-Pene, Briar Grace-Smith, Paula Whetu Jones, Chelsea Winstanley, Katie Wolfe",
      "DirectorArray": [
        "Ainsley Gardiner",
        "Casey Kaa",
        "Renae Maihi",
        "Awanui Simich-Pene",
        "Briar Grace-Smith",
        "Paula Whetu Jones",
        "Chelsea Winstanley",
        "Katie Wolfe"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4676",
      "databaseFilmTitle": "Wasp",
      "FilmTitle": "Wasp",
      "AlternateTitle": "",
      "TitleArray": [
        "Wasp"
      ],
      "Year": "2003",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4677",
      "databaseFilmTitle": "Watching The Detectives",
      "FilmTitle": "Watching The Detectives",
      "AlternateTitle": "",
      "TitleArray": [
        "Watching The Detectives"
      ],
      "Year": "2017",
      "Director": "Chris Kennedy",
      "DirectorArray": [
        "Chris Kennedy"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4678",
      "databaseFilmTitle": "Watchmen",
      "FilmTitle": "Watchmen",
      "AlternateTitle": "",
      "TitleArray": [
        "Watchmen"
      ],
      "Year": "2009",
      "Director": "Zack Snyder",
      "DirectorArray": [
        "Zack Snyder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4679",
      "databaseFilmTitle": "Water",
      "FilmTitle": "Water",
      "AlternateTitle": "",
      "TitleArray": [
        "Water"
      ],
      "Year": "2005",
      "Director": "Deepa Mehta",
      "DirectorArray": [
        "Deepa Mehta"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4680",
      "databaseFilmTitle": "Water and Power",
      "FilmTitle": "Water and Power",
      "AlternateTitle": "",
      "TitleArray": [
        "Water and Power"
      ],
      "Year": "1989",
      "Director": "Pat O'Neill",
      "DirectorArray": [
        "Pat O'Neill"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4681",
      "databaseFilmTitle": "Water Lilies",
      "FilmTitle": "Water Lilies",
      "AlternateTitle": "Naissance des pieuvres",
      "TitleArray": [
        "Water Lilies",
        "Naissance des pieuvres"
      ],
      "Year": "2007",
      "Director": "Céline Sciamma",
      "DirectorArray": [
        "Céline Sciamma"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4682",
      "databaseFilmTitle": "Water-mirror of Granada",
      "FilmTitle": "Water-mirror of Granada",
      "AlternateTitle": "Aguaespejo granadino",
      "TitleArray": [
        "Water-mirror of Granada",
        "Aguaespejo granadino"
      ],
      "Year": "1955",
      "Director": "José Val del Omar",
      "DirectorArray": [
        "José Val del Omar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4683",
      "databaseFilmTitle": "Wavelength",
      "FilmTitle": "Wavelength",
      "AlternateTitle": "",
      "TitleArray": [
        "Wavelength"
      ],
      "Year": "1967",
      "Director": "Michael Snow",
      "DirectorArray": [
        "Michael Snow"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "102",
      "2012votes": "16",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "4684",
      "databaseFilmTitle": "Way Down East",
      "FilmTitle": "Way Down East",
      "AlternateTitle": "",
      "TitleArray": [
        "Way Down East"
      ],
      "Year": "1920",
      "Director": "D.W. Griffith",
      "DirectorArray": [
        "D.W. Griffith"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "55",
      "1952votes": "2",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4685",
      "databaseFilmTitle": "Wayne's World",
      "FilmTitle": "Wayne's World",
      "AlternateTitle": "",
      "TitleArray": [
        "Wayne's World"
      ],
      "Year": "1992",
      "Director": "Penelope Spheeris",
      "DirectorArray": [
        "Penelope Spheeris"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4686",
      "databaseFilmTitle": "We All Loved Each Other So Much",
      "FilmTitle": "We All Loved Each Other So Much",
      "AlternateTitle": "C'eravamo tanto amati",
      "TitleArray": [
        "We All Loved Each Other So Much",
        "C'eravamo tanto amati"
      ],
      "Year": "1974",
      "Director": "Ettore Scola",
      "DirectorArray": [
        "Ettore Scola"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4687",
      "databaseFilmTitle": "We Are Not Children",
      "FilmTitle": "We Are Not Children",
      "AlternateTitle": "Nous ne sommes plus des enfants",
      "TitleArray": [
        "We Are Not Children",
        "Nous ne sommes plus des enfants"
      ],
      "Year": "1934",
      "Director": "Augusto Genina",
      "DirectorArray": [
        "Augusto Genina"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4688",
      "databaseFilmTitle": "We Are the Lambeth Boys",
      "FilmTitle": "We Are the Lambeth Boys",
      "AlternateTitle": "",
      "TitleArray": [
        "We Are the Lambeth Boys"
      ],
      "Year": "1959",
      "Director": "Karel Reisz",
      "DirectorArray": [
        "Karel Reisz"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "77",
      "1962votes": "1",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4689",
      "databaseFilmTitle": "We Can't Go Home Again",
      "FilmTitle": "We Can't Go Home Again",
      "AlternateTitle": "",
      "TitleArray": [
        "We Can't Go Home Again"
      ],
      "Year": "1973",
      "Director": "Nicholas Ray",
      "DirectorArray": [
        "Nicholas Ray"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4690",
      "databaseFilmTitle": "We Go Round and Round in the Night and Are Consumed by Fire",
      "FilmTitle": "We Go Round and Round in the Night and Are Consumed by Fire",
      "AlternateTitle": "In girum imus nocte et consumimur igni",
      "TitleArray": [
        "We Go Round and Round in the Night and Are Consumed by Fire",
        "In girum imus nocte et consumimur igni"
      ],
      "Year": "1978",
      "Director": "Guy Debord",
      "DirectorArray": [
        "Guy Debord"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4691",
      "databaseFilmTitle": "We Need To Talk About Kevin",
      "FilmTitle": "We Need To Talk About Kevin",
      "AlternateTitle": "",
      "TitleArray": [
        "We Need To Talk About Kevin"
      ],
      "Year": "2011",
      "Director": "Lynne Ramsay",
      "DirectorArray": [
        "Lynne Ramsay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4692",
      "databaseFilmTitle": "We the Living",
      "FilmTitle": "We the Living",
      "AlternateTitle": "Noi vivi",
      "TitleArray": [
        "We the Living",
        "Noi vivi"
      ],
      "Year": "1942",
      "Director": "Goffredo Alessandrini",
      "DirectorArray": [
        "Goffredo Alessandrini"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4693",
      "databaseFilmTitle": "We Won't Grow Old Together",
      "FilmTitle": "We Won't Grow Old Together",
      "AlternateTitle": "Nous ne vieillirons pas ensemble",
      "TitleArray": [
        "We Won't Grow Old Together",
        "Nous ne vieillirons pas ensemble"
      ],
      "Year": "1972",
      "Director": "Maurice Pialat",
      "DirectorArray": [
        "Maurice Pialat"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4694",
      "databaseFilmTitle": "Weather Diary 1",
      "FilmTitle": "Weather Diary 1",
      "AlternateTitle": "",
      "TitleArray": [
        "Weather Diary 1"
      ],
      "Year": "1986",
      "Director": "George Kuchar",
      "DirectorArray": [
        "George Kuchar"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4695",
      "databaseFilmTitle": "Wedding in Galilee",
      "FilmTitle": "Wedding in Galilee",
      "AlternateTitle": "Urs al-Jalil",
      "TitleArray": [
        "Wedding in Galilee",
        "Urs al-Jalil"
      ],
      "Year": "1987",
      "Director": "Michel Khleifi",
      "DirectorArray": [
        "Michel Khleifi"
      ],
      "Country": "Palestine",
      "CountryArray": [
        "Palestine"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4696",
      "databaseFilmTitle": "Weekend (1930)",
      "FilmTitle": "Weekend",
      "AlternateTitle": "Wochenende",
      "TitleArray": [
        "Weekend",
        "Wochenende"
      ],
      "Year": "1930",
      "Director": "Walter Ruttmann",
      "DirectorArray": [
        "Walter Ruttmann"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4697",
      "databaseFilmTitle": "Weekend (1967)",
      "FilmTitle": "Weekend",
      "AlternateTitle": "",
      "TitleArray": [
        "Weekend"
      ],
      "Year": "1967",
      "Director": "Jean-Luc Godard",
      "DirectorArray": [
        "Jean-Luc Godard"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "379",
      "2012votes": "4",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4698",
      "databaseFilmTitle": "Weekend (2011)",
      "FilmTitle": "Weekend",
      "AlternateTitle": "",
      "TitleArray": [
        "Weekend"
      ],
      "Year": "2011",
      "Director": "Andrew Haigh",
      "DirectorArray": [
        "Andrew Haigh"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4699",
      "databaseFilmTitle": "Welcome II the Terrordome",
      "FilmTitle": "Welcome II the Terrordome",
      "AlternateTitle": "",
      "TitleArray": [
        "Welcome II the Terrordome"
      ],
      "Year": "1995",
      "Director": "Ngozi Onwurah",
      "DirectorArray": [
        "Ngozi Onwurah"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4700",
      "databaseFilmTitle": "Welcome to the Dollhouse",
      "FilmTitle": "Welcome to the Dollhouse",
      "AlternateTitle": "",
      "TitleArray": [
        "Welcome to the Dollhouse"
      ],
      "Year": "1995",
      "Director": "Todd Solondz",
      "DirectorArray": [
        "Todd Solondz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4701",
      "databaseFilmTitle": "Welcome, or No Tresspassing",
      "FilmTitle": "Welcome, or No Tresspassing",
      "AlternateTitle": "",
      "TitleArray": [
        "Welcome, or No Tresspassing"
      ],
      "Year": "1965",
      "Director": "Elem Klimov",
      "DirectorArray": [
        "Elem Klimov"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4702",
      "databaseFilmTitle": "Welfare",
      "FilmTitle": "Welfare",
      "AlternateTitle": "",
      "TitleArray": [
        "Welfare"
      ],
      "Year": "1975",
      "Director": "Frederick Wiseman",
      "DirectorArray": [
        "Frederick Wiseman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4703",
      "databaseFilmTitle": "Wendy and Lucy",
      "FilmTitle": "Wendy and Lucy",
      "AlternateTitle": "",
      "TitleArray": [
        "Wendy and Lucy"
      ],
      "Year": "2008",
      "Director": "Kelly Reichardt",
      "DirectorArray": [
        "Kelly Reichardt"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4704",
      "databaseFilmTitle": "Went the Day Well?",
      "FilmTitle": "Went the Day Well?",
      "AlternateTitle": "",
      "TitleArray": [
        "Went the Day Well?"
      ],
      "Year": "1942",
      "Director": "Alberto Cavalcanti",
      "DirectorArray": [
        "Alberto Cavalcanti"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4705",
      "databaseFilmTitle": "Werckmeister Harmonies",
      "FilmTitle": "Werckmeister Harmonies",
      "AlternateTitle": "Werckmeister harmóniák",
      "TitleArray": [
        "Werckmeister Harmonies",
        "Werckmeister harmóniák"
      ],
      "Year": "2000",
      "Director": "Béla Tarr, Ágnes Hranitzky",
      "DirectorArray": [
        "Béla Tarr",
        "Ágnes Hranitzky"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "171",
      "2012votes": "10",
      "2022rank": "244",
      "2022votes": "12"
    },
    {
      "key": "4706",
      "databaseFilmTitle": "Werewolf",
      "FilmTitle": "Werewolf",
      "AlternateTitle": "Libahunt",
      "TitleArray": [
        "Werewolf",
        "Libahunt"
      ],
      "Year": "1968",
      "Director": "Leida Laius",
      "DirectorArray": [
        "Leida Laius"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4707",
      "databaseFilmTitle": "West Indies",
      "FilmTitle": "West Indies",
      "AlternateTitle": "West Indies ou les Nègres marrons de la liberté)",
      "TitleArray": [
        "West Indies",
        "West Indies ou les Nègres marrons de la liberté)"
      ],
      "Year": "1979",
      "Director": "Med Hondo",
      "DirectorArray": [
        "Med Hondo"
      ],
      "Country": "Mauritania",
      "CountryArray": [
        "Mauritania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "153",
      "2022votes": "19"
    },
    {
      "key": "4708",
      "databaseFilmTitle": "West of Zanzibar",
      "FilmTitle": "West of Zanzibar",
      "AlternateTitle": "",
      "TitleArray": [
        "West of Zanzibar"
      ],
      "Year": "1928",
      "Director": "Tod Browning",
      "DirectorArray": [
        "Tod Browning"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4709",
      "databaseFilmTitle": "West Side Story",
      "FilmTitle": "West Side Story",
      "AlternateTitle": "",
      "TitleArray": [
        "West Side Story"
      ],
      "Year": "1961",
      "Director": "Jerome Robbins, Robert Wise",
      "DirectorArray": [
        "Jerome Robbins",
        "Robert Wise"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4710",
      "databaseFilmTitle": "Western",
      "FilmTitle": "Western",
      "AlternateTitle": "",
      "TitleArray": [
        "Western"
      ],
      "Year": "2017",
      "Director": "Valeska Grisebach",
      "DirectorArray": [
        "Valeska Grisebach"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4711",
      "databaseFilmTitle": "Western Approaches",
      "FilmTitle": "Western Approaches",
      "AlternateTitle": "",
      "TitleArray": [
        "Western Approaches"
      ],
      "Year": "1944",
      "Director": "Pat Jackson",
      "DirectorArray": [
        "Pat Jackson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4712",
      "databaseFilmTitle": "Wetherby",
      "FilmTitle": "Wetherby",
      "AlternateTitle": "",
      "TitleArray": [
        "Wetherby"
      ],
      "Year": "1985",
      "Director": "David Hare",
      "DirectorArray": [
        "David Hare"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4713",
      "databaseFilmTitle": "Whale Rider",
      "FilmTitle": "Whale Rider",
      "AlternateTitle": "",
      "TitleArray": [
        "Whale Rider"
      ],
      "Year": "2002",
      "Director": "Niki Caro",
      "DirectorArray": [
        "Niki Caro"
      ],
      "Country": "New Zealand",
      "CountryArray": [
        "New Zealand"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4714",
      "databaseFilmTitle": "‎What Do Gypsy Children Do?",
      "FilmTitle": "‎What Do Gypsy Children Do?",
      "AlternateTitle": "Mit csinálnak a cigánygyerekek?",
      "TitleArray": [
        "‎What Do Gypsy Children Do?",
        "Mit csinálnak a cigánygyerekek?"
      ],
      "Year": "1974",
      "Director": "Pál Schiffer",
      "DirectorArray": [
        "Pál Schiffer"
      ],
      "Country": "Hungary",
      "CountryArray": [
        "Hungary"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4715",
      "databaseFilmTitle": "What Ever Happened to Baby Jane?",
      "FilmTitle": "What Ever Happened to Baby Jane?",
      "AlternateTitle": "",
      "TitleArray": [
        "What Ever Happened to Baby Jane?"
      ],
      "Year": "1962",
      "Director": "Robert Aldrich",
      "DirectorArray": [
        "Robert Aldrich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4716",
      "databaseFilmTitle": "What Goes Up",
      "FilmTitle": "What Goes Up",
      "AlternateTitle": "",
      "TitleArray": [
        "What Goes Up"
      ],
      "Year": "2003",
      "Director": "Robert Breer",
      "DirectorArray": [
        "Robert Breer"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4717",
      "databaseFilmTitle": "What Happened to This City?",
      "FilmTitle": "What Happened to This City?",
      "AlternateTitle": "Kya hua is shahar ko?",
      "TitleArray": [
        "What Happened to This City?",
        "Kya hua is shahar ko?"
      ],
      "Year": "1986",
      "Director": "Deepa Dhanraj",
      "DirectorArray": [
        "Deepa Dhanraj"
      ],
      "Country": "India",
      "CountryArray": [
        "India"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4718",
      "databaseFilmTitle": "What Makes This Song Stink, Episodes 1-7",
      "FilmTitle": "What Makes This Song Stink",
      "AlternateTitle": "Episodes 1-7",
      "TitleArray": [
        "What Makes This Song Stink",
        "Episodes 1-7"
      ],
      "Year": "",
      "Director": "Pat Finnerty",
      "DirectorArray": [
        "Pat Finnerty"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4719",
      "databaseFilmTitle": "What Now? Remind Me",
      "FilmTitle": "What Now? Remind Me",
      "AlternateTitle": "E agora? Lembra-me",
      "TitleArray": [
        "What Now? Remind Me",
        "E agora? Lembra-me"
      ],
      "Year": "2013",
      "Director": "Joaquim Pinto",
      "DirectorArray": [
        "Joaquim Pinto"
      ],
      "Country": "Portgual",
      "CountryArray": [
        "Portgual"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4720",
      "databaseFilmTitle": "What Time Is It There?",
      "FilmTitle": "What Time Is It There?",
      "AlternateTitle": "Ni na bian ji dian",
      "TitleArray": [
        "What Time Is It There?",
        "Ni na bian ji dian"
      ],
      "Year": "2001",
      "Director": "Tsai Ming-liang",
      "DirectorArray": [
        "Tsai Ming-liang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4721",
      "databaseFilmTitle": "What's Opera, Doc?",
      "FilmTitle": "What's Opera, Doc?",
      "AlternateTitle": "",
      "TitleArray": [
        "What's Opera, Doc?"
      ],
      "Year": "1957",
      "Director": "Chuck Jones",
      "DirectorArray": [
        "Chuck Jones"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4722",
      "databaseFilmTitle": "What's Up, Doc?",
      "FilmTitle": "What's Up, Doc?",
      "AlternateTitle": "",
      "TitleArray": [
        "What's Up, Doc?"
      ],
      "Year": "1972",
      "Director": "Peter Bogdanovich",
      "DirectorArray": [
        "Peter Bogdanovich"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4723",
      "databaseFilmTitle": "What's Wrong With This Picture? 1",
      "FilmTitle": "What's Wrong With This Picture? 1",
      "AlternateTitle": "",
      "TitleArray": [
        "What's Wrong With This Picture? 1"
      ],
      "Year": "1971",
      "Director": "Owen Land",
      "DirectorArray": [
        "Owen Land"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4724",
      "databaseFilmTitle": "Wheel of Fortune and Fantasy",
      "FilmTitle": "Wheel of Fortune and Fantasy",
      "AlternateTitle": "Gûzen to sôzô",
      "TitleArray": [
        "Wheel of Fortune and Fantasy",
        "Gûzen to sôzô"
      ],
      "Year": "2021",
      "Director": "Ryusuke Hamaguchi",
      "DirectorArray": [
        "Ryusuke Hamaguchi"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4725",
      "databaseFilmTitle": "When a Woman Ascends the Stairs",
      "FilmTitle": "When a Woman Ascends the Stairs",
      "AlternateTitle": "Onno ga kaidan wo agaru toki",
      "TitleArray": [
        "When a Woman Ascends the Stairs",
        "Onno ga kaidan wo agaru toki"
      ],
      "Year": "1960",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4726",
      "databaseFilmTitle": "When Harry Met Sally...",
      "FilmTitle": "When Harry Met Sally...",
      "AlternateTitle": "",
      "TitleArray": [
        "When Harry Met Sally..."
      ],
      "Year": "1989",
      "Director": "Rob Reiner",
      "DirectorArray": [
        "Rob Reiner"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4727",
      "databaseFilmTitle": "When I Am Dead and Gone",
      "FilmTitle": "When I Am Dead and Gone",
      "AlternateTitle": "Kad budem mrtav i beo",
      "TitleArray": [
        "When I Am Dead and Gone",
        "Kad budem mrtav i beo"
      ],
      "Year": "1967",
      "Director": "Živojin Pavlović",
      "DirectorArray": [
        "Živojin Pavlović"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4728",
      "databaseFilmTitle": "When It Rains",
      "FilmTitle": "When It Rains",
      "AlternateTitle": "",
      "TitleArray": [
        "When It Rains"
      ],
      "Year": "1995",
      "Director": "Charles Burnett",
      "DirectorArray": [
        "Charles Burnett"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4729",
      "databaseFilmTitle": "When the Day Breaks",
      "FilmTitle": "When the Day Breaks",
      "AlternateTitle": "",
      "TitleArray": [
        "When the Day Breaks"
      ],
      "Year": "1999",
      "Director": "Amanda Forbis, Wendy Tilby",
      "DirectorArray": [
        "Amanda Forbis",
        "Wendy Tilby"
      ],
      "Country": "Canada",
      "CountryArray": [
        "Canada"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4730",
      "databaseFilmTitle": "When the Tenth Month Comes",
      "FilmTitle": "When the Tenth Month Comes",
      "AlternateTitle": "Bao gio cho den tháng Muoi",
      "TitleArray": [
        "When the Tenth Month Comes",
        "Bao gio cho den tháng Muoi"
      ],
      "Year": "1984",
      "Director": "Đặng Nhật Minh",
      "DirectorArray": [
        "Đặng Nhật Minh"
      ],
      "Country": "Vietnam",
      "CountryArray": [
        "Vietnam"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4731",
      "databaseFilmTitle": "When the Wind Blows",
      "FilmTitle": "When the Wind Blows",
      "AlternateTitle": "",
      "TitleArray": [
        "When the Wind Blows"
      ],
      "Year": "1986",
      "Director": "Jimmy T. Murakami",
      "DirectorArray": [
        "Jimmy T. Murakami"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4732",
      "databaseFilmTitle": "When Tomorrow Comes",
      "FilmTitle": "When Tomorrow Comes",
      "AlternateTitle": "",
      "TitleArray": [
        "When Tomorrow Comes"
      ],
      "Year": "1939",
      "Director": "John M. Stahl",
      "DirectorArray": [
        "John M. Stahl"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4733",
      "databaseFilmTitle": "When We Were Kings",
      "FilmTitle": "When We Were Kings",
      "AlternateTitle": "",
      "TitleArray": [
        "When We Were Kings"
      ],
      "Year": "1996",
      "Director": "Leon Gast",
      "DirectorArray": [
        "Leon Gast"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4734",
      "databaseFilmTitle": "Where Eagles Dare",
      "FilmTitle": "Where Eagles Dare",
      "AlternateTitle": "",
      "TitleArray": [
        "Where Eagles Dare"
      ],
      "Year": "1968",
      "Director": "Brian G. Hutton",
      "DirectorArray": [
        "Brian G. Hutton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4735",
      "databaseFilmTitle": "Where Is the Friend's House?",
      "FilmTitle": "Where Is the Friend's House?",
      "AlternateTitle": "Khane-ye Doust Kodjast?",
      "TitleArray": [
        "Where Is the Friend's House?",
        "Khane-ye Doust Kodjast?"
      ],
      "Year": "1987",
      "Director": "Abbas Kiarostami",
      "DirectorArray": [
        "Abbas Kiarostami"
      ],
      "Country": "Iran",
      "CountryArray": [
        "Iran"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "234",
      "2012votes": "7",
      "2022rank": "157",
      "2022votes": "18"
    },
    {
      "key": "4736",
      "databaseFilmTitle": "Which Way to the Front",
      "FilmTitle": "Which Way to the Front",
      "AlternateTitle": "",
      "TitleArray": [
        "Which Way to the Front"
      ],
      "Year": "1970",
      "Director": "Jerry Lewis",
      "DirectorArray": [
        "Jerry Lewis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4737",
      "databaseFilmTitle": "While the City Sleeps",
      "FilmTitle": "While the City Sleeps",
      "AlternateTitle": "",
      "TitleArray": [
        "While the City Sleeps"
      ],
      "Year": "1956",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4738",
      "databaseFilmTitle": "Whiplash",
      "FilmTitle": "Whiplash",
      "AlternateTitle": "",
      "TitleArray": [
        "Whiplash"
      ],
      "Year": "2014",
      "Director": "Damien Chazelle",
      "DirectorArray": [
        "Damien Chazelle"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4739",
      "databaseFilmTitle": "Whirlpool",
      "FilmTitle": "Whirlpool",
      "AlternateTitle": "",
      "TitleArray": [
        "Whirlpool"
      ],
      "Year": "1949",
      "Director": "Otto Preminger",
      "DirectorArray": [
        "Otto Preminger"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4740",
      "databaseFilmTitle": "Whisky",
      "FilmTitle": "Whisky",
      "AlternateTitle": "",
      "TitleArray": [
        "Whisky"
      ],
      "Year": "2004",
      "Director": "Juan Pablo Rebella, Pablo Stoll Ward",
      "DirectorArray": [
        "Juan Pablo Rebella",
        "Pablo Stoll Ward"
      ],
      "Country": "Uruguay",
      "CountryArray": [
        "Uruguay"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4741",
      "databaseFilmTitle": "Whisper of the Heart",
      "FilmTitle": "Whisper of the Heart",
      "AlternateTitle": "Mimi wo sumaseba",
      "TitleArray": [
        "Whisper of the Heart",
        "Mimi wo sumaseba"
      ],
      "Year": "1995",
      "Director": "Yoshifumi Kondô",
      "DirectorArray": [
        "Yoshifumi Kondô"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4742",
      "databaseFilmTitle": "Whispering Pages",
      "FilmTitle": "Whispering Pages",
      "AlternateTitle": "",
      "TitleArray": [
        "Whispering Pages"
      ],
      "Year": "1994",
      "Director": "Aleksandr Sokurov",
      "DirectorArray": [
        "Aleksandr Sokurov"
      ],
      "Country": "Russia",
      "CountryArray": [
        "Russia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4743",
      "databaseFilmTitle": "Whistle and I'll Come to You",
      "FilmTitle": "Whistle and I'll Come to You",
      "AlternateTitle": "",
      "TitleArray": [
        "Whistle and I'll Come to You"
      ],
      "Year": "1968",
      "Director": "Jonathan Miller",
      "DirectorArray": [
        "Jonathan Miller"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4744",
      "databaseFilmTitle": "White Death",
      "FilmTitle": "White Death",
      "AlternateTitle": "Monangambée",
      "TitleArray": [
        "White Death",
        "Monangambée"
      ],
      "Year": "1968",
      "Director": "Sarah Maldoror",
      "DirectorArray": [
        "Sarah Maldoror"
      ],
      "Country": "Algeria",
      "CountryArray": [
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4745",
      "databaseFilmTitle": "White Dog",
      "FilmTitle": "White Dog",
      "AlternateTitle": "",
      "TitleArray": [
        "White Dog"
      ],
      "Year": "1982",
      "Director": "Samuel Fuller",
      "DirectorArray": [
        "Samuel Fuller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4746",
      "databaseFilmTitle": "White Heat",
      "FilmTitle": "White Heat",
      "AlternateTitle": "",
      "TitleArray": [
        "White Heat"
      ],
      "Year": "1949",
      "Director": "Raoul Walsh",
      "DirectorArray": [
        "Raoul Walsh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4747",
      "databaseFilmTitle": "White Hunter, Black Heart",
      "FilmTitle": "White Hunter, Black Heart",
      "AlternateTitle": "",
      "TitleArray": [
        "White Hunter, Black Heart"
      ],
      "Year": "1990",
      "Director": "Clint Eastwood",
      "DirectorArray": [
        "Clint Eastwood"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4748",
      "databaseFilmTitle": "White Material",
      "FilmTitle": "White Material",
      "AlternateTitle": "",
      "TitleArray": [
        "White Material"
      ],
      "Year": "2009",
      "Director": "Claire Denis",
      "DirectorArray": [
        "Claire Denis"
      ],
      "Country": "France, Cameroon",
      "CountryArray": [
        "France",
        "Cameroon"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4749",
      "databaseFilmTitle": "White Zombie",
      "FilmTitle": "White Zombie",
      "AlternateTitle": "",
      "TitleArray": [
        "White Zombie"
      ],
      "Year": "1932",
      "Director": "Victor Halperin",
      "DirectorArray": [
        "Victor Halperin"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4750",
      "databaseFilmTitle": "Who Framed Roger Rabbit?",
      "FilmTitle": "Who Framed Roger Rabbit?",
      "AlternateTitle": "",
      "TitleArray": [
        "Who Framed Roger Rabbit?"
      ],
      "Year": "1988",
      "Director": "Robert Zemeckis",
      "DirectorArray": [
        "Robert Zemeckis"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4751",
      "databaseFilmTitle": "Who's Afraid of Virginia Woolf?",
      "FilmTitle": "Who's Afraid of Virginia Woolf?",
      "AlternateTitle": "",
      "TitleArray": [
        "Who's Afraid of Virginia Woolf?"
      ],
      "Year": "1966",
      "Director": "Mike Nichols",
      "DirectorArray": [
        "Mike Nichols"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4752",
      "databaseFilmTitle": "Who's Singing Over There?",
      "FilmTitle": "Who's Singing Over There?",
      "AlternateTitle": "Ko to tamo peva",
      "TitleArray": [
        "Who's Singing Over There?",
        "Ko to tamo peva"
      ],
      "Year": "1980",
      "Director": "Slobodan Šijan",
      "DirectorArray": [
        "Slobodan Šijan"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4753",
      "databaseFilmTitle": "Whoopee!",
      "FilmTitle": "Whoopee!",
      "AlternateTitle": "",
      "TitleArray": [
        "Whoopee!"
      ],
      "Year": "1930",
      "Director": "Thornton Freeland",
      "DirectorArray": [
        "Thornton Freeland"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4754",
      "databaseFilmTitle": "Why Has Bodhi-Dharma Left for the East?",
      "FilmTitle": "Why Has Bodhi-Dharma Left for the East?",
      "AlternateTitle": "Dharmaga tongjoguro kan kkadalgun",
      "TitleArray": [
        "Why Has Bodhi-Dharma Left for the East?",
        "Dharmaga tongjoguro kan kkadalgun"
      ],
      "Year": "1989",
      "Director": "Bae Yong-Kyun",
      "DirectorArray": [
        "Bae Yong-Kyun"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "93",
      "1992votes": "3",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4755",
      "databaseFilmTitle": "Why Is Yellow the Middle of the Rainbow?",
      "FilmTitle": "Why Is Yellow the Middle of the Rainbow?",
      "AlternateTitle": "Bakit dilaw ang gitna ng bahag-hari?",
      "TitleArray": [
        "Why Is Yellow the Middle of the Rainbow?",
        "Bakit dilaw ang gitna ng bahag-hari?"
      ],
      "Year": "1994",
      "Director": "Kidlat Tahimik",
      "DirectorArray": [
        "Kidlat Tahimik"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4756",
      "databaseFilmTitle": "Why Not!",
      "FilmTitle": "Why Not!",
      "AlternateTitle": "Pourquoi pas!",
      "TitleArray": [
        "Why Not!",
        "Pourquoi pas!"
      ],
      "Year": "1977",
      "Director": "Coline Serreau",
      "DirectorArray": [
        "Coline Serreau"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4757",
      "databaseFilmTitle": "Wife",
      "FilmTitle": "Wife",
      "AlternateTitle": "Tsuma",
      "TitleArray": [
        "Wife",
        "Tsuma"
      ],
      "Year": "1953",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4758",
      "databaseFilmTitle": "Wife! Be like a Rose!",
      "FilmTitle": "Wife! Be like a Rose!",
      "AlternateTitle": "Tsuma yo bara no yo ni",
      "TitleArray": [
        "Wife! Be like a Rose!",
        "Tsuma yo bara no yo ni"
      ],
      "Year": "1935",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4759",
      "databaseFilmTitle": "Wild at Heart",
      "FilmTitle": "Wild at Heart",
      "AlternateTitle": "",
      "TitleArray": [
        "Wild at Heart"
      ],
      "Year": "1990",
      "Director": "David Lynch",
      "DirectorArray": [
        "David Lynch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4760",
      "databaseFilmTitle": "Wild Grass",
      "FilmTitle": "Wild Grass",
      "AlternateTitle": "Les herbes folles",
      "TitleArray": [
        "Wild Grass",
        "Les herbes folles"
      ],
      "Year": "2009",
      "Director": "Alain Resnais",
      "DirectorArray": [
        "Alain Resnais"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4761",
      "databaseFilmTitle": "Wild Reeds",
      "FilmTitle": "Wild Reeds",
      "AlternateTitle": "Les roseaux sauvages",
      "TitleArray": [
        "Wild Reeds",
        "Les roseaux sauvages"
      ],
      "Year": "1994",
      "Director": "André Téchiné",
      "DirectorArray": [
        "André Téchiné"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4762",
      "databaseFilmTitle": "Wild River",
      "FilmTitle": "Wild River",
      "AlternateTitle": "",
      "TitleArray": [
        "Wild River"
      ],
      "Year": "1960",
      "Director": "Elia Kazan",
      "DirectorArray": [
        "Elia Kazan"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4763",
      "databaseFilmTitle": "Wild Strawberries",
      "FilmTitle": "Wild Strawberries",
      "AlternateTitle": "Smultronstället",
      "TitleArray": [
        "Wild Strawberries",
        "Smultronstället"
      ],
      "Year": "1957",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "26",
      "1962votes": "6",
      "1972rank": "10",
      "1972votes": "9",
      "1982rank": "44",
      "1982votes": "5",
      "1992rank": "18",
      "1992votes": "8",
      "2002rank": "28",
      "2002votes": "7",
      "2012rank": "63",
      "2012votes": "24",
      "2022rank": "108",
      "2022votes": "28"
    },
    {
      "key": "4764",
      "databaseFilmTitle": "Wildfire",
      "FilmTitle": "Wildfire",
      "AlternateTitle": "",
      "TitleArray": [
        "Wildfire"
      ],
      "Year": "2002",
      "Director": "Amy Greenfield",
      "DirectorArray": [
        "Amy Greenfield"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4765",
      "databaseFilmTitle": "Winchester '73",
      "FilmTitle": "Winchester '73",
      "AlternateTitle": "",
      "TitleArray": [
        "Winchester '73"
      ],
      "Year": "1950",
      "Director": "Anthony Mann",
      "DirectorArray": [
        "Anthony Mann"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4766",
      "databaseFilmTitle": "Wind Across the Everglades",
      "FilmTitle": "Wind Across the Everglades",
      "AlternateTitle": "",
      "TitleArray": [
        "Wind Across the Everglades"
      ],
      "Year": "1958",
      "Director": "Nicholas Ray, Budd Schulberg",
      "DirectorArray": [
        "Nicholas Ray",
        "Budd Schulberg"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4767",
      "databaseFilmTitle": "Wind from the East",
      "FilmTitle": "Wind from the East",
      "AlternateTitle": "Le vent d'est",
      "TitleArray": [
        "Wind from the East",
        "Le vent d'est"
      ],
      "Year": "1970",
      "Director": "Groupe Dziga Vertov, Jean-Luc Godard, Jean-Pierre Gorin, Gérard Martin",
      "DirectorArray": [
        "Groupe Dziga Vertov",
        "Jean-Luc Godard",
        "Jean-Pierre Gorin",
        "Gérard Martin"
      ],
      "Country": "Italy, France",
      "CountryArray": [
        "Italy",
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4768",
      "databaseFilmTitle": "Wind Vane",
      "FilmTitle": "Wind Vane",
      "AlternateTitle": "",
      "TitleArray": [
        "Wind Vane"
      ],
      "Year": "1972",
      "Director": "Chris Welsby",
      "DirectorArray": [
        "Chris Welsby"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4769",
      "databaseFilmTitle": "Wind. A Minute and 40 Seconds",
      "FilmTitle": "Wind. A Minute and 40 Seconds",
      "AlternateTitle": "Kaze. Ippun yonjûbyô",
      "TitleArray": [
        "Wind. A Minute and 40 Seconds",
        "Kaze. Ippun yonjûbyô"
      ],
      "Year": "1985",
      "Director": "Tsutomu Shinozuka",
      "DirectorArray": [
        "Tsutomu Shinozuka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4770",
      "databaseFilmTitle": "Window Water Baby Moving",
      "FilmTitle": "Window Water Baby Moving",
      "AlternateTitle": "",
      "TitleArray": [
        "Window Water Baby Moving"
      ],
      "Year": "1959",
      "Director": "Stan Brakhage",
      "DirectorArray": [
        "Stan Brakhage"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4771",
      "databaseFilmTitle": "Windy Day",
      "FilmTitle": "Windy Day",
      "AlternateTitle": "",
      "TitleArray": [
        "Windy Day"
      ],
      "Year": "1968",
      "Director": "John Hubley, Faith Hubley",
      "DirectorArray": [
        "John Hubley",
        "Faith Hubley"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4772",
      "databaseFilmTitle": "Wings (1927)",
      "FilmTitle": "Wings",
      "AlternateTitle": "",
      "TitleArray": [
        "Wings"
      ],
      "Year": "1927",
      "Director": "Willian A. Wellman",
      "DirectorArray": [
        "Willian A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4773",
      "databaseFilmTitle": "Wings (1966)",
      "FilmTitle": "Wings",
      "AlternateTitle": "Krylya",
      "TitleArray": [
        "Wings",
        "Krylya"
      ],
      "Year": "1966",
      "Director": "Larisa Shepitko",
      "DirectorArray": [
        "Larisa Shepitko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4774",
      "databaseFilmTitle": "Wings of Desire",
      "FilmTitle": "Wings of Desire",
      "AlternateTitle": "Der Himmel über Berlin",
      "TitleArray": [
        "Wings of Desire",
        "Der Himmel über Berlin"
      ],
      "Year": "1987",
      "Director": "Win Wenders",
      "DirectorArray": [
        "Win Wenders"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "185",
      "2022votes": "16"
    },
    {
      "key": "4775",
      "databaseFilmTitle": "Winstanley",
      "FilmTitle": "Winstanley",
      "AlternateTitle": "",
      "TitleArray": [
        "Winstanley"
      ],
      "Year": "1975",
      "Director": "Kevin Brownlow, Andrew Mollo",
      "DirectorArray": [
        "Kevin Brownlow",
        "Andrew Mollo"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4776",
      "databaseFilmTitle": "Winter Adé",
      "FilmTitle": "Winter Adé",
      "AlternateTitle": "",
      "TitleArray": [
        "Winter Adé"
      ],
      "Year": "1988",
      "Director": "Helke Misselwitz",
      "DirectorArray": [
        "Helke Misselwitz"
      ],
      "Country": "East Germany",
      "CountryArray": [
        "East Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4777",
      "databaseFilmTitle": "Winter Light",
      "FilmTitle": "Winter Light",
      "AlternateTitle": "Nattvardsgästerna",
      "TitleArray": [
        "Winter Light",
        "Nattvardsgästerna"
      ],
      "Year": "1963",
      "Director": "Ingmar Bergman",
      "DirectorArray": [
        "Ingmar Bergman"
      ],
      "Country": "Sweden",
      "CountryArray": [
        "Sweden"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "87",
      "1972votes": "2",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4778",
      "databaseFilmTitle": "Winter Sleep",
      "FilmTitle": "Winter Sleep",
      "AlternateTitle": "Kis Uykusu",
      "TitleArray": [
        "Winter Sleep",
        "Kis Uykusu"
      ],
      "Year": "2014",
      "Director": "Nuri Bilge Ceylan",
      "DirectorArray": [
        "Nuri Bilge Ceylan"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4779",
      "databaseFilmTitle": "Winter's Bone",
      "FilmTitle": "Winter's Bone",
      "AlternateTitle": "",
      "TitleArray": [
        "Winter's Bone"
      ],
      "Year": "2010",
      "Director": "Debra Granik",
      "DirectorArray": [
        "Debra Granik"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4780",
      "databaseFilmTitle": "Wise Blood",
      "FilmTitle": "Wise Blood",
      "AlternateTitle": "",
      "TitleArray": [
        "Wise Blood"
      ],
      "Year": "1979",
      "Director": "John Huston",
      "DirectorArray": [
        "John Huston"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4781",
      "databaseFilmTitle": "Witchfinder General",
      "FilmTitle": "Witchfinder General",
      "AlternateTitle": "The Conqueror Worm",
      "TitleArray": [
        "Witchfinder General",
        "The Conqueror Worm"
      ],
      "Year": "1968",
      "Director": "Michael Reeves",
      "DirectorArray": [
        "Michael Reeves"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4782",
      "databaseFilmTitle": "With Faith in God",
      "FilmTitle": "With Faith in God",
      "AlternateTitle": "Sa verom u Boga",
      "TitleArray": [
        "With Faith in God",
        "Sa verom u Boga"
      ],
      "Year": "1932",
      "Director": "Mihajlo Al. Popović",
      "DirectorArray": [
        "Mihajlo Al. Popović"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4783",
      "databaseFilmTitle": "Within Our Gates",
      "FilmTitle": "Within Our Gates",
      "AlternateTitle": "",
      "TitleArray": [
        "Within Our Gates"
      ],
      "Year": "1920",
      "Director": "Oscar Micheaux",
      "DirectorArray": [
        "Oscar Micheaux"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4784",
      "databaseFilmTitle": "Withnail & I",
      "FilmTitle": "Withnail & I",
      "AlternateTitle": "",
      "TitleArray": [
        "Withnail & I"
      ],
      "Year": "1987",
      "Director": "Bruce Robinson",
      "DirectorArray": [
        "Bruce Robinson"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4785",
      "databaseFilmTitle": "Witness",
      "FilmTitle": "Witness",
      "AlternateTitle": "",
      "TitleArray": [
        "Witness"
      ],
      "Year": "1985",
      "Director": "Peter Weir",
      "DirectorArray": [
        "Peter Weir"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4786",
      "databaseFilmTitle": "Witness for the Prosecution",
      "FilmTitle": "Witness for the Prosecution",
      "AlternateTitle": "",
      "TitleArray": [
        "Witness for the Prosecution"
      ],
      "Year": "1957",
      "Director": "Billy Wilder",
      "DirectorArray": [
        "Billy Wilder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4787",
      "databaseFilmTitle": "Wolf Children",
      "FilmTitle": "Wolf Children",
      "AlternateTitle": "Okami kodomo no ame to yuko",
      "TitleArray": [
        "Wolf Children",
        "Okami kodomo no ame to yuko"
      ],
      "Year": "2012",
      "Director": "Mamoru Hosoda",
      "DirectorArray": [
        "Mamoru Hosoda"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4788",
      "databaseFilmTitle": "Wolff Von Amerongen: Did He Commit Bancruptcy Offences?",
      "FilmTitle": "Wolff Von Amerongen: Did He Commit Bancruptcy Offences?",
      "AlternateTitle": "Hat Wolff von Amerongen Konkursdelikte begangen?",
      "TitleArray": [
        "Wolff Von Amerongen: Did He Commit Bancruptcy Offences?",
        "Hat Wolff von Amerongen Konkursdelikte begangen?"
      ],
      "Year": "2004",
      "Director": "Gerhard Friedl",
      "DirectorArray": [
        "Gerhard Friedl"
      ],
      "Country": "Austria",
      "CountryArray": [
        "Austria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4789",
      "databaseFilmTitle": "Wolfwalkers",
      "FilmTitle": "Wolfwalkers",
      "AlternateTitle": "",
      "TitleArray": [
        "Wolfwalkers"
      ],
      "Year": "2020",
      "Director": "Tomm Moore, Ross Stewart",
      "DirectorArray": [
        "Tomm Moore",
        "Ross Stewart"
      ],
      "Country": "Ireland",
      "CountryArray": [
        "Ireland"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4790",
      "databaseFilmTitle": "Wolves in the Walls",
      "FilmTitle": "Wolves in the Walls",
      "AlternateTitle": "",
      "TitleArray": [
        "Wolves in the Walls"
      ],
      "Year": "2018",
      "Director": "Pete Billington",
      "DirectorArray": [
        "Pete Billington"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4791",
      "databaseFilmTitle": "Woman in the Dunes",
      "FilmTitle": "Woman in the Dunes",
      "AlternateTitle": "Suna no onna",
      "TitleArray": [
        "Woman in the Dunes",
        "Suna no onna"
      ],
      "Year": "1964",
      "Director": "Hiroshi Teshigahara",
      "DirectorArray": [
        "Hiroshi Teshigahara"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4792",
      "databaseFilmTitle": "Woman of Tokyo",
      "FilmTitle": "Woman of Tokyo",
      "AlternateTitle": "Tôkyô no onna",
      "TitleArray": [
        "Woman of Tokyo",
        "Tôkyô no onna"
      ],
      "Year": "1933",
      "Director": "Yasujirô Ozu",
      "DirectorArray": [
        "Yasujirô Ozu"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4793",
      "databaseFilmTitle": "Woman with Flowers",
      "FilmTitle": "Woman with Flowers",
      "AlternateTitle": "Señora con flores",
      "TitleArray": [
        "Woman with Flowers",
        "Señora con flores"
      ],
      "Year": "2011",
      "Director": "Chick Strand",
      "DirectorArray": [
        "Chick Strand"
      ],
      "Country": "United States, Mexico",
      "CountryArray": [
        "United States",
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4794",
      "databaseFilmTitle": "Women on the Verge of a Nervous Breakdown",
      "FilmTitle": "Women on the Verge of a Nervous Breakdown",
      "AlternateTitle": "Mujeres al borde de un ataque de nervious",
      "TitleArray": [
        "Women on the Verge of a Nervous Breakdown",
        "Mujeres al borde de un ataque de nervious"
      ],
      "Year": "1988",
      "Director": "Pedro Almodóvar",
      "DirectorArray": [
        "Pedro Almodóvar"
      ],
      "Country": "Spain",
      "CountryArray": [
        "Spain"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4795",
      "databaseFilmTitle": "Women's Things",
      "FilmTitle": "Women's Things",
      "AlternateTitle": "Cosas de mujeres",
      "TitleArray": [
        "Women's Things",
        "Cosas de mujeres"
      ],
      "Year": "1978",
      "Director": "Rosa Martha Fernández",
      "DirectorArray": [
        "Rosa Martha Fernández"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4796",
      "databaseFilmTitle": "Wonder Woman",
      "FilmTitle": "Wonder Woman",
      "AlternateTitle": "",
      "TitleArray": [
        "Wonder Woman"
      ],
      "Year": "2017",
      "Director": "Patty Jenkins",
      "DirectorArray": [
        "Patty Jenkins"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4797",
      "databaseFilmTitle": "Wonderland",
      "FilmTitle": "Wonderland",
      "AlternateTitle": "",
      "TitleArray": [
        "Wonderland"
      ],
      "Year": "1999",
      "Director": "Michael Winterbottom",
      "DirectorArray": [
        "Michael Winterbottom"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4798",
      "databaseFilmTitle": "Woodstock",
      "FilmTitle": "Woodstock",
      "AlternateTitle": "",
      "TitleArray": [
        "Woodstock"
      ],
      "Year": "1970",
      "Director": "Michael Wadleigh",
      "DirectorArray": [
        "Michael Wadleigh"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4799",
      "databaseFilmTitle": "Work Done",
      "FilmTitle": "Work Done",
      "AlternateTitle": "",
      "TitleArray": [
        "Work Done"
      ],
      "Year": "1972",
      "Director": "Robert Beavers",
      "DirectorArray": [
        "Robert Beavers"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4800",
      "databaseFilmTitle": "Workers Leaving the Factory",
      "FilmTitle": "Workers Leaving the Factory",
      "AlternateTitle": "Arbeiter Verlassen die Fabrik",
      "TitleArray": [
        "Workers Leaving the Factory",
        "Arbeiter Verlassen die Fabrik"
      ],
      "Year": "1995",
      "Director": "Harun Farocki, Andrei Ujică",
      "DirectorArray": [
        "Harun Farocki",
        "Andrei Ujică"
      ],
      "Country": "Germany",
      "CountryArray": [
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4801",
      "databaseFilmTitle": "Workers Leaving the Lumière Factory",
      "FilmTitle": "Workers Leaving the Lumière Factory",
      "AlternateTitle": "La sortie de l'usine Lumière à Lyon",
      "TitleArray": [
        "Workers Leaving the Lumière Factory",
        "La sortie de l'usine Lumière à Lyon"
      ],
      "Year": "1895",
      "Director": "Louis Lumière",
      "DirectorArray": [
        "Louis Lumière"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4802",
      "databaseFilmTitle": "Workers, Peasants",
      "FilmTitle": "Workers, Peasants",
      "AlternateTitle": "Operai, contadini",
      "TitleArray": [
        "Workers, Peasants",
        "Operai, contadini"
      ],
      "Year": "2001",
      "Director": "Danièle Huillet, Jean-Marie Straub",
      "DirectorArray": [
        "Danièle Huillet",
        "Jean-Marie Straub"
      ],
      "Country": "Italy, Germany",
      "CountryArray": [
        "Italy",
        "Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4803",
      "databaseFilmTitle": "Working Girls",
      "FilmTitle": "Working Girls",
      "AlternateTitle": "",
      "TitleArray": [
        "Working Girls"
      ],
      "Year": "1986",
      "Director": "Lizzie Borden",
      "DirectorArray": [
        "Lizzie Borden"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4804",
      "databaseFilmTitle": "World on a Wire",
      "FilmTitle": "World on a Wire",
      "AlternateTitle": "Welt am Draht",
      "TitleArray": [
        "World on a Wire",
        "Welt am Draht"
      ],
      "Year": "1973",
      "Director": "Rainer Werner Fassbinder",
      "DirectorArray": [
        "Rainer Werner Fassbinder"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4805",
      "databaseFilmTitle": "WR: Mysteries of the Organism",
      "FilmTitle": "WR: Mysteries of the Organism",
      "AlternateTitle": "W.R. - Misterije organizma",
      "TitleArray": [
        "WR: Mysteries of the Organism",
        "W.R. - Misterije organizma"
      ],
      "Year": "1971",
      "Director": "Dušan Makavejev",
      "DirectorArray": [
        "Dušan Makavejev"
      ],
      "Country": "Yugoslavia",
      "CountryArray": [
        "Yugoslavia"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4806",
      "databaseFilmTitle": "Written on the Wind",
      "FilmTitle": "Written on the Wind",
      "AlternateTitle": "",
      "TitleArray": [
        "Written on the Wind"
      ],
      "Year": "1956",
      "Director": "Douglas Sirk",
      "DirectorArray": [
        "Douglas Sirk"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "405",
      "2022votes": "7"
    },
    {
      "key": "4807",
      "databaseFilmTitle": "Wundkanal",
      "FilmTitle": "Wundkanal",
      "AlternateTitle": "",
      "TitleArray": [
        "Wundkanal"
      ],
      "Year": "1984",
      "Director": "Thomas Harlan",
      "DirectorArray": [
        "Thomas Harlan"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4808",
      "databaseFilmTitle": "Wuthering Heights",
      "FilmTitle": "Wuthering Heights",
      "AlternateTitle": "",
      "TitleArray": [
        "Wuthering Heights"
      ],
      "Year": "2011",
      "Director": "Andrea Arnold",
      "DirectorArray": [
        "Andrea Arnold"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4809",
      "databaseFilmTitle": "X: The Man with the X-Ray Eyes",
      "FilmTitle": "X: The Man with the X-Ray Eyes",
      "AlternateTitle": "",
      "TitleArray": [
        "X: The Man with the X-Ray Eyes"
      ],
      "Year": "1963",
      "Director": "Roger Corman",
      "DirectorArray": [
        "Roger Corman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4810",
      "databaseFilmTitle": "Xala",
      "FilmTitle": "Xala",
      "AlternateTitle": "",
      "TitleArray": [
        "Xala"
      ],
      "Year": "1975",
      "Director": "Ousmane Sembène",
      "DirectorArray": [
        "Ousmane Sembène"
      ],
      "Country": "Senegal",
      "CountryArray": [
        "Senegal"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "131",
      "2002votes": "2",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4811",
      "databaseFilmTitle": "Y tu mamá también",
      "FilmTitle": "Y tu mamá también",
      "AlternateTitle": "",
      "TitleArray": [
        "Y tu mamá también"
      ],
      "Year": "2001",
      "Director": "Alfonso Cuarón",
      "DirectorArray": [
        "Alfonso Cuarón"
      ],
      "Country": "Mexico",
      "CountryArray": [
        "Mexico"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4812",
      "databaseFilmTitle": "Yaaba",
      "FilmTitle": "Yaaba",
      "AlternateTitle": "",
      "TitleArray": [
        "Yaaba"
      ],
      "Year": "1989",
      "Director": "Idrissa Ouedraogo",
      "DirectorArray": [
        "Idrissa Ouedraogo"
      ],
      "Country": "Burkina Faso",
      "CountryArray": [
        "Burkina Faso"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4813",
      "databaseFilmTitle": "Yama: Attack to Attack",
      "FilmTitle": "Yama: Attack to Attack",
      "AlternateTitle": "Yama - Yararetara yarikaese",
      "TitleArray": [
        "Yama: Attack to Attack",
        "Yama - Yararetara yarikaese"
      ],
      "Year": "1985",
      "Director": "Mitsuo Sato, Kyoichi Yamaoka",
      "DirectorArray": [
        "Mitsuo Sato",
        "Kyoichi Yamaoka"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4814",
      "databaseFilmTitle": "Yankee Doodle Dandy",
      "FilmTitle": "Yankee Doodle Dandy",
      "AlternateTitle": "",
      "TitleArray": [
        "Yankee Doodle Dandy"
      ],
      "Year": "1942",
      "Director": "Michael Curtiz",
      "DirectorArray": [
        "Michael Curtiz"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4815",
      "databaseFilmTitle": "Year of the Horse",
      "FilmTitle": "Year of the Horse",
      "AlternateTitle": "",
      "TitleArray": [
        "Year of the Horse"
      ],
      "Year": "1997",
      "Director": "Jim Jarmusch",
      "DirectorArray": [
        "Jim Jarmusch"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4816",
      "databaseFilmTitle": "Yearning",
      "FilmTitle": "Yearning",
      "AlternateTitle": "Midareru",
      "TitleArray": [
        "Yearning",
        "Midareru"
      ],
      "Year": "1964",
      "Director": "Mikio Naruse",
      "DirectorArray": [
        "Mikio Naruse"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "846",
      "2022votes": "3"
    },
    {
      "key": "4817",
      "databaseFilmTitle": "Yeelen",
      "FilmTitle": "Yeelen",
      "AlternateTitle": "",
      "TitleArray": [
        "Yeelen"
      ],
      "Year": "1987",
      "Director": "Souleymane Cissé",
      "DirectorArray": [
        "Souleymane Cissé"
      ],
      "Country": "Mali",
      "CountryArray": [
        "Mali"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "131",
      "1992votes": "2",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "282",
      "2012votes": "6",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4818",
      "databaseFilmTitle": "Yellow Earth",
      "FilmTitle": "Yellow Earth",
      "AlternateTitle": "Hunag tu di",
      "TitleArray": [
        "Yellow Earth",
        "Hunag tu di"
      ],
      "Year": "1984",
      "Director": "Chen Kaige",
      "DirectorArray": [
        "Chen Kaige"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "62",
      "1992votes": "4",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4819",
      "databaseFilmTitle": "Yellow Sky",
      "FilmTitle": "Yellow Sky",
      "AlternateTitle": "",
      "TitleArray": [
        "Yellow Sky"
      ],
      "Year": "1948",
      "Director": "William A. Wellman",
      "DirectorArray": [
        "William A. Wellman"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4820",
      "databaseFilmTitle": "Yellow Submarine",
      "FilmTitle": "Yellow Submarine",
      "AlternateTitle": "",
      "TitleArray": [
        "Yellow Submarine"
      ],
      "Year": "1968",
      "Director": "George Dunning",
      "DirectorArray": [
        "George Dunning"
      ],
      "Country": "United States, United Kingdom",
      "CountryArray": [
        "United States",
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4821",
      "databaseFilmTitle": "Yellow the Sun",
      "FilmTitle": "Yellow the Sun",
      "AlternateTitle": "Jaune le soleil",
      "TitleArray": [
        "Yellow the Sun",
        "Jaune le soleil"
      ],
      "Year": "1971",
      "Director": "Marguerite Duras",
      "DirectorArray": [
        "Marguerite Duras"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4822",
      "databaseFilmTitle": "Yes, Madam",
      "FilmTitle": "Yes, Madam",
      "AlternateTitle": "Sissignora",
      "TitleArray": [
        "Yes, Madam",
        "Sissignora"
      ],
      "Year": "1942",
      "Director": "Ferdinando Maria Poggioli",
      "DirectorArray": [
        "Ferdinando Maria Poggioli"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4823",
      "databaseFilmTitle": "Yesterday Girl",
      "FilmTitle": "Yesterday Girl",
      "AlternateTitle": "Abschied von Gestern (Anita G.)",
      "TitleArray": [
        "Yesterday Girl",
        "Abschied von Gestern (Anita G.)"
      ],
      "Year": "1966",
      "Director": "Alexander Kluge",
      "DirectorArray": [
        "Alexander Kluge"
      ],
      "Country": "West Germany",
      "CountryArray": [
        "West Germany"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4824",
      "databaseFilmTitle": "Yi Yi",
      "FilmTitle": "Yi Yi",
      "AlternateTitle": "",
      "TitleArray": [
        "Yi Yi"
      ],
      "Year": "2000",
      "Director": "Edward Yang",
      "DirectorArray": [
        "Edward Yang"
      ],
      "Country": "Taiwan",
      "CountryArray": [
        "Taiwan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "62",
      "2002votes": "4",
      "2012rank": "93",
      "2012votes": "17",
      "2022rank": "90",
      "2022votes": "32"
    },
    {
      "key": "4825",
      "databaseFilmTitle": "Ying",
      "FilmTitle": "Ying",
      "AlternateTitle": "Xiao ying",
      "TitleArray": [
        "Ying",
        "Xiao ying"
      ],
      "Year": "2017",
      "Director": "Jack Hsieh",
      "DirectorArray": [
        "Jack Hsieh"
      ],
      "Country": "China",
      "CountryArray": [
        "China"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4826",
      "databaseFilmTitle": "Yıkılmışı Tedarik",
      "FilmTitle": "Yıkılmışı Tedarik",
      "AlternateTitle": "",
      "TitleArray": [
        "Yıkılmışı Tedarik"
      ],
      "Year": "2006",
      "Director": "Oktay Ince",
      "DirectorArray": [
        "Oktay Ince"
      ],
      "Country": "Turkey",
      "CountryArray": [
        "Turkey"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4827",
      "databaseFilmTitle": "Yojimbo",
      "FilmTitle": "Yojimbo",
      "AlternateTitle": "",
      "TitleArray": [
        "Yojimbo"
      ],
      "Year": "1961",
      "Director": "Akira Kurosawa",
      "DirectorArray": [
        "Akira Kurosawa"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4828",
      "databaseFilmTitle": "You Have Been Weighed and Found Wanting",
      "FilmTitle": "You Have Been Weighed and Found Wanting",
      "AlternateTitle": "Tinimbang Ka Ngunit Kulang",
      "TitleArray": [
        "You Have Been Weighed and Found Wanting",
        "Tinimbang Ka Ngunit Kulang"
      ],
      "Year": "1974",
      "Director": "Lino Brocka",
      "DirectorArray": [
        "Lino Brocka"
      ],
      "Country": "Philippines",
      "CountryArray": [
        "Philippines"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4829",
      "databaseFilmTitle": "You Only Live Once",
      "FilmTitle": "You Only Live Once",
      "AlternateTitle": "",
      "TitleArray": [
        "You Only Live Once"
      ],
      "Year": "1937",
      "Director": "Fritz Lang",
      "DirectorArray": [
        "Fritz Lang"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "83",
      "1952votes": "1",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "155",
      "1972votes": "1",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4830",
      "databaseFilmTitle": "You Were Never Really Here",
      "FilmTitle": "You Were Never Really Here",
      "AlternateTitle": "",
      "TitleArray": [
        "You Were Never Really Here"
      ],
      "Year": "2017",
      "Director": "Lynne Ramsay",
      "DirectorArray": [
        "Lynne Ramsay"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "668",
      "2022votes": "4"
    },
    {
      "key": "4831",
      "databaseFilmTitle": "Young Cassidy",
      "FilmTitle": "Young Cassidy",
      "AlternateTitle": "",
      "TitleArray": [
        "Young Cassidy"
      ],
      "Year": "1965",
      "Director": "Jack Cardiff, John Ford",
      "DirectorArray": [
        "Jack Cardiff",
        "John Ford"
      ],
      "Country": "United Kingdom",
      "CountryArray": [
        "United Kingdom"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4832",
      "databaseFilmTitle": "Young Frankenstein",
      "FilmTitle": "Young Frankenstein",
      "AlternateTitle": "",
      "TitleArray": [
        "Young Frankenstein"
      ],
      "Year": "1974",
      "Director": "Mel Brooks",
      "DirectorArray": [
        "Mel Brooks"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4833",
      "databaseFilmTitle": "Young Mr. Lincoln",
      "FilmTitle": "Young Mr. Lincoln",
      "AlternateTitle": "",
      "TitleArray": [
        "Young Mr. Lincoln"
      ],
      "Year": "1939",
      "Director": "John Ford",
      "DirectorArray": [
        "John Ford"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "462",
      "2022votes": "6"
    },
    {
      "key": "4834",
      "databaseFilmTitle": "Yourself and Yours",
      "FilmTitle": "Yourself and Yours",
      "AlternateTitle": "Dangsinjasingwa Dangsinui Geot",
      "TitleArray": [
        "Yourself and Yours",
        "Dangsinjasingwa Dangsinui Geot"
      ],
      "Year": "2016",
      "Director": "Hong Sang-soo",
      "DirectorArray": [
        "Hong Sang-soo"
      ],
      "Country": "South Korea",
      "CountryArray": [
        "South Korea"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4835",
      "databaseFilmTitle": "Youth Without Youth",
      "FilmTitle": "Youth Without Youth",
      "AlternateTitle": "",
      "TitleArray": [
        "Youth Without Youth"
      ],
      "Year": "2007",
      "Director": "Francis Ford Coppola",
      "DirectorArray": [
        "Francis Ford Coppola"
      ],
      "Country": "United States, Romania",
      "CountryArray": [
        "United States",
        "Romania"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1105",
      "2022votes": "2"
    },
    {
      "key": "4836",
      "databaseFilmTitle": "Z",
      "FilmTitle": "Z",
      "AlternateTitle": "",
      "TitleArray": [
        "Z"
      ],
      "Year": "1969",
      "Director": "Costa-Gavras",
      "DirectorArray": [
        "Costa-Gavras"
      ],
      "Country": "France, Algeria",
      "CountryArray": [
        "France",
        "Algeria"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4837",
      "databaseFilmTitle": "Zabriskie Point",
      "FilmTitle": "Zabriskie Point",
      "AlternateTitle": "",
      "TitleArray": [
        "Zabriskie Point"
      ],
      "Year": "1970",
      "Director": "Michelangelo Antonioni",
      "DirectorArray": [
        "Michelangelo Antonioni"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "899",
      "2012votes": "1",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4838",
      "databaseFilmTitle": "Zama",
      "FilmTitle": "Zama",
      "AlternateTitle": "",
      "TitleArray": [
        "Zama"
      ],
      "Year": "2017",
      "Director": "Lucrecia Martel",
      "DirectorArray": [
        "Lucrecia Martel"
      ],
      "Country": "Argentina",
      "CountryArray": [
        "Argentina"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "196",
      "2022votes": "15"
    },
    {
      "key": "4839",
      "databaseFilmTitle": "Zapping Zone (Proposals for an imaginary television)",
      "FilmTitle": "Zapping Zone (Proposals for an imaginary television)",
      "AlternateTitle": "",
      "TitleArray": [
        "Zapping Zone (Proposals for an imaginary television)"
      ],
      "Year": "1990",
      "Director": "Chris Marker",
      "DirectorArray": [
        "Chris Marker"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4840",
      "databaseFilmTitle": "Zapruder Film of Kennedy Assassination",
      "FilmTitle": "Zapruder Film of Kennedy Assassination",
      "AlternateTitle": "",
      "TitleArray": [
        "Zapruder Film of Kennedy Assassination"
      ],
      "Year": "1963",
      "Director": "Abraham Zapruder",
      "DirectorArray": [
        "Abraham Zapruder"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4841",
      "databaseFilmTitle": "Zefiro Torna or Scenes from the Life of George Maciunas (Fluxus)",
      "FilmTitle": "Zefiro Torna or Scenes from the Life of George Maciunas (Fluxus)",
      "AlternateTitle": "",
      "TitleArray": [
        "Zefiro Torna or Scenes from the Life of George Maciunas (Fluxus)"
      ],
      "Year": "1992",
      "Director": "Jonas Mekas",
      "DirectorArray": [
        "Jonas Mekas"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4842",
      "databaseFilmTitle": "Zelig",
      "FilmTitle": "Zelig",
      "AlternateTitle": "",
      "TitleArray": [
        "Zelig"
      ],
      "Year": "1983",
      "Director": "Woody Allen",
      "DirectorArray": [
        "Woody Allen"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4843",
      "databaseFilmTitle": "Zero for Conduct",
      "FilmTitle": "Zero for Conduct",
      "AlternateTitle": "Zéro de conduite",
      "TitleArray": [
        "Zero for Conduct",
        "Zéro de conduite"
      ],
      "Year": "1933",
      "Director": "Jean Vigo",
      "DirectorArray": [
        "Jean Vigo"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "19",
      "1952votes": "7",
      "1962rank": "11",
      "1962votes": "11",
      "1972rank": "54",
      "1972votes": "3",
      "1982rank": "56",
      "1982votes": "4",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "323",
      "2012votes": "5",
      "2022rank": "354",
      "2022votes": "8"
    },
    {
      "key": "4844",
      "databaseFilmTitle": "Zidane: A 21st Century Portrait",
      "FilmTitle": "Zidane: A 21st Century Portrait",
      "AlternateTitle": "Zidane, un portrait du XXIe siècle",
      "TitleArray": [
        "Zidane: A 21st Century Portrait",
        "Zidane, un portrait du XXIe siècle"
      ],
      "Year": "2006",
      "Director": "Douglas Gordon, Philippe Parreno",
      "DirectorArray": [
        "Douglas Gordon",
        "Philippe Parreno"
      ],
      "Country": "France",
      "CountryArray": [
        "France"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4845",
      "databaseFilmTitle": "Zigeunerweisen",
      "FilmTitle": "Zigeunerweisen",
      "AlternateTitle": "",
      "TitleArray": [
        "Zigeunerweisen"
      ],
      "Year": "1980",
      "Director": "Seijun Suzuki",
      "DirectorArray": [
        "Seijun Suzuki"
      ],
      "Country": "Japan",
      "CountryArray": [
        "Japan"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "217",
      "1982votes": "1",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4846",
      "databaseFilmTitle": "Zodiac",
      "FilmTitle": "Zodiac",
      "AlternateTitle": "",
      "TitleArray": [
        "Zodiac"
      ],
      "Year": "2007",
      "Director": "David Fincher",
      "DirectorArray": [
        "David Fincher"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4847",
      "databaseFilmTitle": "Zombie Flesh Eaters",
      "FilmTitle": "Zombie Flesh Eaters",
      "AlternateTitle": "Zombi 2",
      "TitleArray": [
        "Zombie Flesh Eaters",
        "Zombi 2"
      ],
      "Year": "1979",
      "Director": "Lucio Fulci",
      "DirectorArray": [
        "Lucio Fulci"
      ],
      "Country": "Italy",
      "CountryArray": [
        "Italy"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "1652",
      "2022votes": "1"
    },
    {
      "key": "4848",
      "databaseFilmTitle": "Zoolander",
      "FilmTitle": "Zoolander",
      "AlternateTitle": "",
      "TitleArray": [
        "Zoolander"
      ],
      "Year": "2001",
      "Director": "Ben Stiller",
      "DirectorArray": [
        "Ben Stiller"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "597",
      "2012votes": "2",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4849",
      "databaseFilmTitle": "Zorns Lemma",
      "FilmTitle": "Zorns Lemma",
      "AlternateTitle": "",
      "TitleArray": [
        "Zorns Lemma"
      ],
      "Year": "1970",
      "Director": "Hollis Frampton",
      "DirectorArray": [
        "Hollis Frampton"
      ],
      "Country": "United States",
      "CountryArray": [
        "United States"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "130",
      "1982votes": "2",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "449",
      "2012votes": "3",
      "2022rank": "553",
      "2022votes": "5"
    },
    {
      "key": "4850",
      "databaseFilmTitle": "Zvenigora",
      "FilmTitle": "Zvenigora",
      "AlternateTitle": "",
      "TitleArray": [
        "Zvenigora"
      ],
      "Year": "1928",
      "Director": "Aleksandr Dovzhenko",
      "DirectorArray": [
        "Aleksandr Dovzhenko"
      ],
      "Country": "Soviet Union",
      "CountryArray": [
        "Soviet Union"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "",
      "1992votes": "0",
      "2002rank": "227",
      "2002votes": "1",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    },
    {
      "key": "4851",
      "databaseFilmTitle": "Festival Moon",
      "FilmTitle": "Festival Moon",
      "AlternateTitle": "Zhong qiu yue",
      "TitleArray": [
        "Festival Moon",
        "Zhong qiu yue"
      ],
      "Year": "1953",
      "Director": "Zhu Shilin",
      "DirectorArray": [
        "Zhu Shilin"
      ],
      "Country": "Hong Kong",
      "CountryArray": [
        "Hong Kong"
      ],
      "1952rank": "",
      "1952votes": "0",
      "1962rank": "",
      "1962votes": "0",
      "1972rank": "",
      "1972votes": "0",
      "1982rank": "",
      "1982votes": "0",
      "1992rank": "217",
      "1992votes": "1",
      "2002rank": "",
      "2002votes": "0",
      "2012rank": "",
      "2012votes": "0",
      "2022rank": "",
      "2022votes": "0"
    }
]
